/*
  SLB__GENERATED_BUNDLE__DO_NOT_EDIT
  Project: Saam Law BaseStation (SLB)
  Build-Version: SLB_UAE_V3_231R29_TAO_GAMES_SHARED_POUCH_LOCAL_FIRST_20260808_01
  Build mode: CONCAT (no legacy)
  Built: 2026-08-09T02:39:23.050Z
  Content-SHA256: 60940541211b18c0617ef29bc24945c864e1d4a0c4670a8a74ac4d5fe7128361
*/

;(function(w){
  w.SLB = w.SLB || {};
  w.SLB.__generatedLoaded = true;
  w.SLB.__generatedBuilt = '2026-08-09T02:39:23.050Z';
  w.SLB.__generatedHash = '60940541211b18c0617ef29bc24945c864e1d4a0c4670a8a74ac4d5fe7128361';
  w.SLB.__generatedBuildMode = 'CONCAT (no legacy)';
})(window);

/* ====== SLB SRC: 00_prelude.js ====== */
/* SLB Shared Prelude (Phase 3)
   - Keep this small and dependency-free.
   - Attaches shared namespaces onto window.SLB.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;

  SLB.shared = SLB.shared || {};
  SLB.shared.phase = SLB.shared.phase || 3;

  // Fallbacks (these should already exist from assets/slb.bundle.js)
  SLB.safe = SLB.safe || function(fn, label){
    try{ return fn(); }
    catch(e){ try{ console.error('[SLB]', label || 'error', e); }catch(_e){} }
  };

  SLB.domReady = SLB.domReady || function(fn){
    try{
      if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }catch(_e){}
  };

  // Debug flag (default off)
  function _getDebugFlag(){
    try{
      if(w.SLB_DEBUG === true) return true;
      var sp = null;
      try{ sp = new URLSearchParams((location && location.search) ? location.search : ''); }catch(_e){}
      if(sp){
        var q = sp.get('slbdebug') || sp.get('debug') || '';
        q = String(q || '').toLowerCase();
        if(q === '1' || q === 'true' || q === 'yes' || q === 'on') return true;
      }
      try{
        if(w.localStorage && String(localStorage.getItem('SLB_DEBUG')||'') === '1') return true;
      }catch(_e2){}
      return false;
    }catch(_e3){ return false; }
  }

  w.SLB_DEBUG = _getDebugFlag();

  // Structured logger (ring buffer)
  (function(){
    var MAX = 200;
    var buf = [];
    function nowIso(){
      try{ return new Date().toISOString(); }catch(_e){ return ''; }
    }
    function push_(level, event, data){
      try{
        var entry = {
          t: nowIso(),
          lvl: String(level||'info'),
          evt: String(event||''),
          data: (data===undefined ? null : data)
        };
        buf.push(entry);
        if(buf.length > MAX) buf.splice(0, buf.length - MAX);
        return entry;
      }catch(_e){ return null; }
    }

    function fmtArgs(args){
      try{
        if(!args || !args.length) return {evt:'', data:null};
        if(args.length === 1) return {evt: String(args[0]), data:null};
        return {evt: String(args[0]), data: args.length === 2 ? args[1] : Array.prototype.slice.call(args,1)};
      }catch(_e){ return {evt:'', data:null}; }
    }

    // Base callable for backward compat: SLB.log('x', obj)
    var existing = SLB.log;
    var base = (typeof existing === 'function') ? existing : function(){
      try{ base.debug.apply(null, arguments); }catch(_e){}
    };

    // Methods
    base.setDebug = function(on){
      try{
        var v = on ? '1' : '';
        try{ if(w.localStorage){ if(on) localStorage.setItem('SLB_DEBUG','1'); else localStorage.removeItem('SLB_DEBUG'); } }catch(_e){}
        w.SLB_DEBUG = !!on;
        return w.SLB_DEBUG;
      }catch(_e2){ return !!w.SLB_DEBUG; }
    };

    base.dump = function(){
      try{ return buf.slice(); }catch(_e){ return []; }
    };

    base.clear = function(){
      try{ buf.length = 0; }catch(_e){}
    };

    base.copy = async function(){
      try{
        var payload = JSON.stringify(base.dump(), null, 2);
        if(navigator && navigator.clipboard && navigator.clipboard.writeText){
          await navigator.clipboard.writeText(payload);
          return true;
        }
      }catch(_e){}
      return false;
    };

    base.debug = function(){
      try{
        if(!w.SLB_DEBUG) return;
        var f = fmtArgs(arguments);
        push_('debug', f.evt, f.data);
        try{ console.debug ? console.debug('[SLB]', f.evt, f.data||'') : console.log('[SLB]', f.evt, f.data||''); }catch(_e2){}
      }catch(_e3){}
    };

    base.info = function(){
      try{
        if(!w.SLB_DEBUG) return;
        var f = fmtArgs(arguments);
        push_('info', f.evt, f.data);
        try{ console.info ? console.info('[SLB]', f.evt, f.data||'') : console.log('[SLB]', f.evt, f.data||''); }catch(_e2){}
      }catch(_e3){}
    };

    base.warn = function(){
      try{
        var f = fmtArgs(arguments);
        push_('warn', f.evt, f.data);
        try{ console.warn('[SLB]', f.evt, f.data||''); }catch(_e2){}
      }catch(_e3){}
    };

    base.error = function(){
      try{
        var f = fmtArgs(arguments);
        push_('error', f.evt, f.data);
        try{ console.error('[SLB]', f.evt, f.data||''); }catch(_e2){}
      }catch(_e3){}
    };

    base.event = function(name, data){ base.info(name, data); };

    // Optional: silence noisy consoles in production
    try{
      if(!w.SLB_DEBUG && console && !console.__slbPatched){
        console.__slbPatched = true;
        console.log = function(){};
        console.info = function(){};
        console.debug = function(){};
      }
    }catch(_e){}

    SLB.log = base;
  })();
})(window);


/* ====== SLB SRC: 10_util.js ====== */
/* SLB Shared Util (Phase 2)
   - New code should use SLB.util.*
   - Do NOT override existing helpers if legacy already provides them.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(SLB.util) return;

  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(id){ return document.getElementById(id); }
  function on(node, evt, fn, opts){ if(node) node.addEventListener(evt, fn, opts || false); }
  function off(node, evt, fn, opts){ if(node) node.removeEventListener(evt, fn, opts || false); }
  function addClass(node, cls){ if(node && cls) node.classList.add(cls); }
  function removeClass(node, cls){ if(node && cls) node.classList.remove(cls); }
  function toggleClass(node, cls, force){ if(node && cls) node.classList.toggle(cls, force); }

  function escapeHtml(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function clamp(n, a, b){
    n = Number(n);
    if(!Number.isFinite(n)) return a;
    return Math.max(a, Math.min(b, n));
  }

  function debounce(fn, wait){
    var t = 0;
    return function(){
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  function throttle(fn, wait){
    var last = 0, t = 0;
    return function(){
      var now = Date.now();
      var ctx = this, args = arguments;
      if(now - last >= wait){
        last = now;
        fn.apply(ctx, args);
      }else{
        clearTimeout(t);
        t = setTimeout(function(){
          last = Date.now();
          fn.apply(ctx, args);
        }, wait - (now - last));
      }
    };
  }

  function parseJSON(s, fallback){
    try{ return JSON.parse(s); }catch(_e){ return fallback; }
  }

  function fmtLocalDateTime(ms){
    try{
      var d = (ms instanceof Date) ? ms : new Date(ms);
      return d.toLocaleString(undefined, { year:'numeric', month:'short', day:'2-digit', hour:'2-digit', minute:'2-digit' });
    }catch(_e){
      return '';
    }
  }

  function uid(prefix){
    prefix = prefix || 'id';
    return prefix + '_' + Math.random().toString(36).slice(2, 10) + '_' + Date.now().toString(36);
  }

  SLB.util = {
    qs: qs,
    qsa: qsa,
    el: el,
    on: on,
    off: off,
    addClass: addClass,
    removeClass: removeClass,
    toggleClass: toggleClass,
    escapeHtml: escapeHtml,
    clamp: clamp,
    debounce: debounce,
    throttle: throttle,
    parseJSON: parseJSON,
    fmtLocalDateTime: fmtLocalDateTime,
    uid: uid
  };
})(window);


/* ====== SLB SRC: 20_net.js ====== */
/* SLB Shared Net (Phase 5)
   - Generic fetch helpers.
   - Adds: in-flight de-dupe, optional response cache, and abort-on-timeout (when supported).
   - Backwards compatible: default behavior unchanged unless opts.dedupeKey / opts.cacheTtlMs are provided.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(SLB.net) return;

  var inflight = Object.create(null); // key -> Promise
  var memCache = Object.create(null); // key -> { e: <ms>, v: <any> }

  function now(){ return Date.now(); }

  function mkKey(url, fetchOpts, bodyStr){
    try{
      var m = (fetchOpts && fetchOpts.method) ? String(fetchOpts.method).toUpperCase() : 'GET';
      var b = bodyStr || '';
      if(b && b.length > 512) b = b.slice(0, 512);
      return m + ' ' + url + ' ' + b;
    }catch(_e){
      return String(url || '');
    }
  }

  function withTimeout(promise, ms, abortFn){
    ms = ms || 20000;
    return new Promise(function(resolve, reject){
      var t = setTimeout(function(){
        try{ if(typeof abortFn === 'function') abortFn(); }catch(_e){}
        reject(new Error('Timeout'));
      }, ms);
      promise.then(function(v){ clearTimeout(t); resolve(v); }, function(err){ clearTimeout(t); reject(err); });
    });
  }

  function normalizeError(e){
    try{
      if(!e) return { message:'Unknown error' };
      if(typeof e === 'string') return { message: e };
      return { message: e.message || 'Network error', error: e };
    }catch(_e){
      return { message:'Network error' };
    }
  }

  // opts:
  //  - method, headers, body, credentials, timeoutMs
  //  - dedupeKey: string (if provided, identical concurrent requests share one Promise)
  //  - cacheTtlMs: number (if provided, responses are cached in-memory for ttl)
  //  - signal: AbortSignal (optional)
  //  - abortOnTimeout: boolean (default true)
  function fetchJSON(url, opts){
    opts = opts || {};
    var timeoutMs = opts.timeoutMs || 20000;

    var fetchOpts = {
      method: opts.method || 'GET',
      headers: Object.assign({ 'Accept':'application/json' }, opts.headers || {}),
      credentials: opts.credentials || 'same-origin'
    };

    var bodyStr = null;
    if(opts.body != null){
      bodyStr = (typeof opts.body === 'string') ? opts.body : JSON.stringify(opts.body);
      fetchOpts.body = bodyStr;
      if(!fetchOpts.headers['Content-Type']) fetchOpts.headers['Content-Type'] = 'application/json';
    }

    var key = opts.dedupeKey || (opts.cacheTtlMs ? mkKey(url, fetchOpts, bodyStr) : null);

    if(key && opts.cacheTtlMs){
      var c = memCache[key];
      if(c && c.e && c.e > now()) return Promise.resolve(c.v);
      if(c) delete memCache[key];
    }

    if(key && inflight[key]) return inflight[key];

    var controller = null;
    var abortOnTimeout = (opts.abortOnTimeout !== false);
    if(!fetchOpts.signal && opts.signal) fetchOpts.signal = opts.signal;
    if(!fetchOpts.signal && abortOnTimeout && typeof AbortController !== 'undefined'){
      controller = new AbortController();
      fetchOpts.signal = controller.signal;
    }

    var p = withTimeout(
      fetch(url, fetchOpts).then(function(res){
        return res.text().then(function(txt){
          var data;
          try{ data = txt ? JSON.parse(txt) : null; }catch(_e){ data = { raw: txt }; }
          if(!res.ok){
            var err = new Error((data && data.message) ? data.message : ('HTTP ' + res.status));
            err.status = res.status;
            err.data = data;
            throw err;
          }
          return data;
        });
      }),
      timeoutMs,
      function(){
        try{ if(controller) controller.abort(); }catch(_e){}
      }
    );

    var wrapped = p.then(function(data){
      try{
        if(key && opts.cacheTtlMs && opts.cacheTtlMs > 0){
          memCache[key] = { e: now() + opts.cacheTtlMs, v: data };
        }
      }catch(_e){}
      return data;
    }).finally(function(){
      try{ if(key) delete inflight[key]; }catch(_e){}
    });

    if(key) inflight[key] = wrapped;
    return wrapped;
  }

  function postJSON(url, body, opts){
    opts = opts || {};
    opts.method = 'POST';
    opts.body = body;
    return fetchJSON(url, opts);
  }

  function gasCall(endpoint, payload, opts){
    return postJSON(endpoint, payload, opts).catch(function(e){
      throw normalizeError(e);
    });
  }

  SLB.net = {
    withTimeout: withTimeout,
    fetchJSON: fetchJSON,
    postJSON: postJSON,
    gasCall: gasCall,
    normalizeError: normalizeError
  };
})(window);


/* ====== SLB SRC: 30_storage.js ====== */
/* SLB Shared Storage (Phase 2)
   - Local/session storage helpers with optional TTL.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(SLB.storage) return;

  function now(){ return Date.now(); }

  function setRaw(store, key, value){
    try{ store.setItem(key, value); return true; }catch(_e){ return false; }
  }

  function getRaw(store, key){
    try{ return store.getItem(key); }catch(_e){ return null; }
  }

  function removeRaw(store, key){
    try{ store.removeItem(key); return true; }catch(_e){ return false; }
  }

  // TTL wrapper format: { v: <any>, e: <ms epoch> }
  function setJSON(store, key, obj, ttlMs){
    try{
      var payload = (ttlMs && ttlMs > 0)
        ? { v: obj, e: now() + ttlMs }
        : { v: obj };
      return setRaw(store, key, JSON.stringify(payload));
    }catch(_e){ return false; }
  }

  function getJSON(store, key, fallback){
    var txt = getRaw(store, key);
    if(!txt) return fallback;
    try{
      var payload = JSON.parse(txt);
      if(payload && typeof payload === 'object'){
        if(payload.e && now() > payload.e){
          removeRaw(store, key);
          return fallback;
        }
        if('v' in payload) return payload.v;
      }
      // legacy: raw JSON
      return payload;
    }catch(_e){
      return fallback;
    }
  }

  SLB.storage = {
    // raw
    set: function(key, value){ return setRaw(localStorage, key, String(value)); },
    get: function(key){ return getRaw(localStorage, key); },
    remove: function(key){ return removeRaw(localStorage, key); },
    // JSON + TTL
    setJSON: function(key, obj, ttlMs){ return setJSON(localStorage, key, obj, ttlMs); },
    getJSON: function(key, fallback){ return getJSON(localStorage, key, fallback); },
    // session
    setSession: function(key, value){ return setRaw(sessionStorage, key, String(value)); },
    getSession: function(key){ return getRaw(sessionStorage, key); },
    removeSession: function(key){ return removeRaw(sessionStorage, key); },
    setSessionJSON: function(key, obj, ttlMs){ return setJSON(sessionStorage, key, obj, ttlMs); },
    getSessionJSON: function(key, fallback){ return getJSON(sessionStorage, key, fallback); }
  };
})(window);


/* ====== SLB SRC: 40_ui.js ====== */
/* SLB Shared UI (Phase 2)
   - Small, safe UI helpers.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(SLB.ui) return;

  function ensureToastHost(){
    var id = 'slb_toast_host';
    var host = document.getElementById(id);
    if(host) return host;
    host = document.createElement('div');
    host.id = id;
    host.style.position = 'fixed';
    host.style.right = '12px';
    host.style.bottom = '12px';
    host.style.zIndex = '99999';
    host.style.maxWidth = '340px';
    document.body.appendChild(host);
    return host;
  }

  function toast(msg, ms){
    try{
      ms = ms || 2200;
      var host = ensureToastHost();
      var t = document.createElement('div');
      t.textContent = String(msg == null ? '' : msg);
      t.style.background = 'rgba(15,21,23,0.92)';
      t.style.color = '#fff';
      t.style.padding = '10px 12px';
      t.style.borderRadius = '10px';
      t.style.marginTop = '8px';
      t.style.boxShadow = '0 6px 18px rgba(0,0,0,0.18)';
      t.style.fontSize = '14px';
      t.style.lineHeight = '1.25';
      host.appendChild(t);
      setTimeout(function(){
        try{ if(t && t.parentNode) t.parentNode.removeChild(t); }catch(_e){}
      }, ms);
    }catch(_e){}
  }

  function setBusy(node, on){
    if(!node) return;
    try{
      if(on){
        node.setAttribute('aria-busy','true');
        node.classList.add('slb-busy');
      }else{
        node.removeAttribute('aria-busy');
        node.classList.remove('slb-busy');
      }
    }catch(_e){}
  }

  function wireCollapsible(headerSel, contentSel, openCls){
    openCls = openCls || 'is-open';
    try{
      var headers = document.querySelectorAll(headerSel);
      Array.prototype.forEach.call(headers, function(h){
        h.style.cursor = 'pointer';
        h.addEventListener('click', function(){
          var wrap = h.closest('.cat-section') || h.parentNode;
          var content = wrap ? wrap.querySelector(contentSel) : null;
          if(!content) return;
          var open = content.classList.contains(openCls);
          if(open){
            content.classList.remove(openCls);
            content.style.display = 'none';
          }else{
            content.classList.add(openCls);
            content.style.display = '';
          }
        });
      });
    }catch(_e){}
  }

  SLB.ui = {
    toast: toast,
    setBusy: setBusy,
    wireCollapsible: wireCollapsible
  };
})(window);


/* ====== SLB SRC: 45_a11y.js ====== */
(function(w,d){
  'use strict';
  var SLB = w.SLB = w.SLB || {};
  var activeTrap = null;

  function visible_(el){
    if(!el || !el.isConnected) return false;
    if(el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    try{
      var cs = w.getComputedStyle(el);
      if(cs.display === 'none' || cs.visibility === 'hidden') return false;
    }catch(_e){}
    return true;
  }

  function focusables_(root){
    if(!root || !root.querySelectorAll) return [];
    var nodes = root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),details>summary,[contenteditable]:not([contenteditable="false"]),[tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function(el){
      return visible_(el) && el.getAttribute('aria-hidden') !== 'true';
    });
  }

  function ensureAnnouncer_(kind){
    var id = kind === 'alert' ? 'slbA11yAlert' : 'slbA11yStatus';
    var el = d.getElementById(id);
    if(el) return el;
    el = d.createElement('div');
    el.id = id;
    el.className = 'slbSrOnly';
    el.setAttribute('role', kind === 'alert' ? 'alert' : 'status');
    el.setAttribute('aria-live', kind === 'alert' ? 'assertive' : 'polite');
    el.setAttribute('aria-atomic','true');
    (d.body || d.documentElement).appendChild(el);
    return el;
  }

  function announce_(message, kind){
    var text = String(message == null ? '' : message).trim();
    if(!text) return;
    var el = ensureAnnouncer_(kind === 'alert' ? 'alert' : 'status');
    try{
      el.textContent = '';
      w.setTimeout(function(){ el.textContent = text; }, 20);
    }catch(_e){}
  }

  function trapDialog_(dialog, options){
    options = options || {};
    if(!dialog) return function(){};
    if(activeTrap && activeTrap.dialog === dialog) return activeTrap.release;
    if(activeTrap && typeof activeTrap.release === 'function') activeTrap.release(false);

    var previous = options.returnFocus || d.activeElement;
    var released = false;

    function focusInitial_(){
      var initial = options.initialFocus;
      if(typeof initial === 'string') initial = dialog.querySelector(initial);
      if(!initial || !visible_(initial)){
        var list = focusables_(dialog);
        initial = list[0] || dialog;
      }
      if(initial === dialog && !dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex','-1');
      try{ initial.focus({preventScroll:true}); }catch(_e){ try{ initial.focus(); }catch(_e2){} }
    }

    function onKey_(ev){
      if(!visible_(dialog)) return;
      if(ev.key === 'Escape' && typeof options.onEscape === 'function'){
        ev.preventDefault();
        options.onEscape(ev);
        return;
      }
      if(ev.key !== 'Tab') return;
      var list = focusables_(dialog);
      if(!list.length){
        ev.preventDefault();
        try{ dialog.focus(); }catch(_e){}
        return;
      }
      var first = list[0];
      var last = list[list.length - 1];
      var current = d.activeElement;
      if(ev.shiftKey && (current === first || !dialog.contains(current))){
        ev.preventDefault();
        try{ last.focus(); }catch(_e){}
      }else if(!ev.shiftKey && (current === last || !dialog.contains(current))){
        ev.preventDefault();
        try{ first.focus(); }catch(_e){}
      }
    }

    dialog.addEventListener('keydown', onKey_);
    w.setTimeout(focusInitial_, Number(options.delay || 0));

    function release_(restore){
      if(released) return;
      released = true;
      dialog.removeEventListener('keydown', onKey_);
      if(activeTrap && activeTrap.dialog === dialog) activeTrap = null;
      if(restore !== false && previous && previous.focus && previous.isConnected){
        w.setTimeout(function(){
          try{ previous.focus({preventScroll:true}); }catch(_e){ try{ previous.focus(); }catch(_e2){} }
        }, 0);
      }
    }

    activeTrap = { dialog:dialog, release:release_ };
    return release_;
  }

  function statusRegion_(el, role, live){
    if(!el) return;
    if(!el.hasAttribute('role')) el.setAttribute('role', role);
    if(!el.hasAttribute('aria-live')) el.setAttribute('aria-live', live);
    if(!el.hasAttribute('aria-atomic')) el.setAttribute('aria-atomic','true');
  }

  function enhance_(root){
    root = root || d;
    if(!root.querySelectorAll) return;
    root.querySelectorAll('.err').forEach(function(el){ statusRegion_(el,'alert','assertive'); });
    root.querySelectorAll('.ok,#slbSyncHint,#tywBackendStatus,#slbBootLine,.slbConnText,.slbWarmStatus').forEach(function(el){ statusRegion_(el,'status','polite'); });
    root.querySelectorAll('[data-panel]').forEach(function(panel){
      if(!panel.hasAttribute('role')) panel.setAttribute('role','region');
      if(!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex','-1');
      panel.setAttribute('aria-hidden', panel.classList.contains('hidden') ? 'true' : 'false');
    });
    root.querySelectorAll('[role="dialog"]').forEach(function(dialog){
      if(!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex','-1');
      if(!dialog.hasAttribute('aria-hidden')){
        dialog.setAttribute('aria-hidden', dialog.classList.contains('hidden') || dialog.hidden ? 'true' : 'false');
      }
    });
  }

  SLB.a11y = Object.assign(SLB.a11y || {}, {
    announce: announce_,
    enhance: enhance_,
    focusables: focusables_,
    trapDialog: trapDialog_
  });

  function boot_(){
    ensureAnnouncer_('status');
    ensureAnnouncer_('alert');
    enhance_(d.getElementById('SaamLawBank') || d);
  }
  if(d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot_, {once:true});
  else boot_();
})(window,document);


/* ====== SLB SRC: 47_shell_compact.js ====== */
(function(w,d){
  'use strict';
  var LEGACY_STORAGE_KEY = 'slbHeroPinnedOpen';
  var collapseTimer = 0;
  var OPEN_MS = 6500;
  var isExpanded = false;

  function init_(){
    var hero = d.getElementById('slbHeroRow');
    var button = d.getElementById('slbHeroRevealBtn');
    if(!hero || !button || hero.dataset.compactInit === '1') return;
    hero.dataset.compactInit = '1';

    // Phase 5.1.3: discard the old persistent-open state. It could keep the
    // banner expanded across every SLB page in the same browser tab.
    try{ sessionStorage.removeItem(LEGACY_STORAGE_KEY); }catch(_e){}

    function sync_(collapsed){
      collapsed = !!collapsed;
      isExpanded = !collapsed;
      if(collapsed){
        w.clearTimeout(collapseTimer);
        collapseTimer = 0;
      }
      hero.classList.toggle('slbHeroCollapsed', collapsed);
      hero.classList.toggle('slbHeroPeekOpen', !collapsed);
      hero.classList.remove('slbHeroPinnedOpen');
      hero.dataset.slbHeroExpanded = collapsed ? '0' : '1';
      button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      button.setAttribute('aria-label', collapsed ? 'Show SLB header' : 'Hide SLB header');
      var icon = button.querySelector('span');
      if(icon) icon.textContent = collapsed ? '⌄' : '⌃';
    }

    function collapse_(delay){
      w.clearTimeout(collapseTimer);
      collapseTimer = w.setTimeout(function(){ sync_(true); }, Math.max(0, Number(delay || 0)));
    }

    function openTemporarily_(){
      sync_(false);
      collapse_(OPEN_MS);
    }

    button.addEventListener('click', function(ev){
      ev.preventDefault();
      ev.stopPropagation();
      if(isExpanded || button.getAttribute('aria-expanded') === 'true') sync_(true);
      else openTemporarily_();
      // Pointer/touch clicks should not leave the toggle focused forever.
      if(ev.detail > 0 && button.blur) button.blur();
    });

    // Interactions inside the open header extend its visible time, but hover
    // alone never opens it. Ignore the button and its icon so a close click is
    // never converted into an "extend open" click by the parent capture handler.
    hero.addEventListener('click', function(ev){
      if(button.contains(ev.target)) return;
      if(isExpanded) collapse_(OPEN_MS);
    }, true);
    hero.addEventListener('focusin', function(){
      if(!hero.classList.contains('slbHeroCollapsed')) collapse_(OPEN_MS);
    });
    hero.addEventListener('focusout', function(){
      w.setTimeout(function(){
        if(!hero.contains(d.activeElement) && !hero.classList.contains('slbHeroCollapsed')) collapse_(1200);
      }, 0);
    });
    hero.addEventListener('keydown', function(ev){
      if(ev.key === 'Escape'){
        sync_(true);
        button.focus();
      }
    });

    function ready_(){ sync_(true); }
    w.addEventListener('slb:auth-ready', ready_, {once:true});
    w.addEventListener('slb:ready', ready_, {once:true});
    ready_();
  }

  if(d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init_, {once:true});
  else init_();
})(window,document);


/* ====== SLB SRC: 50_sanitize.js ====== */
/* SLB Shared Sanitizer (Phase 2)
   - Conservative client-side sanitizer.
   - Backend should still sanitize + validate.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(SLB.sanitize) return;

  var ALLOW_TAGS = {
    a:1, b:1, strong:1, i:1, em:1, u:1, s:1,
    br:1, p:1, div:1, span:1,
    ul:1, ol:1, li:1,
    h1:1, h2:1, h3:1, h4:1, h5:1, h6:1,
    blockquote:1, pre:1, code:1,
    img:1, iframe:1
  };

  var ALLOW_ATTR = {
    a: { href:1, target:1, rel:1, title:1 },
    img: { src:1, alt:1, title:1 },
    iframe: { src:1, allow:1, allowfullscreen:1, frameborder:1 },
    '*': { style:1 }
  };

  function isSafeUrl(url){
    url = String(url || '').trim();
    if(!url) return false;
    if(url.startsWith('#')) return true;

    // Block dangerous schemes explicitly
    if(/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url)){
      return /^https?:\/\//i.test(url) || /^mailto:/i.test(url);
    }

    // Allow relative URLs (phpBB often uses /viewtopic.php?... or viewtopic.php?...).
    // Also allow protocol-relative //example.com
    if(url.startsWith('//')) return true;
    return true;
  }

  function isSafeImgSrc(src){
    src = String(src || '').trim();
    if(!src) return false;
    return /^https?:\/\//i.test(src) || /^data:image\//i.test(src);
  }

  function isSafeIframeSrc(src){
    src = String(src || '').trim();
    if(!src) return false;
    // allow common video embeds
    return /^https:\/\/(www\.)?(youtube\.com|youtu\.be|player\.vimeo\.com)\//i.test(src);
  }

  function stripUnsafeAttributes(node){
    if(!node || !node.attributes) return;
    var tag = (node.tagName || '').toLowerCase();
    var allow = ALLOW_ATTR[tag] || {};
    var allowAny = ALLOW_ATTR['*'] || {};

    // Copy because removing while iterating can skip
    var attrs = [];
    for(var i=0;i<node.attributes.length;i++) attrs.push(node.attributes[i].name);

    attrs.forEach(function(name){
      var low = name.toLowerCase();
      if(low.startsWith('on')){ node.removeAttribute(name); return; }
      if(!(allow[low] || allowAny[low])){ node.removeAttribute(name); return; }

      // URL checks
      if(tag === 'a' && low === 'href'){
        if(!isSafeUrl(node.getAttribute(name))) node.removeAttribute(name);
      }
      if(tag === 'img' && low === 'src'){
        if(!isSafeImgSrc(node.getAttribute(name))) node.removeAttribute(name);
      }
      if(tag === 'iframe' && low === 'src'){
        if(!isSafeIframeSrc(node.getAttribute(name))) node.removeAttribute(name);
      }
    });

    // normalize rel on target=_blank
    if(tag === 'a'){
      var tgt = (node.getAttribute('target') || '').toLowerCase();
      if(tgt === '_blank'){
        var rel = node.getAttribute('rel') || '';
        if(!/noopener/i.test(rel)) rel = (rel ? rel + ' ' : '') + 'noopener';
        if(!/noreferrer/i.test(rel)) rel = (rel ? rel + ' ' : '') + 'noreferrer';
        node.setAttribute('rel', rel.trim());
      }
    }
  }

  function sanitizeRich(html){
    html = String(html == null ? '' : html);
    // If legacy provides a sanitizer, prefer it.
    if(typeof w.SLB_SANITIZE_RICH === 'function'){
      try{ return w.SLB_SANITIZE_RICH(html); }catch(_e){}
    }

    try{
      var doc = new DOMParser().parseFromString('<div>'+html+'</div>', 'text/html');
      var root = doc.body && doc.body.firstChild;
      if(!root) return '';

      // Walk all nodes
      var stack = [root];
      while(stack.length){
        var node = stack.pop();
        if(!node) continue;
        var children = node.children ? Array.prototype.slice.call(node.children) : [];
        for(var i=0;i<children.length;i++) stack.push(children[i]);

        if(node.nodeType !== 1) continue;
        var tag = (node.tagName || '').toLowerCase();

        // Remove forbidden tags
        if(!ALLOW_TAGS[tag]){
          // Replace with its text content
          var txt = doc.createTextNode(node.textContent || '');
          if(node.parentNode) node.parentNode.replaceChild(txt, node);
          continue;
        }

        // Strip unsafe attrs
        stripUnsafeAttributes(node);

        // If iframe exists, enforce allowfullscreen if present
        if(tag === 'iframe'){
          if(!node.getAttribute('allowfullscreen')) node.setAttribute('allowfullscreen', 'true');
          // reasonable default allow
          if(!node.getAttribute('allow')) node.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        }
      }

      return root.innerHTML;
    }catch(_e){
      return '';
    }
  }

  function sanitizePlain(text){
    return String(text == null ? '' : text)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;');
  }

  SLB.sanitize = {
    plain: sanitizePlain,
    rich: sanitizeRich
  };
})(window);


/* ====== SLB SRC: 60_editor_core.js ====== */
/* SLB Shared Editor Core (Phase 2)
   - Phase 2: just shared wrappers + conventions.
   - Real editor extraction happens in later phases.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(SLB.editorCore) return;

  function getHtmlFromEditable(editableEl){
    try{ return (editableEl && editableEl.innerHTML) ? editableEl.innerHTML : ''; }catch(_e){ return ''; }
  }

  function setHtmlToEditable(editableEl, html){
    try{ if(editableEl) editableEl.innerHTML = String(html == null ? '' : html); }catch(_e){}
  }

  function sanitizeOutgoing(html){
    try{
      if(SLB.sanitize && typeof SLB.sanitize.rich === 'function') return SLB.sanitize.rich(html);
    }catch(_e){}
    return String(html == null ? '' : html);
  }

  // Hook point: if legacy global editor exists, you can bridge to it.
  function hasLegacyEditor(){
    return !!(w.SLB_EDITOR_GLOBAL && typeof w.SLB_EDITOR_GLOBAL.init === 'function');
  }

  SLB.editorCore = {
    getHtmlFromEditable: getHtmlFromEditable,
    setHtmlToEditable: setHtmlToEditable,
    sanitizeOutgoing: sanitizeOutgoing,
    hasLegacyEditor: hasLegacyEditor
  };
})(window);


/* ====== SLB SRC: 65_features.js ====== */
/* SLB Features Registry + Router (Phase 3)
   - Keeps per-tab logic in small modules.
   - Legacy setPanel() calls: window.SLB.features.onOpen(tab, ctx)
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;

  var F = SLB.features = SLB.features || {};
  F._reg = F._reg || Object.create(null);

  function normTab(tab){
    return String(tab || '').trim();
  }

  // Register a feature module for a given tab.
  F.register = F.register || function(tab, mod){
    try{
      tab = normTab(tab);
      if(!tab) return;
      if(!mod || typeof mod !== 'object') return;
      F._reg[tab] = mod;
    }catch(_e){}
  };

  // Fetch a feature module.
  F.get = F.get || function(tab){
    tab = normTab(tab);
    return tab ? (F._reg[tab] || null) : null;
  };

  // Called by legacy panel router when a tab is opened.
  F.onOpen = F.onOpen || function(tab, ctx){
    tab = normTab(tab);
    if(!tab) return;
    var mod = F._reg[tab];
    if(!mod || typeof mod.onOpen !== 'function') return;
    (SLB.safe || function(fn){ try{ fn(); }catch(_e){} })(function(){
      mod.onOpen(ctx || {});
    }, tab + '.onOpen');
  };

  // Optional helper: call an arbitrary method on a feature module.
  F.call = F.call || function(tab, method, ctx){
    tab = normTab(tab);
    method = String(method || '').trim();
    if(!tab || !method) return;
    var mod = F._reg[tab];
    var fn = mod ? mod[method] : null;
    if(typeof fn !== 'function') return;
    (SLB.safe || function(fn2){ try{ fn2(); }catch(_e){} })(function(){
      fn(ctx || {});
    }, tab + '.' + method);
  };
})(window);


/* ====== SLB SRC: 67_lunar.js ====== */
/* SLB Shared: Lunar / Chinese calendar utilities
   Purpose:
   - Centralize vendor loading for lunar-javascript
   - Provide reusable helpers for future features (e.g., god anniversaries, Fan Tai Sui tools)
   - Keep vendor URLs in ONE place so we never lose them

   This module does NOT auto-load vendor scripts on every page.
   Use: await SLB.lunar.ensureEngine(); then use Solar/Lunar globals.
*/

(function(){
  'use strict';

  window.SLB = window.SLB || {};
  var SLB = window.SLB;

  // Keep the canonical vendor URLs here.
  // (We can later replace these with local theme assets and keep CDN as fallback.)
  var DEFAULT_VENDOR_URLS = {
    primary: 'https://cdn.jsdelivr.net/npm/lunar-javascript@1.7.7/lunar.js',
    fallbacks: [
      // Optional fallback; some networks block jsdelivr
      'https://unpkg.com/lunar-javascript@1.7.7/lunar.js'
    ]
  };

  function uniq(arr){
    var out = [];
    for(var i=0;i<(arr||[]).length;i++){
      var v = arr[i];
      if(!v) continue;
      if(out.indexOf(v) === -1) out.push(v);
    }
    return out;
  }

  function loadScriptOnce(url){
    return new Promise(function(resolve, reject){
      if(!url) return resolve(false);
      try{
        var scripts = document.scripts || [];
        for(var i=0;i<scripts.length;i++){
          var s0 = scripts[i];
          if(s0 && s0.src && s0.src.indexOf(url) !== -1) return resolve(true);
        }
      }catch(_e){}

      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      // This loader owns failure/fallback. The global SLB crash guard must not
      // duplicate a handled CDN miss with a whole-app error bar.
      s.setAttribute('data-slb-managed-resource', 'lunar-vendor');
      s.onload = function(){ resolve(true); };
      s.onerror = function(){ reject(new Error('Failed to load: '+url)); };
      document.head.appendChild(s);
    });
  }

  function getVendorUrls(){
    var v = window.SLB_VENDOR_URLS || {};
    var urls = [];
    // Preferred slots (if you later wire local assets into SLB_VENDOR_URLS)
    if(v.lunarJavascript) urls.push(v.lunarJavascript);
    if(v.lunarJavascriptFallbacks && Array.isArray(v.lunarJavascriptFallbacks)){
      urls = urls.concat(v.lunarJavascriptFallbacks);
    }
    // Canonical CDN list (kept here so we never lose it)
    urls.push(DEFAULT_VENDOR_URLS.primary);
    urls = urls.concat(DEFAULT_VENDOR_URLS.fallbacks);
    return uniq(urls);
  }

  function hasEngine(){
    return (typeof window.Solar !== 'undefined' && typeof window.Lunar !== 'undefined');
  }

  // Single in-flight promise shared across modules
  var enginePromise = null;

  function ensureEngine(){
    if(hasEngine()) return Promise.resolve(true);
    if(enginePromise) return enginePromise;

    var urls = getVendorUrls();

    // Sequential attempt (first successful wins)
    enginePromise = urls.reduce(function(p, url){
      return p.catch(function(){
        return loadScriptOnce(url).then(function(){
          if(hasEngine()) return true;
          // Keep trying if script loaded but globals not present
          return Promise.reject(new Error('Vendor loaded but globals missing'));
        });
      });
    }, Promise.reject(new Error('start')))
    .catch(function(){
      // final check (some environments inject globals late)
      return hasEngine();
    })
    .then(function(ok){
      if(!ok){
        // clear so future retries are possible
        enginePromise = null;
      }
      return ok;
    });

    return enginePromise;
  }

  function pad2(n){ return String(n).padStart(2, '0'); }

  function safeCall(obj, names, fallback){
    if(fallback === undefined) fallback = '';
    for(var i=0;i<names.length;i++){
      var k = names[i];
      if(obj && typeof obj[k] === 'function'){
        try{ return obj[k](); }catch(_e){}
      }
    }
    return fallback;
  }

  function solarFromYmd(y,m,d){
    if(!window.Solar || typeof window.Solar.fromYmd !== 'function') return null;
    return window.Solar.fromYmd(y,m,d);
  }

  function solarFromDate(dt){
    try{
      var d = (dt instanceof Date) ? dt : new Date(dt);
      return solarFromYmd(d.getFullYear(), d.getMonth()+1, d.getDate());
    }catch(_e){
      return null;
    }
  }

  function lunarFromSolar(solar){
    try{ return solar && solar.getLunar ? solar.getLunar() : null; }catch(_e){ return null; }
  }

  function formatSolarYmd(solar){
    if(!solar) return '';
    try{ return solar.getYear()+'-'+pad2(solar.getMonth())+'-'+pad2(solar.getDay()); }catch(_e){ return ''; }
  }

  function formatLunarZh(lunar){
    if(!lunar) return '';
    var ly = safeCall(lunar, ['getYearInChinese','getYearInChineseExact'], '');
    var lm = safeCall(lunar, ['getMonthInChinese','getMonthInChineseExact'], '');
    var ld = safeCall(lunar, ['getDayInChinese','getDayInChineseExact'], '');
    var isLeap = safeCall(lunar, ['isLeap'], false);
    return (ly?ly+'年 ':'') + (isLeap?'閏':'') + (lm?lm+'月 ':'') + (ld||'');
  }

  function formatGanZhiYmd(lunar){
    if(!lunar) return '';
    var gzY = safeCall(lunar, ['getYearInGanZhi','getYearInGanZhiExact','getYearInGanZhiByLiChun'], '');
    var gzM = safeCall(lunar, ['getMonthInGanZhi','getMonthInGanZhiExact'], '');
    var gzD = safeCall(lunar, ['getDayInGanZhi','getDayInGanZhiExact'], '');
    return [gzY, gzM, gzD].filter(Boolean).join(' ');
  }

  SLB.lunar = SLB.lunar || {};
  SLB.lunar.DEFAULT_VENDOR_URLS = DEFAULT_VENDOR_URLS;
  SLB.lunar.getVendorUrls = getVendorUrls;
  SLB.lunar.ensureEngine = ensureEngine;
  SLB.lunar.hasEngine = hasEngine;

  // helper wrappers
  SLB.lunar.solarFromYmd = solarFromYmd;
  SLB.lunar.solarFromDate = solarFromDate;
  SLB.lunar.lunarFromSolar = lunarFromSolar;
  SLB.lunar.formatSolarYmd = formatSolarYmd;
  SLB.lunar.formatLunarZh = formatLunarZh;
  SLB.lunar.formatGanZhiYmd = formatGanZhiYmd;

})();


/* ====== SLB SRC: 68_cultivation_contract.js ====== */
;(function(w){
  "use strict";

  var CACHE_SCHEMA = 3;
  var SUMMARY_VERSION = 2;

  function isDateISO(v){
    var s = String(v == null ? "" : v).trim();
    if(!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
    var d = new Date(s + "T00:00:00Z");
    return !isNaN(d.getTime()) && d.toISOString().slice(0,10) === s;
  }

  function validNumber(v, min){
    var n = Number(v);
    return Number.isFinite(n) && Math.floor(n) === n && n >= min;
  }

  function validateSummaries(input, opts){
    opts = opts || {};
    var arr = Array.isArray(input) ? input : null;
    var errors = [];
    var seen = {};
    if(!arr){ return {ok:false, errors:["summaries must be an array"], summaries:[]}; }
    if(!arr.length && opts.allowEmpty === false) errors.push("summaries are empty");
    var normalized = [];

    arr.forEach(function(raw, i){
      var s = raw && typeof raw === "object" ? raw : null;
      var prefix = "summary[" + i + "] ";
      if(!s){ errors.push(prefix + "is not an object"); return; }
      var tk = String(s.typeKey||"").trim();
      var done = Number(s.doneDays);
      var target = Number(s.targetTotal);
      var last = String(s.lastDoneDateISO || s.lastDateISO || "").trim();
      if(!tk) errors.push(prefix + "typeKey is missing");
      if(tk && seen[tk]) errors.push(prefix + "duplicates typeKey " + tk);
      if(tk) seen[tk] = 1;
      if(!validNumber(done, 0)) errors.push(prefix + "doneDays is invalid");
      if(!validNumber(target, 1)) errors.push(prefix + "targetTotal is invalid");
      if(last && !isDateISO(last)) errors.push(prefix + "lastDoneDateISO is invalid");
      if(validNumber(done, 1) && !isDateISO(last)) errors.push(prefix + "lastDoneDateISO is required");
      if(s.dirty === true || String(s.dirty||"") === "1") errors.push(prefix + "is dirty");
      if(Number(s.summaryVersion) !== SUMMARY_VERSION) errors.push(prefix + "summaryVersion is unsupported");
      ["lastAccountedDateISO","cycleStartISO","baseLastDateISO"].forEach(function(k){
        var d = String(s[k]||"").trim();
        if(d && !isDateISO(d)) errors.push(prefix + k + " is invalid");
      });
      normalized.push(Object.assign({}, s, {
        typeKey:tk,
        doneDays:validNumber(done,0) ? done : s.doneDays,
        targetTotal:validNumber(target,1) ? target : s.targetTotal,
        lastDoneDateISO:last,
        lastDateISO:last,
        summaryVersion:Number(s.summaryVersion),
        started:s.started !== false
      }));
    });
    return {ok:errors.length === 0, errors:errors, summaries:normalized};
  }

  function validateDailyPayload(daily, previousSummaries){
    var errors = [];
    if(!daily || typeof daily !== "object") return {ok:false, errors:["daily payload is missing"], summaries:[]};
    if(daily.authoritative !== true) errors.push("response is not authoritative");
    if(daily.needsRebuild === true) errors.push("response needs rebuild");
    if(daily.summarySchemaValid === false) errors.push("summary schema is invalid");
    if(Number(daily.summaryVersion) !== SUMMARY_VERSION) errors.push("backend summaryVersion is unsupported");
    if(["SUMMARY","FULL_REBUILD"].indexOf(String(daily.source||"")) < 0) errors.push("response source is not authoritative");

    var input = Array.isArray(daily.allSummaries) ? daily.allSummaries : daily.summaries;
    var checked = validateSummaries(input, {allowEmpty:true});
    errors = errors.concat(checked.errors);

    var previous = Array.isArray(previousSummaries) ? previousSummaries : [];
    var previousKeys = {};
    previous.forEach(function(s){ var k=String(s&&s.typeKey||""); if(k) previousKeys[k]=1; });
    var nextKeys = {};
    checked.summaries.forEach(function(s){ if(s.typeKey) nextKeys[s.typeKey]=1; });
    var missingKnown = Object.keys(previousKeys).filter(function(k){ return !nextKeys[k]; });
    if(missingKnown.length && daily.completeTypeSet !== true){
      errors.push("response omitted known cultivation types: " + missingKnown.join(", "));
    }

    var previousHadProgress = previous.some(function(s){ return Number(s&&s.doneDays||0) > 0; });
    var nextAllZero = checked.summaries.length === 0 || checked.summaries.every(function(s){ return Number(s.doneDays||0) === 0; });
    if(previousHadProgress && nextAllZero && daily.zeroStateConfirmed !== true){
      errors.push("unexpected all-zero replacement was not confirmed by backend");
    }
    return {ok:errors.length === 0, errors:errors, summaries:checked.summaries};
  }

  function validateCachePackage(pack, callsign){
    var errors = [];
    var cs = String(callsign||"").trim().toUpperCase();
    if(!pack || typeof pack !== "object") return {ok:false, errors:["cache package is missing"], summaries:[]};
    if(Number(pack.cacheSchema) !== CACHE_SCHEMA) errors.push("cache schema is stale");
    if(!cs || String(pack.callsign||"").trim().toUpperCase() !== cs) errors.push("cache callsign does not match");
    if(pack.authoritative !== true) errors.push("cache was not authoritative");
    if(Number(pack.backendSummaryVersion) !== SUMMARY_VERSION) errors.push("cache backend version is stale");
    if(!Number.isFinite(Number(pack.savedAt)) || Number(pack.savedAt) <= 0) errors.push("cache savedAt is invalid");
    if(["SUMMARY","FULL_REBUILD","MUTATION"].indexOf(String(pack.source||"")) < 0) errors.push("cache source is invalid");
    var checked = validateSummaries(pack.summaries, {allowEmpty:true});
    errors = errors.concat(checked.errors);
    var allZero = checked.summaries.length === 0 || checked.summaries.every(function(s){ return Number(s.doneDays||0) === 0; });
    if(allZero && pack.zeroStateConfirmed !== true) errors.push("zero cache was not confirmed by backend");
    return {ok:errors.length === 0, errors:errors, summaries:checked.summaries};
  }

  function buildSummariesFromRecords(records, existing, typeName, todayISO){
    var meta = {};
    (Array.isArray(existing) ? existing : []).forEach(function(s){
      var tk = String(s&&s.typeKey||"").trim();
      if(tk) meta[tk] = Object.assign({}, s);
    });
    var grouped = {};
    (Array.isArray(records) ? records : []).forEach(function(r){
      if(!r || r.deleted || String(r.__state||"") === "pendingDel") return;
      var tk = String(r.typeKey||"").trim();
      if(!tk) return;
      if(!grouped[tk]) grouped[tk] = {dates:{}, baseline:0, baselineDate:"", label:""};
      var g = grouped[tk];
      if(!g.label && String(r.typeLabel||"").trim()) g.label = String(r.typeLabel).trim();
      if(r.isBaseline || /^BASELINE:/i.test(String(r.logId||""))){
        g.baseline = Math.max(g.baseline, Math.max(0, Math.floor(Number(r.baseDoneDays||0)||0)));
        g.baselineDate = String(r.baseLastDateISO||r.dateISO||"").slice(0,10);
        return;
      }
      var d = String(r.dateISO||"").slice(0,10);
      if(isDateISO(d)) g.dates[d] = 1;
    });

    Object.keys(grouped).forEach(function(tk){
      var g = grouped[tk];
      var s = Object.assign({}, meta[tk] || {});
      var dates = Object.keys(g.dates).sort();
      var label = String(s.displayName||s.typeLabel||g.label||(typeName&&typeName(tk))||tk);
      var targetBase = validNumber(s.targetBase,1) ? Number(s.targetBase) : 108;
      var penaltyDays = validNumber(s.penaltyDays,0) ? Number(s.penaltyDays) : 0;
      s.typeKey = tk;
      s.typeLabel = label;
      s.displayName = label;
      s.started = true;
      s.doneDays = g.baseline + dates.length;
      s.targetBase = targetBase;
      s.penaltyDays = penaltyDays;
      s.targetTotal = validNumber(s.targetTotal,1) ? Number(s.targetTotal) : targetBase + penaltyDays;
      s.lastDoneDateISO = dates.length ? dates[dates.length-1] : g.baselineDate;
      s.lastDateISO = s.lastDoneDateISO;
      s.hasToday = !!(todayISO && s.lastDoneDateISO === todayISO);
      s.__localDerived = true;
      meta[tk] = s;
    });
    return Object.keys(meta).map(function(k){ return meta[k]; }).sort(function(a,b){
      return String(a.displayName||a.typeKey||"").toLowerCase().localeCompare(String(b.displayName||b.typeKey||"").toLowerCase());
    });
  }

  w.SLB_CULT_CONTRACT = {
    cacheSchema:CACHE_SCHEMA,
    summaryVersion:SUMMARY_VERSION,
    isDateISO:isDateISO,
    validateSummaries:validateSummaries,
    validateDailyPayload:validateDailyPayload,
    validateCachePackage:validateCachePackage,
    buildSummariesFromRecords:buildSummariesFromRecords
  };
})(window);


/* ====== SLB CORE: 90_core_app.part01.js ====== */
/* SLB PART FILE — NOT STANDALONE
   This file is concatenated by slb_build/build.mjs into assets/slb.bundle.generated.js
*/

/* SLB CORE APP (split) - part 01/6
   NOTE: These parts are concatenated in order by slb_build/build.mjs.
*/
/* SLB CORE APP (migrated from legacy)
   - Source of truth for the main SLB app runtime.
   - Prefer editing smaller modules under /slb_src/features or /slb_src/admin when possible.
   - This file is included by /slb_build/build.mjs during generation.
*/

      try{ const E = boardEls_(); if(E && E.list) E.list.__hasLoaded = true; }catch(_e){}
/* ===== SLB Shared Helpers (V1) =====
   Purpose: One tiny, stable helper surface used across all slices.
   - Avoids "qs is not defined" type bugs after split / refactors.
   - Does NOT override existing theme globals (only defines if missing).
*/
(function(w){
  try{
    if(!w.SLBH){
      var H = {};
      H.qs  = function(sel, root){ try{ return (root||document).querySelector(sel); }catch(_e){ return null; } };
      H.qsa = function(sel, root){ try{ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }catch(_e){ return []; } };
      H.el  = function(id){ try{ return document.getElementById(id); }catch(_e){ return null; } };
      H.on  = function(node, evt, fn, opts){ try{ if(node) node.addEventListener(evt, fn, opts||false); }catch(_e){} };
      H.show = function(node, on){
        try{
          if(!node) return;
          var yes = (on === undefined) ? true : !!on;
          // Prefer SLB class-based hiding
          if(node.classList){
            if(yes) node.classList.remove('hidden');
            else node.classList.add('hidden');
          }
          // Keep HTML hidden attribute + display in sync
          try{ node.hidden = !yes; }catch(_e){}
          try{ if(node.style) node.style.display = yes ? '' : 'none'; }catch(_e){}
        }catch(_e){}
      };
      H.hide = function(node){
        try{ H.show(node, false); }catch(_e){}
      };

      H.setText = function(nodeOrId, txt){
        try{
          var n = (typeof nodeOrId==="string") ? document.getElementById(nodeOrId) : nodeOrId;
          if(n) n.textContent = (txt==null? "" : String(txt));
        }catch(_e){}
      };
      w.SLBH = H;
    }
    // Compat aliases for older/newer slices (define only if missing)
    if(!w.qs) w.qs = function(sel, root){ return w.SLBH.qs(sel, root); };
    if(!w.qsa) w.qsa = function(sel, root){ return w.SLBH.qsa(sel, root); };
    if(!w.el) w.el = function(id){ return w.SLBH.el(id); };
    if(!w.on) w.on = function(node, evt, fn, opts){ return w.SLBH.on(node, evt, fn, opts); };
    if(!w.show) w.show = function(node, on){ return w.SLBH.show(node, on); };
    if(!w.hide) w.hide = function(node){ return w.SLBH.hide(node); };
    if(!w.setText) w.setText = function(nodeOrId, txt){ return w.SLBH.setText(nodeOrId, txt); };
  }catch(_e){}
})(window);

/* ===== SLB Boot Check (Admin only) ===== */
(function(w){
  try{
    var isAdm = false;
    try{ isAdm = (sessionStorage.getItem("tyw_isAdmin")==="1"); }catch(_e2){}
    if(!isAdm) return;
    var miss = [];
    if(!w.SLBH) miss.push("SLBH");
    if(typeof w.qs!=="function") miss.push("qs");
    if(typeof w.el!=="function") miss.push("el");
    if(typeof w.on!=="function") miss.push("on");
    if(typeof w.setText!=="function") miss.push("setText");
    if(miss.length){
      try{ console.warn("[SLB] BootCheck: missing helpers:", miss.join(", ")); }catch(_e3){}
    }
  }catch(_e){}
})(window);


/* SLB PATCH6: Admin menu hard-switch (window capture) — bypasses theme click blockers */
(function(){
  function _slbShowAdm_(key){
    try{
      var panel = document.getElementById('tywAdminPanel');
      if(!panel) return;
      var pages = Array.prototype.slice.call(panel.querySelectorAll('.admPage'));
      var btns  = Array.prototype.slice.call(panel.querySelectorAll('.admNavBtn'));
      pages.forEach(function(p){ p.classList.toggle('active', (p.getAttribute('data-adm')===key)); });
      btns.forEach(function(b){ b.classList.toggle('active', (b.getAttribute('data-adm')===key)); });
      var anyActive = pages.some(function(p){ return p.classList.contains('active'); });
      if(!anyActive && pages.length){
        pages[0].classList.add('active');
        var k0 = pages[0].getAttribute('data-adm');
        btns.forEach(function(b){ b.classList.toggle('active', (b.getAttribute('data-adm')===k0)); });
      }
          // SLB OFFLINE: auto-load Admin Disciples list when switching to this admin page
      try{
        if(key === 'library_telemetry' && typeof window.SLB_loadLibraryTelemetry === 'function'){ setTimeout(function(){ try{ window.SLB_loadLibraryTelemetry(false); }catch(_eTel){} },0); }
        if(key === 'target' && typeof window.SLB_loadAdminUsers === 'function'){ setTimeout(function(){ try{ window.SLB_loadAdminUsers(false); }catch(_eUsers){} },0); }
        if(key === 'adjust' && typeof window.SLB_refreshAdminAdjust === 'function'){
          setTimeout(function(){ try{ window.SLB_refreshAdminAdjust(); }catch(_eAdj){} },0);
        }
        if(key === 'disciples'){
          try{ if(window.SLB_STATE && !window.SLB_STATE.adminDiscScope) window.SLB_STATE.adminDiscScope = 'IN'; }catch(_e1){}
          (function(){
            var tries = 0;
            function kick(){
              tries++;
              try{
                var active = document.querySelector('#tywAdminPanel .admPage.active');
                var adm = active ? String(active.getAttribute('data-adm')||'') : '';
                if(adm !== 'disciples') return;
                try{
                  var E = (typeof discEls_ === 'function') ? discEls_() : null;
                  if(E && E.scope && !E.scope.value) E.scope.value = 'IN';
                }catch(_e2){}
                if(typeof loadAdminDisciples === 'function'){
                  try{
                    var S = window.SLB_STATE;
                    if(!S || !S.adminDisciples || !S.adminDisciples.__hasLoaded){
                      loadAdminDisciples(false).catch(function(){});
                    }else{
                      try{ discRender_(); }catch(_e3){}
                    }
                  }catch(_e4){}
                  return;
                }
              }catch(_e5){}
              if(tries < 12) setTimeout(kick, 150);
            }
            setTimeout(kick, 0);
          })();
        }
      }catch(_e0){}
    }catch(_e){}
  }

  function _slbAdmHandler_(e){
    try{
      var panel = document.getElementById('tywAdminPanel');
      if(!panel) return;

      // Only when Admin panel is visible
      var cs = window.getComputedStyle ? window.getComputedStyle(panel) : null;
      if(cs && cs.display === 'none') return;

      var menu = panel.querySelector('.adminMenu');
      if(!menu) return;

      // Only handle events that originate from the Admin menu area
      var inMenu = false;
      try{
        if(e && e.composedPath){
          var path = e.composedPath();
          if(path && path.indexOf(menu) >= 0) inMenu = true;
        }
      }catch(_e0){}
      if(!inMenu){
        try{ inMenu = !!(e.target && menu.contains(e.target)); }catch(_e1){}
      }
      if(!inMenu && typeof e.clientX === 'number' && typeof e.clientY === 'number'){
        try{
          var r = menu.getBoundingClientRect();
          if(e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) inMenu = true;
        }catch(_e2){}
      }
      if(!inMenu) return;

      // Identify the intended button even if a drag-scroll helper hijacks the target
      var btn = null;
      try{ btn = e.target && e.target.closest ? e.target.closest('.admNavBtn') : null; }catch(_e3){}
      if(!btn && typeof document.elementFromPoint === 'function' && typeof e.clientX === 'number'){
        try{
          var el = document.elementFromPoint(e.clientX, e.clientY);
          btn = el && el.closest ? el.closest('.admNavBtn') : null;
        }catch(_e4){}
      }
      if(!btn){
        try{
          var btns = Array.prototype.slice.call(menu.querySelectorAll('.admNavBtn'));
          var y = e.clientY;
          for(var i=0;i<btns.length;i++){
            var br = btns[i].getBoundingClientRect();
            if(y >= br.top && y <= br.bottom){ btn = btns[i]; break; }
          }
        }catch(_e5){}
      }
      if(!btn) return;

      // Left-click / primary touch only
      if(typeof e.button === 'number' && e.button !== 0) return;

      var key = btn.getAttribute('data-adm') || 'target';

      try{ e.preventDefault(); }catch(_e6){}
      try{ e.stopPropagation(); }catch(_e7){}
      try{ e.stopImmediatePropagation(); }catch(_e8){}

      _slbShowAdm_(key);
    }catch(_e9){}
  }

  try{
    window.addEventListener('pointerdown', _slbAdmHandler_, true);
    window.addEventListener('mousedown', _slbAdmHandler_, true);
    window.addEventListener('click', _slbAdmHandler_, true);
    window.addEventListener('touchstart', _slbAdmHandler_, {capture:true, passive:false});
  }catch(_e){}
})();



/* SLB PATCH8: Admin Target buttons click passthrough (bypasses theme drag-scroll click blockers) */
(function(){
  function isVisible(el){
    try{
      if(!el) return false;
      var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if(cs && (cs.display === 'none' || cs.visibility === 'hidden' || cs.pointerEvents === 'none')) return false;
      var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      if(r && (r.width <= 1 || r.height <= 1)) return false;
      return true;
    }catch(_e){ return false; }
  }

  function inAdminContent(e, panel){
    try{
      if(!panel) return false;
      var content = panel.querySelector('.adminContent');
      if(!content) return false;

      // Ignore clicks inside left menu; PATCH6 handles those.
      var menu = panel.querySelector('.adminMenu');
      if(menu){
        try{ if(e && e.composedPath && e.composedPath().indexOf(menu) >= 0) return false; }catch(_e0){}
        try{ if(e && e.target && menu.contains(e.target)) return false; }catch(_e1){}
        if(typeof e.clientX === 'number' && typeof e.clientY === 'number'){
          try{
            var mr = menu.getBoundingClientRect();
            if(e.clientX >= mr.left && e.clientX <= mr.right && e.clientY >= mr.top && e.clientY <= mr.bottom) return false;
          }catch(_e2){}
        }
      }

      if(e && e.composedPath){
        var p = e.composedPath();
        if(p && p.indexOf(content) >= 0) return true;
      }
      if(e && e.target && content.contains(e.target)) return true;

      if(typeof e.clientX === 'number' && typeof e.clientY === 'number'){
        try{
          var r = content.getBoundingClientRect();
          if(e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) return true;
        }catch(_e3){}
      }
    }catch(_e){}
    return false;
  }

  function findBtnFromEvent(e, panel){
    try{
      var btn = null;
      var t = e && e.target;
      if(t && t.closest) btn = t.closest('#tywAdmLoadUserBtn, #tywAdmSaveModeratorBtn');
      if(!btn && typeof document.elementFromPoint === 'function' && typeof e.clientX === 'number'){
        var el = document.elementFromPoint(e.clientX, e.clientY);
        if(el && el.closest) btn = el.closest('#tywAdmLoadUserBtn, #tywAdmSaveModeratorBtn');
      }
      if(btn && panel && panel.contains(btn)) return btn;
    }catch(_e){}
    return null;
  }

  function synthClick(btn){
    try{
      btn.__slbBypassTS = Date.now();
      var ev = new MouseEvent('click', { bubbles:true, cancelable:true, view: window });
      btn.dispatchEvent(ev);
    }catch(_e){}
  }

  function swallowIfRecentClick(e){
    try{
      if(!e || e.isTrusted !== true) return;
      var t = e.target;
      if(!t || !t.closest) return;
      var btn = t.closest('#tywAdmLoadUserBtn, #tywAdmSaveModeratorBtn');
      if(!btn) return;
      var ts = btn.__slbBypassTS || 0;
      if(ts && (Date.now() - ts) < 700){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }catch(_e){}
  }

  function handler(e){
    try{
      if(!e || e.isTrusted !== true) return; // only real user gestures
      // Only primary
      if(typeof e.button === 'number' && e.button !== 0) return;

      var panel = document.getElementById('tywAdminPanel');
      if(!panel || !isVisible(panel)) return;
      if(!inAdminContent(e, panel)) return;

      var btn = findBtnFromEvent(e, panel);
      if(!btn || !isVisible(btn) || btn.disabled) return;

      try{ e.preventDefault(); }catch(_e6){}
      try{ e.stopPropagation(); }catch(_e7){}
      try{ e.stopImmediatePropagation(); }catch(_e8){}

      synthClick(btn);
    }catch(_e9){}
  }

  try{
    window.addEventListener('pointerdown', handler, true);
    window.addEventListener('mousedown', handler, true);
    window.addEventListener('touchstart', handler, {capture:true, passive:false});
    window.addEventListener('click', swallowIfRecentClick, true);
  }catch(_e){}
})();

/* SLB: global stubs so older onclick builds never crash even if JS fails to load */
(function(){
  if(window.adminArchiveTxns_) return;
  function setText(id, txt){
    try{ var el=document.getElementById(id); if(el) el.textContent=txt; }catch(e){}
  }
  window.adminArchiveTxns_ = function(){
    setText("tywAdmArchiveMsg","Archive tool is loading. If this message stays, hard refresh (Ctrl+F5).");
  };
  window.previewArchiveTxns_ = function(){ return window.adminArchiveTxns_(); };
  window.runArchiveTxns_ = function(){ return window.adminArchiveTxns_(); };
})();

;(() => {
    "use strict";

    // ====== CONFIG ======
    // Backend WebApp URL resolution order (do NOT hard-lock to the zip default):
// 1) window.SLB_WEBAPP_URL (can be set in theme.liquid)
// 2) localStorage key 'slb_webapp_url' (persistent per browser)
// 3) URL query ?slb_backend=... (one-time override)
// 4) fallback default baked into the zip
function slbResolveWebappUrl(){
  try{
    if(typeof window!== 'undefined' && window.SLB_WEBAPP_URL) return String(window.SLB_WEBAPP_URL).trim();
  }catch(_e){}
  try{
    const v = localStorage.getItem('slb_webapp_url');
    if(v && String(v).trim()) return String(v).trim();
  }catch(_e){}
  try{
    const u = new URL(location.href);
    const q = u.searchParams.get('slb_backend');
    if(q && String(q).trim()){
      const vv = String(q).trim();
      try{ localStorage.setItem('slb_webapp_url', vv); }catch(_e){}
      return vv;
    }
  }catch(_e){}
  return 'https://script.google.com/macros/s/AKfycbwFTGsr-IfaETXvCC4IfTSHTJ3ESkNn46797KvI-hp-n2OIDhlnR7104sfZpheu0YzXCA/exec';
}
const WEBAPP_URL = slbResolveWebappUrl();


// ===== Shared active-machine session =====
// Keep the signed backend token (never the PIN) on this same website origin so
// a new Library tab and a return to SLB can reuse the still-valid login.
const SLB_SHARED_AUTH_KEY = "ty_auth_v1";
const SLB_SHARED_AUTH_FALLBACK_MS = 14 * 24 * 60 * 60 * 1000;
function slbTokenExpiryMs_(token){
  try{
    const head = String(token || "").split(".")[0] || "";
    if(!head) return 0;
    let b64 = head.replace(/-/g,"+").replace(/_/g,"/");
    while(b64.length % 4) b64 += "=";
    const body = JSON.parse(atob(b64));
    const exp = Number(body && body.e || 0);
    return Number.isFinite(exp) && exp > Date.now() ? exp : 0;
  }catch(_e){ return 0; }
}
function slbReadSharedAuth_(){
  try{
    const raw = localStorage.getItem(SLB_SHARED_AUTH_KEY) || "";
    if(!raw) return null;
    const auth = JSON.parse(raw);
    if(!auth || !auth.token) return auth || null;
    const exp = Number(auth.expiresAt || 0) || slbTokenExpiryMs_(auth.token);
    if(exp && Date.now() >= exp){
      localStorage.removeItem(SLB_SHARED_AUTH_KEY);
      return null;
    }
    auth.expiresAt = exp || (Date.now() + SLB_SHARED_AUTH_FALLBACK_MS);
    return auth;
  }catch(_e){ return null; }
}
function slbPersistSharedAuth_(){
  try{
    if(!S || !S.token) return;
    const prof = (S.dash && S.dash.profile) ? S.dash.profile : {};
    const prev = slbReadSharedAuth_() || {};
    const exp = slbTokenExpiryMs_(S.token) || Number(prev.expiresAt || 0) || (Date.now() + SLB_SHARED_AUTH_FALLBACK_MS);
    const auth = {
      token:String(S.token || ""),
      callsign:String(S.callsign || prof.callsign || "").trim().toUpperCase(),
      displayName:String(S.displayName || prof.displayName || S.callsign || "").trim(),
      isAdmin:!!S.isAdmin,
      role:S.isAdmin ? "admin" : (S.isModerator ? "moderator" : "user"),
      isModerator:!!S.isModerator,
      canCreatePouches:!!(S.isAdmin || S.canCreatePouches),
      ts:Date.now(),
      expiresAt:exp
    };
    localStorage.setItem(SLB_SHARED_AUTH_KEY, JSON.stringify(auth));
    localStorage.setItem("slb_fastboot_ok_ts", String(Date.now()));
  }catch(_e){}
}
function slbClearSharedAuth_(){
  try{ localStorage.removeItem(SLB_SHARED_AUTH_KEY); }catch(_e){}
  try{ localStorage.removeItem("slb_fastboot_ok_ts"); }catch(_e2){}
}

// A temporary backend, connection, or permission error must not erase a valid
// SLB login. Only a definite missing/expired/invalid token returns to login.
function slbIsDefinitiveAuthFailure_(err){
  try{
    const code = String((err && (err.code || err.errorCode || err.statusCode)) || "").trim().toUpperCase();
    if(/^(AUTH_EXPIRED|SESSION_EXPIRED|TOKEN_EXPIRED|INVALID_TOKEN|MISSING_TOKEN|AUTH_REQUIRED)$/.test(code)) return true;
    const msg = String((err && err.message) ? err.message : err || "").trim();
    return /(?:^|\b)(session expired|token expired|invalid token|missing token|authentication required|please log in again)(?:\b|$)/i.test(msg);
  }catch(_e){ return false; }
}

    // ====== DOM ROOT ======
    const root = document.getElementById("SaamLawBank") || document.getElementById("tyWealthCourtyard");
    if(!root) return;

    // Boot marker (diagnostic-safe): confirms the frontend JS actually executed
    try{ window.__SLB_BOOT_OK__ = true; }catch(_e){}
    try{ var _bl=document.getElementById("slbBootLine"); if(_bl) _bl.textContent="Loading app…"; }catch(_e){}
    try{ var _b=document.getElementById("slbBuild"); if(_b && /starting/i.test(String(_b.textContent||""))) _b.textContent="—"; }catch(_e){}
    try{ var _bs=document.getElementById("tywBackendStatus"); if(_bs && /starting/i.test(String(_bs.textContent||""))) _bs.textContent="Backend: loading…"; }catch(_e){}

    // ===== FastBoot (skip visible boot steps on refresh when session is still warm) =====
    // Goal: if user already has a valid token recently, don't show the hero boot steps again on F5 refresh.
    // We still refresh data in the background; this only removes the "reboot" feeling.
    const __SLB_FASTBOOT__ = (function(){
      try{
        // token is the primary gate
        let tok = (sessionStorage.getItem("tyw_token") || "");
        if(!tok){
          try{
            const a = slbReadSharedAuth_();
            if(a && a.token) tok = String(a.token || "");
          }catch(_e){}
        }
        if(!tok) return false;

        // default window: 14 days (override via localStorage slb_fastboot_days)
        let days = 14;
        try{
          const d = Number(localStorage.getItem("slb_fastboot_days") || "14");
          if(Number.isFinite(d) && d > 0 && d <= 90) days = d;
        }catch(_e){}

        const ts = Number(localStorage.getItem("slb_fastboot_ok_ts") || "0") || 0;
        if(!ts) return false;
        return (Date.now() - ts) < (days * 24 * 60 * 60 * 1000);
      }catch(_e){
        return false;
      }
    })();
    try{ window.__SLB_FASTBOOT__ = __SLB_FASTBOOT__; }catch(_e){}
    if(__SLB_FASTBOOT__){
      try{ document.documentElement.classList.add("slbFastBoot"); }catch(_e){}
      try{ var _sp=document.getElementById("slbPrebootSplash"); if(_sp) _sp.textContent="Restoring your SLB session…"; }catch(_e){}
    }


    // ====== Sticky offset: keep SLB sticky UI below the Shopify theme header ======
    // We set CSS var --slb-sticky-top on the SLB root so both the topbar and admin menu
    // won't overlap the theme header when scrolling.
    function applyStickyTop(){
      try{
        const sels = [
          '#shopify-section-header',
          'header.site-header',
          'header.header',
          '#HeaderWrapper',
          '#header',
          '.site-header',
          '.header-wrapper',
          'header'
        ];
        const seen = new Set();
        const nodes = [];
        for(const s of sels){
          document.querySelectorAll(s).forEach(n => {
            if(!n || seen.has(n)) return;
            seen.add(n);
            nodes.push(n);
          });
        }
        let bestH = 0;
        for(const n of nodes){
          const st = window.getComputedStyle(n);
          const pos = String(st.position||'');
          if(pos !== 'fixed' && pos !== 'sticky') continue;
          const top = parseFloat(st.top||'0');
          if(!(top <= 1)) continue;
          const r = n.getBoundingClientRect();
          const h = Math.round(r.height||0);
          if(h >= 40 && h < 220 && h > bestH) bestH = h;
        }
        const offset = bestH ? (bestH + 10) : 10;
        root.style.setProperty('--slb-sticky-top', offset + 'px');
      }catch(_e){
        try{ root.style.setProperty('--slb-sticky-top','10px'); }catch(_e2){}
      }
    }
    applyStickyTop();
    window.addEventListener('resize', () => { applyStickyTop(); }, { passive:true });

    // Shopify reinject guard (safe)
    if(root.__tywKeepAlive){
      try{ clearInterval(root.__tywKeepAlive); }catch(_e){}
    }
    root.__tywKeepAlive = 0;

    const el = (id) => (root.querySelector("#"+id) || document.getElementById(id));

    // Patch 4: JSONP-safe field limits (prevents overlong URL payloads)
    const LIMITS = {
      displayName: 60,
      acctName: 40,
      txnNote: 280,
      offerTitle: 80,
      offerDesc: 1200,
      offerDelivery: 200
    };
    const tooLongMsg = (label, max) => `${label} is too long (max ${max} chars).`;
    const ensureMaxLen = (label, v, max) => {
      const s = String(v == null ? "" : v);
      if(s.length > max) throw new Error(tooLongMsg(label, max));
      return s;
    };

    // Add event handlers safely (prevents double-binding if Shopify reinjects scripts)
    const onOnce = (id, evt, handler) => {
      const n = el(id);
      if(!n) return;
      const key = "tywWired" + evt.charAt(0).toUpperCase() + evt.slice(1);
      if(n.dataset && n.dataset[key]) return;
      if(n.dataset) n.dataset[key] = "1";
      n.addEventListener(evt, handler);
    };

    const loginCard = el("tywLoginCard");
    const appWrap = el("tywApp");

const backendStatus = el("tywBackendStatus");

// ===== Boot UI (3-step loader + reconnect) =====
const BOOT = (() => {
  const line = el("slbBootLine") || document.getElementById("slbBootLine");
  const steps = el("slbBootSteps") || document.getElementById("slbBootSteps");
  const s1 = el("slbStep1") || document.getElementById("slbStep1");
  const s2 = el("slbStep2") || document.getElementById("slbStep2");
  const s3 = el("slbStep3") || document.getElementById("slbStep3");
  const conn = el("slbConnBox") || document.getElementById("slbConnBox");
  const connText = el("slbConnText") || document.getElementById("slbConnText");
  const retryBtn = el("slbRetryBtn") || document.getElementById("slbRetryBtn");

  let hideT = 0;

  function setLine(t){
    if(!line) return;
    line.textContent = String(t || "");
  }

  function setStep(n, state){
    const node = (n===1? s1 : (n===2? s2 : s3));
    if(!node) return;
    node.classList.remove("done","active","error","waiting");
    if(state) node.classList.add(state);
  }

  function showSteps(){
    // FastBoot keeps the hero loader hidden on refresh.
    try{ if(window.__SLB_FASTBOOT__) return; }catch(_e){}
    if(steps) steps.classList.remove("hidden");
  }

  function hideStepsSoon(){
    if(!steps) return;
    try{ if(hideT) clearTimeout(hideT); }catch(_e){}
    hideT = setTimeout(() => { try{ steps.classList.add("hidden"); }catch(_e){} }, 1200);
  }

  function showConn(msg){
    // On error we must show the reconnect UI even if FastBoot is enabled.
    try{ document.documentElement.classList.remove("slbFastBoot"); }catch(_e){}
    try{ window.__SLB_FASTBOOT__ = false; }catch(_e){}
    if(connText) connText.textContent = String(msg || "");
    if(conn) conn.classList.remove("hidden");
    if(steps) steps.classList.remove("hidden");
  }

  function hideConn(){
    if(conn) conn.classList.add("hidden");
  }

  return { line, steps, retryBtn, setLine, setStep, showConn, hideConn, showSteps, hideStepsSoon };
})();

	// ===== Shared auth bridge (page.blank.liquid -> SLB) =====
	// If the universal login already stored a valid token in localStorage, hydrate sessionStorage
	// before SLB reads it, so SLB does NOT show a second login screen.
	try{
	  const hasTok = !!(sessionStorage.getItem("tyw_token") || "");
	  if(!hasTok){
	    const a = slbReadSharedAuth_();
	    if(a && a.token){
	      try{ sessionStorage.setItem("tyw_token", String(a.token||"")); }catch(_e){}
	      try{ sessionStorage.setItem("tyw_callsign", String(a.callsign||"").toUpperCase()); }catch(_e){}
	      try{ sessionStorage.setItem("tyw_displayName", String(a.displayName||a.callsign||"").trim()); }catch(_e){}
	      try{ sessionStorage.setItem("tyw_isAdmin", a.isAdmin ? "1" : "0"); }catch(_e){}
	      try{ sessionStorage.setItem("tyw_isModerator", a.isModerator ? "1" : "0"); }catch(_e){}
	      try{ sessionStorage.setItem("tyw_canCreatePouches", a.canCreatePouches ? "1" : "0"); }catch(_e){}
	    }
	  }
	}catch(_e){}

    // ====== STATE ======
    const S = {
      reqSeq: 0,
      dashReq: 0,
      adminTargetReq: 0,
      token: sessionStorage.getItem("tyw_token") || "",
      callsign: sessionStorage.getItem("tyw_callsign") || "",
      displayName: sessionStorage.getItem("tyw_displayName") || "",
      isAdmin: sessionStorage.getItem("tyw_isAdmin") === "1",
      isModerator: sessionStorage.getItem("tyw_isModerator") === "1",
      isAdminOrMod: (sessionStorage.getItem("tyw_isAdmin") === "1") || (sessionStorage.getItem("tyw_isModerator") === "1"),
      canCreatePouches: sessionStorage.getItem("tyw_canCreatePouches") === "1",
      dash: null,

      sort: { key:"time", dir:"desc" },
      aSort: { key:"time", dir:"desc" },

      adminUsers: [],
      adminTarget: "",
      adminDash: null,


      adminRoster: null,
      adminRosterQ: "",
      adminDisciples: null,
      adminDiscQ: "",
      adminDiscScope: "IN",
      adminDiscSelected: null,
      awards: [],
      awardStatus: null,
      payrollRules: [],

      p3: {
        ok: false,
        loaded: { offer:false, market:false, orders:false, sales:false },
        loading: { offer:false, market:false, orders:false, sales:false },
        myOffersShowInactive: (localStorage.getItem("slb_myoffers_showinactive")==="1"),
        myOrdersHideClosed: (localStorage.getItem("slb_myorders_hideclosed")!=="0"),
        mySalesHideClosed: (localStorage.getItem("slb_mysales_hideclosed")!=="0"),
        mineOffers: [],
        marketOffers: [],
        myOrders: [],
        mySales: [],
        last: { offer:0, market:0, orders:0, sales:0 },
        actionCache: {}
      }
    };

    // Save an already-active tab session immediately, and again just before
    // opening the standalone Library in a new tab.
    try{ if(S.token) slbPersistSharedAuth_(); }catch(_eAuthWarm){}
    try{
      document.addEventListener("click", function(e){
        var t=e&&e.target&&e.target.closest ? e.target.closest("[data-slb-external-url]") : null;
        if(!t)return;
        try{ e.preventDefault(); }catch(_ePrevent){}
        try{ e.stopPropagation(); }catch(_eStop){}
        try{ if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }catch(_eStopImmediate){}
        try{ slbPersistSharedAuth_(); }catch(_ePersist){}
        var url=String(t.getAttribute("data-slb-external-url")||"").trim();
        if(!url)return;
        // Open exactly one separate Library tab. Do not use the return value of
        // window.open as a success test: browsers may return null for noopener
        // even after the new tab opened, which previously redirected this SLB tab too.
        try{
          var link=document.createElement("a");
          link.href=url;
          link.target="_blank";
          link.rel="noopener noreferrer";
          link.style.display="none";
          (document.body||document.documentElement).appendChild(link);
          link.click();
          link.remove();
        }catch(_eOpen){
          try{ window.open(url,"_blank"); }catch(_eOpenFallback){}
        }
      }, true);
    }catch(_eAuthLink){}

    // ====== Phase 3 action candidates (backend name auto-detect) ======
    const P3 = {
      // Canonical backend action names (single source of truth)
      offerCreate: ["offerUpsert"],          // args: { offerId:"", title, description, price, qty, status }
      offerListMine: ["offerListMine"],      // returns: { offers: [...] }
      offerListMarket: ["offerListPublic"],  // returns: { offers: [...] }
      offerToggle: ["offerSetStatus"],       // args: { offerId, status: "PUBLISHED"|"DRAFT" }
      offerDelete: ["offerDelete"],          // args: { offerId }


      // We use offerUpsert for price/stock edits (send full offer fields)
      offerSetPrice: ["offerUpsert"],
      offerSetStock: ["offerUpsert"],

      orderCreate: ["orderCreate"],                  // args: { offerId, qty }
      orderCancel: ["orderBuyerCancel"],             // args: { orderId }
      orderConfirmReceived: ["orderBuyerConfirmReceived"], // args: { orderId }

      orderListMine: ["ordersMine"],                 // returns: { orders: [...] }
      saleListMine: ["salesMine"],                   // returns: { orders: [...] }

      // Seller updates order status
      saleAccept: ["orderSellerSetStatus"],          // args: { orderId, status:"IN_PROGRESS" }
      saleMarkDelivered: ["orderSellerSetStatus"]    // args: { orderId, status:"DELIVERED" }
    };

    // ====== Input cleaners ======
    function cleanCallsign(s){ return String(s||"").toUpperCase().replace(/[^A-Z0-9]/g,"").slice(0,12); }
    function cleanPin(s){ return String(s||"").replace(/\D/g,"").slice(0,4); }
    function toNum(s){ const v = Number(String(s||"").replace(/,/g,"").trim()); return Number.isFinite(v) ? v : NaN; }
    function toInt(s){ const v = toNum(s); return Number.isFinite(v) ? Math.trunc(v) : NaN; }

    // Live sanitize login fields
    const callsignInp = el("tywCallsign");
    const pinInp = el("tywPin");
    if(callsignInp){
      callsignInp.value = cleanCallsign(callsignInp.value || S.callsign || "");
      callsignInp.addEventListener("input", () => { callsignInp.value = cleanCallsign(callsignInp.value); });
    }
    if(pinInp){
      pinInp.addEventListener("input", () => { pinInp.value = cleanPin(pinInp.value); });
    }

    // Remember login (optional; per-device)
    const rememberInp = el("tywRemember");
    const SAVE_LOGIN_KEY = "slb_saved_login_v1";
    try{
      const saved = JSON.parse(localStorage.getItem(SAVE_LOGIN_KEY) || "null");
      if(saved && saved.callsign){
        if(saved.pin) localStorage.setItem(SAVE_LOGIN_KEY, JSON.stringify({ callsign: cleanCallsign(saved.callsign || "") }));
        if(callsignInp && !callsignInp.value) callsignInp.value = cleanCallsign(saved.callsign || "");
        if(pinInp) pinInp.value = "";
        if(rememberInp) rememberInp.checked = true;
      }
    }catch(_e){}



// ====== ACTION REGISTRY (Phase 4.5) ======
// Central place to keep action strings consistent (helps prevent typos).
const ACTIONS = Object.freeze({
  ping: "ping",
  login: "login",
  loginBundle: "loginBundle",
  getDashboard: "getDashboard",
  getTxnsPage: "getTxnsPage",
  transfer: "transfer",
  updateTxnNote: "updateTxnNote",
  createAccount: "createAccount",
  renameAccount: "renameAccount",
  reorderAccounts: "reorderAccounts",
  deleteAccount: "deleteAccount",
  // admin / maintenance
  adminArchiveTxns: "adminArchiveTxns",
  adminArchivePreview: "adminArchivePreview",
  adminReconcile: "adminReconcile",
  adminReconcileFix: "adminReconcileFix",
  // bulletin board
  boardList: "boardList",
  boardPost: "boardPost",
  boardDelete: "boardDelete",
  boardReact: "boardReact",
  // treasures
  treasuresList: "treasuresList",
  treasuresUpsert: "treasuresUpsert",
  treasuresDelete: "treasuresDelete",
  adminTreasuresSend: "adminTreasuresSend",
  adminTreasuresListAs: "adminTreasuresListAs",
  adminTreasuresUpsertAs: "adminTreasuresUpsertAs",
  adminTreasuresDeleteAs: "adminTreasuresDeleteAs",
  adminTreasuresOutboxList: "adminTreasuresOutboxList",
  adminTreasuresOutboxDeleteEverywhere: "adminTreasuresOutboxDeleteEverywhere"
});

function stableStringify(v){
  // Deterministic JSON stringify for single-flight keys
  if(v === null) return "null";
  const t = typeof v;
  if(t === "number" || t === "boolean") return String(v);
  if(t === "string") return JSON.stringify(v);
  if(Array.isArray(v)) return "[" + v.map(stableStringify).join(",") + "]";
  if(t === "object"){
    const keys = Object.keys(v).sort();
    const parts = [];
    for(let i=0;i<keys.length;i++){
      const k = keys[i];
      parts.push(JSON.stringify(k) + ":" + stableStringify(v[k]));
    }
    return "{" + parts.join(",") + "}";
  }
  return "null";
}
// ====== Local Page Cache (instant UI) ======
// Goal: show last-known data instantly, then refresh from backend.
// Per-device + per-callsign; safe to ignore if storage is unavailable.
const __SLB_CACHE_VER = "v1";
function slbCachePrefix_(){
  // Use callsign-stable prefix so caches survive browser restarts.
  // Priority: in-memory S.callsign -> sessionStorage -> localStorage shared auth.
  let cs = "";
  try{ cs = String((S && S.callsign) ? S.callsign : "").trim().toUpperCase(); }catch(_e0){ cs=""; }
  if(!cs){
    try{ cs = String(sessionStorage.getItem("tyw_callsign")||"").trim().toUpperCase(); }catch(_e1){ cs=""; }
  }
  if(!cs){
    try{
      const raw = localStorage.getItem("ty_auth_v1") || "";
      if(raw){
        const a = JSON.parse(raw);
        if(a && a.callsign) cs = String(a.callsign||"").trim().toUpperCase();
      }
    }catch(_e2){ cs=""; }
  }
  return "slb_pagecache_" + __SLB_CACHE_VER + "_" + (cs || "ANON");
}
function slbCacheKey_(name){ return slbCachePrefix_() + ":" + String(name||""); }
function slbCacheSensitive_(name){
  return /admin|dashboard|txn|disciple|roster|user|gift|letter|diary|cmr|sdr|swr|dcr|ddr|temple|award|cult|getmy|inbox/i.test(String(name||""));
}
function slbCacheStore_(name){ return slbCacheSensitive_(name) ? sessionStorage : localStorage; }
function slbCacheGet_(name, maxAgeMs){
  try{
    const raw = slbCacheStore_(name).getItem(slbCacheKey_(name));
    if(!raw) return null;
    const obj = JSON.parse(raw);
    if(!obj || typeof obj !== "object") return null;
    const ts = Number(obj.ts || 0);
    if(maxAgeMs && ts && (Date.now() - ts) > maxAgeMs) return null;
    return ("data" in obj) ? obj.data : null;
  }catch(_e){ return null; }
}
function slbCacheSet_(name, data){
  try{
    slbCacheStore_(name).setItem(slbCacheKey_(name), JSON.stringify({ ts: Date.now(), data: data }));
  }catch(_e){}
}

// ====== Persistent Warm Cache (localStorage) ======
// Used by "Supercharge" (star button) so cache survives browser restarts.
// Key store: slb_warm_cache_v1  (shared, per-action+payload signature)
function slbWarmDays_(){
  try{
    const d = Number(localStorage.getItem("slb_warm_days") || "14");
    if(Number.isFinite(d) && d > 0 && d <= 90) return d;
  }catch(_e){}
  return 14;
}
function slbWarmTtlMs_(){ return slbWarmDays_() * 24 * 60 * 60 * 1000; }

function slbWarmLoad_(){
  try{
    const raw = localStorage.getItem("slb_warm_cache_v2") || "";
    if(!raw) return {v:1, items:{}};
    const obj = JSON.parse(raw);
    if(!obj || typeof obj !== "object") return {v:1, items:{}};
    if(!obj.items || typeof obj.items !== "object") obj.items = {};
    return obj;
  }catch(_e){ return {v:1, items:{}}; }
}
function slbWarmSave_(obj){
  try{ localStorage.setItem("slb_warm_cache_v2", JSON.stringify(obj)); }catch(_e){}
}
function slbWarmAllowed_(action){
  return ["cultGetTypes","libraryBootstrap","libraryList","libraryGet","magic7Bootstrap","letterGodsList"].indexOf(String(action||"")) >= 0;
}
function slbWarmKey_(action, payload){
  try{
    payload = payload || {};
    if(payload && typeof payload === "object"){
      const keys = Object.keys(payload).filter(k => k !== "__warm_capture").sort();
      const parts = [];
      for(let i=0;i<keys.length;i++){
        const k = keys[i];
        parts.push([k, payload[k]]);
      }
      let cs = "ANON";
      try{ cs = String(sessionStorage.getItem("tyw_callsign")||"").trim().toUpperCase() || "ANON"; }catch(_eCs){}
      return cs + "|" + String(action||"") + "|" + JSON.stringify(parts);
    }
  }catch(_e){}
  return String(action||"");
}
function slbWarmGet_(action, payload){
  if(!slbWarmAllowed_(action)) return null;
  try{
    const db = slbWarmLoad_();
    const key = slbWarmKey_(action, payload);
    const it = db.items && db.items[key];
    if(!it) return null;
    const t = Number(it.t||0) || 0;
    const ttl = Number(it.ttl||0) || 0;
    if(t && ttl && (Date.now() - t) > ttl) return null;
    return ("v" in it) ? it.v : null;
  }catch(_e){ return null; }
}
function slbWarmPut_(action, payload, res, ttlMs){
  if(!slbWarmAllowed_(action)) return;
  try{
    const db = slbWarmLoad_();
    const key = slbWarmKey_(action, payload);
    db.items[key] = { t: Date.now(), ttl: ttlMs || slbWarmTtlMs_(), v: res };
    slbWarmSave_(db);
  }catch(_e){}
}



// ====== Secure POST RPC (explicit JSONP emergency fallback only) ======

    function toast(type, msg){
  try{
    var el = document.getElementById('slbToast');
    if(!el){ return; }
    var cls = (type === 'ok') ? 'ok' : 'err';
    el.className = 'slbToast show ' + cls;
    el.textContent = String(msg||'');
    if(el.__t) clearTimeout(el.__t);
    el.__t = setTimeout(function(){ el.className = 'slbToast'; }, 2600);
  }catch(e){}
}
// route all alerts to toast (keeps code changes minimal)
try{
  window.alert = function(m){ toast('err', m); };
}catch(e){}
function setBuildText(v){
  var t = String(v||'');
  var el = document.getElementById('slbBuild');
  if(el) el.textContent = t;
  var el2 = document.getElementById('slbBuildFoot');
  if(el2) el2.textContent = t;
}

// ===== Phase 2: Persistent Outbox Queue (V1) =====
// Goal: protect long writes (chunk transport) from page refresh / phone sleep by persisting payload locally.
// Phase 2: enqueue + markDone/markFailed only. (Auto-flush / hero sync button comes in Phase 3/4.)
const OUTBOX = (function(){
  const LS_META = "slb_outbox_meta_v1";
  const DB_NAME = "slb_outbox_db_v1";
  const STORE = "items";
  let dbp = null;
  // Phase 5 hardening
  const MAX_ITEMS = 80; // cap meta list (prevents localStorage bloat)
  const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // drop items older than 30 days (stale)
  const HARD_FAIL_TRIES = 8; // after this, auto-sync backs off heavily; manual Sync can still force
  const BACKOFF_BASE_MS = 5000; // 5s
  const BACKOFF_MAX_MS  = 10 * 60 * 1000; // 10m

  function backoffMs_(tries){
    tries = Number(tries || 0) || 0;
    // 5s, 10s, 20s... up to 10m (with jitter)
    let ms = BACKOFF_BASE_MS * Math.pow(2, Math.max(0, tries - 1));
    ms = Math.min(BACKOFF_MAX_MS, ms);
    // jitter +/- 20%
    const j = 0.8 + Math.random() * 0.4;
    return Math.floor(ms * j);
  }

  function pruneMeta_(metaArr){
    const ts = now();
    const kept = [];
    const removedIds = [];
    for(const m of (metaArr || [])){
      if(!m || !m.id) continue;
      const age = ts - (Number(m.createdAt || 0) || ts);
      if(age > MAX_AGE_MS){
        removedIds.push(m.id);
        continue;
      }
      kept.push(m);
    }
    // Cap by oldest-first removal (meta is newest-first)
    while(kept.length > MAX_ITEMS){
      const m = kept.pop();
      if(m && m.id) removedIds.push(m.id);
    }
    return { metaArr: kept, removedIds };
  }


  function now(){ return Date.now(); }
  function makeId(){
    return "ob_" + now() + "_" + Math.random().toString(16).slice(2);
  }

  function lsReadMeta_(){
    try{
      const s = localStorage.getItem(LS_META) || "";
      if(!s) return [];
      const a = JSON.parse(s);
      return Array.isArray(a) ? a : [];
    }catch(_e){ return []; }
  }
  function lsWriteMeta_(arr){
    try{
      localStorage.setItem(LS_META, JSON.stringify(arr||[]));
      return true;
    }catch(_e){ return false; }
  }

  function openDb_(){
    if(dbp) return dbp;
    dbp = new Promise((resolve, reject) => {
      try{
        if(!window.indexedDB) return resolve(null);
        const req = indexedDB.open(DB_NAME, 1);
        req.onupgradeneeded = function(){
          try{
            const db = req.result;
            if(!db.objectStoreNames.contains(STORE)){
              db.createObjectStore(STORE, { keyPath: "id" });
            }
          }catch(_e){}
        };
        req.onsuccess = function(){ resolve(req.result || null); };
        req.onerror = function(){ resolve(null); }; // fallback to localStorage-only
      }catch(_e){ resolve(null); }
    });
    return dbp;
  }

  async function dbPut_(rec){
    const db = await openDb_();
    if(!db) return false;
    return new Promise((resolve) => {
      try{
        const tx = db.transaction(STORE, "readwrite");
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => resolve(false);
        tx.objectStore(STORE).put(rec);
      }catch(_e){ resolve(false); }
    });
  }
  async function dbDel_(id){
    const db = await openDb_();
    if(!db) return false;
    return new Promise((resolve) => {
      try{
        const tx = db.transaction(STORE, "readwrite");
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => resolve(false);
        tx.objectStore(STORE).delete(id);
      }catch(_e){ resolve(false); }
    });
  }


async function dbGet_(id){
  const db = await openDb_();
  if(!db) return null;
  return new Promise((resolve) => {
    try{
      const tx = db.transaction(STORE, "readonly");
      const req = tx.objectStore(STORE).get(id);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => resolve(null);
    }catch(_e){ resolve(null); }
  });
}

  function coalesce_(metaArr, module, key){
    if(!module || !key) return { metaArr, removedIds: [] };
    const removed = [];
    const out = [];
    for(const m of metaArr){
      if(m && m.module === module && m.key === key){
        removed.push(m.id);
        continue;
      }
      out.push(m);
    }
    return { metaArr: out, removedIds: removed };
  }

  async function enqueue_(o){
    try{
      const module = String((o && o.module) || "generic");
      const key = String((o && o.key) || "");
      const action = String((o && o.action) || "");
      const args = (o && o.args) ? o.args : {};
      const id = makeId();
      let meta = lsReadMeta_();

      const c = coalesce_(meta, module, key);
      meta = c.metaArr;
      // Remove coalesced payloads from IDB (best effort)
      try{ for(const rid of c.removedIds) await dbDel_(rid); }catch(_e){}

      // Phase 5: prune stale/overflow items (best effort)
      try{
        const pr = pruneMeta_(meta);
        meta = pr.metaArr;
        for(const rid of pr.removedIds){ try{ await dbDel_(rid); }catch(_e){} }
      }catch(_e){}

      const m = { id, module, key, action, createdAt: now(), status: "pending", tries: 0, lastErr: "" };
      meta.unshift(m);
      lsWriteMeta_(meta);

      // Store payload in IDB (preferred). If IDB is unavailable, store inline as a last resort.
      const ok = await dbPut_({ id, action, args });
      if(!ok){
        // Inline fallback (may fail for very large payloads)
        try{
          m.inline = { action: action, args: args };
          lsWriteMeta_(meta);
        }catch(_e){}
      }
      return id;
    }catch(_e){
      return "";
    }
  }

  function updateMeta_(id, patch){
    const meta = lsReadMeta_();
    let changed = false;
    for(const m of meta){
      if(!m || m.id !== id) continue;
      Object.assign(m, patch||{});
      changed = true;
      break;
    }
    if(changed) lsWriteMeta_(meta);
    return changed;
  }

  async function markDone_(id){
    if(!id) return;
    const meta = lsReadMeta_().filter(m => m && m.id !== id);
    lsWriteMeta_(meta);
    try{ await dbDel_(id); }catch(_e){}
  }

  function markFailed_(id, err){
  if(!id) return;
  const msg = String((err && err.message) ? err.message : (err || ""));
  let tries = 0;
  try{
    const meta = lsReadMeta_();
    for(const mm of meta){ if(mm && mm.id === id){ tries = Number(mm.tries || 0) || 0; break; } }
  }catch(_e){}
  const ts = now();
  const patch = {
    status: "failed",
    lastErr: msg.slice(0, 220),
    tries: tries,
    owner: "",
    startedAt: 0
  };

  // Backoff schedule (prevents hammering)
  try{
    patch.nextTryAt = ts + backoffMs_(tries);
  }catch(_e){}

  // After many failures, stop auto-retrying aggressively; require manual Sync to force.
  if(tries >= HARD_FAIL_TRIES){
    patch.needsAttention = 1;
    try{ patch.nextTryAt = ts + (12 * 60 * 60 * 1000); }catch(_e){} // 12h
  }

  updateMeta_(id, patch);
}


  function pendingCount_(){
    const meta = lsReadMeta_();
    let n = 0;
    for(const m of meta){
      if(!m) continue;
      if(m.status === "pending" || m.status === "failed") n++;
    }
    return n;
  }

  function failedCount_(){
    const meta = lsReadMeta_();
    let n = 0;
    for(const m of meta){
      if(!m) continue;
      if(m.status === "failed") n++;
    }
    return n;
  }

  function needsAttentionCount_(){
    const meta = lsReadMeta_();
    let n = 0;
    for(const m of meta){
      if(!m) continue;
      if(m.needsAttention) n++;
    }
    return n;
  }



async function claimNext_(owner, force){
  const meta = lsReadMeta_();
  const ts = now();
  let changed = false;

  // Recover stale inflight items (e.g., phone slept / tab closed mid-send)
  for(const m of meta){
    if(!m) continue;
    if(m.status === "inflight"){
      const st = Number(m.startedAt || 0) || 0;
      if(st && (ts - st) > (2 * 60 * 1000)){
        m.status = "failed";
        m.lastErr = m.lastErr || "Recovered stale inflight item.";
        changed = true;
      }
    }
  }

  let target = null;
  const forced = !!force;
  for(const m of meta){
    if(!m) continue;
    if(m.status === "pending" || m.status === "failed"){
      // Respect backoff window unless forced by user
      const nta = Number(m.nextTryAt || 0) || 0;
      if(!forced && nta && ts < nta) continue;
      // After many failures, require manual Sync to force attempts
      const tr = Number(m.tries || 0) || 0;
      if(!forced && tr >= HARD_FAIL_TRIES) continue;
      target = m;
      break;
    }
  }

  if(changed) lsWriteMeta_(meta);
  if(!target) return null;

  // Claim it (best-effort cross-tab lock)
  try{
    target.status = "inflight";
    target.startedAt = ts;
    target.owner = String(owner || "");
    target.tries = (Number(target.tries || 0) || 0) + 1;
    target.lastTryAt = ts;
    // Clear backoff window since we're actively attempting now
    target.nextTryAt = 0;
    lsWriteMeta_(meta);
  }catch(_e){}

  let rec = null;
  try{ rec = await dbGet_(target.id); }catch(_e){}
  let action = "", args = {};
  try{
    if(rec && rec.action){
      action = String(rec.action || "");
      args = rec.args || {};
    }else if(target.inline && target.inline.action){
      action = String(target.inline.action || "");
      args = target.inline.args || {};
    }
  }catch(_e){}

  return { id: target.id, meta: target, payload: { action, args } };
}

  return {
    enqueue: enqueue_,
    markDone: markDone_,
    markFailed: markFailed_,
    listMeta: lsReadMeta_,
    pendingCount: pendingCount_,
    failedCount: failedCount_,
    needsAttentionCount: needsAttentionCount_,
    claimNext: claimNext_,
    _openDb: openDb_
  };
})();
function normalizeOutbox_(action, args, opts){
  try{
    if(!opts) return null;
    const ob = opts.outbox;
    if(!ob) return null;
    if(ob === true) return { module:"generic", key:"" };
    if(typeof ob === "string") return { module: ob, key:"" };
    if(typeof ob === "object"){
      if(ob.enabled === false) return null;
      return { module: String(ob.module || "generic"), key: String(ob.key || "") };
    }
  }catch(_e){}
  return null;
}



function rpc(action, args, opts){
      // Phase 4.1 client-side single-flight for write actions (prevents double-click duplicates)
      // Phase 5.2: generated from the centralized backend route manifest.
      // Every WRITE route receives write timeout/single-flight treatment.
      const WRITE = {
        "adminAddUser":1, "adminAdjustBalance":1, "adminAdjustGameCurrency":1, "aofCreatePill":1, "aofBuyVials":1, "aofConclude":1, "adminAnnivDelete":1, "adminAnnivNotifyEnsureTrigger":1, "adminAnnivNotifyTestEmail":1,
        "adminAnnivSeedGodDays":1, "adminAnnivUpsert":1, "adminArchiveTxns":1, "adminAwardDelete":1, "adminAwardGive":1,
        "adminAwardRevoke":1, "adminAwardToggle":1, "adminAwardUpsert":1, "adminChatAttachmentTrash":1, "adminChatGuestInviteEmail":1,
        "adminChatGuestRoomCreate":1, "adminChatGuestRoomSetMembers":1, "adminChatGuestRoomUpdateSettings":1, "adminChatPurgeNow":1, "adminChatPurgeRoomAll":1,
        "adminChatRoomClose":1, "adminChatRoomCreate":1, "adminChatRoomRename":1, "adminChatRoomReopen":1, "adminChatRoomSetAcl":1,
        "adminClearAvatar":1, "adminCocConfigSave":1, "adminCocRunProfileSync":1, "adminCocRunSync":1, "adminCocRunTests":1,
        "adminCocSetupTriggers":1, "adminCocTestApi":1, "adminCocTownSave":1, "adminCocTownSetActive":1, "adminCultAdjust":1,
        "adminCultCustomAdjust":1, "adminCultDeleteType":1, "adminCultDuplicateAudit":1, "adminCultImportCsv":1, "adminCultRebuildAllSummaries":1,
        "adminCultRebuildSummary":1, "adminDeletePouch":1, "adminDiscipleDedupe":1, "adminDiscipleDelete":1, "adminDiscipleImportCsv":1,
        "adminDiscipleImportCsvChunk":1, "adminDiscipleMove":1, "adminDiscipleUpdateShipping":1, "adminDiscipleUpsert":1, "adminIctRoomResolve":1,
        "adminLetterGodDelete":1, "adminLetterGodUpsert":1, "adminLetterGodsRefresh":1, "adminLetterGodsSyncAnniv":1, "adminLetterSampleDelete":1,
        "adminLetterSampleUpsert":1, "adminLettersDelete":1, "adminLettersEmailToDisciple":1, "adminLettersReplySend":1, "adminLettersUpsert":1,
        "adminLibraryCatsDelete":1, "adminLibraryCatsUpsert":1, "adminLibraryDedupe":1, "adminLibraryGroupsDelete":1, "adminLibraryGroupsUpsert":1,
        "adminM3MenuDelete":1, "adminM3MenuUpsert":1, "adminM3RestaurantDelete":1, "adminM3RestaurantUpsert":1, "adminMarketAutoConfirm":1,
        "adminMissionArchiveCompletedLogs":1, "adminMissionDelete":1, "adminMissionRevokeReward":1, "adminMissionSetArchive":1, "adminMissionUpsert":1,
        "adminOfferingAppendCorrection":1, "adminOfferingCatalogUpsert":1, "adminOfferingInventoryAdjust":1, "adminOfferingUploadArtwork":1, "adminOpsAuditPurge":1,
        "adminOpsClientError":1, "adminOpsErrorsAck":1, "adminOpsErrorsAckAllNew":1, "adminOpsErrorsPurge":1, "adminOpsLogTestError":1,
        "adminOrderForceRefund":1, "adminOrderForceRelease":1, "adminPageCfgImportAll":1, "adminPageCfgSave":1, "adminPayrollDelete":1,
        "adminPayrollRunDueNow":1, "adminPayrollRunRule":1, "adminPayrollRunRuleNow":1, "adminPayrollToggle":1, "adminPayrollUpsert":1,
        "adminReconcileFix":1, "adminResetUserPin":1, "adminSaamlAudioDelete":1, "adminSaamlAudioUpload":1, "adminSaamlAudioUpsert":1,
        "adminSaamlCharBulkUpsert":1, "adminSaamlCharUpsert":1, "adminSaamlCreateNewDb":1, "adminSaamlImportMasterCsvChunk":1, "adminSaamlImportMasterCsvFinalize":1,
        "adminSaamlImportMasterCsvInit":1, "adminSaamlInit":1, "adminSaamlRebuildTokenIndexAll":1, "adminSaamlTokenMetaUpsert":1, "adminSetAvatarImage":1,
        "adminSetAvatarUrl":1, "adminSetLibrarySpreadsheetId":1, "adminSetModerator":1, "adminSetPouchCreation":1, "adminTempleArchiveDone":1,
        "adminTempleBlocksSaveAll":1, "adminTempleCatalogUpsert":1, "adminTempleOrderArchive":1, "adminTempleOrderResendEmail":1, "adminTempleOrderSetStatus":1,
        "adminTreasuresDeleteAs":1, "adminTreasuresOutboxDeleteEverywhere":1, "adminTreasuresSend":1, "adminTreasuresUpsertAs":1, "adminUpdateTxnNote":1,
        "adminUserDelete":1, "adminUserUpdate":1, "boardDelete":1, "boardPost":1, "boardReact":1,
        "budgetAccessSet":1, "budgetEnsureProfile":1, "budgetPut":1, "budgetPutParts":1, "budgetWipeProfile":1,
        "cabinEmailSend":1, "changePin":1, "chatBanUser":1, "chatDeleteMessages":1, "chatEditMessage":1, "chatGuestEmergencyCall":1,
        "chatGuestPost":1, "chatPinMessage":1, "chatPost":1, "chatRedAlert":1, "chatSendAlert":1,
        "chatSetRoomNote":1, "chatSetRoomTools":1, "chatToggleReaction":1, "chatTypingPing":1, "chatUnbanUser":1,
        "chatUnpinMessage":1, "chatUploadAttachment":1, "clearAvatar":1, "cmrDelete":1, "cmrEmailJee":1,
        "cmrEmailMyself":1, "cmrEmailToDisciple":1, "cmrReplySend":1, "cmrUpsert":1, "createAccount":1,
        "cultAdd":1, "cultApplyMissed":1, "cultArchiveType":1, "cultDelete":1, "cultDeleteLog":1,
        "cultDeleteType":1, "cultRenameType":1, "cultRepairProgress":1, "cultRepairSelf":1, "cultSelfAdjust":1,
        "cultSetMyBaseline":1, "cultSetTarget":1, "cultUnarchiveType":1, "cultUpdate":1, "dcrDelete":1,
        "dcrEmailJee":1, "dcrEmailMyself":1, "dcrEmailToDisciple":1, "dcrReplySend":1, "dcrUpsert":1,
        "ddrDelete":1, "ddrEmailJee":1, "ddrEmailMyself":1, "ddrEmailToDisciple":1, "ddrReplySend":1,
        "ddrUpsert":1, "deleteAccount":1, "diaryAward":1, "diaryDelete":1, "diaryEmailToDisciple":1,
        "diaryEmailToSiJuen":1, "diaryEntryFlagSet":1, "diaryInboxMarkDone":1, "diaryInboxMarkDoneBulk":1, "diaryInboxTouchSeen":1,
        "diaryInboxTouchSeenBulk":1, "diaryDeskSendBatch":1, "diaryReplySend":1, "diaryReplyUpsert":1, "diaryUpsert":1, "giftSend":1,
        "ictBuyIn":1, "ictCashOut":1, "ictDragonRoomAct":1, "ictDragonRoomCreate":1, "ictDragonRoomJoin":1,
        "ictDragonRoomLeave":1, "ictDragonRoomPublish":1, "ictDragonV2Forfeit":1, "ictDragonV2Settle":1, "ictDragonV2Start":1,
        "ictRoomClose":1, "ictRoomCreate":1, "ictRoomJoin":1, "ictRoomPublish":1, "ictRoomSetStake":1,
        "ictRoomSettle":1, "ictRoomSettleHand":1, "ictRoomVoid":1, "ictSettleHand":1, "ictFreeplayWin":1, "taoGameFreeplayWin":1, "ictSettleMatch":1,
        "ictStartMatch":1, "lettersDelete":1, "lettersEmailToSiJuen":1, "lettersUpsert":1, "libraryCommentAdd":1,
        "libraryCommentDelete":1, "libraryNotifySendTo":1, "libraryPostArchive":1, "libraryPostDelete":1, "libraryPostPin":1,
        "libraryPostUpsert":1, "m3SendGift":1, "magic3mStartPrayer":1, "magic3mFinishPrayer":1, "magic3mHarvest":1, "magic3mDiscard":1, "magic3mSend":1, "magic3mConsume":1, "myAltarCreate":1, "myAltarUpdate":1, "myAltarDelete":1, "myAltarCompleteDay":1, "myAltarEndEarly":1, "myAltarGift":1, "myAltarConsume":1, "magic7DeploySubmit":1, "magic7FinalizeSubmit":1, "magic7SaveSubmit":1,
        "magic7SpotConfigSave":1, "magic7ToolsCleanupDemoConfirm":1, "magic7ToolsSeededTabsCleanupConfirm":1, "magic7ToolsTargetDisable":1, "magic7ToolsTargetRecordSave":1,
        "magic7ToolsTargetUpsert":1, "missionsComplete":1, "missionsStart":1, "notifyPrefsSet":1, "notifySendLinkTo":1,
        "notifySendTest":1, "nscBuyIn":1, "spExchangeVials":1, "nscCashOut":1, "nscRoomAct":1, "nscRoomCreate":1,
        "nscRoomJoin":1, "nscRoomLeave":1, "nscSoloFinish":1, "nscSoloForfeit":1, "nscSoloStart":1,
        "offerDelete":1, "offerSetStatus":1, "offerUpsert":1, "offeringBurn":1, "offeringDeleteDraft":1,
        "offeringPurchase":1, "offeringSaveDraft":1, "offeringUpdateBurnMeta":1, "orderBuyerCancel":1, "orderBuyerConfirmReceived":1,
        "orderCreate":1, "orderSellerSetStatus":1, "pinResetRequest":1, "renameAccount":1, "reorderAccounts":1, "sdrDelete":1,
        "sdrEmailJee":1, "sdrEmailMyself":1, "sdrEmailToDisciple":1, "sdrReplySend":1, "sdrUpsert":1,
        "setMyAvatar":1, "sltcRoomAct":1, "sltcRoomClose":1, "sltcRoomConfirm":1, "sltcRoomCreate":1,
        "sltcRoomForfeit":1, "sltcRoomJoin":1, "sltcSoloAct":1, "sltcSoloFinish":1, "sltcSoloForfeit":1,
        "sltcSoloStart":1, "submitCase":1, "thunderCourtBootstrap":1, "thunderCourtSubmit":1, "swrDelete":1, "swrEmailJee":1, "swrEmailMyself":1,
        "swrEmailToDisciple":1, "swrReplySend":1, "swrUpsert":1, "templeOrderArchive":1, "templeOrderCreate":1,
        "templeOrderCreateBulk":1, "transfer":1, "treasuresDelete":1, "treasuresUpsert":1, "updateCase":1,
        "updateTxnNote":1, "discipleAppRegisterDevice":1, "discipleAppRevokeDevice":1, "diaryDiscipleAppSubmit":1,
        "ccpCoinStart":1, "ccpCoinFinish":1, "ccpCoinForfeit":1, "ccpLessonReward":1,
        "mtmCoinStart":1, "mtmCoinFinish":1, "mtmCoinForfeit":1, "mtmFreeplayWin":1,
        "strCoinStart":1, "strCoinFinish":1, "strCoinForfeit":1, "taoCoinStart":1, "taoCoinFinish":1, "taoCoinForfeit":1,
        "twBootstrap":1, "twStart":1, "twAnswer":1, "tydLibraryTelemetry":1,
      };
      window.__TYW_INFLIGHT = window.__TYW_INFLIGHT || {};
      window.__TYW_INFLIGHT_READ = window.__TYW_INFLIGHT_READ || {};
      window.__TYW_RPC_CACHE = window.__TYW_RPC_CACHE || {};
const a = String(action||"").trim();
const isWrite = !!WRITE[a];

// Hydrate auth before any authenticated call.
// BUT: on some pages (or after long idle), S.token may not be hydrated even though a valid token exists
// in sessionStorage/localStorage. Re-hydrate once before declaring "Session expired".
if(!S.token){
  try{
    let tok = "";
    try{ tok = String(sessionStorage.getItem("tyw_token")||""); }catch(_e1){}
    if(!tok){
      try{
        const raw = localStorage.getItem("ty_auth_v1") || "";
        if(raw){
          const a = JSON.parse(raw);
          if(a && a.token) tok = String(a.token||"");
        }
      }catch(_e2){}
    }
    if(tok){
      S.token = tok;
      try{ sessionStorage.setItem("tyw_token", tok); }catch(_e3){}
    }
  }catch(_e0){}
}
if(isWrite && !S.token){
  try{ if(typeof showLogin === "function") showLogin(); }catch(_e){}
  return Promise.reject(new Error("Session expired. Please log in again."));
}


// Phase 2 Outbox: persist writes that opt-in (for Sync / resume later)
const ob = normalizeOutbox_(a, args||{}, opts||{});
let outboxId = "";
if(ob && !/^(get|list|fetch)/i.test(a)){
  try{ outboxId = OUTBOX.enqueue({ module: ob.module, key: ob.key, action: a, args: (args||{}) }); }catch(_e){}
}


// Phase 5: single-flight for writes + reads, plus optional response cache (reads only)
// - Writes: prevents double-click duplicates
// - Reads: prevents duplicate concurrent loads (room switch / tab spam / double render)
// - Cache: set opts.cacheTtlMs to keep result in-memory briefly
const isLoad = /^(get|list|fetch)/i.test(a);
const cacheTtlMs = (opts && opts.cacheTtlMs != null) ? Math.max(0, Number(opts.cacheTtlMs)||0) : 0;

// Write key (token-bound)
const wKey = isWrite ? (a + "|" + stableStringify(args||{}) + "|" + (S.token||"")) : null;

// Read key (token-bound; can be overridden by opts.dedupeKey)
const rKey = (!isWrite && (isLoad || cacheTtlMs > 0 || (opts && (opts.dedupe === true || opts.dedupeKey))))
  ? (opts && opts.dedupeKey ? String(opts.dedupeKey) : (a + "|" + stableStringify(args||{}) + "|" + (S.token||"")))
  : null;

const inflightMap = isWrite ? window.__TYW_INFLIGHT : window.__TYW_INFLIGHT_READ;
const key = isWrite ? wKey : rKey;

// Cache hit (reads only)
if(!isWrite && key && cacheTtlMs > 0){
  const c = window.__TYW_RPC_CACHE[key];
  if(c && c.e && c.e > Date.now()) return Promise.resolve(c.v);
  if(c) try{ delete window.__TYW_RPC_CACHE[key]; }catch(_e){}

// Persistent Warm Cache hit (reads only; survives browser restarts)
// Only used for cacheable reads (cacheTtlMs>0) or when opts.useWarmCache is true.
const warmEligible = (!isWrite && isLoad && (cacheTtlMs > 0 || (opts && opts.useWarmCache)));
const warmTtlMs = slbWarmTtlMs_();
if(warmEligible){
  const wh = slbWarmGet_(a, args||{});
  if(wh != null){
    // also seed in-memory cache for this session
    if(key && cacheTtlMs > 0){
      try{ window.__TYW_RPC_CACHE[key] = { v: wh, e: Date.now() + cacheTtlMs }; }catch(_e){}
    }
    return Promise.resolve(wh);
  }
}

}

// In-flight de-dupe
if(key && inflightMap[key]) return inflightMap[key];


const p = new Promise((resolve, reject) => {
        const requestId = (opts && opts.requestId) ? String(opts.requestId) : ("r" + Date.now() + "_" + Math.random().toString(16).slice(2));
        const tok = S.token || "";

        const timeoutMs = (function(){
          try{
            const custom = Number(opts && (opts.timeoutMs || opts.tmoMs || opts.timeout));
            if(Number.isFinite(custom) && custom >= 3000 && custom <= 180000) return custom;
          }catch(_eTmo){}
          const a = String(action||"");
          // Long-running operations (imports/reconcile/archive)
          if(/Import/i.test(a)) return 180000;
          if(/Email/i.test(a)) return 70000;
          if(a==="adminReconcile" || a==="adminReconcileFix" || a==="adminArchiveTxns" || a==="adminArchivePreview") return 120000;
          // Core banking writes can wait on spreadsheet locks for up to 20 seconds,
          // then still need idempotency logging and secure-response storage.
          // A 25-second client timeout can incorrectly mark a successful transfer
          // as failed before the server response becomes available.
          if(/^(transfer|giftSend|createAccount|renameAccount|reorderAccounts|deleteAccount|updateTxnNote)$/.test(a)) return 90000;
          // Marketplace actions can occasionally be slow due to sheet locks.
          if(/^offer/i.test(a) || /^order/i.test(a)) return 70000;
          // Give all other writes more room than ordinary reads.
          if(isWrite) return 70000;
          return 30000;
        })();

        function postBridgeCall_(payloadObj, tmo){
          if(!window.SLBPostBridge || typeof window.SLBPostBridge.call !== "function"){
            return Promise.reject(new Error("Secure SLB transport did not load. Hard refresh and try again."));
          }
          try{ window.__SLB_TRANSPORT_MODE__ = "POST_POLL_V1"; }catch(_eMode){}
          const bridgeOptions = {
            timeoutMs: Math.max(5000, Number(tmo || timeoutMs)),
            action: String(a || action || "")
          };
          if(opts && opts.visibleResponse === true) bridgeOptions.visibleResponse = true;
          return window.SLBPostBridge.call(WEBAPP_URL, payloadObj, bridgeOptions).then(function(data){
            try{ if(typeof window.__SLB_NET_MARK_HEALTHY__ === 'function') window.__SLB_NET_MARK_HEALTHY__({ action: a, requestId: String(payloadObj && payloadObj.requestId || ""), transport:"POST_POLL_V1" }); }catch(_eNet){}
            try{ if(warmEligible) slbWarmPut_(a, args||{}, data, warmTtlMs); }catch(_eWarm){}
            return data;
          });
        }

        const payloadOrig = { requestId, action, token: tok, args: args || {} };
        postBridgeCall_(payloadOrig, timeoutMs).then(resolve).catch(reject);
      });

      // Phase 2 Outbox completion hooks
      if(outboxId){
        try{
          p.then(function(){ try{ OUTBOX.markDone(outboxId); }catch(_e){} })
           .catch(function(e){ try{ OUTBOX.markFailed(outboxId, e); }catch(_e){} });
        }catch(_e){}
      }
      if(key) inflightMap[key] = p;

      if(!key) return p;
      return p.then(v => {
                try{
                  // Cache success for reads only
                  if(!isWrite && cacheTtlMs > 0){
                    window.__TYW_RPC_CACHE[key] = { e: Date.now() + cacheTtlMs, v: v };
                  }
                }catch(_e){}
                try{ delete inflightMap[key]; }catch(_e){}
                return v;
              })
              .catch(e => { try{ delete inflightMap[key]; }catch(_e){} throw e; });
    }

    // Alias (some sections call apiCall)
    const apiCall = rpc;


    function isUnknownActionErr(e){
      const m = String((e && e.message) ? e.message : e || "");
      return /unknown action/i.test(m);
    }

    async function rpcTryCached(cacheKey, candidates, args, opts){
      const cached = S.p3.actionCache[cacheKey];
      if(cached){
        try{ return await rpc(cached, args, opts); }
        catch(e){
          if(isUnknownActionErr(e)) delete S.p3.actionCache[cacheKey];
          else throw e;
        }
      }
      let lastErr = null;
      for(const a of candidates){
        try{
          const out = await rpc(a, args, opts);
          S.p3.actionCache[cacheKey] = a;
          return out;
        }catch(e){ lastErr = e; }
      }
      throw lastErr || new Error("Backend action not supported.");
    }

    // ====== UI Helpers ======
    function setText(id, txt){ const n = el(id); if(n) n.textContent = txt; }
    function setMsg(node, text, isOk){
      if(!node) return;
      const t = String(text == null ? "" : text);

      node.classList.remove("hidden");
      node.classList.toggle("ok", !!isOk);
      node.classList.toggle("err", !isOk);
      node.textContent = t;

      // Consistent toast: always for errors; only for final "ok" (avoid "Loading..." spam)
      const msg = t.trim();
      if(!msg) return;
      if(!isOk){
        toast("err", msg);
        return;
      }
      if(/\.\.\.$/.test(msg)) return;
      if(/^loading\b/i.test(msg)) return;
      if(/^logging in\b/i.test(msg)) return;
      if(/\b(syncing|queued)\b/i.test(msg)) return;
      toast("ok", msg);
    }
    function clearMsg(node){
      if(!node) return;
      node.classList.add("hidden");
      node.textContent = "";
      node.classList.remove("ok","err");
    }
    function money(n){
      const v = Number(n || 0);
      return (Math.round(v*100)/100).toString();
    }
    function escapeHtml(s){
      return String(s).replace(/[&<>"']/g, m => ({
        "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"
      }[m]));
    }

    function escapeAttr(s){
      return String(s||"")
        .replace(/&/g,"&amp;")
        .replace(/</g,"&lt;")
        .replace(/>/g,"&gt;")
        .replace(/\"/g,"&quot;")
        .replace(/'/g,"&#39;");
    }


    // Alias used by renderers
    const esc = escapeHtml;

    // Short date formatter for tables (e.g., Treasures Outbox)
    // Accepts ISO string, epoch ms, or any value Date() can parse.
    function fmtShortDate_(v){
      try{
        if(v == null) return "";
        const s = String(v).trim();
        if(!s) return "";
        // Support epoch milliseconds if passed as a number-like string
        const num = Number(s);
        const d = isFinite(num) && /^(\d{10,13})$/.test(s) ? new Date(num) : new Date(s);
        if(!isFinite(d)) return "";
        return d.toLocaleDateString("en-US", { year:"numeric", month:"short", day:"numeric" });
      }catch(_e){ return ""; }
    }

    function displayAcctName(name){
      return (String(name) === "Wallet") ? "On Hand" : String(name);
    }


    function normAcctName(name){
      return String(name||"")
        .trim()
        .toLowerCase()
        .replace(/[_\-]+/g, " ")
        .replace(/\s+/g, " ");
    }


    // Identify the special "On Hand" account by account kind or its actual name.
    // Never classify by the id prefix: some legacy Cosmic Pouches were incorrectly
    // created with w_* ids, and treating those as On Hand hides them from selectors.
    const isOnHand = (a) => {
      const kind = String((a && a.kind) || "").toUpperCase().trim();
      if(kind === "POUCH" || kind === "ACCOUNT") return false;
      if(kind === "ESCROW") return false;
      if(kind === "WALLET") return true;

      const key = String((a && a.name) || "")
        .toLowerCase()
        .replace(/[_\-\s]+/g,"")
        .trim();
      return (key === "wallet" || key === "onhand" || key === "onhandwallet");
    };

// ====== Nav (grouped dropdowns + keep inside container) ======
    function closeAllDrops(options){
      const opts = options || {};
      root.querySelectorAll(".drop").forEach(d => {
        d.classList.add("hidden");
        d.setAttribute("aria-hidden", "true");
        d.style.left = "";
        d.style.right = "";
      });
      root.querySelectorAll(".navBtn").forEach(b => {
        b.classList.remove("active");
        b.setAttribute("aria-expanded", "false");
      });

      [root, el("tywMobilePanel")].forEach(sc => {
        if(!sc) return;
        sc.querySelectorAll(".slbSubToggle[data-subtoggle]").forEach(btn => {
          const tid = btn.getAttribute("data-subtoggle");
          const body = el(tid);
          if(body){
            body.classList.add("hidden");
            body.setAttribute("aria-hidden", "true");
          }
          const base = btn.dataset.baseLabel || btn.getAttribute("data-label") || btn.textContent.replace(/[▸▾]\s*$/, "").trim();
          btn.dataset.baseLabel = base || "Inbox";
          btn.textContent = btn.dataset.baseLabel + " ▸";
          btn.classList.remove("open");
          btn.setAttribute("aria-expanded", "false");
        });
      });

      if(opts.keepMobile !== true && typeof closeMobileDrawer_ === "function"){
        closeMobileDrawer_({ restoreFocus: opts.restoreFocus !== false });
      }
    }

    function positionDrop(dropEl){
      if(!dropEl) return;
      // reset first
      dropEl.style.left = "0";
      dropEl.style.right = "auto";

      // after layout, push inside container edges
      requestAnimationFrame(() => {
        try{
          const cont = root.getBoundingClientRect();
          const r = dropEl.getBoundingClientRect();
          const pad = 8;

          // if overflow right -> dock to right edge
          if(r.right > cont.right - pad){
            dropEl.style.left = "auto";
            dropEl.style.right = "0";
          }else if(r.left < cont.left + pad){
            dropEl.style.left = "0";
            dropEl.style.right = "auto";
          }
        }catch(_e){}
      });
    }

    function toggleDrop(id, focusFirst){
      const d = el(id);
      if(!d) return;
      const btn = root.querySelector(`.navBtn[data-drop="${CSS.escape(id)}"]`);
      const isOpen = !d.classList.contains("hidden");
      closeAllDrops({ keepMobile:true, restoreFocus:false });
      if(!isOpen){
        d.classList.remove("hidden");
        d.setAttribute("aria-hidden", "false");
        if(btn){
          btn.classList.add("active");
          btn.setAttribute("aria-expanded", "true");
        }
        positionDrop(d);
        if(focusFirst){
          requestAnimationFrame(() => {
            try{
              const first = d.querySelector('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
              if(first) first.focus();
            }catch(_e){}
          });
        }
      }
    }

    root.querySelectorAll(".navBtn[data-drop]").forEach(btn => {
      const id = btn.getAttribute("data-drop");
      btn.setAttribute("aria-controls", id);
      btn.setAttribute("aria-haspopup", "true");
      btn.setAttribute("aria-expanded", "false");
      const drop = el(id);
      if(drop) drop.setAttribute("aria-hidden", drop.classList.contains("hidden") ? "true" : "false");

      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        toggleDrop(id, false);
      });
      btn.addEventListener("keydown", (e) => {
        if(e.key === "ArrowDown"){
          e.preventDefault();
          e.stopPropagation();
          toggleDrop(id, true);
        }else if(e.key === "Escape"){
          e.preventDefault();
          closeAllDrops({ keepMobile:true, restoreFocus:false });
          btn.focus();
        }
      });
    });

// mobile button (drawer)
const mobileBtn = el("tywMobileMenuBtn");
const mobilePanel = el("tywMobilePanel");
const mobileMask = el("tywMobileMask");
const mobileCloseBtn = el("tywMobileCloseBtn");

// IMPORTANT: Some SLB header/wrapper containers use CSS transforms.
// A transformed ancestor breaks `position:fixed` (it becomes relative to that ancestor),
// which makes the drawer appear "trapped" inside the top bar.
// We move the mask + panel to be direct children of <body> so the drawer always overlays
// the whole screen on mobile.
function ensureMobileDrawerInBody_(){
  try{
    if(!document.body) return;
    if(mobileMask && mobileMask.parentNode !== document.body) document.body.appendChild(mobileMask);
    if(mobilePanel && mobilePanel.parentNode !== document.body) document.body.appendChild(mobilePanel);
  }catch(_e){}
}

let mobileTrapRelease_ = null;
let mobilePrevOverflow_ = "";

function openMobileDrawer_(){
  try{
    ensureMobileDrawerInBody_();
    try{ if(typeof wireMenuClicks_ === "function") wireMenuClicks_(); }catch(_e){}
    try{ if(typeof wireSubToggles === "function") wireSubToggles(); }catch(_e){}
    closeAllDrops({ keepMobile:true, restoreFocus:false });
    if(mobileMask){
      mobileMask.classList.remove("hidden");
      mobileMask.setAttribute("aria-hidden", "false");
    }
    if(mobilePanel){
      mobilePanel.classList.remove("hidden");
      mobilePanel.setAttribute("aria-hidden", "false");
    }
    if(document.body){
      document.body.classList.add("slb-mobile-open");
      mobilePrevOverflow_ = document.body.style.overflow || "";
      document.body.style.overflow = "hidden";
    }
    if(mobileBtn) mobileBtn.setAttribute("aria-expanded", "true");
    if(typeof mobileTrapRelease_ === "function") mobileTrapRelease_();
    mobileTrapRelease_ = null;
    if(window.SLB && SLB.a11y && typeof SLB.a11y.trapDialog === "function" && mobilePanel){
      mobileTrapRelease_ = SLB.a11y.trapDialog(mobilePanel, {
        initialFocus: mobileCloseBtn || mobilePanel,
        returnFocus: mobileBtn,
        onEscape: () => closeMobileDrawer_({ restoreFocus:true })
      });
    }else if(mobileCloseBtn){
      requestAnimationFrame(() => mobileCloseBtn.focus());
    }
    try{ window.SLB && SLB.a11y && SLB.a11y.announce("Navigation opened"); }catch(_e){}
  }catch(_e){}
}

function closeMobileDrawer_(options){
  const opts = options || {};
  const wasOpen = !!(document.body && document.body.classList.contains("slb-mobile-open"));
  try{
    if(typeof mobileTrapRelease_ === "function") mobileTrapRelease_();
    mobileTrapRelease_ = null;
    if(mobilePanel){
      mobilePanel.classList.add("hidden");
      mobilePanel.setAttribute("aria-hidden", "true");
    }
    if(mobileMask){
      mobileMask.classList.add("hidden");
      mobileMask.setAttribute("aria-hidden", "true");
    }
    if(document.body){
      document.body.classList.remove("slb-mobile-open");
      document.body.style.overflow = mobilePrevOverflow_;
    }
    if(mobileBtn) mobileBtn.setAttribute("aria-expanded", "false");
    if(wasOpen && opts.restoreFocus !== false && mobileBtn){
      requestAnimationFrame(() => mobileBtn.focus());
    }
  }catch(_e){}
}

ensureMobileDrawerInBody_();
if(mobilePanel) mobilePanel.setAttribute("aria-hidden", mobilePanel.classList.contains("hidden") ? "true" : "false");
if(mobileMask) mobileMask.setAttribute("aria-hidden", mobileMask.classList.contains("hidden") ? "true" : "false");

if(mobileBtn && mobilePanel){
  mobileBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    const open = !!(document.body && document.body.classList.contains("slb-mobile-open"));
    if(open) closeMobileDrawer_({ restoreFocus:true });
    else openMobileDrawer_();
  });
}
if(mobileMask){
  mobileMask.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeAllDrops({ restoreFocus:true });
  });
}
if(mobileCloseBtn){
  mobileCloseBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeAllDrops({ restoreFocus:true });
  });
}

    // nav mode: toggle body.slb-mobile so only ONE menu shows at a time
// nav mode: toggle body.slb-mobile (phone) / body.slb-force-desktop (Shopify preview iframe)
function updateNavMode(){
  try{
    if(!document.body) return false;

    // Keep drawer elements at body level (prevents transform trapping).
    ensureMobileDrawerInBody_();

    // Detect Shopify admin/theme preview iframe (force desktop nav so menus don't get stuck)
    let inIframe = false;
    try{ inIframe = (window.self !== window.top); }catch(_e){ inIframe = true; }
    const ref = String(document.referrer || "").toLowerCase();
    const host = String(location.hostname || "").toLowerCase();
    const forceDesktop = !!(inIframe && (ref.includes("shopify") || host.includes("myshopify") || host.includes("shopify")));

    document.body.classList.toggle("slb-force-desktop", forceDesktop);

    if(forceDesktop){
      document.body.classList.remove("slb-mobile");
      closeMobileDrawer_({ restoreFocus:false });
      return true;
    }

    // Normal site: switch to mobile nav based on viewport
    document.body.classList.remove("slb-force-desktop");
    const isMobile = window.matchMedia
      ? window.matchMedia("(max-width:760px)").matches
      : (window.innerWidth <= 760);

    document.body.classList.toggle("slb-mobile", !!isMobile);

    // Keep drawer elements outside transformed header wrappers (full-viewport overlay)
    if(isMobile){
      ensureMobileDrawerInBody_();
    }else{
      closeMobileDrawer_({ restoreFocus:false });
    }

    return true;
  }catch(_e){ return false; }
}



    // Body can be null if this runs too early (rare in Shopify preview). Ensure we apply after DOM is ready.
    if(!updateNavMode()){
      document.addEventListener("DOMContentLoaded", updateNavMode, { once:true });
      // extra safety: one more microtask tick
      setTimeout(updateNavMode, 0);
    }
    window.addEventListener("resize", updateNavMode);

// click outside closes
    document.addEventListener("click", (e) => {
      if(!root.contains(e.target)) return;
      const inside = e.target.closest(".drop, .navBtn, #tywMobilePanel, #tywMobileMenuBtn");
      if(!inside) closeAllDrops();
    }, true);

    // Escape closes
    document.addEventListener("keydown", (e) => {
      if(e.key === "Escape") closeAllDrops();
    });

    // Reposition open dropdown on resize
    window.addEventListener("resize", () => {
      const openDrop = root.querySelector(".drop:not(.hidden)");
      if(openDrop) positionDrop(openDrop);
    });

    // nested folders inside drops (eg: Admin > Inbox)
    function wireSubToggles(){
      const scopes = [];
      if(root) scopes.push(root);
      const mp = (typeof mobilePanel !== "undefined" && mobilePanel) ? mobilePanel : el("tywMobilePanel");
      if(mp) scopes.push(mp);

      scopes.forEach(sc => {
        sc.querySelectorAll(".slbSubToggle[data-subtoggle]").forEach(btn => {
          if(btn.dataset.tywSubWired) return;
          btn.dataset.tywSubWired = "1";

          const tid = btn.getAttribute("data-subtoggle");
          const body = el(tid);
          if(!body) return;
          btn.setAttribute("aria-controls", tid);

          const base = (btn.getAttribute("data-label") || btn.textContent.replace(/[▸▾]\s*$/, "").trim() || "Inbox");
          btn.dataset.baseLabel = base;

          function setState(open){
            body.classList.toggle("hidden", !open);
            body.setAttribute("aria-hidden", open ? "false" : "true");
            btn.textContent = base + (open ? " ▾" : " ▸");
            btn.classList.toggle("open", !!open);
            btn.setAttribute("aria-expanded", open ? "true" : "false");
          }

          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            const open = body.classList.contains("hidden");
            setState(open);
          });

          // collapsed by default
          setState(false);
        });
      });
    }
    wireSubToggles();

    // ====== Panels ======
    function markActiveMenu(tab){
      const scopes = [root, mobilePanel].filter(Boolean);
      scopes.forEach(sc => {
        sc.querySelectorAll(".menuItem[data-tab]").forEach(b => {
          const active = b.getAttribute("data-tab") === tab;
          b.classList.toggle("active", active);
          if(active) b.setAttribute("aria-current", "page");
          else b.removeAttribute("aria-current");
        });
      });
    }


    // ====== Lazy-load Phase 3 panels (Offer / Market / My Orders / My Sales) ======
    // Safe UX: do not fetch Phase 3 data until the user opens that tab.
    function lazyLoadP3OnOpen_(tab){
      try{
        if(!["offer","market","orders","sales"].includes(tab)) return;
        if(!S || !S.token) return;

        const p3 = S.p3 || (S.p3 = {});
        p3.loaded  = p3.loaded  || { offer:false, market:false, orders:false, sales:false };
        p3.loading = p3.loading || { offer:false, market:false, orders:false, sales:false };

        if(p3.loaded[tab] || p3.loading[tab]) return;

        p3.loading[tab] = true;

        const btnId = ({ offer:"tywOfferReloadBtn", market:"tywMarketReloadBtn", orders:"tywOrdersReloadBtn", sales:"tywSalesReloadBtn" })[tab];
        const btn = el(btnId);
        const isIconOnly = !!(btn && btn.dataset && (btn.dataset.icononly==="1" || btn.dataset.iconOnly==="1" || btn.dataset.slbIconOnly==="1"));
        const unlock = btn ? lockBtn(btn, isIconOnly ? null : "Loading…") : (()=>{});

        const st = el("tywStatus");
        const prev = st ? String(st.textContent||"").trim() : "";
        const canSetStatus = !!st && (!prev || prev === "Ready");
        if(canSetStatus) setText("tywStatus", "Loading…");

        (async () => {
          try{
            if(tab === "offer") await loadMyOffers();
            if(tab === "market") await loadMarket();
            if(tab === "orders") await loadMyOrders();
            if(tab === "sales") await loadMySales();
          }catch(_e){
            // loaders already show UI messages
          }finally{
            try{ p3.loading[tab] = false; }catch(_e){}
            try{ if(p3.ok) p3.loaded[tab] = true; }catch(_e){}
            unlock();

            if(canSetStatus){
              setTimeout(() => {
                try{
                  const st2 = el("tywStatus");
                  if(st2 && String(st2.textContent||"").trim() === "Loading…") setText("tywStatus", "Ready");
                }catch(_e){}
              }, 700);
            }
          }
        })();
      }catch(_e){}
    }

    function slbCanUseAdminPanels_(){
      try{
        if(S && (S.isAdminOrMod || S.isAdmin || S.isModerator)) return true;
      }catch(_e){}
      try{
        if(sessionStorage.getItem("tyw_isAdmin") === "1" || sessionStorage.getItem("tyw_isModerator") === "1") return true;
      }catch(_e2){}
      try{
        const raw = localStorage.getItem("ty_auth_v1") || "";
        if(raw){
          const a = JSON.parse(raw);
          if(a && (a.isAdmin || a.isModerator)) return true;
        }
      }catch(_e3){}
      return false;
    }

    async function activateEmbeddedTab_(tab){
      tab = String(tab || "").trim();
      if(!tab) return false;
      try{
        if(tab === "overview"){
          try{ await boardRefresh_(true); }catch(_e0){}
        }
        if(tab === "cult"){
          try{ await loadCultivations(false); }catch(_e1){}
        }
        if(tab === "treasures"){
          try{ treBindOnce_(); }catch(_e2){}
          try{ await treLoad_(false); }catch(_e3){}
        }
        if(tab === "user"){
          try{
            if(window.SLB_loadNotifyPrefs) await window.SLB_loadNotifyPrefs();
            else if(typeof loadNotifyPrefs_ === "function") await loadNotifyPrefs_();
          }catch(_e4){}
        }
        try{ lazyLoadP3OnOpen_(tab); }catch(_e5){}
        try{
          if(window.SLB && window.SLB.features && typeof window.SLB.features.onOpen === "function"){
            window.SLB.features.onOpen(tab, { state:S, root:root, embedded:true, container:"myCabin" });
          }
        }catch(_e6){}
        if(tab === "chat"){
          try{
            if(window.SLB_CHAT && typeof window.SLB_CHAT.onOpen === "function") await window.SLB_CHAT.onOpen();
            else if(window.SLB_CHAT && typeof window.SLB_CHAT.reload === "function") await window.SLB_CHAT.reload();
          }catch(_e7){}
        }
        if(tab === "m3Offering"){
          try{
            if(window.SLB_M3 && typeof window.SLB_M3.open === "function") window.SLB_M3.open();
            else if(window.SLB_M3 && typeof window.SLB_M3.refresh === "function") window.SLB_M3.refresh();
          }catch(_e8){}
        }
        return true;
      }catch(_e){ return false; }
    }

    function setPanel(tab){
      var _embeddedTab = "";
      var _embeddedParent = "";
      try{
        var _myCabinTabs = {overview:1,diary:1,diaryWrite:1,diaryRead:1,m3Received:1,m3Offering:1,cult:1,treasures:1,library:1,chat:1,cabinEmail:1,user:1,export:1,backup:1,help:1};
        var _goldenTabs = {accounts:1,deposit:1,withdraw:1,gift:1,txns:1,coins:1,missions:1,market:1,orders:1,offer:1,sales:1};
        var _bagwaTabs = {gdgToken:1,letters:1,offeringHall:1,anniv:1,cCalendar:1,temple:1,cmr:1,sdr:1,swr:1,dcr:1,ddr:1,stars9Div:1,fanTaiSui:1};
        var _rawEmbedded = String(tab||"").trim();
        if(_myCabinTabs[_rawEmbedded]){_embeddedParent="myCabin";_embeddedTab=(_rawEmbedded==="diary"?"diaryWrite":_rawEmbedded==="backup"?"export":_rawEmbedded);}
        else if(_goldenTabs[_rawEmbedded]){_embeddedParent="goldenCenter";_embeddedTab=_rawEmbedded;}
        else if(_bagwaTabs[_rawEmbedded]){_embeddedParent="bagwaHall";_embeddedTab=_rawEmbedded;}
        if(_embeddedParent)tab=_embeddedParent;
      }catch(_eEmbedded){}
      try{ if(tab !== "goldenCenter" && window.SLB_GOLDEN_CENTER && typeof window.SLB_GOLDEN_CENTER.restoreAll === "function") window.SLB_GOLDEN_CENTER.restoreAll(); }catch(_eGolden){}
      try{ if(tab !== "myCabin" && window.SLB_MY_CABIN && typeof window.SLB_MY_CABIN.restoreAll === "function") window.SLB_MY_CABIN.restoreAll(); }catch(_eCabin){}
      try{ if(tab !== "bagwaHall" && window.SLB_BAGWA_HALL && typeof window.SLB_BAGWA_HALL.restoreAll === "function") window.SLB_BAGWA_HALL.restoreAll(); }catch(_eBagwa){}
      closeAllDrops();
      // Library UX: when navigating away from Library, forget the last opened post so the menu always returns to the list.
      // (Deep links still work because postId in the hash will re-open it on load.)
      try{
        var hh = String(location.hash||"");
        var _libraryWanted = (tab === "library") || (tab === "myCabin" && (hh.indexOf("cabin=library") >= 0 || hh.indexOf("tab=library") >= 0 || hh === "#library"));
        if(!_libraryWanted){
          window.__SLB_LIB_SELECTED_POSTID = "";
        }else if(hh && hh.indexOf("postId=") < 0){
          window.__SLB_LIB_SELECTED_POSTID = "";
        }
      }catch(_e){}
try{
        const _adminPanelWanted = (tab === "admin" || tab === "diaryDesk" || tab === "diaryInbox" || tab === "cmrInbox" || tab === "sdrInbox" || tab === "swrInbox" || tab === "dcrInbox" || tab === "ddrInbox" || tab === "treasury" || tab === "ops" || tab === "templeAdmin" || tab === "lettersTools" || tab === "pageBuilder" || tab === "altarStudio" || tab === "offeringHallV2Test" || tab === "myAltarTest" || tab === "aofTest" || tab === "thunderCourtTest" || tab === "shipping" || tab === "missionTool");
        // FastBoot can open the shell before the fresh dashboard role has finished hydrating.
        // Trust the saved admin/mod flag during that short window so admin inboxes do not bounce back to Overview.
        if(_adminPanelWanted && !slbCanUseAdminPanels_()) tab = "myCabin";
      }catch(_e){}
      (root||document).querySelectorAll("[data-panel]").forEach(p => {
        const active = p.getAttribute("data-panel") === tab;
        p.classList.toggle("hidden", !active);
        p.setAttribute("aria-hidden", active ? "false" : "true");
        if(active){
          p.setAttribute("role", p.getAttribute("role") || "region");
          p.setAttribute("tabindex", p.getAttribute("tabindex") || "-1");
        }
      });
	      const panelLabel = ({
        overview:"Overview", wallet:"On Hand",
        diary:"Diary",
        fanTaiSui:"Fan Tai Sui",
        thunderCourt:"Thunder Court", altarFaith:"Altar of Faith", bagwaPortal:"BAGWA PORTAL", lunarCal:"Lunar Calendar", cCalendar:"C-Calendar", anniv:"Anniversaries", learnGeneral:"Learn", chat:"Chat", magic7Tool:"7 STARS TOOLS",
        stars9Div:"9 Stars Div", stars9Review:"9 Stars Review", saamlDict:"Saamlawnese", saamlTools:"Saamlawnese Tools",
        user:"User",
        deposit:"Deposit", withdraw:"Withdrawal", gift:"Gift", accounts:"Cosmic Pouch",
        offer:"Offer", market:"Market", missions:"Missions", missionTool:"Mission Tool", m3Offering:"Celestial Kitchen Brew", m3Tool:"3M Tools", m3Tools:"3M Tools",
        orders:"My Orders", sales:"My Sales",
        temple:"Temple",
	        txns:"Transactions", goldenCenter:"Golden Center", myCabin:"My Cabin", bagwaHall:"Bagwa Hall", gameCenter:"Tao-Game Center", taoMan:"TaoMan", gdgToken:"GDG Token", cocWar:"Clash Duty Hall", cult:"Cultivations", treasures:"Treasures", library:"Library", cmr:"CMR", sdr:"SDR", swr:"SWR", dcr:"DCR", ddr:"DDR",
	        lettersInbox:"Letters Inbox", lettersTools:"LETTER TOOLS", shipping:"Shipping",
	        pageBuilder:"Visual Builder",
        altarStudio:"Universal Altar Engine",
        offeringHallV2Test:"Offering Hall Free Style Test",
        myAltarTest:"My Altar Test",
        aofTest:"AOF Test",
        thunderCourtTest:"Thunder Court Test",
	        cmrInbox:"CMR INBOX",
	        sdrInbox:"SDR INBOX",swrInbox:"SWR INBOX",dcrInbox:"DCR INBOX",ddrInbox:"DDR INBOX",export:"Backup",
	        admin:"Admin", treasury:"Treasury", diaryDesk:"Morning Diary Desk", diaryInbox:"Diary Inbox", ops:"Ops Panel", templeAdmin:"Temple Admin"
      }[tab] || tab);
      setText("tywNowTab", panelLabel);
      try{ window.SLB && SLB.a11y && SLB.a11y.announce(panelLabel + " opened"); }catch(_eA11y){}
      if(tab === "altarFaith") setTimeout(function(){try{var host=document.querySelector('slb-aof-test-v2[data-aof-live="1"]');if(host&&typeof host.boot==="function")host.boot();}catch(_eAof){}},0);
      if(tab === "gift") ensureGiftUsersLoaded().catch(()=>{});
      if(tab === "cult"){
        // Central Cultivation entry point. This covers menu clicks, mobile navigation,
        // restored #cult URLs, and any other code path that calls setPanel("cult").
        setTimeout(()=>{
          try{
            if(typeof loadCultivations === "function") loadCultivations(false).catch(()=>{});
          }catch(_e){}
        }, 0);
      }
      if(tab === "diaryDesk" || tab === "diaryInbox" || tab === "lettersInbox" || tab === "cmrInbox" ||
         tab === "sdrInbox" || tab === "swrInbox" || tab === "dcrInbox" || tab === "ddrInbox"){
        // Admin inboxes are long-lived SPA panels. Re-enter them on every navigation so
        // fresh disciple submissions appear without requiring F5 or a browser restart.
        setTimeout(()=>{
          try{
            const inboxApis = {
              diaryDesk: window.SLB_DiaryDesk,
              diaryInbox: window.SLB_DiaryInbox,
              lettersInbox: window.SLB_LettersInbox,
              cmrInbox: window.SLB_CmrInbox,
              sdrInbox: window.SLB_SdrInbox,
              swrInbox: window.SLB_SwrInbox,
              dcrInbox: window.SLB_DcrInbox,
              ddrInbox: window.SLB_DdrInbox
            };
            const api = inboxApis[tab];
            if(api && typeof api.enter === "function"){
              api.enter({ reason:"panel-open" }).catch(()=>{});
            }
          }catch(_e){}
        }, 0);
      }
      if(tab === "overview"){
        try{ boardRefresh_(false); }catch(_e){}
      }
      if(tab === "treasures"){
        try{ treBindOnce_(); }catch(_e){}
        try{ treLoad_(false); }catch(_e){}
      }
      markActiveMenu(tab);

      // USER panel: always refresh notify prefs from backend so email/opt-in never shows stale OFF/blank.
      if(tab === "user"){
        try{
          if(window.SLB_loadNotifyPrefs) window.SLB_loadNotifyPrefs();
          else if(typeof loadNotifyPrefs_ === "function") loadNotifyPrefs_();
        }catch(_e){}
      }

      lazyLoadP3OnOpen_(tab);
      // Phase 3 modular hook: tab-level onOpen (small modules under /slb_src/features)
      try{
        if(window.SLB && window.SLB.features && typeof window.SLB.features.onOpen === "function"){
          window.SLB.features.onOpen(tab, { state:S, root:root });
        }
      }catch(_e){}
      if(_embeddedParent && _embeddedTab){
        setTimeout(function(){
          try{
            var _api = _embeddedParent==="myCabin"?window.SLB_MY_CABIN:_embeddedParent==="goldenCenter"?window.SLB_GOLDEN_CENTER:window.SLB_BAGWA_HALL;
            if(_api&&typeof _api.openTab==="function")_api.openTab(_embeddedTab,{});
          }catch(_eEmbeddedOpen){}
        },0);
      }

      if(tab === "admin" && !slbCanUseAdminPanels_()){
        setPanel("myCabin");
      } else if(tab === "admin"){
        // For Moderator accounts, don't let the Help panel (corner widget) disable admin navigation.
        // Help is not a full-screen overlay, so we keep admin usable.
        try{
          if(S.isModerator && !S.isAdmin){
            var hp = el("slbHelpPanel");
            if(hp) hp.classList.add("hidden");
            try{ document.body.classList.remove("slbHelpOpen"); }catch(_e2){}
          }
        }catch(_e){}
        try{ if(window.SLB_applyRoleUI) window.SLB_applyRoleUI(); }catch(_e3){}
        try{ treAdmBindOnce_(); }catch(_e4){}
        try{ treAdmViewBindOnce_(); }catch(_e5){}
      }

      if(tab === "treasury" && !slbCanUseAdminPanels_()){
        setPanel("myCabin");
      } else if(tab === "treasury"){
        try{ treAdmBindOnce_(); }catch(_eT1){}
        try{ treAdmViewBindOnce_(); }catch(_eT2){}
      }

      // ====== Deep Links (hash routing + Share button) ======
      // We keep the URL stable (Shopify page URL), and use a hash like:
      //   #wallet
      //   #admin/disciples?id=DISC123
      // so you can share a direct link to a specific page.
      try{
        if(!window.__SLB_ROUTE_INIT__){
          window.__SLB_ROUTE_INIT__ = true;
          (function(){
            // Auto-discover valid tabs at runtime so new pages don't require a hard-coded list.
// Sources (in order):
//  1) [data-slb-tab] (new convention)
//  2) [data-panel] (existing SLB panels)
//  3) [data-tab] (menu items)
//  4) ID inference (slbXxxPanel / tywXxxPanel / slbPanelXxx / panel_xxx)
const TAB_ALIAS = { main:"myCabin", home:"myCabin", overview:"myCabin", stars7Portal:"thunderCourt" };
function toCamel_(s){
  const raw = String(s||"").trim();
  if(!raw) return "";
  if(raw.indexOf("_")<0 && raw.indexOf("-")<0) return raw;
  const parts = raw.split(/[_-]+/).filter(Boolean);
  if(!parts.length) return raw;
  return parts[0] + parts.slice(1).map(p => p ? (p.charAt(0).toUpperCase() + p.slice(1)) : "").join("");
}
function normTab_(k){
  k = String(k||"").trim().replace(/^#/,"");
  try{ k = decodeURIComponent(k); }catch(_e){}
  k = String(k||"").trim();
  if(!k) return "";
  k = k.split("/")[0]; // only top-level tab key
  if(TAB_ALIAS[k]) k = TAB_ALIAS[k];
  return k;
}
function discoverTabs_(){
  const tabs = new Set();
  const add = (v) => {
    const key = normTab_(v);
    if(key) tabs.add(key);
  };

  try{ document.querySelectorAll('[data-slb-tab]').forEach(el => add(el.getAttribute('data-slb-tab'))); }catch(_e){}
  try{ (root||document).querySelectorAll('[data-panel]').forEach(el => add(el.getAttribute('data-panel'))); }catch(_e){}
  try{ document.querySelectorAll('[data-tab]').forEach(el => add(el.getAttribute('data-tab'))); }catch(_e){}

  // Optional: infer from panel IDs (safe if naming is consistent)
  try{
    (root||document).querySelectorAll('[id$="Panel"], [id^="slbPanel"], [id^="panel_"], [id^="panel-"]').forEach(el => {
      const id = String(el.id||"").trim();
      if(!id) return;

      let m = id.match(/^(?:slb|tyw)([A-Za-z0-9]+)Panel$/);
      if(m && m[1]){
        const key = m[1].charAt(0).toLowerCase() + m[1].slice(1);
        add(key);
        return;
      }
      m = id.match(/^slbPanel([A-Za-z0-9]+)$/);
      if(m && m[1]){
        const key = m[1].charAt(0).toLowerCase() + m[1].slice(1);
        add(key);
        return;
      }
      m = id.match(/^panel[_-](.+)$/i);
      if(m && m[1]){
        add(toCamel_(m[1]));
        return;
      }
    });
  }catch(_e){}

  if(!tabs.size) tabs.add("myCabin");
  return tabs;
}

            const COMBINED_ROUTES = {
              myCabin:{ key:"cabin", defaultTab:"overview", api:"SLB_MY_CABIN", tabs:new Set(["overview","m3Received","diaryRead","cult","treasures","library","diaryWrite","m3Offering","chat","cabinEmail","user","export","help"]) },
              goldenCenter:{ key:"golden", defaultTab:"accounts", api:"SLB_GOLDEN_CENTER", tabs:new Set(["accounts","deposit","withdraw","gift","txns","coins","missions","market","orders","offer","sales"]) },
              bagwaHall:{ key:"bagwa", defaultTab:"gdgToken", api:"SLB_BAGWA_HALL", tabs:new Set(["gdgToken","letters","offeringHall","anniv","cCalendar","temple","cmr","sdr","swr","dcr","ddr","stars9Div","fanTaiSui"]) }
            };
            const LEGACY_COMBINED = Object.create(null);
            Object.keys(COMBINED_ROUTES).forEach(function(parent){
              COMBINED_ROUTES[parent].tabs.forEach(function(sub){LEGACY_COMBINED[sub]={parent:parent,sub:sub};});
            });
            LEGACY_COMBINED.diary={parent:"myCabin",sub:"diaryWrite"};
            LEGACY_COMBINED.backup={parent:"myCabin",sub:"export"};

            function paramsToObject_(sp){
              const out=Object.create(null);
              try{sp.forEach(function(v,k){out[String(k||"").replace(/^amp;/,"")]=String(v||"");});}catch(_e){}
              return out;
            }
            function makeParams_(raw){
              try{return new URLSearchParams(String(raw||"").replace(/&amp;/g,"&"));}catch(_e){return new URLSearchParams();}
            }
            function combinedHash_(parent,sub,values){
              const info=COMBINED_ROUTES[parent];
              if(!info)return "#"+encodeURIComponent(parent||"myCabin");
              sub=String(sub||info.defaultTab).trim();
              if(!info.tabs.has(sub))sub=info.defaultTab;
              const sp=new URLSearchParams();
              sp.set("tab",parent);sp.set(info.key,sub);
              const allowed={postId:1,noteId:1,room:1,buy:1,entryId:1,orderId:1,batchId:1};
              const obj=values||{};
              Object.keys(obj).forEach(function(k){
                const clean=String(k||"").replace(/^amp;/,"");
                if(!allowed[clean])return;
                const v=String(obj[k]==null?"":obj[k]).trim();if(v)sp.set(clean,v);
              });
              return "#"+sp.toString();
            }
            function parsedCanonicalHash_(parsed){
              if(parsed&&COMBINED_ROUTES[parsed.tab])return combinedHash_(parsed.tab,parsed.subtab,parsed.values||{});
              return "";
            }

            const ROUTE = {
              ready:false,
              applying:false,
              muting:false,
              _tabs:null,
              _tabsTs:0,
              _lastParsed:null,
              getTabs(force){
                try{
                  const now = Date.now();
                  if(force || !this._tabs || (now - (this._tabsTs||0)) > 1000){
                    this._tabs = discoverTabs_();
                    Object.keys(COMBINED_ROUTES).forEach(x=>this._tabs.add(x));
                    this._tabsTs = now;
                  }
                  return this._tabs || new Set(["myCabin"]);
                }catch(_e){ return this._tabs || new Set(["myCabin"]); }
              },
              hasTab(tab){
                const key = normTab_(tab);
                if(COMBINED_ROUTES[key])return true;
                const tabs = this.getTabs(false);
                try{ return tabs && tabs.has && tabs.has(key); }catch(_e){}
                return false;
              },
              parse(hash){
                const raw0=String(hash||"").replace(/^#/,"").replace(/&amp;/g,"&");
                if(!raw0)return null;
                let path="",qs="",queryStyle=false;
                if(raw0.indexOf("tab=")===0||raw0.indexOf("?tab=")===0){queryStyle=true;qs=raw0.replace(/^\?/,"");}
                else{const parts=raw0.split("?");path=String(parts.shift()||"").trim();qs=parts.join("?");}
                if(!queryStyle&&(path.indexOf("admin/")===0||path.indexOf("admin-")===0)){
                  const adm=path.indexOf("admin/")===0?String(path.split("/")[1]||"target"):String(path.slice(6)||"target");
                  const spAdmin=makeParams_(qs);return {tab:"admin",adm:adm||"target",id:spAdmin.get("id")||"",params:qs,values:paramsToObject_(spAdmin)};
                }
                const sp=makeParams_(qs);
                let rawTab=queryStyle?(sp.get("tab")||sp.get("amp;tab")||""):path.split("/")[0];
                rawTab=String(rawTab||"").trim().replace(/^#/,"");
                try{rawTab=decodeURIComponent(rawTab)}catch(_e){}
                if(!rawTab)return null;
                if(rawTab==="admin")return {tab:"admin",adm:sp.get("adm")||sp.get("admin")||"target",id:sp.get("id")||"",params:qs,values:paramsToObject_(sp)};
                let tab=normTab_(rawTab),subtab="",legacy=false,aliasRedirect=(rawTab==="stars7Portal");
                if(COMBINED_ROUTES[tab]){
                  const info=COMBINED_ROUTES[tab];subtab=String(sp.get(info.key)||info.defaultTab).trim();if(!info.tabs.has(subtab))subtab=info.defaultTab;
                }else if(LEGACY_COMBINED[rawTab]||LEGACY_COMBINED[tab]){
                  const hit=LEGACY_COMBINED[rawTab]||LEGACY_COMBINED[tab];tab=hit.parent;subtab=hit.sub;legacy=true;
                }
                const values=paramsToObject_(sp);
                return {tab:tab,subtab:subtab,legacy:legacy,aliasRedirect:aliasRedirect,params:qs,values:values,postId:values.postId||values.pid||"",id:values.id||""};
              },
              activeTopTab_(){
                let tab="myCabin";
                try{
                  const nodes=Array.from((root||document).querySelectorAll('[data-panel]:not(.hidden)'));
                  const active=nodes.find(function(node){
                    if(node.hasAttribute('data-cabin-hosted')||node.hasAttribute('data-cabin-preloaded')||node.hasAttribute('data-golden-hosted')||node.hasAttribute('data-bagwa-hosted')||node.hasAttribute('data-bagwa-preloaded'))return false;
                    if(node.closest&&node.closest('#slbCabinPreloadDock,#slbBagwaPreloadDock,[data-slb-preload-dock]'))return false;
                    return true;
                  });
                  if(active)tab=String(active.getAttribute('data-panel')||tab);
                }catch(_e){}
                if(LEGACY_COMBINED[tab])tab=LEGACY_COMBINED[tab].parent;
                if(!this.hasTab(tab))tab="myCabin";
                return tab;
              },
              getState(){
                const tab=this.activeTopTab_();
                let adm="target",id="",subtab="",values={};
                if(tab==="admin"){
                  try{const ap=document.querySelector('#tywAdminPanel .admPage.active');if(ap)adm=String(ap.getAttribute('data-adm')||adm)}catch(_e){}
                  if(adm==="disciples"){try{id=String((S&&S.adminDiscSelected&&S.adminDiscSelected.discipleId)||"")}catch(_e2){}}
                }else if(COMBINED_ROUTES[tab]){
                  const info=COMBINED_ROUTES[tab];subtab=info.defaultTab;
                  try{const api=window[info.api];if(api&&typeof api.getRouteState==="function"){const rs=api.getRouteState()||{};if(info.tabs.has(String(rs.tab||"")))subtab=String(rs.tab)}}catch(_e3){}
                  const cur=this.parse(location.hash);
                  if(cur&&cur.tab===tab&&cur.subtab===subtab)values=Object.assign({},cur.values||{});
                  if(tab==="myCabin"&&subtab==="library"){
                    try{const pid=String(window.__SLB_LIB_SELECTED_POSTID||"").trim();if(pid)values.postId=pid;else delete values.postId}catch(_e4){}
                  }
                }
                return {tab:tab,adm:adm,id:id,subtab:subtab,values:values};
              },
              buildHash(){
                const st=this.getState(),tab=st.tab||"myCabin";
                if(tab==="admin"){
                  let h="#admin/"+encodeURIComponent(String(st.adm||"target"));if(st.id)h+="?id="+encodeURIComponent(String(st.id));return h;
                }
                if(COMBINED_ROUTES[tab])return combinedHash_(tab,st.subtab,st.values);
                if(tab==="learnGeneral"){
                  let blog="",post="";try{blog=String(window.__SLB_LEARN_SELECTED_BLOG||"");post=String(window.__SLB_LEARN_SELECTED_POST||"")}catch(_e){}
                  if(post){let h="#tab=learnGeneral";if(blog)h+="&blog="+encodeURIComponent(blog);h+="&post="+encodeURIComponent(post);return h;}
                }
                return "#"+encodeURIComponent(tab);
              },
              buildSubHash(parent,sub,params){return combinedHash_(String(parent||""),String(sub||""),params||{})},
              sync(push){
                try{
                  if(!this.ready||this.applying)return;
                  const h=this.buildHash();if(!h||String(location.hash||"")===String(h))return;
                  this.muting=true;if(push)location.hash=h;else history.replaceState(null,"",h);
                  setTimeout(()=>{this.muting=false},0);
                }catch(_e){this.muting=false}
              },
              openCombined_(parsed){
                const info=COMBINED_ROUTES[parsed.tab];if(!info)return;
                const opts=Object.assign({},parsed.values||{});if(parsed.postId&&!opts.postId)opts.postId=parsed.postId;
                const attempt=(n)=>{
                  try{const api=window[info.api];if(api&&typeof api.openTab==="function"){api.openTab(parsed.subtab||info.defaultTab,opts);return}}
                  catch(_e){}
                  if(n>0)setTimeout(()=>attempt(n-1),120);
                };
                attempt(30);
              },
              async applyFromHash(){
                try{
                  if(this.muting||!S)return;
                  if(!S.token){
                    try{let tok="";try{tok=String(sessionStorage.getItem("tyw_token")||"")}catch(_e1){}if(!tok){try{const raw=localStorage.getItem("ty_auth_v1")||"";if(raw){const a=JSON.parse(raw);if(a&&a.token)tok=String(a.token||"")}}catch(_e2){}}if(tok){S.token=tok;try{sessionStorage.setItem("tyw_token",tok)}catch(_e3){}}}catch(_e0){}
                  }
                  if(!S.token){if(!this._hashRetry){this._hashRetry=true;setTimeout(()=>{try{this._hashRetry=false;this.applyFromHash()}catch(_e){}},350)}return}
                  this.applying=true;
                  const parsed=this.parse(location.hash);
                  if(!parsed){this.ready=true;this.sync(false);return}
                  this._lastParsed=parsed;
                  let tab=normTab_(parsed.tab||"myCabin")||"myCabin";if(!this.hasTab(tab))tab="myCabin";
                  if(tab!=="admin"){
                    if(tab==="myCabin"&&parsed.subtab==="library")try{window.__SLB_LIB_SELECTED_POSTID=String(parsed.postId||"").trim()}catch(_e){}
                    if(tab==="learnGeneral"){
                      try{const vals=parsed.values||{};window.__SLB_LEARN_SELECTED_BLOG=String(vals.blog||vals.b||"").trim();window.__SLB_LEARN_SELECTED_POST=String(vals.post||vals.a||vals.url||"").trim()}catch(_e2){}
                    }
                    setPanel(tab);
                    if(COMBINED_ROUTES[tab])this.openCombined_(parsed);
                    const canonical=parsedCanonicalHash_(parsed);if(canonical&&String(location.hash||"")!==canonical){try{history.replaceState(null,"",canonical)}catch(_e3){}}
                    else if(parsed.aliasRedirect&&tab==="thunderCourt"){try{history.replaceState(null,"","#thunderCourt")}catch(_eAlias){}}
                  }else{
                    setPanel("admin");const adm=String(parsed.adm||"target")||"target";
                    setTimeout(()=>{try{if(window.SLB_showAdmPage)window.SLB_showAdmPage(adm)}catch(_e){}},0);
                    if(adm==="disciples"&&parsed.id){const wantId=String(parsed.id||"");setTimeout(async()=>{try{if(typeof loadAdminDisciples==='function')await loadAdminDisciples(true)}catch(_e){}try{const data=S.adminDisciples||{in:[],out:[]},all=(data.in||[]).concat(data.out||[]),found=all.find(x=>String(x.discipleId||"")===wantId)||all.find(x=>String(x.callsign||"")===wantId)||null;if(found&&typeof discSelect_==='function')discSelect_(found)}catch(_e2){}},120)}
                  }
                  this.ready=true;
                }finally{setTimeout(()=>{try{this.applying=false}catch(_e){}},0)}
              },
              getLink(){const base=String(location.href||"").split("#")[0];return base+(this.buildHash()||String(location.hash||""))},
              async copy(text){
                const t=String(text||"").trim();if(!t)return false;
                try{if(navigator.clipboard&&navigator.clipboard.writeText){await navigator.clipboard.writeText(t);return true}}catch(_e){}
                try{const ta=document.createElement('textarea');ta.value=t;ta.setAttribute('readonly','');ta.style.position='fixed';ta.style.left='-9999px';ta.style.top='0';document.body.appendChild(ta);ta.select();const ok=document.execCommand('copy');document.body.removeChild(ta);return !!ok}catch(_e2){}
                return false;
              }
            };
            window.SLB_route = ROUTE;
            // Initial load: apply existing hash once (hashchange won't fire on page load).
            try{ setTimeout(()=>{ try{ ROUTE.applyFromHash(); }catch(_e){} }, 0); }catch(_e){}
            window.addEventListener('hashchange', ()=>{ try{ ROUTE.applyFromHash(); }catch(_e){} });

            
// Link icon (🔗 next to logout): copy current deep link (includes hash).
// Users rely on this to share specific entries (e.g., Library post).
onOnce('slbShareIcon','click', async ()=>{
  try{
    if(!window.SLB_route) return;
    // Ensure hash is up-to-date before copying.
    try{ window.SLB_route.sync && window.SLB_route.sync(false); }catch(_e){}
    const link = window.SLB_route.getLink();
    const ok = await window.SLB_route.copy(link);
    toast(ok ? 'ok' : 'err', ok ? 'Deep link copied.' : 'Copy failed.');
  }catch(e){
    toast('err', (e && e.message) ? e.message : String(e));
  }
});

// Deep link icon: copy current in-app route (with hash).
onOnce('slbDeepLinkIcon','click', async ()=>{
  try{
    if(!window.SLB_route) return;
    const link = window.SLB_route.getLink();
    const ok = await window.SLB_route.copy(link);
    toast(ok ? 'ok' : 'err', ok ? 'Deep link copied.' : 'Copy failed.');
  }catch(e){
    toast('err', (e && e.message) ? e.message : String(e));
  }
});


// Send-link icon (✉): Admin/Mod can send the current page deep link to selected people.
let _slbSendLinkModal = null;

function _slbRoot_(){
  return (document.getElementById("SaamLawBank") || document.getElementById("tyWealthCourtyard") || document.body);
}

function slbSendLinkEnsureModal_(){
  if(_slbSendLinkModal && _slbSendLinkModal.mask && _slbSendLinkModal.modal) return _slbSendLinkModal;

  const mask = document.createElement("div");
  mask.id = "slbSendLinkMask";
  mask.className = "slbModalMask";

  const modal = document.createElement("div");
  modal.id = "slbSendLinkModal";
  modal.className = "slbModal";
  modal.style.color = "var(--slb-text,#0f1517)";
  modal.innerHTML = `
    <h4>Send This Page</h4>
    <div class="note">Choose one or more people from the notification list. They will receive an email with a link to the page you are on.</div>

    <div class="row" style="gap:8px;align-items:center;flex-wrap:wrap;">
      <input class="inp" id="slbSendLinkSearch" placeholder="Search callsign..." style="flex:1;min-width:200px;" />
      <button class="btn soft" id="slbSendLinkAll" type="button">All</button>
      <button class="btn soft" id="slbSendLinkNone" type="button">None</button>
    </div>

    <div class="row" id="slbSendLinkList" style="max-height:320px;overflow:auto;border:1px solid var(--slb-border,#e2e6ea);border-radius:12px;padding:8px;color:var(--slb-text,#0f1517);"></div>

    <div class="note" id="slbSendLinkMsg" style="display:none;"></div>

    <div class="actions">
      <button class="btn orange" id="slbSendLinkSend" type="button">Send</button>
      <button class="btn soft" id="slbSendLinkCancel" type="button">Cancel</button>
    </div>
  `;

  _slbRoot_().appendChild(mask);
  _slbRoot_().appendChild(modal);

  const close = ()=>{
    mask.classList.remove("show");
    modal.classList.remove("show");
    try{ const msg = modal.querySelector("#slbSendLinkMsg"); if(msg){ msg.style.display="none"; msg.textContent=""; } }catch(_e){}
  };
  mask.addEventListener("click", close);
  const cancel = modal.querySelector("#slbSendLinkCancel");
  if(cancel) cancel.addEventListener("click", close);

  _slbSendLinkModal = { mask, modal, close };
  return _slbSendLinkModal;
}

function _slbSendLinkRenderList_(recips, filter){
  const W = slbSendLinkEnsureModal_();
  const list = W.modal.querySelector("#slbSendLinkList");
  if(!list) return;
  const q = String(filter||"").trim().toUpperCase();
  const arr = (recips||[]).slice().sort((a,b)=>String(a.callsign||"").localeCompare(String(b.callsign||"")));
  const showArr = q ? arr.filter(r=>String(r.callsign||"").toUpperCase().includes(q)) : arr;

  if(!showArr.length){
    list.innerHTML = `<div class="note">No matches.</div>`;
    return;
  }

  list.innerHTML = showArr.map(r=>{
    const cs = esc(String(r.callsign||""));
    const em = esc(String(r.email||""));
    return `
      <label style="display:flex;align-items:center;gap:8px;padding:6px 4px;border-radius:10px;cursor:pointer;color:var(--slb-text,#0f1517);">
        <input type="checkbox" class="slbSendLinkChk" data-email="${em}" data-callsign="${cs}" />
        <span style="font-weight:800;min-width:90px;">${cs}</span>
        <span style="color:var(--slb-muted,#6b7680);font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${em}</span>
      </label>
    `;
  }).join("");
}

async function slbSendLinkOpen_(){
  try{
    if(!(S.isAdmin || S.isModerator)){
      toast("err", "Admin/Mod only.");
      return;
    }

    const W = slbSendLinkEnsureModal_();
    W.mask.classList.add("show");
    W.modal.classList.add("show");

    // Load recipients (cached)
    if(!S.__notifyRecips){
      const out = await rpc("notifyRecipients", {});
      S.__notifyRecips = (out && out.recipients) ? out.recipients : [];
    }

    _slbSendLinkRenderList_(S.__notifyRecips, "");

    const search = W.modal.querySelector("#slbSendLinkSearch");
    if(search && !search.__slbBound){
      search.__slbBound = true;
      search.addEventListener("input", ()=>{ _slbSendLinkRenderList_(S.__notifyRecips, search.value); });
    }else{
      try{ if(search) search.value = ""; }catch(_e){}
    }

    const btnAll = W.modal.querySelector("#slbSendLinkAll");
    if(btnAll && !btnAll.__slbBound){
      btnAll.__slbBound = true;
      btnAll.addEventListener("click", ()=>{
        W.modal.querySelectorAll(".slbSendLinkChk").forEach(x=>{ try{x.checked=true;}catch(_e){} });
      });
    }

    const btnNone = W.modal.querySelector("#slbSendLinkNone");
    if(btnNone && !btnNone.__slbBound){
      btnNone.__slbBound = true;
      btnNone.addEventListener("click", ()=>{
        W.modal.querySelectorAll(".slbSendLinkChk").forEach(x=>{ try{x.checked=false;}catch(_e){} });
      });
    }

    const sendBtn = W.modal.querySelector("#slbSendLinkSend");
    if(sendBtn && !sendBtn.__slbBound){
      sendBtn.__slbBound = true;
      sendBtn.addEventListener("click", async ()=>{
        const msg = W.modal.querySelector("#slbSendLinkMsg");
        const checks = Array.from(W.modal.querySelectorAll(".slbSendLinkChk") || []);
        const emails = checks.filter(x=>x && x.checked).map(x=>String(x.getAttribute("data-email")||"").trim()).filter(Boolean);

        if(!emails.length){
          if(msg){ msg.textContent = "Please choose at least one person."; msg.style.display="block"; }
          return;
        }

        if(sendBtn) sendBtn.disabled = true;
        try{
          // Ensure the hash is current before building the link.
          try{ window.SLB_route && window.SLB_route.sync && window.SLB_route.sync(false); }catch(_e){}
          const url = (window.SLB_route && window.SLB_route.getLink) ? window.SLB_route.getLink() : String(location.href||"");
          const label = (document && document.title) ? String(document.title||"") : "SLB";

          const out = await rpc("notifySendLinkTo", { to: emails, url: url, label: label });
          if(msg){
            msg.textContent = "Sent: " + String((out && out.sent) || 0) + " (requested " + String((out && out.requested) || emails.length) + ")";
            msg.style.display="block";
          }
          toast("ok", "Sent.");
        }catch(e){
          if(msg){ msg.textContent = "Send failed: " + String(e && (e.message||e) || "Error"); msg.style.display="block"; }
          toast("err", (e && e.message) ? e.message : String(e));
        }finally{
          if(sendBtn) sendBtn.disabled = false;
        }
      });
    }

  }catch(e){
    toast("err", (e && e.message) ? e.message : String(e));
  }
}

onOnce("slbSendLinkToIcon", "click", ()=>{ try{ slbSendLinkOpen_(); }catch(_e){} });


// Chat icon: jump to Chat page instantly.
            onOnce('slbChatIcon','click', ()=>{
              try{
                if(!window.SLB_route) { location.hash = '#tab=myCabin&cabin=chat'; return; }
                location.hash = '#tab=myCabin&cabin=chat';
                try{ window.SLB_route.applyFromHash && window.SLB_route.applyFromHash(); }catch(_e){}
                try{ window.SLB_route.sync && window.SLB_route.sync(false); }catch(_e){}
              }catch(_e){
                try{ location.hash = '#tab=myCabin&cabin=chat'; }catch(_e2){}
              }
            });

          })();
        }
      }catch(_e){}

      // keep URL updated when you navigate in the app
      // auto-load Disciples list (default IN) so it doesn't start blank
    try{
      if(key === "disciples"){
        try{ if(S) S.adminDiscScope = "IN"; }catch(_e){}
        try{
          var E = (typeof discEls_==="function") ? discEls_() : null;
          if(E && E.scope) E.scope.value = "IN";
        }catch(_e){}
        var has = false;
        try{ has = !!(S && S.adminDisciples && S.adminDisciples.__hasLoaded); }catch(_e){}
        if(!has){
          setTimeout(function(){
            try{ if(typeof loadAdminDisciples==="function") loadAdminDisciples(false); }catch(_e){}
          }, 0);
        }
      }
    }catch(_e){}

    try{ if(window.SLB_route && window.SLB_route.sync) window.SLB_route.sync(true); }catch(_e){}

    // ====== Help Wizard (Normal User) ======
    const HELP = {
      open:false,
      mode:"tour", // tour | topics
      idx:0,
      hiEl:null,
      trapRelease:null,
      returnFocus:null,
      embedded:false,
      embedAnchor:null,
      embedHost:null
    };

    const helpEls = () => ({
      overlay: el("slbHelpPanel"),
      bodyTour: el("slbHelpBodyTour"),
      bodyTopics: el("slbHelpBodyTopics"),
      footerTour: el("slbHelpFooterTour"),
      footerTopics: el("slbHelpFooterTopics"),
      title: el("slbHelpStepTitle"),
      text: el("slbHelpStepText"),
      mini: el("slbHelpMini"),
      dots: el("slbHelpDots"),
      tabTour: el("slbHelpTabTour"),
      tabTopics: el("slbHelpTabTopics"),
      btnBack: el("slbHelpBack"),
      btnNext: el("slbHelpNext"),
      btnShow: el("slbHelpShow"),
      btnClose: el("slbHelpClose"),
      btnClose2: el("slbHelpClose2"),
      btnRestart: el("slbHelpRestartTour"),
      topHelp: el("slbHelpBtn"),
    });

    const helpSeenKey = () => "slb_seen_guide_" + (S.callsign || sessionStorage.getItem("tyw_callsign") || "unknown");
    const hasSeenHelp = () => localStorage.getItem(helpSeenKey()) === "1";
    const markSeenHelp = () => { try{ localStorage.setItem(helpSeenKey(), "1"); }catch(_e){} };

    const HELP_STEPS = [
      {
        title:"Welcome to Saam Law BaseStation",
        text:
`Saam Law BaseStation helps you manage Spirit Stones safely.

You have:
- On Hand → temporary holding
- Cosmic Pouches → storage for use, trade, and spending

Click Next to learn the flow.`,
        mini:"Tip: You can open Help anytime using the Help button.",
        panel:"myCabin",
        hi:'[data-panel="myCabin"]',
        nav:'button.menuItem[data-tab="myCabin"]'
      },
      {
        title:"My Cabin",
        text:
`My Cabin is your SLB home.

Start here for your daily information, diary, cultivation, messages, and quick access to the rest of SLB.`,
        mini:"My Cabin now opens first whenever you enter SLB.",
        panel:"myCabin",
        hi:'[data-panel="myCabin"]',
        nav:'button.menuItem[data-tab="myCabin"]'
      },
      {
        title:"On Hand",
        text:
`On Hand is the entry point.

You can:
- Receive stones here
- Move stones into a Cosmic Pouch

You cannot:
- You cannot spend directly from On Hand`,
        mini:"Normal flow: On Hand → Cosmic Pouch → action.",
        panel:"wallet",
        hi:'[data-panel="wallet"]',
        nav:'button.menuItem[data-tab="wallet"]'
      },
      {
        title:"Transfers (Deposit / Withdrawal)",
        text:
`Transfers move stones between On Hand and your Cosmic Pouches.

Deposit:
On Hand → Cosmic Pouch

Withdrawal:
Cosmic Pouch → On Hand`,
        mini:"Deposit first if you plan to spend or trade.",
        panel:"deposit",
        hi:'[data-panel="deposit"]',
        nav:'button.menuItem[data-tab="deposit"]'
      },
      {
        title:"Cosmic Pouches",
        text:
`Cosmic Pouches are where stones are organized and used.

You can:
- Rename pouches
- Keep stones separated
- Use stones for actions (spend, trade, send)`,
        mini:"If you can’t find stones, they may still be On Hand.",
        panel:"accounts",
        hi:'[data-panel="accounts"]',
        nav:'button.menuItem[data-tab="accounts"]'
      },
      {
        title:"Offer & Market",
        text:
`Offer:
Create listings for others to order from you.

Market:
Browse listings and place orders.

You can track:
- My Orders
- My Sales`,
        mini:"Always read the delivery notes before ordering.",
        panel:"market",
        hi:'[data-panel="market"]',
        nav:'button.menuItem[data-tab="market"]'
      },
      {
        title:"Transactions & Export",
        text:
`Transactions is your record.

Use it to:
- Confirm transfers
- Confirm purchases and sales
- Track where stones moved

Export lets you download your records for backup.`,
        mini:"If you need proof, Transactions is the place.",
        panel:"txns",
        hi:'[data-panel="txns"]',
        nav:'button.menuItem[data-tab="txns"]'
      },
      {
        title:"You’re ready",
        text:
`That’s it.

If you forget anything, click Help anytime.`,
        mini:"",
        panel:"myCabin",
        hi:null,
        nav:null
      }
    ];

    // Defensive: ensure Guided Tour text is rendered at least once
    try{ setTimeout(helpRenderStep, 0); }catch(_e){}

    function helpClearHighlight(){
      try{
        if(HELP.hiEl) HELP.hiEl.classList.remove("slbHelpSpotlight");
      }catch(_e){}
      HELP.hiEl = null;
    }

    function helpApplyHighlight(selector){
      helpClearHighlight();
      if(!selector) return;
      const elx = root.querySelector(selector);
      if(!elx) return;
      HELP.hiEl = elx;
      elx.classList.add("slbHelpSpotlight");
      try{
        elx.scrollIntoView({behavior:"smooth", block:"center", inline:"nearest"});
      }catch(_e){}
    }

    function helpRenderDots(){
      const H = helpEls();
      if(!H.dots) return;
      H.dots.innerHTML = "";
      H.dots.setAttribute("aria-label", "Guided tour step " + (HELP.idx + 1) + " of " + HELP_STEPS.length);
      for(let i=0;i<HELP_STEPS.length;i++){
        const d = document.createElement("span");
        d.className = "slbHelpDot" + (i===HELP.idx ? " active" : (i<HELP.idx ? " done" : ""));
        d.setAttribute("aria-hidden", "true");
        H.dots.appendChild(d);
      }
    }

    function helpSetMode(mode, focusTab){
      const H = helpEls();
      HELP.mode = mode;
      const isTour = mode === "tour";
      if(H.tabTour){
        H.tabTour.classList.toggle("active", isTour);
        H.tabTour.setAttribute("aria-selected", isTour ? "true" : "false");
        H.tabTour.tabIndex = isTour ? 0 : -1;
      }
      if(H.tabTopics){
        H.tabTopics.classList.toggle("active", !isTour);
        H.tabTopics.setAttribute("aria-selected", isTour ? "false" : "true");
        H.tabTopics.tabIndex = isTour ? -1 : 0;
      }
      if(H.bodyTour){
        H.bodyTour.classList.toggle("hidden", !isTour);
        H.bodyTour.setAttribute("aria-hidden", isTour ? "false" : "true");
      }
      if(H.footerTour) H.footerTour.classList.toggle("hidden", !isTour);
      if(H.bodyTopics){
        H.bodyTopics.classList.toggle("hidden", isTour);
        H.bodyTopics.setAttribute("aria-hidden", isTour ? "true" : "false");
      }
      if(H.footerTopics) H.footerTopics.classList.toggle("hidden", isTour);
      helpClearHighlight();
      if(isTour) helpRenderStep();
      if(focusTab){
        const target = isTour ? H.tabTour : H.tabTopics;
        if(target) requestAnimationFrame(() => target.focus());
      }
      try{ window.SLB && SLB.a11y && SLB.a11y.announce(isTour ? "Guided Tour selected" : "Help Topics selected"); }catch(_e){}
    }

    function helpRenderStep(){
      const step = HELP_STEPS[HELP.idx] || HELP_STEPS[0];
      const H = helpEls();
      if(H.title) H.title.textContent = step.title || "Help";
      if(H.text) H.text.textContent = step.text || "";
      if(H.mini) {
        H.mini.textContent = step.mini || "";
        H.mini.classList.toggle("hidden", !step.mini);
      }
      if(H.btnBack) H.btnBack.disabled = HELP.idx<=0;
      if(H.btnNext) H.btnNext.textContent = (HELP.idx >= HELP_STEPS.length-1) ? "Done" : "Next";
      helpRenderDots();
    }

    function helpGo(delta){
      const next = HELP.idx + delta;
      HELP.idx = Math.max(0, Math.min(HELP_STEPS.length-1, next));
      helpRenderStep();
    }

    function helpShowMe(){
      const step = HELP_STEPS[HELP.idx] || HELP_STEPS[0];
      if(step.panel) setPanel(step.panel);
      // highlight nav button first (helps user understand where they clicked), then panel
      if(step.nav) helpApplyHighlight(step.nav);
      setTimeout(() => helpApplyHighlight(step.hi), 220);
    }

    function helpUnembed(){
      const H = helpEls();
      if(!HELP.embedded || !H.overlay) return false;
      HELP.embedded = false;
      HELP.open = false;
      HELP.embedHost = null;
      helpClearHighlight();
      if(typeof HELP.trapRelease === "function") HELP.trapRelease(false);
      HELP.trapRelease = null;
      H.overlay.classList.remove("slbHelpEmbedded");
      H.overlay.classList.add("hidden");
      H.overlay.setAttribute("aria-hidden", "true");
      const shell = H.overlay.querySelector(".slbHelpShell");
      if(shell){ shell.setAttribute("role","dialog"); shell.setAttribute("aria-modal","true"); }
      try{
        if(HELP.embedAnchor && HELP.embedAnchor.parentNode){
          HELP.embedAnchor.parentNode.insertBefore(H.overlay, HELP.embedAnchor.nextSibling);
        }
      }catch(_e){}
      return true;
    }

    function helpEmbed(host, mode){
      const H = helpEls();
      if(!host || !H.overlay) return false;
      if(HELP.open && !HELP.embedded) helpClose();
      if(!HELP.embedAnchor && H.overlay.parentNode){
        HELP.embedAnchor = document.createComment("SLB Help original position");
        H.overlay.parentNode.insertBefore(HELP.embedAnchor, H.overlay);
      }
      if(typeof HELP.trapRelease === "function") HELP.trapRelease(false);
      HELP.trapRelease = null;
      HELP.embedded = true;
      HELP.open = true;
      HELP.embedHost = host;
      document.body.classList.remove("slbHelpOpen");
      H.overlay.classList.remove("hidden");
      H.overlay.classList.add("slbHelpEmbedded");
      H.overlay.setAttribute("aria-hidden", "false");
      host.innerHTML = "";
      host.appendChild(H.overlay);
      const shell = H.overlay.querySelector(".slbHelpShell");
      if(shell){ shell.setAttribute("role","region"); shell.setAttribute("aria-modal","false"); }
      helpSetMode(mode === "tour" ? "tour" : "topics");
      return true;
    }

    function helpOpen(mode="tour", startIdx=0){
      if(HELP.embedded) helpUnembed();
      const H = helpEls();
      if(!H.overlay) return;
      HELP.returnFocus = document.activeElement;
      HELP.open = true;
      document.body.classList.add("slbHelpOpen");
      HELP.idx = Math.max(0, Math.min(HELP_STEPS.length-1, startIdx||0));
      H.overlay.classList.remove("hidden");
      H.overlay.setAttribute("aria-hidden", "false");
      helpSetMode(mode);
      helpRenderStep();
      const shell = H.overlay.querySelector(".slbHelpShell");
      if(typeof HELP.trapRelease === "function") HELP.trapRelease(false);
      HELP.trapRelease = null;
      if(shell && window.SLB && SLB.a11y && typeof SLB.a11y.trapDialog === "function"){
        HELP.trapRelease = SLB.a11y.trapDialog(shell, {
          initialFocus: H.btnClose || shell,
          returnFocus: HELP.returnFocus,
          onEscape: helpClose
        });
      }else if(H.btnClose){
        requestAnimationFrame(() => H.btnClose.focus());
      }
      try{ window.SLB && SLB.a11y && SLB.a11y.announce("Help opened"); }catch(_e){}
    }

    function helpClose(){
      const H = helpEls();
      if(HELP.embedded){ helpUnembed(); markSeenHelp(); return; }
      if(!HELP.open) return;
      HELP.open = false;
      document.body.classList.remove("slbHelpOpen");
      helpClearHighlight();
      if(H.overlay){
        H.overlay.classList.add("hidden");
        H.overlay.setAttribute("aria-hidden", "true");
      }
      if(typeof HELP.trapRelease === "function") HELP.trapRelease(true);
      HELP.trapRelease = null;
      markSeenHelp();
      try{ window.SLB && SLB.a11y && SLB.a11y.announce("Help closed"); }catch(_e){}
    }

    function maybeAutoHelp(){
      // Only auto-open when app is visible and user hasn't seen it
      const H = helpEls();
      if(!H.overlay) return;
      if(hasSeenHelp()) return;
      const isAppVisible = !appWrap.classList.contains("hidden");
      if(!isAppVisible) return;
      setTimeout(() => {
        if(!hasSeenHelp() && !HELP.open) helpOpen("tour", 0);
      }, 380);
    }

    // Help bindings (safe)

    // Expose minimal global for onclick safety
    window.SLB_HELP = window.SLB_HELP || {};
    window.SLB_HELP.openTour = () => helpOpen('tour', 0);
    window.SLB_HELP.openTopics = () => helpOpen('topics', 0);
    window.SLB_HELP.close = () => helpClose();
    window.SLB_HELP.embed = (host, mode) => helpEmbed(host, mode || 'topics');
    window.SLB_HELP.unembed = () => helpUnembed();
    window.SLB_HELP.isEmbedded = () => !!HELP.embedded;

    onOnce("slbHelpBtn","click", () => helpOpen("tour", 0));
    onOnce("slbHelpClose","click", helpClose);
    onOnce("slbHelpClose2","click", helpClose);
    onOnce("slbHelpBack","click", () => helpGo(-1));
    onOnce("slbHelpNext","click", () => {
      if(HELP.idx >= HELP_STEPS.length-1) return helpClose();
      helpGo(1);
    });
    onOnce("slbHelpShow","click", helpShowMe);
    onOnce("slbHelpRestartTour","click", () => helpSetMode("tour") || helpOpen("tour", 0));

    onOnce("slbHelpTabTour","click", () => helpSetMode("tour"));
    onOnce("slbHelpTabTopics","click", () => helpSetMode("topics"));
    ["slbHelpTabTour","slbHelpTabTopics"].forEach(id => {
      const tabBtn = el(id);
      if(!tabBtn || tabBtn.dataset.slbHelpKeys) return;
      tabBtn.dataset.slbHelpKeys = "1";
      tabBtn.addEventListener("keydown", (e) => {
        if(!["ArrowLeft","ArrowRight","Home","End"].includes(e.key)) return;
        e.preventDefault();
        const nextMode = (e.key === "Home" || e.key === "ArrowLeft") ? "tour" : "topics";
        helpSetMode(nextMode, true);
      });
    });

    // close when clicking outside modal (non-blocking overlay)
    document.addEventListener("click", (e) => {
      if(!HELP.open) return;
      if(e.target && e.target.closest && e.target.closest("#slbHelpBtn,[data-slb-help-open]")) return;
      const modal = root.querySelector(".slbHelpShell");
      if(modal && !modal.contains(e.target)) helpClose();
    });

    // Escape to close
    document.addEventListener("keydown", (e) => {
      if(e.key === "Escape" && HELP.open) helpClose();
    });

    }

    // menu clicks (desktop + mobile share .menuItem)
    // NOTE: Mobile drawer is moved to <body> to avoid transformed ancestors.
    // That means its buttons are no longer inside `root`, so we must wire clicks in BOTH places.
    function wireMenuClicks_(){
      const scopes = [];
      if(root) scopes.push(root);
      if(mobilePanel) scopes.push(mobilePanel);
      scopes.forEach(sc => {
        sc.querySelectorAll(".menuItem[data-tab]").forEach(btn => {
          if(btn.dataset.tywMenuWired) return;
          btn.dataset.tywMenuWired = "1";
          btn.addEventListener("click", () => {
            try{ closeAllDrops(); }catch(_e){}
            const tab = btn.getAttribute("data-tab");
            if(tab === "admin" && !S.isAdminOrMod) return;
            if(tab === "library"){
              // Menu Library should ALWAYS go to Library front page (list), not the last opened post.
              try{ window.__SLB_LIB_SELECTED_POSTID = ""; }catch(_e){}
              try{ if(window.SLB_LIBRARY && typeof window.SLB_LIBRARY.goHome === "function") window.SLB_LIBRARY.goHome(); }catch(_e){}
            }
            setPanel(tab);

            if(tab === "admin"){
              // Admin (full) loads
              if(S.isAdmin){
                loadAdminUsers().catch(()=>{});
                loadAdminAwards().catch(()=>{});
                loadAdminPayroll().catch(()=>{});
              }
              // Read-only loads (Admin + Moderator)
              loadAdminRoster().catch(()=>{});
              loadAdminCultOverviewAll().catch(()=>{});

              // Moderator Option A: default to roster and hide other pages
              try{
                if(window.SLB_applyRoleUI) window.SLB_applyRoleUI();
                const isModOnly = (!!S.isModerator) && (!S.isAdmin);
                if(isModOnly && window.SLB_showAdmPage) window.SLB_showAdmPage("roster");
              }catch(_e){}
            }

            if(tab === "admin"){
              // Auto-load Disciples list when entering Admin tab (covers session-restore where Disciples is already active)
              (function(){
                var tries = 0;
                function kick(){
                  tries++;
                  try{
                    var active = qs('#tywAdminPanel .admPage.active');
                    var adm = active ? String(active.getAttribute('data-adm')||'') : '';
                    if(adm !== 'disciples'){
                      return; // not on Disciples page
                    }
                    // default scope IN
                    try{
                      var E = (typeof discEls_ === 'function') ? discEls_() : null;
                      if(E && E.scope && !E.scope.value) E.scope.value = "IN";
                    }catch(_e){}
                    if(typeof loadAdminDisciples === 'function'){
                      if(!S.adminDisciples || !S.adminDisciples.__hasLoaded){
                        loadAdminDisciples(false).catch(()=>{});
                      }else{
                        try{ discRender_(); }catch(_e){}
                      }
                      return;
                    }
                  }catch(_e){}
                  if(tries < 8) setTimeout(kick, 250);
                }
                setTimeout(kick, 0);
              })();
            }

            if(tab === "user"){ loadNotifyPrefs_().catch(()=>{}); }
            if(tab === "cult"){ loadCultivations(false).catch(()=>{}); }
          });
        });
      });
    }

    // wire once now, and again on open (in case the drawer is moved later)
    wireMenuClicks_();


    function setBusy(isBusy){
      try{ if(appWrap) appWrap.setAttribute("aria-busy", isBusy ? "true" : "false"); }catch(_e){}
      [
        "tywLoginBtn","tywDepBtn","tywWitBtn","tywGiftBtn",
        "tywPinChangeBtn","tywPinResetReqBtn",
        "tywCreateAcctBtn","tywExportBtn",
        "tywOfferPostBtn","tywOfferReloadBtn","tywMarketReloadBtn","tywOrdersReloadBtn","tywSalesReloadBtn",
        "tywAdmAddUserBtn","tywAdmLoadUserBtn","tywAdmAdjBtn",
        "tywAdmAwardCreateBtn","tywAdmAwardReloadBtn",
        "tywAdmPayCreateBtn","tywAdmPayReloadBtn","tywAdmPayRunDueBtn","tywAdmPayForceAllBtn"
      ,
        "slbNotifySaveBtn","slbNotifyTestBtn"].forEach(id => { const n = el(id); if(n) n.disabled = !!isBusy; });

      // icons/links
      const r = el("tywRefreshIcon");
      const l = el("tywLogoutLink");
      if(r) r.disabled = !!isBusy;
      if(l) l.style.pointerEvents = isBusy ? "none" : "";
      if(l) l.style.opacity = isBusy ? ".55" : "";
    }


    // ====== Button-level busy (prevents double-click on table buttons) ======
    function lockBtn(btn, busyLabel){
      try{
        if(!btn) return ()=>{};
        if(btn.dataset && btn.dataset.slbBusy === "1") return ()=>{};
        const isIconOnly = !!(
          (btn.dataset && btn.dataset.icononly === "1") ||
          (btn.dataset && (btn.dataset.iconOnly === "1" || btn.dataset.slbIconOnly === "1")) ||
          (btn.classList && (btn.classList.contains("iconOnly") || btn.classList.contains("slbMktReloadIcon")))
        );
        if(btn.dataset){
          btn.dataset.slbBusy = "1";
          const __curHtml = (btn.innerHTML || "");
          btn.dataset.slbOrigHtml = isIconOnly ? (__curHtml ? __curHtml : "__KEEP__") : "";
          btn.dataset.slbOrigText = btn.textContent || "";
          btn.dataset.slbOrigDisabled = btn.disabled ? "1" : "0";
          btn.dataset.slbOrigMinW = btn.style.minWidth || "";
        }
        // keep width stable to reduce UI jitter
        try{
          const w = (btn.getBoundingClientRect && btn.getBoundingClientRect().width) ? btn.getBoundingClientRect().width : 0;
          if(w) btn.style.minWidth = Math.ceil(w) + "px";
        }catch(_e){}
        if(busyLabel){
          if(isIconOnly){
            try{ btn.classList.add("isLoading"); }catch(_e){}
            try{ btn.setAttribute("aria-busy","true"); }catch(_e){}
          }else{
            btn.textContent = busyLabel;
          }
        }
        // For icon-only buttons, always show spinner feedback (no text)
        if(isIconOnly){
          try{ btn.classList.add("isLoading"); }catch(_e){}
          try{ btn.setAttribute("aria-busy","true"); }catch(_e){}
        }
        try{ btn.setAttribute("aria-busy","true"); }catch(_e){}
        btn.disabled = true;

        return () => {
          try{
            if(!btn || !btn.isConnected) return;
            if(btn.dataset){
              if(isIconOnly){
                if(btn.dataset.slbOrigHtml != null && btn.dataset.slbOrigHtml !== "__KEEP__") btn.innerHTML = btn.dataset.slbOrigHtml;
                try{ btn.classList.remove("isLoading"); }catch(_e){}
              }else{
                if(btn.dataset.slbOrigText != null) btn.textContent = btn.dataset.slbOrigText;
              }
              try{ btn.removeAttribute("aria-busy"); }catch(_e){}
              btn.style.minWidth = btn.dataset.slbOrigMinW || "";
              btn.disabled = (btn.dataset.slbOrigDisabled === "1");
              delete btn.dataset.slbBusy;
              delete btn.dataset.slbOrigHtml;
              delete btn.dataset.slbOrigText;
              delete btn.dataset.slbOrigDisabled;
              delete btn.dataset.slbOrigMinW;
            }else{
              btn.disabled = false;
            }
          }catch(_e){}
        };
      }catch(_e){
        return ()=>{};
      }
    }

    function fillSelect(sel, items, placeholder){
      if(!sel) return;
      sel.innerHTML = "";
      if(!items || !items.length){
        const opt = document.createElement("option");
        opt.value = "";
        opt.textContent = placeholder || "—";
        sel.appendChild(opt);
        return;
      }
      items.forEach(a => {
        const opt = document.createElement("option");
        opt.value = a.value;
        opt.textContent = a.label;
        sel.appendChild(opt);
      });
    }
    function fillSelectWithPlaceholder(sel, items, placeholder, emptyLabel){
      if(!sel) return;
      sel.innerHTML = "";
      const opt0 = document.createElement("option");
      opt0.value = "";
      opt0.textContent = (items && items.length) ? (placeholder || "—") : (emptyLabel || placeholder || "—");
      sel.appendChild(opt0);
      if(!items || !items.length) return;
      items.forEach(a => {
        const opt = document.createElement("option");
        opt.value = a.value;
        opt.textContent = a.label;
        sel.appendChild(opt);
      });
    }

    function renderAllSelects(){
      const accounts = (S.dash && Array.isArray(S.dash.accounts)) ? S.dash.accounts : [];
      const norm = (s) => String(s||"").toLowerCase().replace(/\s+/g,"").trim();
      
      const wallet = accounts.find(isOnHand) || null;
      const others = accounts.filter(a => a && !isOnHand(a) && !a.__state);

      const depFromItems = wallet ? [{ value: String(wallet.accountId || wallet.walletId || ''), label: `${displayAcctName(wallet.name)} (bal ${money(wallet.balance)})` }] : [];
      const depToItems = others.map(a => ({ value: String(a.accountId || a.walletId || ''), label: `${displayAcctName(a.name)} (bal ${money(a.balance)})` }));

      const witToItems = wallet ? [{ value: String(wallet.accountId || wallet.walletId || ''), label: `${displayAcctName(wallet.name)} (bal ${money(wallet.balance)})` }] : [];
      const witFromItems = others.map(a => ({ value: String(a.accountId || a.walletId || ''), label: `${displayAcctName(a.name)} (bal ${money(a.balance)})` }));

      const giftFromItems = others.map(a => ({ value: String(a.accountId || a.walletId || ""), label: `${displayAcctName(a.name)} (bal ${money(a.balance)})` }));

      // Use placeholder when needed so user can see what to do, but still populate real values.
      fillSelectWithPlaceholder(el("tywDepFrom"), depFromItems, "- select -", "—");
      fillSelectWithPlaceholder(el("tywDepTo"), depToItems, "- select -", "—");
      fillSelectWithPlaceholder(el("tywWitFrom"), witFromItems, "- select -", "—");
      fillSelectWithPlaceholder(el("tywWitTo"), witToItems, "- select -", "—");
      fillSelectWithPlaceholder(el("tywGiftFrom"), giftFromItems, "- select -", "—");

      // If placeholder is selected but there are real options, auto-pick first real option.
      const autoPick = (sel) => {
        if(!sel || !sel.options || !sel.options.length) return;
        if(sel.value) return;
        for(let i=0;i<sel.options.length;i++){
          const v = sel.options[i].value;
          if(v){ sel.selectedIndex = i; return; }
        }
      };
      autoPick(el("tywDepFrom"));
      autoPick(el("tywDepTo"));
      autoPick(el("tywWitFrom"));
      autoPick(el("tywWitTo"));
    }


    let __pouchArrangeMode = false;
    let __pouchDraftIds = [];
    let __pouchDragId = "";

    function pouchAlpha_(a,b){
      return String(displayAcctName(a && a.name)||"").localeCompare(String(displayAcctName(b && b.name)||""), undefined, { sensitivity:"base", numeric:true });
    }

    function pouchOrderedAccounts_(){
      const accounts = (S.dash && Array.isArray(S.dash.accounts)) ? S.dash.accounts.filter(Boolean) : [];
      const wallet = accounts.filter(isOnHand);
      const pouches = accounts.filter(a => !isOnHand(a));

      // Legacy numeric sort values are intentionally ignored. A saved rearrangement uses
      // the reserved 10000+ range; otherwise pouches are shown alphabetically.
      const custom = pouches.filter(a => Number(a.sort||0) >= 10000).sort((a,b) => Number(a.sort||0)-Number(b.sort||0) || pouchAlpha_(a,b));
      const normal = pouches.filter(a => Number(a.sort||0) < 10000).sort(pouchAlpha_);
      let ordered = custom.concat(normal);

      if(__pouchArrangeMode && __pouchDraftIds.length){
        const byId = Object.create(null);
        ordered.forEach(a => { byId[String(a.accountId||a.walletId||"")] = a; });
        const draft = [];
        __pouchDraftIds.forEach(id => { if(byId[id]){ draft.push(byId[id]); delete byId[id]; } });
        ordered.forEach(a => { const id=String(a.accountId||a.walletId||""); if(byId[id]){ draft.push(a); delete byId[id]; } });
        ordered = draft;
      }
      return wallet.sort(pouchAlpha_).concat(ordered);
    }

    function pouchSetArrangeUi_(){
      const save=el("tywPouchSaveOrderBtn"), cancel=el("tywPouchCancelOrderBtn"), start=el("tywPouchRearrangeBtn"), hint=el("tywPouchArrangeHint");
      if(start) start.classList.toggle("hidden", __pouchArrangeMode);
      if(save) save.classList.toggle("hidden", !__pouchArrangeMode);
      if(cancel) cancel.classList.toggle("hidden", !__pouchArrangeMode);
      if(hint) hint.classList.toggle("hidden", !__pouchArrangeMode);
    }

    function pouchMoveDraft_(id,dir){
      const idx=__pouchDraftIds.indexOf(String(id||""));
      const next=idx+Number(dir||0);
      if(idx<0 || next<0 || next>=__pouchDraftIds.length) return;
      const tmp=__pouchDraftIds[idx];
      __pouchDraftIds[idx]=__pouchDraftIds[next];
      __pouchDraftIds[next]=tmp;
      renderAccounts();
    }

    function pouchBindToolbar_(){
      const start=el("tywPouchRearrangeBtn"), save=el("tywPouchSaveOrderBtn"), cancel=el("tywPouchCancelOrderBtn");
      if(start && !start.dataset.pouchBound){
        start.dataset.pouchBound="1";
        start.addEventListener("click", () => {
          clearMsg(el("tywPouchOrderMsg")); clearMsg(el("tywPouchOrderOk"));
          __pouchArrangeMode=true;
          __pouchDraftIds=pouchOrderedAccounts_().filter(a=>!isOnHand(a)&&!a.__state).map(a=>String(a.accountId||a.walletId||""));
          renderAccounts();
        });
      }
      if(cancel && !cancel.dataset.pouchBound){
        cancel.dataset.pouchBound="1";
        cancel.addEventListener("click", () => {
          __pouchArrangeMode=false; __pouchDraftIds=[]; __pouchDragId="";
          clearMsg(el("tywPouchOrderMsg"));
          renderAccounts();
        });
      }
      if(save && !save.dataset.pouchBound){
        save.dataset.pouchBound="1";
        save.addEventListener("click", async () => {
          clearMsg(el("tywPouchOrderMsg")); clearMsg(el("tywPouchOrderOk"));
          const ids=__pouchDraftIds.filter(Boolean);
          if(ids.length<2){ __pouchArrangeMode=false; renderAccounts(); return; }
          const unlock=lockBtn(save,"Saving…");
          try{
            await rpc("reorderAccounts", { accountIds:ids }, { requestId:"pouch_order_"+Date.now(), timeoutMs:90000 });
            const rank=Object.create(null); ids.forEach((id,i)=>{rank[id]=10000+(i+1)*10;});
            const accounts=(S.dash&&Array.isArray(S.dash.accounts))?S.dash.accounts:[];
            accounts.forEach(a=>{const id=String(a.accountId||a.walletId||""); if(rank[id]) a.sort=rank[id];});
            __pouchArrangeMode=false; __pouchDraftIds=[]; __pouchDragId="";
            setMsg(el("tywPouchOrderOk"),"Pouch order saved.",true);
            renderAllSelects();
            renderAccounts();
          }catch(e){
            setMsg(el("tywPouchOrderMsg"),e.message||String(e),false);
          }finally{ unlock(); }
        });
      }
    }

    function renderAccounts(){
      const wrap = el("tywAccountsList");
      if(!wrap) return;
      pouchBindToolbar_();
      pouchSetArrangeUi_();
      wrap.innerHTML = "";
      const accounts = pouchOrderedAccounts_();
      const activePouches = accounts.filter(a=>!isOnHand(a)&&!a.__state);
      const canArrange = activePouches.length > 1 && !!(S.isAdmin || S.canCreatePouches);
      const rearrangeBtn=el("tywPouchRearrangeBtn");
      if(rearrangeBtn){ rearrangeBtn.disabled=!canArrange; rearrangeBtn.title=canArrange?"Change Cosmic Pouch order":"Create at least two pouches to rearrange"; }

      accounts.forEach((a,accountIndex) => {
        const st = (a && a.__state) ? String(a.__state) : "";
        const id = String(a.accountId || a.walletId || "");
        const wallet = isOnHand(a);
        const acctSyncHtml = st ? (' <span class="pill slbStickyState ' + (st==='failed'?'retry':'syncing') + '">' + (st==='failed'?'Not Synced':'Syncing…') + '</span>') : '';
        const row = document.createElement("div");
        row.className = "slbPouchRow" + (wallet?" slbPouchOnHand":"") + (__pouchArrangeMode&&!wallet?" is-arranging":"");
        row.setAttribute("data-pouch-id",id);
        if(__pouchArrangeMode && !wallet && !st){ row.draggable=true; row.setAttribute("data-pouch-arrange-id",id); }
        const pouchPos = __pouchDraftIds.indexOf(id);
        const controls = (__pouchArrangeMode && !wallet && !st) ? `
          <div class="slbPouchMoveControls" aria-label="Rearrange ${escapeHtml(displayAcctName(a.name))}">
            <button class="btn soft mini" type="button" data-pouch-move="-1" data-pouch-id="${escapeHtml(id)}" ${pouchPos<=0?'disabled':''} aria-label="Move up">↑</button>
            <button class="btn soft mini" type="button" data-pouch-move="1" data-pouch-id="${escapeHtml(id)}" ${pouchPos<0||pouchPos>=__pouchDraftIds.length-1?'disabled':''} aria-label="Move down">↓</button>
            <span class="slbPouchDragGrip" title="Drag to rearrange" aria-hidden="true">⋮⋮</span>
          </div>` : `
          <div class="slbPouchRowActions">
            <button class="btn soft mini" data-rename="${escapeHtml(id)}" ${(wallet || st || !(S.isAdmin || S.canCreatePouches)) ? "disabled" : ""}>Rename</button>
            <span class="badge">${wallet?'ON HAND':'POUCH '+String(Math.max(1,accountIndex))}</span>
          </div>`;
        row.innerHTML = `
          <div class="slbPouchRowMain">
            <div class="slbPouchIdentity">
              <div class="slbPouchName">${escapeHtml(displayAcctName(a.name))}${acctSyncHtml}</div>
              <div class="slbPouchBalance">Balance: <b>${money(a.balance)}</b> stones</div>
            </div>
            ${controls}
          </div>
        `;
        wrap.appendChild(row);
      });

      wrap.querySelectorAll("button[data-rename]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-rename");
          const all=(S.dash&&Array.isArray(S.dash.accounts))?S.dash.accounts:[];
          const acct = all.find(x => String(x.accountId||x.walletId||"") === id);
          if(!acct || isOnHand(acct) || acct.__state) return;
          const nn = prompt("New cosmic pouch name:", displayAcctName(acct.name));
          if(nn === null) return;
          const nextName = String(nn||"").trim();
          if(!nextName) return;

          try{ ensureMaxLen("Cosmic Pouch name", nextName, LIMITS.acctName); }catch(e){ alert(e.message || String(e)); return; }

          const unlock = lockBtn(btn, "Saving…");
          try{
            const op = bankQueueRename_({ accountId:id, newName: nextName });
            bankRenderNow_();
            toast("ok","Renamed (syncing…).");
            bankSyncOp_(op);
          }catch(e){
            alert(e.message || String(e));
          }finally{
            unlock();
          }
        });
      });

      wrap.querySelectorAll("button[data-pouch-move]").forEach(btn=>{
        btn.addEventListener("click",()=>pouchMoveDraft_(btn.getAttribute("data-pouch-id"),Number(btn.getAttribute("data-pouch-move")||0)));
      });
      wrap.querySelectorAll("[data-pouch-arrange-id]").forEach(row=>{
        row.addEventListener("dragstart",e=>{__pouchDragId=row.getAttribute("data-pouch-arrange-id")||""; row.classList.add("is-dragging"); try{e.dataTransfer.effectAllowed="move";e.dataTransfer.setData("text/plain",__pouchDragId);}catch(_e){}});
        row.addEventListener("dragend",()=>{row.classList.remove("is-dragging");__pouchDragId="";});
        row.addEventListener("dragover",e=>{e.preventDefault();row.classList.add("is-dragover");});
        row.addEventListener("dragleave",()=>row.classList.remove("is-dragover"));
        row.addEventListener("drop",e=>{
          e.preventDefault(); row.classList.remove("is-dragover");
          const target=row.getAttribute("data-pouch-arrange-id")||"";
          let source=__pouchDragId; try{source=source||e.dataTransfer.getData("text/plain");}catch(_e){}
          if(!source||!target||source===target)return;
          const from=__pouchDraftIds.indexOf(source),to=__pouchDraftIds.indexOf(target);
          if(from<0||to<0)return;
          __pouchDraftIds.splice(from,1); __pouchDraftIds.splice(to,0,source); renderAccounts();
        });
      });
    }

    function dedupeTxns(txns){
      const seen = new Set();
      const out = [];
      (txns||[]).forEach(t => {
        const id = String((t && (t.txnId || t.id)) || "");
        if(id){
          if(seen.has(id)) return;
          seen.add(id);
        }
        out.push(t);
      });
      return out;
    }

    function sortTxns(txns, sort){
      const key = sort.key;
      const dir = sort.dir === "asc" ? 1 : -1;

      const get = (t) => {
        if(key === "amount") return Number(t.amount||0);
        return String(t[key] || "").toLowerCase();
      };

      return [...txns].sort((a,b) => {
        const av = get(a), bv = get(b);
        if(key === "amount") return (av - bv) * dir;
        return String(av).localeCompare(String(bv)) * dir;
      });
    }

    function renderSortMarks(prefix, sort){
      ["time","type","from","to","amount","note"].forEach(k => {
        const n = el(prefix + k);
        if(!n) return;
        n.textContent = (sort.key === k) ? (sort.dir === "asc" ? "▲" : "▼") : "";
      });
    }

    async function editTxnNoteSelf(txn){
      if(!txn || !txn.txnId){
        alert("This entry has no txnId. If you want editing, the backend must store txnId for each row.");
        return;
      }
      const nn = prompt("Edit note:", txn.note || "");
      if(nn === null) return;
      try{ ensureMaxLen("Note", nn||"", LIMITS.txnNote); }catch(e){ alert(e.message || String(e)); return; }
      await rpc("updateTxnNote", { txnId: txn.txnId, note: String(nn||"") });
      await reloadTxnsFirstPage();
    }

    function renderTxnsSelf(){
      const body = el("tywTxnsBody");
      if(!body) return;
      body.innerHTML = "";

      const txns0 = (S.dash && S.dash.txns) ? S.dash.txns : [];
      const txns = sortTxns(dedupeTxns(txns0), S.sort);

      const map = {};
      (S.dash && S.dash.accounts || []).forEach(a => map[a.accountId] = a.name);

      const dispAcct = (id) => {
        // Self view should NOT expose internal technical accounts (SYS / escrow / etc).
        // Anything not in the user's own account map is treated as internal and masked.
        if(!id) return "";

        // Special display tokens (safe to show in self view)
        const sid = String(id);
        if(sid.startsWith("CS:") || sid.startsWith("cs:")) return sid.slice(3).toUpperCase();

        if(Object.prototype.hasOwnProperty.call(map, id)){
          let n = map[id] || "";
          if(String(n).toLowerCase() === "wallet") n = "On Hand";
          return n;
        }

        // Mask system pseudo-user and any unknown accounts.
        return "SLB";
      };

      const dispType = (type) => {
        const t = String(type || "").trim();
        if(!t) return "";
        const u = t.toUpperCase();
        // (continued in part02)


/* ====== SLB CORE: 90_core_app.part02.js ====== */
/* SLB PART FILE — NOT STANDALONE
   This file is concatenated by slb_build/build.mjs into assets/slb.bundle.generated.js
*/

/* SLB CORE APP (split) - part 02/6
   NOTE: These parts are concatenated in order by slb_build/build.mjs.
*/

        // Self view should NOT show internal technical codes like ESCROW_HOLD.
        // Convert them into disciple-friendly labels.
        if(u === "ESCROW_HOLD") return "Market Hold";
        if(u === "ESCROW_RELEASE") return "Market Release";
        if(u === "ESCROW_PAYOUT") return "Market Payout";
        if(u.startsWith("ESCROW_")) return "Market";

        // System/internal labels
        if(u.startsWith("SYS_")) return "SLB";

        // Gifts
        if(u === "GIFT_SENT") return "Gift Sent";
        if(u === "GIFT_RECEIVED") return "Gift Received";
        if(u.startsWith("GIFT_")) return "Gift";

        // Keep normal ones as-is
        return t;
      };
      // Map for fast click-to-edit without per-row listeners
      if(!S._txnsById) S._txnsById = Object.create(null);

      body.innerHTML = "";
      const CHUNK = 250;
      let i0 = 0;

      const renderChunk = () => {
        const frag = document.createDocumentFragment();
        const i1 = Math.min(i0 + CHUNK, txns.length);

        for(let i=i0; i<i1; i++) {
          const t = txns[i];
          const st = (t && t.__state) ? String(t.__state) : "";
          const syncHtml = st ? (' <span class="pill slbStickyState ' + (st==='failed'?'retry':'syncing') + '">' + (st==='failed'?'Not Synced':'Syncing…') + '</span>') : '';
          const tr = document.createElement("tr");
          tr.innerHTML = `
            <td>${escapeHtml(t.time || "")}</td>
            <td>${escapeHtml(dispType(t.type) || "")}${syncHtml}</td>
            <td>${escapeHtml(dispAcct(t.from) || "")}</td>
            <td>${escapeHtml(dispAcct(t.to) || "")}</td>
            <td><b>${money(t.amount)}</b></td>
            <td>${escapeHtml(t.note || "")}</td>
            <td style="display:flex;gap:8px;flex-wrap:wrap;">
              <button class="btn soft mini slbIconBtn slbEditTiny" data-txn="${escapeAttr(t.txnId || "")}" ${t.txnId ? "" : "disabled"} title="Edit" aria-label="Edit"><span class="slbIco">✎</span></button>
              <button class="btn soft mini slbCopyBtn slbIconBtn slbCopyTiny" data-copy="${escapeAttr(t.txnId || "")}" ${t.txnId ? "" : "disabled"} title="Copy ID" aria-label="Copy ID"><span class="slbIco">⧉</span></button>
            </td>
          `;

          if(t.txnId){
            S._txnsById[t.txnId] = t;
          }
          frag.appendChild(tr);
        }

        body.appendChild(frag);
        i0 = i1;
        if(i0 < txns.length) requestAnimationFrame(renderChunk);
      };

      requestAnimationFrame(renderChunk);

      if(!body.__txnEditBound){
        body.__txnEditBound = true;
        body.addEventListener("click", async (e) => {
          const btn = e.target.closest("button[data-txn]");
          if(!btn || btn.disabled) return;
          const unlock = lockBtn(btn, "Opening…");
          try{
            setBusy(true);
            const txnId = String(btn.getAttribute("data-txn")||"");
            const t = (S._txnsById && S._txnsById[txnId]) ? S._txnsById[txnId] : null;
            if(!t) throw new Error("Transaction not found. Please reload.");
            await editTxnNoteSelf(t);
          }catch(e){
            alert(e.message || String(e));
          }finally{
            setBusy(false);
            unlock();
          }
        });
      }

      renderSortMarks("tywSort_", S.sort);
      renderTxnsMore();
    }

    // Phase 4.3: load older txns (paged)
    async function loadOlderTxns(){
      if(!S.txnsCursor || !S.txnsHasMore) return;
      const btn = el("tywLoadOlderTxns");
      if(btn) btn.disabled = true;

      try{
        const page = await rpc("getTxnsPage", { cursor: S.txnsCursor, limit: 200 });
        const items = (page && page.items) ? page.items : [];
        if(!S.dash) S.dash = {};
        if(!Array.isArray(S.dash.txns)) S.dash.txns = [];
        S.dash.txns = S.dash.txns.concat(items);
        S.txnsCursor = page && page.nextCursor ? page.nextCursor : null;
        S.txnsHasMore = !!(page && page.hasMore);

      // Save for instant next-load
      try{
        slbCacheSet_("txnsFirst", { items: S.dash.txns, nextCursor: S.txnsCursor, hasMore: S.txnsHasMore });
      }catch(_e){} 
        try{ wireTxnsForceReloadBtn_(); }catch(_e){}
        try{ setTxnsLastRef_(); }catch(_e){}
        renderTxnsSelf();
      }catch(e){
        alert(e.message || String(e));
        if(btn) btn.disabled = false;
      }
    }

    function renderTxnsMore(){
      const row = el("tywTxnsMoreRow");
      if(!row) return;
      if(!S.txnsHasMore || !S.txnsCursor){
        row.innerHTML = "";
        return;
      }
      row.innerHTML = '<button class="btn" id="tywLoadOlderTxns">Load older transactions</button>';
      const b = el("tywLoadOlderTxns");
      if(b) b.addEventListener("click", loadOlderTxns);
    }


    // click-to-sort txns
    const txHead = el("tywTxnsHead");
    if(txHead){
      txHead.addEventListener("click", (e) => {
        const th = e.target.closest("th");
        if(!th || th.classList.contains("noclick")) return;
        const key = th.getAttribute("data-sort");
        if(!key) return;
        if(S.sort.key === key) S.sort.dir = (S.sort.dir === "asc" ? "desc" : "asc");
        else { S.sort.key = key; S.sort.dir = "asc"; }
        renderTxnsSelf();
      });
    }

    // ====== Phase 3 hints ======
    function p3Hint(id, text){ const n = el(id); if(n){ n.textContent = text || ""; n.classList.toggle("hidden", !text); } }
    function setPhase3HintAll(msg){
      const text = msg ? ("Phase 3: " + msg) : "";
      p3Hint("tywPhase3Hint_offer", text);
      p3Hint("tywPhase3Hint_market", text);
      p3Hint("tywPhase3Hint_orders", text);
      p3Hint("tywPhase3Hint_sales", text);
    }

    async function ensurePhase3ForTab(tab){
      if(!["offer","market","orders","sales"].includes(tab)) return;
      if(S.p3.ok) return;

      // quick probe: try list mine offers (or market list)
      try{
        await rpcTryCached("p3_offerListMine", P3.offerListMine, {});
        S.p3.ok = true;
        setPhase3HintAll("");
      }catch(e){
        S.p3.ok = false;
        setPhase3HintAll("Market functions not enabled on backend yet.");
      }
    }

    
    // ====== Gift recipients (safe dropdown) ======
    async function ensureGiftUsersLoaded(){
      if(S.giftUsersLoaded) return;
      if(S.giftUsersLoading) return;
      S.giftUsersLoading = true;
      try{
        const res = await rpc("giftUserList", {});
        const users = (res && Array.isArray(res.users)) ? res.users : [];
        S.giftUsers = users;
        S.giftUsersLoaded = true;
        renderGiftUsers();
      }catch(_e){
        // leave empty; user can refresh or re-login
      }finally{
        S.giftUsersLoading = false;
      }
    }

    // ====== Treasures recipients (ALL callsigns, not just active) ======
    async function ensureTreAllUsersLoaded(){
      if(S.treAllUsersLoaded) return;
      if(S.treAllUsersLoading) return;
      S.treAllUsersLoading = true;
      try{
        let out = null;
        try{ out = slbCacheGet_("adminRoster"); }catch(_e){}
        if(!out){
          out = await rpc("adminRoster", {});
          try{ slbCacheSet_("adminRoster", out); }catch(_e2){}
        }
        const rows = (out && Array.isArray(out.roster)) ? out.roster : [];
        const map = new Map();
        rows.forEach(r=>{
          const cs = String((r && (r.callsign||r.cs)) || "").trim().toUpperCase();
          if(!cs) return;
          const name = String((r && (r.displayName||r.name)) || "").trim();
          if(!map.has(cs)) map.set(cs, { callsign: cs, displayName: name });
        });
        S.treAllUsers = Array.from(map.values()).sort((a,b)=> String(a.callsign).localeCompare(String(b.callsign)));
        S.treAllUsersLoaded = true;
      }catch(_e){
        S.treAllUsers = [];
        S.treAllUsersLoaded = true;
      }finally{
        S.treAllUsersLoading = false;
      }
    }

    function renderGiftUsers(){
      const sel = el("tywGiftTo");
      if(!sel) return;
      const me = String(S.callsign||"").trim().toUpperCase();
      const keep = String(sel.value||"").trim().toUpperCase();

      // reset
      sel.innerHTML = "";

      const o0 = document.createElement("option");
      o0.value = "";
      o0.textContent = "Select recipient…";
      sel.appendChild(o0);

      const arr = Array.isArray(S.giftUsers) ? S.giftUsers : [];
      for(const u of arr){
        const cs = String((u && (u.callsign || u.cs)) || "").trim().toUpperCase();
        if(!cs) continue;
        if(cs === me) continue;
        const name = String((u && (u.displayName || u.name)) || "").trim();
        const opt = document.createElement("option");
        opt.value = cs;
        opt.textContent = name ? (name + " — " + cs) : cs;
        sel.appendChild(opt);
      }

      if(keep) sel.value = keep;
    }



    // ====== Bulletin Board (Stickies) ======
    function cssEscape_(s){
      try{
        if(window.CSS && CSS.escape) return CSS.escape(String(s||""));
      }catch(_e){}
      return String(s||"").replace(/[^a-zA-Z0-9_-]/g, "\\$&");
    }

    function boardEls_(){
      return {
        wrap: el("slbBoardWrap"),
        postWrap: el("slbBoardPostWrap"),
        composeToggle: el("slbBoardComposeToggle"),
        msg: el("slbBoardMsg"),
        list: el("slbBoardList"),
        count: el("slbStickyCount"),
        body: el("slbBoardBody"),
        color: el("slbBoardColor"),
        swatches: el("slbBoardSwatches"),
        toType: el("slbBoardToType"),
        toWho: el("slbBoardToWho"),
        toWhoBtn: el("slbBoardPickBtn"),
        pinRow: el("slbBoardAdminRow"),
        pinned: el("slbBoardPinned"),
        noExpire: el("slbBoardNoExpire"),
        postBtn: el("slbBoardPostBtn"),
        refreshBtn: el("slbBoardRefreshBtn"),
        pickerModal: el("slbBoardPickerModal"),
        pickerMask: el("slbBoardPickerMask"),
        pickerTitle: el("slbBoardPickerTitle"),
        pickerList: el("slbBoardPickerList"),
        pickerCancel: el("slbBoardPickerCancel"),
        pickerOk: el("slbBoardPickerOk")
      };
    }

    function boardShowMsg_(text, ok){
      const E = boardEls_();
      if(!E.msg) return;
      E.msg.classList.remove("hidden","good","bad");
      if(ok === true) E.msg.classList.add("good");
      if(ok === false) E.msg.classList.add("bad");
      E.msg.textContent = String(text||"");
    }
    function boardHideMsg_(){
      const E = boardEls_();
      if(!E.msg) return;
      E.msg.classList.add("hidden");
      E.msg.textContent = "";
    }

    function boardEmojiPreset_(){
  // Emoji-only quick reactions (limited set)
  return [
    { key:"ok",    label:"✅", title:"OK / Done" },
    { key:"no",    label:"❌", title:"No" },
    { key:"heart", label:"❤️", title:"Love" },
    { key:"idea",  label:"💡", title:"Idea" }
  ];
}
function boardEmojiLabel_(key, maybeLabel){
  // If backend sends text labels, force emoji icons by key
  const map = {
    "ok":"✅",
    "no":"❌",
    "heart":"❤️",
    "idea":"💡"
  };
  const k = String(key||"");
  const lbl = String(maybeLabel||"");
  if(map[k]) return map[k];
  // fallback: if label looks like an emoji already, keep it
  if(lbl && !/[a-zA-Z]/.test(lbl)) return lbl;
  return "🙂";
}
function hexToRgb_(hex){
  const h = String(hex||"").trim();
  const m = /^#?([0-9a-fA-F]{6})$/.exec(h);
  if(!m) return null;
  const s = m[1];
  const r = parseInt(s.slice(0,2),16);
  const g = parseInt(s.slice(2,4),16);
  const b = parseInt(s.slice(4,6),16);
  return {r,g,b};
}
function isDarkHex_(hex){
  const rgb = hexToRgb_(hex);
  if(!rgb) return false;
  // perceived luminance
  const l = (0.2126*rgb.r + 0.7152*rgb.g + 0.0722*rgb.b) / 255;
  return l < 0.50;
}
function normalizeHex_(hex){
  const h = String(hex||"").trim();
  const m = /^#?([0-9a-fA-F]{6})$/.exec(h);
  if(!m) return "";
  return "#" + m[1].toUpperCase();
}

function boardState_(){
      if(!S.board) S.board = {};
      if(!S.board.preset) S.board.preset = boardEmojiPreset_();
      if(!S.board.pickerSel) S.board.pickerSel = [];
      if(!S.board.toList) S.board.toList = [];
      if(!S.board.toType) S.board.toType = "PUBLIC";
      if(!S.board.loading) S.board.loading = false;
      if(!S.board.lastFetch) S.board.lastFetch = 0;
      if(!Array.isArray(S.board.localNotes)) S.board.localNotes = [];
      if(!Array.isArray(S.board.hideNoteIds)) S.board.hideNoteIds = [];
      if(!S.board._opSeq) S.board._opSeq = 0;
      if(typeof S.board.composeOpen !== "boolean") S.board.composeOpen = false;
      return S.board;
    }

    function boardRenderUsers_(){
      const st = boardState_();
      const E = boardEls_();
      if(!E.pickerList) return;

      const arr = Array.isArray(S.giftUsers) ? S.giftUsers : [];
      const me = String(S.callsign||"").trim().toUpperCase();

      const selSet = new Set((st.pickerSel||[]).map(x=>String(x||"").toUpperCase()));

      E.pickerList.innerHTML = "";
      if(!arr.length){
        const div = document.createElement("div");
        div.style.padding = "10px";
        div.style.color = "var(--muted)";
        div.textContent = "No users loaded yet. Try Refresh.";
        E.pickerList.appendChild(div);
        return;
      }

      for(const u of arr){
        const cs = String((u && (u.callsign || u.cs)) || "").trim().toUpperCase();
        if(!cs || cs === me) continue;
        const name = String((u && (u.displayName || u.name)) || "").trim();
        const row = document.createElement("label");
        row.className = "slbBoardPickRow";
        const cb = document.createElement("input");
        cb.type = "checkbox";
        cb.value = cs;
        cb.checked = selSet.has(cs);
        const span = document.createElement("span");
        span.innerHTML = `<b>${escapeHtml(cs)}</b>`;
        row.appendChild(cb);
        row.appendChild(span);
        E.pickerList.appendChild(row);
      }
    }

    function boardOpenPicker_(mode){
      const st = boardState_();
      const E = boardEls_();
      if(!E.pickerModal || !E.pickerMask) return;

      st.pickerMode = mode; // "DIRECT" or "GROUP"

      if(E.pickerTitle){
        E.pickerTitle.textContent = mode === "DIRECT" ? "Pick 1 person" : "Pick people";
      }

      // seed selection from current toList
      st.pickerSel = Array.isArray(st.toList) ? st.toList.slice(0) : [];
      boardRenderUsers_();

      E.pickerMask.classList.add("show");
      E.pickerModal.classList.add("show");
    }

    function boardClosePicker_(){
      const E = boardEls_();
      if(!E.pickerModal || !E.pickerMask) return;
      E.pickerMask.classList.remove("show");
      E.pickerModal.classList.remove("show");
    }

    function boardApplyPicker_(){
      const st = boardState_();
      const E = boardEls_();
      if(!E.pickerList) return;

      const chosen = [];
      E.pickerList.querySelectorAll("input[type=checkbox]").forEach(cb => {
        if(cb.checked){
          const cs = String(cb.value||"").trim().toUpperCase();
          if(cs) chosen.push(cs);
        }
      });

      if(st.pickerMode === "DIRECT"){
        st.toList = chosen.slice(0,1);
        st.toType = "DIRECT";
      }else{
        st.toList = chosen.slice(0,20);
        st.toType = "GROUP";
      }

      // reflect UI
      if(E.toType) E.toType.value = st.toType;
      boardSyncToWhoUI_();
      boardSetComposeOpen_(false);
      boardBindColorUI_();

      boardClosePicker_();
    }

    function boardSyncToWhoUI_(){
      const st = boardState_();
      const E = boardEls_();
      if(!E.toWho) return;

      const arr = Array.isArray(st.toList) ? st.toList : [];
      if(st.toType === "PUBLIC"){
        E.toWho.value = "Everyone";
        E.toWho.disabled = true;
        if(E.toWhoBtn) E.toWhoBtn.classList.add("hidden");
        return;
      }
      E.toWho.disabled = true; // always read-only; pick via button
      if(E.toWhoBtn) E.toWhoBtn.classList.remove("hidden");

      if(st.toType === "DIRECT"){
        const cs = arr[0] ? String(arr[0]).toUpperCase() : "";
        if(!cs){ E.toWho.value = "Pick someone…"; return; }
        const u = (Array.isArray(S.giftUsers)?S.giftUsers:[]).find(x => String((x.callsign||x.cs)||"").toUpperCase() === cs);
        const nm = u ? String(u.displayName||u.name||cs) : cs;
        E.toWho.value = cs + (nm && nm !== cs ? (" — " + nm) : "");
        return;
      }

      // GROUP
      const n = arr.length;
      E.toWho.value = n ? (n + " people selected") : "Pick people…";
    }

    function boardToTypeChanged_(){
      const st = boardState_();
      const E = boardEls_();
      if(!E.toType) return;

      const v = String(E.toType.value || "PUBLIC").toUpperCase();
      if(v === "PUBLIC"){
        st.toType = "PUBLIC";
        st.toList = [];
        boardSyncToWhoUI_();
        return;
      }

      // Ensure user list loaded
      ensureGiftUsersLoaded().then(() => {
        if(v === "DIRECT"){
          st.toType = "DIRECT";
          if(!Array.isArray(st.toList) || st.toList.length !== 1){
            st.toList = [];
            boardOpenPicker_("DIRECT");
          }else{
            boardSyncToWhoUI_();
          }
        }else{
          st.toType = "GROUP";
          if(!Array.isArray(st.toList) || st.toList.length < 1){
            st.toList = [];
            boardOpenPicker_("GROUP");
          }else{
            boardSyncToWhoUI_();
          }
        }
      }).catch(()=>{});
    }

    
function boardSetComposeOpen_(open){
  const st = boardState_();
  const E = boardEls_();
  const on = !!open;
  st.composeOpen = on;
  if(E.postWrap){
    if(on) E.postWrap.classList.remove("slbCollapsed");
    else E.postWrap.classList.add("slbCollapsed");
  }
  if(E.composeToggle){
    const lab = E.composeToggle.querySelector && E.composeToggle.querySelector("[data-compose-label]");
    if(lab) lab.textContent = on ? "Hide" : "Write";
    else E.composeToggle.textContent = on ? "Hide" : "Write";
  }
}

function boardSetColor_(hex){
  const E = boardEls_();
  const st = boardState_();
  const h = normalizeHex_(hex);
  if(h){
    st.color = h;
    if(E.color) E.color.value = h;
  }
  // update swatch highlight
  if(E.swatches){
    E.swatches.querySelectorAll("button.slbSwatch").forEach(b=>{
      const c = normalizeHex_(b.getAttribute("data-color"));
      if(c && c === normalizeHex_(st.color)) b.classList.add("on");
      else b.classList.remove("on");
    });
  }
}

function boardBindColorUI_(){
  const st = boardState_();
  const E = boardEls_();
  if(!E.color) return;
  // seed default
  if(!st.color) st.color = normalizeHex_(E.color.value) || "#FFF1A8";
  boardSetColor_(st.color);

  if(E.color && !E.color.__bound){
    E.color.__bound = true;
    E.color.addEventListener("input", ()=>{ boardSetColor_(E.color.value); });
    E.color.addEventListener("change", ()=>{ boardSetColor_(E.color.value); });
  }
  if(E.swatches && !E.swatches.__bound){
    E.swatches.__bound = true;
    E.swatches.querySelectorAll("button.slbSwatch").forEach(b=>{
      b.addEventListener("click", (ev)=>{
        ev.preventDefault();
        const c = b.getAttribute("data-color");
        if(c) boardSetColor_(c);
      });
    });
  }
}

function boardInitOnce_(){
      const st = boardState_();
      // SWR cache: render cached stickies instantly
      try{
        const cached = slbCacheGet_("boardList", 7*24*60*60*1000) || slbCacheGet_("boardList");
        if(cached && typeof cached === "object"){
          if(cached.preset && Array.isArray(cached.preset)) st.preset = cached.preset;
          // Render cached notes if any
          if(Array.isArray(cached.notes)) boardRenderNotes_(cached);
        }
      }catch(_e){}
      if(st.bound) return true;

      const E = boardEls_();
      // Do not permanently mark the Board as bound before its real Overview markup exists.
      if(!E.wrap || !E.list) return false;
      st.bound = true;

      // Role-based admin row (admin+mod)
      if(E.pinRow) show(E.pinRow, !!S.isAdminOrMod);

      if(E.toType){
        E.toType.addEventListener("change", boardToTypeChanged_);
      }
      if(E.toWhoBtn){
        E.toWhoBtn.addEventListener("click", (e) => {
          e.preventDefault();
          const v = String((E.toType && E.toType.value) || "PUBLIC").toUpperCase();
          if(v === "DIRECT") boardOpenPicker_("DIRECT");
          else if(v === "GROUP") boardOpenPicker_("GROUP");
        });
      }

      if(E.pickerCancel) E.pickerCancel.addEventListener("click", (e)=>{ e.preventDefault(); boardClosePicker_(); });
      if(E.pickerMask) E.pickerMask.addEventListener("click", ()=>{ boardClosePicker_(); });
      if(E.pickerOk) E.pickerOk.addEventListener("click", (e)=>{ e.preventDefault(); boardApplyPicker_(); });

      if(E.refreshBtn) E.refreshBtn.addEventListener("click", (e)=>{ e.preventDefault(); boardRefresh_(true); });

      if(E.postBtn) E.postBtn.addEventListener("click", (e)=>{ e.preventDefault(); boardPostNow_(); });


// compose toggle (list first, write later)
if(E.composeToggle){
  E.composeToggle.addEventListener("click", (e)=>{
    e.preventDefault();
    boardSetComposeOpen_(!S.board.composeOpen);
  });
}

// color picker
boardBindColorUI_();


      // default UI
      if(E.toType){
        const cur = String(st.toType||"PUBLIC").toUpperCase();
        E.toType.value = cur;
      }
      boardSyncToWhoUI_();
      return true;
    }

    
    
    // ====== Immortal Message Board: Optimistic UI helpers (instant UI, backend sync after) ======
    function boardMakeReqId_(prefix){
      const st = boardState_();
      try{ st._opSeq = (st._opSeq||0) + 1; }catch(_e){}
      return (prefix||"b") + "_" + Date.now() + "_" + Math.random().toString(16).slice(2) + "_" + (st._opSeq||0);
    }

    function boardIsRetryableErr_(e){
      const msg = String((e && (e.message||e)) || "").toLowerCase();
      if(!msg) return false;
      if(msg.indexOf("timeout") >= 0) return true;
      if(msg.indexOf("script load failed") >= 0) return true;
      if(msg.indexOf("failed to fetch") >= 0) return true;
      if(msg.indexOf("network") >= 0) return true;
      if(msg.indexOf("offline") >= 0) return true;
      return false;
    }

    function boardSendWithRetry_(action, args, opts){
      const requestId = (opts && opts.requestId) ? String(opts.requestId) : boardMakeReqId_("op");
      const maxAttempts = (opts && opts.maxAttempts) ? Number(opts.maxAttempts) : 3;
      const baseDelay = (opts && opts.baseDelayMs) ? Number(opts.baseDelayMs) : 600;
      let attempt = 0;

      const doTry = () => {
        attempt++;
        return rpc(action, args, { requestId }).catch(err => {
          if(attempt < maxAttempts && boardIsRetryableErr_(err)){
            const d = baseDelay * Math.pow(2, attempt-1) + Math.floor(Math.random()*250);
            return new Promise(res => setTimeout(res, d)).then(doTry);
          }
          throw err;
        });
      };
      return doTry();
    }

    function boardIsTmpId_(id){
      return /^tmp_/i.test(String(id||""));
    }

    function boardToLabelFrom_(toType, toList){
      const t = String(toType||"PUBLIC").toUpperCase();
      const arr = Array.isArray(toList) ? toList : [];
      if(t === "PUBLIC") return "Everyone";
      if(t === "DIRECT"){
        const cs = arr[0] ? String(arr[0]).toUpperCase() : "";
        if(!cs) return "Direct";
        const u = (Array.isArray(S.giftUsers)?S.giftUsers:[]).find(x => String((x.callsign||x.cs)||"").toUpperCase() === cs);
        const nm = u ? String(u.displayName||u.name||cs) : cs;
        return "To " + cs + (nm && nm !== cs ? (" — " + nm) : "");
      }
      const n = arr.length;
      return n ? ("To " + n + " people") : "Group";
    }

    function boardSetCardBg_(card, bg){
      const c = normalizeHex_(bg||"");
      if(!c) return;
      try{
        card.style.setProperty("background", c, "important");
        card.style.setProperty("background-color", c, "important");
      }catch(_e){
        card.style.backgroundColor = c;
      }
      const dark = isDarkHex_(c);
      card.style.setProperty("--slbStickyText", dark ? "#fff" : "#111");
      card.style.setProperty("--slbStickyMuted", dark ? "rgba(255,255,255,.78)" : "rgba(15,21,23,.65)");
      card.style.borderColor = dark ? "rgba(255,255,255,.22)" : "rgba(15,21,23,.16)";
    }

    function boardApplyReactToggleUI_(card, prevKey, newKey){
      const allBtns = Array.from(card.querySelectorAll("button.emojiBtn"));
      const getCount = (b)=>{
        const t = (b.querySelector(".c") && b.querySelector(".c").textContent) || "";
        const n = parseInt(String(t).trim(), 10);
        return isFinite(n) ? n : 0;
      };
      const setCount = (b, v)=>{
        const cEl = b.querySelector(".c");
        if(!cEl) return;
        const n = Math.max(0, Number(v||0));
        cEl.textContent = n > 0 ? String(n) : "";
      };

      if(prevKey){
        const prevBtn = allBtns.find(b=>String(b.getAttribute("data-emoji")||"") === prevKey);
        if(prevBtn && (!newKey || newKey !== prevKey)){
          setCount(prevBtn, getCount(prevBtn) - 1);
          prevBtn.classList.remove("on");
        }
      }
      if(newKey){
        const newBtn = allBtns.find(b=>String(b.getAttribute("data-emoji")||"") === newKey);
        if(newBtn){
          if(!prevKey || prevKey !== newKey) setCount(newBtn, getCount(newBtn) + 1);
        }
        allBtns.forEach(b=>{
          b.classList.toggle("on", String(b.getAttribute("data-emoji")||"") === newKey);
        });
      }else{
        allBtns.forEach(b=>b.classList.remove("on"));
      }
    }

    function boardBuildStickyCard_(n, preset){
      const st = boardState_();
      const noteId = String(n.noteId||"").trim();
      const isTmp = boardIsTmpId_(noteId);
      const state = String(n.__state||""); // "pending" | "failed" | ""

      const from = escapeHtml(String(n.fromCallsign||n.fromName||""));
      const when = escapeHtml(fmtShortDate_(n.createdAt||"") || String(n.createdAt||""));
      const toLabel = escapeHtml(String(n.toLabel||""));
      const body = escapeHtml(String(n.body||"")).replace(/\n/g,"<br>");

      const canDelete = !!n.canDelete;
      const my = String(n.myReaction||"");
      const counts = (n.reactions && typeof n.reactions==="object") ? n.reactions : {};

      const disableReacts = (state === "pending") || isTmp;

      const chips = preset.map(p => {
        const key = String(p.key||"");
        const icon = boardEmojiLabel_(key, p.label);
        const c = Number(counts[key]||0);
        const on = (my === key);
        return `
          <button class="emojiBtn ${on?"on":""}" data-nid="${escapeHtml(noteId)}" data-emoji="${escapeHtml(key)}" type="button" title="${escapeHtml(String(p.title||key))}" ${disableReacts?'disabled':''}>
            <span class="e">${escapeHtml(icon)}</span>
            <span class="c">${c?escapeHtml(String(c)):""}</span>
          </button>
        `;
      }).join("");

      const statePill = (state === "pending") ? `<span class="pill slbStickyState syncing">Syncing…</span>`
                       : (state === "failed") ? `<button class="pill slbStickyState retry" data-post-retry="${escapeHtml(noteId)}" type="button" title="Retry">Retry</button>`
                       : "";

      let delBtn = "";
      if(state === "pending"){
        delBtn = `<button class="iconBtnDel" type="button" disabled title="Syncing…">✕</button>`;
      }else if(isTmp){
        delBtn = `<button class="iconBtnDel" data-discard="${escapeHtml(noteId)}" type="button" title="Remove">✕</button>`;
      }else if(canDelete){
        delBtn = `<button class="iconBtnDel" data-del="${escapeHtml(noteId)}" type="button" title="Delete">✕</button>`;
      }

      const pinned = n.pinned ? `<span class="pill on">PIN</span>` : "";

      const card = document.createElement("div");
      card.className = "slbSticky" + (state ? (" slbSticky_" + state) : "");
      card.setAttribute("data-noteid", noteId);

      const bg = normalizeHex_(n.bgColor || n.color || "");
      if(bg) boardSetCardBg_(card, bg);

      card.innerHTML = `
        <div class="slbStickyTop">
          <div class="slbStickyMeta">
            <div class="slbStickyFrom"><b>${from}</b> ${pinned}</div>
            <div class="slbStickyTo">${toLabel}</div>
          </div>
          <div class="slbStickyRight">
            ${statePill}
            <div class="slbStickyWhen">${when}</div>
            ${delBtn}
          </div>
        </div>
        <div class="slbStickyBody">${body}</div>
        <div class="slbStickyReact">${chips}</div>
      `;

      // ===== retry for failed posts =====
      const retry = card.querySelector("button[data-post-retry]");
      if(retry){
        retry.addEventListener("click", (e)=>{
          e.preventDefault();
          const id = retry.getAttribute("data-post-retry");
          const note = (Array.isArray(st.localNotes)?st.localNotes:[]).find(x => String(x.noteId||"") === String(id||""));
          if(!note) return;
          if(note.__state !== "failed") return;

          note.__state = "pending";
          note.createdAt = "Syncing…";

          // quick re-render in place
          try{
            const curEl = note.__el || card;
            const newEl = boardBuildStickyCard_(note, preset);
            note.__el = newEl;
            curEl.replaceWith(newEl);
          }catch(_e){}

          const rid = String(note.__requestId||"") || boardMakeReqId_("bp");
          note.__requestId = rid;
          const postArgs = note.__postArgs || {};

          boardSendWithRetry_(ACTIONS.boardPost, postArgs, { requestId: rid, maxAttempts: 3 }).then(res=>{
            if(!res || !res.noteId) throw new Error("Post failed.");
            note.noteId = String(res.noteId);
            note.createdAt = String(res.createdAt||"");
            note.__state = "";
            note.canDelete = 1;

            try{
              const curEl = note.__el;
              const doneEl = boardBuildStickyCard_(note, preset);
              note.__el = doneEl;
              if(curEl) curEl.replaceWith(doneEl);
            }catch(_e){}
          }).catch(err=>{
            note.__state = "failed";
            note.createdAt = "Not sent";
            try{
              const curEl = note.__el;
              const failEl = boardBuildStickyCard_(note, preset);
              note.__el = failEl;
              if(curEl) curEl.replaceWith(failEl);
            }catch(_e){}
            boardShowMsg_(err.message||String(err), false);
          });
        });
      }

      // ===== reactions (optimistic) =====
      card.querySelectorAll("button.emojiBtn").forEach(btn => {
        btn.addEventListener("click", async () => {
          if(disableReacts) return;

          const nid = btn.getAttribute("data-nid");
          const ek = btn.getAttribute("data-emoji");
          if(!nid || !ek) return;

          if(card.__reactInFlight) return;
          card.__reactInFlight = true;

          const allBtns = Array.from(card.querySelectorAll("button.emojiBtn"));
          const prevBtn = allBtns.find(b=>b.classList.contains("on"));
          const prevKey = prevBtn ? String(prevBtn.getAttribute("data-emoji")||"") : "";

          let newKey = String(ek);
          if(prevKey && prevKey === String(ek)) newKey = "";

          const snap = allBtns.map(b => ({
            key: String(b.getAttribute("data-emoji")||""),
            on: b.classList.contains("on"),
            c: (b.querySelector(".c") && b.querySelector(".c").textContent) || ""
          }));

          boardApplyReactToggleUI_(card, prevKey, newKey);
          allBtns.forEach(b=>{ try{ b.disabled = true; }catch(_e){} });

          const rid = boardMakeReqId_("br");
          try{
            await boardSendWithRetry_(ACTIONS.boardReact, { noteId:nid, emojiKey: ek }, { requestId: rid, maxAttempts: 2 });
          }catch(err){
            try{
              for(const s of snap){
                const b = allBtns.find(x=>String(x.getAttribute("data-emoji")||"")===s.key);
                if(!b) continue;
                b.classList.toggle("on", !!s.on);
                const cEl = b.querySelector(".c");
                if(cEl) cEl.textContent = String(s.c||"");
              }
            }catch(_e){}
            boardShowMsg_(err.message||String(err), false);
          }finally{
            allBtns.forEach(b=>{ try{ b.disabled = false; }catch(_e){} });
            card.__reactInFlight = false;
          }
        });
      });

      // ===== delete (optimistic) =====
      const del = card.querySelector("button[data-del]");
      if(del){
        del.addEventListener("click", async () => {
          const nid = del.getAttribute("data-del");
          if(!nid) return;
          if(!confirm("Delete this sticky?")) return;

          const E = boardEls_();

          try{
            if(Array.isArray(st.hideNoteIds) && st.hideNoteIds.indexOf(nid) < 0) st.hideNoteIds.push(nid);
          }catch(_e){}

          try{ card.classList.add("slbStickyRemoving"); }catch(_e){}
          try{ setTimeout(()=>{ try{ card.remove(); }catch(_e){} }, 160); }catch(_e){}

          try{
            if(E && E.count){
              const cur = parseInt(String(E.count.textContent||"0"),10);
              if(isFinite(cur) && cur > 0) E.count.textContent = String(cur - 1);
            }
          }catch(_e){}

          try{
            if(E && E.list){
              setTimeout(()=>{
                try{
                  if(!E.list.children || E.list.children.length === 0){
                    E.list.innerHTML = `<div class="note" style="margin-top:10px;color:var(--muted);">No stickies right now.</div>`;
                  }
                }catch(_e){}
              }, 180);
            }
          }catch(_e){}

          const rid = boardMakeReqId_("bd");
          try{
            await boardSendWithRetry_(ACTIONS.boardDelete, { noteId:nid }, { requestId: rid, maxAttempts: 2 });
            try{
              const idx = Array.isArray(st.hideNoteIds) ? st.hideNoteIds.indexOf(nid) : -1;
              if(idx >= 0) st.hideNoteIds.splice(idx,1);
            }catch(_e){}
          }catch(err){
            try{
              const idx = Array.isArray(st.hideNoteIds) ? st.hideNoteIds.indexOf(nid) : -1;
              if(idx >= 0) st.hideNoteIds.splice(idx,1);
            }catch(_e){}
            boardShowMsg_(err.message||String(err), false);
            try{ boardRefresh_(true); }catch(_e){}
          }
        });
      }

      // remove local (unsent) sticky
      const discard = card.querySelector("button[data-discard]");
      if(discard){
        discard.addEventListener("click", (e)=>{
          e.preventDefault();
          const nid = discard.getAttribute("data-discard");
          if(!nid) return;
          if(!confirm("Remove this sticky?")) return;

          try{
            st.localNotes = (Array.isArray(st.localNotes)?st.localNotes:[]).filter(x => String(x.noteId||"") !== String(nid));
          }catch(_e){}

          try{ card.remove(); }catch(_e){}

          try{
            const E = boardEls_();
            if(E && E.count){
              const cur = parseInt(String(E.count.textContent||"0"),10);
              if(isFinite(cur) && cur > 0) E.count.textContent = String(cur - 1);
            }
          }catch(_e){}
        });
      }

      return card;
    }

    function boardRenderNotes_(payload){
      const st = boardState_();
      const E = boardEls_();

      if(payload && payload.preset && Array.isArray(payload.preset) && payload.preset.length){
        st.preset = payload.preset;
      }
      const preset = st.preset || boardEmojiPreset_();

      if(E.presetHint) E.presetHint.textContent = preset.map(x=>x.label).join(" ");

      const serverNotes = (payload && Array.isArray(payload.notes)) ? payload.notes : [];

      // Hide notes that are currently pending-delete (optimistic delete)
      const hidden = Array.isArray(st.hideNoteIds) ? st.hideNoteIds : [];
      const serverFiltered = hidden.length
        ? serverNotes.filter(n => hidden.indexOf(String(n.noteId||"")) < 0)
        : serverNotes.slice();

      // Drop local notes that are already present in server list (avoid duplicates)
      const local = Array.isArray(st.localNotes) ? st.localNotes : [];
      const serverIdSet = new Set(serverFiltered.map(n=>String(n.noteId||"")));

      if(local.length){
        st.localNotes = local.filter(n=>{
          const nid = String(n.noteId||"");
          if(boardIsTmpId_(nid)) return true;
          const state = String(n.__state||"");
          if(state) return true; // keep pending/failed markers
          return !serverIdSet.has(nid);
        });
      }

      const local2 = Array.isArray(st.localNotes) ? st.localNotes : [];
      const localIdSet = new Set(local2.map(n=>String(n.noteId||"")));
      const merged = local2.concat(serverFiltered.filter(n => !localIdSet.has(String(n.noteId||""))));

      if(E.count) E.count.textContent = String(merged.length);

      const frag = document.createDocumentFragment();
      if(!merged.length){
        const empty = document.createElement("div");
        empty.className = "note";
        empty.style.marginTop = "10px";
        empty.style.color = "var(--muted)";
        empty.textContent = "No stickies right now.";
        frag.appendChild(empty);
      }else{
        for(const n0 of merged){
          const n = n0 || {};
          const card = boardBuildStickyCard_(n, preset);
          if(n && n.__local) n.__el = card;
          frag.appendChild(card);
        }
      }

      E.list.replaceChildren(frag);
      try{ E.list.__hasLoaded = true; }catch(_e){}
    }

    async function boardRefresh_(force){
      const st = boardState_();
      boardInitOnce_();

      const E = boardEls_();
      if(!E.wrap) return;
      if(!S || !S.token) return;

      const now = Date.now();
      if(!force && st.lastFetch && (now - st.lastFetch) < 6000) return;
      st.lastFetch = now;

      if(st.loading) return;
      st.loading = true;
      try{ if(E.wrap) E.wrap.classList.add("slbBoardLoading"); }catch(_e){}

      try{
        boardHideMsg_();
        if(E.list){
          // Keep existing stickies visible while fetching (no flicker)
          if(!E.list.__hasLoaded){
            E.list.innerHTML = `<div class="note" style="margin-top:10px;color:var(--muted);">Loading stickies…</div>`;
          }
        }
        await ensureGiftUsersLoaded().catch(()=>{});
        const payload = await rpc(ACTIONS.boardList, {});
        try{ slbCacheSet_("boardList", payload || {}); }catch(_e){}
        if(payload && payload.preset && Array.isArray(payload.preset)) st.preset = payload.preset;
        boardRenderNotes_(payload || {});
      }catch(e){
        boardShowMsg_(e.message || String(e), false);
      }finally{
        try{ if(E.wrap) E.wrap.classList.remove("slbBoardLoading"); }catch(_e){}
        st.loading = false;
      }
    }

    async function boardPostNow_(){
      const st = boardState_();
      const E = boardEls_();

      const body = String(E.body && E.body.value || "").trim();
      if(!body){
        boardShowMsg_("Write something first.", false);
        return;
      }
      if(body.length > 1000){
        boardShowMsg_("Too long (max 1000 characters).", false);
        return;
      }

      const toType = String(st.toType||"PUBLIC");
      const toList = Array.isArray(st.toList) ? st.toList.slice() : [];

      if(toType === "DIRECT" && !toList.length){
        boardShowMsg_("Pick 1 person for Direct.", false);
        return;
      }
      if(toType === "GROUP" && toList.length < 2){
        boardShowMsg_("Pick 2+ people for Group.", false);
        return;
      }

      const pinned = !!(E.pinned && E.pinned.checked);
      const noExpire = !!(E.noExpire && E.noExpire.checked);
      const bgColor = normalizeHex_(st.color || "#FFF1A8") || "#FFF1A8";

      let unlockPostBtn = null;
      try{ unlockPostBtn = lockBtn(E.postBtn); setTimeout(()=>{ try{ if(unlockPostBtn) unlockPostBtn(); }catch(_e){} }, 500); }catch(_e){}

      // ===== Optimistic: show sticky instantly =====
      const requestId = boardMakeReqId_("bp");
      const tmpId = "tmp_" + requestId;

      const note = {
        __local: 1,
        __state: "pending",
        __requestId: requestId,
        __postArgs: { body, toType, toList, pinned, noExpire, bgColor },
        noteId: tmpId,
        fromCallsign: String(S.callsign||""),
        toLabel: boardToLabelFrom_(toType, toList),
        createdAt: "Syncing…",
        body,
        pinned,
        bgColor,
        reactions: {},
        myReaction: "",
        canDelete: 0
      };

      if(!Array.isArray(st.localNotes)) st.localNotes = [];
      st.localNotes.unshift(note);

      const preset = st.preset || boardEmojiPreset_();
      const card = boardBuildStickyCard_(note, preset);
      note.__el = card;

      try{
        // remove "No stickies" placeholder if present
        if(E.list){
          const hasStickies = !!E.list.querySelector(".slbSticky");
          if(!hasStickies){
            const ph = E.list.querySelector(".note");
            if(ph) ph.remove();
          }
          E.list.prepend(card);
        }
        if(E.count){
          const cur = parseInt(String(E.count.textContent||"0"),10);
          E.count.textContent = String(isFinite(cur) ? (cur + 1) : 1);
        }
      }catch(_e){}

      // clear composer immediately (feels instant)
      try{ E.body.value = ""; }catch(_e){}
      try{ boardHideMsg_(); }catch(_e){}

      // ===== Backend sync (retry) =====
      boardSendWithRetry_(ACTIONS.boardPost, note.__postArgs, { requestId, maxAttempts: 3 }).then(res=>{
        if(!res || !res.noteId) throw new Error("Post failed.");
        note.noteId = String(res.noteId);
        note.createdAt = String(res.createdAt||"");
        note.__state = "";
        note.canDelete = 1;

        // re-render in place with real noteId
        try{
          const curEl = note.__el;
          const doneEl = boardBuildStickyCard_(note, preset);
          note.__el = doneEl;
          if(curEl) curEl.replaceWith(doneEl);
        }catch(_e){}
      }).catch(err=>{
        note.__state = "failed";
        note.__error = (err && (err.message||err)) ? String(err.message||err) : "";
        note.createdAt = "Not sent";

        try{
          const curEl = note.__el;
          const failEl = boardBuildStickyCard_(note, preset);
          note.__el = failEl;
          if(curEl) curEl.replaceWith(failEl);
        }catch(_e){}

        boardShowMsg_(err.message||String(err), false);
      });
    }



// ====== Treasures (Personal Storage Box) ======
    function treState_(){
      S.tre = S.tre || { bound:false, items:[], lastFetch:0, lastAttempt:0, loading:false, loadPromise:null, loadedOnce:false, lastError:"", lastResult:null, editId:"", selId:"", q:"" };
      return S.tre;
    }
    function treEls_(){
      return {
        title: el("slbTreTitle"),
        catSel: el("slbTreCatSel"),
        catCustomBox: el("slbTreCatCustomBox"),
        catCustom: el("slbTreCatCustom"),
        tags: el("slbTreTags"),
        bodyRich: el("slbTreBodyRich"),
        saveBtn: el("slbTreSaveBtn"),
        reloadBtn: el("slbTreReload"),
        exportBtn: el("slbTreExportBtn"),
        count: el("slbTreCount"),
        msg: el("slbTreMsg"),
        ok: el("slbTreOk"),
        search: el("slbTreSearch"),
        list: el("slbTreList"),
        viewBox: el("slbTreViewBox"),
        viewTitle: el("slbTreViewTitle"),
        viewMeta: el("slbTreViewMeta"),
        viewBody: el("slbTreViewBody"),
        viewRefreshBtn: el("slbTreViewRefresh"),
        viewEditBtn: el("slbTreViewEdit"),
        viewDeleteBtn: el("slbTreViewDelete"),
        writeCard: el("slbTreWriteCard"),
        editing: el("slbTreEditing")
      };
    }

    const TRE_CELL_MAX_CHARS = 45000;
    function treUpdateCount_(E){
      try{
        E = E || treEls_();
        if(!E || !E.count) return;
        const meta = treCatTagsFromForm_(E.catSel, E.catCustom, E.tags);
        const bodyHtml = String(E.bodyRich && E.bodyRich.innerHTML || '').trim();
        const content = trePackBody_(bodyHtml, meta.cat, meta.tags);
        const len = content.length;
        const left = TRE_CELL_MAX_CHARS - len;
        E.count.textContent = String(len) + ' / ' + String(TRE_CELL_MAX_CHARS);
        try{ E.count.title = (left >= 0) ? (String(left) + ' left') : (String(-left) + ' over limit'); }catch(_e){}
      }catch(_e){}
    }

    function treAdmEls_(){
      return {
        targets: el("slbAdmTreTargets"),
        pickBtn: el("slbAdmTrePickBtn"),
        pickPanel: el("slbAdmTrePickPanel"),
        pickSearch: el("slbAdmTrePickSearch"),
        pickAll: el("slbAdmTrePickAll"),
        pickList: el("slbAdmTrePickList"),
        pickClose: el("slbAdmTrePickClose"),
        title: el("slbAdmTreTitle"),
        size: el("slbAdmTreSize"),
        mode: el("slbAdmTreMode"),
        catSel: el("slbAdmTreCatSel"),
        catCustomBox: el("slbAdmTreCatCustomBox"),
        catCustom: el("slbAdmTreCatCustom"),
        tags: el("slbAdmTreTags"),
        textBox: el("slbAdmTreTextBox"),
        linkBox: el("slbAdmTreLinkBox"),
        // rich editor area (Standard Editor V1)
        bodyRich: el("slbAdmTreBodyRich"),
        // legacy textarea id may not exist anymore; keep for backwards safety
        content: el("slbAdmTreContent"),
        link: el("slbAdmTreLink"),
        saveBtn: el("slbAdmTreSaveBtn"),
        sendBtn: el("slbAdmTreSendBtn"),
        sendAllBtn: el("slbAdmTreSendAllBtn"),
        status: el("slbAdmTreStatus"),
        msg: el("slbAdmTreMsg"),
        ok: el("slbAdmTreOk")
      };
    }

    function treAdmViewEls_(){
      return {
        target: el("slbAdmTreViewTarget"),
        pickBtn: el("slbAdmTreViewPickBtn"),
        pickPanel: el("slbAdmTreViewPickPanel"),
        pickSearch: el("slbAdmTreViewPickSearch"),
        pickList: el("slbAdmTreViewPickList"),
        pickClose: el("slbAdmTreViewPickClose"),
        loadBtn: el("slbAdmTreViewLoadBtn"),
        exportBtn: el("slbAdmTreViewExportBtn"),
        count: el("slbAdmTreViewCount"),
        body: el("slbAdmTreViewBody"),
        msg: el("slbAdmTreViewMsg"),
        ok: el("slbAdmTreViewOk"),
        editBox: el("slbAdmTreEditBox"),
        editTitle: el("slbAdmTreEditTitle"),
        editSize: el("slbAdmTreEditSize"),
        editMode: el("slbAdmTreEditMode"),
        editCatSel: el("slbAdmTreEditCatSel"),
        editCatCustomBox: el("slbAdmTreEditCatCustomBox"),
        editCatCustom: el("slbAdmTreEditCatCustom"),
        editTags: el("slbAdmTreEditTags"),
        editTextBox: el("slbAdmTreEditTextBox"),
        editLinkBox: el("slbAdmTreEditLinkBox"),
        // rich editor area (Standard Editor V1)
        editBodyRich: el("slbAdmTreEditBodyRich"),
        editContent: el("slbAdmTreEditContent"),
        editLink: el("slbAdmTreEditLink"),
        editSave: el("slbAdmTreEditSaveBtn"),
        editCancel: el("slbAdmTreEditCancelBtn"),
        editDelete: el("slbAdmTreEditDeleteBtn"),
        editId: el("slbAdmTreEditId"),
        viewBox: el("slbAdmTreViewViewer"),
        viewTitle: el("slbAdmTreViewViewerTitle"),
        viewMeta: el("slbAdmTreViewViewerMeta"),
        viewBody: el("slbAdmTreViewViewerBody"),
        viewClose: el("slbAdmTreViewViewerCloseBtn"),
        viewEdit: el("slbAdmTreViewViewerEditBtn"),
        viewDelete: el("slbAdmTreViewViewerDeleteBtn")
      };
    }

    function treShow_(elx, on){
      if(!elx) return;
      if(on) elx.classList.remove("hidden");
      else elx.classList.add("hidden");
    }
    function treMsg_(ok, text){
      const E = treEls_();
      if(E.msg) { E.msg.textContent = String(text||""); treShow_(E.msg, !ok && !!text); }
      if(E.ok)  { E.ok.textContent  = String(text||""); treShow_(E.ok,  ok && !!text); }
    }
    function treAdmMsg_(ok, text){
      const E = treAdmEls_();
      if(E.msg) { E.msg.textContent = String(text||""); treShow_(E.msg, !ok && !!text); }
      if(E.ok)  { E.ok.textContent  = String(text||""); treShow_(E.ok,  ok && !!text); }
    }

    // ===== Admin Treasures Outbox =====
    function treAdmOutboxEls_(){
      return {
        search: el("slbAdmTreOutboxSearch"),
        reloadBtn: el("slbAdmTreOutboxReloadBtn"),
        count: el("slbAdmTreOutboxCount"),
        body: el("slbAdmTreOutboxBody"),
        msg: el("slbAdmTreOutboxMsg"),
        ok: el("slbAdmTreOutboxOk"),
        viewBox: el("slbAdmTreOutboxViewer"),
        viewTitle: el("slbAdmTreOutboxViewerTitle"),
        viewMeta: el("slbAdmTreOutboxViewerMeta"),
        viewBody: el("slbAdmTreOutboxViewerBody"),
        viewClose: el("slbAdmTreOutboxViewerCloseBtn"),
        viewLoadCompose: el("slbAdmTreOutboxViewerLoadComposeBtn")
      };
    }
    function treAdmOutboxState_(){
      S.treAdmOutbox = S.treAdmOutbox || { items: [], byId:{}, viewId:"", sortKey: "createdAt", sortDir: "desc" };
      return S.treAdmOutbox;
    }
    function treAdmOutboxMsg_(ok, text){
      const E = treAdmOutboxEls_();
      if(E.msg) { E.msg.textContent = String(text||""); treShow_(E.msg, !ok && !!text); }
      if(E.ok)  { E.ok.textContent  = String(text||""); treShow_(E.ok,  ok && !!text); }
    }
    function treTargetLabel_(it){
      if(!it) return "—";
      const tt = String(it.targetType||"").toLowerCase();
      if(tt === "everyone") return "Everyone";
      const list = String(it.targetList||"").trim();
      if(!list) return "List";
      const arr = list.split(",").map(x=>String(x||"").trim()).filter(Boolean);
      if(arr.length <= 1) return arr[0] || "1 user";
      if(arr.length === 2) return arr[0] + ", " + arr[1];
      return arr[0] + " +" + (arr.length-1);
    }
    function treAdmOutboxRender_(){
      const st = treAdmOutboxState_();
      const E = treAdmOutboxEls_();
      if(!E.body) return;
      const tbody = E.body;

      const q = String(E.search && E.search.value || '').trim().toLowerCase();
      st.q = q;

      let list = Array.isArray(st.items) ? st.items.slice() : [];

      // Build lookup
      st.byId = {};
      list.forEach(it=>{
        const id = String(it.outboxId||'');
        if(id) st.byId[id] = it;
      });

      if(q){
        list = list.filter(it => {
          const bodyText = treStripHtmlToText_(treStripMeta_(it.content||''));
          const hay = [
            String(it.title||''),
            String(it.toLabel||''),
            String(it.tags||''),
            bodyText
          ].join(' ').toLowerCase();
          return hay.indexOf(q) >= 0;
        });
      }

      list.sort((a,b)=> String(b.updatedAt||b.createdAt||'').localeCompare(String(a.updatedAt||a.createdAt||'')));
      if(E.count) E.count.textContent = String(list.length);

      tbody.innerHTML = '';
      if(!list.length){
        tbody.innerHTML = '<tr><td colspan="6" class="note" style="padding:10px;">No outbox messages yet.</td></tr>';
        return;
      }

      list.forEach(it=>{
        const sentAt = String(it.updatedAt||'') || String(it.createdAt||'');
        const createdAt = String(it.createdAt||'');
        const sent = sentAt ? treFmtDateTime_(sentAt) : '';
        const created = createdAt ? treFmtDateTime_(createdAt) : '';
        const tags = String(it.tags||'');
        const obId = String(it.outboxId||'');

        const tr = document.createElement('tr');
        tr.className = 'slbTreClickRow';
        tr.setAttribute('data-ob-id', obId);
        tr.innerHTML = ''
          + '<td class="tTitle">' + escapeHtml(String(it.title||'')) + '</td>'
          + '<td>' + escapeHtml(String(it.toLabel||'')) + '</td>'
          + '<td>' + escapeHtml(sent) + '</td>'
          + '<td>' + escapeHtml(tags) + '</td>'
          + '<td>' + escapeHtml(created) + '</td>'
          + '<td><button type="button" class="btn danger mini" data-ob-del="' + escapeHtml(obId) + '">Delete</button></td>';
        tbody.appendChild(tr);
      });
    }

    function treAdmOutboxCloseViewer_(){
      const st = treAdmOutboxState_();
      const E = treAdmOutboxEls_();
      st.viewId = '';
      if(E.viewBox) E.viewBox.classList.add('hidden');
      if(E.viewTitle) E.viewTitle.textContent = '—';
      if(E.viewMeta) E.viewMeta.textContent = '—';
      if(E.viewBody) E.viewBody.innerHTML = '';
    }

    function treAdmOutboxOpenViewerById_(id){
      const st = treAdmOutboxState_();
      const it = st.byId && st.byId[String(id||'')];
      if(!it) return;
      treAdmOutboxOpenViewer_(it);
    }

    function treAdmOutboxOpenViewer_(it){
      const st = treAdmOutboxState_();
      const E = treAdmOutboxEls_();
      if(!it) return;
      st.viewId = String(it.outboxId||'');

      const raw = String(it.content||'');
      const p = treParseMeta_(raw);
      const body = treBodyToHtml_(p.body||'');

      if(E.viewTitle) E.viewTitle.textContent = String(it.title||'') || '—';

      const sentAt = String(it.updatedAt||'') || String(it.createdAt||'');
      const createdAt = String(it.createdAt||'');
      const sent = sentAt ? treFmtDateTime_(sentAt) : '';
      const created = createdAt ? treFmtDateTime_(createdAt) : '';

      const meta = [
        (String(it.toLabel||'') ? ('To: ' + String(it.toLabel||'')) : ''),
        (String(it.tags||'') ? ('Tags: ' + String(it.tags||'')) : ''),
        (sent ? ('Sent: ' + sent) : ''),
        (created ? ('Created: ' + created) : '')
      ].filter(Boolean).join(' | ');

      if(E.viewMeta) E.viewMeta.textContent = meta || '—';
      if(E.viewBody) E.viewBody.innerHTML = body;
      if(E.viewBox) E.viewBox.classList.remove('hidden');
      try{ E.viewBox.scrollIntoView({behavior:'smooth', block:'start'}); }catch(_e){}
    }

    function treAdmOutboxLoadToCompose_(){
      const st = treAdmOutboxState_();
      const E = treAdmOutboxEls_();
      const id = String(st.viewId||'');
      const it = st.byId && st.byId[id];
      if(!it) return;
      const CE = treAdmEls_();
      const raw = String(it.content||'');
      const p = treParseMeta_(raw);

      // Open Compose fold
      try{
        var body = el('slbTreasuryComposeFoldBody');
        var btn = el('slbTreasuryComposeFoldBtn');
        if(body && body.classList.contains('hidden')) body.classList.remove('hidden');
        if(btn) btn.textContent = 'Close';
      }catch(_e){}

      if(CE.title) CE.title.value = String(it.title||'');
      if(CE.tags) CE.tags.value = String(it.tags||p.tags||'');
      if(CE.bodyRich) CE.bodyRich.innerHTML = String(p.body||'');
      try{ (CE.bodyRich||CE.title||E.viewBox).scrollIntoView({behavior:'smooth', block:'start'}); }catch(_e){}
      toast('ok','Loaded to Compose');
    }

    async function treAdmOutboxLoad_(force){
      const st = treAdmOutboxState_();
      const E = treAdmOutboxEls_();
      treAdmOutboxMsg_(true, "");
      if(!S.isAdmin) return treAdmOutboxMsg_(false, "Admin only.");
      const cacheKey = "admTreOutbox_v2fix1";
      if(!force){
        const cached = slbCacheGet_(cacheKey, 1000*60*10);
        if(cached && Array.isArray(cached.items)){
          st.items = cached.items;
          treAdmOutboxRender_();
        }
      }
      const unlock = lockBtn(E.reloadBtn);
      try{
        const payload = await rpc(ACTIONS.adminTreasuresOutboxList, {});
        st.items = Array.isArray(payload && payload.items) ? payload.items : [];
        try{ slbCacheSet_(cacheKey, { items: st.items }); }catch(_e){}
        treAdmOutboxRender_();
        let _m = "Outbox loaded (" + st.items.length + ").";
        if(payload && payload.meta){
          const m = payload.meta;
          if(m.treSsid) _m += " ssid " + String(m.treSsid).slice(0,8) + "…";
          if(m.obLastRow !== undefined) _m += " obRows " + String(m.obLastRow);
          if(m.treLastRow !== undefined) _m += " treRows " + String(m.treLastRow);
        }
        treAdmOutboxMsg_(true, _m);
      }catch(err){
        treAdmOutboxMsg_(false, err && err.message ? err.message : String(err));
      }finally{
        unlock();
      }
    }

    async function treAdmOutboxDeleteEverywhere_(outboxId, btnEl){
      const E = treAdmOutboxEls_();
      treAdmOutboxMsg_(true, "");
      if(!S.isAdmin) return treAdmOutboxMsg_(false, "Admin only.");
      const id = String(outboxId||"").trim();
      if(!id) return treAdmOutboxMsg_(false, "Missing outboxId.");

      if(!confirm("Delete this admin send everywhere?\n\nThis will HARD delete it and remove it from all users' treasure boxes.")) return;

      const st = treAdmOutboxState_();

      // UI lock
      try{ if(btnEl) btnEl.disabled = true; }catch(_e){}
      try{ if(btnEl) btnEl.textContent = "Deleting…"; }catch(_e){}

      // Try HARD delete immediately
      try{
        await rpc(ACTIONS.adminTreasuresOutboxDeleteEverywhere, { outboxId: id, id: id, hard: 1 });

        // Remove locally
        try{
          if(st && Array.isArray(st.items)){
            st.items = st.items.filter(it => String(it.outboxId||"") !== id);
          }
          if(st.byId) delete st.byId[id];
          if(String(st.viewId||"") === id) treAdmOutboxCloseViewer_();
        }catch(_e){}
        treAdmOutboxRender_();
        treAdmOutboxMsg_(true, "Deleted everywhere.");
        try{ bankUpdateStatusUI_(); }catch(_e){}
        return;
      }catch(err){
        // Fallback: queue a retryable op (so you still get deletion eventually)
        try{
          const op = treOpsEnqueueDeleteEverywhere_(id);
          if(op){
            treAdmOutboxMsg_(false, "Hard delete failed. Queued for sync: " + (err && err.message ? err.message : String(err)));
            try{ treRenderQueuePanel_(); }catch(_e){}
            try{ treOpsSyncOp_(op); }catch(_e){}
            return;
          }
        }catch(_e){}
        treAdmOutboxMsg_(false, err && err.message ? err.message : String(err));
      }finally{
        try{ if(btnEl){ btnEl.disabled = false; btnEl.textContent = "Delete"; } }catch(_e){}
      }
    }


    function treAdmOutboxBind_(){
      const E = treAdmOutboxEls_();
      // Robust global capture handler for outbox delete
      try{
        if(!document.__slbTreAdmOutboxDelCap){
          document.__slbTreAdmOutboxDelCap = true;
          document.addEventListener("click", (e)=>{
            const b = e.target && e.target.closest && e.target.closest("button[data-ob-del]");
            if(!b) return;
            // Only activate if Outbox is present on page
            if(!el("slbAdmTreOutboxBody")) return;
            const id = b.getAttribute("data-ob-del");
            if(!id) return;
            try{ e.preventDefault(); e.stopPropagation(); }catch(_e){}
            treAdmOutboxDeleteEverywhere_(id, b);
          }, true);
        }
      }catch(_e){}
      if(!E.body) return;
      if(E.reloadBtn && !E.reloadBtn.__bound){
        E.reloadBtn.__bound = true;
        E.reloadBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmOutboxLoad_(true); });
      }
      if(E.search && !E.search.__bound){
        E.search.__bound = true;
        E.search.addEventListener("input", ()=>{ treAdmOutboxRender_(); });
      }
      if(E.viewClose && !E.viewClose.__bound){
        E.viewClose.__bound = true;
        E.viewClose.addEventListener('click',(e)=>{ e.preventDefault(); treAdmOutboxCloseViewer_(); });
      }
      if(E.viewLoadCompose && !E.viewLoadCompose.__bound){
        E.viewLoadCompose.__bound = true;
        E.viewLoadCompose.addEventListener('click',(e)=>{ e.preventDefault(); treAdmOutboxLoadToCompose_(); });
      }
      if(E.body && !E.body.__bound){
        E.body.__bound = true;
        E.body.addEventListener("click", (e)=>{
          const delBtn = e.target && e.target.closest && e.target.closest("button[data-ob-del]");
          if(delBtn){
            const id = delBtn.getAttribute("data-ob-del");
            if(id) treAdmOutboxDeleteEverywhere_(id, delBtn);
            return;
          }
          const tr = e.target && e.target.closest && e.target.closest("tr[data-ob-id]");
          if(!tr) return;
          const id = tr.getAttribute('data-ob-id');
          if(!id) return;
          treAdmOutboxOpenViewerById_(id);
        });
      }
    }


    function treNormSizeLabel_(s){
      const t = String(s||"").toUpperCase();
      if(t === "S") return "Small";
      if(t === "M") return "Mid";
      if(t === "L") return "Large";
      return t || "—";
    }
    // --- Treasures Meta: Category + Tags stored inside content as hidden first line
    function treMetaClean_(s, max){
      s = String(s||"").trim();
      s = s.replace(/[\r\n\t]+/g, " ");
      s = s.replace(/\s{2,}/g, " ");
      if(max && s.length > max) s = s.slice(0, max);
      return s;
    }
    function treBuildMetaLine_(cat, tags, outbox){
      // category is deprecated; keep signature for backward compatibility
      tags = treMetaClean_(tags, 180);
      outbox = treMetaClean_(outbox, 80);
      const parts = [];
      if(tags) parts.push('tags=' + encodeURIComponent(tags));
      if(outbox) parts.push('outbox=' + encodeURIComponent(outbox));
      if(!parts.length) return '';
      return '[[SLB_META ' + parts.join(' ') + ']]\n';
    }
    // Strip the hidden meta header from a treasure content string.
    // We store category/tags/outboxId as a first-line meta marker, and keep the user-facing body below it.
    function treStripMeta_(raw){
      return treParseMeta_(raw).body || '';
    }

    function treBodyToHtml_(s){
      s = String(s||'');
      const hasTags = /<\/?[a-z][\s\S]*>/i.test(s);
      if(hasTags) return s;
      // treat as plain text
      s = s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      s = s.replace(/\r\n/g,'\n').replace(/\r/g,'\n');
      s = s.replace(/\n/g,'<br/>');
      return '<p>' + s + '</p>';
    }

    function treParseMeta_(raw){
      raw = String(raw||'');
      const out = { cat:'', tags:'', outbox:'', body: raw };
      const m = raw.match(/^\[\[SLB_META\s+([^\]]+)\]\]\n?/);
      if(!m) return out;
      const parts = String(m[1]||'').trim().split(/\s+/).filter(Boolean);
      for(const part of parts){
        const eq = part.indexOf('=');
        if(eq < 0) continue;
        const k = part.slice(0, eq).toLowerCase();
        const v = part.slice(eq+1);
        let dec = v;
        try{ dec = decodeURIComponent(v); }catch(_e){}
        if(k === 'tags') out.tags = dec;
        else if(k === 'outbox') out.outbox = dec;
        else if(k === 'cat' || k === 'category') out.cat = dec; // legacy; ignored elsewhere
      }
      out.body = raw.slice(m[0].length);
      return out;
    }
    function trePackBody_(body, cat, tags, outbox){
      body = String(body||'');
      const parsed = treParseMeta_(body);
      const keepOutbox = treMetaClean_(outbox, 80) || (parsed.outbox||'');
      const cleanBody = (parsed.body !== undefined) ? String(parsed.body||'') : body;
      const meta = treBuildMetaLine_('', tags, keepOutbox);
      return meta + cleanBody;
    }
    function treCatUIBind_(sel, box, input){
      // Category is no longer used. Keep as a harmless no-op.
      try{
        if(box) box.classList.add('hidden');
        if(input) input.value = '';
        if(sel) sel.value = '';
      }catch(_e){}
    }
    function treCatTagsFromForm_(sel, customInput, tagsInput){
      // Category deprecated; only tags remain
      const tags = treMetaClean_(String(tagsInput && tagsInput.value || ''), 180);
      return { cat:'', tags: tags };
    }

    function treFromLabel_(it){
      const by = String(it.createdBy||"").toUpperCase();
      if(by === "ADMIN") return "Admin";
      if(by === "SELF") return "Me";
      if(by) return by;
      return (it.fromCallsign && String(it.fromCallsign).toUpperCase() !== String(S.callsign||"").toUpperCase()) ? "Admin" : "Me";
    }

    function treParseTargets_(raw){
      const arr = String(raw||"")
        .split(/[\s,;]+/g)
        .map(s=>String(s||"").trim().toUpperCase())
        .filter(Boolean);
      // de-dupe
      const seen = new Set();
      const out = [];
      for(const cs of arr){ if(!seen.has(cs)){ seen.add(cs); out.push(cs); } }
      return out.slice(0,200);
    }

    // ===== Admin Treasures recipient picker (checkbox list, like Board vibe) =====
    function treAdmState_(){
      S.treAdm = S.treAdm || { sel:[], all:false };
      if(!Array.isArray(S.treAdm.sel)) S.treAdm.sel = [];
      S.treAdm.all = !!S.treAdm.all;
      return S.treAdm;
    }

    // ===== Admin Treasury compose state =====
    function treAdmComposeState_(){
      S.treAdmCompose = S.treAdmCompose || { mode:'new', target:'', editId:'' };
      return S.treAdmCompose;
    }
    function treAdmComposeClear_(){
      const st = treAdmComposeState_();
      st.mode = 'new';
      st.target = '';
      st.editId = '';
      const E = treAdmEls_();
      if(E.status) E.status.textContent = '—';
    }
    function treAdmComposeSetSingleTarget_(cs){
      const t = String(cs||'').trim().toUpperCase();
      const st = treAdmState_();
      st.all = false;
      st.sel = t ? [t] : [];
      const E = treAdmEls_();
      if(E.pickAll) E.pickAll.checked = false;
      treAdmSyncTargetsInput_();
      try{ treAdmRenderPickList_(); }catch(_e){}
    }
    function treAdmLoadInboxItemToCompose_(targetCallsign, it){
      const E = treAdmEls_();
      const st = treAdmComposeState_();
      const target = String(targetCallsign||'').trim().toUpperCase();
      if(!target || !it) return;
      st.mode = 'editInbox';
      st.target = target;
      st.editId = String(it.id||'').trim();

      // Open Compose fold
      try{
        var body = el('slbTreasuryComposeFoldBody');
        var btn = el('slbTreasuryComposeFoldBtn');
        if(body && body.classList.contains('hidden')) body.classList.remove('hidden');
        if(btn) btn.textContent = 'Close';
      }catch(_e){}

      const raw = String(it.content||'');
      const p = treParseMeta_(raw);
      if(E.title) E.title.value = String(it.title||'');
      if(E.tags) E.tags.value = String(it.tags||p.tags||'');
      if(E.bodyRich) E.bodyRich.innerHTML = String(p.body||'');
      treAdmComposeSetSingleTarget_(target);
      if(E.status) E.status.textContent = 'Editing: ' + target;
      try{ (E.title||E.bodyRich).scrollIntoView({behavior:'smooth', block:'start'}); }catch(_e){}
      try{ if(E.bodyRich && E.bodyRich.focus) E.bodyRich.focus(); }catch(_e){}
    }

    function treAdmSyncTargetsInput_(){
      const st = treAdmState_();
      const E = treAdmEls_();
      if(!E.targets) return;
      if(st.all){
        E.targets.value = "EVERYONE";
        return;
      }
      const arr = (st.sel||[]).map(x=>String(x||"").trim().toUpperCase()).filter(Boolean);
      E.targets.value = arr.join(", ");
    }

    function treAdmRenderPickList_(){
      const st = treAdmState_();
      const E = treAdmEls_();
      if(!E.pickList) return;

      const q = String(E.pickSearch && E.pickSearch.value || "").trim().toUpperCase();
      const users = Array.isArray(S.treAllUsers) ? S.treAllUsers : (Array.isArray(S.giftUsers) ? S.giftUsers : []);
      const sel = new Set((st.sel||[]).map(x=>String(x||"").toUpperCase()));

      E.pickList.innerHTML = "";
      if(!users.length){
        const div = document.createElement("div");
        div.style.padding = "10px";
        div.style.color = "var(--muted)";

        // Auto-load callsigns here (no need to visit Overview)
        if(!S.treAllUsersLoaded && !S.treAllUsersLoading){
          div.textContent = "Loading callsigns…";
          E.pickList.appendChild(div);
          try{
            ensureTreAllUsersLoaded().then(()=>{
              try{ treAdmRenderPickList_(); }catch(_e){}
              try{ treAdmViewRenderPickList_(); }catch(_e){}
            }).catch(()=>{});
          }catch(_e){}
          return;
        }

        div.textContent = "No callsigns found.";
        E.pickList.appendChild(div);
        return;
      }

      users.forEach(u=>{
        const cs = String((u && (u.callsign || u.cs)) || "").trim().toUpperCase();
        if(!cs) return;
        const name = String((u && (u.displayName || u.name)) || "").trim();
        if(q && cs.indexOf(q) < 0 && name.toUpperCase().indexOf(q) < 0) return;
        const row = document.createElement("label");
        row.className = "slbBoardPickRow";
        const cb = document.createElement("input");
        cb.type = "checkbox";
        cb.value = cs;
        cb.checked = sel.has(cs);
        cb.disabled = !!st.all;
        const span = document.createElement("span");
        span.innerHTML = `<b>${escapeHtml(cs)}</b>`;
        row.appendChild(cb);
        row.appendChild(span);
        E.pickList.appendChild(row);
      });
    }

    function treAdmTogglePickPanel_(on){
      const E = treAdmEls_();
      if(!E.pickPanel) return;
      const mask = el("slbAdmTrePickMask");
      const show = (typeof on === "boolean") ? on : E.pickPanel.classList.contains("hidden");
      if(show){
        E.pickPanel.classList.remove("hidden");
        E.pickPanel.classList.add("show");
        if(mask) mask.classList.add("show");
        try{ treAdmRenderPickList_(); }catch(_e){}
      }else{
        E.pickPanel.classList.add("hidden");
        E.pickPanel.classList.remove("show");
        if(mask) mask.classList.remove("show");
      }
    }

    
    function treFmtDateTime_(iso){
      try{
        const d = new Date(iso);
        if(!isFinite(d.getTime())) return String(iso||"");
        return d.toLocaleString(undefined,{year:'numeric',month:'short',day:'numeric',hour:'2-digit',minute:'2-digit',hour12:false});
      }catch(_e){ return String(iso||""); }
    }
    function treStripHtmlToText_(html){
      html = String(html||"");
      if(!html) return "";
      return html
        .replace(/<script[\s\S]*?<\/script>/gi, " ")
        .replace(/<style[\s\S]*?<\/style>/gi, " ")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/g, " ")
        .replace(/\n/g, " ")
        .replace(/\s{2,}/g, " ")
        .trim();
    }
    function treSetViewBody_(elBody, body, mode, link){
      if(!elBody) return;
      mode = String(mode||"text");
      if(mode === "link"){
        const url = String(link||body||"").trim();
        if(!url){ elBody.innerHTML = '<div class="note">(Empty)</div>'; return; }
        const safe = escapeHtml(url);
        elBody.innerHTML = '<a href="' + safe + '" target="_blank" rel="noopener">' + safe + '</a>';
        return;
      }
      body = String(body||"");
      // if it looks like HTML, render as-is (backend sanitizes)
      if(/<\/?[a-z][\s\S]*>/i.test(body)){
        elBody.innerHTML = body;
      }else{
        elBody.innerHTML = escapeHtml(body).replace(/\n/g,'<br/>');
      }
    }

    function treRenderSelected_(it){
      const st = treState_();
      const E = treEls_();
      if(!E.viewBox) return;
      if(!it){
        if(E.viewBox) E.viewBox.classList.remove('hidden');
        if(E.viewTitle) E.viewTitle.textContent = 'Select a treasure';
        if(E.viewMeta) E.viewMeta.textContent = '';
        if(E.viewBody) E.viewBody.innerHTML = '';
        if(E.viewEditBtn) E.viewEditBtn.disabled = true;
        if(E.viewDeleteBtn) E.viewDeleteBtn.disabled = true;
        return;
      }

      if(E.viewBox) E.viewBox.classList.remove('hidden');

      const mode = String(it.mode||'text');
      const raw = (mode === 'link') ? String(it.link||it.content||'') : String(it.content||'');
      const p = treParseMeta_(raw);

      const tags = String(p.tags||'').trim();
      const created = String(it.createdAt||'');
      const updated = String(it.updatedAt||'');
      const from = treFromLabel_(it);

      if(E.viewTitle) E.viewTitle.textContent = String(it.title||'');
      if(E.viewMeta){
        const parts = [];
        if(tags) parts.push('Tags: ' + tags);
        if(from) parts.push('From: ' + from);
        if(created) parts.push('Created: ' + treFmtDateTime_(created));
        if(updated) parts.push('Updated: ' + treFmtDateTime_(updated));
        E.viewMeta.textContent = parts.join(' | ');
      }

      // Always render as rich HTML (backend sanitizes). Fallback for legacy plain text.
      treSetViewBody_(E.viewBody, p.body||'', 'text', '');

      // Edit always loads into the Write editor. If the selected item isn't editable in-place,
      // we treat it as a "copy" on save (see treFillForm_()).
      if(E.viewEditBtn) E.viewEditBtn.disabled = false;

      // V2: users can delete ANY treasures (including admin). Only disable if explicitly false.
      if(E.viewDeleteBtn) E.viewDeleteBtn.disabled = (it.canDelete === false);
    }

    function treRender_(){
      const st = treState_();
      const E = treEls_();
      if(!E.list) return false;

      const q = String(E.search && E.search.value || '').trim().toLowerCase();
      st.q = q;

      let list = Array.isArray(st.items) ? st.items.slice() : [];
      list = list.map(it => {
        const mode = String(it.mode||'text');
        const raw = (mode === 'link') ? String(it.link||it.content||'') : String(it.content||'');
        const p = treParseMeta_(raw);
        return Object.assign({}, it, { _tags: p.tags||'', _body: p.body||'' });
      });

      if(q){
        list = list.filter(it => {
          const hay = [
            String(it.title||''),
            String(it._tags||''),
            treStripHtmlToText_(it._body||'')
          ].join(' ').toLowerCase();
          return hay.indexOf(q) >= 0;
        });
      }

      list.sort((a,b)=> String(b.updatedAt||b.createdAt||'').localeCompare(String(a.updatedAt||a.createdAt||'')));

      if(E.count) E.count.textContent = String(list.length);

      // selection sanity
      if(st.selId && !list.some(x=>String(x.id||'')===String(st.selId))) st.selId = '';
      if(!st.selId && list.length) st.selId = String(list[0].id||'');

      E.list.innerHTML = '';
      if(!list.length){
        E.list.innerHTML = '<div class="note" style="padding:10px;">No treasures yet.</div>';
        treRenderSelected_(null);
        return true;
      }

      list.forEach((it)=>{
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slbDiaryReadItem';
        btn.setAttribute('data-tre-id', String(it.id||''));
        if(String(it.id||'') === String(st.selId)) btn.classList.add('active');

        btn.innerHTML = '<div class="slbTreListTitle" style="font-weight:800;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(String(it.title||'')) + '</div>';
        E.list.appendChild(btn);
      });

      const sel = list.find(x=>String(x.id||'')===String(st.selId)) || null;
      treRenderSelected_(sel);
      return true;
    }

    function treSetEditingLabel_(text){
      const E = treEls_();
      if(E.editing) E.editing.textContent = String(text||'');
    }

    function treClearForm_(){
      const st = treState_();
      const E = treEls_();
      st.editId = '';
      if(E.title) E.title.value = '';
      if(E.catSel) E.catSel.value = '';
      if(E.catCustom) E.catCustom.value = '';
      if(E.catCustomBox) E.catCustomBox.classList.add('hidden');
      if(E.tags) E.tags.value = '';
      try{ if(E.bodyRich) E.bodyRich.innerHTML = ''; }catch(_e){}
      if(E.saveBtn) E.saveBtn.textContent = 'Save';
      treSetEditingLabel_('');
      treMsg_(true,'');
    }

    function treScrollToWrite_(){
      const E = treEls_();
      try{
        var wb = document.getElementById('slbTreWriteFoldBody');
        var wbtn = document.getElementById('slbTreWriteFoldBtn');
        if(wb && wb.classList.contains('hidden')) wb.classList.remove('hidden');
        if(wbtn) wbtn.textContent = 'Close';
      }catch(_e){}
      try{
        if(E.writeCard && E.writeCard.scrollIntoView) E.writeCard.scrollIntoView({behavior:'smooth', block:'start'});
        else window.scrollTo({ top: document.body.scrollHeight, behavior:'smooth' });
      }catch(_e){}
    }

    function treFillForm_(it){
      const st = treState_();
      const E = treEls_();
      if(!it) return;
      // If it's not editable (e.g., admin / locked), treat EDIT as "copy to write" so user can save.
      const canEdit = (it.canEdit === true) && !it.locked;
      st.editId = canEdit ? String(it.id||'') : '';

      const raw = String(it.content||'');
      const parsed = treParseMeta_(raw);

      if(E.title) E.title.value = String(it.title||'');
      if(E.tags) E.tags.value = parsed.tags || '';

      const body = String(parsed.body||'');
      try{ if(E.bodyRich) E.bodyRich.innerHTML = body; }catch(_e){}

      if(E.saveBtn) E.saveBtn.textContent = 'Save';
      treSetEditingLabel_(canEdit ? ('Editing: ' + String(it.title||'')) : ('Editing copy: ' + String(it.title||'')));
      treMsg_(true,'');
      try{ treUpdateCount_(E); }catch(_e){}
      treScrollToWrite_();
    }

    function treNormalizePayload_(out){
      var cur = out;
      for(var i=0;i<8;i++){
        if(Array.isArray(cur)) return { items: cur };
        if(!cur || typeof cur !== 'object') break;
        if(cur.ok === false) throw new Error(cur.error || cur.err || cur.message || 'Treasures request failed.');
        if(Array.isArray(cur.items)) return cur;
        if(Array.isArray(cur.treasures)) return Object.assign({}, cur, { items: cur.treasures });
        if(Array.isArray(cur.records)) return Object.assign({}, cur, { items: cur.records });
        if(Array.isArray(cur.list)) return Object.assign({}, cur, { items: cur.list });
        if(cur.data && typeof cur.data === 'object'){ cur = cur.data; continue; }
        if(cur.result && typeof cur.result === 'object'){ cur = cur.result; continue; }
        if(cur.payload && typeof cur.payload === 'object'){ cur = cur.payload; continue; }
        if(cur.response && typeof cur.response === 'object'){ cur = cur.response; continue; }
        break;
      }
      if(Array.isArray(cur)) return { items: cur };
      return (cur && typeof cur === 'object') ? cur : { items: [] };
    }

    function treApplyPayload_(out){
      const st = treState_();
      try{ treBindOnce_(); }catch(_e0){}
      const payload = treNormalizePayload_(out);
      const items = Array.isArray(payload.items) ? payload.items : [];
      st.items = items;
      st.loadedOnce = true;
      st.lastFetch = Date.now();
      st.lastError = '';
      try{ slbCacheSet_('treasuresList', { items: items }); }catch(_e){}
      treRender_();
      const result = { payload: payload, items: items, count: items.length };
      st.lastResult = result;
      return result;
    }

    function treHydrateToken_(){
      try{
        if(S && S.token) return true;
        var tok = '';
        try{ tok = String(sessionStorage.getItem('tyw_token') || ''); }catch(_e0){}
        if(!tok){
          try{
            var raw = localStorage.getItem('ty_auth_v1') || '';
            if(raw){ var saved = JSON.parse(raw); if(saved && saved.token) tok = String(saved.token || ''); }
          }catch(_e1){}
        }
        if(tok && S){
          S.token = tok;
          try{ if(!S.callsign) S.callsign = String(sessionStorage.getItem('tyw_callsign') || '').trim().toUpperCase(); }catch(_e2){}
          return true;
        }
      }catch(_e3){}
      return false;
    }

    async function treLoad_(force){
      const st = treState_();
      try{ treBindOnce_(); }catch(_eBind){}
      if(!treHydrateToken_()){
        st.lastError = 'SLB login is not ready.';
        treMsg_(false, st.lastError);
        throw new Error(st.lastError);
      }

      const now = Date.now();
      if(st.loading && st.loadPromise) return st.loadPromise;
      if(!force && st.loadedOnce && st.lastFetch && (now - st.lastFetch) < 6000){
        treRender_();
        return st.lastResult || { items: st.items || [], count: (st.items || []).length };
      }
      st.lastAttempt = now;
      st.loading = true;
      st.lastError = '';

      // Render the last verified cache instantly, but do not treat it as a
      // completed server load until the authoritative request settles.
      try{
        const cached = slbCacheGet_('treasuresList', 45*24*60*60*1000) || slbCacheGet_('treasuresList');
        if(cached && typeof cached === 'object' && Array.isArray(cached.items)){
          st.items = cached.items;
          treRender_();
        }
      }catch(_eCache){}

      const task = (async function(){
        try{
          var payload = await rpc(ACTIONS.treasuresList, {}, {
            cacheTtlMs: force ? 0 : 5000,
            dedupeKey: 'treasures-list-' + String(S.callsign || ''),
            timeoutMs: 90000,
            progressMode: 'silent'
          });
          var applied = treApplyPayload_(payload);

          // The Admin Treasury Inbox reads the same disciple records. If an
          // authenticated admin receives an incorrectly empty personal result,
          // verify the active callsign through that proven route before showing
          // an empty page.
          if(!applied.items.length && S.isAdmin && String(S.callsign || '').trim()){
            try{
              var adminPayload = await rpc(ACTIONS.adminTreasuresListAs, { targetCallsign:String(S.callsign || '').trim().toUpperCase() }, {
                cacheTtlMs: 0,
                dedupeKey: 'treasures-admin-fallback-' + String(S.callsign || ''),
                timeoutMs: 90000,
                progressMode: 'silent'
              });
              var adminNorm = treNormalizePayload_(adminPayload);
              if(Array.isArray(adminNorm.items) && adminNorm.items.length) applied = treApplyPayload_(adminNorm);
            }catch(_eAdmin){}
          }

          st.loadedOnce = true;
          st.lastFetch = Date.now();
          st.lastResult = applied;
          st.lastError = '';
          treMsg_(true, '');
          try{ treBindOnce_(); }catch(_eRebind){}
          treRender_();
          return applied;
        }catch(e){
          st.lastError = String((e && e.message) || e || 'Treasures could not load.');
          treMsg_(false, st.lastError);
          throw e;
        }finally{
          st.loading = false;
          st.loadPromise = null;
        }
      })();
      st.loadPromise = task;
      return task;
    }
    function treEditorIsEmpty_(html){
      html = String(html||'').trim();
      if(!html) return true;
      const hasMedia = /<img\b|<iframe\b|<video\b/i.test(html);
      const text = treStripHtmlToText_(html);
      if(hasMedia) return false;
      return !text;
    }

    async function treSave_(){
      const st = treState_();
      const E = treEls_();
      treMsg_(true,'');

      const title = String(E.title && E.title.value || '').trim();
      const meta = treCatTagsFromForm_(E.catSel, E.catCustom, E.tags);
      const bodyHtml = String(E.bodyRich && E.bodyRich.innerHTML || '').trim();

      if(!title) return treMsg_(false, 'Title is required.');
      if(treEditorIsEmpty_(bodyHtml)) return treMsg_(false, 'Content is required.');

      const content = trePackBody_(bodyHtml, meta.cat, meta.tags);
      if(content.length > TRE_CELL_MAX_CHARS){
        try{ treUpdateCount_(E); }catch(_e){}
        return treMsg_(false, 'Too long: ' + String(content.length) + ' / ' + String(TRE_CELL_MAX_CHARS) + '. Please shorten.');
      }
      const args = { id: st.editId || '', title, content };

      const unlock = lockBtn(E.saveBtn);


/* ====== SLB CORE: 90_core_app.part03.js ====== */
/* SLB PART FILE — NOT STANDALONE
   This file is concatenated by slb_build/build.mjs into assets/slb.bundle.generated.js
*/

/* SLB CORE APP (split) - part 03/6
   NOTE: These parts are concatenated in order by slb_build/build.mjs.
*/
      try{
        const res = await rpc(ACTIONS.treasuresUpsert, args);
        const savedId = (res && res.id) ? String(res.id) : (st.editId||'');
        if(savedId) st.selId = savedId;
        await treLoad_(true);
        treMsg_(true, st.editId ? 'Updated.' : 'Saved.');
        if(unlock) unlock();
        treClearForm_();
      }catch(e){
        if(unlock) unlock();
        treMsg_(false, e.message || String(e));
      }
    }

    async function treDelete_(id){
      const st = treState_();
      const tid = String(id||'');
      if(!tid) return;
      if(!confirm('Delete this treasure?')) return;
      treMsg_(true,'');
      try{
        await rpc(ACTIONS.treasuresDelete, { id: tid });
        if(st.editId && st.editId === tid) treClearForm_();
        if(st.selId && st.selId === tid) st.selId = '';
        await treLoad_(true);
        treMsg_(true, 'Deleted.');
      }catch(e){
        treMsg_(false, e.message || String(e));
      }
    }

    function treExportCsv_(){
      const st = treState_();
      const items = Array.isArray(st.items) ? st.items.slice() : [];
      if(!items.length){ toast('warn','No treasures'); return; }
      items.sort((a,b)=> (String(b.updatedAt||b.createdAt||'').localeCompare(String(a.updatedAt||a.createdAt||''))));
      const header = ['title','tags','body','from','createdAt','updatedAt','locked'];
      const rows = [header];
      items.forEach(it=>{
        const raw = String(it.content||'');
        const p = treParseMeta_(raw);
        const from = treFromLabel_(it);
        rows.push([
          String(it.title||''),
          String(p.tags||''),
          String(p.body||''),
          from,
          String(it.createdAt||''),
          String(it.updatedAt||''),
          String(it.locked||'')
        ]);
      });
      const csv = rows.map(r => r.map(csvCell_).join(',')).join('\n');
      downloadText('Treasures.csv', csv, true);
      toast('ok','Exported');
    }

function treBindOnce_(){
      const st = treState_();
      const E = treEls_();
      // Re-check the CURRENT DOM nodes every time. My Cabin moves the original
      // panel, and Shopify/P42 may rebuild editor controls after the first boot.
      // A single global `bound` flag can therefore leave new Read/Write headers
      // and Refresh controls permanently unwired.
      if(!E || !E.list || !E.reloadBtn || !E.viewBody) return false;
      st.bound = true;
      st.boundList = E.list;
      st.boundReloadBtn = E.reloadBtn;
      st.boundReadBtn = document.getElementById('slbTreReadFoldBtn');
      st.boundWriteBtn = document.getElementById('slbTreWriteFoldBtn');

      // folds (Read/Write) — header bar clickable
      (function(){
        function bindFold(foldId, bodyId, btnId){
          var fold = document.getElementById(foldId);
          var body = document.getElementById(bodyId);
          var btn = document.getElementById(btnId);
          if(!fold || !body) return;
          var header = fold.querySelector ? fold.querySelector('.slbFoldHeader') : null;
          function setOpen(open){
            try{ body.classList.toggle('hidden', !open); }catch(_e){}
            try{ if(btn) btn.textContent = open ? 'Close' : 'Open'; }catch(_e){}
          }
          setOpen(!body.classList.contains('hidden'));
          function toggle(){ setOpen(body.classList.contains('hidden')); }
          if(btn && !btn.__bound){
            btn.__bound = true;
            btn.addEventListener('click', function(e){ e.preventDefault(); toggle(); });
          }
          if(header && !header.__boundTre){
            header.__boundTre = true;
            header.addEventListener('click', function(e){
              try{ if(e && e.target && e.target.closest && e.target.closest('button')) return; }catch(_e){}
              toggle();
            });
          }
        }
        bindFold('slbTreFoldRead','slbTreReadFoldBody','slbTreReadFoldBtn');
        bindFold('slbTreWriteFold','slbTreWriteFoldBody','slbTreWriteFoldBtn');
      })();

      // category UI
      treCatUIBind_(E.catSel, E.catCustomBox, E.catCustom);

      // Char count (stored content length; keeps the on-screen max realistic)
      (function(){
        const upd = function(){ try{ treUpdateCount_(E); }catch(_e){} };
        try{
          if(E.bodyRich && !E.bodyRich.__treCountBound){
            E.bodyRich.__treCountBound = true;
            E.bodyRich.addEventListener('input', upd);
            E.bodyRich.addEventListener('keyup', upd);
          }
          if(E.tags && !E.tags.__treCountBound){
            E.tags.__treCountBound = true;
            E.tags.addEventListener('input', upd);
          }
          if(E.catSel && !E.catSel.__treCountBound){
            E.catSel.__treCountBound = true;
            E.catSel.addEventListener('change', upd);
          }
          if(E.catCustom && !E.catCustom.__treCountBound){
            E.catCustom.__treCountBound = true;
            E.catCustom.addEventListener('input', upd);
          }
          setTimeout(upd, 60);
        }catch(_e){}
      })();

      if(E.saveBtn && !E.saveBtn.__bound){
        E.saveBtn.__bound = true;
        E.saveBtn.addEventListener('click', (e)=>{ e.preventDefault(); treSave_(); });
      }
      if(E.reloadBtn && !E.reloadBtn.__bound){
        E.reloadBtn.__bound = true;
        E.reloadBtn.addEventListener('click', (e)=>{ e.preventDefault(); treLoad_(true); });
      }
      if(E.viewRefreshBtn && !E.viewRefreshBtn.__bound){
        E.viewRefreshBtn.__bound = true;
        E.viewRefreshBtn.addEventListener('click', (e)=>{ e.preventDefault(); treLoad_(true); });
      }
      if(E.exportBtn && !E.exportBtn.__bound){
        E.exportBtn.__bound = true;
        E.exportBtn.addEventListener('click', (e)=>{ e.preventDefault(); treExportCsv_(); });
      }
      if(E.search && !E.search.__bound){
        E.search.__bound = true;
        E.search.addEventListener('input', ()=>{ treRender_(); });
      }

      if(E.list && !E.list.__bound){
        E.list.__bound = true;
        E.list.addEventListener('click', (e)=>{
          const btn = e.target && e.target.closest ? e.target.closest('[data-tre-id]') : null;
          if(!btn) return;
          const id = String(btn.getAttribute('data-tre-id')||'');
          if(!id) return;
          st.selId = id;
          treRender_();
        });
      }

      if(E.viewEditBtn && !E.viewEditBtn.__bound){
        E.viewEditBtn.__bound = true;
        E.viewEditBtn.addEventListener('click', (e)=>{
          e.preventDefault();
          const id = String(st.selId||'');
          const it = (Array.isArray(st.items)? st.items: []).find(x=>String(x.id||'')===id);
          if(it) treFillForm_(it);
        });
      }
      if(E.viewDeleteBtn && !E.viewDeleteBtn.__bound){
        E.viewDeleteBtn.__bound = true;
        E.viewDeleteBtn.addEventListener('click', (e)=>{ e.preventDefault(); treDelete_(st.selId); });
      }
      return true;
    }



async function treAdmSend_(sendAll, notify){
      const E = treAdmEls_();
      treAdmMsg_(true, "");
      if(!S.isAdmin) return treAdmMsg_(false, "Admin only.");

      const doNotify = (typeof notify === 'boolean') ? notify : true;
      const pickAll = !!(E.pickAll && E.pickAll.checked);
      const doAll = !!sendAll || pickAll;

      const cst = treAdmComposeState_();

      // Recipients
      let targets = doAll ? [] : treParseTargets_(E.targets && E.targets.value);
      const isEditingInbox = !!(!doAll && cst && cst.mode === 'editInbox' && cst.target && cst.editId
        && Array.isArray(targets) && targets.length === 1 && String(targets[0]||'').trim().toUpperCase() === String(cst.target||'').trim().toUpperCase());
      if(isEditingInbox) targets = [String(cst.target).trim().toUpperCase()];

      const title = String(E.title && E.title.value || "").trim();
      // Admin Treasury compose is rich-text (Standard Editor V1) only.
      const bodyHtml = String(E.bodyRich && E.bodyRich.innerHTML || "").trim();

      if(!title) return treAdmMsg_(false, "Title is required.");
      if(treEditorIsEmpty_(bodyHtml)) return treAdmMsg_(false, "Content is required.");
      if(!doAll && !targets.length) return treAdmMsg_(false, "Please select at least 1 recipient (or Everyone).");

      const meta = treCatTagsFromForm_(E.catSel, E.catCustom, E.tags);
      const content = trePackBody_(bodyHtml, meta.cat, meta.tags);
      if(content.length > TRE_CELL_MAX_CHARS){
        return treAdmMsg_(false, 'Too long: ' + String(content.length) + ' / ' + String(TRE_CELL_MAX_CHARS) + '. Please shorten.');
      }

      // Button locks
      const btnPrimary = (doAll ? (E.sendAllBtn || E.sendBtn || E.saveBtn) : (doNotify ? E.sendBtn : E.saveBtn));
      const btnAlt1 = (doAll ? (E.sendBtn || E.saveBtn) : (doNotify ? E.saveBtn : E.sendBtn));
      const btnAlt2 = (doAll ? E.saveBtn : E.sendAllBtn);

      if(S.__treAdmBusy) return treAdmMsg_(false, "Still working. Please wait.");
      S.__treAdmBusy = true;
      const unlock = lockBtn(btnPrimary, isEditingInbox ? "Saving..." : (doNotify ? "Sending..." : "Saving..."));
      const unlockAlt1 = lockBtn(btnAlt1);
      const unlockAlt2 = lockBtn(btnAlt2);
      treAdmMsg_(true, isEditingInbox ? "Saving..." : (doNotify ? "Sending..." : "Saving..."));

      try{
        if(isEditingInbox){
          const args = {
            targetCallsign: String(cst.target||''),
            id: String(cst.editId||''),
            title: title,
            content: content,
            notify: doNotify ? 1 : 0
          };
          await rpc(ACTIONS.adminTreasuresUpsertAs, args);
          treAdmMsg_(true, doNotify ? "Saved and sent." : "Saved.");
          try{ treAdmViewLoad_(true); }catch(_e){}
          try{ treAdmOutboxLoad_(true); }catch(_e){}
          return;
        }

        const args = { targets, title, content, sendAll: doAll ? 1 : 0, notify: doNotify ? 1 : 0 };
        await rpc(ACTIONS.adminTreasuresSend, args);
        treAdmMsg_(true, doNotify ? (doAll ? "Sent to everyone." : ("Sent to " + String(targets.length) + ".")) : "Saved.");
        try{ treAdmOutboxLoad_(true); }catch(_e){}

        // Clear form after a new send/save
        treAdmComposeClear_();
        if(E.title) E.title.value = "";
        if(E.size) E.size.value = "L";
        if(E.mode) E.mode.value = "text";
        if(E.catSel) E.catSel.value = "";
        if(E.catCustom) E.catCustom.value = "";
        if(E.catCustomBox) E.catCustomBox.classList.add("hidden");
        if(E.tags) E.tags.value = "";
        if(E.bodyRich) E.bodyRich.innerHTML = "";
        if(E.content) E.content.value = "";
        if(E.link) E.link.value = "";
        if(E.textBox) E.textBox.classList.remove("hidden");
        if(E.linkBox) E.linkBox.classList.add("hidden");
      }catch(e){
        treAdmMsg_(false, e.message || String(e));
      }finally{
        try{ if(unlock) unlock(); }catch(_e){}
        try{ if(unlockAlt1) unlockAlt1(); }catch(_e){}
        try{ if(unlockAlt2) unlockAlt2(); }catch(_e){}
        S.__treAdmBusy = false;
      }
    }

    function treAdmBindOnce_(){

      // Multi-send modal open (checkbox picker)
      const multiBtn = el("slbAdmTreMultiBtn");
      if(multiBtn && !multiBtn.__bound){
        multiBtn.__bound = true;
        multiBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmTogglePickPanel_(true); });
      }
      const pickMask = el("slbAdmTrePickMask");
      if(pickMask && !pickMask.__bound){
        pickMask.__bound = true;
        pickMask.addEventListener("click", (e)=>{ e.preventDefault(); treAdmTogglePickPanel_(false); });
      }
      const E = treAdmEls_();
      treCatUIBind_(E.catSel, E.catCustomBox, E.catCustom);

      if(!E.saveBtn && !E.sendBtn && !E.sendAllBtn) return;

      // Recipient picker (checkbox list)
      if(E.pickBtn && !E.pickBtn.__bound){
        E.pickBtn.__bound = true;
        E.pickBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmTogglePickPanel_(); });
      }
      // Let To field / pick button open the recipient picker
      try{
        var mb = el("slbAdmTreMultiBtn");
        if(mb && !mb.__bound){
          mb.__bound = true;
          mb.addEventListener("click", (e)=>{ e.preventDefault(); treAdmTogglePickPanel_(); });
        }
        if(E.targets && !E.targets.__boundPick){
          E.targets.__boundPick = true;
          E.targets.addEventListener("click", (e)=>{
            try{ e.preventDefault(); }catch(_e){}
            treAdmTogglePickPanel_();
          });
        }
      }catch(_e){}

      if(E.pickClose && !E.pickClose.__bound){
        E.pickClose.__bound = true;
        E.pickClose.addEventListener("click", (e)=>{ e.preventDefault(); treAdmTogglePickPanel_(false); });
      }
      if(E.pickSearch && !E.pickSearch.__bound){
        E.pickSearch.__bound = true;
        E.pickSearch.addEventListener("input", ()=>{ treAdmRenderPickList_(); });
      }
      if(E.pickAll && !E.pickAll.__bound){
        E.pickAll.__bound = true;
        E.pickAll.addEventListener("change", ()=>{
          const st = treAdmState_();
          st.all = !!E.pickAll.checked;
          if(st.all) st.sel = [];
          treAdmSyncTargetsInput_();
          treAdmRenderPickList_();
        });
      }
      if(E.pickList && !E.pickList.__bound){
        E.pickList.__bound = true;
        E.pickList.addEventListener("change", (e)=>{
          const t = e.target;
          if(!t || t.tagName !== "INPUT" || t.type !== "checkbox") return;
          const st = treAdmState_();
          if(st.all) return;
          const cs = String(t.value||"").trim().toUpperCase();
          if(!cs) return;
          const set = new Set((st.sel||[]).map(x=>String(x||"").toUpperCase()));
          if(t.checked) set.add(cs);
          else set.delete(cs);
          st.sel = Array.from(set).slice(0,200);
          treAdmSyncTargetsInput_();
        });
      }
      if(E.mode && !E.mode.__bound){
        E.mode.__bound = true;
        E.mode.addEventListener("change", ()=>{
          const m = String(E.mode.value||"text");
          if(m === "link"){
            if(E.textBox) E.textBox.classList.add("hidden");
            if(E.linkBox) E.linkBox.classList.remove("hidden");
          }else{
            if(E.textBox) E.textBox.classList.remove("hidden");
            if(E.linkBox) E.linkBox.classList.add("hidden");
          }
        });
      }
      if(E.saveBtn && !E.saveBtn.__bound){
        E.saveBtn.__bound = true;
        E.saveBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmSend_(false, false); });
      }
      if(E.sendBtn && !E.sendBtn.__bound){
        E.sendBtn.__bound = true;
        E.sendBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmSend_(false, true); });
      }
      if(E.sendAllBtn && !E.sendAllBtn.__bound){
        E.sendAllBtn.__bound = true;
        E.sendAllBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmSend_(true, true); });
      }
    
      // Treasury: make fold header bar clickable
      try{
        function bindFold_(foldId, bodyId, btnId){
          var fold = el(foldId); var body = el(bodyId); var btn = el(btnId);
          if(!fold || !body || !btn) return;
          var header = fold.querySelector ? fold.querySelector('.slbFoldHeader') : null;
          if(!header || header.__bound) return;
          header.__bound = true;
          function syncBtn(){ btn.textContent = body.classList.contains('hidden') ? 'Open' : 'Close'; }
          syncBtn();
          header.addEventListener('click', (e)=>{
            // If click originated from a link/button inside header, still toggle (matches diary/cmr behavior)
            body.classList.toggle('hidden');
            syncBtn();
          });
        }
        bindFold_('slbTreasuryFoldCompose','slbTreasuryComposeFoldBody','slbTreasuryComposeFoldBtn');
        bindFold_('slbTreasuryFoldRecords','slbTreasuryRecordsFoldBody','slbTreasuryRecordsFoldBtn');
      }catch(_e){}

      // outbox
      try{ treAdmOutboxBind_(); }catch(_e){}
      try{ treAdmOutboxLoad_(false); }catch(_e){}
      // ensure callsigns are available on this page too (no need to visit Overview)
      try{
        ensureTreAllUsersLoaded().then(()=>{
          try{ treAdmRenderPickList_(); }catch(_e){}
          try{ treAdmViewRenderPickList_(); }catch(_e){}
        }).catch(()=>{});
      }catch(_e){}
}

    // ===== Admin Treasures: view/edit/delete any user's treasury =====
    function treAdmViewState_(){
      S.treAdmView = S.treAdmView || { bound:false, target:"", items:[], byId:{}, editId:"", viewId:"" };
      if(!Array.isArray(S.treAdmView.items)) S.treAdmView.items = [];
      return S.treAdmView;
    }

    function treAdmViewMsg_(ok, text){
      const E = treAdmViewEls_();
      if(E.msg){ E.msg.textContent = String(text||""); treShow_(E.msg, !ok && !!text); }
      if(E.ok){  E.ok.textContent  = String(text||""); treShow_(E.ok,  ok && !!text); }
    }

    function treAdmViewSetTarget_(cs){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      st.target = String(cs||"").trim().toUpperCase();
      if(E.target) E.target.value = st.target;
      try{ treAdmViewCloseViewer_(); }catch(_e){}
    }

    function treAdmViewRenderPickList_(){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      if(!E.pickList) return;
      const q = String(E.pickSearch && E.pickSearch.value || "").trim().toUpperCase();
      const users = Array.isArray(S.treAllUsers) ? S.treAllUsers : (Array.isArray(S.giftUsers) ? S.giftUsers : []);
      E.pickList.innerHTML = "";
      if(!users.length){
        const div = document.createElement("div");
        div.style.padding = "10px";
        div.style.color = "var(--muted)";

        // Auto-load callsigns here (no need to visit Overview)
        if(!S.treAllUsersLoaded && !S.treAllUsersLoading){
          div.textContent = "Loading callsigns…";
          E.pickList.appendChild(div);
          try{
            ensureTreAllUsersLoaded().then(()=>{
              try{ treAdmRenderPickList_(); }catch(_e){}
              try{ treAdmViewRenderPickList_(); }catch(_e){}
            }).catch(()=>{});
          }catch(_e){}
          return;
        }

        div.textContent = "No callsigns found.";
        E.pickList.appendChild(div);
        return;
      }
      users.forEach(u=>{
        const cs = String((u && (u.callsign || u.cs)) || "").trim().toUpperCase();
        if(!cs) return;
        const name = String((u && (u.displayName || u.name)) || "").trim();
        if(q && cs.indexOf(q) < 0 && name.toUpperCase().indexOf(q) < 0) return;
        const row = document.createElement("button");
        row.type = "button";
        const cur = String((E.target && E.target.value) || "").trim().toUpperCase();
        row.className = "slbTrePickRow" + (cs === cur ? " active" : "");
        row.innerHTML = `<b>${escapeHtml(cs)}</b>`;
        row.addEventListener("click", (e)=>{
          e.preventDefault();
          treAdmViewSetTarget_(cs);

          try{ treAdmEditClear_(); }catch(_e){}
          try{
            const mode = (E.pickPanel && E.pickPanel.getAttribute) ? String(E.pickPanel.getAttribute("data-mode")||"") : "";
            if(mode !== "inbox") treAdmViewTogglePickPanel_(false);
          }catch(_e){}
          try{ treAdmViewRenderPickList_(); }catch(_e){}
          try{
            treAdmViewLoad_(false);
          }catch(_e){}
        });
        E.pickList.appendChild(row);
      });
    }

    function treAdmViewTogglePickPanel_(on){
      const E = treAdmViewEls_();
      if(!E.pickPanel) return;
      const show = (typeof on === "boolean") ? on : E.pickPanel.classList.contains("hidden");
      if(show) E.pickPanel.classList.remove("hidden");
      else E.pickPanel.classList.add("hidden");
      if(show){
        try{ treAdmViewRenderPickList_(); }catch(_e){}
      }
    }

    function treAdmViewRender_(){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      if(!E.body) return;
      const tbody = E.body;

      let list = Array.isArray(st.items) ? st.items.slice() : [];
      // Build a fast lookup map
      st.byId = {};
      list = list.map(it => {
        const raw = String(it.content||'');
        const p = treParseMeta_(raw);
        const out = Object.assign({}, it, { _tags: p.tags||'', _body: p.body||'' });
        const id = String(out.id||'');
        if(id) st.byId[id] = out;
        return out;
      });

      // Sort by updated date desc
      list.sort((a,b)=> String(b.updatedAt||b.createdAt||'').localeCompare(String(a.updatedAt||a.createdAt||'')));

      if(E.count) E.count.textContent = String(list.length);

      tbody.innerHTML = '';
      if(!list.length){
        tbody.innerHTML = '<tr><td colspan="4" class="note" style="padding:10px;">No inbox records.</td></tr>';
        return;
      }

      list.forEach(it=>{
        const id = String(it.id||'');
        const updatedAt = String(it.updatedAt||it.createdAt||'');
        const updated = updatedAt ? treFmtDateTime_(updatedAt) : '';

        const tr = document.createElement('tr');
        tr.className = 'slbTreClickRow';
        tr.setAttribute('data-treadm-id', id);
        tr.innerHTML = ''
          + '<td class="tTitle">' + escapeHtml(String(it.title||'')) + '</td>'
          + '<td>' + escapeHtml(String(it._tags||'')) + '</td>'
          + '<td class="tFrom"><b>' + escapeHtml(String(it.from||'')) + '</b></td>'
          + '<td>' + escapeHtml(updated) + '</td>';
        tbody.appendChild(tr);
      });
    }

    function treAdmViewCloseViewer_(){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      st.viewId = '';
      if(E.viewBox) E.viewBox.classList.add('hidden');
      if(E.viewTitle) E.viewTitle.textContent = '—';
      if(E.viewMeta) E.viewMeta.textContent = '—';
      if(E.viewBody) E.viewBody.innerHTML = '';
    }

    function treAdmViewOpenViewerById_(id){
      const st = treAdmViewState_();
      const it = st.byId && st.byId[String(id||'')];
      if(!it) return;
      treAdmViewOpenViewer_(it);
    }

    function treAdmViewLoadToComposeById_(id){
      const st = treAdmViewState_();
      const it = st.byId && st.byId[String(id||'')];
      if(!it) return;
      // Load into top Compose editor instead of opening a second editor
      treAdmLoadInboxItemToCompose_(st.target, it);
    }

    function treAdmViewOpenViewer_(it){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      if(!it) return;
      st.viewId = String(it.id||'');

      const raw = String(it.content||'');
      const p = treParseMeta_(raw);
      const body = treBodyToHtml_(p.body||'');

      if(E.viewTitle) E.viewTitle.textContent = String(it.title||'') || '—';

      const updatedAt = String(it.updatedAt||it.createdAt||'');
      const updated = updatedAt ? treFmtDateTime_(updatedAt) : '';
      const meta = [
        (String(it.from||'') ? ('From: ' + String(it.from||'')) : ''),
        (String(p.tags||'') ? ('Tags: ' + String(p.tags||'')) : ''),
        (updated ? ('Updated: ' + updated) : '')
      ].filter(Boolean).join(' | ');

      if(E.viewMeta) E.viewMeta.textContent = meta || '—';
      if(E.viewBody) E.viewBody.innerHTML = body;
      if(E.viewBox) E.viewBox.classList.remove('hidden');
      try{ E.viewBox.scrollIntoView({behavior:'smooth', block:'start'}); }catch(_e){}
    }

    async function treAdmViewLoad_(force){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      treAdmViewMsg_(true, "");
      if(!S.isAdmin) return treAdmViewMsg_(false, "Admin only.");
      const target = String(E.target && E.target.value || st.target || "").trim().toUpperCase();
      if(!target) return treAdmViewMsg_(false, "Pick a callsign.");
      treAdmViewSetTarget_(target);

      const cacheKey = "admTreView_v2fix1:" + target;
      if(!force){
        const cached = slbCacheGet_(cacheKey, 1000*60*60*24*14);
        if(cached && Array.isArray(cached.items)){
          st.items = cached.items;
          treAdmViewRender_();
        }
      }
      const unlock = lockBtn(E.loadBtn);
      try{
        const payload = await rpc(ACTIONS.adminTreasuresListAs, { targetCallsign: target });
        const items = (payload && payload.items) ? payload.items : [];
        st.items = Array.isArray(items) ? items : [];
        try{ slbCacheSet_(cacheKey, { items: st.items }); }catch(_e){}
        treAdmViewRender_();
        let _m2 = "Loaded (" + st.items.length + ").";
        if(payload && payload.meta){
          const m2 = payload.meta;
          if(m2.treSsid) _m2 += " ssid " + String(m2.treSsid).slice(0,8) + "…";
          if(m2.treLastRow !== undefined) _m2 += " treRows " + String(m2.treLastRow);
          if(m2.hdrRow !== undefined) _m2 += " hdrRow " + String(m2.hdrRow);
          if(m2.reason) _m2 += " " + String(m2.reason);
        }
        treAdmViewMsg_(true, _m2);
        if(unlock) unlock();
      }catch(e){
        if(unlock) unlock();
        treAdmViewMsg_(false, e.message || String(e));
      }
    }

    function treAdmViewExportCsv_(){
      const st = treAdmViewState_();
      const items = Array.isArray(st.items) ? st.items.slice() : [];
      if(!items.length){ toast('warn','No records'); return; }
      items.sort((a,b)=> (String(b.updatedAt||b.createdAt||'').localeCompare(String(a.updatedAt||a.createdAt||''))));
      const header = ['title','tags','body','from','createdAt','updatedAt','locked'];
      const rows = [header];
      items.forEach(it=>{
        const p = treParseMeta_(String(it.content||''));
        rows.push([
          String(it.title||''),
          String(p.tags||''),
          String(p.body||''),
          String(it.from||''),
          String(it.createdAt||''),
          String(it.updatedAt||''),
          String(it.locked||'')
        ]);
      });
      const csv = rows.map(r => r.map(csvCell_).join(',')).join('\n');
      downloadText('Treasury_Inbox.csv', csv, true);
      toast('ok','Exported');
    }

    function treAdmEditFill_(it){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      if(!it) return;
      st.editId = String(it.id||"");
      if(E.editBox) E.editBox.classList.remove("hidden");
      if(E.editId) E.editId.textContent = "Editing: " + st.editId;
      if(E.editTitle) E.editTitle.value = String(it.title||"");

      const p = treParseMeta_(String(it.content||""));
      if(E.editTags) E.editTags.value = p.tags || "";

      // Always rich HTML
      if(E.editBodyRich) E.editBodyRich.innerHTML = String(p.body||"");
      if(E.editContent) E.editContent.value = "";
      if(E.editLink) E.editLink.value = "";

      try{ E.editBox.scrollIntoView({behavior:"smooth", block:"start"}); }catch(_e){}
    }

    function treAdmEditClear_(){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      st.editId = "";
      if(E.editBox) E.editBox.classList.add("hidden");
      if(E.editId) E.editId.textContent = "";
      if(E.editTitle) E.editTitle.value = "";
      if(E.editBodyRich) E.editBodyRich.innerHTML = "";
      if(E.editContent) E.editContent.value = "";
      if(E.editLink) E.editLink.value = "";
    }

    async function treAdmEditSave_(){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      treAdmViewMsg_(true, "");
      if(!S.isAdmin) return treAdmViewMsg_(false, "Admin only.");
      const target = String(st.target||"").trim().toUpperCase();
      const id = String(st.editId||"").trim();
      if(!target || !id) return treAdmViewMsg_(false, "Pick an item first.");
      const title = String(E.editTitle && E.editTitle.value || "").trim();
      const body = String(E.editBodyRich && E.editBodyRich.innerHTML || "").trim();
      if(!title) return treAdmViewMsg_(false, "Title is required.");
      if(treEditorIsEmpty_(body)) return treAdmViewMsg_(false, "Content is required.");

      const meta = treCatTagsFromForm_(null, null, E.editTags);
      const content = trePackBody_(body, '', meta.tags);

      const args = { target, id, title, content };
      const unlock = lockBtn(E.editSaveBtn);
      try{
        await rpc(ACTIONS.adminTreasuresUpdate, args);
        if(unlock) unlock();
        treAdmViewMsg_(true, "Updated.");
        await treAdmViewLoad_(true);
      }catch(e){
        if(unlock) unlock();
        treAdmViewMsg_(false, e.message || String(e));
      }
    }

    async function treAdmEditDelete_(){
      const st = treAdmViewState_();
      const E = treAdmViewEls_();
      treAdmViewMsg_(true, "");
      if(!S.isAdmin) return treAdmViewMsg_(false, "Admin only.");
      const target = String(st.target||"").trim().toUpperCase();
      const id = String(st.editId||"").trim();
      if(!target || !id) return treAdmViewMsg_(false, "Pick an item first.");
      if(!confirm("Delete this treasure for " + target + "?")) return;
      const unlock = lockBtn(E.editDelete);
      try{
        await rpc(ACTIONS.adminTreasuresDeleteAs, { targetCallsign: target, id });
        await treAdmViewLoad_(true);
        treAdmViewMsg_(true, "Deleted.");
        if(unlock) unlock();
        treAdmEditClear_();
      }catch(e){
        if(unlock) unlock();
        treAdmViewMsg_(false, e.message || String(e));
      }
    }

    function treAdmViewBindOnce_(){
      const st = treAdmViewState_();
      if(st.bound) return;
      st.bound = true;
      const E = treAdmViewEls_();
      treCatUIBind_(E.editCatSel, E.editCatCustomBox, E.editCatCustom);

      if(!E.target) return;

      if(E.pickBtn && !E.pickBtn.__bound){
        E.pickBtn.__bound = true;
        E.pickBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmViewTogglePickPanel_(); });
      }
      if(E.pickClose && !E.pickClose.__bound){
        E.pickClose.__bound = true;
        E.pickClose.addEventListener("click", (e)=>{ e.preventDefault(); treAdmViewTogglePickPanel_(false); });
      }
      if(E.pickSearch && !E.pickSearch.__bound){
        E.pickSearch.__bound = true;
        E.pickSearch.addEventListener("input", ()=>{ treAdmViewRenderPickList_(); });
      }
      if(E.loadBtn && !E.loadBtn.__bound){
        E.loadBtn.__bound = true;
        E.loadBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmViewLoad_(true); });
      }
      if(E.exportBtn && !E.exportBtn.__bound){
        E.exportBtn.__bound = true;
        E.exportBtn.addEventListener("click", (e)=>{ e.preventDefault(); treAdmViewExportCsv_(); });
      }
      if(E.viewClose && !E.viewClose.__bound){
        E.viewClose.__bound = true;
        E.viewClose.addEventListener('click',(e)=>{ e.preventDefault(); treAdmViewCloseViewer_(); });
      }
      if(E.viewEdit && !E.viewEdit.__bound){
        E.viewEdit.__bound = true;
        E.viewEdit.addEventListener('click',(e)=>{ e.preventDefault();
          const st = treAdmViewState_();
          const it = st.byId && st.byId[String(st.viewId||'')];
          if(it){
            try{ treAdmViewCloseViewer_(); }catch(_e){}
            try{ treAdmEditClear_(); }catch(_e){}
            treAdmLoadInboxItemToCompose_(st.target, it);
          }
        });
      }
      if(E.viewDelete && !E.viewDelete.__bound){
        E.viewDelete.__bound = true;
        E.viewDelete.addEventListener('click',(e)=>{ e.preventDefault();
          const st = treAdmViewState_();
          const id = String(st.viewId||'');
          if(!id) return;
          if(!confirm('Delete this treasure for ' + String(st.target||'') + '?')) return;
          rpc(ACTIONS.adminTreasuresDeleteAs, { targetCallsign: String(st.target||''), id: id })
            .then(()=> treAdmViewLoad_(true))
            .then(()=>{ treAdmViewMsg_(true,'Deleted.'); treAdmViewCloseViewer_(); try{ treAdmEditClear_(); }catch(_e){} })
            .catch(err=> treAdmViewMsg_(false, err.message||String(err)));
        });
      }
      if(E.body && !E.body.__bound){
        E.body.__bound = true;
        E.body.addEventListener("click", (e)=>{
          const tr = e.target && e.target.closest && e.target.closest('tr[data-treadm-id]');
          if(!tr) return;
          const id = tr.getAttribute('data-treadm-id');
          if(!id) return;
          // Click -> open the viewer below the list (Edit/Delete available).
          try{ const st = treAdmViewState_(); st.viewId = String(id); }catch(_e){}
          try{ treAdmViewRender_(); }catch(_e){}
          try{ treAdmEditClear_(); }catch(_e){}
          treAdmViewOpenViewerById_(id);
        });
      }
      if(E.editMode && !E.editMode.__bound){
        E.editMode.__bound = true;
        E.editMode.addEventListener("change", ()=>{
          const m = String(E.editMode.value||"text");
          if(m === "link"){
            if(E.editTextBox) E.editTextBox.classList.add("hidden");
            if(E.editLinkBox) E.editLinkBox.classList.remove("hidden");
          }else{
            if(E.editTextBox) E.editTextBox.classList.remove("hidden");
            if(E.editLinkBox) E.editLinkBox.classList.add("hidden");
          }
        });
      }
      if(E.editSave && !E.editSave.__bound){
        E.editSave.__bound = true;
        E.editSave.addEventListener("click", (e)=>{ e.preventDefault(); treAdmEditSave_(); });
      }
      if(E.editCancel && !E.editCancel.__bound){
        E.editCancel.__bound = true;
        E.editCancel.addEventListener("click", (e)=>{ e.preventDefault(); treAdmEditClear_(); });
      }
      if(E.editDelete && !E.editDelete.__bound){
        E.editDelete.__bound = true;
        E.editDelete.addEventListener("click", (e)=>{ e.preventDefault(); treAdmEditDelete_(); });
      }

      // If this pick panel is used as a left column (Diary-reader style), render it once
      try{
        if(E.pickPanel && String(E.pickPanel.getAttribute("data-mode")||"")==="inbox"){
          treAdmViewRenderPickList_();
        }
      }catch(_e){}
    }


// ====== Phase 3 render helpers ======
    function statusPill(on){
      return `<span class="pill ${on ? "on" : "off"}">${on ? "ON" : "OFF"}</span>`;
    }

    function normalizeOffer(o){
      const status = String(o.status || "").trim().toUpperCase();
      return {
        offerId: String(o.offerId || o.id || "").trim(),
        title: String(o.title || o.offerTitle || o.itemTitle || "").trim(),
        desc: String(o.description || o.desc || o.offerDescription || o.itemDescription || "").trim(),
        delivery: String(o.delivery || o.deliveryNote || o.offerDelivery || o.deliveryInfo || o.contact || "").trim(),
        price: Number(o.price || 0),
        stock: Number(o.qty || o.stock || 0),
        enabled: (status ? (status === "PUBLISHED") : true),
        status: status || "PUBLISHED",
        sellerCallsign: String(o.sellerCallsign || "").trim(),
        sellerName: String(o.sellerName || "").trim(),
        __raw: o || null
      };
    }

    function canonOrderStatus(s){
      let t = String(s||"").trim().toUpperCase();
      t = t.replace(/[\s-]+/g,"_");
      if(t === "INPROGRESS") t = "IN_PROGRESS";
      if(t === "MARKED_DELIVERED") t = "DELIVERED";
      return t;
    }

    
    function slbPad2_(n){ n = Number(n||0); return (n<10?'0':'')+n; }
    function slbFmtShortTs(s){
      s = String(s||'').trim();
      if(!s) return '';
      if(s.indexOf('@') >= 0 && /\d{4}-\d{2}-\d{2}/.test(s)) return s; // already in nice format
      const d = new Date(s);
      if(!isFinite(d.getTime())) return s;
      const Y = d.getFullYear();
      const M = slbPad2_(d.getMonth()+1);
      const D = slbPad2_(d.getDate());
      const h = slbPad2_(d.getHours());
      const m = slbPad2_(d.getMinutes());
      return `${Y}-${M}-${D} @ ${h}:${m}`;
    }

function normalizeOrder(o){
      const createdAtRaw = String(o.createdAt || "").trim();
      const updatedAtRaw = String(o.updatedAt || "").trim();
      const sortSource = createdAtRaw || updatedAtRaw;
      const sortTs = Date.parse(sortSource);
      return {
        orderId: String(o.orderId || o.id || "").trim(),
        time: slbFmtShortTs(sortSource),
        offerTitle: String(o.title || o.offerTitle || o.itemTitle || "").trim(),
        offerId: String(o.offerId || o.itemId || "").trim(),
        qty: Number(o.qty || 0),
        total: Number(o.total || 0),
        status: canonOrderStatus(o.status),
        sellerCallsign: String(o.sellerCallsign || "").trim(),
        sellerName: String(o.sellerName || "").trim(),
        buyerCallsign: String(o.buyerCallsign || "").trim(),
        buyerName: String(o.buyerName || "").trim(),
        desc: String(o.description || o.desc || o.offerDescription || o.itemDescription || "").trim(),
        delivery: String(o.delivery || o.deliveryNote || o.offerDelivery || o.deliveryInfo || o.contact || "").trim(),
        deliveredAt: String(o.deliveredAt || "").trim(),
        receivedAt: String(o.receivedAt || "").trim(),
        createdAtRaw,
        updatedAtRaw,
        sortTs: Number.isFinite(sortTs) ? sortTs : 0,
        __raw: o || null
      };
    }
    function lookupOfferDetail_(offerId, offerTitle){
      const id = String(offerId || '').trim();
      const ttl = String(offerTitle || '').trim().toLowerCase();
      const sources = [];
      if(Array.isArray(S && S.p3 && S.p3.marketOffers)) sources.push(S.p3.marketOffers);
      if(Array.isArray(S && S.p3 && S.p3.mineOffers)) sources.push(S.p3.mineOffers);
      try{
        const cachedOffers = (typeof slbCacheGet_ === 'function') ? slbCacheGet_('p3_marketOffers', 7*24*60*60*1000) : null;
        if(Array.isArray(cachedOffers) && cachedOffers.length) sources.push(cachedOffers);
      }catch(_e){}
      for(let s=0;s<sources.length;s++){
        const list = sources[s] || [];
        for(let i=0;i<list.length;i++){
          const x = normalizeOffer(list[i] || {});
          if(id && String(x.offerId || '').trim() === id) return x;
          if(ttl && String(x.title || '').trim().toLowerCase() === ttl) return x;
        }
      }
      return null;
    }
    function parseOfferDescParts_(text){
      const raw = String(text || '').replace(/\r/g,'').trim();
      if(!raw) return { desc:'', delivery:'' };
      const rx = /(?:\n\n|\n|^)(Delivery\s*\/\s*Contact|Delivery|Contact)\s*:\s*/i;
      const m = rx.exec(raw);
      if(!m) return { desc: raw, delivery: '' };
      const desc = raw.slice(0, m.index).trim();
      const delivery = raw.slice(m.index + m[0].length).trim();
      return { desc, delivery };
    }
    function firstNonEmptyText_(){
      for(let i=0;i<arguments.length;i++){
        const v = String(arguments[i] || '').trim();
        if(v) return v;
      }
      return '';
    }
    function pickDeepText_(obj, keys){
      if(!obj || typeof obj !== 'object') return '';
      for(let i=0;i<keys.length;i++){
        const k = keys[i];
        if(obj && obj[k] != null){
          const v = String(obj[k]).trim();
          if(v && v !== '[object Object]') return v;
        }
      }
      const nests = ['offer','item','snapshot','offerSnapshot','itemSnapshot','marketOffer','payload','data','raw','details','itemData','offerData','product','productData','listing','listingData'];
      for(let i=0;i<nests.length;i++){
        const child = obj[nests[i]];
        if(child && typeof child === 'object'){
          const v = pickDeepText_(child, keys);
          if(v) return v;
        }
      }
      return '';
    }
    function getOrderDetailPayload_(o){
      const raw = (o && o.__raw && typeof o.__raw === 'object') ? o.__raw : (o || {});
      const offerInfo = lookupOfferDetail_(firstNonEmptyText_(o && o.offerId, raw.offerId, raw.itemId), firstNonEmptyText_(o && o.offerTitle, raw.title, raw.offerTitle, raw.itemTitle));
      const offerRaw = offerInfo && offerInfo.__raw ? offerInfo.__raw : (offerInfo || {});
      const rawDesc = firstNonEmptyText_(
        o && o.desc,
        o && o.description,
        pickDeepText_(raw, ['description','desc','offerDescription','itemDescription','details','blurb','body','notes']),
        offerInfo && offerInfo.desc,
        pickDeepText_(offerRaw, ['description','desc','offerDescription','itemDescription','details','blurb','body','notes'])
      );
      const parsed = parseOfferDescParts_(rawDesc);
      const delivery = firstNonEmptyText_(
        o && o.delivery,
        pickDeepText_(raw, ['delivery','deliveryNote','offerDelivery','deliveryInfo','contact']),
        offerInfo && offerInfo.delivery,
        pickDeepText_(offerRaw, ['delivery','deliveryNote','offerDelivery','deliveryInfo','contact']),
        parsed.delivery
      );
      return {
        desc: parsed.desc || rawDesc,
        delivery,
        title: firstNonEmptyText_(o && o.offerTitle, raw.title, raw.offerTitle, raw.itemTitle, offerInfo && offerInfo.title)
      };
    }
    function bindOrderLikeRowDetails_(body, rowSelector, keyAttr, getPayload, metaBuilder){
      if(!body) return;
      function closeAllDetails(){
        body.querySelectorAll('tr.slbMktDetailRow').forEach(n => n.remove());
        body.querySelectorAll(`${rowSelector}.open`).forEach(n => { n.classList.remove('open'); n.setAttribute('aria-expanded','false'); });
      }
      function toggleRow(tr){
        const rowKey = tr.getAttribute(keyAttr) || '';
        if(!rowKey) return;
        const next = tr.nextElementSibling;
        if(next && next.classList.contains('slbMktDetailRow') && (next.getAttribute(keyAttr) === rowKey)){
          next.remove();
          tr.classList.remove('open');
          tr.setAttribute('aria-expanded','false');
          return;
        }
        closeAllDetails();
        const payload = getPayload(tr, rowKey) || {};
        const det = document.createElement('tr');
        det.className = 'slbMktDetailRow';
        det.setAttribute(keyAttr, rowKey);
        const desc = String(payload.desc || '').trim();
        const metaHtml = metaBuilder ? metaBuilder(payload, tr, rowKey) : '';
        det.innerHTML = `
          <td colspan="7">
            <div class="slbMktDetailBox">
              ${desc ? `<div class="slbMktDetailDesc">${escapeHtml(desc).replace(/\n/g,'<br>')}</div>` : `<div class="slbMktDetailDesc" style="color:var(--muted);">No description.</div>`}
              ${metaHtml ? `<div class="slbMktDetailMeta">${metaHtml}</div>` : ``}
            </div>
          </td>
        `;
        tr.after(det);
        tr.classList.add('open');
        tr.setAttribute('aria-expanded','true');
      }
      body.querySelectorAll(rowSelector).forEach(tr => {
        tr.addEventListener('click', (e)=>{
          if(e.target.closest('button,input,textarea,select,a,label')) return;
          toggleRow(tr);
        });
        tr.addEventListener('keydown', (e)=>{
          if(e.key === 'Enter' || e.key === ' '){
            if(e.target.closest('button,input,textarea,select,a,label')) return;
            e.preventDefault();
            toggleRow(tr);
          }
          if(e.key === 'Escape') closeAllDetails();
        });
      });
    }

    function canCancelOrder(status){
      const s = canonOrderStatus(status);
      return !s || ["PLACED","PENDING","CREATED","WAITING","NEW","OPEN"].includes(s);
    }
    function canConfirmReceived(status){
      const s = canonOrderStatus(status);
      return ["DELIVERED","SENT"].includes(s);
    }
    function canAcceptSale(status){
      const s = canonOrderStatus(status);
      return !s || ["PLACED","PENDING","CREATED","WAITING","NEW","OPEN","PAID"].includes(s);
    }
    function canMarkDelivered(status){
      const s = canonOrderStatus(status);
      return ["ACCEPTED","IN_PROGRESS"].includes(s);
    }
    function isClosedOrderStatus(status){
      const s = canonOrderStatus(status);
      return ["COMPLETED","COMPLETE","CONFIRMED","RECEIVED","CLOSED","CANCELLED","CANCELED","REFUNDED","FAILED","EXPIRED"].includes(s);
    }
    function orderSortRank_(status){
      return isClosedOrderStatus(status) ? 1 : 0;
    }
    function sortOrdersList_(list){
      return list.slice().sort((a,b) => {
        const rankDiff = orderSortRank_(a.status) - orderSortRank_(b.status);
        if(rankDiff) return rankDiff;
        const timeDiff = Number(b.sortTs || 0) - Number(a.sortTs || 0);
        if(timeDiff) return timeDiff;
        return String(b.orderId || '').localeCompare(String(a.orderId || ''));
      });
    }
    function isClosedSaleStatus(status){
      return isClosedOrderStatus(status);
    }
    function saleSortRank_(status){
      return isClosedSaleStatus(status) ? 1 : 0;
    }
    function sortSalesList_(list){
      return list.slice().sort((a,b) => {
        const rankDiff = saleSortRank_(a.status) - saleSortRank_(b.status);
        if(rankDiff) return rankDiff;
        const timeDiff = Number(b.sortTs || 0) - Number(a.sortTs || 0);
        if(timeDiff) return timeDiff;
        return String(b.orderId || '').localeCompare(String(a.orderId || ''));
      });
    }

    function splitOfferDescriptionForEdit_(raw){
      const txt = String(raw || '').replace(/\r\n/g, '\n').trim();
      if(!txt) return { desc:'', delivery:'' };
      const marker = '\n\nDelivery / Contact:\n';
      const marker2 = 'Delivery / Contact:\n';
      const idx = txt.lastIndexOf(marker);
      if(idx >= 0){
        return { desc: txt.slice(0, idx).trim(), delivery: txt.slice(idx + marker.length).trim() };
      }
      if(txt.indexOf(marker2) === 0){
        return { desc:'', delivery: txt.slice(marker2.length).trim() };
      }
      return { desc: txt, delivery:'' };
    }
    function offerFormSetEditing_(offer){
      const o = normalizeOffer(offer || {});
      const parts = splitOfferDescriptionForEdit_(o.desc || '');
      try{ if(el("tywOfferTitle")) el("tywOfferTitle").value = String(o.title || ''); }catch(_e){}
      try{ if(el("tywOfferDesc")) el("tywOfferDesc").value = String(parts.desc || ''); }catch(_e){}
      try{ if(el("tywOfferDelivery")) el("tywOfferDelivery").value = String(parts.delivery || ''); }catch(_e){}
      try{ if(el("tywOfferPrice")) el("tywOfferPrice").value = String(Number.isFinite(Number(o.price)) ? Number(o.price) : ''); }catch(_e){}
      try{ if(el("tywOfferQty")) el("tywOfferQty").value = String(Number.isFinite(Number(o.stock)) ? Number(o.stock) : 1); }catch(_e){}
      try{
        const btn = el("tywOfferPostBtn");
        if(btn){
          btn.setAttribute('data-edit-offer-id', String(o.offerId || ''));
          btn.textContent = 'Update Offer';
        }
      }catch(_e){}
      try{ setMsg(el("tywOfferOk"), 'Editing offer. Update the fields and click Update Offer.', true); }catch(_e){}
      try{ clearMsg(el("tywOfferMsg")); }catch(_e){}
      try{ const first = el("tywOfferTitle"); if(first && first.focus) first.focus(); }catch(_e){}
    }
    function offerFormClearEditing_(){
      try{
        const btn = el("tywOfferPostBtn");
        if(btn){
          btn.removeAttribute('data-edit-offer-id');
          btn.textContent = 'Post Offer';
        }
      }catch(_e){}
    }

    function renderMyOffers(){
      const body = el("tywMyOffersBody");
      if(!body) return;

      const toggleBtn = el("tywMyOffersShowInactiveBtn");
      if(toggleBtn){
        toggleBtn.textContent = S.p3.myOffersShowInactive ? "Hide Inactive" : "Show Inactive";
      }

      body.innerHTML = "";

      const listAll = (S.p3.mineOffers || []).map(normalizeOffer);
      const list = S.p3.myOffersShowInactive ? listAll : listAll.filter(o => {
        const st = String(o.status || "").trim().toUpperCase();
        return (!st || st === "PUBLISHED");
      });

      if(!list.length){
        const tr = document.createElement("tr");
        tr.innerHTML = `<td colspan="5" style="color:var(--muted);padding:12px;">No offers yet.</td>`;
        body.appendChild(tr);
        return;
      }

      list.forEach(o => {
        const tr = document.createElement("tr");
        const isDeleted = String(o.status||"").toUpperCase() === "DELETED";
        const isPending = !!o.__pending;
        const isFailed = !!o.__failed;
        const pill = isDeleted ? `<span class="pill off">DEL</span>` : (isFailed ? `<span class="pill off">FAIL</span>` : (isPending ? `<span class="pill pending">SYNC</span>` : statusPill(o.enabled)));

        const actions = isDeleted
          ? `<span style="color:var(--muted);font-size:12px;">Deleted</span>`
          : (isFailed
            ? `<button class="btn soft mini" data-resync="${escapeHtml(o.offerId)}">Resync</button>`
            : (isPending
              ? `<span style="color:var(--muted);font-size:12px;">Syncing…</span>`
              : `
            <button class="btn soft mini" data-edit="${escapeHtml(o.offerId)}">Edit</button>
            <button class="btn soft mini" data-toggle="${escapeHtml(o.offerId)}">${o.enabled ? "Disable" : "Enable"}</button>
            <button class="btn soft mini" data-save="${escapeHtml(o.offerId)}">Save</button>
            <button class="btn danger mini" data-del="${escapeHtml(o.offerId)}">Delete</button>
          `));
tr.innerHTML = `
          <td>${pill}</td>
          <td><b>${escapeHtml(o.title)}</b></td>
          <td><input class="qtyMini" data-price="${escapeHtml(o.offerId)}" value="${escapeHtml(String(o.price))}" inputmode="decimal" ${(isDeleted||isPending) ? "disabled" : ""}></td>
          <td><input class="qtyMini" data-stock="${escapeHtml(o.offerId)}" value="${escapeHtml(String(o.stock))}" inputmode="numeric" ${(isDeleted||isPending) ? "disabled" : ""}></td>
          <td style="display:flex;gap:8px;flex-wrap:wrap;">${actions}</td>
        `;
        body.appendChild(tr);
      });

      body.querySelectorAll("button[data-edit]").forEach(btn => {
        btn.addEventListener("click", () => {
          const id = btn.getAttribute("data-edit");
          const offer = (S.p3.mineOffers || []).map(normalizeOffer).find(x => x.offerId === id);
          if(!offer) return;
          offerFormSetEditing_(offer);
        });
      });

      body.querySelectorAll("button[data-toggle]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-toggle");
          const offer = (S.p3.mineOffers || []).map(normalizeOffer).find(x => x.offerId === id);
          if(!offer) return;
          const unlock = lockBtn(btn, "Updating…");
          try{
            setBusy(true);
            await rpcTryCached("p3_offerToggle", P3.offerToggle, { offerId:id, enabled: !offer.enabled });
            await loadMyOffers();
          }catch(e){
            alert(e.message || String(e));
          }finally{ setBusy(false); unlock(); }
        });
      });

      body.querySelectorAll("button[data-save]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-save");
          const priceInp = body.querySelector(`input[data-price="${CSS.escape(id)}"]`);
          const stockInp = body.querySelector(`input[data-stock="${CSS.escape(id)}"]`);
          const price = toNum(priceInp ? priceInp.value : "");
          const stock = toInt(stockInp ? stockInp.value : "");
          if(!Number.isFinite(price) || price <= 0) return alert("Price must be > 0.");
          if(!Number.isFinite(stock) || stock < 0) return alert("Invalid stock.");

          const unlock = lockBtn(btn, "Saving…");
          try{
            setBusy(true);
            const cur = (S.p3.mineOffers || []).map(normalizeOffer).find(o => o.offerId === id);
            if(!cur) throw new Error("Offer not found (reload list).");
            const status = cur.enabled ? "PUBLISHED" : "DRAFT";
            await rpcTryCached("p3_offerSetPrice", P3.offerSetPrice, {
              offerId: id,
              title: cur.title,
              description: cur.desc || "",
              price,
              qty: stock,
              status
            });
            await loadMyOffers();
          }catch(e){
            alert(e.message || String(e));
          }finally{ setBusy(false); unlock(); }
        });
      });

      body.querySelectorAll("button[data-del]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-del");
          if(!id) return;
          if(!confirm("Delete this offer? It will be removed from Market. Past orders keep history.")) return;
          const unlock = lockBtn(btn, "Deleting…");
          try{
            setBusy(true);
            await rpcTryCached("p3_offerDelete", P3.offerDelete, { offerId:id });
            await loadMyOffers();
          }catch(e){
            alert(e.message || String(e));
          }finally{ setBusy(false); unlock(); }
        });
      });
      body.querySelectorAll("button[data-resync]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-resync");
          if(!id) return;
          const offer = (S.p3.mineOffers || []).find(x => x && x.offerId === id);
          if(!offer) return;

          // mark pending again
          offer.__pending = true;
          offer.__failed = false;
          renderMyOffers();
          renderMarket();

          const payload = offer.__payload || {
            title: offer.title || "",
            description: offer.description || offer.desc || "",
            price: offer.price,
            qty: offer.qty || offer.stock || 0,
            status: "PUBLISHED"
          };

          const tmpId = id;
          try{
            const out = await rpcTryCached("p3_offerCreate", P3.offerCreate, Object.assign({ offerId:"" }, payload));
            const realId = out && (out.offerId || (out.offer && out.offer.offerId)) ? String(out.offerId || (out.offer && out.offer.offerId)) : "";
            if(!realId) throw new Error("Offer created but missing offerId.");

            // replace ids
            const fixList = (arrName) => {
              const arr = S.p3[arrName];
              if(!Array.isArray(arr)) return;
              const i = arr.findIndex(x => x && x.offerId === tmpId);
              if(i >= 0){
                arr[i] = Object.assign({}, arr[i], { offerId: realId, __pending: false, __tmp: false, __failed: false });
              }
            };
            fixList("mineOffers");
            fixList("marketOffers");
            renderMyOffers(); renderMarket();
            try{ await Promise.all([loadMyOffers(), loadMarket()]); }catch(_e){}
          }catch(e){
            offer.__pending = false;
            offer.__failed = true;
            offer.__failMsg = (e.message || String(e));
            renderMyOffers(); renderMarket();
            alert(e.message || String(e));
          }finally{
            offer.__pending = false;
          }
        });
      });

    }

    function renderMarket(){
      const body = el("tywMarketBody");
      if(!body) return;
      body.innerHTML = "";

      const listAll = (S.p3.marketOffers || []).map(normalizeOffer).filter(o => o.enabled && o.stock > 0);

      // ===== Quick Buy deep link =====
      function _slbParseMarketBuy(){
        try{
          var raw = String(location.hash||"").replace(/^#/,"");
          if(!raw) return null;
          var sp = null;
          if(raw.indexOf("tab=") === 0 || raw.indexOf("?tab=") === 0){
            var qsOnly = raw.replace(/^\?/,"").replace(/&amp;/g,"&");
            sp = new URLSearchParams(qsOnly);
          }else{
            var parts = raw.split("?");
            var qs = String(parts[1]||"").replace(/&amp;/g,"&");
            sp = new URLSearchParams(qs);
          }
          if(!sp) return null;
          var buy = sp.get("buy") || sp.get("amp;buy") || "";
          buy = String(buy||"").trim();
          if(!buy) return null;
          var map = new Map();
          buy.split(",").forEach(function(tok){
            tok = String(tok||"").trim();
            if(!tok) return;
            var p = tok.split(":");
            var id = String(p[0]||"").trim();
            if(!id) return;
            var q = parseInt(String(p[1]||"1").trim(), 10);
            if(!Number.isFinite(q) || q <= 0) q = 1;
            map.set(id, q);
          });
          return map.size ? map : null;
        }catch(_e){}
        return null;
      }

      function _slbBuildMarketBuyLink(items){
        try{
          var baseUrl = String(location.href||"").split("#")[0];
          var buyStr = (items||[]).map(function(it){
            return String(it.id||"").trim() + ":" + String(it.qty||1);
          }).filter(Boolean).join(",");
          var sp = new URLSearchParams();
          sp.set("tab","goldenCenter");
          sp.set("golden","market");
          sp.set("buy", buyStr);
          return baseUrl + "#" + sp.toString();
        }catch(_e){}
        return "";
      }

      function _slbCopyTextSync(t){
        try{
          var ta = document.createElement("textarea");
          ta.value = String(t||"");
          ta.setAttribute("readonly","");
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          ta.style.top = "0";
          document.body.appendChild(ta);
          ta.select();
          var ok = document.execCommand("copy");
          document.body.removeChild(ta);
          return !!ok;
        }catch(_e){}
        return false;
      }

      function _slbCopyText(t){
        var s = String(t||"").trim();
        if(!s) return Promise.resolve(false);
        var ok = _slbCopyTextSync(s);
        if(ok) return Promise.resolve(true);
        try{
          if(navigator && navigator.clipboard && navigator.clipboard.writeText){
            return navigator.clipboard.writeText(s).then(function(){ return true; }, function(){ return false; });
          }
        }catch(_e){}
        return Promise.resolve(false);
      }

      var quickMap = _slbParseMarketBuy();
      var list = listAll;
      if(quickMap){
        list = listAll.filter(function(o){ return quickMap.has(String(o.offerId||"")); });
      }

      // Banner for Quick Buy mode
      try{
        var panel = document.getElementById("slbMarketPanel") || body.closest("#slbMarketPanel") || body.parentElement;
        if(panel){
          var existing = panel.querySelector("#slbMktQuickBuyBar");
          if(existing) existing.remove();
          if(quickMap){
            var bar = document.createElement("div");
            bar.id = "slbMktQuickBuyBar";
            bar.className = "slbMktQuickBuyBar";
            bar.innerHTML = '<div><b>Quick Buy Link</b> — showing ' + quickMap.size + ' item(s)</div>' +
              '<button type="button" class="btn soft mini" id="slbMktShowAllBtn">Show Full Market</button>';
            panel.insertBefore(bar, panel.firstChild);
            var b = bar.querySelector("#slbMktShowAllBtn");
            if(b){
              b.addEventListener("click", function(){
                try{
                  var baseUrl = String(location.href||"").split("#")[0];
                  location.hash = "#tab=goldenCenter&golden=market";
                  if(history && history.replaceState) history.replaceState(null, "", baseUrl + "#tab=goldenCenter&golden=market");
                }catch(_e){}
                try{ if(window.SLB_route && window.SLB_route.applyFromHash) window.SLB_route.applyFromHash(); }catch(_e2){}
              });
            }
          }
        }
      }catch(_e){}
      const byId = new Map(list.map(o => [String(o.offerId||""), o]));

      if(!list.length){
        const tr = document.createElement("tr");
        tr.innerHTML = `<td colspan="6" style="color:var(--muted);padding:12px;">No active offers.</td>`;
        body.appendChild(tr);
        return;
      }

      list.forEach(o => {
        const sellerLabel = (o.sellerName ? `${o.sellerName}` : o.sellerCallsign) || "—";
        const offerId = String(o.offerId || "");
        const q0 = (quickMap && quickMap.has(offerId)) ? (quickMap.get(offerId) || 1) : 1;
        const delivery = String(o.delivery || "").trim();
        const desc = String(o.desc || "").trim();
        const descShort = desc ? (desc.length > 120 ? (desc.slice(0,120) + "…") : desc) : "";

        const tr = document.createElement("tr");
        tr.className = "slbMktRow";
        tr.setAttribute("data-offer", offerId);
        tr.setAttribute("role","button");
        tr.setAttribute("tabindex","0");

        tr.innerHTML = `
          <td>
            <div class="slbMktTitleRow">
              <b>${escapeHtml(o.title)}</b>
              <span class="slbMktChevron" aria-hidden="true">▾</span>
            </div>
            ${delivery ? `<div class="slbMktMeta">${escapeHtml(delivery)}</div>` : ``}
            ${descShort ? `<div class="slbMktDescPrev">${escapeHtml(descShort)}</div>` : ``}
          </td>
          <td>${escapeHtml(sellerLabel)}</td>
          <td><b>${money(o.price)}</b></td>
          <td>${escapeHtml(String(o.stock))}</td>
          <td><input class="qtyMini" data-buyqty="${escapeHtml(offerId)}" value="${escapeHtml(String(q0))}" inputmode="numeric"></td>
          <td><div class="slbMktActRow"><button class="btn orange mini" data-buy="${escapeHtml(offerId)}">Buy</button><button class="btn soft mini slbMktLinkBtn" data-link="${escapeHtml(offerId)}" title="Copy buy link" aria-label="Copy buy link">🔗</button></div></td>
        `;
        body.appendChild(tr);
      });

      // Buy handlers
      body.querySelectorAll("button[data-buy]").forEach(btn => {
        btn.addEventListener("click", async (e) => {
          e.stopPropagation();
          const id = btn.getAttribute("data-buy");
          const qtyInp = body.querySelector(`input[data-buyqty="${CSS.escape(id)}"]`);
          const qty = toInt(qtyInp ? qtyInp.value : "1");
          if(!Number.isFinite(qty) || qty <= 0) return alert("Invalid qty.");
          const unlock = lockBtn(btn, "Buying…");
          try{
            setBusy(true);
            clearMsg(el("tywMarketMsg")); clearMsg(el("tywMarketOk"));
            
            const prof = (S.dash && S.dash.profile) ? S.dash.profile : null;
            const canSpend = !!(prof && (prof.isAdmin || prof.canCreatePouches));
            if(!canSpend) throw new Error("Spending is not enabled. You are in Saving/Receive mode.");

            const accounts = (S.dash && S.dash.accounts) ? S.dash.accounts : [];
            const pouches = accounts.filter(a => a && !isOnHand(a) && String(a.status||"ACTIVE").toUpperCase() === "ACTIVE");
            if(!pouches.length) throw new Error("You need at least 1 Cosmic Pouch to buy. Transfer stones into a pouch first.");

            let payAccountId = "";
            if(pouches.length === 1){
              payAccountId = String(pouches[0].accountId || pouches[0].walletId || "");
            }else{
              const lines = pouches.map((p,i)=> `${i+1}) ${displayAcctName(p.name)} — bal ${money(p.balance)}`);
              const pick = prompt("Pay from which Cosmic Pouch? Enter number:\n" + lines.join("\n"), "1");
              if(pick == null) return;
              const n = parseInt(String(pick).trim(), 10);
              if(!Number.isFinite(n) || n < 1 || n > pouches.length) throw new Error("Invalid selection.");
              const p = pouches[n-1];
              payAccountId = String(p.accountId || p.walletId || "");
            }
            if(!payAccountId) throw new Error("Pick a Cosmic Pouch to pay from.");

            await rpcTryCached("p3_orderCreate", P3.orderCreate, { offerId:id, qty, payAccountId });

            setMsg(el("tywMarketOk"), "Order placed. Check My Orders.", true);
            await Promise.all([loadMarket(), loadMyOrders(), refreshDashboardLite()]);
          }catch(e){
            setMsg(el("tywMarketMsg"), e.message || String(e), false);
          }finally{ setBusy(false); unlock(); }
        });
      });

      // Link buttons (copy Quick Buy link)
      body.querySelectorAll("button[data-link]").forEach(btn => {
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          const id = btn.getAttribute("data-link") || "";
          const qtyInp = body.querySelector(`input[data-buyqty="${CSS.escape(id)}"]`);
          const qty = toInt(qtyInp ? qtyInp.value : "1");
          const q = (Number.isFinite(qty) && qty > 0) ? qty : 1;
          const link = _slbBuildMarketBuyLink([{ id, qty: q }]);
          if(!link) return;
          _slbCopyText(link).then(function(ok){
            try{ toast(ok ? "ok" : "err", ok ? "Buy link copied." : "Copy failed."); }catch(_e){}
            if(!ok){
              try{ prompt("Copy this buy link:", link); }catch(_e2){}
            }
          });
        });
      });


      // Expand details (click row)
      function closeAllDetails(){
        body.querySelectorAll('tr.slbMktDetailRow').forEach(n => n.remove());
        body.querySelectorAll('tr.slbMktRow.open').forEach(n => n.classList.remove('open'));
      }

      function toggleRow(tr){
        const offerId = tr.getAttribute('data-offer') || '';
        if(!offerId) return;
        const next = tr.nextElementSibling;
        if(next && next.classList.contains('slbMktDetailRow') && (next.getAttribute('data-offer') === offerId)){
          next.remove();
          tr.classList.remove('open');
          return;
        }
        closeAllDetails();
        const o = byId.get(offerId);
        if(!o) return;
        const sellerLabel = (o.sellerName ? `${o.sellerName}` : o.sellerCallsign) || '—';
        const delivery = String(o.delivery || '').trim();
        const desc = String(o.desc || '').trim();

        const det = document.createElement('tr');
        det.className = 'slbMktDetailRow';
        det.setAttribute('data-offer', offerId);
        det.innerHTML = `
          <td colspan="6">
            <div class="slbMktDetailBox">
              ${desc ? `<div class="slbMktDetailDesc">${escapeHtml(desc).replace(/\n/g,'<br>')}</div>` : `<div class="slbMktDetailDesc" style="color:var(--muted);">No description.</div>`}
              <div class="slbMktDetailMeta">
                <span><b>Seller:</b> ${escapeHtml(sellerLabel)}</span>
                ${delivery ? `<span><b>Delivery:</b> ${escapeHtml(delivery)}</span>` : ``}
              </div>
            </div>
          </td>
        `;
        tr.after(det);
        tr.classList.add('open');
      }

      body.querySelectorAll('tr.slbMktRow').forEach(tr => {
        tr.addEventListener('click', (e)=>{
          if(e.target.closest('button,input,textarea,select,a,label')) return;
          toggleRow(tr);
        });
        tr.addEventListener('keydown', (e)=>{
          if(e.key === 'Enter' || e.key === ' '){
            if(e.target.closest('button,input,textarea,select,a,label')) return;
            e.preventDefault();
            toggleRow(tr);
          }
          if(e.key === 'Escape') closeAllDetails();
        });
      });
    }

    function renderOrders(){
      const panel = el("slbOrdersPanel");
      if(panel) panel.classList.remove("slbTimeReady");
      const body = el("tywOrdersBody");
      if(!body) return;
      body.innerHTML = "";

      const hideClosedBtn = el("tywOrdersHideClosedBtn");
      if(hideClosedBtn){
        hideClosedBtn.textContent = S.p3.myOrdersHideClosed ? "Show Completed" : "Hide Completed";
        hideClosedBtn.classList.toggle("active", !!S.p3.myOrdersHideClosed);
      }

      const listAll = sortOrdersList_((S.p3.myOrders || []).map(normalizeOrder));
      const list = S.p3.myOrdersHideClosed ? listAll.filter(o => !isClosedOrderStatus(o.status)) : listAll;

      if(!list.length){
        const tr = document.createElement("tr");
        tr.innerHTML = `<td colspan="7" style="color:var(--muted);padding:12px;">${S.p3.myOrdersHideClosed ? "No open orders." : "No orders."}</td>`;
        body.appendChild(tr);
        return;
      }

      list.forEach(o => {
        const actions = [];
        if(canCancelOrder(o.status)) actions.push(`<button class="btn soft mini" data-ocancel="${escapeHtml(o.orderId)}">Cancel</button>`);
        if(canConfirmReceived(o.status)) actions.push(`<button class="btn orange mini" data-orecv="${escapeHtml(o.orderId)}">Confirm Received</button>`);
                if(o.orderId) actions.push(`<button class="btn soft mini slbCopyBtn slbIconBtn slbCopyTiny" data-copy="${escapeHtml(o.orderId)}" title="Copy ID" aria-label="Copy ID"><span class="slbIco">⧉</span></button>`);
const tr = document.createElement("tr");
        tr.className = "slbMktRow slbOrderRow";
        tr.setAttribute("data-order", o.orderId || "");
        tr.tabIndex = 0;
        tr.setAttribute("role","button");
        tr.setAttribute("aria-expanded","false");
        tr.innerHTML = `
          <td>${escapeHtml(o.time || "")}</td>
          <td><b>${escapeHtml(o.offerTitle || "")}</b></td>
          <td>${escapeHtml(o.sellerCallsign || o.sellerName || "")}</td>
          <td>${escapeHtml(String(o.qty))}</td>
          <td><b>${money(o.total)}</b></td>
          <td>${escapeHtml(o.status || "")}</td>
          <td style="display:flex;gap:8px;flex-wrap:wrap;min-width:190px;">${actions.join("") || `<span style="color:var(--muted);">—</span>`}</td>
        `;
        body.appendChild(tr);
      });

      bindOrderLikeRowDetails_(body, 'tr.slbOrderRow', 'data-order', (_tr, rowKey)=>{
        const o = list.find(x => String(x.orderId || '') === String(rowKey || '')) || null;
        const detail = getOrderDetailPayload_(o || {});
        const sellerLabel = (o && (o.sellerCallsign || o.sellerName)) || '—';
        return Object.assign({}, detail, { sellerLabel });
      }, (payload)=>[
        `<div class="slbMktMetaLine"><b>Seller:</b> ${escapeHtml(payload.sellerLabel || '—')}</div>`,
        payload.delivery ? `<div class="slbMktMetaLine"><b>Delivery:</b> ${escapeHtml(payload.delivery)}</div>` : ``
      ].filter(Boolean).join(''));

      if(panel) panel.classList.add("slbTimeReady");

      body.querySelectorAll("button[data-ocancel]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-ocancel");
          if(!confirm("Cancel this order?")) return;
          const unlock = lockBtn(btn, "Cancelling…");
          try{
            setBusy(true);
            clearMsg(el("tywOrdersMsg")); clearMsg(el("tywOrdersOk"));
            await rpcTryCached("p3_orderCancel", P3.orderCancel, { orderId:id });
            setMsg(el("tywOrdersOk"), "Order cancelled.", true);
            await Promise.all([loadMyOrders(), refreshDashboardLite(), loadMarket()]);
          }catch(e){
            setMsg(el("tywOrdersMsg"), e.message || String(e), false);
          }finally{ setBusy(false); unlock(); }
        });
      });

      body.querySelectorAll("button[data-orecv]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-orecv");
          if(!confirm("Confirm received? This releases the hold to the seller.")) return;
          const unlock = lockBtn(btn, "Confirming…");
          try{
            setBusy(true);
            clearMsg(el("tywOrdersMsg")); clearMsg(el("tywOrdersOk"));
            await rpcTryCached("p3_orderConfirmReceived", P3.orderConfirmReceived, { orderId:id });
            setMsg(el("tywOrdersOk"), "Confirmed. Hold released.", true);
            await Promise.all([loadMyOrders(), loadMySales(), refreshDashboardLite()]);
          }catch(e){
            setMsg(el("tywOrdersMsg"), e.message || String(e), false);
          }finally{ setBusy(false); unlock(); }
        });
      });
    }

    function renderSales(){
      const panel = el("slbSalesPanel");
      if(panel) panel.classList.remove("slbTimeReady");
      const body = el("tywSalesBody");
      if(!body) return;
      body.innerHTML = "";

      const hideClosedBtn = el("tywSalesHideClosedBtn");
      if(hideClosedBtn){
        hideClosedBtn.textContent = S.p3.mySalesHideClosed ? "Show Closed" : "Hide Closed";
        hideClosedBtn.classList.toggle("active", !!S.p3.mySalesHideClosed);
      }

      const listAll = sortSalesList_((S.p3.mySales || []).map(normalizeOrder));
      const list = S.p3.mySalesHideClosed ? listAll.filter(o => !isClosedSaleStatus(o.status)) : listAll;

      if(!list.length){
        const tr = document.createElement("tr");
        tr.innerHTML = `<td colspan="7" style="color:var(--muted);padding:12px;">${S.p3.mySalesHideClosed ? "No open sales." : "No sales."}</td>`;
        body.appendChild(tr);
        return;
      }

      list.forEach(o => {
        const actions = [];
        if(canAcceptSale(o.status)) actions.push(`<button class="btn orange mini" data-saccept="${escapeHtml(o.orderId)}">Accept</button>`);
        if(canMarkDelivered(o.status)) actions.push(`<button class="btn orange mini" data-sdeliv="${escapeHtml(o.orderId)}">Mark Delivered</button>`);
        if(o.orderId) actions.push(`<button class="btn soft mini slbCopyBtn slbIconBtn slbCopyTiny" data-copy="${escapeHtml(o.orderId)}" title="Copy ID" aria-label="Copy ID"><span class="slbIco">⧉</span></button>`);
        const buyerLabel = o.buyerCallsign || o.buyerName || "";
        const tr = document.createElement("tr");
        tr.className = "slbMktRow slbSaleRow";
        tr.setAttribute("data-order", o.orderId || "");
        tr.tabIndex = 0;
        tr.setAttribute("role","button");
        tr.setAttribute("aria-expanded","false");
        tr.innerHTML = `
          <td>${escapeHtml(o.time || "")}</td>
          <td><b>${escapeHtml(o.offerTitle || "")}</b></td>
          <td>${escapeHtml(buyerLabel)}</td>
          <td>${escapeHtml(String(o.qty))}</td>
          <td><b>${money(o.total)}</b></td>
          <td>${escapeHtml(o.status || "")}</td>
          <td style="display:flex;gap:8px;flex-wrap:wrap;min-width:190px;">${actions.join("") || `<span style="color:var(--muted);">—</span>`}</td>
        `;
        body.appendChild(tr);
      });

      bindOrderLikeRowDetails_(body, 'tr.slbSaleRow', 'data-order', (_tr, rowKey)=>{
        const o = list.find(x => String(x.orderId || '') === String(rowKey || '')) || null;
        const detail = getOrderDetailPayload_(o || {});
        const buyerLabel = (o && (o.buyerCallsign || o.buyerName)) || '—';
        return Object.assign({}, detail, { buyerLabel });
      }, (payload)=>[
        `<div class="slbMktMetaLine"><b>Buyer:</b> ${escapeHtml(payload.buyerLabel || '—')}</div>`,
        payload.delivery ? `<div class="slbMktMetaLine"><b>Delivery:</b> ${escapeHtml(payload.delivery)}</div>` : ``
      ].filter(Boolean).join(''));

      if(panel) panel.classList.add("slbTimeReady");

      body.querySelectorAll("button[data-saccept]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-saccept");
          const unlock = lockBtn(btn, "Accepting…");
          try{
            setBusy(true);
            clearMsg(el("tywSalesMsg")); clearMsg(el("tywSalesOk"));
            await rpcTryCached("p3_saleAccept", P3.saleAccept, { orderId:id, status:"IN_PROGRESS" });
            setMsg(el("tywSalesOk"), "Accepted. You can deliver now.", true);
            await loadMySales();
          }catch(e){
            setMsg(el("tywSalesMsg"), e.message || String(e), false);
          }finally{ setBusy(false); unlock(); }
        });
      });

      body.querySelectorAll("button[data-sdeliv]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const id = btn.getAttribute("data-sdeliv");
          const unlock = lockBtn(btn, "Updating…");
          try{
            setBusy(true);
            clearMsg(el("tywSalesMsg")); clearMsg(el("tywSalesOk"));
            await rpcTryCached("p3_saleMarkDelivered", P3.saleMarkDelivered, { orderId:id, status:"DELIVERED" });
            setMsg(el("tywSalesOk"), "Marked delivered. Buyer must confirm.", true);
            await Promise.all([loadMySales(), loadMyOrders()]);
          }catch(e){
            setMsg(el("tywSalesMsg"), e.message || String(e), false);
          }finally{ setBusy(false); unlock(); }
        });
      });
    }

    function phase3LoadMeta_(tab){
      return ({
        offer:{body:"tywMyOffersBody",cols:5,label:"offers"},
        market:{body:"tywMarketBody",cols:6,label:"market"},
        orders:{body:"tywOrdersBody",cols:7,label:"orders"},
        sales:{body:"tywSalesBody",cols:7,label:"sales"}
      })[tab] || null;
    }
    function phase3ShowLoading_(tab){
      const meta=phase3LoadMeta_(tab),body=meta&&el(meta.body);
      if(body && !body.children.length) body.innerHTML=`<tr class="slbP3LoadState"><td colspan="${meta.cols}" style="padding:14px;color:var(--muted);">Loading ${meta.label}…</td></tr>`;
    }
    function phase3ShowError_(tab,error){
      const meta=phase3LoadMeta_(tab),body=meta&&el(meta.body);
      const text=(error&&error.message)?error.message:String(error||"Could not load data.");
      S.p3.errors=S.p3.errors||{}; S.p3.errors[tab]=text;
      if(body) body.innerHTML=`<tr class="slbP3LoadState slbP3LoadError"><td colspan="${meta.cols}" style="padding:14px;"><strong>Could not load ${meta.label}.</strong><div class="note">${escapeHtml(text)}</div></td></tr>`;
      setPhase3HintAll(text);
    }
    function phase3ClearError_(tab){
      S.p3.errors=S.p3.errors||{}; S.p3.errors[tab]="";
    }

    // Golden Center can open before the Apps Script read path has warmed up.
    // Retry the actual source loader automatically so Reload is never required.
    const phase3GoldenRetryCount_ = {offer:0,market:0,orders:0,sales:0};
    const phase3GoldenRetryTimers_ = {};
    function phase3GoldenCenterVisible_(){
      const panel=el("slbGoldenCenterPanel");
      return !!(panel && !panel.classList.contains("hidden"));
    }
    function phase3GoldenAutoRetry_(tab,loader,result){
      if(!phase3GoldenCenterVisible_() || typeof loader!=="function") return;
      const hasRows=!!(result && result.ok && Number(result.count||0)>0);
      if(hasRows){
        phase3GoldenRetryCount_[tab]=0;
        if(phase3GoldenRetryTimers_[tab]) clearTimeout(phase3GoldenRetryTimers_[tab]);
        delete phase3GoldenRetryTimers_[tab];
        return;
      }
      const attempt=Number(phase3GoldenRetryCount_[tab]||0);
      if(attempt>=4 || phase3GoldenRetryTimers_[tab]) return;
      const delays=[700,1500,3000,5200];
      phase3GoldenRetryCount_[tab]=attempt+1;
      phase3GoldenRetryTimers_[tab]=setTimeout(async function(){
        delete phase3GoldenRetryTimers_[tab];
        if(!phase3GoldenCenterVisible_()) return;
        try{ await loader(); }catch(_e){}
      },delays[Math.min(attempt,delays.length-1)]);
    }

    // ====== Phase 3 loaders ======
    async function loadMyOffers(){
      phase3ShowLoading_("offer");
      // Instant UI: show cached data first
      try{
        const c = slbCacheGet_("p3_mineOffers", 7*24*60*60*1000);
        if(c && Array.isArray(c) && (!S.p3.mineOffers || !S.p3.mineOffers.length)){
          S.p3.mineOffers = c;
          try{ renderMyOffers(); }catch(_e){}
        }
      }catch(_e){}

      try{
        const out = await rpcTryCached("p3_offerListMine", P3.offerListMine, {});
        S.p3.mineOffers = (out && out.offers) ? out.offers : (Array.isArray(out) ? out : []);
        
        try{ slbCacheSet_("p3_mineOffers", S.p3.mineOffers); }catch(_e){}renderMyOffers();
        S.p3.ok = true;
        try{ S.p3.loaded.offer = true; }catch(_e){}
        phase3ClearError_("offer");
        setPhase3HintAll("");
        const result={ok:true,count:S.p3.mineOffers.length}; phase3GoldenAutoRetry_("offer",loadMyOffers,result); return result;
      }catch(e){
        S.p3.ok = false;
        try{ S.p3.loaded.offer = false; }catch(_e){}
        if(S.p3.mineOffers && S.p3.mineOffers.length) renderMyOffers(); else phase3ShowError_("offer",e);
        const result={ok:false,error:(e&&e.message)?e.message:String(e||"")}; phase3GoldenAutoRetry_("offer",loadMyOffers,result); return result;
      }
    }

    async function loadMarket(){
      phase3ShowLoading_("market");
      // Instant UI: show cached data first
      try{
        const c = slbCacheGet_("p3_marketOffers", 7*24*60*60*1000);
        if(c && Array.isArray(c) && (!S.p3.marketOffers || !S.p3.marketOffers.length)){
          S.p3.marketOffers = c;
          try{ renderMarket(); }catch(_e){}
        }
      }catch(_e){}

      try{
        const out = await rpcTryCached("p3_offerListMarket", P3.offerListMarket, {});
        S.p3.marketOffers = (out && out.offers) ? out.offers : (Array.isArray(out) ? out : []);
        
        try{ slbCacheSet_("p3_marketOffers", S.p3.marketOffers); }catch(_e){}renderMarket();
        S.p3.ok = true;
        try{ S.p3.loaded.market = true; }catch(_e){}
        phase3ClearError_("market");
        setPhase3HintAll("");
        const result={ok:true,count:S.p3.marketOffers.length}; phase3GoldenAutoRetry_("market",loadMarket,result); return result;
      }catch(e){
        S.p3.ok = false;
        try{ S.p3.loaded.market = false; }catch(_e){}
        if(S.p3.marketOffers && S.p3.marketOffers.length) renderMarket(); else phase3ShowError_("market",e);
        const result={ok:false,error:(e&&e.message)?e.message:String(e||"")}; phase3GoldenAutoRetry_("market",loadMarket,result); return result;
      }
    }

    async function loadMyOrders(){
      phase3ShowLoading_("orders");
      // Instant UI: show cached data first
      try{
        const c = slbCacheGet_("p3_myOrders", 7*24*60*60*1000);
        if(c && Array.isArray(c) && (!S.p3.myOrders || !S.p3.myOrders.length)){
          S.p3.myOrders = c;
          try{ renderOrders(); }catch(_e){}
        }
      }catch(_e){}

      try{
        const out = await rpcTryCached("p3_orderListMine", P3.orderListMine, {});
        S.p3.myOrders = (out && out.orders) ? out.orders : (Array.isArray(out) ? out : []);
        
        try{ slbCacheSet_("p3_myOrders", S.p3.myOrders); }catch(_e){}renderOrders();
        S.p3.ok = true;
        try{ S.p3.loaded.orders = true; }catch(_e){}
        phase3ClearError_("orders");
        setPhase3HintAll("");
        const result={ok:true,count:S.p3.myOrders.length}; phase3GoldenAutoRetry_("orders",loadMyOrders,result); return result;
      }catch(e){
        S.p3.ok = false;
        try{ S.p3.loaded.orders = false; }catch(_e){}
        if(S.p3.myOrders && S.p3.myOrders.length) renderOrders(); else phase3ShowError_("orders",e);
        const result={ok:false,error:(e&&e.message)?e.message:String(e||"")}; phase3GoldenAutoRetry_("orders",loadMyOrders,result); return result;
      }
    }

    async function loadMySales(){
      phase3ShowLoading_("sales");
      // Instant UI: show cached data first
      try{
        const c = slbCacheGet_("p3_mySales", 7*24*60*60*1000);
        if(c && Array.isArray(c) && (!S.p3.mySales || !S.p3.mySales.length)){
          S.p3.mySales = c;
          try{ renderSales(); }catch(_e){}
        }
      }catch(_e){}

      try{
        const out = await rpcTryCached("p3_saleListMine", P3.saleListMine, {});
        S.p3.mySales = (out && out.orders) ? out.orders : (Array.isArray(out) ? out : []);
        
        try{ slbCacheSet_("p3_mySales", S.p3.mySales); }catch(_e){}renderSales();
        S.p3.ok = true;
        try{ S.p3.loaded.sales = true; }catch(_e){}
        phase3ClearError_("sales");
        setPhase3HintAll("");
        const result={ok:true,count:S.p3.mySales.length}; phase3GoldenAutoRetry_("sales",loadMySales,result); return result;
      }catch(e){
        S.p3.ok = false;
        try{ S.p3.loaded.sales = false; }catch(_e){}
        if(S.p3.mySales && S.p3.mySales.length) renderSales(); else phase3ShowError_("sales",e);
        const result={ok:false,error:(e&&e.message)?e.message:String(e||"")}; phase3GoldenAutoRetry_("sales",loadMySales,result); return result;
      }
    }

    // UI buttons
    onOnce("tywOfferReloadBtn","click", async () => {
      try{ setBusy(true); await loadMyOffers(); } finally{ setBusy(false); }
    });
    onOnce("tywMyOffersShowInactiveBtn","click", () => {
      S.p3.myOffersShowInactive = !S.p3.myOffersShowInactive;
      try{ localStorage.setItem("slb_myoffers_showinactive", S.p3.myOffersShowInactive ? "1" : "0"); }catch(_e){}
      renderMyOffers();
    });

    onOnce("tywMarketReloadBtn","click", async () => {
      const b = el("tywMarketReloadBtn");
      try{ if(b) b.classList.add("isLoading"); }catch(_e){}
      try{ setBusy(true); await loadMarket(); }
      finally{
        try{ setBusy(false); }catch(_e){}
        try{ if(b) b.classList.remove("isLoading"); }catch(_e){}
      }
    });
    onOnce("tywOrdersReloadBtn","click", async () => {
      const b = el("tywOrdersReloadBtn");
      try{ if(b) b.classList.add("isLoading"); }catch(_e){}
      try{ setBusy(true); await loadMyOrders(); }
      finally{
        try{ setBusy(false); }catch(_e){}
        try{ if(b) b.classList.remove("isLoading"); }catch(_e){}
      }
    });
    onOnce("tywSalesReloadBtn","click", async () => {
      const b = el("tywSalesReloadBtn");
      try{ if(b) b.classList.add("isLoading"); }catch(_e){}
      try{ setBusy(true); await loadMySales(); }
      finally{
        try{ setBusy(false); }catch(_e){}
        try{ if(b) b.classList.remove("isLoading"); }catch(_e){}
      }
    });
    onOnce("tywOrdersHideClosedBtn","click", () => {
      S.p3.myOrdersHideClosed = !S.p3.myOrdersHideClosed;
      try{ localStorage.setItem("slb_myorders_hideclosed", S.p3.myOrdersHideClosed ? "1" : "0"); }catch(_e){}
      renderOrders();
    });
    onOnce("tywSalesHideClosedBtn","click", () => {
      S.p3.mySalesHideClosed = !S.p3.mySalesHideClosed;
      try{ localStorage.setItem("slb_mysales_hideclosed", S.p3.mySalesHideClosed ? "1" : "0"); }catch(_e){}
      renderSales();
    });

    // Post offer (optimistic)
    onOnce("tywOfferPostBtn","click", async () => {
      // Optimistic: insert immediately into tables, then sync in background.
      try{
        setBusy(true);
        clearMsg(el("tywOfferMsg")); clearMsg(el("tywOfferOk"));

        const editingOfferId = String((el("tywOfferPostBtn") && el("tywOfferPostBtn").getAttribute('data-edit-offer-id')) || '').trim();
        const title = String(el("tywOfferTitle").value || "").trim();
        const desc = String(el("tywOfferDesc").value || "").trim();
        const delivery = String(el("tywOfferDelivery").value || "").trim();
        const price = toNum(el("tywOfferPrice").value);
        const stock = toInt(el("tywOfferQty").value);

        if(!title) return setMsg(el("tywOfferMsg"), "Title required.", false);
        if(!Number.isFinite(price) || price <= 0) return setMsg(el("tywOfferMsg"), "Price must be > 0.", false);
        if(!Number.isFinite(stock) || stock < 0) return setMsg(el("tywOfferMsg"), "Invalid stock.", false);

        try{
          ensureMaxLen("Title", title, LIMITS.offerTitle);
          ensureMaxLen("Description", desc, LIMITS.offerDesc);
          ensureMaxLen("Delivery / Contact", delivery, LIMITS.offerDelivery);
        }catch(e){
          return setMsg(el("tywOfferMsg"), e.message || String(e), false);
        }

        const description = (delivery
          ? (desc ? (desc + "\n\nDelivery / Contact:\n" + delivery) : ("Delivery / Contact:\n" + delivery))
          : desc);
        try{ ensureMaxLen("Description", description, LIMITS.offerDesc); }
        catch(e){ return setMsg(el("tywOfferMsg"), e.message || String(e), false); }

        if(editingOfferId){
          const cur = (S.p3.mineOffers || []).map(normalizeOffer).find(x => x.offerId === editingOfferId);
          if(!cur) return setMsg(el("tywOfferMsg"), "Offer not found (reload list).", false);
          const status = cur.enabled ? 'PUBLISHED' : 'DRAFT';
          await rpcTryCached("p3_offerSetPrice", P3.offerSetPrice, { offerId: editingOfferId, title, description, price, qty: stock, status });
          await loadMyOffers();
          await loadMarket();
          el("tywOfferTitle").value = "";
          el("tywOfferDesc").value = "";
          el("tywOfferDelivery").value = "";
          el("tywOfferPrice").value = "";
          el("tywOfferQty").value = "1";
          offerFormClearEditing_();
          return setMsg(el("tywOfferOk"), "Offer updated.", true);
        }

        // 1) optimistic insert
        const tmpId = "tmp_of_" + Date.now() + "_" + Math.random().toString(16).slice(2);
        const tmpOffer = {
          offerId: tmpId,
          title,
          description,
          price,
          qty: stock,
          status: "PUBLISHED",
          enabled: true,
          stock: stock,
          sellerCallsign: (S && S.call ? String(S.call).toUpperCase() : ""),
          __pending: true,
          __tmp: true,
          __createdAt: Date.now(),
          __payload: { title, description, price, qty: stock, status: "PUBLISHED" }
        };

        // keep local lists ready
        S.p3 = S.p3 || {};
        S.p3.mineOffers = Array.isArray(S.p3.mineOffers) ? S.p3.mineOffers : [];
        S.p3.marketOffers = Array.isArray(S.p3.marketOffers) ? S.p3.marketOffers : [];

        // prepend for snappy feel
        S.p3.mineOffers.unshift(tmpOffer);
        S.p3.marketOffers.unshift(tmpOffer);

        renderMyOffers();
        renderMarket();

        // clear form immediately
        el("tywOfferTitle").value = "";
        el("tywOfferDesc").value = "";
        el("tywOfferDelivery").value = "";
        el("tywOfferPrice").value = "";
        el("tywOfferQty").value = "1";

        setMsg(el("tywOfferOk"), "Offer queued (syncing…)", true);

        // 2) background sync (no UI blocking)
        (async () => {
          try{
            const out = await rpcTryCached("p3_offerCreate", P3.offerCreate, {
              offerId: "",
              title,
              description,
              price,
              qty: stock,
              status: "PUBLISHED"
            });

            const realId = out && (out.offerId || (out.offer && out.offer.offerId)) ? String(out.offerId || (out.offer && out.offer.offerId)) : "";
            if(!realId) throw new Error("Offer created but missing offerId.");

            // replace tmpId with realId in both lists
            const fixList = (arrName) => {
              const arr = S.p3[arrName];
              if(!Array.isArray(arr)) return;
              const i = arr.findIndex(x => x && x.offerId === tmpId);
              if(i >= 0){
                arr[i] = Object.assign({}, arr[i], { offerId: realId, __pending: false, __tmp: false });
              }
            };
            fixList("mineOffers");
            fixList("marketOffers");

            renderMyOffers();
            renderMarket();

            // light refresh in background (keeps things consistent)
            try{ await Promise.all([loadMyOffers(), loadMarket()]); }catch(_e){}
            setMsg(el("tywOfferOk"), "Offer posted.", true);
          }catch(e){
            // mark failed state but keep it visible
            const markFailed = (arrName) => {
              const arr = S.p3[arrName];
              if(!Array.isArray(arr)) return;
              const i = arr.findIndex(x => x && x.offerId === tmpId);
              if(i >= 0){
                arr[i] = Object.assign({}, arr[i], { __pending: false, __failed: true, __failMsg: (e.message||String(e)) });
              }
            };
            markFailed("mineOffers");
            markFailed("marketOffers");
            renderMyOffers();
            renderMarket();
            setMsg(el("tywOfferMsg"), (e.message || String(e)), false);
          }
        })();

      }catch(e){
        setMsg(el("tywOfferMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });

    // ====== Admin (basic actions only; will show errors if backend not ready) ======
    let adminUsersLoadPromise_ = null;
    function adminUsersFromResponse_(out){
      const data = (out && out.data && typeof out.data === 'object') ? out.data : (out || {});
      const rows = Array.isArray(data) ? data : (Array.isArray(data.users) ? data.users : (Array.isArray(data.roster) ? data.roster : []));
      return rows.map(u => ({
        ...u,
        callsign: cleanCallsign((u && (u.callsign || u.id)) || ''),
        displayName: String((u && (u.displayName || u.name)) || '').trim()
      })).filter(u => !!u.callsign);
    }
    function renderAdminUserSelect_(rows, wanted){
      const sel = el("tywAdmUserSelect");
      if(!sel) return;
      const keep = cleanCallsign(wanted || sel.value || S.adminTarget || S.callsign || '');
      fillSelect(sel, (rows || []).map(u => ({
        value: u.callsign || u.id || "",
        label: (u.displayName ? `${u.displayName} • ` : "") + (u.callsign || u.id || "")
      })), "No disciple names loaded");
      try{
        const hasKeep = keep && Array.from(sel.options||[]).some(o => cleanCallsign(o.value||"") === keep);
        if(hasKeep) sel.value = keep;
        else{
          const me = cleanCallsign(S.callsign || '');
          const hasMe = me && Array.from(sel.options||[]).some(o => cleanCallsign(o.value||"") === me);
          if(hasMe) sel.value = me;
        }
      }catch(_e){}
    }
    function adminUsersRequest_(action, force){
      const timeoutMs = 12000;
      return Promise.race([
        rpc(action, {}, { cacheTtlMs: force ? 0 : 15000, progressMode:'silent' }),
        new Promise((_, reject) => setTimeout(() => reject(new Error(action + ' timed out.')), timeoutMs))
      ]);
    }
    async function loadAdminUsers(force){
      if(!slbIsAdmin_()) return [];
      if(adminUsersLoadPromise_ && !force) return adminUsersLoadPromise_;
      const sel = el("tywAdmUserSelect");
      const wanted = cleanCallsign((sel && sel.value) || S.adminTarget || S.callsign || '');
      let cached = (Array.isArray(S.adminUsers) && S.adminUsers.length) ? S.adminUsers : null;
      if(!cached){ try{ cached = slbCacheGet_("adminUsers", 24*60*60*1000); }catch(_e){} }
      if(Array.isArray(cached) && cached.length){ S.adminUsers = cached; renderAdminUserSelect_(cached, wanted); }
      setText("tywAdmUserLoadState", "Loading disciple names…");
      const reloadBtn = el("tywAdmReloadNamesBtn");
      if(reloadBtn){ reloadBtn.disabled = true; reloadBtn.textContent = "LOADING…"; reloadBtn.setAttribute('aria-busy','true'); }
      adminUsersLoadPromise_ = (async () => {
        let rows = [], lastErr = null;
        try{ rows = adminUsersFromResponse_(await adminUsersRequest_("adminListUsers", !!force)); }catch(e){ lastErr = e; }
        if(!rows.length){
          try{ rows = adminUsersFromResponse_(await adminUsersRequest_("adminRoster", true)); }catch(e){ lastErr = e; }
        }
        if(!rows.length) throw lastErr || new Error('No disciple names were returned.');
        S.adminUsers = rows;
        try{ slbCacheSet_("adminUsers", rows); }catch(_e){}
        renderAdminUserSelect_(rows, wanted);
        setText("tywAdmUserLoadState", rows.length + " disciple name" + (rows.length===1?"":"s") + " loaded.");
        return rows;
      })().catch(err => {
        const kept = Array.isArray(S.adminUsers) ? S.adminUsers : [];
        if(kept.length){
          renderAdminUserSelect_(kept, wanted);
          setText("tywAdmUserLoadState", "Using the saved disciple list. Reload failed: " + ((err && err.message) || String(err)));
          return kept;
        }
        if(sel) sel.innerHTML = '<option value="">Could not load disciple names</option>';
        setText("tywAdmUserLoadState", "Disciple-name load failed: " + ((err && err.message) || String(err)));
        throw err;
      }).finally(() => {
        adminUsersLoadPromise_ = null;
        if(reloadBtn){ reloadBtn.disabled = false; reloadBtn.textContent = "Reload Names"; reloadBtn.removeAttribute('aria-busy'); }
      });
      return adminUsersLoadPromise_;
    }
    try{ window.SLB_loadAdminUsers = loadAdminUsers; }catch(_eExposeUsers){}


async function loadAdminRoster(){
  if(!S.isAdminOrMod) return;
  clearMsg(el("tywAdmRosterMsg")); clearMsg(el("tywAdmRosterOk"));
  try{
    // SWR cache: show cached roster instantly
    try{
      const cached = slbCacheGet_("adminRoster", 7*24*60*60*1000) || slbCacheGet_("adminRoster");
      if(cached){ S.adminRoster = cached; renderAdminRoster(); }
    }catch(_e){}
    const out = await rpc("adminRoster", {});
    S.adminRoster = out || null;
    try{ slbCacheSet_("adminRoster", S.adminRoster); }catch(_e){}
    setMsg(el("tywAdmRosterOk"), "Loaded.", true);
  }catch(e){
    S.adminRoster = null;
    setMsg(el("tywAdmRosterMsg"), e.message || String(e), false);
  }
  renderAdminRoster();
}

// Expose for reliable auto-load kickers
try{ window.SLB_loadAdminRoster = loadAdminRoster; }catch(_e){}

function renderAdminRoster(){
  const body = el("tywAdmRosterBody");
  if(!body) return;

  const rows = (S.adminRoster && Array.isArray(S.adminRoster.roster)) ? S.adminRoster.roster : [];
  const q = String((el("tywAdmRosterSearch") && el("tywAdmRosterSearch").value) || "").trim().toLowerCase();

  const filtered = q
    ? rows.filter(u => (String(u.callsign||"").toLowerCase().includes(q) || String(u.displayName||"").toLowerCase().includes(q)))
    : rows;

  // Summary (always based on full roster, not filtered)
  let supply = 0, okP = 0, lockedP = 0;
  for(const u of rows){
    supply += Number(u.totalStones||0) || 0;
    if(u.canCreatePouches) okP++; else lockedP++;
  }
  const summary = rows.length
    ? (rows.length + " users • Supply " + money(supply) + " • Pouch OK " + okP + " / Locked " + lockedP)
    : "—";
  setText("tywAdmRosterSummary", summary);

  if(!filtered.length){
    body.innerHTML = '<tr><td class="muted" colspan="8">No users.</td></tr>';
    return;
  }

  body.innerHTML = filtered.map(u => {
    const cs = esc(u.callsign || "");
    const nm = esc(u.displayName || "");
    const st = esc(u.status || "");
    const total = money(u.totalStones || 0);
    const onhand = money(u.onHandStones || 0);
    const pouch = money(u.pouchStones || 0);
    const pc = String(u.pouchCount || 0);
    const ok = u.canCreatePouches ? "✅" : "—";
    return `
      <tr>
        <td>${cs}</td>
        <td>${nm}</td>
        <td>${st}</td>
        <td>${total}</td>
        <td>${onhand}</td>
        <td>${pouch}</td>
        <td>${pc}</td>
        <td>${ok}</td>
      </tr>
    `;
  }).join("");
}

    // ===== ADMIN: Disciples =====
    function discEls_(){
      return {
        page: el("slbAdmDisciples"),
        search: el("slbAdmDiscSearch"),
        scope: el("slbAdmDiscScope"),
        sort: el("slbAdmDiscSort"),
        sortDirBtn: el("slbAdmDiscSortDir"),
        table: el("slbAdmDiscTable"),
        insightsSummary: el("slbAdmDiscInsightsSummary"),
        bdayBody: el("slbAdmDiscBdayBody"),
        dupePill: el("slbAdmDiscDupePill"),
        dupeAlert: el("slbAdmDiscDupeAlert"),
        dupeBody: el("slbAdmDiscDupeBody"),
        reloadBtn: el("slbAdmDiscReloadBtn"),
        exportBtn: el("slbAdmDiscExportBtn"),
        summary: el("slbAdmDiscSummary"),
        body: el("slbAdmDiscBody"),
        ok: el("slbAdmDiscOk"),
        msg: el("slbAdmDiscMsg"),
        adminTools: el("slbAdmDiscAdminTools"),
        importFile: el("slbAdmDiscImportFile"),
        addBtn: el("slbAdmDiscAddBtn"),

        detail: el("slbAdmDiscDetail"),
        detailBadge: el("slbAdmDiscDetailBadge"),
        meta: el("slbAdmDiscMeta"),
        id: el("slbAdmDiscId"),

        ordinary: el("slbAdmDiscOrdinary"),
        taoist: el("slbAdmDiscTaoist"),
        callsign: el("slbAdmDiscCallsign"),
        level: el("slbAdmDiscLevel"),
        status: el("slbAdmDiscStatus"),
        acg: el("slbAdmDiscAcg"),
        minister: el("slbAdmDiscMinister"),
        birthday: el("slbAdmDiscBirthday"),
        ordain: el("slbAdmDiscOrdain"),
        death: el("slbAdmDiscDeath"),
        email: el("slbAdmDiscEmail"),
        phone: el("slbAdmDiscPhone"),
        address: el("slbAdmDiscAddress"),
        city: el("slbAdmDiscCity"),
        country: el("slbAdmDiscCountry"),
        photoUrl: el("slbAdmDiscPhotoUrl"),
        notes: el("slbAdmDiscNotes"),
        special: el("slbAdmDiscSpecial"),

        // ordain parser (admin-only)
        parserBox: el("slbAdmDiscParserBox"),
        parserText: el("slbAdmDiscParserText"),
        parseBtn: el("slbAdmDiscParseBtn"),
        parseClearBtn: el("slbAdmDiscParseClearBtn"),
        parseMsg: el("slbAdmDiscParseMsg"),

        saveBtn: el("slbAdmDiscSaveBtn"),
        moveBtn: el("slbAdmDiscMoveBtn"),
        deleteBtn: el("slbAdmDiscDeleteBtn"),
        closeBtn: el("slbAdmDiscCloseBtn"),
        detailBtns: el("slbAdmDiscDetailBtns")
      };
    }

    function discAll_(data){
      const din = (data && data.in) ? data.in : [];
      const dout = (data && data.out) ? data.out : [];
      return din.concat(dout);
    }


    function discBoolFlag_(v){
      if(v === true || v === 1) return true;
      const s = String(v==null?"":v).trim().toLowerCase();
      return s === "1" || s === "true" || s === "yes" || s === "y" || s === "in" || s === "acg" || s === "active";
    }
    function discAcgMarkerVal_(d){
      if(!d) return null;
      const fields = [d.acgNote, d.notes, d.specialNote, d.SpecialNote, d["Special Note"], d.note, d.remarks];
      for(let i=0;i<fields.length;i++){
        const s = String(fields[i]==null?"":fields[i]);
        if(!s) continue;
        const m = s.match(/\[\s*ACG\s*=\s*([01])\s*\]|\bACG\s*[:=]\s*([01])\b/i);
        if(m) return String(m[1] || m[2] || "") === "1";
      }
      return null;
    }
    function discAcgHasMarker_(d){ return discAcgMarkerVal_(d) !== null; }
    function discAcgCleanMarkerText_(s){
      return String(s==null?"":s)
        .replace(/\s*\[\s*ACG\s*=\s*[01]\s*\]\s*/ig, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    }
    function discSetAcgMarker_(d,on){
      d = d || {};
      const marker = "[ACG=" + (on ? "1" : "0") + "]";
      const base = discAcgCleanMarkerText_(d.specialNote);
      d.specialNote = base ? (base + "\n" + marker) : marker;
      return d;
    }
    function discIsAcg_(d){
      if(!d) return false;
      const marker = discAcgMarkerVal_(d);
      if(marker !== null) return !!marker;
      return discBoolFlag_(d.acg) || discBoolFlag_(d.ACG) || discBoolFlag_(d.isAcg) || discBoolFlag_(d.acgActive) || discBoolFlag_(d.inAcg);
    }
    function discSetAcgFields_(d,on){
      d = d || {};
      const v = on ? "1" : "0";
      d.acg = v;
      d.ACG = v;
      d.isAcg = !!on;
      d.acgActive = !!on;
      d.inAcg = !!on;
      discSetAcgMarker_(d, !!on);
      return d;
    }
    function discAcgLabel_(d){
      if(discIsAcg_(d)) return (d && d.__acgLocalOverride) ? "IN ACG (local)" : "IN ACG";
      return (d && d.__acgLocalOverride) ? "OUT ACG (local)" : "—";
    }

    // Frontend safety layer for ACG.
    // If the Apps Script / Sheet is not returning the new ACG column yet,
    // admin changes used to appear, then disappear on the next reload.
    // This local override keeps the admin ACG page stable while the backend catches up.
    function discAcgOverrideStorageKey_(){ return "SLB_ADMIN_ACG_OVERRIDES_V1"; }
    function discAcgHasField_(d){
      if(!d || typeof d !== "object") return false;
      return discAcgHasMarker_(d) ||
             Object.prototype.hasOwnProperty.call(d,"acg") ||
             Object.prototype.hasOwnProperty.call(d,"ACG") ||
             Object.prototype.hasOwnProperty.call(d,"isAcg") ||
             Object.prototype.hasOwnProperty.call(d,"acgActive") ||
             Object.prototype.hasOwnProperty.call(d,"inAcg");
    }
    function discAcgKeys_(d){
      const out = [];
      const id = String((d && d.discipleId) || "").trim();
      const cs = String((d && d.callsign) || "").trim().toUpperCase();
      if(id) out.push("id:" + id);
      if(cs) out.push("cs:" + cs);
      return out;
    }
    function discLoadAcgOverrides_(){
      try{
        const raw = localStorage.getItem(discAcgOverrideStorageKey_());
        const obj = raw ? JSON.parse(raw) : {};
        return (obj && typeof obj === "object") ? obj : {};
      }catch(_e){ return {}; }
    }
    function discSaveAcgOverrides_(obj){
      try{ localStorage.setItem(discAcgOverrideStorageKey_(), JSON.stringify(obj || {})); }catch(_e){}
    }
    function discRememberAcgOverride_(d,on){
      const keys = discAcgKeys_(d);
      if(!keys.length) return;
      const map = discLoadAcgOverrides_();
      const rec = {
        v: on ? "1" : "0",
        ts: Date.now(),
        discipleId: String((d && d.discipleId) || ""),
        callsign: String((d && d.callsign) || "").trim().toUpperCase(),
        name: String((d && (d.taoistName || d.ordinaryName || d.callsign)) || "")
      };
      keys.forEach(k=>{ map[k] = rec; });
      discSaveAcgOverrides_(map);
    }
    function discClearAcgOverride_(d){
      const keys = discAcgKeys_(d);
      if(!keys.length) return;
      const map = discLoadAcgOverrides_();
      let changed = false;
      keys.forEach(k=>{ if(Object.prototype.hasOwnProperty.call(map,k)){ delete map[k]; changed = true; } });
      if(changed) discSaveAcgOverrides_(map);
    }
    function discFindAcgOverride_(map,d){
      const keys = discAcgKeys_(d);
      for(let i=0;i<keys.length;i++){
        if(map && map[keys[i]]) return map[keys[i]];
      }
      return null;
    }
    function discApplyAcgOverrides_(data,source){
      if(!data) return data;
      const map = discLoadAcgOverrides_();
      const all = discAll_(data);
      let used = 0;
      let backendHasField = false;
      all.forEach(d=>{
        if(!d) return;
        const backendHas = discAcgHasField_(d);
        if(backendHas) backendHasField = true;
        const ov = discFindAcgOverride_(map,d);
        if(ov && Object.prototype.hasOwnProperty.call(ov,"v")){
          const ovOn = discBoolFlag_(ov.v);
          if(backendHas && discIsAcg_(d) === ovOn){
            discClearAcgOverride_(d);
            try{ delete d.__acgLocalOverride; }catch(_e0){}
          }else{
            discSetAcgFields_(d, ovOn);
            d.__acgLocalOverride = true;
            used++;
          }
        }else if(d && d.__acgLocalOverride){
          try{ delete d.__acgLocalOverride; }catch(_e){}
        }
      });
      try{
        data.__acgOverrideCount = used;
        data.__acgBackendHasField = backendHasField;
        data.__acgBackendMissing = (!backendHasField && used > 0);
        data.__acgOverlaySource = source || "";
      }catch(_e2){}
      return data;
    }


    function slbIsAdmin_(){
      try{ return (sessionStorage.getItem("tyw_isAdmin")==="1"); }catch(_e){ return !!S.isAdmin; }
    }

    // disciples sort/tools helpers
    function discInitSortState_(){
      if(!S.adminDiscSortKey) S.adminDiscSortKey = "__order";
      if(!S.adminDiscSortDir) S.adminDiscSortDir = 1;
    }
    function discApplyOrder_(data){
      if(!data) return;
      const din = (data.in||[]);
      const dout = (data.out||[]);
      din.forEach((d,i)=>{
        if(!d) return;
        d.bucket = d.bucket || "IN";
        d.__orderIn = i+1;
        d.__orderAll = i+1;
        d.__orderLabel = String(i+1);
      });
      dout.forEach((d,i)=>{
        if(!d) return;
        d.bucket = d.bucket || "OUT";
        d.__orderOut = i+1;
        d.__orderAll = 100000 + (i+1);
        d.__orderLabel = "OUT-" + String(i+1);
      });
    }
    function discGetOrderForScope_(d, scope){
      if(!d) return 0;
      const sc = String(scope||"IN").toUpperCase();
      if(sc === "ALL") return (typeof d.__orderAll === "number") ? d.__orderAll : 0;
      if(sc === "OUT") return (typeof d.__orderOut === "number") ? d.__orderOut : (typeof d.__orderAll === "number" ? d.__orderAll : 0);
      return (typeof d.__orderIn === "number") ? d.__orderIn : (typeof d.__orderAll === "number" ? d.__orderAll : 0);
    }
    function discParseMonthDay_(s){
      s = String(s||"").replace(/\u00A0/g," ").trim();
      if(!s) return null;
      s = s.split(/\r?\n/)[0].trim();
      s = s.replace(/\bApirl\b/ig,"April");
      s = s.replace(/\bSept\b/ig,"Sep");

      // Try ISO date extraction
      let m = s.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
      if(m){
        const mm = parseInt(m[2],10), dd = parseInt(m[3],10);
        if(mm>=1&&mm<=12&&dd>=1&&dd<=31) return {m:mm,d:dd};
      }

      // mm/dd, mm-dd, possibly with year and/or trailing text
      m = s.match(/(\d{1,2})[\/\-](\d{1,2})(?:[\/\-](\d{2,4}))?/);
      if(m){
        const a = parseInt(m[1],10), b = parseInt(m[2],10);
        if(a>=1&&a<=12&&b>=1&&b<=31) return {m:a,d:b};
        if(b>=1&&b<=12&&a>=1&&a<=31) return {m:b,d:a}; // likely DD/MM
      }

      // Month-name without needing Date() to understand trailing text
      m = s.match(/\b(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t|tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\b[^0-9]{0,6}(\d{1,2})/i);
      if(m){
        const mon = String(m[1]||"").toLowerCase();
        const day = parseInt(m[2],10);
        const map = {
          jan:1,january:1,
          feb:2,february:2,
          mar:3,march:3,
          apr:4,april:4,
          may:5,
          jun:6,june:6,
          jul:7,july:7,
          aug:8,august:8,
          sep:9,sept:9,september:9,
          oct:10,october:10,
          nov:11,november:11,
          dec:12,december:12
        };
        const mo = map[mon] || 0;
        if(mo>=1 && mo<=12 && day>=1 && day<=31) return {m:mo,d:day};
      }

      // Fallback to Date parse
      const dt = new Date(s);
      if(!isNaN(dt.getTime())){
        return {m: dt.getMonth()+1, d: dt.getDate()};
      }
      return null;
    }
    const DISC_LEVELS_ = ["Tin Yat","Saam Law","Sun Lung Munn","Sun Lung Mo","Tin Ting Munn","Tin Ting Mo","Tin Ting Soul","Sun Ting","Tin Si"];
    // Callsign stage digit -> Level
    const DISC_STAGE_TO_LEVEL_ = {
      "1": "Tin Yat",
      "2": "Saam Law",
      "3": "Sun Lung Munn",
      "4": "Sun Lung Mo",
      "5": "Tin Ting Munn",
      "6": "Tin Ting Mo",
      "7": "Tin Ting Soul",
      "8": "Sun Ting",
      "9": "Tin Si"
    };
    const DISC_LEVEL_TO_STAGE_ = (()=>{
      const o = Object.create(null);
      Object.keys(DISC_STAGE_TO_LEVEL_).forEach(k=>{ o[DISC_STAGE_TO_LEVEL_[k]] = k; });
      return o;
    })();

    function discStageFromCallsign_(cs){
      const m = String(cs||"").toUpperCase().replace(/\s+/g,"").match(/^TY([1-9])/);
      return m ? String(m[1]||"") : "";
    }
    function discLevelFromCallsign_(cs){
      const st = discStageFromCallsign_(cs);
      return st ? (DISC_STAGE_TO_LEVEL_[st] || "") : "";
    }
    function discStageFromLevel_(lv){
      const n = discNormLevel_(lv);
      return (n && DISC_LEVEL_TO_STAGE_[n]) ? String(DISC_LEVEL_TO_STAGE_[n]) : "";
    }
    function discApplyStageToCallsign_(callsign, stage){
      const st = String(stage||"").trim();
      let cs = String(callsign||"").toUpperCase().replace(/\s+/g,"");
      if(!st) return cs;
      const m = cs.match(/^TY([1-9])(.*)$/);
      if(m) return "TY" + st + String(m[2]||"");
      const m2 = cs.match(/^TY(.*)$/);
      if(m2) return "TY" + st + String(m2[1]||"");
      if(!cs) return "TY" + st;
      // Don't rewrite non-TY callsigns
      return cs;
    }

    function discSyncFromCallsignInput_(){
      if(S._discSyncing) return;
      const E = discEls_();
      if(!E.callsign || !E.level) return;
      const cs = String(E.callsign.value||"").toUpperCase();
      const lv = discLevelFromCallsign_(cs);
      if(lv){
        S._discSyncing = true;
        E.level.value = lv;
        S._discSyncing = false;
      }
    }
    function discSyncFromLevelInput_(){
      if(S._discSyncing) return;
      const E = discEls_();
      if(!E.callsign || !E.level) return;
      const lv = discNormLevel_(String(E.level.value||""));
      const st = discStageFromLevel_(lv);
      if(!st) return;
      const before = String(E.callsign.value||"");
      const after = discApplyStageToCallsign_(before, st);
      if(after !== before){
        S._discSyncing = true;
        E.callsign.value = after;
        S._discSyncing = false;
      }
    }
    function discSyncPairBeforeSave_(disciple){
      const d = disciple || {};
      d.callsign = String(d.callsign||"").toUpperCase().replace(/\s+/g,"");
      d.level = discNormLevel_(d.level||"");
      const stCs = discStageFromCallsign_(d.callsign);
      if(stCs){
        d.level = DISC_STAGE_TO_LEVEL_[stCs] || d.level;
        return d;
      }
      const stLv = discStageFromLevel_(d.level);
      if(stLv){
        d.callsign = discApplyStageToCallsign_(d.callsign, stLv);
      }
      return d;
    }
    function discNormLevel_(s){
      const t = String(s||"").trim();
      if(!t) return "";
      const low = t.toLowerCase().replace(/\s+/g," ").trim();
      for(let i=0;i<DISC_LEVELS_.length;i++){
        if(DISC_LEVELS_[i].toLowerCase()===low) return DISC_LEVELS_[i];
      }
      if(low.indexOf("sun lung")!==-1){
        if(low.indexOf("mo")!==-1) return "Sun Lung Mo";
        return "Sun Lung Munn";
      }
      if(low.indexOf("tin ting")!==-1){
        if(low.indexOf("soul")!==-1) return "Tin Ting Soul";
        if(low.indexOf("mo")!==-1) return "Tin Ting Mo";
        return "Tin Ting Munn";
      }
      if(low.indexOf("sun ting")!==-1) return "Sun Ting";
      if(low.indexOf("tin si")!==-1) return "Tin Si";
      if(low.indexOf("saam law")!==-1) return "Saam Law";
      if(low.indexOf("tin yat")!==-1) return "Tin Yat";
      return t;
    }
    function discIsoDate_(s){
      s = String(s||"").replace(/\u00A0/g," ").trim();
      if(!s) return "";
      // If multi-line, use the first line only
      s = s.split(/\r?\n/)[0].trim();
      // Common typos / variants
      s = s.replace(/\bApirl\b/ig,"April");
      s = s.replace(/\bSept\b/ig,"Sep");

      // If embedded ISO datetime, prefer date-only
      let m = s.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
      if(m){
        const y = String(m[1]).padStart(4,"0");
        const mm = String(parseInt(m[2],10)).padStart(2,"0");
        const dd = String(parseInt(m[3],10)).padStart(2,"0");
        return y+"-"+mm+"-"+dd;
      }

      // Embedded mm/dd/yyyy or mm-dd-yyyy (ignore trailing time/text)
      m = s.match(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})/);
      if(m){
        let a = parseInt(m[1],10), b = parseInt(m[2],10), y = parseInt(m[3],10);
        if(y < 100) y = 2000 + y;
        // default MM/DD, but swap when clearly DD/MM
        let mo = a, d = b;
        if(a > 12 && b <= 12){ mo = b; d = a; }
        if(mo>=1 && mo<=12 && d>=1 && d<=31){
          return String(y).padStart(4,"0")+"-"+String(mo).padStart(2,"0")+"-"+String(d).padStart(2,"0");
        }
      }

      // Month-name patterns like "MAY 12, 2019 -stage1", "Sept 2, 1951", "Sept 3.2016"
      m = s.match(/\b(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t|tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\b[^0-9]{0,6}(\d{1,2})(?:st|nd|rd|th)?[^0-9]{0,6}(\d{4})/i);
      if(m){
        const mon = String(m[1]||"").toLowerCase();
        const day = parseInt(m[2],10);
        const year = parseInt(m[3],10);
        const map = {
          jan:1,january:1,
          feb:2,february:2,
          mar:3,march:3,
          apr:4,april:4,
          may:5,
          jun:6,june:6,
          jul:7,july:7,
          aug:8,august:8,
          sep:9,sept:9,september:9,
          oct:10,october:10,
          nov:11,november:11,
          dec:12,december:12
        };
        const mo = map[mon] || 0;
        if(mo>=1 && mo<=12 && day>=1 && day<=31){
          return String(year).padStart(4,"0")+"-"+String(mo).padStart(2,"0")+"-"+String(day).padStart(2,"0");
        }
      }

      // Last resort: Date parse (handles "Sun Jan 22 2023 00:00:00 GMT-0500 ...")
      const dt = new Date(s);
      if(!isNaN(dt.getTime())){
        const y = dt.getFullYear();
        const mo = String(dt.getMonth()+1).padStart(2,"0");
        const d = String(dt.getDate()).padStart(2,"0");
        return y + "-" + mo + "-" + d;
      }
      return "";
    }

    function discNextBirthdayTs_(b){
      const md = discParseMonthDay_(b);
      if(!md) return null;
      const now = new Date();
      const y = now.getFullYear();
      const tsNow = new Date(y, now.getMonth(), now.getDate(),0,0,0,0).getTime();
      const ts1 = new Date(y, md.m-1, md.d,0,0,0,0).getTime();
      if(ts1 >= tsNow) return ts1;
      return new Date(y+1, md.m-1, md.d,0,0,0,0).getTime();
    }
    function discFmtMonthDay_(ts){
      const d = new Date(ts);
      const mo = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()];
      const dd = String(d.getDate()).padStart(2,"0");
      return mo + " " + dd;
    }
    function discSortArr_(arr, scope){
      discInitSortState_();
      const key = String(S.adminDiscSortKey||"__order");
      const dir = (S.adminDiscSortDir===-1) ? -1 : 1;
      const getVal = (d)=>{
        if(key === "__order"){
          return discGetOrderForScope_(d, scope);
        }
        if(key === "birthday"){
          const ts = discNextBirthdayTs_(d && d.birthday);
          return ts || 9000000000000000;
        }
        if(key === "acg"){
          return discIsAcg_(d) ? 0 : 1;
        }
        const v = (d && d[key]!=null) ? d[key] : "";
        return String(v||"").trim().toLowerCase();
      };
      const out = (arr||[]).slice(0);
      out.sort((a,b)=>{
        const av = getVal(a), bv = getVal(b);
        if(typeof av === "number" && typeof bv === "number"){
          if(av<bv) return -1*dir;
          if(av>bv) return 1*dir;
          return 0;
        }
        const as = String(av||""), bs = String(bv||"");
        const c = as.localeCompare(bs, undefined, {numeric:true, sensitivity:"base"});
        return c*dir;
      });
      return out;
    }
    function discUpdateSortUI_(){
      const E = discEls_();
      discInitSortState_();
      if(E.sort) E.sort.value = String(S.adminDiscSortKey||"__order");
      if(E.sortDirBtn) E.sortDirBtn.textContent = (S.adminDiscSortDir===-1) ? "▼" : "▲";
      if(E.table){
        const ths = E.table.querySelectorAll("th[data-sort-key]");
        ths.forEach(th=>{
          const k = th.getAttribute("data-sort-key");
          if(!th.getAttribute("data-base-text")){
            th.setAttribute("data-base-text", (th.textContent||"").replace(/\s*[▲▼]$/,"").trim());
          }
          const base = th.getAttribute("data-base-text") || "";
          if(k === String(S.adminDiscSortKey||"__order")){
            const icon = (S.adminDiscSortDir===-1) ? " ▼" : " ▲";
            th.textContent = base + icon;
          }else{
            th.textContent = base;
          }
        });
      }
    }
    function discRenderInsights_(data){
      const E = discEls_();
      if(!E.bdayBody && !E.dupeBody && !E.insightsSummary) return;
      const din = (data && data.in) ? data.in : [];
      const now = new Date();
      const now0 = new Date(now.getFullYear(), now.getMonth(), now.getDate(),0,0,0,0).getTime();
      const maxDays = 45;
      const maxTs = now0 + maxDays*86400000;
      const bdays = [];
      din.forEach(d=>{
        const ts = discNextBirthdayTs_(d && d.birthday);
        if(!ts) return;
        if(ts < now0 || ts > maxTs) return;
        bdays.push({ts:ts, d:d});
      });
      bdays.sort((a,b)=>a.ts-b.ts);
      const esc = (t)=>String(t||"")
        .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
        .replace(/"/g,"&quot;").replace(/'/g,"&#39;");
      if(E.bdayBody){
        E.bdayBody.innerHTML = (bdays.slice(0,50).map(x=>{
          const days = Math.max(0, Math.round((x.ts-now0)/86400000));
          const d = x.d || {};
          return `<tr>
            <td>${days}d</td>
            <td>${esc(discFmtMonthDay_(x.ts))}</td>
            <td>${esc(d.taoistName||"")}</td>
            <td>${esc(d.callsign||"")}</td>
            <td>${esc(d.ordinaryName||"")}</td>
          </tr>`;
        }).join("")) || `<tr><td colspan="5" class="note">No birthdays in the next ${maxDays} days.</td></tr>`;
      }

      const all = discAll_(data);
      const norm = (s)=>String(s||"").trim().toLowerCase();
      const normCall = (s)=>String(s||"").trim().toUpperCase().replace(/\s+/g,"");
      const dups = [];

      // Callsign duplicates
      (function(){
        const mp = {};
        all.forEach(d=>{
          const v = normCall(d && d.callsign);
          if(!v) return;
          if(!mp[v]) mp[v]=[];
          mp[v].push(d);
        });
        Object.keys(mp).forEach(k=>{
          if(mp[k].length>1){
            dups.push({type:"Callsign", key:k, value:k, count: mp[k].length, list: mp[k]});
          }
        });
      })();

      // Name pair duplicates (Taoist + Ordinary must BOTH match)
      (function(){
        const mp = {};
        all.forEach(d=>{
          const tn = norm(d && d.taoistName);
          const on = norm(d && d.ordinaryName);
          if(!tn || !on) return;
          const k = tn + "||" + on;
          if(!mp[k]) mp[k]=[];
          mp[k].push(d);
        });
        Object.keys(mp).forEach(k=>{
          if(mp[k].length>1){
            const first = (mp[k] && mp[k][0]) ? mp[k][0] : {};
            const disp = (String(first.taoistName||"").trim() + " / " + String(first.ordinaryName||"").trim()).trim();
            dups.push({type:"Name Pair", key:k, value: disp || k, count: mp[k].length, list: mp[k]});
          }
        });
      })();

      dups.sort((a,b)=> (b.count-a.count) || (a.type.localeCompare(b.type)) || (String(a.key||"").localeCompare(String(b.key||""))));
      if(E.dupePill) E.dupePill.textContent = `${dups.length} found`;
      if(E.dupeAlert) E.dupeAlert.textContent = dups.length ? "Please review duplicates." : "No duplicates found.";
      if(E.dupeBody){
        E.dupeBody.innerHTML = (dups.map(x=>{
          const names = (x.list||[]).map(d=>String(d.taoistName||d.ordinaryName||d.callsign||"").trim()).filter(Boolean).slice(0,8).join(" | ");
          const more = (x.list||[]).length>8 ? " ..." : "";
          return `<tr>
            <td>${esc(x.type)}</td>
            <td>${esc(x.display || x.value)}</td>
            <td>${esc(x.count)}</td>
            <td>${esc(names + more)}</td>
          </tr>`;
        }).join("")) || `<tr><td colspan="4" class="note">—</td></tr>`;
      }

      if(E.insightsSummary){
        const inCount = (data && data.in) ? data.in.length : 0;
        const outCount = (data && data.out) ? data.out.length : 0;
        E.insightsSummary.textContent = `IN ${inCount} • OUT ${outCount} • Birthdays ${bdays.length}/${maxDays}d • Dupes ${dups.length}`;
      }
    }

function discApplyRoleUI_(){
      const E = discEls_();
      const isAdmin = slbIsAdmin_();
      // admin-only tools
      show(E.adminTools, isAdmin);
      show(E.parserBox, isAdmin);
      // detail buttons
      if(E.detailBtns){
        const btns = E.detailBtns.querySelectorAll("button");
        btns.forEach(b=>{
          const id = (b && b.id) ? b.id : "";
          // close always
          if(id === "slbAdmDiscCloseBtn") return;
          show(b, isAdmin);
        });
      }
      // disable inputs for moderators
      const fields = [E.ordinary,E.taoist,E.callsign,E.level,E.status,E.minister,E.birthday,E.ordain,E.death,E.email,E.phone,E.address,E.city,E.country,E.photoUrl,E.notes,E.special,E.parserText];
      fields.forEach(x=>{ if(x) x.disabled = !isAdmin; });
    }



/* ====== SLB CORE: 90_core_app.part04.js ====== */
/* SLB PART FILE — NOT STANDALONE
   This file is concatenated by slb_build/build.mjs into assets/slb.bundle.generated.js
*/

/* SLB CORE APP (split) - part 04/6
   NOTE: These parts are concatenated in order by slb_build/build.mjs.
*/
    function discSetMsg_(ok, msg){
      const E = discEls_();
      if(ok){
        clearMsg(E.msg);
        setMsg(E.ok, msg, true);
      }else{
        clearMsg(E.ok);
        setMsg(E.msg, msg, false);
      }
    }

    function discClearMsg_(){
      const E = discEls_();
      clearMsg(E.ok); clearMsg(E.msg);
    }

    // -------- Ordain Parser (admin only) --------
    function discSetParseMsg_(msg){
      const E = discEls_();
      if(!E.parseMsg) return;
      E.parseMsg.textContent = String(msg||"");
    }

    function discNormKey_(s){
      return String(s||"").toLowerCase()
        .replace(/[\u00A0]/g," ")
        .replace(/[^a-z0-9\u4e00-\u9fff]+/g,"")
        .trim();
    }

    function discMapParserKey_(k){
      k = discNormKey_(k);
      if(!k) return "";
      const map = {
        // names
        "taoistname":"taoist","daoistname":"taoist","taoist":"taoist","daoname":"taoist","道名":"taoist","法名":"taoist","道號":"taoist","道号":"taoist","nameintemple":"taoist",
        "ordinaryname":"ordinary","realname":"ordinary","legalname":"ordinary","englishname":"ordinary","name":"ordinary",

        // ids
        "callsign":"callsign","callsignid":"callsign","call":"callsign","callsignnumber":"callsign","號碼":"callsign","编号":"callsign",

        // stage
        "level":"level","stage":"level","rank":"level",

        // misc
        "status":"status",
        // common intake forms (what they are ordaining as)
        "ordaining":"status","ordination":"status",
        "minister":"minister","ministername":"minister","ordainedby":"minister","sifu":"minister","師傅":"minister","師父":"minister",

        // dates
        "birthday":"birthday","dob":"birthday","birthdate":"birthday","dateofbirth":"birthday","出生":"birthday","生日":"birthday",
        "ordaindate":"ordain","ordain":"ordain","ordinationdate":"ordain","ordaineddate":"ordain","dateofordination":"ordain","受籙":"ordain","受箓":"ordain",
        "dateofdeath":"death","deathdate":"death","dod":"death","passed":"death","deceased":"death","逝世":"death","去世":"death",

        // contact
        "email":"email","mail":"email",
        "phone":"phone","tel":"phone","telephone":"phone","mobile":"phone","whatsapp":"phone",

        // location
        "address":"address","addr":"address","street":"address","address1":"address",
        "shippingaddress":"address","shippingaddr":"address","mailingaddress":"address","deliveryaddress":"address",
        "city":"city","stateprovince":"city","province":"city","state":"city",
        "country":"country","nation":"country",

        // extras
        "photourl":"photoUrl","photo":"photoUrl","image":"photoUrl","avatar":"photoUrl","picture":"photoUrl","profilephoto":"photoUrl",
        "notes":"notes","note":"notes","remark":"notes","comments":"notes","comment":"notes",
        "specialnote":"special","special":"special","aboutreasonforordaining":"special","aboutreasonforordination":"special","aboutreasonforordinating":"special","reasonforordaining":"special","reasonforordination":"special"
      };
      return map[k] || "";
    }

    function discParseOrdainText_(raw){
      raw = String(raw||"").replace(/\r/g,"\n").trim();
      const out = {};
      const set = (k,v)=>{
        if(!k) return;
        v = (v==null) ? "" : String(v);
        v = v.replace(/\u00A0/g," ").trim();
        if(!v) return;
        if(out[k]) return;
        out[k] = v;
      };

      const lines = raw.split("\n").map(x=>String(x||"").trim()).filter(Boolean);
      const looksLikeKeyLine = (line)=> /^.{1,60}\s*(?:[:：=]|(?:\s[-–—]\s))\s*.+$/.test(line);

      for(let i=0;i<lines.length;i++){
        const line = lines[i];
        let m = line.match(/^(.{1,60}?)\s*(?:[:：=]|(?:\s[-–—]\s))\s*(.+)$/);
        if(!m){
          m = line.match(/^(Taoist Name|Daoist Name|Ordinary Name|Real Name|Legal Name|English Name|Name|Callsign|Level|Stage|Rank|Status|Minister|Minister Name|Birthday|DOB|Birthdate|Date of Birth|Ordain Date|Ordained|Ordination Date|Date of Death|Email|E-mail|Phone|Tel|Mobile|WhatsApp|Address|Shipping Address|Mailing Address|City|Country|Photo|Photo URL|Notes|Special Note)\s+(.*)$/i);
        }
        if(m){
          const keyRaw = String(m[1]||"").trim();
          const valRaw = String(m[2]||"").trim();
          const field = discMapParserKey_(keyRaw);
          if(field){
            if(field==="address" || field==="notes" || field==="special"){
              let buf = valRaw;
              let j = i+1;
              while(j<lines.length){
                const nxt = lines[j];
                if(looksLikeKeyLine(nxt)) break;
                if(buf.length < 900) buf += (buf ? " " : "") + nxt;
                j++;
              }
              set(field, buf);
              i = j-1;
            }else{
              set(field, valRaw);
            }
          }
        }
      }

      // heuristics
      if(!out.email){
        const em = raw.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
        if(em) set("email", em[0]);
      }
      if(!out.callsign){
        const cs = raw.match(/\bTY\s*\d{1,2}\s*[A-Z0-9]{1,8}\b/i);
        if(cs) set("callsign", cs[0].replace(/\s+/g,"").toUpperCase());
      }

      // date normalize (date picker expects yyyy-mm-dd)
      if(out.birthday) out.birthday = discIsoDate_(out.birthday);
      if(out.ordain) out.ordain = discIsoDate_(out.ordain);
      if(out.death) out.death = discIsoDate_(out.death);

      if(out.callsign) out.callsign = String(out.callsign).toUpperCase().replace(/\s+/g,"");
      return out;
    }

    function discParsePasteToFields_(){
      const E = discEls_();
      if(!slbIsAdmin_()) return;

      // if detail is not open, open new record first
      if(E.detail && E.detail.classList.contains("hidden")){
        discNew_();
      }

      const raw = (E.parserText && E.parserText.value!=null) ? E.parserText.value : "";
      if(!String(raw||"").trim()){
        discSetParseMsg_("Paste text first.");
        return;
      }

      const p = discParseOrdainText_(raw);
      let filled = 0;
      const put = (el, v)=>{
        if(!el) return;
        v = (v==null) ? "" : String(v).trim();
        if(!v) return;
        el.value = v;
        filled++;
      };

      put(E.taoist, p.taoist);
      put(E.ordinary, p.ordinary);

      if(p.callsign && E.callsign){
        E.callsign.value = p.callsign;
        filled++;
        discSyncFromCallsignInput_();
      }
      if(p.level && E.level){
        E.level.value = discNormLevel_(p.level);
        filled++;
        discSyncFromLevelInput_();
      }
      put(E.status, p.status);
      put(E.minister, p.minister);
      if(p.birthday && E.birthday){ E.birthday.value = p.birthday; filled++; }
      if(p.ordain && E.ordain){ E.ordain.value = p.ordain; filled++; }
      if(p.death && E.death){ E.death.value = p.death; filled++; }
      put(E.email, p.email);
      put(E.phone, p.phone);
      put(E.address, p.address);
      put(E.city, p.city);
      put(E.country, p.country);
      put(E.photoUrl, p.photoUrl);
      put(E.notes, p.notes);
      put(E.special, p.special);

      discSetParseMsg_(filled ? ("Parsed and filled " + filled + " field(s).") : "No fields detected. Try adding labels like ‘Email: ...’");
      try{ if(E.detail) E.detail.scrollIntoView({behavior:"smooth", block:"start"}); }catch(_e){}
    }

    function discRender_(){
      const E = discEls_();
      if(!E.body) return;



      const data = S.adminDisciples || { in:[], out:[] };
      const q = String((E.search && E.search.value!=null) ? E.search.value : (S.adminDiscQ||"")).trim().toLowerCase();
      const scope = String((E.scope && E.scope.value) ? E.scope.value : (S.adminDiscScope||"IN")).toUpperCase();
      S.adminDiscQ = q;
      S.adminDiscScope = scope;

      let arr = [];
      if(scope === "OUT") arr = (data.out || []);
      else if(scope === "ALL") arr = discAll_(data);
      else arr = (data.in || []);

      const match = (d)=>{
        if(!q) return true;
        const hay = [
          d.taoistName, d.ordinaryName, d.callsign, d.level, d.status, discIsAcg_(d) ? "ACG IN AC GROUP" : "NOT ACG", d.ministerName,
          d.email, d.phone, d.city, d.country
        ].map(x=>String(x||"").toLowerCase()).join(" | ");
        return hay.indexOf(q) !== -1;
      };

      arr = arr.filter(match);

      // keep sheet order by default; allow user-controlled sorting
      arr = discSortArr_(arr, scope);
      discUpdateSortUI_();

      // order label for current view
      arr.forEach(d=>{ if(!d) return; if(String(scope).toUpperCase()==="ALL"){ const ob = String(d.bucket||"").toUpperCase()==="OUT" ? discGetOrderForScope_(d,"OUT") : discGetOrderForScope_(d,"IN"); d.__orderLabel = (String(d.bucket||"").toUpperCase()==="OUT") ? ("OUT-"+String(ob)) : String(ob); } else { d.__orderLabel = String(discGetOrderForScope_(d, scope)); } });

      const inCount = (data.in||[]).length;
      const outCount = (data.out||[]).length;
      const acgCount = (data.in||[]).filter(discIsAcg_).length;
      if(E.summary) E.summary.textContent = `IN ${inCount} • ACG ${acgCount} • OUT ${outCount} • Showing ${arr.length}`;

      const esc = (t)=>{
        return String(t==null?"":t)
          .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
          .replace(/"/g,"&quot;").replace(/'/g,"&#39;");
      };

      const oneLine = (t)=>{
        return String(t==null?"":t).replace(/\s+/g," ").trim();
      };


      S.adminDiscRendered = arr;

      E.body.innerHTML = arr.map((d,i)=>{
        const badge = scope==="ALL" ? (`<span class="badge" style="margin-right:6px;">${esc(d.bucket||"")}</span>`) : "";
        return `
<tr data-idx="${i}" data-id="${esc(d.discipleId||"")}" data-bucket="${esc(d.bucket||scope||"IN")}" data-callsign="${esc(d.callsign||"")}">
  <td title="${esc(oneLine(d.__orderLabel||""))}">${esc(oneLine(d.__orderLabel||""))}</td>
  <td title="${esc(oneLine(d.taoistName||""))}">${badge}${esc(oneLine(d.taoistName||""))}</td>
  <td title="${esc(oneLine(d.ordinaryName||""))}">${esc(oneLine(d.ordinaryName||""))}</td>
  <td title="${esc(oneLine(d.callsign||""))}">${esc(oneLine(d.callsign||""))}</td>
  <td title="${esc(oneLine(discNormLevel_(d.level)||""))}">${esc(oneLine(discNormLevel_(d.level)||""))}</td>
  <td title="${esc(oneLine(d.status||""))}">${esc(oneLine(d.status||""))}</td>
  <td title="${esc(discAcgLabel_(d))}">${discIsAcg_(d) ? '<span class="badge">ACG</span>' : '—'}</td>
  <td title="${esc(oneLine(d.ministerName||""))}">${esc(oneLine(d.ministerName||""))}</td>
  <td title="${esc(oneLine(d.birthday||""))}">${esc(oneLine(d.birthday||""))}</td>
  <td title="${esc(oneLine(d.email||""))}">${esc(oneLine(d.email||""))}</td>
  <td title="${esc(oneLine(d.phone||""))}">${esc(oneLine(d.phone||""))}</td>
  <td title="${esc(oneLine(d.country||""))}">${esc(oneLine(d.country||""))}</td>
</tr>`;;
      }).join("");

      // keep selection if still exists
      if(S.adminDiscSelected){
        const keepId = String(S.adminDiscSelected.discipleId||"");
        const found = discAll_(data).find(x=>String(x.discipleId||"")===keepId);
        if(found){
          discSelect_(found);
        }else{
          discCloseDetail_();
        }
      }
    }

    function discSelect_(d){
      const E = discEls_();
      if(!d) return;

      S.adminDiscSelected = d;

      if(E.detail) show(E.detail, true);
      try{ if(E.detail && E.detail.scrollIntoView) E.detail.scrollIntoView({behavior:"smooth", block:"start"}); }catch(e){}
      if(E.id) E.id.value = String(d.discipleId||"");
      if(E.detailBadge){
        const b = String(d.bucket||"IN");
        const cs = String(d.callsign||"");
        E.detailBadge.textContent = `${b} • ${cs || "—"} • ${discIsAcg_(d) ? "ACG • " : ""}${String(d.taoistName||d.ordinaryName||"")}`;
      }
      if(E.meta){
        E.meta.textContent = `ID: ${String(d.discipleId||"")} • Updated: ${String(d.updatedAt||"")} • By: ${String(d.updatedBy||"")}`;
      }

      const set = (el,val)=>{ if(el) el.value = String(val==null?"":val); };
      set(E.ordinary, d.ordinaryName);
      set(E.taoist, d.taoistName);
      set(E.callsign, d.callsign);
      set(E.level, discNormLevel_(d.level));
      set(E.status, d.status);
      if(E.acg) E.acg.checked = discIsAcg_(d);
      set(E.minister, d.ministerName);
      set(E.birthday, discIsoDate_(d.birthday));
      set(E.ordain, discIsoDate_(d.ordainDate));
      set(E.death, discIsoDate_(d.dateOfDeath));
      set(E.email, d.email);
      set(E.phone, d.phone);
      set(E.address, d.address);
      set(E.city, d.city);
      set(E.country, d.country);
      set(E.photoUrl, d.photoUrl);
      set(E.notes, d.notes);
      set(E.special, d.specialNote);

      // Keep Level consistent with Callsign stage digit (TY1..TY9)
      discSyncFromCallsignInput_();

      // move button label
      if(E.moveBtn){
        const b = String(d.bucket||"IN").toUpperCase();
        E.moveBtn.textContent = (b==="OUT") ? "Restore to IN" : "Remove to OUT";
      }

      discApplyRoleUI_();

      // update deep link when selecting a disciple (use replaceState, no history spam)
      try{ if(window.SLB_route && window.SLB_route.sync) window.SLB_route.sync(false); }catch(_e){}
    }

    function discNew_(){
      const E = discEls_();
      S.adminDiscSelected = null;
      if(E.detail) show(E.detail, true);
      try{ if(E.detail && E.detail.scrollIntoView) E.detail.scrollIntoView({behavior:"smooth", block:"start"}); }catch(_e){}
      try{ if(E.ordinary && E.ordinary.focus) E.ordinary.focus(); }catch(_e2){}
      if(E.id) E.id.value = "";
      if(E.detailBadge) E.detailBadge.textContent = "NEW • IN";
      if(E.meta) E.meta.textContent = "New record (not saved yet).";
      const clear = (x)=>{ if(x) x.value = ""; };
      [E.ordinary,E.taoist,E.callsign,E.level,E.status,E.minister,E.birthday,E.ordain,E.death,E.email,E.phone,E.address,E.city,E.country,E.photoUrl,E.notes,E.special].forEach(clear);
      if(E.acg) E.acg.checked = false;
      if(E.moveBtn) E.moveBtn.textContent = "Remove to OUT";
      discApplyRoleUI_();
    }

    function discCloseDetail_(){
      const E = discEls_();
      S.adminDiscSelected = null;
      if(E.detail) show(E.detail, false);
      if(E.id) E.id.value = "";
    }

    // Move/withdraw verification helpers.
    // Apps Script can finish the sheet write after the browser-side JSONP timeout.
    // So for disciple move/withdraw, timeout must mean "pending verification", not instant failure.
    function discPersonKey_(d){
      return {
        id: String((d && d.discipleId) || "").trim(),
        cs: String((d && d.callsign) || "").trim().toUpperCase()
      };
    }

    function discFindMoved_(data, d, bucket){
      const key = discPersonKey_(d);
      const b = String(bucket||"").toUpperCase();
      const list = (b === "OUT") ? ((data && data.out) || []) : ((data && data.in) || []);
      return list.find(x=>{
        const k = discPersonKey_(x);
        return (key.id && k.id === key.id) || (key.cs && k.cs === key.cs);
      }) || null;
    }

    function discSaveAdminCache_(){
      try{ slbCacheSet_("adminDiscipleList", { data: S.adminDisciples || { in:[], out:[] } }); }catch(_e){}
    }

    function discMoveLocal_(d, toBucket){
      try{
        const to = String(toBucket||"OUT").toUpperCase();
        const from = (to === "OUT") ? "IN" : "OUT";
        const fromKey = (from === "OUT") ? "out" : "in";
        const toKey = (to === "OUT") ? "out" : "in";
        const data0 = S.adminDisciples || { in:[], out:[] };
        data0.in = Array.isArray(data0.in) ? data0.in : [];
        data0.out = Array.isArray(data0.out) ? data0.out : [];
        const key = discPersonKey_(d);
        let moved = null;
        let ix = -1;
        if(key.id) ix = data0[fromKey].findIndex(x=>discPersonKey_(x).id === key.id);
        if(ix < 0 && key.cs) ix = data0[fromKey].findIndex(x=>discPersonKey_(x).cs === key.cs);
        if(ix >= 0) moved = data0[fromKey].splice(ix, 1)[0];
        if(!moved) moved = Object.assign({}, d || {});
        moved = Object.assign({}, moved, { bucket: to, __pendingMove: true });
        const oldToIx = data0[toKey].findIndex(x=>{
          const k = discPersonKey_(x);
          return (key.id && k.id === key.id) || (key.cs && k.cs === key.cs);
        });
        if(oldToIx >= 0) data0[toKey][oldToIx] = Object.assign({}, data0[toKey][oldToIx], moved, { bucket: to });
        else data0[toKey].push(moved);
        try{ data0.__hasLoaded = true; }catch(_e0){}
        discApplyOrder_(data0);
        S.adminDisciples = data0;
        discSaveAdminCache_();
        discRenderInsights_(S.adminDisciples);
        discRender_();
        return moved;
      }catch(_e){ return null; }
    }

    async function discFetchDisciplesQuiet_(){
      const res = await rpc("adminDiscipleList", { includeOut:true }, { timeoutMs: 60000, progressMode: "silent", noGlobalRetry: true, __slbNoGlobalRetry: true, useWarmCache: false, cacheTtlMs: 0 });
      const data = (res && res.data) ? res.data : res;
      S.adminDisciples = data || { in:[], out:[] };
      try{ S.adminDisciples.__hasLoaded = true; }catch(_e){}
      discApplyAcgOverrides_(S.adminDisciples, "server");
      discApplyOrder_(S.adminDisciples);
      discUpdateSortUI_();
      discRenderInsights_(S.adminDisciples);
      discRender_();
      try{ slbCacheSet_("adminDiscipleList", res || data); }catch(_e2){}
      return S.adminDisciples;
    }

    async function discVerifyMove_(d, toBucket, opts){
      opts = opts || {};
      const to = String(toBucket||"OUT").toUpperCase();
      const name = String((d && (d.taoistName || d.ordinaryName || d.callsign)) || "this disciple");
      const waits = Array.isArray(opts.waits) ? opts.waits : [0, 3500, 8500, 16000];
      for(let i=0;i<waits.length;i++){
        const w = Number(waits[i]||0);
        if(w > 0) await new Promise(resolve=>setTimeout(resolve, w));
        try{
          const fresh = await discFetchDisciplesQuiet_();
          const found = discFindMoved_(fresh, d, to);
          if(found){
            discSetMsg_(true, `${name} is confirmed in ${to}.`);
            try{ if(to === "OUT") discCloseDetail_(); else discSelect_(found); }catch(_eS){}
            return { ok:true, found };
          }
        }catch(_e){
          // Keep verifying on the next loop. Do not turn a slow backend into a false failure.
        }
      }
      discSetMsg_(true, `${name} was sent to ${to}, but the sheet has not confirmed it yet. Check again with Reload in a moment.`);
      return { ok:false };
    }

    function discStartMoveVerify_(d, toBucket, msg){
      try{
        discMoveLocal_(d, toBucket);
        try{ if(String(toBucket||"").toUpperCase() === "OUT") discCloseDetail_(); }catch(_eC){}
        discSetMsg_(true, msg || "Move request sent. Verifying with backend…");
        setTimeout(function(){
          try{ discVerifyMove_(d, toBucket).catch(function(){}); }catch(_e){}
        }, 1200);
      }catch(_e){}
    }

    // Withdraw quick tool (IN -> OUT)
    let _discWithdraw = null;
    let _discWithdrawBusy = false;
    function discWithdrawEnsure_(){
      if(_discWithdraw && _discWithdraw.mask && _discWithdraw.modal) return _discWithdraw;
      const mask = document.createElement("div");
      mask.id = "slbDiscWithdrawMask";
      mask.className = "slbModalMask";
      const modal = document.createElement("div");
      modal.id = "slbDiscWithdrawModal";
      modal.className = "slbModal";
      modal.innerHTML = `
        <h4>Withdraw Disciple</h4>
        <div class="note">Move a disciple from <b>IN</b> to <b>OUT</b> (withdrawn).</div>
        <div class="row" style="gap:8px;align-items:center;flex-wrap:wrap;">
          <select id="slbDiscWithdrawSel" style="width:100%;min-width:260px;"></select>
        </div>
        <div id="slbDiscWithdrawStatus" class="note" style="margin-top:8px;display:none;"></div>
        <div class="actions">
          <button class="btn danger" id="slbDiscWithdrawOk" type="button">Withdraw</button>
          <button class="btn soft" id="slbDiscWithdrawCancel" type="button">Cancel</button>
        </div>
      `;
      var root = (document.getElementById("SaamLawBank") || document.getElementById("tyWealthCourtyard") || document.body);
      root.appendChild(mask);
      root.appendChild(modal);

      const close = ()=>{
        if(_discWithdrawBusy){
          const st = modal.querySelector("#slbDiscWithdrawStatus");
          if(st){ st.style.display = "block"; st.textContent = "Withdraw is being sent. Please wait for confirmation."; }
          return;
        }
        mask.classList.remove("show");
        modal.classList.remove("show");
      };
      mask.addEventListener("click", close);
      const cancel = modal.querySelector("#slbDiscWithdrawCancel");
      if(cancel) cancel.addEventListener("click", close);
      const ok = modal.querySelector("#slbDiscWithdrawOk");
      if(ok) ok.addEventListener("click", async ()=>{
        if(!slbIsAdmin_()) return;
        const sel = modal.querySelector("#slbDiscWithdrawSel");
        const cancelBtn = modal.querySelector("#slbDiscWithdrawCancel");
        const st = modal.querySelector("#slbDiscWithdrawStatus");
        const val = sel ? String(sel.value||"") : "";
        if(!val){ close(); return; }
        const data = S.adminDisciples || { in:[], out:[] };
        const d = (data.in||[]).find(x=>String(x.discipleId||"")===val) || (data.in||[]).find(x=>String(x.callsign||"")===val) || null;
        if(!d){ close(); return; }
        discClearMsg_();
        _discWithdrawBusy = true;
        if(sel) sel.disabled = true;
        if(cancelBtn) cancelBtn.disabled = true;
        if(st){ st.style.display = "block"; st.textContent = "Sending withdraw request… do not close this box yet."; }
        const unlock = lockBtn(ok, "Withdrawing…");
        try{
          const r = await rpc("adminDiscipleMove", { discipleId: d.discipleId, callsign: d.callsign, toBucket: "OUT" }, { timeoutMs: 90000, progressMode: "silent", noGlobalRetry: true, __slbNoGlobalRetry: true });
          if(r && (r.ok || r.success)){
            _discWithdrawBusy = false;
            discMoveLocal_(d, "OUT");
            if(st){ st.textContent = "Withdraw received. Verifying sheet…"; }
            discSetMsg_(true, `Withdrawn request received for ${String(d.taoistName||d.callsign||"")}. Verifying sheet…`);
            mask.classList.remove("show");
            modal.classList.remove("show");
            await discVerifyMove_(d, "OUT", { waits:[0, 3000, 7000] });
          }else{
            _discWithdrawBusy = false;
            discStartMoveVerify_(d, "OUT", "Withdraw response was unclear, so I moved it locally and I am verifying with the sheet…");
            mask.classList.remove("show");
            modal.classList.remove("show");
          }
        }catch(err){
          const msg = (err && err.message) ? String(err.message) : String(err);
          _discWithdrawBusy = false;
          if(/timeout/i.test(msg)){
            discStartMoveVerify_(d, "OUT", "Withdraw was sent, but the browser timed out before Apps Script replied. I moved it locally and I am verifying with the sheet…");
            mask.classList.remove("show");
            modal.classList.remove("show");
          }else{
            discSetMsg_(false, msg);
          }
        }finally{
          _discWithdrawBusy = false;
          try{ if(sel) sel.disabled = false; }catch(_e1){}
          try{ if(cancelBtn) cancelBtn.disabled = false; }catch(_e2){}
          unlock && unlock();
        }
      });

      _discWithdraw = { mask, modal };
      return _discWithdraw;
    }

    function discWithdrawOpen_(){
      if(!slbIsAdmin_()) return;
      const W = discWithdrawEnsure_();
      const data = S.adminDisciples || { in:[], out:[] };
      const arr = (data.in||[]).slice().sort((a,b)=>{
        const an = String(a.taoistName||""), bn = String(b.taoistName||"");
        const ac = String(a.callsign||""), bc = String(b.callsign||"");
        return (an||ac).localeCompare((bn||bc));
      });
      _discWithdrawBusy = false;
      const st = W.modal.querySelector("#slbDiscWithdrawStatus");
      if(st){ st.style.display = "none"; st.textContent = ""; }
      const cancelBtn = W.modal.querySelector("#slbDiscWithdrawCancel");
      if(cancelBtn) cancelBtn.disabled = false;
      const okBtn = W.modal.querySelector("#slbDiscWithdrawOk");
      if(okBtn) okBtn.disabled = false;
      const sel = W.modal.querySelector("#slbDiscWithdrawSel");
      if(sel){
        sel.disabled = false;
        sel.innerHTML = "";
        const opt0 = document.createElement("option");
        opt0.value = "";
        opt0.textContent = "Select a disciple…";
        sel.appendChild(opt0);
        arr.forEach(d=>{
          const o = document.createElement("option");
          o.value = String(d.discipleId||d.callsign||"");
          const tn = String(d.taoistName||"");
          const on = String(d.ordinaryName||"");
          const cs = String(d.callsign||"");
          o.textContent = `${tn || on || "(no name)"} — ${cs}${on && tn ? " — " + on : ""}`;
          sel.appendChild(o);
        });
      }
      W.mask.classList.add("show");
      W.modal.classList.add("show");
    }


    // Hover ID card (quick glance)
    function discHoverEnsure_(){
      let box = document.getElementById("slbDiscHoverCard");
      if(box) return box;
      box = document.createElement("div");
      box.id = "slbDiscHoverCard";
      box.className = "slb-hovercard hidden";
      box.setAttribute("aria-hidden","true");
      document.body.appendChild(box);

      // style (inject once)
      if(!document.getElementById("slbDiscHoverCardStyle")){
        const st = document.createElement("style");
        st.id = "slbDiscHoverCardStyle";
        st.textContent = `
#slbDiscHoverCard.slb-hovercard{position:fixed;z-index:99999;pointer-events:none;min-width:260px;max-width:340px;}
#slbDiscHoverCard.hidden{display:none !important;}
#slbDiscHoverCard .hc{background:var(--ty-card,#fff);color:var(--ty-fg,#111418);border:1px solid rgba(0,0,0,.12);border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.18);padding:10px;display:flex;gap:10px;}
html[data-slb-theme="dark"] #slbDiscHoverCard .hc{background:var(--ty-card,#151c1f);color:#eaf2f5;border-color:rgba(255,255,255,.14);box-shadow:0 12px 36px rgba(0,0,0,.55);}
#slbDiscHoverCard .hc .ph{width:72px;height:72px;border-radius:10px;overflow:hidden;flex:0 0 72px;background:var(--ty-bg2,#f0f2f4);border:1px solid rgba(0,0,0,.08);
html[data-slb-theme="dark"] #slbDiscHoverCard .hc .ph{background:rgba(255,255,255,.06);border-color:rgba(255,255,255,.12);} }
#slbDiscHoverCard .hc .ph img{width:100%;height:100%;object-fit:cover;display:block;}
#slbDiscHoverCard .hc .meta{flex:1;min-width:0;}
#slbDiscHoverCard .hc .nm{font-weight:800;font-size:14px;line-height:1.2;margin:1px 0 2px 0;}
#slbDiscHoverCard .hc .lv{font-weight:700;font-size:12px;opacity:.85;margin-bottom:6px;}
#slbDiscHoverCard .hc .ln{font-size:12px;line-height:1.25;opacity:.9;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
#slbDiscHoverCard .hc .lb{opacity:.65;margin-right:6px;}
html[data-slb-theme="dark"] #slbDiscHoverCard .hc .lb{opacity:.72;color:rgba(234,242,245,.78);} 
`;
        document.head.appendChild(st);
      }
      return box;
    }

    const discHoverPlaceholder_ = (function(){
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
<rect width="120" height="120" rx="18" fill="#e9eef2"/>
<circle cx="60" cy="48" r="20" fill="#c9d4dc"/>
<path d="M20 110c6-22 22-34 40-34s34 12 40 34" fill="#c9d4dc"/>
</svg>`;
      return "data:image/svg+xml;utf8," + encodeURIComponent(svg);
    })();

    function discHoverSet_(d){
      const box = discHoverEnsure_();
      const esc = (t)=>String(t||"")
        .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
        .replace(/"/g,"&quot;").replace(/'/g,"&#39;");
      const img = String((d && d.photoUrl) ? d.photoUrl : "").trim();
      const taoist = String(d && d.taoistName || "").trim();
      const level = discNormLevel_(d && d.level);
      const bday = discIsoDate_(d && d.birthday);
      const email = String(d && d.email || "").trim();
      const country = String(d && d.country || "").trim();
      box.innerHTML = `
        <div class="hc">
          <div class="ph"><img src="${esc(img||discHoverPlaceholder_)}" onerror="this.onerror=null;this.src='${esc(discHoverPlaceholder_)}'"/></div>
          <div class="meta">
            <div class="nm">${esc(taoist||"(No Taoist Name)")}</div>
            <div class="lv">${esc(level||"—")}</div>
            <div class="ln"><span class="lb">Birth:</span>${esc(bday||"—")}</div>
            <div class="ln"><span class="lb">Email:</span>${esc(email||"—")}</div>
            <div class="ln"><span class="lb">Country:</span>${esc(country||"—")}</div>
          </div>
        </div>`;
    }

    function discHoverShow_(d, ev){
      if(!d) return discHoverHide_();
      const box = discHoverEnsure_();
      discHoverSet_(d);
      box.classList.remove("hidden");
      box.setAttribute("aria-hidden","false");
      discHoverMove_(ev);
    }

    function discHoverHide_(){
      const box = document.getElementById("slbDiscHoverCard");
      if(!box) return;
      box.classList.add("hidden");
      box.setAttribute("aria-hidden","true");
    }

    function discHoverMove_(ev){
      const box = document.getElementById("slbDiscHoverCard");
      if(!box || box.classList.contains("hidden")) return;
      const pad = 14;
      const vw = Math.max(320, window.innerWidth||0);
      const vh = Math.max(320, window.innerHeight||0);
      const rect = box.getBoundingClientRect();
      let x = (ev && ev.clientX!=null) ? ev.clientX + pad : pad;
      let y = (ev && ev.clientY!=null) ? ev.clientY + pad : pad;
      if(x + rect.width + pad > vw) x = Math.max(pad, vw - rect.width - pad);
      if(y + rect.height + pad > vh) y = Math.max(pad, (ev && ev.clientY!=null ? ev.clientY - rect.height - pad : vh - rect.height - pad));
      box.style.left = x + "px";
      box.style.top = y + "px";
    }

    let discLoadInFlight_ = null;
    let discLoadStartedAt_ = 0;

    function discUseCachedList_(label){
      try{
        const cached = slbCacheGet_("adminDiscipleList", 7*24*60*60*1000) || slbCacheGet_("adminDiscipleList");
        if(!cached) return false;
        const data0 = (cached && cached.data) ? cached.data : cached;
        if(!data0 || (!Array.isArray(data0.in) && !Array.isArray(data0.out))) return false;
        S.adminDisciples = data0 || { in:[], out:[] };
        try{ S.adminDisciples.__hasLoaded = true; }catch(_e){}
        discApplyAcgOverrides_(S.adminDisciples, label || "cache");
        discApplyOrder_(S.adminDisciples);
        discUpdateSortUI_();
        discRenderInsights_(S.adminDisciples);
        discRender_();
        return true;
      }catch(_e){ return false; }
    }

    async function loadAdminDisciples(force){
      force = !!force;
      const E = discEls_();
      if(!E.page) return;

      // Single-flight guard: do not let auto-load start many backend calls while the first one is still pending.
      // This was causing the Disciples page to sit on "Loading disciple list…", grey the Reload button,
      // and sometimes overload the backend into timeout.
      if(discLoadInFlight_){
        const age = Date.now() - (discLoadStartedAt_ || 0);
        if(!force || age < 65000){
          if(force) discSetMsg_(true, "Disciple list is already loading. Please wait a moment.");
          return discLoadInFlight_;
        }
        // If a previous request somehow stayed around too long, allow a manual reload to replace it.
        discLoadInFlight_ = null;
      }

      const task = (async ()=>{
        discClearMsg_();
        const unlock = force ? lockBtn(E.reloadBtn) : (()=>{});
        try{
          if(E.body && (!S.adminDisciples || !S.adminDisciples.__hasLoaded)){
            try{ E.body.innerHTML = '<tr><td colspan="13" class="muted">Loading disciple list…</td></tr>'; }catch(_eLoadRow){}
          }

          // SWR cache: show cached disciple list instantly. Auto-load uses this without locking the Reload button.
          const hadCache = discUseCachedList_("cache");

          const res = await rpc("adminDiscipleList", { includeOut:true }, { timeoutMs: force ? 70000 : 55000, useWarmCache: !force, cacheTtlMs: force ? 0 : 30000, progressMode: force ? "normal" : "silent", noGlobalRetry: !force, __slbNoGlobalRetry: !force });
          const data = (res && res.data) ? res.data : res;
          S.adminDisciples = data || { in:[], out:[] };
          try{ S.adminDisciples.__hasLoaded = true; }catch(_e){}
          discApplyAcgOverrides_(S.adminDisciples, "server");
          try{ slbCacheSet_("adminDiscipleList", { data: S.adminDisciples }); }catch(_e){}
          discApplyOrder_(S.adminDisciples);
          discUpdateSortUI_();
          discRenderInsights_(S.adminDisciples);
          discRender_();
          discSetMsg_(true, "Loaded.");
        }catch(err){
          const usedCache = !!(S && S.adminDisciples && S.adminDisciples.__hasLoaded) || discUseCachedList_("cache-fallback");
          const msg = (err && err.message) ? err.message : String(err);
          if(usedCache){
            discSetMsg_(false, "Backend timeout / slow response. Showing the last saved disciple list. Try Reload again in a moment if you need fresh data. " + msg);
          }else{
            discSetMsg_(false, msg);
          }
        }finally{
          unlock();
        }
      })();

      discLoadInFlight_ = task;
      discLoadStartedAt_ = Date.now();
      try{ S.__adminDiscipleLoading = true; }catch(_e){}
      try{ return await task; }
      finally{
        if(discLoadInFlight_ === task) discLoadInFlight_ = null;
        try{ S.__adminDiscipleLoading = false; }catch(_e){}
      }
    }

    // Expose a safe hook so other modules (admin page router) can trigger loading
    // without relying on synthetic button clicks (which some themes can block).
    try{ window.SLB_loadAdminDisciples = loadAdminDisciples; }catch(_e){}
    try{ window.SLB_discRender = discRender_; }catch(_e){}

    // Robust auto-load for Admin → Disciples.
    // Some Shopify/theme click/restore paths activate the page without going through the normal admin router.
    // This watcher makes sure the disciple table paints automatically instead of waiting for the Reload button.
    (function(){
      let lastKick = 0;
      function isDisciplePageVisible_(){
        try{
          const p = document.querySelector('#tywAdminPanel .admPage[data-adm="disciples"]');
          if(!p || !p.classList.contains('active')) return false;
          const admin = document.getElementById('tywAdminPanel');
          if(admin && admin.classList && admin.classList.contains('hidden')) return false;
          return true;
        }catch(_e){ return false; }
      }
      function ensureDiscipleListAuto_(){
        try{
          if(!isDisciplePageVisible_()) return;
          const E = discEls_();
          if(E && E.scope && !E.scope.value) E.scope.value = 'IN';
          if(S && !S.adminDiscScope) S.adminDiscScope = 'IN';
          const hasLoaded = !!(S && S.adminDisciples && S.adminDisciples.__hasLoaded);
          const hasRows = !!(E && E.body && E.body.querySelector && E.body.querySelector('tr[data-id]'));
          const now = Date.now();
          if((!hasLoaded || !hasRows) && now - lastKick > 2500){
            lastKick = now;
            loadAdminDisciples(false).catch(function(){});
          }else if(hasLoaded && !hasRows){
            try{ discRender_(); }catch(_eR){}
          }
        }catch(_e){}
      }
      try{ window.SLB_ensureAdminDisciplesAutoLoad = ensureDiscipleListAuto_; }catch(_e0){}
      try{
        document.addEventListener('click', function(){ setTimeout(ensureDiscipleListAuto_, 80); }, true);
        window.addEventListener('hashchange', function(){ setTimeout(ensureDiscipleListAuto_, 150); });
        window.addEventListener('slb:auth-ready', function(){ setTimeout(ensureDiscipleListAuto_, 0); });
        const adminRoot = document.getElementById('tywAdminPanel');
        if(adminRoot && window.MutationObserver){
          let queued = false;
          new MutationObserver(function(){
            if(queued) return;
            queued = true;
            setTimeout(function(){ queued = false; ensureDiscipleListAuto_(); }, 0);
          }).observe(adminRoot, {subtree:true, attributes:true, attributeFilter:['class']});
        }
        setTimeout(ensureDiscipleListAuto_, 250);
      }catch(_e1){}
    })();

    function discBuildCsvClient_(arr){
      const hdr = [
        "Bucket","discipleId","Taoist Name","Ordinary Name","Callsign","Level","Status","ACG","Minister Name",
        "Birthday","Ordain Date","Date of Death",
        "Email","Phone","Address","City","Country",
        "Photo URL","Notes","Special Note","Removed At",
        "createdAt","updatedAt","updatedBy"
      ];
      const esc = (v)=>{
        const s = String(v==null?"":v);
        if(/[",\n]/.test(s)) return '"' + s.replace(/"/g,'""') + '"';
        return s;
      };
      const lines = [];
      lines.push(hdr.map(esc).join(","));
      (arr||[]).forEach(d=>{
        const row = [
          d.bucket, d.discipleId, d.taoistName, d.ordinaryName, d.callsign, d.level, d.status, discIsAcg_(d) ? "1" : "0", d.ministerName,
          discIsoDate_(d.birthday), discIsoDate_(d.ordainDate), discIsoDate_(d.dateOfDeath),
          d.email, d.phone, d.address, d.city, d.country,
          d.photoUrl, d.notes, d.specialNote, discIsoDate_(d.removedAt),
          d.createdAt, d.updatedAt, d.updatedBy
        ];
        lines.push(row.map(esc).join(","));
      });
      return lines.join("\n");
    }



    // ===== ADMIN: ACG manager =====
    function acgEls_(){
      return {
        page: el("slbAdmAcgPage"),
        search: el("slbAdmAcgSearch"),
        reloadBtn: el("slbAdmAcgReloadBtn"),
        exportBtn: el("slbAdmAcgExportBtn"),
        syncBtn: el("slbAdmAcgSyncBtn"),
        summary: el("slbAdmAcgSummary"),
        backendWarn: el("slbAdmAcgBackendWarn"),
        inCount: el("slbAdmAcgInCount"),
        outCount: el("slbAdmAcgOutCount"),
        inBody: el("slbAdmAcgInBody"),
        outBody: el("slbAdmAcgOutBody"),
        ok: el("slbAdmAcgOk"),
        msg: el("slbAdmAcgMsg")
      };
    }
    function acgSetMsg_(ok,msg){
      const E = acgEls_();
      if(E.ok){ E.ok.classList.toggle("hidden", !ok || !msg); E.ok.textContent = ok && msg ? String(msg) : ""; }
      if(E.msg){ E.msg.classList.toggle("hidden", ok || !msg); E.msg.textContent = (!ok && msg) ? String(msg) : ""; }
    }
    function acgName_(d){ return String((d && (d.taoistName || d.ordinaryName || d.callsign)) || "").trim(); }

    function discLocalAcgRecords_(){
      const map = discLoadAcgOverrides_();
      const seen = {};
      const rows = [];
      Object.keys(map||{}).forEach(k=>{
        const r = map[k] || {};
        const key = String(r.discipleId||"") || String(r.callsign||"") || k;
        if(!key || seen[key]) return;
        seen[key] = true;
        rows.push({
          discipleId: String(r.discipleId||""),
          callsign: String(r.callsign||"").trim().toUpperCase(),
          name: String(r.name||""),
          on: discBoolFlag_(r.v),
          ts: r.ts || 0
        });
      });
      return rows;
    }
    function acgFindByKey_(discipleId, callsign){
      const all = discAll_(S.adminDisciples || { in:[], out:[] });
      const id = String(discipleId||"");
      const cs = String(callsign||"").trim().toUpperCase();
      return all.find(x=> (id && String((x&&x.discipleId)||"")===id) || (cs && String((x&&x.callsign)||"").trim().toUpperCase()===cs)) || null;
    }
    function acgRender_(){
      const E = acgEls_();
      if(!E.inBody || !E.outBody) return;
      const data = S.adminDisciples || { in:[], out:[] };
      const q = String(E.search && E.search.value ? E.search.value : "").trim().toLowerCase();
      const base = (data.in || []).filter(d=> String(d && d.bucket || "IN").toUpperCase() !== "OUT");
      const match = (d)=>{
        if(!q) return true;
        const hay = [d.taoistName,d.ordinaryName,d.callsign,d.level,d.status,d.email,d.country, discIsAcg_(d)?"in acg":"not acg"].map(x=>String(x||"").toLowerCase()).join(" | ");
        return hay.indexOf(q) !== -1;
      };
      const inAcg = base.filter(d=>discIsAcg_(d)).filter(match);
      const outAcg = base.filter(d=>!discIsAcg_(d)).filter(match);
      const esc = (t)=>String(t==null?"":t).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;");
      const row = (d,on)=>`<tr data-id="${esc(d.discipleId||"")}" data-callsign="${esc(String(d.callsign||"").toUpperCase())}">
        <td>${esc(acgName_(d))}${d.__acgLocalOverride ? ' <span class="badge">local</span>' : ''}</td>
        <td>${esc(String(d.callsign||"").toUpperCase())}</td>
        <td>${esc(discNormLevel_(d.level)||"")}</td>
        <td><button class="btn ${on ? 'danger' : 'orange'} mini" data-acg-action="${on ? 'out' : 'in'}" data-id="${esc(d.discipleId||"")}" data-callsign="${esc(String(d.callsign||"").toUpperCase())}" type="button">${on ? 'Kick OUT ACG' : 'Put IN ACG'}</button></td>
      </tr>`;
      E.inBody.innerHTML = inAcg.length ? inAcg.map(d=>row(d,true)).join("") : '<tr><td colspan="4">No one in ACG.</td></tr>';
      E.outBody.innerHTML = outAcg.length ? outAcg.map(d=>row(d,false)).join("") : '<tr><td colspan="4">No matching disciples outside ACG.</td></tr>';
      if(E.inCount) E.inCount.textContent = String((base||[]).filter(discIsAcg_).length);
      if(E.outCount) E.outCount.textContent = String((base||[]).filter(d=>!discIsAcg_(d)).length);
      if(E.summary){
        let extra = "";
        if(data && data.__acgOverrideCount) extra += ` • Local pending ${data.__acgOverrideCount}`;
        if(data && data.__acgBackendMissing) extra += " • BACKEND ACG NOT LIVE";
        else if(data && data.__acgBackendHasField) extra += " • Backend ACG confirmed";
        E.summary.textContent = `Lineage IN ${base.length} • ACG ${(base||[]).filter(discIsAcg_).length} • Not ACG ${(base||[]).filter(d=>!discIsAcg_(d)).length}${extra}`;
      }
      if(E.backendWarn){
        const show = !!(data && data.__acgBackendMissing);
        E.backendWarn.classList.toggle("hidden", !show);
        E.backendWarn.style.display = show ? "block" : "none";
        if(show) E.backendWarn.textContent = "The connected backend is not returning the canonical ACG field yet. Upload and deploy the matching Phase 1 backend ZIP, then reload this page.";
      }
    }
    let acgAutoMigrationStarted_ = false;
    async function loadAdminAcg(force){
      try{ await loadAdminDisciples(!!force); }catch(_e){}
      try{ acgRender_(); }catch(_e2){}
      // One-time migration: automatically push ACG choices that were saved locally
      // by the older frontend before the canonical backend ACG column existed.
      const data = S.adminDisciples || {};
      if(!acgAutoMigrationStarted_ && data.__acgBackendHasField && Number(data.__acgOverrideCount||0) > 0){
        acgAutoMigrationStarted_ = true;
        acgSetMsg_(true, "Migrating older saved ACG choices into the backend…");
        try{ await acgSyncLocalOverrides_(); }catch(_e3){}
      }
    }
    async function acgToggle_(disciple,on){
      if(!slbIsAdmin_()) return;
      const d0 = disciple || {};
      const name = acgName_(d0) || String(d0.callsign||"this disciple");
      const d = discSetAcgFields_(Object.assign({}, d0), !!on);
      d.bucket = String(d.bucket || d0.bucket || "IN").toUpperCase();
      acgSetMsg_(true, "Updating Library ACG access for " + name + "…");

      // Keep a local copy first so the admin page does not bounce empty if Apps Script ignores ACG.
      discRememberAcgOverride_(d, !!on);

      function applyLocal_(source){
        const data0 = S.adminDisciples || { in:[], out:[] };
        data0.in = Array.isArray(data0.in) ? data0.in : [];
        data0.out = Array.isArray(data0.out) ? data0.out : [];
        const list = String(d.bucket).toUpperCase()==="OUT" ? data0.out : data0.in;
        let ix = -1;
        const idStr = String(d.discipleId||"");
        const csStr = String(d.callsign||"").trim().toUpperCase();
        if(idStr) ix = list.findIndex(x=>String((x&&x.discipleId)||"")===idStr);
        if(ix < 0 && csStr) ix = list.findIndex(x=>String((x&&x.callsign)||"").trim().toUpperCase()===csStr);
        if(ix >= 0) list[ix] = Object.assign({}, list[ix], d);
        data0.__hasLoaded = true;
        discApplyAcgOverrides_(data0, source || "local");
        discApplyOrder_(data0);
        S.adminDisciples = data0;
        if(S.adminDiscSelected){
          const selId = String(S.adminDiscSelected.discipleId||"");
          const selCs = String(S.adminDiscSelected.callsign||"").trim().toUpperCase();
          if((idStr && selId===idStr) || (csStr && selCs===csStr)) discSetAcgFields_(S.adminDiscSelected, !!on);
        }
        discSaveAdminCache_();
        discRenderInsights_(S.adminDisciples);
        discRender_();
        acgRender_();
      }

      try{
        const res = await rpc("adminDiscipleUpsert", { bucket: d.bucket, disciple: d }, { timeoutMs: 90000, progressMode:"silent", noGlobalRetry:true, __slbNoGlobalRetry:true });
        applyLocal_("local-sent");
        if(res && res.__queued){
          acgSetMsg_(true, name + " changed locally and queued. Tap Sync when online.");
          return;
        }

        // Verify with a fresh backend list. If Apps Script does not return ACG, this is still local-only.
        let verified = false, backendHasAnyAcg = false, foundFresh = null;
        try{
          const freshRes = await rpc("adminDiscipleList", { includeOut:true }, { timeoutMs: 60000, useWarmCache:false, cacheTtlMs:0, progressMode:"silent", noGlobalRetry:true, __slbNoGlobalRetry:true });
          const fresh = (freshRes && freshRes.data) ? freshRes.data : freshRes;
          const all = discAll_(fresh || { in:[], out:[] });
          backendHasAnyAcg = all.some(discAcgHasField_);
          const idStr = String(d.discipleId||"");
          const csStr = String(d.callsign||"").trim().toUpperCase();
          foundFresh = all.find(x=> (idStr && String((x&&x.discipleId)||"")===idStr) || (csStr && String((x&&x.callsign)||"").trim().toUpperCase()===csStr)) || null;
          verified = !!(foundFresh && discAcgHasField_(foundFresh) && discIsAcg_(foundFresh) === !!on);
          if(verified){
            discClearAcgOverride_(d);
            S.adminDisciples = fresh || { in:[], out:[] };
            try{ S.adminDisciples.__hasLoaded = true; }catch(_e){}
            discApplyAcgOverrides_(S.adminDisciples, "server-verified");
            try{ slbCacheSet_("adminDiscipleList", { data: S.adminDisciples }); }catch(_e2){}
            discApplyOrder_(S.adminDisciples);
            discRenderInsights_(S.adminDisciples);
            discRender_();
            acgRender_();
          }else{
            applyLocal_("local-backend-not-confirmed");
          }
        }catch(_verifyErr){
          applyLocal_("local-verify-failed");
        }

        if(verified){
          acgSetMsg_(true, name + " is now " + (on ? "IN ACG" : "OUT of ACG") + " and the Library access record is confirmed.");
        }else if(!backendHasAnyAcg){
          acgSetMsg_(false, name + " changed locally only. Backend accepted the request but is not returning an ACG column yet, so the Sheet/Apps Script is not live for ACG.");
        }else{
          acgSetMsg_(false, name + " changed locally, but backend did not confirm the ACG value yet. Reload later or check the ACG column in the Sheet.");
        }
      }catch(err){
        try{ applyLocal_("local-fallback"); }catch(_eLocal){}
        acgSetMsg_(false, ((err && err.message) ? err.message : String(err)) + " — ACG change kept locally only; backend did not confirm.");
      }
    }

    async function acgSyncLocalOverrides_(){
      if(!slbIsAdmin_()) return;
      const pending = discLocalAcgRecords_();
      if(!pending.length){
        acgSetMsg_(true, "No local ACG changes waiting to sync.");
        try{ await loadAdminAcg(true); }catch(_e){}
        return;
      }
      acgSetMsg_(true, "Syncing " + pending.length + " local ACG change(s) to backend...");
      try{ await loadAdminDisciples(true); }catch(_e0){}
      const all = discAll_(S.adminDisciples || { in:[], out:[] });
      let sent = 0, failed = 0;
      const failedNames = [];
      for(const rec of pending){
        const id = String(rec.discipleId||"");
        const cs = String(rec.callsign||"").trim().toUpperCase();
        const found = all.find(x=> (id && String((x&&x.discipleId)||"")===id) || (cs && String((x&&x.callsign)||"").trim().toUpperCase()===cs)) || null;
        if(!found){ failed++; failedNames.push(rec.name || rec.callsign || rec.discipleId || "unknown"); continue; }
        const d = discSetAcgFields_(Object.assign({}, found), !!rec.on);
        d.bucket = String(d.bucket || found.bucket || "IN").toUpperCase();
        try{
          await rpc("adminDiscipleUpsert", { bucket: d.bucket, disciple: d }, { timeoutMs: 90000, progressMode:"silent", noGlobalRetry:true, __slbNoGlobalRetry:true });
          sent++;
        }catch(e){
          failed++;
          failedNames.push(acgName_(found) || rec.callsign || rec.discipleId || ((e&&e.message)||"unknown"));
        }
      }

      let verified = 0;
      try{
        const freshRes = await rpc("adminDiscipleList", { includeOut:true }, { timeoutMs: 60000, useWarmCache:false, cacheTtlMs:0, progressMode:"silent", noGlobalRetry:true, __slbNoGlobalRetry:true });
        const fresh = (freshRes && freshRes.data) ? freshRes.data : freshRes;
        const fall = discAll_(fresh || { in:[], out:[] });
        pending.forEach(rec=>{
          const id = String(rec.discipleId||"");
          const cs = String(rec.callsign||"").trim().toUpperCase();
          const got = fall.find(x=> (id && String((x&&x.discipleId)||"")===id) || (cs && String((x&&x.callsign)||"").trim().toUpperCase()===cs)) || null;
          if(got && discAcgHasField_(got) && discIsAcg_(got) === !!rec.on){
            discClearAcgOverride_(got);
            verified++;
          }
        });
        S.adminDisciples = fresh || { in:[], out:[] };
        try{ S.adminDisciples.__hasLoaded = true; }catch(_e){}
        discApplyAcgOverrides_(S.adminDisciples, "sync-local-to-backend");
        try{ slbCacheSet_("adminDiscipleList", { data: S.adminDisciples }); }catch(_e2){}
        discApplyOrder_(S.adminDisciples);
        discRenderInsights_(S.adminDisciples);
        discRender_();
        acgRender_();
      }catch(e2){
        failed++;
      }

      if(verified === pending.length){
        acgSetMsg_(true, "Synced and backend confirmed all " + verified + " local ACG change(s).");
      }else if(verified > 0){
        acgSetMsg_(false, "Synced " + verified + " of " + pending.length + " local ACG change(s). Remaining local items need reload/check. Failed: " + (failedNames.slice(0,5).join(", ") || failed));
      }else if(sent > 0){
        acgSetMsg_(false, "Sent " + sent + " local ACG change(s), but backend did not confirm them yet. Reload ACG page and check the Sheet ACG column.");
      }else{
        acgSetMsg_(false, "No local ACG changes were synced. Failed: " + (failedNames.slice(0,5).join(", ") || failed));
      }
    }

    // UI wiring (once)
    onOnce("slbAdmDiscReloadBtn","click", async ()=>{ await loadAdminDisciples(true); });

    onOnce("slbAdmAcgReloadBtn","click", async ()=>{ await loadAdminAcg(true); });
    onOnce("slbAdmAcgExportBtn","click", ()=>{
      try{
        const csv = discExportLocalAcgCsv_();
        discDownloadText_("slb-acg-local-overrides.csv", csv);
        acgSetMsg_(true, "Downloaded local ACG CSV as a backup.");
      }catch(e){ acgSetMsg_(false, (e && e.message) ? e.message : String(e)); }
    });
    onOnce("slbAdmAcgSyncBtn","click", async ()=>{ await acgSyncLocalOverrides_(); });
    onOnce("slbAdmAcgSearch","input", ()=>{ acgRender_(); });
    onOnce("slbAdmAcgPage","click", async (ev)=>{
      const t = ev && ev.target ? ev.target : null;
      const btn = t ? t.closest("button[data-acg-action]") : null;
      if(!btn) return;
      const on = String(btn.getAttribute("data-acg-action")||"") === "in";
      const d = acgFindByKey_(btn.getAttribute("data-id"), btn.getAttribute("data-callsign"));
      if(!d){ acgSetMsg_(false, "Disciple not found. Reload and try again."); return; }
      const unlock = lockBtn(btn, on ? "Putting IN…" : "Kicking OUT…");
      try{ await acgToggle_(d,on); }finally{ unlock(); }
    });
    try{ window.SLB_loadAdminAcg = loadAdminAcg; window.SLB_acgRender = acgRender_; window.SLB_syncLocalAcgToBackend = acgSyncLocalOverrides_; }catch(_e){}
    (function acgAutoLoad_(){
      function activeAcg(){ try{ const p = document.querySelector('#tywAdminPanel .admPage.active'); return !!(p && String(p.getAttribute('data-adm')||'') === 'acg'); }catch(_e){ return false; } }
      function kick(){
        try{
          if(!activeAcg()) return;
          const has = !!(S && S.adminDisciples && S.adminDisciples.__hasLoaded);
          if(!has) loadAdminAcg(false).catch(()=>{});
          else acgRender_();
        }catch(_e){}
      }
      try{
        document.addEventListener('click', function(){ setTimeout(kick, 120); }, true);
        window.addEventListener('hashchange', function(){ setTimeout(kick, 180); });
        window.addEventListener('slb:auth-ready', function(){ setTimeout(kick, 0); });
        const adminRoot = document.getElementById('tywAdminPanel');
        if(adminRoot && window.MutationObserver){
          let queued = false;
          new MutationObserver(function(){
            if(queued) return;
            queued = true;
            setTimeout(function(){ queued = false; kick(); }, 0);
          }).observe(adminRoot, {subtree:true, attributes:true, attributeFilter:['class']});
        }
      }catch(_e){}
    })();


    // ===== ADMIN: Saam Law Library telemetry viewer =====
    function libTelEls_(){
      return {page:el("slbAdmLibraryTelemetry"),days:el("slbAdmLibTelDays"),event:el("slbAdmLibTelEvent"),access:el("slbAdmLibTelAccess"),callsign:el("slbAdmLibTelCallsign"),query:el("slbAdmLibTelQuery"),reload:el("slbAdmLibTelReload"),total:el("slbAdmLibTelTotal"),errors:el("slbAdmLibTelErrors"),slow:el("slbAdmLibTelSlow"),downloads:el("slbAdmLibTelDownloads"),avg:el("slbAdmLibTelAvg"),max:el("slbAdmLibTelMax"),users:el("slbAdmLibTelUsers"),eventSummary:el("slbAdmLibTelEventSummary"),body:el("slbAdmLibTelBody"),ok:el("slbAdmLibTelOk"),msg:el("slbAdmLibTelMsg")};
    }
    function libTelEsc_(v){ return String(v==null?"":v).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\"/g,"&quot;").replace(/'/g,"&#39;"); }
    function libTelMsg_(ok,msg){ const E=libTelEls_(); if(E.ok){E.ok.classList.toggle("hidden",!ok||!msg);E.ok.textContent=ok&&msg?String(msg):"";} if(E.msg){E.msg.classList.toggle("hidden",ok||!msg);E.msg.textContent=!ok&&msg?String(msg):"";} }
    function libTelTime_(v){ try{ const d=new Date(v); if(!isNaN(d.getTime())) return d.toLocaleString(); }catch(_e){} return String(v||""); }
    function libTelEventClass_(v){ const s=String(v||"").toLowerCase(); return /error/.test(s)?"danger":(/^slow_/.test(s)?"warn":""); }
    function renderLibraryTelemetry_(data){
      const E=libTelEls_(), d=(data&&data.data)?data.data:(data||{}), sm=d.summary||{}, rows=Array.isArray(d.rows)?d.rows:[];
      if(E.total)E.total.textContent=String(sm.total||0); if(E.errors)E.errors.textContent=String(sm.errors||0); if(E.slow)E.slow.textContent=String(sm.slow||0); if(E.downloads)E.downloads.textContent=String(sm.downloads||0);
      if(E.avg)E.avg.textContent=String(sm.averageDurationMs||0)+" ms"; if(E.max)E.max.textContent=String(sm.maxDurationMs||0)+" ms"; if(E.users)E.users.textContent=String(sm.affectedCallsigns||0);
      if(E.eventSummary){ const parts=Object.keys(sm.byEvent||{}).sort((a,b)=>(sm.byEvent[b]||0)-(sm.byEvent[a]||0)).slice(0,5).map(k=>k+" "+sm.byEvent[k]); E.eventSummary.textContent=parts.length?parts.join(" • "):"No events"; }
      if(E.body){
        E.body.innerHTML=rows.length?rows.map(r=>`<tr><td>${libTelEsc_(libTelTime_(r.timestamp))}</td><td><b>${libTelEsc_(r.callsign)}</b></td><td>${libTelEsc_(r.access)}</td><td><span class="badge ${libTelEventClass_(r.event)}">${libTelEsc_(r.event)}</span></td><td>${libTelEsc_(Number(r.durationMs||0).toLocaleString())} ms</td><td style="min-width:260px;max-width:520px;white-space:normal;overflow-wrap:anywhere;">${libTelEsc_(r.detail)}</td><td style="max-width:220px;white-space:normal;overflow-wrap:anywhere;">${libTelEsc_(r.clientBuild)}</td></tr>`).join(""):'<tr><td colspan="7">No Library telemetry matched these filters.</td></tr>';
      }
      libTelMsg_(true,d.sheetExists===false?"No telemetry sheet exists yet. It will be created after the Library records its first report.":("Loaded "+rows.length+" row(s)."));
    }
    async function loadLibraryTelemetry_(force){
      if(!slbIsAdmin_()) return;
      const E=libTelEls_(); if(!E.page)return;
      const args={days:Number(E.days&&E.days.value||7),limit:250,event:String(E.event&&E.event.value||""),access:String(E.access&&E.access.value||""),callsign:String(E.callsign&&E.callsign.value||"").trim().toUpperCase(),query:String(E.query&&E.query.value||"").trim()};
      libTelMsg_(true,"Loading Library logs…"); if(E.reload)E.reload.disabled=true;
      try{ const res=await rpc("adminLibraryTelemetry",args,{timeoutMs:60000,progressMode:force?"normal":"silent",useWarmCache:false,cacheTtlMs:0,noGlobalRetry:true,__slbNoGlobalRetry:true}); renderLibraryTelemetry_(res); }
      catch(err){ libTelMsg_(false,(err&&err.message)?err.message:String(err)); }
      finally{ if(E.reload)E.reload.disabled=false; }
    }
    onOnce("slbAdmLibTelReload","click",()=>{loadLibraryTelemetry_(true);});
    ["slbAdmLibTelDays","slbAdmLibTelEvent","slbAdmLibTelAccess"].forEach(id=>onOnce(id,"change",()=>{loadLibraryTelemetry_(false);}));
    ["slbAdmLibTelCallsign","slbAdmLibTelQuery"].forEach(id=>onOnce(id,"keydown",ev=>{if(ev&&ev.key==="Enter")loadLibraryTelemetry_(true);}));
    try{ window.SLB_loadLibraryTelemetry=loadLibraryTelemetry_; }catch(_e){}
    (function libTelAutoLoad_(){
      let last=0;
      function kick(){ try{ const p=document.querySelector('#tywAdminPanel .admPage.active'); if(!p||String(p.getAttribute('data-adm')||'')!=="library_telemetry")return; const now=Date.now(); if(now-last<1500)return; last=now; loadLibraryTelemetry_(false); }catch(_e){} }
      try{ document.addEventListener('click',()=>setTimeout(kick,120),true); window.addEventListener('hashchange',()=>setTimeout(kick,180)); const r=document.getElementById('tywAdminPanel'); if(r&&window.MutationObserver)new MutationObserver(()=>setTimeout(kick,0)).observe(r,{subtree:true,attributes:true,attributeFilter:['class']}); }catch(_e){}
    })();

    onOnce("slbAdmDiscSearch","input", ()=>{ discRender_(); });
    onOnce("slbAdmDiscScope","change", ()=>{ discRender_(); });
    onOnce("slbAdmDiscSort","change", ()=>{ const E = discEls_(); S.adminDiscSortKey = String((E.sort && E.sort.value!=null) ? E.sort.value : "__order"); discRender_(); });
    onOnce("slbAdmDiscSortDir","click", ()=>{ S.adminDiscSortDir = (S.adminDiscSortDir===-1) ? 1 : -1; discRender_(); });
    onOnce("slbAdmDiscTable","click", (ev)=>{ const t = ev && ev.target ? ev.target : null; const th = t ? t.closest("th[data-sort-key]") : null; if(th){ const key = th.getAttribute("data-sort-key"); if(String(S.adminDiscSortKey||"__order") === String(key||"")){ S.adminDiscSortDir = (S.adminDiscSortDir===-1) ? 1 : -1; }else{ S.adminDiscSortKey = String(key||"__order"); S.adminDiscSortDir = 1; } const E = discEls_(); if(E.sort) E.sort.value = String(S.adminDiscSortKey||"__order"); discRender_(); return; } const tr = t ? t.closest("tr[data-id]") : null; if(!tr) return; const id = String(tr.getAttribute("data-id")||""); const b = String(tr.getAttribute("data-bucket")||""); const cs = String(tr.getAttribute("data-callsign")||""); const data = S.adminDisciples || { in:[], out:[] }; const all = discAll_(data); let found = null; if(id){ found = all.find(x=>String(x.discipleId||"")===id && String(x.bucket||"")===b) || all.find(x=>String(x.discipleId||"")===id) || null; } if(!found && cs){ found = all.find(x=>String(x.callsign||"")===cs && String(x.bucket||"")===b) || all.find(x=>String(x.callsign||"")===cs) || null; } if(found){ discSelect_(found); } });
    // Hover card wiring
    onOnce("slbAdmDiscTable","mousemove", (ev)=>{
      const t = ev && ev.target ? ev.target : null;
      const tr = t ? t.closest("tr[data-idx]") : null;
      if(!tr){ discHoverHide_(); return; }
      const idx = parseInt(tr.getAttribute("data-idx")||"-1",10);
      const arr = S.adminDiscRendered || [];
      const d = (idx>=0 && idx < arr.length) ? arr[idx] : null;
      if(d){ discHoverShow_(d, ev); } else { discHoverHide_(); }
    });
    onOnce("slbAdmDiscTable","mouseleave", ()=>{ discHoverHide_(); });

onOnce("slbAdmDiscExportBtn","click", async ()=>{
      const E = discEls_();
      discClearMsg_();
      const unlock = lockBtn(E.exportBtn);
      try{
        // Preferred: server-side ZIP containing BOTH IN + OUT
        const res = await rpcTryCached("adminDiscipleExportZip", ["adminDiscipleExportZip","discipleExportZip","exportDisciplesZip"], {});
        const data = (res && res.data) ? res.data : res;
        const b64 = data && (data.zipBase64 || data.base64 || data.b64);
        const fn = (data && (data.fileName || data.filename)) || ("slb-disciples-backup-" + new Date().toISOString().slice(0,10) + ".zip");

        if(b64){
          const bytes = Uint8Array.from(atob(b64), c=>c.charCodeAt(0));
          const blob = new Blob([bytes], { type:"application/zip" });
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = fn;
          document.body.appendChild(a);
          a.click();
          setTimeout(()=>{ try{ URL.revokeObjectURL(a.href); }catch(_e){} a.remove(); }, 80);
          discSetMsg_(true, "Backup downloaded: " + fn);
          return;
        }

        // Fallback: export 2 CSV files (IN + OUT) if ZIP isn't available
        const all = S.adminDisciples || { in:[], out:[] };
        const today = new Date().toISOString().slice(0,10);
        const dl = (text, name)=>{
          const blob = new Blob([text], { type:"text/csv;charset=utf-8" });
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = name;
          document.body.appendChild(a);
          a.click();
          setTimeout(()=>{ try{ URL.revokeObjectURL(a.href); }catch(_e){} a.remove(); }, 80);
        };
        dl("\uFEFF" + discBuildCsvClient_((all.in||[]).map(d=>({ ...d, bucket:"IN" }))), "slb-disciples-IN-" + today + ".csv");
        dl("\uFEFF" + discBuildCsvClient_((all.out||[]).map(d=>({ ...d, bucket:"OUT" }))), "slb-disciples-OUT-" + today + ".csv");
        discSetMsg_(true, "Exported IN + OUT CSV (fallback).");
      }catch(err){
        discSetMsg_(false, (err && err.message) ? err.message : String(err));
      }finally{ unlock(); }
    });

    onOnce("slbAdmDiscAddBtn","click", ()=>{ discNew_(); });

    // Ordain request parser (admin only)
    onOnce("slbAdmDiscParseBtn","click", ()=>{ discParsePasteToFields_(); });
    onOnce("slbAdmDiscParseClearBtn","click", ()=>{
      const E = discEls_();
      if(E && E.parserText) E.parserText.value = "";
      discSetParseMsg_("");
    });

    // NEW ORDAIN / WITHDRAW fallback wiring (works even if elements are injected late)
    document.addEventListener("click", (e)=>{
      const t = e && e.target && e.target.closest ? e.target.closest("#slbAdmDiscAddBtn") : null;
      if(t){ discNew_(); }
      const w = e && e.target && e.target.closest ? e.target.closest("#slbAdmDiscWithdrawBtn") : null;
      if(w){ discWithdrawOpen_(); }

      const p = e && e.target && e.target.closest ? e.target.closest("#slbAdmDiscParseBtn") : null;
      if(p){ discParsePasteToFields_(); }

      const pc = e && e.target && e.target.closest ? e.target.closest("#slbAdmDiscParseClearBtn") : null;
      if(pc){
        const E = discEls_();
        if(E && E.parserText) E.parserText.value = "";
        discSetParseMsg_("");
      }
    });

    onOnce("slbAdmDiscWithdrawBtn","click", ()=>{ discWithdrawOpen_(); });

    // Callsign / Level auto-sync
    onOnce("slbAdmDiscCallsign","input", ()=>{ discSyncFromCallsignInput_(); });
    onOnce("slbAdmDiscCallsign","blur", ()=>{ const E = discEls_(); if(E.callsign){ E.callsign.value = String(E.callsign.value||"").toUpperCase().replace(/\s+/g,""); } discSyncFromCallsignInput_(); });
    onOnce("slbAdmDiscLevel","change", ()=>{ discSyncFromLevelInput_(); });

    onOnce("slbAdmDiscDedupeBtn","click", async ()=>{
      const E = discEls_();
      if(!slbIsAdmin_()) return;
      discClearMsg_();
      const scope = String((E.scope && E.scope.value) ? E.scope.value : "IN").toUpperCase();
      if(scope==="ALL"){
        discSetMsg_(false, "Please switch Scope to IN or OUT before deduplicating.");
        return;
      }
      const bucket = (scope==="OUT") ? "OUT" : "IN";
      const unlock = lockBtn(document.getElementById("slbAdmDiscDedupeBtn"));
      try{
        const r = await rpc("adminDiscipleDedupe", { bucket });
        if(r && r.ok){
          discSetMsg_(true, "Deduplicated " + bucket + ": removed " + (r.removed||0) + " duplicates. Reloading…");
          await loadAdminDisciples(true);
        }else{
          discSetMsg_(false, "Deduplicate failed.");
        }
      }catch(err){
        discSetMsg_(false, (err && err.message) ? err.message : String(err));
      }finally{ unlock && unlock(); }
    });

    // Import CSV (admin only)
    onOnce("slbAdmDiscImportFile","change", async (e)=>{
      const E = discEls_();
      if(!slbIsAdmin_()) return;
      const file = e && e.target && e.target.files && e.target.files[0];
      if(!file) return;
      discClearMsg_();
      try{
        const txt = await file.text();
        const scope = String((E.scope && E.scope.value) ? E.scope.value : "IN").toUpperCase();
        const bucket = (scope==="OUT") ? "OUT" : "IN";

        // Chunked upload (JSONP GET has URL length limits)
        const b64 = btoa(unescape(encodeURIComponent(txt)));
        const chunkSize = 900; // base64 chars per chunk (safe for URL length)
        const total = Math.max(1, Math.ceil(b64.length / chunkSize));

        // Resume state (if previous run timed out)
        const stateKey = "slb_dimp_" + bucket + "_" + file.name + "_" + file.size + "_" + file.lastModified;
        let state = null;
        try{ state = JSON.parse(localStorage.getItem(stateKey)||"null"); }catch(_e){ state = null; }

        let sessionId = (state && state.sessionId && state.total===total) ? String(state.sessionId) : "";
        let startAt = (state && isFinite(state.nextIndex)) ? Math.max(0, parseInt(state.nextIndex,10)||0) : 0;

        if(!sessionId){
          sessionId = "DIMP_" + Date.now() + "_" + Math.random().toString(16).slice(2);
          startAt = 0;
        }
        let finalResult = null;

        for(let i=startAt;i<total;i++){
          const chunkB64 = b64.slice(i*chunkSize, (i+1)*chunkSize);
          discSetMsg_(true, (i < total-1) ? ("Uploading… (" + (i+1) + "/" + total + ")") : "Finalizing import… (this step writes to the sheet)");
          // persist progress BEFORE sending next chunk (so user can resume even if browser crashes)
          try{
            localStorage.setItem(stateKey, JSON.stringify({ sessionId, total, nextIndex: i, at: Date.now() }));
          }catch(_e){}

          const r = await rpc("adminDiscipleImportCsvChunk", { bucket, sessionId, index:i, total:total, chunkB64:chunkB64 });

          // update progress after ack
          try{
            localStorage.setItem(stateKey, JSON.stringify({ sessionId, total, nextIndex: i+1, at: Date.now() }));
          }catch(_e){}
          if(r && r.done){
            finalResult = r;
            try{ localStorage.removeItem(stateKey); }catch(_e){}
            break;
          }
        }

                (function(){
          var m = "Imported.";
          try{
            if(finalResult){
              var created = Number(finalResult.created||0)||0;
              var updated = Number(finalResult.updated||0)||0;
              var skipped = Number(finalResult.skipped||0)||0;
              var errs = (finalResult.errors && finalResult.errors.length) ? finalResult.errors : [];
              m = "Imported: " + created + " new, " + updated + " updated" + (skipped? (", " + skipped + " skipped") : "");
              if(errs.length){
                var sample = errs.slice(0,3).map(function(e){ return "#" + (e.row||"?") + " " + (e.error||""); }).join(" | ");
                m += " — " + errs.length + " error(s). " + sample;
              }
              m += "  Reloading…";
            }else{
              m = "Imported. Reloading…";
            }
          }catch(_e){}
          discSetMsg_(true, m);
        })();
        if(E.importFile) E.importFile.value = "";
        await loadAdminDisciples(true);
      }catch(err){
        // keep resume state; user can re-select the same file to continue
        const msg = (err && err.message) ? err.message : String(err);
        discSetMsg_(false, msg + "  (Tip: re-select the SAME file to resume.)");
      }
    });

    // Row view button
    document.addEventListener("click", (e)=>{
      const b = e && e.target && e.target.closest ? e.target.closest("button[data-disc-view]") : null;
      if(!b) return;

      const data = S.adminDisciples || { in:[], out:[] };
      const all = discAll_(data);

      const id = String(b.getAttribute("data-id")||"").trim();
      const idx = Number(b.getAttribute("data-idx"));
      const cs = String(b.getAttribute("data-callsign")||"").trim();
      const bucket = String(b.getAttribute("data-bucket")||"").trim();

      let found = null;

      // Prefer stable ID
      if(id){
        found = all.find(x=>String(x.discipleId||"")===id) || null;
      }

      // Fallback: last rendered list index (works even if IDs are missing)
      if(!found && Number.isFinite(idx) && Array.isArray(S.adminDiscRendered) && S.adminDiscRendered[idx]){
        found = S.adminDiscRendered[idx];
      }

      // Fallback: callsign (+bucket)
      if(!found && cs){
        found = all.find(x=>String(x.callsign||"").trim()===cs && String(x.bucket||"IN").trim().toUpperCase()===bucket.toUpperCase()) ||
                all.find(x=>String(x.callsign||"").trim()===cs) || null;
      }

      if(found) discSelect_(found);
    });

onOnce("slbAdmDiscCloseBtn","click", ()=>{ discCloseDetail_(); });

    onOnce("slbAdmDiscSaveBtn","click", async ()=>{
      const E = discEls_();
      if(!slbIsAdmin_()) return;
      discClearMsg_();
      const unlock = lockBtn(E.saveBtn);
      try{
        const __startWasNewDisc = !String(E.id && E.id.value ? E.id.value : "").trim();
        const d0 = S.adminDiscSelected || {};
        const scope = String((E.scope && E.scope.value) ? E.scope.value : (d0.bucket||"IN")).toUpperCase();
        let bucket = (d0 && d0.bucket) ? String(d0.bucket) : (scope==="OUT" ? "OUT" : "IN");
        if(scope==="ALL" && !d0.bucket) bucket = "IN";

        const disciple = {
          discipleId: String(E.id && E.id.value ? E.id.value : ""),
          bucket,
          ordinaryName: String(E.ordinary && E.ordinary.value ? E.ordinary.value : ""),
          taoistName: String(E.taoist && E.taoist.value ? E.taoist.value : ""),
          callsign: String(E.callsign && E.callsign.value ? E.callsign.value : "").toUpperCase(),
          level: String(E.level && E.level.value ? E.level.value : ""),
          status: String(E.status && E.status.value ? E.status.value : ""),
          acg: (E.acg && E.acg.checked) ? "1" : "0",
          ACG: (E.acg && E.acg.checked) ? "1" : "0",
          isAcg: !!(E.acg && E.acg.checked),
          acgActive: !!(E.acg && E.acg.checked),
          inAcg: !!(E.acg && E.acg.checked),
          ministerName: String(E.minister && E.minister.value ? E.minister.value : ""),
          birthday: String(E.birthday && E.birthday.value ? E.birthday.value : ""),
          ordainDate: String(E.ordain && E.ordain.value ? E.ordain.value : ""),
          dateOfDeath: String(E.death && E.death.value ? E.death.value : ""),
          email: String(E.email && E.email.value ? E.email.value : ""),
          phone: String(E.phone && E.phone.value ? E.phone.value : ""),
          address: String(E.address && E.address.value ? E.address.value : ""),
          city: String(E.city && E.city.value ? E.city.value : ""),
          country: String(E.country && E.country.value ? E.country.value : ""),
          photoUrl: String(E.photoUrl && E.photoUrl.value ? E.photoUrl.value : ""),
          notes: String(E.notes && E.notes.value ? E.notes.value : ""),
          specialNote: String(E.special && E.special.value ? E.special.value : "")
        };
        discSetAcgFields_(disciple, !!(E.acg && E.acg.checked));



// SAFETY: prevent accidental overwrite when creating a new disciple.
// When discipleId is blank, backend may upsert by Callsign; so require a real unique Callsign,
// and generate a client-side id for brand-new records.
const __isNewDisc = !String(disciple.discipleId||"").trim();
const __cs = String(disciple.callsign||"").trim().toUpperCase();
if(!__cs) throw new Error("Callsign is required (example: TY4LEI).");
if(/^TY[1-9]$/.test(__cs) || __cs.length < 5){
  throw new Error("Callsign is too short. Use a full unique Callsign (example: TY4LEI).");
}
let __dup = null;
try{
  const __all = discAll_(S.adminDisciples || {});
  __dup = __all.find(x=>{
    const cs2 = String((x&&x.callsign)||"").trim().toUpperCase();
    if(!cs2) return false;
    if(cs2 !== __cs) return false;
    if(__isNewDisc) return true;
    return String((x&&x.discipleId)||"") !== String(disciple.discipleId||"");
  });
}catch(_e){}
if(__dup){
  throw new Error("Callsign already exists: " + __cs + ". Click that row to edit, or choose a different Callsign.");
}
if(__isNewDisc){
  // Force "new row" semantics even if backend prioritizes discipleId.
  disciple.discipleId = "d_" + Date.now() + "_" + Math.random().toString(16).slice(2,6);
  if(E.id) E.id.value = disciple.discipleId;
}
        // Normalize + sync (TY1..TY9 callsign digit always matches Level)
        disciple.level = discNormLevel_(disciple.level);
        discSyncPairBeforeSave_(disciple);
        if(E.level) E.level.value = disciple.level;
        if(E.callsign) E.callsign.value = disciple.callsign;

        discRememberAcgOverride_(disciple, !!(E.acg && E.acg.checked));
        const res = await rpc("adminDiscipleUpsert", { bucket, disciple });
        if(res && res.__queued){
          discSetMsg_(true, "Queued (offline). Tap Sync when online.");
          try{
            const data0 = S.adminDisciples || { in:[], out:[] };
            data0.in = Array.isArray(data0.in) ? data0.in : [];
            data0.out = Array.isArray(data0.out) ? data0.out : [];
            const key = (String(bucket||"IN").toUpperCase() === "OUT") ? "out" : "in";
            const list = Array.isArray(data0[key]) ? data0[key] : [];
            const d = Object.assign({}, disciple);
            d.bucket = String(bucket||d.bucket||"IN").toUpperCase();
            d.callsign = String(d.callsign||"").toUpperCase();
            const idStr = String(d.discipleId||"").trim();
            const csStr = String(d.callsign||"").trim();
            let ix = -1;
            if(idStr) ix = list.findIndex(x=>String((x&&x.discipleId)||"")===idStr);
            if(ix < 0 && csStr) ix = list.findIndex(x=>String((x&&x.callsign)||"").trim().toUpperCase()===csStr);
            if(ix >= 0){
              list[ix] = Object.assign({}, list[ix], d);
            }else{
              if(!d.discipleId) d.discipleId = "tmp_" + Date.now();
              list.push(d);
            }
            data0[key] = list;
            data0.__hasLoaded = true;
            discApplyAcgOverrides_(data0, "local");
            discApplyOrder_(data0);
            S.adminDisciples = data0;
            discSelect_(d);
          }catch(_e){}
          return;
        }
        const data = (res && res.data) ? res.data : res;
        discSetMsg_(true, "Saved.");
        // reload to reflect ids/meta
        await loadAdminDisciples(true);
        // reselect
        const all = discAll_(S.adminDisciples || {});
        const found = all.find(x=>String(x.discipleId||"")===String((data && data.discipleId) ? data.discipleId : disciple.discipleId));
        if(found) discSelect_(found);
        if(__startWasNewDisc){ discNew_(); discSetMsg_(true, "Saved. Ready for next NEW ORDAIN."); }
      }catch(err){
        discSetMsg_(false, (err && err.message) ? err.message : String(err));
      }finally{ unlock(); }
    });

    onOnce("slbAdmDiscMoveBtn","click", async ()=>{
      const E = discEls_();
      if(!slbIsAdmin_()) return;
      const d0 = S.adminDiscSelected;
      if(!d0 || !d0.discipleId) return;
      discClearMsg_();
      const unlock = lockBtn(E.moveBtn, "Moving…");
      try{
        const from = String(d0.bucket||"IN").toUpperCase();
        const to = (from==="OUT") ? "IN" : "OUT";
        const out = await rpc("adminDiscipleMove", { discipleId: String(d0.discipleId), callsign: String(d0.callsign||""), toBucket: to }, { timeoutMs: 90000, progressMode: "silent", noGlobalRetry: true, __slbNoGlobalRetry: true });
        if(out && out.__queued){
          discSetMsg_(true, "Queued (offline). Moved to " + to + " locally. Tap Sync when online.");
          discMoveLocal_(d0, to);
          discCloseDetail_();
          return;
        }
        if(out && (out.ok || out.success)){
          discMoveLocal_(d0, to);
          discSetMsg_(true, "Move request received. Verifying " + to + " sheet…");
          await discVerifyMove_(d0, to, { waits:[0, 3000, 7000] });
          return;
        }
        discStartMoveVerify_(d0, to, "Move response was unclear, so I moved it locally and I am verifying with the sheet…");
      }catch(err){
        const msg = (err && err.message) ? String(err.message) : String(err);
        const from = String(d0.bucket||"IN").toUpperCase();
        const to = (from==="OUT") ? "IN" : "OUT";
        if(/timeout/i.test(msg)){
          discStartMoveVerify_(d0, to, "Move/withdraw was sent, but the browser timed out before Apps Script replied. I moved it locally and I am verifying with the sheet…");
        }else{
          discSetMsg_(false, msg);
        }
      }finally{ unlock(); }
    });

    onOnce("slbAdmDiscDeleteBtn","click", async ()=>{
      const E = discEls_();
      if(!slbIsAdmin_()) return;
      const d0 = S.adminDiscSelected;
      if(!d0 || !d0.discipleId) return;
      if(!window.confirm("Delete this disciple permanently? This cannot be undone.")) return;
      discClearMsg_();
      const unlock = lockBtn(E.deleteBtn);
      try{
        const out = await rpc("adminDiscipleDelete", { discipleId: String(d0.discipleId), callsign: String(d0.callsign||"" ) });
        if(out && out.__queued){
          discSetMsg_(true, "Queued (offline). Deleted locally. Tap Sync when online.");
          try{
            const data0 = S.adminDisciples || { in:[], out:[] };
            data0.in = Array.isArray(data0.in) ? data0.in : [];
            data0.out = Array.isArray(data0.out) ? data0.out : [];
            const idStr = String(d0.discipleId||"");
            data0.in = data0.in.filter(x=>String((x&&x.discipleId)||"")!==idStr);
            data0.out = data0.out.filter(x=>String((x&&x.discipleId)||"")!==idStr);
            discApplyOrder_(data0);
            S.adminDisciples = data0;
          }catch(_e){}
          discCloseDetail_();
          return;
        }
        discSetMsg_(true, "Deleted. Reloading…");
        await loadAdminDisciples(true);
        discCloseDetail_();
      }catch(err){
        discSetMsg_(false, (err && err.message) ? err.message : String(err));
      }finally{ unlock(); }
    });

async function loadAdminCultOverviewAll(){
  if(!S.isAdminOrMod) return;
  clearMsg(el("slbAdmCultOverviewMsg")); clearMsg(el("slbAdmCultOverviewOk"));
  try{
  // SWR cache: show cached overview instantly
  try{
    const cached = slbCacheGet_("adminCultOverviewAll", 7*24*60*60*1000) || slbCacheGet_("adminCultOverviewAll");
    if(cached){ S.adminCultOverviewAll = cached; renderAdminCultOverviewAll(); }
  }catch(_e){}
    const out = await rpc("adminCultOverviewAll", {});
    S.adminCultOverviewAll = out || null;
    try{ slbCacheSet_("adminCultOverviewAll", S.adminCultOverviewAll); }catch(_e){}
    setMsg(el("slbAdmCultOverviewOk"), "Loaded.", true);
  }catch(e){
    S.adminCultOverviewAll = null;
    setMsg(el("slbAdmCultOverviewMsg"), e.message || String(e), false);
  }
  renderAdminCultOverviewAll();
}

function renderAdminCultOverviewAll(){
  const body = el("slbAdmCultOverviewBody");
  if(!body) return;

  const map = (S.adminCultOverviewAll && S.adminCultOverviewAll.byCallsign) ? S.adminCultOverviewAll.byCallsign : {};
  const q = String((el("slbAdmCultOverviewSearch") && el("slbAdmCultOverviewSearch").value) || "").trim().toLowerCase();

  function prettyLabel(raw){
    const s = String(raw||"");
    if(s.indexOf("CUSTOM:") === 0){
      const rest = s.slice(7);
      const li = rest.lastIndexOf("_");
      const base = (li > 0) ? rest.slice(0, li) : rest;
      const nice = String(base||"").replace(/_/g," ").trim();
      return nice || rest || s;
    }
    return s;
  }

  const callsigns = Object.keys(map || {}).sort((a,b)=>String(a).localeCompare(String(b)));
  const filtered = q ? callsigns.filter(cs=>String(cs||"").toLowerCase().includes(q)) : callsigns;

  let listHtml = "";
  let vis = 0;

  filtered.forEach((cs)=>{
    const items = Array.isArray(map[cs]) ? map[cs] : [];
    if(!items.length) return;

    const z = (vis % 2) ? "1" : "0";
    vis++;

    // summary line
    const parts = items.slice(0, 5).map(it=>{
      const done = Math.max(0, parseInt(it.doneDays||0,10)||0);
      const total = Math.max(1, parseInt(it.targetTotal||it.targetBase||108,10)||108);
      return escapeHtml(prettyLabel(it.typeLabel||it.typeKey||"")) + " " + done + "/" + total;
    });
    const more = (items.length > 5) ? (" +" + (items.length-5)) : "";

    listHtml += '<details class="slbCultOvItem" data-z="' + z + '">';
    listHtml += '<summary class="slbCultOvSum">';
    listHtml += '<div class="slbCultOvLeft"><b>' + escapeHtml(cs) + '</b><span class="slbCultOvMini"> — ' + parts.join(" • ") + more + '</span></div>';
    listHtml += '<div class="slbCultOvHint">click</div>';
    listHtml += '</summary>';
    listHtml += '<div class="slbCultOvInner">';

    items.forEach(it=>{
      const label = prettyLabel(it.typeLabel||it.typeKey||"");
      const done = Math.max(0, parseInt(it.doneDays||0,10)||0);
      const total = Math.max(1, parseInt(it.targetTotal||it.targetBase||108,10)||108);
      const pct = Math.min(100, Math.max(0, Math.round((done/total)*100)));
      const status = String(it.status||"");
      listHtml += '<div class="slbCultOvRow">';
      listHtml += '<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-end;">';
      listHtml += '<div><b>' + escapeHtml(label) + '</b> <span style="color:var(--ty-muted,#6b7680);">(' + escapeHtml(status) + ')</span></div>';
      listHtml += '<div style="white-space:nowrap;">' + done + '/' + total + '</div>';
      listHtml += '</div>';
      listHtml += '<div style="height:10px;background:var(--ty-border,#e2e6ea);border-radius:999px;overflow:hidden;margin-top:6px;">';
      listHtml += '<div style="height:10px;width:' + pct + '%;background:var(--ty-orange,#ef5e14);"></div>';
      listHtml += '</div>';
      listHtml += '</div>';
    });

    listHtml += '</div>';
    listHtml += '</details>';
  });

  if(!vis){
    body.innerHTML = '<div class="note">No cultivation data.</div>';
    body.classList.remove("slbCultOvScroll");
    return;
  }

  const tools =
    '<div class="slbCultOvToolsRow">' +
      '<div class="slbCultOvToolsLeft">' +
        '<button type="button" class="slbBtn slbBtnSm slbCultOvBtn" data-act="expand">Expand all</button>' +
        '<button type="button" class="slbBtn slbBtnSm slbCultOvBtn" data-act="collapse">Collapse all</button>' +
      '</div>' +
      '<div class="slbCultOvToolsRight">' + vis + '</div>' +
    '</div>';

  body.innerHTML = tools + listHtml;
  body.classList.add("slbCultOvScroll");
}

    function fmtMoney(value){
      var n=Number(value||0);
      if(!isFinite(n))n=0;
      try{return new Intl.NumberFormat('en-CA',{minimumFractionDigits:0,maximumFractionDigits:2}).format(n);}
      catch(_e){return String(Math.round(n*100)/100);}
    }

    function renderAdminGameCurrency(dash){
      if(!S.adminTarget && slbIsAdmin_()){
        var selfCallsign=cleanCallsign(S.callsign||S.userCallsign||"");
        if(selfCallsign){S.adminTarget=selfCallsign;setText("tywAdmTargetBadge","Target: "+selfCallsign);}
      }

      dash=(dash&&dash.data&&typeof dash.data==='object')?dash.data:(dash||{});
      var directState=!!(dash&&Array.isArray(dash.pouches)&&String(dash.mode||'').indexOf('admin-currency')===0);
      var data=directState?dash:(dash&&dash.gameCurrency||{});
      var pouches=Array.isArray(data.pouches)?data.pouches.slice():[];
      var sel=el("tywAdmGamePouch");
      var accounts=Array.isArray(dash.accounts)?dash.accounts:[];
      var actualWallet=null;
      try{
        // Prefer the actual account name. Some old Cosmic Pouches were incorrectly
        // saved with kind WALLET, so kind alone must not hide a disciple's pouch.
        actualWallet=accounts.find(function(a){
          var key=String(a&&a.name||'').toLowerCase().replace(/[_\-\s]+/g,'').trim();
          return key==='wallet'||key==='onhand'||key==='onhandwallet';
        })||null;
        if(!actualWallet){
          var walletKinds=accounts.filter(function(a){return String(a&&a.kind||'').toUpperCase().trim()==='WALLET';});
          if(walletKinds.length===1)actualWallet=walletKinds[0];
        }
      }catch(_eWallet){}
      var actualWalletId=String(actualWallet&&(actualWallet.accountId||actualWallet.walletId)||'');

      function isAdminPouch_(a){
        if(!a)return false;
        var status=String(a.status||'ACTIVE').toUpperCase().trim()||'ACTIVE';
        var kind=String(a.kind||'').toUpperCase().trim();
        var id=String(a.accountId||a.walletId||'');
        var name=String(a.name||'').toLowerCase().replace(/[_\-\s]+/g,'').trim();
        if(status!=='ACTIVE')return false;
        if(kind==='ESCROW')return false;
        if(actualWalletId&&id===actualWalletId)return false;
        if(name==='wallet'||name==='onhand'||name==='onhandwallet')return false;
        // Legacy Cosmic Pouches can be stored with kind WALLET or with a w_* id.
        // Only the actual On Hand account is excluded.
        return true;
      }

      if(!pouches.length&&accounts.length){
        pouches=accounts.filter(isAdminPouch_).map(function(a){
          var accountId=String(a.accountId||a.walletId||'');
          var linked=null;
          try{
            if(data.wallet&&String(data.wallet.pouchAccountId||'')===accountId)linked=data.wallet;
          }catch(_e){}
          return {
            accountId:accountId,
            name:String(a.name||'Cosmic Pouch'),
            balance:Number(a.balance||0),
            status:String(a.status||'ACTIVE'),
            kind:'POUCH',
            wallet:linked||{coinBalance:0,chipBalance:0,spBalance:0}
          };
        });
      }

      var seen={};
      pouches=pouches.filter(function(p){
        var id=String(p&&p.accountId||'');
        if(!id||seen[id])return false;
        seen[id]=1;
        return true;
      });

      if(sel){
        var current=String(sel.value||"");
        sel.innerHTML=pouches.length?pouches.map(function(p){return '<option value="'+escapeAttr(p.accountId||'')+'">'+escapeHtml(p.name||p.accountId||'Cosmic Pouch')+' · '+escapeHtml(fmtMoney(Number(p.balance||0)))+' Stones</option>';}).join(''):'<option value="">No active Cosmic Pouch found</option>';
        if(current&&pouches.some(function(p){return String(p.accountId||'')===current;}))sel.value=current;
        else if(data.selectedPouchId&&pouches.some(function(p){return String(p.accountId||'')===String(data.selectedPouchId||'');}))sel.value=String(data.selectedPouchId||'');
        else if(pouches[0])sel.value=String(pouches[0].accountId||'');
        sel.disabled=!pouches.length;
      }

      var id=sel?String(sel.value||''):String(data.selectedPouchId||'');
      var pouch=pouches.find(function(x){return String(x.accountId||'')===id;})||pouches[0]||null;
      var w=pouch&&pouch.wallet||{};
      var coins=Math.floor(Math.max(0,Number(w.coinBalance!==undefined?w.coinBalance:w.chipBalance||0)||0));
      var sp=Math.floor(Math.max(0,Number(w.spBalance!==undefined?w.spBalance:w.spiritPower||0)||0));
      setText("tywAdmGameCoins",pouch?String(coins):"—");
      setText("tywAdmGameSp",pouch?String(sp):"—");
      setText("tywAdmGameVials",pouch?String(Math.floor(sp/10)):"—");
      setText("tywAdmAdjustTargetLabel",S.adminTarget?("Disciple: "+S.adminTarget):"No disciple loaded");

      var state=el("tywAdmGameLoadState");
      if(state){
        state.textContent=pouches.length?(pouches.length+" Cosmic Pouch"+(pouches.length===1?"":"es")+" loaded."):"No Cosmic Pouches were returned for this disciple.";
      }
      var btn=el("tywAdmGameBtn");
      if(btn)btn.disabled=!pouches.length;
    }

    async function loadAdminGameCurrencyState_(forcedCallsign){
      if(!slbIsAdmin_())return null;
      var target=cleanCallsign(forcedCallsign||S.adminTarget||(el("tywAdmUserSelect")?el("tywAdmUserSelect").value:"")||"");
      if(!target){
        setText("tywAdmGameLoadState","Load a disciple first.");
        return null;
      }
      S.adminTarget=target;
      setText("tywAdmAdjustTargetLabel","Disciple: "+target);
      var sel=el("tywAdmGamePouch");
      var current=String(sel&&sel.value||"");
      if(sel&&!current){sel.innerHTML='<option value="">Loading Cosmic Pouches…</option>';sel.disabled=true;}
      setText("tywAdmGameLoadState","Loading Cosmic Pouches for "+target+"…");
      try{
        // Use the long-established dashboard route. Some deployed backends do not yet
        // know the newer adminGetGameCurrencyState action and reject it before routing.
        var raw=await rpc("adminGetUserDashboard",{callsign:target});
        if(cleanCallsign(S.adminTarget||"")!==target)return null;
        var unwrapped=(raw&&raw.data&&typeof raw.data==='object')?raw.data:raw;
        var dash=(unwrapped&&unwrapped.dash)?unwrapped.dash:(unwrapped||{});
        var state=(dash&&dash.gameCurrency&&typeof dash.gameCurrency==='object')?dash.gameCurrency:dash;
        S.adminDash=dash||S.adminDash||null;
        S.adminGameCurrency=state||null;
        renderAdminGameCurrency(dash||state||{});
        return state||null;
      }catch(err){
        // Keep any pouches already returned by the main dashboard, but make the failure visible.
        try{renderAdminGameCurrency(S.adminDash||{});}catch(_eRender){}
        setText("tywAdmGameLoadState","Pouch reload failed: "+((err&&err.message)||String(err)));
        throw err;
      }
    }
    try{window.SLB_loadAdminGameCurrency=loadAdminGameCurrencyState_;}catch(_eExposeCurrency){}

    async function loadAdminTarget(forcedCallsign){
      if(!slbIsAdmin_()) return;
      const callsign = cleanCallsign(forcedCallsign || (el("tywAdmUserSelect") ? el("tywAdmUserSelect").value : "") || "");
      if(!callsign) return;

      S.adminTarget = callsign;
      setText("tywAdmTargetBadge", "Target: " + callsign);
      const seq = ++S.reqSeq;
      S.adminTargetReq = seq;

      clearMsg(el("tywAdmMsg")); clearMsg(el("tywAdmOk"));

      try{
        setBusy(true);

        // Ensure user list is loaded (needed for moderator flag + select consistency)
        try{
          if(!Array.isArray(S.adminUsers) || !S.adminUsers.length){
            await loadAdminUsers();
          }
          const selFix = el("tywAdmUserSelect");
          if(selFix) selFix.value = callsign;
        }catch(_e){}

        // Fetch dashboard (support both shapes: {dash:{...}} and direct)
        const raw = await rpcTryCached("adminGetUserDashboard", ["adminGetUserDashboard"], { callsign });
        if(S.adminTargetReq !== seq) return;
        const unwrapped = (raw && raw.data && typeof raw.data === "object") ? raw.data : raw;
        const dash = (unwrapped && unwrapped.dash) ? unwrapped.dash : unwrapped;

        S.adminDash = dash || null;
        // Cosmic Pouch permission badge + checkbox
        const perm = !!(dash && dash.profile && dash.profile.canCreatePouches);
        const cbPerm = el("tywAdmAllowPouches");
        if(cbPerm) cbPerm.checked = perm;
        const badgePerm = el("tywAdmPouchPermBadge");
        if(badgePerm) badgePerm.textContent = perm ? "Allowed" : "Locked";
    try{
      var modCb = el("tywAdmIsModerator") || document.querySelector("#tywAdmIsModerator");
      var badgeMod = el("tywAdmModeratorBadge") || document.querySelector("#tywAdmModeratorBadge");

      // Moderator flag: prefer Admin user list (fresh sheet read) over dashboard (may be cached)
      var isAdminFlag = !!(dash && dash.profile && dash.profile.isAdmin);
      var listFlag = null;
      try{
        if(Array.isArray(S.adminUsers) && callsign){
          var u = S.adminUsers.find(x => String(x.callsign||"").toUpperCase() === callsign);
          if(u){
            if(typeof u.isAdmin !== "undefined") isAdminFlag = !!u.isAdmin;
            if(typeof u.isModerator !== "undefined") listFlag = !!u.isModerator;
          }
        }
      }catch(_e){}

      var dashFlag = null;
      if(dash && dash.profile && typeof dash.profile.isModerator !== "undefined") dashFlag = !!dash.profile.isModerator;

      var effMod = (!isAdminFlag) && ((listFlag !== null) ? listFlag : (dashFlag !== null ? dashFlag : false));

      if(modCb) modCb.checked = !!effMod;
      if(badgeMod) badgeMod.textContent = effMod ? "ON" : "OFF";
    }catch(e){}


        const accounts = (dash && Array.isArray(dash.accounts)) ? dash.accounts : [];

        // Adjust balance (Admin can ONLY adjust On Hand)
        const adjEl = el("tywAdmAdjAcct");
        const wallet = accounts.find(a => isOnHand(a) && String(a.status||"") === "ACTIVE");
        if(adjEl){
          // hidden input: store actual walletId if present, else 'wallet' alias
          adjEl.value = wallet ? (wallet.accountId || "wallet") : "wallet";
        }
        renderAdminGameCurrency(dash);
        try{await loadAdminGameCurrencyState_(callsign);}catch(_eGameCurrency){}

        // Payroll target defaults
        if(el("tywAdmPayCall")) el("tywAdmPayCall").value = callsign;

        // Payroll always pays to On Hand (wallet)
        const paySel = el("tywAdmPayAcct");
        if(paySel) paySel.value = (wallet ? (wallet.accountId || "wallet") : "wallet");

// Prefill user edit form
        if(el("tywAdmEditName")) el("tywAdmEditName").value = String((dash && dash.user && dash.user.displayName) || "");
        if(el("tywAdmEditCall")) el("tywAdmEditCall").value = callsign;

        // Pouch permission
        const allowBox = el("tywAdmAllowPouches");
        const permBadge = el("tywAdmPouchPermBadge");
        const canP = !!(dash && dash.profile && dash.profile.canCreatePouches);
        if(allowBox) allowBox.checked = canP;
        if(permBadge) permBadge.textContent = canP ? "Allowed" : "Locked";

        // Render accounts + txns
        if(typeof renderAdminAccounts === "function") renderAdminAccounts(dash);
        if(typeof renderAdminTxns === "function") renderAdminTxns(dash);
        if(typeof renderAdminDeletePouch === "function") renderAdminDeletePouch(dash);

        // Ensure awards master list is loaded (so the one-time table can render)
        if(typeof loadAdminAwards === "function" && !S._awardsLoaded) await loadAdminAwards();
        if(S.adminTargetReq !== seq) return;

        // Awards status for this user
        if(typeof loadAdminAwardStatus === "function") loadAdminAwardStatus().catch(()=>{});

        setMsg(el("tywAdmOk"), "Loaded.", true);
      }catch(e){
        setMsg(el("tywAdmMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    }


    var adminAdjustRefreshTimer_=0;
    function refreshAdminAdjust_(){
      if(!slbIsAdmin_())return;
      try{renderAdminGameCurrency(S.adminGameCurrency||S.adminDash||{});}catch(_eRender){}
      var target=cleanCallsign(S.adminTarget||(el("tywAdmUserSelect")?el("tywAdmUserSelect").value:"")||S.callsign||"");
      if(!target){setText("tywAdmGameLoadState","Load a disciple first.");return;}
      try{clearTimeout(adminAdjustRefreshTimer_);}catch(_eClear){}
      adminAdjustRefreshTimer_=setTimeout(function(){
        loadAdminGameCurrencyState_(target).catch(function(err){
          try{setMsg(el("tywAdmGameMsg"),(err&&err.message)||String(err),false);}catch(_eMsg){}
        });
      },80);
    }
    try{window.SLB_refreshAdminAdjust=refreshAdminAdjust_;}catch(_eExpose){}

    // ====== Admin — Awards / Payroll / User Management ======
    async function loadAdminAwards(){
      if(!slbIsAdmin_()) return;
      try{
        const out = await rpc("adminAwardList", {});
        S.adminAwards = (out && out.awards) ? out.awards : [];
      }catch(e){
        S.adminAwards = [];
      }
      renderAdminAwardList();
      S._awardsLoaded = true;
      if(S.adminTarget) loadAdminAwardStatus().catch(()=>{});
    }

    async function loadAdminAwardStatus(){
      if(!S.isAdmin || !S.adminTarget) return;
      try{
        const out = await rpc("adminAwardStatusForUser", { callsign: S.adminTarget });
        S.adminAwardStatus = out || null;
      }catch(e){
        S.adminAwardStatus = null;
      }
      renderAdminAwardGive();
    }

    function renderAdminAwardList(){
      const body = el("tywAdmAwardListBody");
      if(!body) return;
      const awards = Array.isArray(S.adminAwards) ? S.adminAwards : [];
      body.innerHTML = awards.map(a => {
        const on = !!a.enabled;
        const amt = money(a.amount);
        return `
          <tr>
            <td>${esc(a.name||"")}</td>
            <td>${amt}</td>
            <td>${on ? "YES" : "NO"}</td>
            <td>
              <button class="btn mini ${on ? "soft" : "orange"}" data-aw-toggle="${esc(a.awardId||"")}" data-aw-on="${on ? "1":"0"}">${on ? "Disable" : "Enable"}</button>
              <button class="btn danger mini" data-aw-del="${esc(a.awardId||"")}">Delete</button>
            </td>
          </tr>
        `;
      }).join("");

      body.querySelectorAll("[data-aw-toggle]").forEach(btn => {
        btn.addEventListener("click", async () => {
          clearMsg(el("tywAdmAwardMsg")); clearMsg(el("tywAdmAwardOk"));
          try{
            setBusy(true);
            const awardId = btn.getAttribute("data-aw-toggle");
            const on = btn.getAttribute("data-aw-on") === "1";
            await rpc("adminAwardToggle", { awardId, enabled: !on });
            await loadAdminAwards();
            setMsg(el("tywAdmAwardOk"), "Updated.", true);
          }catch(e){
            setMsg(el("tywAdmAwardMsg"), e.message || String(e), false);
          }finally{ setBusy(false); }
        });
      });
      body.querySelectorAll("[data-aw-del]").forEach(btn => {
        btn.addEventListener("click", async () => {
          clearMsg(el("tywAdmAwardMsg")); clearMsg(el("tywAdmAwardOk"));
          const awardId = btn.getAttribute("data-aw-del");
          if(!awardId) return;
          if(!confirm("Delete this award? This does not undo already-given awards.")) return;
          try{
            setBusy(true);
            await rpc("adminAwardDelete", { awardId });
            await loadAdminAwards();
            setMsg(el("tywAdmAwardOk"), "Deleted.", true);
          }catch(e){
            setMsg(el("tywAdmAwardMsg"), e.message || String(e), false);
          }finally{ setBusy(false); }
        });
      });
    }

    function renderAdminAwardGive(){
      const body = el("tywAdmAwardGiveBody");
      if(!body) return;
      const status = S.adminAwardStatus;
      const awards = (status && Array.isArray(status.awards)) ? status.awards : (Array.isArray(S.adminAwards) ? S.adminAwards.map(a => ({
        awardId:a.awardId, enabled:a.enabled, name:a.name, amount:a.amount, hasAward:false
      })) : []);
      body.innerHTML = awards.map(a => {
        const has = !!a.hasAward;
        const enabled = (a.enabled !== false && a.enabled !== "0");
        const dis = (!enabled);
        return `
          <tr style="${has ? "opacity:.55;" : ""}">
            <td>${esc(a.name||"")}</td>
            <td>${money(a.amount)}</td>
            <td>${has ? "HAS" : "—"}</td>
            <td>
              ${dis ? `<span class="badge">Disabled</span>` : (has
                ? `<button class="btn soft mini" data-aw-revoke="${esc(a.awardId||"")}">Take Back</button>`
                : `<button class="btn orange mini" data-aw-give="${esc(a.awardId||"")}">Give</button>`)}
            </td>
          </tr>
        `;
      }).join("");

      body.querySelectorAll("[data-aw-give]").forEach(btn => {
        btn.addEventListener("click", async () => {
          clearMsg(el("tywAdmGiveMsg")); clearMsg(el("tywAdmGiveOk"));
          if(!S.adminTarget) return setMsg(el("tywAdmGiveMsg"), "Load a target user first.", false);
          try{
            setBusy(true);
            const awardId = btn.getAttribute("data-aw-give");
            // 1) Do the action
            await rpc("adminAwardGive", { callsign: S.adminTarget, awardId, note: "Admin award" });

            // 2) Optimistic UI update (instant feedback)
            try{
              if(S.adminAwardStatus && Array.isArray(S.adminAwardStatus.awards)){
                const a = S.adminAwardStatus.awards.find(x => String(x.awardId) === String(awardId));
                if(a) a.hasAward = true;
              }
              renderAdminAwardGive();
            }catch(_e){}

            setMsg(el("tywAdmGiveOk"), "Award given.", true);

            // 3) Background refresh (don’t block UI)
            Promise.allSettled([
              loadAdminTarget(),        // refresh balances
              loadAdminAwardStatus()    // re-sync award state
            ]).catch(()=>{});
          }catch(e){
            setMsg(el("tywAdmGiveMsg"), e.message || String(e), false);
          }finally{ setBusy(false); }
        });
      });
      body.querySelectorAll("[data-aw-revoke]").forEach(btn => {
        btn.addEventListener("click", async () => {
          clearMsg(el("tywAdmGiveMsg")); clearMsg(el("tywAdmGiveOk"));
          if(!S.adminTarget) return setMsg(el("tywAdmGiveMsg"), "Load a target user first.", false);
          try{
            setBusy(true);
            const awardId = btn.getAttribute("data-aw-revoke");
            await rpc("adminAwardRevoke", { callsign: S.adminTarget, awardId });

            // Optimistic UI update
            try{
              if(S.adminAwardStatus && Array.isArray(S.adminAwardStatus.awards)){
                const a = S.adminAwardStatus.awards.find(x => String(x.awardId) === String(awardId));
                if(a) a.hasAward = false;
              }
              renderAdminAwardGive();
            }catch(_e){}

            setMsg(el("tywAdmGiveOk"), "Taken back.", true);

            // Background refresh
            Promise.allSettled([
              loadAdminTarget(),
              loadAdminAwardStatus()
            ]).catch(()=>{});
          }catch(e){
            setMsg(el("tywAdmGiveMsg"), e.message || String(e), false);
          }finally{ setBusy(false); }
        });
      });
    }

    async function loadAdminPayroll(){
      if(!slbIsAdmin_()) return;
      try{
        const out = await rpc("adminPayrollList", {});
        S.adminPayroll = (out && out.rules) ? out.rules : [];
      }catch(e){
        S.adminPayroll = [];
      }
      renderAdminPayrollList();
    }

    // Debug helpers (safe no-op if unused)
    window.TYW = window.TYW || {};
    window.TYW.loadAdminAwards = loadAdminAwards;
    window.TYW.loadAdminPayroll = loadAdminPayroll;

    function renderAdminPayrollList(){
      const body = el("tywAdmPayListBody");
      if(!body) return;
      const rules = Array.isArray(S.adminPayroll) ? S.adminPayroll : [];

      body.innerHTML = rules.map(r => {
        const on = !!r.enabled;

        // Frequency display (keep simple + consistent)
        // Examples:
        //   DAILY @09:00 America/Toronto
        //   WEEKLY Mon @09:00 America/Toronto
        //   MONTHLY 15 @09:00 America/Toronto
        const freq = (r.freq || "").toUpperCase();
        const dow = r.dow ? String(r.dow) : "";
        const dom = (r.dom !== undefined && r.dom !== null && r.dom !== "") ? String(r.dom) : "";
        const hh  = (r.hour  !== undefined && r.hour  !== null) ? String(r.hour).padStart(2,"0") : "--";
        const mm  = (r.minute!== undefined && r.minute!== null) ? String(r.minute).padStart(2,"0") : "--";
        const tz  = r.tz ? String(r.tz) : "";

        let freqDisp = freq || "";
        if(freq === "WEEKLY" && dow) freqDisp += ` ${esc(dow)}`;
        if(freq === "MONTHLY" && dom) freqDisp += ` ${esc(dom)}`;
        if(freqDisp) freqDisp += ` @${esc(hh)}:${esc(mm)}${tz ? (" " + esc(tz)) : ""}`;

        const note = r.note || "";

        return `
          <tr>
            <td><b>${on ? "ON" : "OFF"}</b></td>
            <td>${esc(r.callsign||"")}</td>
            <td><b>${money(r.amount)}</b></td>
            <td>${freqDisp}</td>
            <td>${esc(r.nextRunISO||"")}</td>
            <td>${esc(note)}</td>
            <td style="white-space:nowrap;">
              <button class="btn mini ${on ? "soft" : "orange"}" data-pay-toggle="${esc(r.ruleId||"")}" data-pay-on="${on?"1":"0"}">${on?"Disable":"Enable"}</button>
              <button class="btn soft mini" data-pay-run="${esc(r.ruleId||"")}">Run Now</button>
              <button class="btn soft mini" data-pay-del="${esc(r.ruleId||"")}">Delete</button>
            </td>
          </tr>
        `;
      }).join("");

      body.querySelectorAll("[data-pay-toggle]").forEach(btn => {
        btn.addEventListener("click", async () => {
          clearMsg(el("tywAdmPayMsg")); clearMsg(el("tywAdmPayOk"));
          try{
            setBusy(true);
            const ruleId = btn.getAttribute("data-pay-toggle");
            const on = btn.getAttribute("data-pay-on") === "1";
            await rpc("adminPayrollToggle", { ruleId, enabled: !on });
            await loadAdminPayroll();
            setMsg(el("tywAdmPayOk"), "Updated.", true);
          }catch(e){
            setMsg(el("tywAdmPayMsg"), e.message || String(e), false);
          }finally{ setBusy(false); }
        });
      });

      body.querySelectorAll("[data-pay-run]").forEach(btn => {
        btn.addEventListener("click", async () => {
          clearMsg(el("tywAdmPayMsg")); clearMsg(el("tywAdmPayOk"));
          try{
            setBusy(true);
            const ruleId = btn.getAttribute("data-pay-run");
            await rpc("adminPayrollRunRule", { ruleId });
            await loadAdminPayroll();
            setMsg(el("tywAdmPayOk"), "Ran.", true);
          }catch(e){
            setMsg(el("tywAdmPayMsg"), e.message || String(e), false);
          }finally{ setBusy(false); }
        });
      });

      body.querySelectorAll("[data-pay-del]").forEach(btn => {
        btn.addEventListener("click", async () => {
          clearMsg(el("tywAdmPayMsg")); clearMsg(el("tywAdmPayOk"));
          try{
            if(!confirm("Delete this payroll rule?")) return;
            setBusy(true);
            const ruleId = btn.getAttribute("data-pay-del");
            await rpc("adminPayrollDelete", { ruleId });
            await loadAdminPayroll();
            setMsg(el("tywAdmPayOk"), "Deleted.", true);
          }catch(e){
            setMsg(el("tywAdmPayMsg"), e.message || String(e), false);
          }finally{ setBusy(false); }
        });
      });
    }


    function renderAdminAccounts(dash){
      const wrap = el("tywAdmTargetAccounts");
      if(!wrap) return;
      wrap.innerHTML = "";
      const accounts = (dash && dash.accounts) ? dash.accounts : [];
      accounts.forEach(a => {
        const row = document.createElement("div");
        row.style.cssText = "border:1px solid var(--border2);border-radius:14px;background:var(--ty-grey-ui);padding:10px;margin-bottom:8px;";
        row.innerHTML = `
          <div style="display:flex;justify-content:space-between;gap:10px;align-items:center;flex-wrap:wrap;">
            <div>
              <div style="font-weight:900;">${escapeHtml(displayAcctName(a.name))}</div>
              <div style="color:var(--muted);font-size:12px;">Balance: <b>${money(a.balance)}</b> stones</div>
            </div>
            <span class="badge">ID: ${escapeHtml(String(a.accountId || a.walletId || '').slice(0,8))}…</span>
          </div>
        `;
        wrap.appendChild(row);
      });
    }

    function renderAdminTxns(dash){
      const body = el("tywAdmTxnsBody");
      if(!body) return;
      body.innerHTML = "";
      const txns0 = (dash && dash.txns) ? dash.txns : [];
      const txns = sortTxns(txns0, S.aSort);

      const map = {};
      (dash && dash.accounts || []).forEach(a => map[a.accountId] = a.name);

      const dispAcct = (id) => {
        if(!id) return "";
        const sid = String(id);

        // allow callsign tokens if backend ever returns CS:TY....
        if(sid.startsWith("CS:") || sid.startsWith("cs:")) return sid.slice(3).toUpperCase();

        if(Object.prototype.hasOwnProperty.call(map, id)){
          let n = map[id] || "";
          if(String(n).toLowerCase() === "wallet") n = "On Hand";
          return n;
        }

        // Mask internal/system accounts so admin view doesn't show sys_* / escrow ids
        const up = sid.toUpperCase();
        if(up === "SYS" || sid.startsWith("sys_") || sid.startsWith("SYS_") || sid.startsWith("sys-") || sid.startsWith("SYS-")) return "SLB";

        return sid;
      };

      const dispType = (type) => {
        const t = String(type || "").trim();
        if(!t) return "";
        const u = t.toUpperCase();

        // Market hold (formerly escrow)
        if(u === "ESCROW_HOLD") return "SLB Hold";
        if(u === "ESCROW_RELEASE") return "SLB Release";
        if(u === "ESCROW_PAYOUT") return "SLB Payout";
        if(u.startsWith("ESCROW_")) return "SLB";

        // System/internal labels
        if(u.startsWith("SYS_")) return "SLB";

        return t;
      };
      // Map for fast click-to-edit without per-row listeners
            if(!S._adminTxnsById) S._adminTxnsById = Object.create(null);

      body.innerHTML = "";
      const CHUNK = 250;
      let i0 = 0;

      const renderChunk = () => {
        const frag = document.createDocumentFragment();
        const i1 = Math.min(i0 + CHUNK, txns.length);

        for(let i=i0; i<i1; i++) {
          const t = txns[i];
          const tr = document.createElement("tr");
          tr.innerHTML = `
            <td>${escapeHtml(t.time || "")}</td>
            <td>${escapeHtml(dispType(t.type) || "")}</td>
            <td>${escapeHtml(dispAcct(t.from) || "")}</td>
            <td>${escapeHtml(dispAcct(t.to) || "")}</td>
            <td><b>${money(t.amount)}</b></td>
            <td>${escapeHtml(t.note || "")}</td>
            <td style="display:flex;gap:8px;flex-wrap:wrap;">
              <button class="btn soft mini slbIconBtn slbEditTiny" data-txn="${escapeAttr(t.txnId || "")}" ${t.txnId ? "" : "disabled"} title="Edit" aria-label="Edit"><span class="slbIco">✎</span></button>
              <button class="btn soft mini slbCopyBtn slbIconBtn slbCopyTiny" data-copy="${escapeAttr(t.txnId || "")}" ${t.txnId ? "" : "disabled"} title="Copy ID" aria-label="Copy ID"><span class="slbIco">⧉</span></button>
            </td>
          `;

          if(t.txnId){
            S._adminTxnsById[t.txnId] = t;
          }
          frag.appendChild(tr);
        }

        body.appendChild(frag);
        i0 = i1;
        if(i0 < txns.length) requestAnimationFrame(renderChunk);
      };

      requestAnimationFrame(renderChunk);

      if(!body.__txnEditBound){
        body.__txnEditBound = true;
        body.addEventListener("click", async (e) => {
          const btn = e.target.closest("button[data-txn]");
          if(!btn || btn.disabled) return;
          try{
            setBusy(true);
            const txnId = String(btn.getAttribute("data-txn")||"");
            const t = (S._adminTxnsById && S._adminTxnsById[txnId]) ? S._adminTxnsById[txnId] : null;
            if(!t) throw new Error("Transaction not found. Please reload.");
            const nn = prompt("Edit note:", t.note || "");
            if(nn === null) return;
            await rpc("updateTxnNote", { txnId: txnId, note: String(nn||"") });
            await loadAdminTarget();
          }catch(e){
            alert(e.message || String(e));
          }finally{
            setBusy(false);
          }
        });
      }

      renderSortMarks("tywASort_", S.aSort);
    }

    // click-to-sort admin txns
    const aHead = el("tywAdmTxnsHead");
    if(aHead){
      aHead.addEventListener("click", (e) => {
        const th = e.target.closest("th");
        if(!th || th.classList.contains("noclick")) return;
        const key = th.getAttribute("data-asort");
        if(!key) return;
        if(S.aSort.key === key) S.aSort.dir = (S.aSort.dir === "asc" ? "desc" : "asc");
        else { S.aSort.key = key; S.aSort.dir = "asc"; }
        renderAdminTxns(S.adminDash || {});
      });
    }

    // admin buttons
onOnce("tywAdmAddUserBtn","click", async () => {
      clearMsg(el("tywAdmAddUserMsg")); clearMsg(el("tywAdmAddUserOk"));
      const c = cleanCallsign(el("tywAdmNewCall").value);
      const p = cleanPin(el("tywAdmNewPin").value);
      const n = String(el("tywAdmNewName").value || "").trim();
      if(!c) return setMsg(el("tywAdmAddUserMsg"), "Callsign required.", false);
      if(p.length !== 4) return setMsg(el("tywAdmAddUserMsg"), "PIN must be 4 digits.", false);
      if(!n) return setMsg(el("tywAdmAddUserMsg"), "Display name required.", false);
      try{
        setBusy(true);
        await rpc("adminAddUser", { callsign:c, pin:p, displayName:n });
        setMsg(el("tywAdmAddUserOk"), "User created.", true);
        el("tywAdmNewCall").value = "";
        el("tywAdmNewPin").value = "";
        el("tywAdmNewName").value = "";
        await loadAdminUsers();
      }catch(e){
        setMsg(el("tywAdmAddUserMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });


    //
    // ===== ADMIN: Archive TXNS (Phase 4) =====
    // Preview (dry run)
    onOnce("tywAdmArchivePreviewBtn","click", async () => {
      clearMsg(el("tywAdmArchiveMsg")); clearMsg(el("tywAdmArchiveOk"));
      try{
        setBusy(true);

        const daysEl = el("tywAdmArchiveDays");
        let days = parseInt((daysEl && daysEl.value || "90"), 10);
        if(!isFinite(days) || days < 1) days = 90;
        if(days > 3650) days = 3650; // safety cap (10 yrs)

        const keepEl = el("tywAdmArchiveKeepRows");
        let keepRows = parseInt((keepEl && keepEl.value || "100"), 10);
        if(!isFinite(keepRows) || keepRows < 0) keepRows = 100;
        if(keepRows > 10000) keepRows = 10000;

        const r = await rpc("adminArchiveTxns", { olderThanDays: days, keepLastPerPouch: keepRows, dryRun: 1 });

        const moved = (r && r.movedCount != null) ? r.movedCount : "?";
        const before = (r && r.beforeCount != null) ? r.beforeCount : "?";
        const after  = (r && r.afterCount != null) ? r.afterCount : "?";
        const cutoff = (r && r.cutoffISO) ? r.cutoffISO : "";
        const prot   = (r && r.protectedCount != null) ? r.protectedCount : null;
        const rid = (r && r.runId) ? r.runId : "";
        const s1  = (r && r.totalSupplyBefore != null) ? r.totalSupplyBefore : null;
        const s2  = (r && r.totalSupplyAfter != null) ? r.totalSupplyAfter : null;

        let extra = "";
        if(prot != null) extra += ` Protected: ${prot}.`;
        if(cutoff) extra += ` Cutoff: ${cutoff}.`;
        if(rid) extra += ` Run: ${rid}.`;
        if(s1 != null) extra += ` Supply: ${s1}${(s2!=null?(" → "+s2):"")}.`;

        setMsg(el("tywAdmArchiveOk"), `Preview: would archive ${moved} rows. TXNS: ${before} → ${after}.${extra}`, true);
      }catch(e){
        setMsg(el("tywAdmArchiveMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    });

    // Archive (real)
    onOnce("tywAdmArchiveBtn","click", async () => {
      clearMsg(el("tywAdmArchiveMsg")); clearMsg(el("tywAdmArchiveOk"));
      try{
        setBusy(true);

        const daysEl = el("tywAdmArchiveDays");
        let days = parseInt((daysEl && daysEl.value || "90"), 10);
        if(!isFinite(days) || days < 1) days = 90;
        if(days > 3650) days = 3650; // safety cap (10 yrs)

        const keepEl = el("tywAdmArchiveKeepRows");
        let keepRows = parseInt((keepEl && keepEl.value || "100"), 10);
        if(!isFinite(keepRows) || keepRows < 0) keepRows = 100;
        if(keepRows > 10000) keepRows = 10000;

        const r = await rpc("adminArchiveTxns", { olderThanDays: days, keepLastPerPouch: keepRows });

        const moved = (r && r.movedCount != null) ? r.movedCount : "?";
        const before = (r && r.beforeCount != null) ? r.beforeCount : "?";
        const after  = (r && r.afterCount != null) ? r.afterCount : "?";
        const cutoff = (r && r.cutoffISO) ? r.cutoffISO : "";
        const prot   = (r && r.protectedCount != null) ? r.protectedCount : null;
        const rid = (r && r.runId) ? r.runId : "";
        const s1  = (r && r.totalSupplyBefore != null) ? r.totalSupplyBefore : null;
        const s2  = (r && r.totalSupplyAfter != null) ? r.totalSupplyAfter : null;

        let extra = "";
        if(prot != null) extra += ` Protected: ${prot}.`;
        if(cutoff) extra += ` Cutoff: ${cutoff}.`;
        if(rid) extra += ` Run: ${rid}.`;
        if(s1 != null) extra += ` Supply: ${s1}${(s2!=null?(" → "+s2):"")}.`;

        setMsg(el("tywAdmArchiveOk"), `Archived ${moved} rows. TXNS: ${before} → ${after}.${extra}`, true);
      }catch(e){
        setMsg(el("tywAdmArchiveMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    });

    // ===== ADMIN: Reconcile / Integrity (Phase 4.4) =====
    onOnce("tywAdmReconRunBtn","click", async () => {
      clearMsg(el("tywAdmReconMsg")); clearMsg(el("tywAdmReconOk"));
      try{
        setBusy(true);
        const out = el("tywAdmReconOut"); if(out) out.textContent = "";
        const r = await rpc("adminReconcile", { limit: 500 });

        // summary
        const mism = (r && r.mismatchCount != null) ? r.mismatchCount : "?";
        const totA = (r && r.totalAccounts != null) ? r.totalAccounts : "?";
        const runId = (r && r.runId) ? r.runId : "";
        setMsg(el("tywAdmReconOk"), "Reconcile done. Mismatches: " + mism + " / " + totA + (runId?(" | Run: "+runId):""), true);

        if(out) out.textContent = JSON.stringify(r, null, 2);
      }catch(e){
        setMsg(el("tywAdmReconMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    });

    onOnce("tywAdmReconFixBtn","click", async () => {
      clearMsg(el("tywAdmReconMsg")); clearMsg(el("tywAdmReconOk"));
      try{
        setBusy(true);
        const out = el("tywAdmReconOut"); if(out) out.textContent = "";
        const r = await rpc("adminReconcileFix", { limit: 500 });

        const fixed = (r && r.fixedCount != null) ? r.fixedCount : "?";
        const mism = (r && r.mismatchCount != null) ? r.mismatchCount : "?";
        const runId = (r && r.runId) ? r.runId : "";
        setMsg(el("tywAdmReconOk"), "Fix done. Fixed: " + fixed + " | Mismatches before: " + mism + (runId?(" | Run: "+runId):""), true);

        if(out) out.textContent = JSON.stringify(r, null, 2);
      }catch(e){
        setMsg(el("tywAdmReconMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    });


    // Reconcile (preview)
    onOnce("tywAdmReconRunBtn","click", async () => {
      clearMsg(el("tywAdmReconMsg")); clearMsg(el("tywAdmReconOk"));
      try{
        setBusy(true);
        const res = await apiCall("adminReconcile", { limit: 800 });
        const out = res && res.data ? res.data : res;
        const lines = [];
        lines.push("Run: " + (out.runId||""));
        lines.push("Time: " + (out.timeISO||""));
        lines.push("Mismatches: " + (out.mismatchCount||0) + (out.truncated ? " (truncated)" : ""));
        lines.push("Total Supply (Sheet): " + fmtMoney(out.totalSupplySheet||0));
        lines.push("Total Supply (Ledger): " + fmtMoney(out.totalSupplyLedger||0));
        lines.push("");
        const ms = out.mismatches || [];
        if(!ms.length){
          lines.push("✅ OK: No mismatches found.");
        }else{
          lines.push("---- MISMATCHES ----");
          ms.forEach((x,i)=>{
            lines.push(
              (i+1)+". "+(x.callsign||"")+" | "+(x.name||"")+" ("+(x.accountId||"")+")"
              +" | sheet="+fmtMoney(x.sheetBalance||0)
              +" | ledger="+fmtMoney(x.ledgerBalance||0)
              +" | diff="+fmtMoney(x.diff||0)
              +" | status="+(x.status||"")
            );
          });
        }
        el("tywAdmReconOut").textContent = lines.join("\n");
        showMsg(el("tywAdmReconOk"), "Reconcile complete.", true);
      }catch(e){
        showMsg(el("tywAdmReconMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    });

    // Reconcile (fix)
    onOnce("tywAdmReconFixBtn","click", async () => {
      clearMsg(el("tywAdmReconMsg")); clearMsg(el("tywAdmReconOk"));
      try{
        setBusy(true);
        const res = await apiCall("adminReconcileFix", { maxFix: 2000 });
        const out = res && res.data ? res.data : res;
        const lines = [];
        lines.push("Fix Run: " + (out.runId||""));
        lines.push("Time: " + (out.timeISO||""));
        lines.push("Mismatches: " + (out.mismatchCount||0));
        lines.push("Fixed: " + (out.fixedCount||0));
        lines.push("Total Supply (Sheet): " + fmtMoney(out.totalSupplySheet||0));
        lines.push("Total Supply (Ledger): " + fmtMoney(out.totalSupplyLedger||0));
        lines.push("");
        if(out.fixedCount){
          lines.push("✅ Balances updated to match TXNS ledger.");
        }else{
          lines.push("No changes needed.");
        }
        el("tywAdmReconOut").textContent = lines.join("\n");
        showMsg(el("tywAdmReconOk"), "Fix complete.", true);
      }catch(e){
        showMsg(el("tywAdmReconMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    });

onOnce("tywAdmGamePouch","change", function(){renderAdminGameCurrency(S.adminGameCurrency||S.adminDash||{});});
onOnce("tywAdmGameReload","click", function(){loadAdminGameCurrencyState_(S.adminTarget||"").catch(function(){});});

onOnce("tywAdmGameBtn","click", async () => {
      clearMsg(el("tywAdmGameMsg")); clearMsg(el("tywAdmGameOk"));
      if(!S.adminTarget){var selfCallsign=cleanCallsign(S.callsign||S.userCallsign||"");if(selfCallsign)await loadAdminTarget(selfCallsign);}
      if(!S.adminTarget) return setMsg(el("tywAdmGameMsg"), "No disciple could be detected.", false);
      const pouchAccountId=String((el("tywAdmGamePouch")&&el("tywAdmGamePouch").value)||"");
      const currency=String((el("tywAdmGameCurrency")&&el("tywAdmGameCurrency").value)||"").toUpperCase();
      const delta=toNum((el("tywAdmGameDelta")&&el("tywAdmGameDelta").value)||0);
      const note=String((el("tywAdmGameNote")&&el("tywAdmGameNote").value)||"").trim();
      if(!pouchAccountId)return setMsg(el("tywAdmGameMsg"),"Choose a Cosmic Pouch.",false);
      if(!Number.isFinite(delta)||delta===0)return setMsg(el("tywAdmGameMsg"),"Invalid delta.",false);
      const gameBtn=el("tywAdmGameBtn"),unlockGameBtn=lockBtn(gameBtn,"APPLYING…");
      try{
        setText("tywAdmGameLoadState","Applying the "+(currency==="SP"?"SP":"Coin")+" adjustment…");
        setBusy(true);
        await rpc("adminAdjustGameCurrency",{callsign:S.adminTarget,pouchAccountId:pouchAccountId,currency:currency,delta:delta,note:note});
        setMsg(el("tywAdmGameOk"),(delta>0?"Added ":"Deducted ")+Math.abs(Math.trunc(delta))+" "+(currency==="SP"?"Spirit Power":"Coins")+".",true);
        el("tywAdmGameDelta").value="";el("tywAdmGameNote").value="";
        await loadAdminTarget(S.adminTarget);
      }catch(e){setMsg(el("tywAdmGameMsg"),e.message||String(e),false);}finally{setBusy(false);unlockGameBtn();}
    });

onOnce("tywAdmAdjBtn","click", async () => {
      clearMsg(el("tywAdmAdjMsg")); clearMsg(el("tywAdmAdjOk"));
      if(!S.adminTarget) return setMsg(el("tywAdmAdjMsg"), "Load a target user first.", false);
      const acct = el("tywAdmAdjAcct").value;
      const delta = toNum(el("tywAdmAdjDelta").value);
      const note = String(el("tywAdmAdjNote").value || "").trim();
      if(!Number.isFinite(delta) || delta === 0) return setMsg(el("tywAdmAdjMsg"), "Invalid delta.", false);
      const stoneBtn=el("tywAdmAdjBtn"),unlockStoneBtn=lockBtn(stoneBtn,"APPLYING…");
      try{
        setBusy(true);
        await rpc("adminAdjustBalance", { callsign:S.adminTarget, accountId:acct, delta, note });
        setMsg(el("tywAdmAdjOk"), "Applied.", true);
        el("tywAdmAdjDelta").value = "";
        el("tywAdmAdjNote").value = "";
        await loadAdminTarget();
      }catch(e){
        setMsg(el("tywAdmAdjMsg"), e.message || String(e), false);
      }finally{ setBusy(false); unlockStoneBtn(); }
    });


    // ====== Core actions (deposit/withdraw/create/export) ======
    let _backendPingRetries = 0;
    let _backendPingPromise = null;
    async function refreshBackendStatus(){
      if(_backendPingPromise) return _backendPingPromise;
      _backendPingPromise = (async function(){
      try{
        // step 2: connect
        if(BOOT){
          BOOT.showSteps();
          BOOT.setStep(1, "done");
          BOOT.setStep(2, "active");
          BOOT.setLine("Connecting to bank server…");
        }

        const res = await rpc("ping", {});
        // backend is source of truth for build
        if(res && res.build){
          try{ S.backendBuild = res.build; }catch(_e){}
          setBuildText(res.build);
        }
        if(backendStatus) backendStatus.textContent = "Backend: OK • " + (res.serverTime || "");
        try{ _backendPingRetries = 0; }catch(_eRetry){}
        try{ if(typeof window.__SLB_NET_MARK_HEALTHY__ === 'function') window.__SLB_NET_MARK_HEALTHY__({ action:'ping', source:'refreshBackendStatus' }); }catch(_eNet){}

        if(BOOT){
          BOOT.hideConn();
          BOOT.setStep(2, "done");
          if(S.token){
            BOOT.setStep(3, "active");
            BOOT.setLine("Loading your data…");
          }else{
            BOOT.setStep(3, "waiting");
            BOOT.setLine("Ready. Please log in.");
          }
        }

        return res;
      }catch(e){
        if(backendStatus) backendStatus.textContent = "Backend: ERROR • " + (e.message || String(e));
        if(BOOT){
          BOOT.setStep(2, "error");
          BOOT.setStep(3, "waiting");
          BOOT.setLine("Can’t reach the bank server.");
          BOOT.showConn(e && (e.message || String(e)));
        }
        // Soft auto-retry: fixes the common "cold start" / iframe timing issue where the first ping fails
        // but everything works a moment later.
        try{
          if(_backendPingRetries < 3){
            _backendPingRetries++;
            setTimeout(()=>{ try{ refreshBackendStatus(); }catch(_e2){} }, 3500);
          }
        }catch(_e3){}
        return null;
      }
      })();
      try{
        return await _backendPingPromise;
      }finally{
        _backendPingPromise = null;
      }
    }

    function renderAdminDeletePouch(dash){
      const sel = el("tywAdmDelPouchSel");
      const btn = el("tywAdmDelPouchBtn");
      const ck  = el("tywAdmDelConfirm");
      if(!sel || !btn || !ck) return;

      // Clear messages
      setMsg(el("tywAdmDelMsg"), "", false);
      setMsg(el("tywAdmDelOk"), "", true);

      // Build options from backend-filtered list (exclude On Hand / deleted)
      sel.innerHTML = `<option value="">- Select Cosmic Pouch -</option>`;

      const target = String((dash && dash.profile && dash.profile.callsign) || "").trim().toUpperCase();
      if(!target){
        btn.disabled = true;
        return;
      }

      // Prefer server-truth list (safer), but fall back to dash.accounts if needed
      (async()=>{
        try{
          const r = await rpc("adminListPouchesForDelete", { callsign: target });
          const pouches = (r && r.pouches) ? r.pouches : [];
          pouches.forEach(p=>{
            const opt = document.createElement("option");
            opt.value = String(p.accountId||"");
            opt.textContent = `${displayAcctName(p.name)} (${money(p.balance)} stones)`;
            sel.appendChild(opt);
          });

          // Keep button state correct
          btn.disabled = !(ck.checked && !!sel.value);
        }catch(e){
          // fallback to dash.accounts
          const accts = (dash && dash.accounts) ? dash.accounts : [];
          accts
            .filter(a=>{
              const nm = normAcctName(a.name);
              const st = String(a.status||"").toUpperCase();
              if(st==="DELETED") return false;
              if(nm==="wallet" || nm==="on hand" || nm==="onhand") return false;
              return true;
            })
            .forEach(a=>{
              const opt = document.createElement("option");
              opt.value = String(a.accountId||"");
              opt.textContent = `${displayAcctName(a.name)} (${money(a.balance)} stones)`;
              sel.appendChild(opt);
            });
          btn.disabled = !(ck.checked && !!sel.value);
          setMsg(el("tywAdmDelMsg"), (e && e.message) ? e.message : String(e), false);
        }
      })();

      // Wire up (idempotent)
      if(!sel._slbBound){
        sel.addEventListener("change", ()=>{ btn.disabled = !(ck.checked && !!sel.value); });
        ck.addEventListener("change", ()=>{ btn.disabled = !(ck.checked && !!sel.value); });

        btn.addEventListener("click", async()=>{
                  // Optimistic lockout: disable controls immediately to prevent double-clicks
                  let oldText = "";
                  let snapSelHTML = "";
                  let snapSelVal = "";
                  let snapCk = false;
        
                  try{
                    oldText = btn.textContent;
                    snapSelHTML = sel.innerHTML;
                    snapSelVal = sel.value;
                    snapCk = !!ck.checked;
        
                    setMsg(el("tywAdmDelMsg"), "", false);
                    setMsg(el("tywAdmDelOk"), "Deleting…", true);
        
                    // lock UI instantly
                    btn.disabled = true;
                    try{ sel.disabled = true; ck.disabled = true; }catch(_e){}
                    try{ btn.textContent = "Deleting…"; }catch(_e){}
        
                    const accountId = String(snapSelVal||"").trim();
                    if(!accountId) throw new Error("Please select a Cosmic Pouch.");
                    if(!snapCk) throw new Error("Please confirm first.");
        
                    const nameTxt = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : accountId;
                    const note = `Admin delete pouch: ${nameTxt}`;
        
                    // Optimistic: remove the selected option immediately (rollback on failure)
                    try{
                      const opt = sel.options[sel.selectedIndex];
                      if(opt) opt.remove();
                      sel.value = "";
                      ck.checked = false;
                    }catch(_e){}
        
                    setBusy(true);
                    await rpc("adminDeletePouch", { callsign: target, accountId, note });
        
                    // Refresh admin dashboard view for the same target
                    if(typeof loadAdminTarget === "function"){
                      await loadAdminTarget(target);
                    }else{
                      // fallback: reload pouches list only
                      const r2 = await rpc("adminGetUserDashboard", { callsign: target });
                      renderAdminAccounts(r2);
                      renderAdminTxns(r2);
                      renderAdminDeletePouch(r2);
                    }
        
                    setMsg(el("tywAdmDelOk"), "Deleted.", true);
                  }catch(e){
                    // rollback optimistic changes
                    try{
                      if(snapSelHTML) sel.innerHTML = snapSelHTML;
                      sel.value = snapSelVal;
                      ck.checked = snapCk;
                    }catch(_e){}
                    setMsg(el("tywAdmDelMsg"), e.message || String(e), false);
                  }finally{
                    try{ setBusy(false); }catch(_e){}
                    try{ sel.disabled = false; ck.disabled = false; }catch(_e){}
                    try{ if(oldText) btn.textContent = oldText; }catch(_e){}
                    try{ btn.disabled = !(ck.checked && !!sel.value); }catch(_e){}
                  }
                });

        sel._slbBound = true;
      }
    }

    function applyDashboard(dash){
      S.dash = dash;
      // V3.149: the dashboard response now owns all four wealth counters. Feed
      // its grouped Coin/SP snapshot into the shared hub immediately.
      try{
        const groupedCurrency = dash && (dash.currencySnapshot || ((dash.totalCoinBalance !== undefined || dash.totalSpBalance !== undefined) ? dash : null));
        if(groupedCurrency){
          if(window.SLB_BALANCE_HUB && typeof window.SLB_BALANCE_HUB.accept === "function") window.SLB_BALANCE_HUB.accept(groupedCurrency);
          else window.__SLB_PENDING_DASH_CURRENCY__ = groupedCurrency;
        }
      }catch(_eGroupedCurrency){}

      // Phase 4.3: txns paging cursor
      S.txnsCursor = (dash && dash.txnsNextCursor) ? dash.txnsNextCursor : null;
      S.txnsHasMore = !!(dash && dash.txnsHasMore);

      S.callsign = dash.profile.callsign;
      S.displayName = dash.profile.displayName;
      const prof = (dash && dash.profile) ? dash.profile : {};
const role = String(prof.role || "").toLowerCase().trim();
S.isAdmin = (!!prof.isAdmin) || (role === "admin");
S.isModerator = (!!prof.isModerator) || (role === "moderator");
S.isAdminOrMod = (S.isAdmin || S.isModerator);
try{
        var _root = document.documentElement;
        if(_root && _root.classList){
          _root.classList.toggle("tyRoleAdmin", !!S.isAdmin);
          _root.classList.toggle("tyRoleModerator", !!S.isModerator);
          _root.classList.toggle("tyRoleAdminOrMod", !!S.isAdminOrMod);
        }
      }catch(_e){} 
      S.canCreatePouches = !!dash.profile.canCreatePouches;

      sessionStorage.setItem("tyw_callsign", S.callsign);

      // FastBoot: mark session as recently OK so refresh can skip the visible boot steps.
      try{ localStorage.setItem("slb_fastboot_ok_ts", String(Date.now())); }catch(_e){}

      // Bank optimistic UI overlay (deposit/withdraw/gift/pouches)
      try{
        bankInitForUser_();
        bankSetBaseFromDash_(dash);
        bankApplyViewToDash_(dash);
      }catch(_e){}

      sessionStorage.setItem("tyw_displayName", S.displayName);
      sessionStorage.setItem("tyw_isAdmin", S.isAdmin ? "1" : "0");


/* ====== SLB CORE: 90_core_app.part05.js ====== */
/* SLB PART FILE — NOT STANDALONE
   This file is concatenated by slb_build/build.mjs into assets/slb.bundle.generated.js
*/

/* SLB CORE APP (split) - part 05/6
   NOTE: These parts are concatenated in order by slb_build/build.mjs.
*/
      sessionStorage.setItem("tyw_isModerator", S.isModerator ? "1" : "0");
      sessionStorage.setItem("tyw_canCreatePouches", (S.isAdmin || S.canCreatePouches) ? "1" : "0");
      try{ slbPersistSharedAuth_(); }catch(_eAuthPersist){}

      const who = el("tywWho");
      const whoText = `You are logged in as: ${S.displayName} • ${S.callsign}`;
      if(who){
        who.textContent = whoText;
        who.title = whoText;
      }

      setText("tywTotal", money(dash.totals.totalStones));
      setText("tywWallet", money(dash.totals.walletStones));
      setText("tywWallet2", money(dash.totals.walletStones));
      setText("tywStatus", "Ready");
      try{ bankUpdateStatusUI_(); }catch(_e){}

      // show admin menu groups
      const admNav = el("tywAdminNav");
      const mobAdm = el("tywMobileAdminGroup");
      if(admNav) admNav.classList.toggle("hidden", !S.isAdminOrMod);
      if(mobAdm) mobAdm.classList.toggle("hidden", !S.isAdminOrMod);

      // rename Admin -> Moderator when needed
      try{
        const isModOnly = (!!S.isModerator) && (!S.isAdmin);
        const dt = document.querySelector("#dropAdmin .dropTitle");
        if(dt) dt.textContent = isModOnly ? "Moderator" : "Admin";
        const mi = document.querySelector("#dropAdmin .menuItem[data-tab=\"admin\"]");
        if(mi) mi.textContent = isModOnly ? "Moderator Panel" : "Admin Panel";
        try{ if(window.SLB_applyRoleUI) window.SLB_applyRoleUI(); else setTimeout(()=>{ try{ if(window.SLB_applyRoleUI) window.SLB_applyRoleUI(); }catch(_e){} },0); }catch(_e){}
      }catch(_e){}

      // pouch permission UI
      const canPouchUI = (S.isAdmin || S.canCreatePouches);
      const lockNote = el("tywPouchLockedNote");
      const createBox = el("tywCreatePouchBox");
      if(lockNote) lockNote.classList.toggle("hidden", canPouchUI);
      if(createBox) createBox.classList.toggle("hidden", !canPouchUI);

      renderAllSelects();
      renderAccounts();
      renderTxnsSelf();
      try{
        window.dispatchEvent(new CustomEvent("slb:dashboard-updated", { detail: dash }));
      }catch(_eDashEvent){}
    }

    async function refreshDashboard(){
      const seq = ++S.reqSeq;
      S.dashReq = seq;
      const dash = await (async()=>{
        const delays = [0, 900, 1800];
        let lastErr = null;
        for(let i=0;i<delays.length;i++){
          try{
            if(delays[i]) await new Promise(r => setTimeout(r, delays[i]));
            return await rpc("getDashboard", { forceFresh: 1 });
          }catch(e){
            lastErr = e;
          }
        }
        throw lastErr || new Error("getDashboard failed");
      })();
      if(S.dashReq !== seq) return; // ignore stale response
      applyDashboard(dash);
    }

    // Performance: lite dashboard refresh (accounts + totals only), preserves current txns list + paging state
    async function refreshDashboardLite(){
      const seq = ++S.reqSeq;
      S.dashReq = seq;
      // Instant UI: hydrate from cache before network (first-load only)

      try{

        if(!S.dash || !Array.isArray(S.dash.accounts) || !S.dash.accounts.length){

          const c = slbCacheGet_("dashLite", 7*24*60*60*1000);

          if(c && typeof c === "object"){

            if(!S.dash) S.dash = {};

            const keepTxns = Array.isArray(S.dash.txns) ? S.dash.txns : [];

            const keepCursor = S.txnsCursor;

            const keepHasMore = S.txnsHasMore;

            // Merge profile so role fields (isModerator/role) are not lost if a cached dashLite
            // snapshot is missing them (older cache entries, or older backend builds).
            S.dash.profile = Object.assign({}, (S.dash.profile||{}), (c.profile||{}));

            S.dash.accounts = c.accounts || [];

            S.dash.totals = c.totals || { totalStones: 0, walletStones: 0 };
            if(c.currencySnapshot) S.dash.currencySnapshot = c.currencySnapshot;
            if(c.totalCoinBalance !== undefined) S.dash.totalCoinBalance = c.totalCoinBalance;
            if(c.totalSpBalance !== undefined) S.dash.totalSpBalance = c.totalSpBalance;
            if(c.currency) S.dash.currency = c.currency;

            S.dash.txns = keepTxns;

            if(keepCursor) S.dash.txnsNextCursor = keepCursor;

            S.dash.txnsHasMore = !!keepHasMore;

            applyDashboard(S.dash);

            S.txnsCursor = keepCursor;

            S.txnsHasMore = keepHasMore;

          }

        }

      }catch(_e){} 

      // Robust fetch: retry a few times on transient Apps Script cold start / sheet locks
      const lite = await (async()=>{
        const delays = [0, 900, 1800]; // ms
        let lastErr = null;
        for(let i=0;i<delays.length;i++){
          try{
            if(delays[i]) await new Promise(r => setTimeout(r, delays[i]));
            return await rpc("getDashboardLite", { forceFresh: 1 });
          }catch(e){
            lastErr = e;
          }
        }
        throw lastErr || new Error("getDashboardLite failed");
      })();
      if(S.dashReq !== seq) return;

      // Guard: avoid leaving UI stuck in "logged in as: —" if lite payload is incomplete.
      // If the backend returns an empty/partial lite response (rare), fall back to full dashboard once.
      try{
        const _cs = (lite && lite.profile) ? String(lite.profile.callsign || "").trim() : "";
        if(!_cs){
          const dash = await (async()=>{
            const delays = [0, 900];
            let lastErr = null;
            for(let i=0;i<delays.length;i++){
              try{
                if(delays[i]) await new Promise(r => setTimeout(r, delays[i]));
                return await rpc("getDashboard", { forceFresh: 1 });
              }catch(e){
                lastErr = e;
              }
            }
            throw lastErr || new Error("getDashboard failed");
          })();
          if(S.dashReq !== seq) return;
          applyDashboard(dash);
          const _cs2 = (dash && dash.profile) ? String(dash.profile.callsign || "").trim() : "";
          if(!_cs2) throw new Error("Session not hydrated");
          return;
        }
      }catch(e){
        // Let caller decide whether to retry / show login
        throw e;
      }


      if(!S.dash) S.dash = {};
      const keepTxns = Array.isArray(S.dash.txns) ? S.dash.txns : [];
      const keepCursor = S.txnsCursor;
      const keepHasMore = S.txnsHasMore;

      // Merge profile so role fields are not lost if dashLite payload is partial.
      S.dash.profile = Object.assign({}, (S.dash.profile||{}), (lite.profile||{}));
      S.dash.accounts = lite.accounts || [];
      S.dash.totals = lite.totals || { totalStones: 0, walletStones: 0 };
      if(lite.currencySnapshot) S.dash.currencySnapshot = lite.currencySnapshot;
      if(lite.totalCoinBalance !== undefined) S.dash.totalCoinBalance = lite.totalCoinBalance;
      if(lite.totalSpBalance !== undefined) S.dash.totalSpBalance = lite.totalSpBalance;
      if(lite.currency) S.dash.currency = lite.currency;

      // Save one grouped dashboard snapshot so Stones, Pouches, Coins, and SP
      // all paint together on the next visit.
      try{ slbCacheSet_("dashLite", { profile: S.dash.profile, accounts: S.dash.accounts, totals: S.dash.totals, currencySnapshot: S.dash.currencySnapshot || null, totalCoinBalance: S.dash.totalCoinBalance, totalSpBalance: S.dash.totalSpBalance, currency: S.dash.currency || null }); }catch(_e){}

      // preserve txns + paging state through applyDashboard
      S.dash.txns = keepTxns;
      if(keepCursor) S.dash.txnsNextCursor = keepCursor;
      S.dash.txnsHasMore = !!keepHasMore;

      applyDashboard(S.dash);

      // restore paging (applyDashboard reads from dash)
      S.txnsCursor = keepCursor;
      S.txnsHasMore = keepHasMore;
    }

    
    function setTxnsLastRef_(d){
      try{
        const elx = el("tywTxnsLastRef");
        if(!elx) return;
        const dd = d ? new Date(d) : new Date();
        elx.textContent = dd.toLocaleString();
      }catch(_e){}
    }

    function wireTxnsForceReloadBtn_(){
      try{
        const btn = el("tywTxnsForceBtn");
        if(!btn || btn.__wired) return;
        btn.__wired = true;
        btn.addEventListener("click", async ()=>{
          try{
            btn.disabled = true;
            btn.textContent = "Reloading...";
            await reloadTxnsFirstPage(true);
          }catch(e){
            alert(e.message || String(e));
          }finally{
            btn.disabled = false;
            btn.textContent = "Force reload";
          }
        });
      }catch(_e){}
    }
// Reload the newest transactions page (fast path vs full dashboard)
    async function reloadTxnsFirstPage(forceFresh){
      try{ wireTxnsForceReloadBtn_(); }catch(_e){}
      if(forceFresh){
        try{ localStorage.removeItem(slbCacheKey_("txnsFirst")); }catch(_e){}
      }
      // Instant UI: show cached txns first page if available
      try{
        if(!S.dash) S.dash = {};
        if(!Array.isArray(S.dash.txns) || !S.dash.txns.length){
          const c = slbCacheGet_("txnsFirst", 7*24*60*60*1000);
          if(c && typeof c === "object"){
            S.dash.txns = c.items || [];
            S.txnsCursor = c.nextCursor || null;
            S.txnsHasMore = !!c.hasMore;
            S.dash.txnsNextCursor = S.txnsCursor;
            S.dash.txnsHasMore = S.txnsHasMore;
            try{ bankInitForUser_(); bankApplyViewToDash_(S.dash, { updateBase:false }); }catch(_e){}
            renderTxnsSelf();
            renderTxnsMore();
          }
        }
      }catch(_e){}
      const page = await rpc("getTxnsPage", { cursor: null, limit: 200, forceFresh: forceFresh ? 1 : 0, _ts: Date.now() });
      if(!S.dash) S.dash = {};
      S.dash.txns = (page && page.items) ? page.items : [];
      S.txnsCursor = (page && page.nextCursor) ? page.nextCursor : null;
      S.txnsHasMore = !!(page && page.hasMore);

      // Keep dash fields consistent for applyDashboard paging expectations
      S.dash.txnsNextCursor = S.txnsCursor;
      S.dash.txnsHasMore = S.txnsHasMore;

      // Bank optimistic overlay for txns (no base refresh)
      try{ bankInitForUser_(); bankApplyViewToDash_(S.dash, { updateBase:false }); }catch(_e){}

      renderTxnsSelf();
      renderTxnsMore();
    }


// ====== Fast UX helpers ======
// Keep write actions strict/atomic, but refresh UI in the background so the app feels snappy.
function bgRun_(promises){
  try{
    Promise.allSettled(promises || []).catch(()=>{});
  }catch(_e){}
}

function bgSyncBalancesAndTxns_(){
  try{ setText("tywStatus", "Syncing..."); }catch(_e){}
  bgRun_([ refreshDashboardLite(), reloadTxnsFirstPage() ]);
  setTimeout(()=>{
    try{ setText("tywStatus", "Ready"); }catch(_e){}
    try{ bankUpdateStatusUI_(); }catch(_e){}
  }, 1200);
}
    // ============================
    // Bank Optimistic UI (SLB)
    // ============================
    let __bankOps = [];
    let __bankKey = "";
    let __bankInflight = Object.create(null);

    function bankKey_(){
      const cs = String(S.callsign || sessionStorage.getItem("tyw_callsign") || "").trim().toUpperCase();
      return "slb_bank_pending_" + (cs || "ANON");
    }
    function bankLoad_(){
      const k = bankKey_();
      if(__bankKey === k) return;
      __bankKey = k;
      __bankInflight = Object.create(null);
      try{
        const raw = localStorage.getItem(k) || "[]";
        const arr = JSON.parse(raw);
        __bankOps = Array.isArray(arr) ? arr.filter(Boolean) : [];
      }catch(_e){
        __bankOps = [];
      }

      // HARDEN3: normalize queued ops so retries are predictable across versions
      try{
        (__bankOps || []).forEach(op => {
          if(!op || !op.opId) return;
          if(typeof op.attempts !== "number") op.attempts = 0;
          if(typeof op.nextTryAt !== "number") op.nextTryAt = 0;
          if(!op.state) op.state = "pending";
        });
      }catch(_e){}
    }
    function bankSave_(){
      try{ localStorage.setItem(__bankKey || bankKey_(), JSON.stringify(__bankOps || [])); }catch(_e){}
    }
    function bankHasOps_(){ return (__bankOps || []).length > 0; }
    function bankHasFailed_(){ return (__bankOps || []).some(o => o && o.state === "failed"); }
    function bankHasPending_(){ return (__bankOps || []).some(o => o && o.state !== "failed"); }

    // ============================
    // Treasury Optimistic Ops Queue (Admin Outbox Deletes)
    // HARDEN3.3: make treasury deletes retryable like bank ops
    // ============================
    let __treOps = [];
    let __treKey = "";
    let __treInflight = Object.create(null);

    function treOpsKey_(){
      const cs = String(S.callsign || sessionStorage.getItem("tyw_callsign") || "").trim().toUpperCase();
      return "slb_tre_pending_" + (cs || "ANON");
    }
    function treOpsLoad_(){
      __treKey = treOpsKey_();
      try{
        const raw = localStorage.getItem(__treKey);
        if(!raw){ __treOps = []; return; }
        const arr = JSON.parse(raw);
        __treOps = Array.isArray(arr) ? arr.filter(Boolean) : [];
      }catch(_e){
        __treOps = [];
      }
      try{
        (__treOps || []).forEach(op => {
          if(!op || !op.opId) return;
          if(typeof op.attempts !== "number") op.attempts = 0;
          if(typeof op.nextTryAt !== "number") op.nextTryAt = 0;
          if(!op.state) op.state = "pending";
        });
      }catch(_e){}
    }
    function treOpsSave_(){
      try{ localStorage.setItem(__treKey || treOpsKey_(), JSON.stringify(__treOps || [])); }catch(_e){}
    }
    function treOpsHasAny_(){ return (__treOps || []).length > 0; }
    function treOpsFailedCount_(){ return (__treOps || []).filter(o => o && o.state === "failed").length; }
    function treOpsPendingCount_(){ return (__treOps || []).filter(o => o && o.state !== "failed").length; }

    function treOpsEnqueueDeleteEverywhere_(outboxId){
      treOpsLoad_();
      const id = String(outboxId||"").trim();
      if(!id) return null;

      // de-dupe: only keep one pending op per outboxId
      const exists = (__treOps || []).some(op => op && op.kind === "outboxDeleteEverywhere" && String(op.outboxId||"") === id && op.state !== "done");
      if(exists) return null;

      const opId = "tre_" + Date.now() + "_" + Math.random().toString(16).slice(2);
      const op = { opId, kind: "outboxDeleteEverywhere", outboxId: id, state: "pending", attempts: 0, nextTryAt: 0, createdAt: Date.now() };
      __treOps.push(op);
      treOpsSave_();
      return op;
    }

    async function treOpsSyncOp_(op){
      if(!op || !op.opId || !op.kind) return;
      if(__treInflight[op.opId]) return;
      if(op.state === "failed") return; // wait for Resync
      const now = Date.now();
      if(Number(op.nextTryAt||0) > now) return;

      __treInflight[op.opId] = 1;
      try{
        if(op.kind === "outboxDeleteEverywhere"){
	          // HARD delete everywhere (admin outbox) — required by backend to actually remove
	          await rpc(
	            ACTIONS.adminTreasuresOutboxDeleteEverywhere,
	            { outboxId: String(op.outboxId||""), hard: 1 },
	            { requestId: op.opId }
	          );
        }else{
          throw new Error("Unknown treasury op: " + String(op.kind));
        }

        // success: remove op
        treOpsLoad_();
        __treOps = (__treOps || []).filter(x => x && x.opId !== op.opId);
        treOpsSave_();
        try{ setTimeout(()=>{ try{ treAdmOutboxLoad_(true); }catch(_e){} }, 200); }catch(_e){}
        try{ Object.keys(localStorage||{}).filter(k=> (k.indexOf("slb_pagecache_")>=0 || k.indexOf("admTreView")>=0 )).forEach(k=>localStorage.removeItem(k)); }catch(_e){}
      }catch(err){
        // mark failed with backoff
        try{
          op.attempts = Number(op.attempts||0) + 1;
          op.err = (err && err.message) ? String(err.message) : String(err);
          op.state = "failed";
          const base = 3000; // 3s
          const delay = Math.min(60000, base * Math.pow(2, Math.min(4, op.attempts-1))); // cap ~60s
          op.nextTryAt = Date.now() + delay;
          treOpsLoad_();
          __treOps = (__treOps || []).map(x => (x && x.opId===op.opId) ? op : x);
          treOpsSave_();
        }catch(_e){}
      }finally{
        delete __treInflight[op.opId];
      }
    }

    function treOpsResyncAll_(){
      treOpsLoad_();
      const failed = (__treOps || []).filter(o => o && o.state === "failed");
      if(!failed.length) return 0;
      failed.forEach(op => { op.state = "pending"; delete op.err; op.nextTryAt = 0; });
      treOpsSave_();
      failed.forEach(op => { try{ treOpsSyncOp_(op); }catch(_e){} });
      return failed.length;
    }

    function bankEnsureResyncUI_(){
      const st = el("tywStatus");
      if(!st) return;
      if(el("slbBankResyncBtn")) return;

      const parent = st.parentElement || st;
      let row = el("slbBankSyncActions");
      if(!row){
        row = document.createElement("div");
        row.id = "slbBankSyncActions";
        row.className = "slbBankSyncActions";
        row.setAttribute("role", "group");
        row.setAttribute("aria-label", "Bank synchronization controls");
        parent.appendChild(row);
      }

      const btn = document.createElement("button");
      btn.id = "slbBankResyncBtn";
      btn.className = "btn orange mini";
      btn.type = "button";
      btn.textContent = "Resync Now";
      btn.style.display = "none";
      btn.disabled = false;
      btn.setAttribute("aria-disabled", "false");
      btn.addEventListener("click", (ev) => {
        try{ ev.preventDefault(); ev.stopPropagation(); }catch(_e){}
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        Promise.resolve().then(() => slbResyncAll_()).finally(() => {
          setTimeout(() => {
            try{
              btn.disabled = false;
              btn.setAttribute("aria-disabled", "false");
            }catch(_e){}
          }, 900);
        });
      });
      row.appendChild(btn);
    }
    
    
    // ============================
    // Admin: Sync Queue Panel (HARDEN3.2 — Bank + Board + Treasury)
    // ============================
    function bankIsAdmin_(){ try{ return !!(S && S.isAdminOrMod); }catch(_e){ return false; } }

    function slbAdminQueueTab_(){ try{ return String(S.__adminQueueTab||"bank"); }catch(_e){ return "bank"; } }
    function slbAdminQueueSetTab_(tab){ try{ S.__adminQueueTab = String(tab||"bank"); }catch(_e){} }

    function slbAdminQueueShowTab_(tab){
      slbAdminQueueSetTab_(tab);
      const tabs = ["bank","board","treasury"];
      tabs.forEach(t=>{
        const b = el("slbAdminQueueTab_"+t);
        const p = el("slbAdminQueuePanel_"+t);
        if(b){
          b.classList.toggle("on", t===tab);
          b.style.background = (t===tab) ? "var(--ty-orange, #ef5e14)" : "#fff";
          b.style.color = (t===tab) ? "#fff" : "var(--text,#111)";
          b.style.borderColor = (t===tab) ? "var(--ty-orange, #ef5e14)" : "var(--border,#e2e6ea)";
        }
        if(p) p.style.display = (t===tab) ? "block" : "none";
      });

      try{
        if(tab === "bank"){ bankLoad_(); bankRenderQueuePanel_(); }
        else if(tab === "board"){ boardRenderQueuePanel_(); }
        else if(tab === "treasury"){ treRenderQueuePanel_(); }
      }catch(_e){}
    }

    function bankEnsureQueuePanelUI_(){
      if(!bankIsAdmin_()) return;
      const st = el("tywStatus");
      if(!st) return;

      // Button next to Resync
      if(!el("slbBankQueueBtn")){
        // find a good parent: same row as Resync button if exists
        let parent = st.parentElement;
        try{
          const res = el("bankResyncBtn");
          if(res && res.parentElement) parent = res.parentElement;
        }catch(_e){}
        if(!parent) parent = st;

        const btn = document.createElement("button");
        btn.id = "slbBankQueueBtn";
        btn.className = "btn soft mini";
        btn.textContent = "Queue";
        btn.style.marginLeft = "8px";
        btn.style.display = "inline-flex";
        btn.addEventListener("click", () => {
          bankEnsureQueuePanelUI_();
          // default open to Bank tab
          slbAdminQueueShowTab_("bank");
          const modal = el("slbBankQueueModal");
          if(modal) modal.style.display = "flex";
        });
        parent.appendChild(btn);
      }

      // Modal shell (created once)
      if(!el("slbBankQueueModal")){
        const modal = document.createElement("div");
        modal.id = "slbBankQueueModal";
        modal.style.cssText = "position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.55);padding:14px;";
        modal.addEventListener("click", (e) => { if(e.target === modal) bankCloseQueuePanel_(); });

        const card = document.createElement("div");
        card.style.cssText = "width:min(980px,100%);max-height:min(82vh,900px);overflow:auto;background:#fff;border-radius:14px;box-shadow:0 12px 40px rgba(0,0,0,.25);padding:14px 14px 10px;";

        const head = document.createElement("div");
        head.style.cssText = "display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;";

        const title = document.createElement("div");
        title.style.cssText = "font-weight:700;font-size:16px;";
        title.textContent = "Admin Sync Queue (Local)";

        const actions = document.createElement("div");
        actions.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;";

        function mkBtn(txt2, onClick){
          const b = document.createElement("button");
          b.className = "btn soft mini";
          b.textContent = txt2;
          b.addEventListener("click", (e)=>{ e.preventDefault(); e.stopPropagation(); onClick && onClick(); });
          return b;
        }
        actions.appendChild(mkBtn("Close", () => bankCloseQueuePanel_()));

        head.appendChild(title);
        head.appendChild(actions);

        // Tabs
        const tabBar = document.createElement("div");
        tabBar.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;margin:0 0 10px;";
        function mkTab(tab, label){
          const b = document.createElement("button");
          b.id = "slbAdminQueueTab_"+tab;
          b.className = "btn soft mini";
          b.textContent = label;
          b.style.border = "1px solid var(--border,#e2e6ea)";
          b.addEventListener("click", (e)=>{ e.preventDefault(); e.stopPropagation(); slbAdminQueueShowTab_(tab); });
          return b;
        }
        tabBar.appendChild(mkTab("bank","Bank Ops"));
        tabBar.appendChild(mkTab("board","Message Board"));
        tabBar.appendChild(mkTab("treasury","Treasury Messages"));

        // Panels wrapper
        const panels = document.createElement("div");

        // Bank panel (existing ids used by bankRenderQueuePanel_)
        const pBank = document.createElement("div");
        pBank.id = "slbAdminQueuePanel_bank";
        const bankActs = document.createElement("div");
        bankActs.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;margin:0 0 8px;";
        bankActs.appendChild(mkBtn("Copy Bank JSON", () => bankCopyQueueJSON_()));
        bankActs.appendChild(mkBtn("Clear Failed", () => bankClearQueueFailed_()));
        bankActs.appendChild(mkBtn("Clear All", () => bankClearQueueAll_()));
        const infoBank = document.createElement("div");
        infoBank.id = "slbBankQueueInfo";
        infoBank.style.cssText = "font-size:12px;opacity:.85;margin:0 0 10px;";
        const bodyBank = document.createElement("div");
        bodyBank.id = "slbBankQueueBody";
        pBank.appendChild(bankActs);
        pBank.appendChild(infoBank);
        pBank.appendChild(bodyBank);

        // Board panel
        const pBoard = document.createElement("div");
        pBoard.id = "slbAdminQueuePanel_board";
        const boardActs = document.createElement("div");
        boardActs.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;margin:0 0 8px;";
        boardActs.appendChild(mkBtn("Copy Board JSON", () => boardCopyQueueJSON_()));
        boardActs.appendChild(mkBtn("Clear Failed", () => boardClearFailed_()));
        boardActs.appendChild(mkBtn("Clear All Local", () => boardClearAllLocal_()));
        const infoBoard = document.createElement("div");
        infoBoard.id = "slbBoardQueueInfo";
        infoBoard.style.cssText = "font-size:12px;opacity:.85;margin:0 0 10px;";
        const bodyBoard = document.createElement("div");
        bodyBoard.id = "slbBoardQueueBody";
        pBoard.appendChild(boardActs);
        pBoard.appendChild(infoBoard);
        pBoard.appendChild(bodyBoard);

        // Treasury panel
        const pTre = document.createElement("div");
        pTre.id = "slbAdminQueuePanel_treasury";
        const treActs = document.createElement("div");
        treActs.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;margin:0 0 8px;";
        treActs.appendChild(mkBtn("Reload Outbox", () => { try{ treAdmOutboxLoad_(true); }catch(_e){} setTimeout(()=>{ try{ treRenderQueuePanel_(); }catch(_e){} }, 300); }));
        treActs.appendChild(mkBtn("Copy Outbox JSON", () => treCopyQueueJSON_()));
        treActs.appendChild(mkBtn("Copy Ops JSON", () => treCopyOpsQueueJSON_()));
        treActs.appendChild(mkBtn("Clear Ops Failed", () => treClearOpsFailed_()));
        treActs.appendChild(mkBtn("Clear Ops All", () => treClearOpsAll_()));
        const infoTre = document.createElement("div");
        infoTre.id = "slbTreQueueInfo";
        infoTre.style.cssText = "font-size:12px;opacity:.85;margin:0 0 10px;";
        const bodyTre = document.createElement("div");
        bodyTre.id = "slbTreQueueBody";
        pTre.appendChild(treActs);
        pTre.appendChild(infoTre);
        pTre.appendChild(bodyTre);

        panels.appendChild(pBank);
        panels.appendChild(pBoard);
        panels.appendChild(pTre);

        card.appendChild(head);
        card.appendChild(tabBar);
        card.appendChild(panels);
        modal.appendChild(card);
        document.body.appendChild(modal);

        // initial tab
        try{ slbAdminQueueShowTab_(slbAdminQueueTab_()); }catch(_e){}
      }
    }

    function bankOpenQueuePanel_(){
      if(!bankIsAdmin_()) return;
      bankEnsureQueuePanelUI_();
      try{ slbAdminQueueShowTab_("bank"); }catch(_e){}
      const modal = el("slbBankQueueModal");
      if(modal) modal.style.display = "flex";
    }
    function bankCloseQueuePanel_(){
      const modal = el("slbBankQueueModal");
      if(modal) modal.style.display = "none";
    }

    // ============================
    // Admin Panel: Message Board local ops (HARDEN3.2)
    // ============================
    function boardCopyQueueJSON_(){
      try{
        const st = boardState_();
        const payload = { localNotes: st.localNotes || [], hideNoteIds: st.hideNoteIds || [] };
        const txt = JSON.stringify(payload, null, 2);
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(txt).then(()=>toast("ok","Copied."), ()=>toast("bad","Copy failed."));
        }else{
          prompt("Copy JSON:", txt);
        }
      }catch(e){
        toast("bad", e.message||String(e));
      }
    }
    function boardClearFailed_(){
      try{
        const st = boardState_();
        st.localNotes = (Array.isArray(st.localNotes)?st.localNotes:[]).filter(n => String(n.__state||"") !== "failed");
        toast("ok","Cleared failed local notes.");
        try{ slbAdminQueueShowTab_("board"); }catch(_e){}
        try{ boardRefresh_(true); }catch(_e){}
      }catch(e){ toast("bad", e.message||String(e)); }
    }
    function boardClearAllLocal_(){
      if(!confirm("Clear ALL local board items (pending/failed local-only)?")) return;
      try{
        const st = boardState_();
        st.localNotes = [];
        st.hideNoteIds = [];
        toast("ok","Cleared local board state.");
        try{ slbAdminQueueShowTab_("board"); }catch(_e){}
        try{ boardRefresh_(true); }catch(_e){}
      }catch(e){ toast("bad", e.message||String(e)); }
    }

    function boardRenderQueuePanel_(){
      try{
        const st = boardState_();
        const info = el("slbBoardQueueInfo");
        const body = el("slbBoardQueueBody");
        if(!info || !body) return;

        const notes = Array.isArray(st.localNotes) ? st.localNotes : [];
        const pending = notes.filter(n => String(n.__state||"") === "pending");
        const failed = notes.filter(n => String(n.__state||"") === "failed");
        const hidden = Array.isArray(st.hideNoteIds) ? st.hideNoteIds : [];

        info.textContent = `Local board items: ${notes.length} (pending ${pending.length}, failed ${failed.length}) • Hidden ids: ${hidden.length}`;

        if(!notes.length && !hidden.length){
          body.innerHTML = `<div class="note">No local board pending/failed items. (This panel shows local-only unsent / failed posts and hidden ids.)</div>`;
          return;
        }

        const rows = notes.map((n,i)=>{
          const state = String(n.__state||"");
          const line = (n.toLabel ? (String(n.toLabel)+" • ") : "") + (n.createdAt ? String(n.createdAt) : "");
          const snippet = String(n.body||"").slice(0,180);
          const err = n.__error ? String(n.__error) : "";
          return `
            <div style="border:1px solid var(--border,#e2e6ea);border-radius:12px;padding:10px 10px 8px;margin-bottom:10px;">
              <div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;">
                <div>
                  <div style="font-weight:700;">#${i+1} • ${esc(state||"local")}${state==="pending" ? " <span class='pill pending'>SYNC</span>" : (state==="failed" ? " <span class='pill off'>FAILED</span>" : "")}</div>
                  <div class="muted" style="font-size:12px;margin-top:2px;">${esc(line)}</div>
                </div>
                <div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;">
                  <button class="btn soft mini" data-bq-copy="${i}">Copy</button>
                  <button class="btn danger mini" data-bq-remove="${i}">Remove</button>
                </div>
              </div>
              <div style="white-space:pre-wrap;word-break:break-word;margin-top:8px;">${esc(snippet)}${(String(n.body||"").length>180)?"…":""}</div>
              ${err ? `<div class="err" style="margin-top:8px;white-space:pre-wrap;">${esc(err)}</div>` : ``}
            </div>
          `;
        }).join("");

        const hiddenBox = hidden.length ? `
          <div style="border:1px dashed var(--border,#e2e6ea);border-radius:12px;padding:10px;margin-top:12px;">
            <div style="font-weight:700;">Hidden noteIds (optimistic delete)</div>
            <div class="muted" style="font-size:12px;margin-top:4px;">These are temporarily hidden on this device. Refresh/reload may restore if delete failed.</div>
            <div style="margin-top:8px;white-space:pre-wrap;word-break:break-word;font-size:12px;">${esc(JSON.stringify(hidden, null, 2))}</div>
          </div>
        ` : "";

        body.innerHTML = rows + hiddenBox;

        // Wire buttons
        body.querySelectorAll("[data-bq-copy]").forEach(btn=>{
          btn.addEventListener("click", ()=>{
            const idx = parseInt(btn.getAttribute("data-bq-copy")||"-1",10);
            try{
              const st2 = boardState_();
              const n2 = (Array.isArray(st2.localNotes)?st2.localNotes:[])[idx];
              const txt = JSON.stringify(n2 || {}, null, 2);
              if(navigator.clipboard && navigator.clipboard.writeText){
                navigator.clipboard.writeText(txt).then(()=>toast("ok","Copied."), ()=>toast("bad","Copy failed."));
              }else{
                prompt("Copy JSON:", txt);
              }
            }catch(_e){ toast("bad","Copy failed."); }
          });
        });
        body.querySelectorAll("[data-bq-remove]").forEach(btn=>{
          btn.addEventListener("click", ()=>{
            const idx = parseInt(btn.getAttribute("data-bq-copy")||"-1",10);
            if(!(idx>=0)) return;
            if(!confirm("Remove this local item?")) return;
            try{
              const st2 = boardState_();
              st2.localNotes = (Array.isArray(st2.localNotes)?st2.localNotes:[]).filter((_,j)=>j!==idx);
              toast("ok","Removed.");
              boardRenderQueuePanel_();
              try{ boardRefresh_(true); }catch(_e){}
            }catch(e){ toast("bad", e.message||String(e)); }
          });
        });

      }catch(e){
        const info = el("slbBoardQueueInfo");
        const body = el("slbBoardQueueBody");
        if(info) info.textContent = "Error loading board panel.";
        if(body) body.innerHTML = `<div class="err">${esc(e.message||String(e))}</div>`;
      }
    }

    // ============================
    // Admin Panel: Treasury Messages (Outbox) (HARDEN3.2)
    // ============================
    function treCopyQueueJSON_(){
      try{
        const st = treAdmOutboxState_();
        const payload = { outbox: st.items || [] };
        const txt = JSON.stringify(payload, null, 2);
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(txt).then(()=>toast("ok","Copied."), ()=>toast("bad","Copy failed."));
        }else{
          prompt("Copy JSON:", txt);
        }
      }catch(e){ toast("bad", e.message||String(e)); }
    }

    function treCopyOpsQueueJSON_(){
      try{
        treOpsLoad_();
        const payload = { treOps: __treOps || [] };
        const t = JSON.stringify(payload, null, 2);
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(t).then(()=>toast("ok","Copied ops JSON."));
        }else{
          prompt("Copy ops JSON:", t);
        }
      }catch(e){ toast("bad", e.message||String(e)); }
    }

    function treClearOpsFailed_(){
      try{
        treOpsLoad_();
        const before = (__treOps || []).length;
        __treOps = (__treOps || []).filter(op => !(op && op.state === "failed"));
        treOpsSave_();
        const removed = before - (__treOps || []).length;
        toast("ok", removed ? ("Cleared "+removed+" failed op(s).") : "No failed ops.");
        try{ bankUpdateStatusUI_(); }catch(_e){}
        try{ treRenderQueuePanel_(); }catch(_e){}
      }catch(e){ toast("bad", e.message||String(e)); }
    }

    function treClearOpsAll_(){
      try{
        if(!confirm("Clear ALL treasury ops from this device?\n\nThis does not undo server changes.")) return;
        treOpsLoad_();
        __treOps = [];
        treOpsSave_();
        toast("ok","Cleared.");
        try{ bankUpdateStatusUI_(); }catch(_e){}
        try{ treRenderQueuePanel_(); }catch(_e){}
      }catch(e){ toast("bad", e.message||String(e)); }
    }



    function treBindQueuePanelOps_(){
      const body = el("slbTreQueueBody");
      if(!body) return;
      if(body.__treOpsBound) return;
      body.__treOpsBound = true;

      body.addEventListener("click", (e)=>{
        const copyBtn = e.target && e.target.closest && e.target.closest("button[data-treop-copy]");
        const rmBtn = e.target && e.target.closest && e.target.closest("button[data-treop-rm]");

        if(copyBtn){
          const opId = copyBtn.getAttribute("data-treop-copy");
          treOpsLoad_();
          const op = (__treOps || []).find(o => o && String(o.opId||"") === String(opId||""));
          if(!op) return toast("warn","Op not found.");
          const t = JSON.stringify(op, null, 2);
          if(navigator.clipboard && navigator.clipboard.writeText){
            navigator.clipboard.writeText(t).then(()=>toast("ok","Copied."));
          }else{
            prompt("Copy op JSON:", t);
          }
          return;
        }

        if(rmBtn){
          const opId = rmBtn.getAttribute("data-treop-rm");
          if(!confirm("Remove this local treasury op?\n\nThis does not undo server changes.")) return;
          treOpsLoad_();
          __treOps = (__treOps || []).filter(o => !(o && String(o.opId||"") === String(opId||"")));
          treOpsSave_();
          try{ bankUpdateStatusUI_(); }catch(_e){}
          try{ treRenderQueuePanel_(); }catch(_e){}
          toast("ok","Removed.");
          return;
        }
      });
    }

    function treRenderQueuePanel_(){
      try{
        const info = el("slbTreQueueInfo");
        const body = el("slbTreQueueBody");
        if(!info || !body) return;

        treOpsLoad_();
        const treOps = Array.isArray(__treOps) ? __treOps : [];
        const treFailed = treOps.filter(o => o && o.state === "failed").length;
        const trePending = treOps.filter(o => o && o.state !== "failed").length;

        const st = treAdmOutboxState_();
        const items = Array.isArray(st.items) ? st.items : [];

        info.textContent = `Treasury Ops Queue: ${treOps.length} op(s) (${trePending} pending, ${treFailed} failed).  |  Outbox: ${items.length} item(s).`;

        let html = "";

        // Local ops section (retryable)
        if(treOps.length){
          const opsRows = treOps.slice().sort((a,b)=>Number(b.createdAt||0)-Number(a.createdAt||0)).map(op=>{
            const kind = esc(op.kind||"");
            const oid = esc(op.outboxId||"");
            const stt = esc(op.state||"");
            const att = Number(op.attempts||0);
            const err = esc(op.err||"");
            const opId = esc(op.opId||"");
            return `
              <tr>
                <td style="min-width:170px;"><div style="font-weight:700;">${kind}</div><div style="font-size:12px;opacity:.8;">${opId}</div></td>
                <td style="min-width:160px;">${oid}</td>
                <td style="min-width:100px;">${stt}</td>
                <td style="min-width:90px;">${att}</td>
                <td style="min-width:280px;"><div style="font-size:12px;opacity:.85;white-space:pre-wrap;word-break:break-word;">${err}</div></td>
                <td style="min-width:180px;">
                  <button class="btn soft mini" type="button" data-treop-copy="${opId}">Copy</button>
                  <button class="btn danger mini" type="button" data-treop-rm="${opId}">Remove</button>
                </td>
              </tr>
            `;
          }).join("");

          html += `
            <div class="note" style="margin:0 0 8px;">
              Local Treasury Ops (this device). Failed ops require Resync.
            </div>
            <div style="overflow:auto;border:1px solid var(--border,#e2e6ea);border-radius:12px;margin:0 0 14px;">
              <table class="table" style="width:100%;min-width:920px;">
                <thead><tr>
                  <th style="text-align:left;">Op</th>
                  <th style="text-align:left;">OutboxId</th>
                  <th style="text-align:left;">State</th>
                  <th style="text-align:left;">Attempts</th>
                  <th style="text-align:left;">Last error</th>
                  <th style="text-align:left;">Actions</th>
                </tr></thead>
                <tbody>${opsRows}</tbody>
              </table>
            </div>
          `;
        }else{
          html += `<div class="note" style="margin:0 0 14px;">No local treasury ops.</div>`;
        }

        // Outbox section (server list)
        if(!items.length){
          html += `<div class="note">No outbox items loaded. Press “Reload Outbox” (or open Admin → Treasury Outbox and press Reload).</div>`;
          body.innerHTML = html;
          // bind actions
          treBindQueuePanelOps_();
          return;
        }

        const head = `
          <div class="note" style="margin:0 0 8px;">Treasury Outbox (server list, not a local queue)</div>
          <div style="overflow:auto;border:1px solid var(--border,#e2e6ea);border-radius:12px;">
            <table class="table" style="width:100%;min-width:820px;">
              <thead>
                <tr>
                  <th style="text-align:left;">Title</th>
                  <th style="text-align:left;">Targets</th>
                  <th style="text-align:left;">Created</th>
                  <th style="text-align:left;">Deleted</th>
                </tr>
              </thead>
              <tbody>
        `;

        const rows = items.slice().sort((a,b)=>String(b.createdAt||"").localeCompare(String(a.createdAt||""))).map(it=>{
          return `
            <tr>
              <td style="min-width:260px;">
                <div style="font-weight:700;">${esc(it.title||"")}</div>
                <div style="font-size:12px;opacity:.8;">${esc(String(it.outboxId||""))}</div>
              </td>
              <td style="min-width:240px;">${esc(treTargetLabel_(it))}</td>
              <td style="min-width:140px;">${esc(fmtShortDate_(it.createdAt||""))}</td>
              <td style="min-width:140px;">${it.deletedAt ? esc(fmtShortDate_(it.deletedAt||"")) : "—"}</td>
            </tr>
          `;
        }).join("");

        html += head + rows + `</tbody></table></div>`;
        body.innerHTML = html;

        treBindQueuePanelOps_();
      }catch(_e){}
    }


    function bankCopyQueueJSON_(){
      try{
        bankLoad_();
        const payload = JSON.stringify(__bankOps || [], null, 2);
        navigator.clipboard.writeText(payload).then(()=> toast("ok","Queue copied."), ()=> toast("err","Copy failed."));
      }catch(e){
        toast("err", e && e.message ? e.message : "Copy failed.");
      }
    }

    function bankClearQueueFailed_(){
      try{
        bankLoad_();
        const before = (__bankOps||[]).length;
        __bankOps = (__bankOps||[]).filter(op => !(op && op.state === "failed"));
        bankSave_();
        bankUpdateStatusUI_();
        bankRenderQueuePanel_();
        toast("ok", "Cleared failed: " + (before - (__bankOps||[]).length));
      }catch(e){
        toast("err", e && e.message ? e.message : "Clear failed.");
      }
    }

    function bankClearQueueAll_(){
      try{
        if(!confirm("Clear ALL queued bank ops for this user on this device?")) return;
        bankLoad_();
        __bankOps = [];
        bankSave_();
        bankUpdateStatusUI_();
        bankRenderQueuePanel_();
        toast("ok", "Queue cleared.");
      }catch(e){
        toast("err", e && e.message ? e.message : "Clear failed.");
      }
    }

    function bankFmtOpLine_(op){
      try{
        const kind = op.kind || "unknown";
        const amt = (typeof op.amount !== "undefined") ? (" $" + money(op.amount)) : "";
        let who = "";
        if(kind === "giftSend") who = " → " + (op.toCallsign||"");
        if(kind === "transfer") who = " (" + (op.fromAccountId||"") + " → " + (op.toAccountId||"") + ")";
        if(kind === "createAccount") who = " (" + (op.name||"") + ")";
        if(kind === "renameAccount") who = " (" + (op.accountId||"") + " → " + (op.newName||"") + ")";
        return kind + amt + who;
      }catch(_e){
        return String(op && op.kind || "op");
      }
    }

    function bankRenderQueuePanel_(){
      if(!bankIsAdmin_()) return;
      const info = el("slbBankQueueInfo");
      const body = el("slbBankQueueBody");
      if(!body) return;

      const cs = String(S.callsign || sessionStorage.getItem("tyw_callsign") || "").trim().toUpperCase();
      const k = bankKey_();
      const ops = (__bankOps || []).filter(Boolean);
      const pending = ops.filter(o => o && o.state !== "failed").length;
      const failed = ops.filter(o => o && o.state === "failed").length;

      if(info){
        info.textContent = "User: " + (cs||"") + " | Key: " + k + " | Total: " + ops.length + " | Pending: " + pending + " | Failed: " + failed;
      }

      body.innerHTML = "";
      if(!ops.length){
        const empty = document.createElement("div");
        empty.style.cssText = "padding:10px;border:1px dashed #ddd;border-radius:12px;opacity:.85;";
        empty.textContent = "Queue is empty.";
        body.appendChild(empty);
        return;
      }

      const table = document.createElement("table");
      table.style.cssText = "width:100%;border-collapse:separate;border-spacing:0 8px;font-size:13px;";

      ops.forEach((op, idx) => {
        const row = document.createElement("tr");

        const left = document.createElement("td");
        left.style.cssText = "background:#f7f7f7;border:1px solid #e5e5e5;border-right:none;border-radius:12px 0 0 12px;padding:10px;vertical-align:top;width:52%;";
        const line = document.createElement("div");
        line.style.cssText = "font-weight:700;margin-bottom:4px;";
        line.textContent = (idx+1) + ". " + bankFmtOpLine_(op);
        const meta = document.createElement("div");
        meta.style.cssText = "opacity:.85;font-size:12px;";
        meta.textContent = "opId: " + (op.opId||"") + " | state: " + (op.state||"pending") + " | attempts: " + (op.attempts||0);
        left.appendChild(line);
        left.appendChild(meta);

        if(op && op.lastError){
          const err = document.createElement("div");
          err.style.cssText = "margin-top:6px;color:#b00020;font-size:12px;white-space:pre-wrap;";
          err.textContent = String(op.lastError);
          left.appendChild(err);
        }

        const right = document.createElement("td");
        right.style.cssText = "background:#fff;border:1px solid #e5e5e5;border-left:none;border-radius:0 12px 12px 0;padding:10px;vertical-align:top;";

        const pre = document.createElement("pre");
        pre.style.cssText = "margin:0;white-space:pre-wrap;word-break:break-word;font-size:12px;line-height:1.25;max-height:170px;overflow:auto;";
        try{ pre.textContent = JSON.stringify(op || {}, null, 2); }catch(_e){ pre.textContent = String(op||""); }

        const btnRow = document.createElement("div");
        btnRow.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;margin-top:8px;";

        const b1 = document.createElement("button");
        b1.className = "btn soft mini";
        b1.textContent = "Copy Op";
        b1.addEventListener("click", () => {
          try{
            navigator.clipboard.writeText(JSON.stringify(op||{}, null, 2)).then(()=> toast("ok","Op copied."), ()=> toast("err","Copy failed."));
          }catch(e){ toast("err","Copy failed."); }
        });

        const b2 = document.createElement("button");
        b2.className = "btn soft mini";
        b2.textContent = "Remove";
        b2.addEventListener("click", () => {
          try{
            if(!confirm("Remove this op from local queue? This will NOT run it.")) return;
            bankLoad_();
            __bankOps = (__bankOps||[]).filter(x => x && x.opId !== op.opId);
            bankSave_();
            bankUpdateStatusUI_();
            bankRenderQueuePanel_();
            toast("ok","Removed.");
          }catch(e){ toast("err","Remove failed."); }
        });

        btnRow.appendChild(b1);
        btnRow.appendChild(b2);

        right.appendChild(pre);
        right.appendChild(btnRow);

        row.appendChild(left);
        row.appendChild(right);
        table.appendChild(row);
      });

      body.appendChild(table);
    }

    function bankUpdateStatusUI_(){
      bankEnsureResyncUI_();
      bankEnsureQueuePanelUI_();
      const btn = el("slbBankResyncBtn");

      bankLoad_();
      treOpsLoad_();

      const bankOps = (__bankOps || []).filter(Boolean);
      const treOps  = (__treOps  || []).filter(Boolean);

      const bankFailed = bankOps.filter(o => o && o.state === "failed").length;
      const bankPending = bankOps.filter(o => o && o.state !== "failed").length;

      const treFailed = treOps.filter(o => o && o.state === "failed").length;
      const trePending = treOps.filter(o => o && o.state !== "failed").length;

      const totalOps = bankOps.length + treOps.length;
      const failedTotal = bankFailed + treFailed;
      const pendingTotal = bankPending + trePending;

      if(!totalOps){
        if(btn){
          btn.style.display = "none";
          btn.disabled = false;
          btn.setAttribute("aria-disabled", "false");
        }
        try{ setText("tywStatus", "Ready"); }catch(_e){}
        try{ bankAutoSyncStop_(); }catch(_e){}
        return;
      }

      // HARDEN3: keep auto-sync running while there are pending ops (Bank + Treasury)
      try{
        if(pendingTotal > 0) bankAutoSyncStart_();
        else bankAutoSyncStop_();
      }catch(_e){}

      if(failedTotal > 0){
        const firstFailed = bankOps.concat(treOps).find(o => o && o.state === "failed");
        const reason = firstFailed ? String(firstFailed.err || firstFailed.lastError || "").trim() : "";
        const summary = pendingTotal
          ? ("Not synced ("+failedTotal+" failed, syncing "+pendingTotal+")")
          : ("Not synced ("+failedTotal+" failed)");
        try{
          setText("tywStatus", summary);
          const st = el("tywStatus");
          if(st) st.title = reason || "A saved action needs a safe retry.";
        }catch(_e){}
        if(btn){
          btn.style.display = "inline-flex";
          btn.disabled = false;
          btn.setAttribute("aria-disabled", "false");
          btn.title = reason ? ("Retry safely. Last error: " + reason) : "Retry failed actions safely.";
        }
      }else{
        try{
          setText("tywStatus", pendingTotal ? ("Syncing ("+pendingTotal+")") : "Ready");
          const st = el("tywStatus");
          if(st) st.removeAttribute("title");
        }catch(_e){}
        if(btn) btn.style.display = "none";
      }
    }


    // ====== HARDEN3: unified optimistic sync loop for Bank ops ======
    let __bankAutoTimer = null;
    const __bankAutoEveryMs = 3500;

    function bankAutoSyncStart_(){
      if(__bankAutoTimer) return;
      __bankAutoTimer = setInterval(() => {
        try{ bankAutoSyncTick_(); }catch(_e){}
      }, __bankAutoEveryMs);
      try{ bankAutoSyncTick_(); }catch(_e){}
    }

    function bankAutoSyncStop_(){
      if(__bankAutoTimer){
        clearInterval(__bankAutoTimer);
        __bankAutoTimer = null;
      }
    }

    function bankAutoSyncTick_(){
      bankLoad_();
      treOpsLoad_();

      const hasAny = bankHasOps_() || treOpsHasAny_();
      if(!hasAny){
        bankAutoSyncStop_();
        return;
      }

      const now = Date.now();

      // Bank: auto-sync non-failed ops. Failed ops wait for user to click Resync.
      const bankPending = (__bankOps || []).filter(op =>
        op && op.opId && op.state !== "failed" && !__bankInflight[op.opId] && (Number(op.nextTryAt || 0) <= now)
      );

      if(bankPending.length){
        bankPending.slice(0, 3).forEach(op => {
          try{ bankSyncOp_(op); }catch(_e){}
        });
      }

      // Treasury: auto-sync non-failed ops (admin-only queue). Failed ops wait for Resync.
      const trePending = (__treOps || []).filter(op =>
        op && op.opId && op.state !== "failed" && !__treInflight[op.opId] && (Number(op.nextTryAt || 0) <= now)
      );

      if(trePending.length){
        trePending.slice(0, 1).forEach(op => {
          try{ treOpsSyncOp_(op); }catch(_e){}
        });
      }
    }
    // ====== /HARDEN3 ======


    function bankInitForUser_(){
      bankLoad_();
      bankUpdateStatusUI_();

      // Background retry on load (idempotent via requestId=opId)
      if(bankHasOps_()){
        setTimeout(() => {
          (__bankOps || []).forEach(op => {
            if(op && !__bankInflight[op.opId]) bankSyncOp_(op);
          });
        }, 80);
      }
    }

    function bankSetBaseFromDash_(dash){
      if(!dash) return;
      try{
        S._bankBase = {
          totals: dash.totals ? {...dash.totals} : { totalStones: 0, walletStones: 0 },
          accounts: Array.isArray(dash.accounts) ? dash.accounts.map(a => ({...a})) : []
        };
      }catch(_e){}
    }

    function bankBase_(){
      if(S._bankBase && Array.isArray(S._bankBase.accounts)) return S._bankBase;
      return { totals: (S.dash && S.dash.totals) ? {...S.dash.totals} : { totalStones: 0, walletStones: 0 },
               accounts: (S.dash && Array.isArray(S.dash.accounts)) ? S.dash.accounts.map(a => ({...a})) : [] };
    }

    function bankBuildView_(dash){
      const base = bankBase_();
      const totals = base.totals ? {...base.totals} : { totalStones: 0, walletStones: 0 };
      const accounts = Array.isArray(base.accounts) ? base.accounts.map(a => ({...a})) : [];

      const byId = Object.create(null);
      accounts.forEach(a => { if(a && a.accountId) byId[a.accountId] = a; });

      const wallet = accounts.find(isOnHand) || null;

      const pendingTxns = [];
      const ops = __bankOps || [];
      for(const op of ops){
        if(!op || !op.kind) continue;
        const st = (op.state === "failed") ? "failed" : "pending";

        if(op.kind === "createAccount"){
          const tmpId = op.tmpAccountId;
          if(tmpId && !byId[tmpId]){
            const a = { accountId: tmpId, name: op.name || "New Pouch", balance: 0, kind: "POUCH", status: "ACTIVE", __state: st };
            accounts.push(a);
            byId[tmpId] = a;
          }else if(tmpId && byId[tmpId]){
            byId[tmpId].name = op.name || byId[tmpId].name;
            byId[tmpId].__state = st;
          }
          continue;
        }

        if(op.kind === "renameAccount"){
          const a = byId[op.accountId];
          if(a){
            a.name = op.newName || a.name;
            a.__state = st;
          }
          continue;
        }

        if(op.kind === "transfer"){
          const amt = Number(op.amount);
          if(Number.isFinite(amt)){
            const aFrom = byId[op.fromAccountId];
            const aTo = byId[op.toAccountId];
            if(aFrom) aFrom.balance = Number(aFrom.balance || 0) - amt;
            if(aTo) aTo.balance = Number(aTo.balance || 0) + amt;

            // walletStones mirrors wallet balance
            if(wallet && wallet.accountId){
              if(op.fromAccountId === wallet.accountId) totals.walletStones = Number(totals.walletStones || 0) - amt;
              if(op.toAccountId === wallet.accountId) totals.walletStones = Number(totals.walletStones || 0) + amt;
            }
          }

          pendingTxns.push({
            time: op.time || (new Date(op.createdAt || Date.now()).toISOString().slice(0,19).replace("T"," ")),
            type: op.mode === "withdraw" ? "Withdraw" : "Deposit",
            from: op.fromAccountId,
            to: op.toAccountId,
            amount: Number(op.amount || 0),
            note: op.note || "",
            txnId: "",
            __state: st,
            __bankOpId: op.opId
          });
          continue;
        }

        if(op.kind === "giftSend"){
          const amt = Number(op.amount);
          if(Number.isFinite(amt)){
            const aFrom = byId[op.fromPouchId];
            if(aFrom) aFrom.balance = Number(aFrom.balance || 0) - amt;
            totals.totalStones = Number(totals.totalStones || 0) - amt;
          }
          pendingTxns.push({
            time: op.time || (new Date(op.createdAt || Date.now()).toISOString().slice(0,19).replace("T"," ")),
            type: "GIFT_SENT",
            from: op.fromPouchId,
            to: "CS:" + String(op.toCallsign || "").toUpperCase(),
            amount: Number(op.amount || 0),
            note: op.note || "",
            txnId: "",
            __state: st,
            __bankOpId: op.opId
          });
          continue;
        }
      }

      // merge txns: base txns from current dash (without prior injected pending)
      const baseTxns = (dash && Array.isArray(dash.txns)) ? dash.txns.filter(t => t && !t.__bankOpId) : [];
      const txns = baseTxns.concat(pendingTxns);

      return { totals, accounts, txns };
    }

    function bankApplyViewToDash_(dash, opts){
      if(!dash) return;
      if(opts && opts.updateBase === false){
        // do not touch base snapshot
      }
      const view = bankBuildView_(dash);
      dash.totals = view.totals;
      dash.accounts = view.accounts;
      dash.txns = view.txns;
      bankUpdateStatusUI_();
    }

    function bankRenderNow_(){
      if(!S.dash) return;
      // Apply view without changing base snapshot
      bankApplyViewToDash_(S.dash, { updateBase:false });

      // Update visible totals (bank page shows these)
      try{ setText("tywTotal", money(S.dash.totals.totalStones)); }catch(_e){}
      try{ setText("tywWallet", money(S.dash.totals.walletStones)); }catch(_e){}
      try{ setText("tywWallet2", money(S.dash.totals.walletStones)); }catch(_e){}

      try{ renderAllSelects(); }catch(_e){}
      try{ renderAccounts(); }catch(_e){}
      try{ renderTxnsSelf(); }catch(_e){}
    }

    function bankNewId_(){
      return "bop_" + Date.now() + "_" + Math.random().toString(16).slice(2);
    }

    function bankQueueTransfer_(p){
      bankLoad_();
      const op = {
        opId: bankNewId_(),
        kind: "transfer",
        fromAccountId: String(p.fromAccountId || ""),
        toAccountId: String(p.toAccountId || ""),
        amount: Number(p.amount || 0),
        note: String(p.note || ""),
        mode: (p.mode === "withdraw") ? "withdraw" : "deposit",
        createdAt: Date.now(),
        time: (new Date()).toISOString().slice(0,19).replace("T"," "),
        state: "pending"
      };
      __bankOps.push(op);
      bankSave_();
      bankUpdateStatusUI_();
      return op;
    }

    function bankQueueGift_(p){
      bankLoad_();
      const op = {
        opId: bankNewId_(),
        kind: "giftSend",
        fromPouchId: String(p.fromPouchId || ""),
        toCallsign: String(p.toCallsign || "").trim().toUpperCase(),
        amount: Number(p.amount || 0),
        note: String(p.note || ""),
        createdAt: Date.now(),
        time: (new Date()).toISOString().slice(0,19).replace("T"," "),
        state: "pending"
      };
      __bankOps.push(op);
      bankSave_();
      bankUpdateStatusUI_();
      return op;
    }

    function bankQueueCreateAccount_(p){
      bankLoad_();
      const op = {
        opId: bankNewId_(),
        kind: "createAccount",
        tmpAccountId: "tmp_" + Date.now().toString(16) + "_" + Math.random().toString(16).slice(2),
        name: String(p.name || "").trim(),
        sortOrder: Number(p.sortOrder || 10),
        createdAt: Date.now(),
        time: (new Date()).toISOString().slice(0,19).replace("T"," "),
        state: "pending"
      };
      __bankOps.push(op);
      bankSave_();
      bankUpdateStatusUI_();
      return op;
    }

    function bankQueueRename_(p){
      bankLoad_();
      const op = {
        opId: bankNewId_(),
        kind: "renameAccount",
        accountId: String(p.accountId || ""),
        newName: String(p.newName || "").trim(),
        createdAt: Date.now(),
        time: (new Date()).toISOString().slice(0,19).replace("T"," "),
        state: "pending"
      };
      __bankOps.push(op);
      bankSave_();
      bankUpdateStatusUI_();
      return op;
    }

    function bankRemoveOp_(opId){
      bankLoad_();
      __bankOps = (__bankOps || []).filter(o => o && o.opId !== opId);
      bankSave_();
      bankUpdateStatusUI_();
    }

    function bankMarkFailed_(opId, err){
      bankLoad_();
      const op = (__bankOps || []).find(o => o && o.opId === opId);
      if(op){
        op.state = "failed";
        op.err = String(err || "");
        op.attempts = Number(op.attempts || 0) + 1;

        // HARDEN3: exponential backoff for auto-retry (failed ops require manual Resync)
        const base = 1200; // ms
        const cap  = 15000; // ms
        const pow  = Math.min(6, Math.max(0, op.attempts - 1));
        const wait = Math.min(cap, Math.round(base * Math.pow(2, pow)));
        op.nextTryAt = Date.now() + wait;

        bankSave_();
      }
      bankUpdateStatusUI_();
    }

    function bankShouldRollback_(msg){
      const m = String(msg || "");
      if(/insufficient|not enough|balance|invalid|forbidden|denied|cannot|can't|must|required|out of stock|sold out|no stock|insufficient stock|not enough stock/i.test(m)) return true;
      return false;
    }


    function bankOpMsgMap_(op){
      if(!op) return null;
      if(op.kind === "transfer"){
        if(op.mode === "withdraw") return { ok:"tywWitOk", err:"tywWitMsg", label:"Withdraw" };
        return { ok:"tywDepOk", err:"tywDepMsg", label:"Deposit" };
      }
      if(op.kind === "giftSend") return { ok:"tywGiftOk", err:"tywGiftMsg", label:"Gift" };
      if(op.kind === "createAccount") return { ok:"tywCreateAcctOk", err:"tywCreateAcctMsg", label:"Cosmic pouch" };
      return null;
    }

    function bankFlashOkDone_(op, finalText){
      const m = bankOpMsgMap_(op);
      if(!m || !m.ok) return;
      const node = el(m.ok);
      if(!node) return;
      const cur = String(node.textContent||"");
      const hasSyncText = /syncing|queued/i.test(cur);
      const isHidden = node.classList.contains("hidden");
      if(isHidden && !hasSyncText) return; // don't pop up messages from background sync
      setMsg(node, String(finalText||"Done."), true);
      setTimeout(() => { try{ clearMsg(node); }catch(_e){} }, 2200);
    }

    function bankMarkPanelFailed_(op){
      const m = bankOpMsgMap_(op);
      if(!m || !m.ok) return;
      const node = el(m.ok);
      if(!node) return;
      const cur = String(node.textContent||"");
      const hasSyncText = /syncing|queued/i.test(cur);
      const isHidden = node.classList.contains("hidden");
      if(isHidden && !hasSyncText) return;
      const reason = String(op && op.err || "").trim();
      const suffix = reason ? (" Last error: " + reason) : "";
      setMsg(node, (m.label || "Action") + " response was not confirmed." + suffix + " Check the balances or transaction history, then use the visible Resync Now button.", false);
    }

    function bankClearQueuedMsg_(op){
      const m = bankOpMsgMap_(op);
      if(!m || !m.ok) return;
      const node = el(m.ok);
      if(!node) return;
      const cur = String(node.textContent||"");
      if(/syncing|queued/i.test(cur)) clearMsg(node);
    }

    async function bankSyncOp_(op){
      if(!op || !op.opId) return;
      if(__bankInflight[op.opId]) return;
      __bankInflight[op.opId] = 1;

      try{
        if(op.kind === "transfer"){
          await rpc("transfer", { fromAccountId: op.fromAccountId, toAccountId: op.toAccountId, amount: op.amount, note: op.note }, { requestId: op.opId, timeoutMs: 90000 });
        }else if(op.kind === "giftSend"){
          await rpc("giftSend", { fromPouchId: op.fromPouchId, toCallsign: op.toCallsign, amount: op.amount, note: op.note }, { requestId: op.opId, timeoutMs: 90000 });
        }else if(op.kind === "createAccount"){
          await rpc("createAccount", { name: op.name, sortOrder: op.sortOrder }, { requestId: op.opId, timeoutMs: 90000 });
        }else if(op.kind === "renameAccount"){
          await rpc("renameAccount", { accountId: op.accountId, newName: op.newName }, { requestId: op.opId, timeoutMs: 90000 });
        }else{
          // unknown
          bankRemoveOp_(op.opId);
          return;
        }

        // Success: remove + reconcile from backend
        bankRemoveOp_(op.opId);
        try{
          if(op.kind === "transfer"){
            bankFlashOkDone_(op, (op.mode === "withdraw") ? "Withdraw completed." : "Deposit completed.");
          }else if(op.kind === "giftSend"){
            bankFlashOkDone_(op, "Gift sent.");
          }else if(op.kind === "createAccount"){
            bankFlashOkDone_(op, "Cosmic pouch created.");
          }
        }catch(_e){}
        bgSyncBalancesAndTxns_();
      }catch(e){
        const msg = e && e.message ? e.message : String(e);
        if(bankShouldRollback_(msg)){
          bankRemoveOp_(op.opId);
          bankRenderNow_();
          try{ bankClearQueuedMsg_(op); }catch(_e){}
          toast("err", msg);
        }else{
          bankMarkFailed_(op.opId, msg);
          bankRenderNow_();
          try{ bankMarkPanelFailed_(op); }catch(_e){}
        }
      }finally{
        delete __bankInflight[op.opId];
      }
    }

    function bankResyncAll_(){
      bankLoad_();
      const failed = (__bankOps || []).filter(o => o && o.state === "failed");
      if(!failed.length){
        toast("ok","Nothing to resync.");
        bankUpdateStatusUI_();
        return;
      }
      failed.forEach(op => { op.state = "pending"; delete op.err; op.nextTryAt = 0; });
      bankSave_();
      bankUpdateStatusUI_();
      bankRenderNow_();
      failed.forEach(op => bankSyncOp_(op));
      toast("ok","Resync started.");
    }

    // HARDEN3.3: Resync all optimistic queues (Bank + Treasury)
    function slbResyncAll_(){
      let did = 0;
      try{
        bankLoad_();
        const failedBank = (__bankOps || []).filter(o => o && o.state === "failed").length;
        if(failedBank) { bankResyncAll_(); did += failedBank; }
      }catch(_e){}
      try{
        const n = treOpsResyncAll_();
        if(n) did += n;
      }catch(_e){}
      if(!did){
        toast("ok","Nothing to resync.");
      }else{
        toast("ok","Resync started.");
      }
      try{ bankUpdateStatusUI_(); }catch(_e){}
      try{ treRenderQueuePanel_(); }catch(_e){}
    }






    
    // 3M Received: show a big pop-up on next login if the user has a new gift (unseen in this browser).
    let __m3GiftPopupChecked = false;

    function m3ParseTs_(v){
      try{
        if(v == null) return 0;
        if(typeof v === "number" && Number.isFinite(v)) return v;
        const s = String(v).trim();
        if(!s) return 0;
        if(/^[0-9]{10,13}$/.test(s)) return Number(s);
        const t = Date.parse(s);
        return Number.isFinite(t) ? t : 0;
      }catch(_e){ return 0; }
    }

    function m3InjectGiftPopupCss_(){
      if(document.getElementById("slbM3GiftPopupCss")) return;
      const css = `#slbM3GiftPopup{ position:fixed; inset:0; background:rgba(0,0,0,.55); display:flex; align-items:center; justify-content:center; padding:14px; z-index:999999; }
#slbM3GiftPopup .card{ width:min(640px,100%); background:var(--slb-panel,#fff); color:var(--slb-text,#0f1517); border-radius:18px; border:1px solid rgba(15,21,23,.20); box-shadow:0 10px 24px rgba(0,0,0,.25); overflow:hidden; }
#slbM3GiftPopup .head{ display:flex; align-items:center; justify-content:space-between; gap:10px; padding:12px 14px; border-bottom:1px solid rgba(15,21,23,.12); background: var(--ty-grey-ui, rgba(15,21,23,.10)); font-weight:1000; }
#slbM3GiftPopup .body{ padding:12px 14px; }
#slbM3GiftPopup .title{ font-size:22px; font-weight:1100; margin:0 0 8px; }
#slbM3GiftPopup .line{ font-size:15px; font-weight:900; margin:6px 0; }
#slbM3GiftPopup .actions{ display:flex; gap:10px; justify-content:flex-end; margin-top:12px; flex-wrap:wrap; }
#slbM3GiftPopup .hint{ display:block; margin-top:8px; font-size:13px; font-weight:900; color: rgba(15,21,23,.72); }

/* Buttons (override global) */
#slbM3GiftPopup .slbBtn{  padding:10px 14px;  border-radius:14px;  border:1px solid rgba(15,21,23,.18);  background:rgba(15,21,23,.06);  color:var(--slb-text,#0f1517);  font-weight:900;  cursor:pointer;  box-shadow:none;}#slbM3GiftPopup .slbBtn:hover{  border-color:rgba(239,94,20,.45);  background:rgba(239,94,20,.10);}#slbM3GiftPopup .slbBtnOrange{  background:var(--ty-orange,#ef5e14);  color:#fff;  border-color:rgba(239,94,20,.60);}#slbM3GiftPopup .slbBtnOrange:hover{  filter:brightness(1.02);  box-shadow:0 10px 18px rgba(239,94,20,.18);}
/* Dark mode */
:root[data-slb-theme="dark"] #slbM3GiftPopup .card{  background:var(--slb-panel,#0f1517);  color:var(--slb-text,#e8eef2);  border-color:rgba(255,255,255,.14);}:root[data-slb-theme="dark"] #slbM3GiftPopup .head{  background:var(--slb-panel-2,#151c20);  border-bottom-color:rgba(255,255,255,.10);}:root[data-slb-theme="dark"] #slbM3GiftPopup .hint{ color:var(--slb-muted,#aab6c0); }:root[data-slb-theme="dark"] #slbM3GiftPopup .slbBtn{  border-color:rgba(255,255,255,.12);  background:rgba(255,255,255,.06);  color:var(--slb-text,#e8eef2);}:root[data-slb-theme="dark"] #slbM3GiftPopup .slbBtn:hover{  border-color:rgba(239,94,20,.55);  background:rgba(239,94,20,.14);}`;
      const st = document.createElement("style");
      st.id = "slbM3GiftPopupCss";
      st.textContent = css;
      document.head.appendChild(st);
    }

    function m3CloseGiftPopup_(){
      try{ const elx = document.getElementById("slbM3GiftPopup"); if(elx) elx.remove(); }catch(_e){}
    }

    function m3OpenM3Tab_(){
      // Try click menu item first (works with lazy-loader).
      try{
        const tabBtn = document.querySelector('[data-tab="m3Received"]');
        if(tabBtn) tabBtn.click();
      }catch(_e){}
      // Fallback: set hash deep link.
      try{ window.location.hash = "#tab=myCabin&cabin=m3Received"; }catch(_e){}
      try{ if(window.SLB_route && window.SLB_route.applyFromHash) window.SLB_route.applyFromHash(); }catch(_e){}
      try{
        setTimeout(() => {
          try{
            const p = document.getElementById("slbCabinM3Received") || document.getElementById("slbMagic3MReceive");
            if(p && p.scrollIntoView) p.scrollIntoView({ behavior:"smooth", block:"start" });
          }catch(_e){}
        }, 800);
      }catch(_e){}
    }

    function m3ShowGiftPopup_(rec, newestTs, seenKey){
      try{
        m3InjectGiftPopupCss_();
        m3CloseGiftPopup_();

        const from = String(rec.fromCallsign || rec.from || "").trim();
        const food = String(rec.foodName || "Celestial Food").trim();
        const sp = String(rec.spValue == null ? "" : rec.spValue).trim();
        const when = newestTs ? (new Date(newestTs)).toLocaleString() : "";

        const wrap = document.createElement("div");
        wrap.id = "slbM3GiftPopup";
        wrap.innerHTML = `
          <div class="card" role="dialog" aria-modal="true">
            <div class="head">
              <div>Celestial Kitchen Received</div>
              <button class="slbBtn" type="button" data-x="1">Close</button>
            </div>
            <div class="body">
              <div class="title">You received magical food!</div>
              ${from ? `<div class="line">From: ${escapeHtml(from)}</div>` : ``}
              ${food ? `<div class="line">Food: ${escapeHtml(food)}</div>` : ``}
              ${sp ? `<div class="line">Stored Spirit Power: ${escapeHtml(sp)} SP</div>` : ``}
              ${when ? `<div class="line">Time: ${escapeHtml(when)}</div>` : ``}
              <span class="hint">This pop-up shows only once per new gift on this device.</span>
              <div class="actions">
                <button class="slbBtn" type="button" data-later="1">Later</button>
                <button class="slbBtn slbBtnOrange" type="button" data-open="1">Open Celestial Kitchen Receive</button>
              </div>
            </div>
          </div>
        `;
        wrap.onclick = (e) => {
          const t = e && e.target ? e.target : null;
          if(t && t.getAttribute){
            if(t.getAttribute("data-x")==="1" || t.getAttribute("data-later")==="1"){
              try{ localStorage.setItem(seenKey, String(newestTs)); }catch(_e){}
              m3CloseGiftPopup_();
              return;
            }
            if(t.getAttribute("data-open")==="1"){
              try{ localStorage.setItem(seenKey, String(newestTs)); }catch(_e){}
              m3CloseGiftPopup_();
              m3OpenM3Tab_();
              return;
            }
          }
          if(t === wrap){
            try{ localStorage.setItem(seenKey, String(newestTs)); }catch(_e){}
            m3CloseGiftPopup_();
          }
        };
        document.body.appendChild(wrap);

        // Also show toast (in case user closes pop-up quickly).
        try{ toast("ok", "You received Celestial Kitchen food."); }catch(_e){}
      }catch(_e){}
    }

    async function m3CheckGiftPopup_(){
      if(__m3GiftPopupChecked) return;
      __m3GiftPopupChecked = true;
      try{
        if(!S || !S.token) return;
        const cs = String(S.callsign || "").trim().toUpperCase();
        if(!cs) return;

        const seenKey = "slb_m3_seen_" + cs;
        const lastSeen = Number(localStorage.getItem(seenKey) || 0) || 0;

        const r = await rpc("magic3mReceiveList", {});
        const data = (r && r.records) ? r : ((r && r.result) ? r.result : r) || {};
        const records = Array.isArray(data.incoming) ? data.incoming.filter(function(x){ return String(x.status||"").toUpperCase()==="SENT"; }) : [];
        if(!records.length) return;

        let newestTs = 0;
        let newestRec = null;
        for(let i=0;i<records.length;i++){
          const rec = records[i] || {};
          const ts = m3ParseTs_(rec.createdAt || rec.created_at || rec.ts || rec.time);
          if(ts > newestTs){ newestTs = ts; newestRec = rec; }
        }
        if(!newestRec || !newestTs) return;
        if(newestTs <= lastSeen) return;

        m3ShowGiftPopup_(newestRec, newestTs, seenKey);
      }catch(_e){}
    }

function initialPanelFromHash_(){
      try{
        var raw=String(location.hash||'').replace(/^#/,'').trim();if(!raw)return '';
        var tab='';
        if(raw.indexOf('=')>=0){
          try{var params=new URLSearchParams(raw);tab=String(params.get('tab')||params.get('panel')||'').trim();}catch(_eParams){}
        }
        if(!tab)tab=String(raw.split(/[\/?&]/)[0]||'').trim();
        if(/^admin(?:$|[-_])/i.test(tab))tab='admin';
        if(tab==='home'||tab==='main')tab='myCabin';
        var found='';(root||document).querySelectorAll('[data-panel]').forEach(function(panel){if(!found&&String(panel.getAttribute('data-panel')||'')===tab)found=tab;});
        return found;
      }catch(_e){return '';}
    }

function showApp(){
      // FastBoot/background auth can call showApp more than once.
      // Do not reset an already-open admin panel back to Overview during the second hydration pass.
      let activeTab = "";
      let wasVisible = false;
      try{
        wasVisible = !!(appWrap && !appWrap.classList.contains("hidden"));
        const active = (root||document).querySelector('[data-panel]:not(.hidden)');
        if(active) activeTab = String(active.getAttribute('data-panel')||'');
      }catch(_e0){}

      if(loginCard){
        loginCard.classList.add("hidden");
        loginCard.setAttribute("aria-hidden", "true");
      }

      // Select the URL panel while the application shell is still hidden. This prevents
      // My Cabin from painting for a moment before a direct #myAltarTest route is applied.
      var firstRouteTab="";
      try{if(!wasVisible)firstRouteTab=initialPanelFromHash_();}catch(_eRouteTab){}
      try{
        if(firstRouteTab)setPanel(firstRouteTab);
        else if(wasVisible&&activeTab)setPanel(activeTab);
        else setPanel("myCabin");
      }catch(_ePreselect){}

      if(appWrap){
        appWrap.classList.remove("hidden");
        appWrap.setAttribute("aria-hidden", "false");
      }

      // Apply the complete route after the correct top-level panel is already selected.
      try{
        const h = String(location.hash || "").trim();
        const hasRoute = !!(h && h !== "#" && !/^#(?:(?:overview|myCabin)|tab=(?:overview|myCabin))(?:$|[&?])/i.test(h));
        if(hasRoute && window.SLB_route && window.SLB_route.applyFromHash){
          window.SLB_route.applyFromHash();
        }else if(wasVisible && activeTab){
          setPanel(activeTab);
        }else if(firstRouteTab){
          setPanel(firstRouteTab);
        }else{
          setPanel("myCabin");
        }
      }catch(_e1){
        try{ setPanel((wasVisible && activeTab) ? activeTab : (firstRouteTab||"myCabin")); }catch(_e2){}
      }
      try{ maybeAutoHelp(); }catch(_e){}
      // 3M pop-up: check once per login (non-blocking)
      try{ setTimeout(() => { try{ m3CheckGiftPopup_(); }catch(_e){} }, 800); }catch(_e){}
      try{
        window.dispatchEvent(new CustomEvent("slb:auth-ready", { detail:{
          token:String((S && S.token)||""),
          callsign:String((S && S.callsign)||"").trim().toUpperCase(),
          displayName:String((S && S.displayName)||"")
        }}));
      }catch(_e){}
    }
    function showLogin(){
      if(loginCard){
        loginCard.classList.add("hidden");
        loginCard.setAttribute("aria-hidden", "true");
      }
      if(appWrap){
        appWrap.classList.add("hidden");
        appWrap.setAttribute("aria-hidden", "true");
      }
      try{ window.dispatchEvent(new CustomEvent("slb:login-required")); }catch(_e){}
    }

    // User: Change / reset PIN
    onOnce("tywPinChangeBtn","click", async () => {
      const msg = el("tywPinChangeMsg");
      const ok = el("tywPinChangeOk");
      clearMsg(msg); clearMsg(ok);

      const cur = cleanPin((el("tywPinCur") && el("tywPinCur").value) ? el("tywPinCur").value : "");
      const n1  = cleanPin((el("tywPinNew") && el("tywPinNew").value) ? el("tywPinNew").value : "");
      const n2  = cleanPin((el("tywPinNew2") && el("tywPinNew2").value) ? el("tywPinNew2").value : "");

      if(cur.length !== 4) return setMsg(msg, "Current PIN must be 4 digits.", false);
      if(n1.length !== 4) return setMsg(msg, "New PIN must be 4 digits.", false);
      if(n1 !== n2) return setMsg(msg, "New PIN confirmation does not match.", false);
      if(cur === n1) return setMsg(msg, "New PIN must be different.", false);

      try{
        setBusy(true);
        await rpc("changePin", { currentPin: cur, newPin: n1 });
        setMsg(ok, "PIN changed. Next login use your new PIN.", true);
        try{ el("tywPinCur").value = ""; el("tywPinNew").value = ""; el("tywPinNew2").value = ""; }catch(_e){}
      }catch(e){
        setMsg(msg, (e && e.message) ? e.message : String(e), false);
      }finally{
        setBusy(false);
      }
    });

    onOnce("tywPinResetReqBtn","click", async () => {
      const msg = el("tywPinChangeMsg");
      const ok = el("tywPinChangeOk");
      clearMsg(msg); clearMsg(ok);
      try{
        setBusy(true);
        await rpc("pinResetRequest", { note: "" });
        setMsg(ok, "Request sent. Contact the court admin to finish the reset.", true);
      }catch(e){
        setMsg(msg, (e && e.message) ? e.message : String(e), false);
      }finally{ setBusy(false); }
    });

    // User: Email Notifications (opt-in)
    let __notifyPrefsCache = null;

    async function loadNotifyPrefs_(){
      try{
        // IMPORTANT: do NOT use cache-first for notify prefs.
        // Users can change opt-in/email anytime; cache-first can show stale OFF/blank.
        const r = await rpc("notifyPrefsGet", {}, { noCacheFirst: 1 });
        const p = (r && r.prefs) ? r.prefs : {};
        __notifyPrefsCache = p || {};

        if(el("slbNotifyEmail")) el("slbNotifyEmail").value = p.email || "";

        // Set hidden checkboxes + trigger change so Plan C button UI syncs immediately.
        const pairs = [
          ["slbNotifyOptIn",     "optIn"],
          ["slbNotifySticky",   "sticky"],
          ["slbNotifyMarket",   "market"],
          ["slbNotifyTemple",   "temple"],
          ["slbNotifyTreasury", "treasury"],
          ["slbNotifyTransfers", "transfers"],
          ["slbNotifyWeekly",   "weeklyExport"]
        ];
        for(let i=0;i<pairs.length;i++){
          const id = pairs[i][0];
          const key = pairs[i][1];
          const cb = el(id);
          if(!cb) continue;
          cb.checked = !!p[key];
          try{ cb.dispatchEvent(new Event('change', { bubbles:true })); }catch(_e){}
        }

        try{ clearMsg(el("slbNotifyMsg")); clearMsg(el("slbNotifyOk")); }catch(_e){}
      }catch(e){
        toast("err", (e && e.message) ? e.message : String(e));
      }
    }

    /* Expose loader for panel switch hooks (Plan C User UI). */
    try{ window.SLB_loadNotifyPrefs = loadNotifyPrefs_; }catch(_e){}
    try{ setTimeout(()=>{ try{ loadNotifyPrefs_(); }catch(_e){} }, 50); }catch(_e){}

    // FIX58: Auto-enable opt-in when any notification flag is turned on
    function _notifyAutoOptIn_(){
      try{
        const opt = el("slbNotifyOptIn");
        if(!opt) return;
        const ids = ["slbNotifySticky","slbNotifyMarket","slbNotifyTemple","slbNotifyTreasury","slbNotifyTransfers","slbNotifyWeekly"];
        for(let i=0;i<ids.length;i++){
          const cb = el(ids[i]);
          if(!cb) continue;
          cb.addEventListener("change", () => {
            try{ if(cb.checked) opt.checked = true; }catch(_e){}
          });
        }
      }catch(_e){}
    }
    try{ _notifyAutoOptIn_(); }catch(_e){}

    onOnce("slbNotifySaveBtn","click", async () => {
      const msg = el("slbNotifyMsg");
      const ok = el("slbNotifyOk");
      clearMsg(msg); clearMsg(ok);

      const email = (el("slbNotifyEmail") && el("slbNotifyEmail").value) ? String(el("slbNotifyEmail").value).trim() : "";
      const optIn = !!(el("slbNotifyOptIn") && el("slbNotifyOptIn").checked);

      const sticky    = !!(el("slbNotifySticky") && el("slbNotifySticky").checked);
      const market    = !!(el("slbNotifyMarket") && el("slbNotifyMarket").checked);
      const temple    = !!(el("slbNotifyTemple") && el("slbNotifyTemple").checked);
      const treasury  = !!(el("slbNotifyTreasury") && el("slbNotifyTreasury").checked);
      const transfers = !!(el("slbNotifyTransfers") && el("slbNotifyTransfers").checked);
      const weeklyExport = !!(el("slbNotifyWeekly") && el("slbNotifyWeekly").checked);

      const prev = __notifyPrefsCache || {};
      const shouldTest = optIn && email && ( !prev.optIn || String(prev.email||"").trim() !== email );

      try{
        setBusy(true);
        const out = await rpc("notifyPrefsSet", {
          email, optIn, sticky, market, temple, treasury, transfers,
          weeklyExport,
          sendTest: shouldTest ? 1 : 0
        });

        __notifyPrefsCache = (out && out.prefs) ? out.prefs : __notifyPrefsCache;
        setMsg(ok, shouldTest ? "Saved. Test email sent." : "Saved.", true);
      }catch(e){
        setMsg(msg, (e && e.message) ? e.message : String(e), false);
      }finally{
        setBusy(false);
      }
    });

    onOnce("slbNotifyTestBtn","click", async () => {
      const msg = el("slbNotifyMsg");
      const ok = el("slbNotifyOk");
      clearMsg(msg); clearMsg(ok);

      try{
        setBusy(true);
        await rpc("notifySendTest", {});
        setMsg(ok, "Test email sent.", true);
      }catch(e){
        setMsg(msg, (e && e.message) ? e.message : String(e), false);
      }finally{
        setBusy(false);
      }
    });

    // Deposit
    onOnce("tywDepBtn","click", async (ev) => {
      clearMsg(el("tywDepMsg")); clearMsg(el("tywDepOk"));
      const btn = (ev && ev.currentTarget) ? ev.currentTarget : el("tywDepBtn");
      const unlock = lockBtn(btn);
      try{
        const depPanel = (ev && ev.currentTarget && ev.currentTarget.closest) ? ev.currentTarget.closest('[data-panel="deposit"]') : null;
        const fromSel = depPanel ? (depPanel.querySelector('#tywDepFrom') || depPanel.querySelector('[data-role="dep-from"]')) : el("tywDepFrom");
        const toSel   = depPanel ? (depPanel.querySelector('#tywDepTo')   || depPanel.querySelector('[data-role="dep-to"]'))   : el("tywDepTo");
        const from = String((fromSel && fromSel.value) || "").trim();
        const to   = String((toSel   && toSel.value)   || "").trim();
        const amt  = Number(String(el("tywDepAmt") ? el("tywDepAmt").value : "").trim());
        const note = String(el("tywDepNote") ? el("tywDepNote").value : "").trim();

        if(!from || !to) throw new Error("Pick accounts.");
        if(!Number.isFinite(amt) || amt <= 0) throw new Error("Enter amount.");

        const op = bankQueueTransfer_({ fromAccountId: from, toAccountId: to, amount: amt, note, mode: "deposit" });
        bankRenderNow_();

        if(el("tywDepAmt")) el("tywDepAmt").value = "";
        if(el("tywDepNote")) el("tywDepNote").value = "";

        setMsg(el("tywDepOk"), "Deposit queued (syncing…).", true);
        bankSyncOp_(op);
      }catch(e){
        setMsg(el("tywDepMsg"), e.message || String(e), false);
      }finally{
        unlock();
      }
    });

    // Withdraw
    onOnce("tywWitBtn","click", async (ev) => {
      clearMsg(el("tywWitMsg")); clearMsg(el("tywWitOk"));
      const btn = (ev && ev.currentTarget) ? ev.currentTarget : el("tywWitBtn");
      const unlock = lockBtn(btn);
      try{
        const witPanel = (ev && ev.currentTarget && ev.currentTarget.closest) ? ev.currentTarget.closest('[data-panel="withdraw"]') : null;
        const fromSel = witPanel ? (witPanel.querySelector('#tywWitFrom') || witPanel.querySelector('[data-role="wit-from"]')) : el("tywWitFrom");
        const toSel   = witPanel ? (witPanel.querySelector('#tywWitTo')   || witPanel.querySelector('[data-role="wit-to"]'))   : el("tywWitTo");
        const from = String((fromSel && fromSel.value) || "").trim();
        const to   = String((toSel   && toSel.value)   || "").trim();
        const amt  = Number(String(el("tywWitAmt") ? el("tywWitAmt").value : "").trim());
        const note = String(el("tywWitNote") ? el("tywWitNote").value : "").trim();

        if(!from || !to) throw new Error("Pick accounts.");
        if(!Number.isFinite(amt) || amt <= 0) throw new Error("Enter amount.");

        const op = bankQueueTransfer_({ fromAccountId: from, toAccountId: to, amount: amt, note, mode: "withdraw" });
        bankRenderNow_();

        if(el("tywWitAmt")) el("tywWitAmt").value = "";
        if(el("tywWitNote")) el("tywWitNote").value = "";

        setMsg(el("tywWitOk"), "Withdraw queued (syncing…).", true);
        bankSyncOp_(op);
      }catch(e){
        setMsg(el("tywWitMsg"), e.message || String(e), false);
      }finally{
        unlock();
      }
    });

    // Gift
    let __giftLock = false;
    onOnce("tywGiftBtn","click", async (ev) => {
      clearMsg(el("tywGiftMsg")); clearMsg(el("tywGiftOk"));
      if(__giftLock) return;
      __giftLock = true;
      const btn = (ev && ev.currentTarget) ? ev.currentTarget : el("tywGiftBtn");
      const unlock = lockBtn(btn);
      try{
        const giftPanel = (ev && ev.currentTarget && ev.currentTarget.closest) ? ev.currentTarget.closest('[data-panel="gift"]') : null;
        const fromSel = giftPanel ? (giftPanel.querySelector('#tywGiftFrom') || giftPanel.querySelector('[data-role="gift-from"]')) : el("tywGiftFrom");
        const fromPouchId = String((fromSel && fromSel.value) || "").trim();
        const toCallsign = String(el("tywGiftTo") ? el("tywGiftTo").value : "").trim().toUpperCase();
        const amt = Number(String(el("tywGiftAmt") ? el("tywGiftAmt").value : "").trim());
        const note = String(el("tywGiftNote") ? el("tywGiftNote").value : "").trim();

        if(!fromPouchId) throw new Error("Pick a pouch.");
        if(!toCallsign) throw new Error("Enter receiver callsign.");
        if(!Number.isFinite(amt) || amt <= 0) throw new Error("Enter amount.");

        const op = bankQueueGift_({ fromPouchId, toCallsign, amount: amt, note });
        bankRenderNow_();

        if(el("tywGiftAmt")) el("tywGiftAmt").value = "";
        if(el("tywGiftNote")) el("tywGiftNote").value = "";

        setMsg(el("tywGiftOk"), "Gift queued (syncing…).", true);
        bankSyncOp_(op);
      }catch(e){
        setMsg(el("tywGiftMsg"), e.message || String(e), false);
      }finally{
        unlock();
        __giftLock = false;
      }
    });

    /*__CNY_RP_INJECT__*/


    // CNY Red Packet (Gift)
    (function(){
      const PHRASES = [
        ["恭喜發財","Gung Hei Faat Choy","Congrats, wealth is being given out!"],
        ["大吉大利","Daai Gut Daai Lei","Big luck, big benefit, smooth wins."],
        ["萬事勝意","Maan Si Sing Yee","Everything goes better than expected."],
        ["心想事成","Sum Sheung Si Sing","What you wish for, you can make it happen."],
        ["福星高照","Fuk Sing Go Jiu","Blessing star shines from above."],
        ["出入平安","Chut Yup Ping On","Safe when you go out, safe when you come back."],
        ["財源廣進","Choy Yuen Gwong Jun","Wealth comes from all directions."],
        ["時來運轉","Si Loy Wun Juen","When the time arrives, luck turns immediately."],
        ["金玉滿堂","Gum Yuk Moon Tong","House full of Gold and Jade."],
        ["横財就手","Waang Choy Jau Sau","Side wealth comes right into your hand."],
        ["花開富貴","Fa Hoi Foo Gwai","Wealth blooms and gives fruits and results."],
        ["官運亨通","Goon Wun Hung Tung","Smooth career luck and promotion luck."],
        ["馬到功成","Ma Doe Gung Sing","Quick success. Fast results."],
        ["大展鴻圖","Daai Jeen Hung Toe","Expand big. Build big. Achieve big goals."],
        ["前程錦繡","Chin Ching Gum Sau","A bright future with beautiful results ahead."],
        ["學業進步","Hork Yeep Jun Bo","Study luck, learning luck, progress."],
        ["龍馬精神","Lung Ma Jing Sun","Dragon + Horse energy: strong drive."],
        ["笑口常開","Siu Hau Seung Hoi","Keep joyful moments coming all the time."],
        ["和合順心","Woh Hup Shun Sum","Harmony and alignment with the heart."],
        ["貴人扶持","Gwai Yun Fu Chi","Helpful people and forces support you."],
        ["神采飛揚","Sun Choy Fei Yeung","God light lifts you up, makes you glow."],
        ["身壯力健","Sun Jong Lik Geen","Strong body, strong energy, strong health."],
        ["安枕無憂","On Jum Mo Yau","Sleep settled, no worries. Rest well."],
        ["穩如泰山","Wun Yue Taai Saan","Stable like a mountain."],
        ["正氣常存","Jing Hei Sheung Chuen","Upright Chi stays strong."],
        ["壽與天齊","Sau Yu Tin Chai","Longevity, steady and lasting."],
        ["神功顯赫","Sun Gung Heen Haak","May your magic-skill show strong and clear."],
        ["法力無邊","Faat Lik Mo Been","May your Magic Power be unlimited."],
      ];

      const rootId = "slbCnyRp";
      const cssId = "slbCnyRpCss";
      const lsKey = "slb_cny_rp_sel_v1";

      function esc(s){
        return String(s||"")
          .replace(/&/g,"&amp;")
          .replace(/</g,"&lt;")
          .replace(/>/g,"&gt;")
          .replace(/"/g,"&quot;")
          .replace(/'/g,"&#39;");
      }

      function ensureCss(){
        if(document.getElementById(cssId)) return;
        const st = document.createElement("style");
        st.id = cssId;
        st.textContent = `
#${rootId}{position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,.45);display:flex;align-items:flex-start;justify-content:center;padding:28px 14px;}
#${rootId} .card{width:min(860px,96vw);background:#fff;border:1px solid rgba(0,0,0,.12);border-radius:14px;box-shadow:0 14px 40px rgba(0,0,0,.22);overflow:hidden;}
#${rootId} .head{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:12px 14px;border-bottom:1px solid rgba(0,0,0,.08);}
#${rootId} .title{font-weight:1000;}
#${rootId} .x{border:0;background:transparent;font-size:22px;line-height:1;cursor:pointer;padding:4px 8px;opacity:.75;}
#${rootId} .x:hover{opacity:1;}
#${rootId} .body{padding:12px 14px;max-height:68vh;overflow:auto;}
#${rootId} .hint{color:rgba(15,21,23,.65);font-size:12px;margin:0 0 10px;}
#${rootId} .list{display:flex;flex-direction:column;gap:8px;}
#${rootId} label.it{display:grid;grid-template-columns:18px 1fr;gap:10px;align-items:start;padding:10px 10px;border:1px solid rgba(0,0,0,.10);border-radius:12px;cursor:pointer;}
#${rootId} label.it:hover{border-color:rgba(239,94,20,.40);}
#${rootId} .cn{font-weight:1000;margin-right:8px;}
#${rootId} .py{color:rgba(15,21,23,.72);margin-right:8px;}
#${rootId} .en{color:rgba(15,21,23,.60);}
#${rootId} .bar{display:flex;justify-content:flex-end;gap:8px;padding:12px 14px;border-top:1px solid rgba(0,0,0,.08);background:rgba(0,0,0,.02);}
#${rootId} .btn{border:1px solid rgba(0,0,0,.14);background:#fff;color:#0f1517;border-radius:10px;padding:8px 12px;cursor:pointer;font-weight:900;}
#${rootId} .btn.primary{background:#ef5e14;border-color:#ef5e14;color:#fff;}
#${rootId} .btn:active{transform:translateY(1px);}
`;
        document.head.appendChild(st);
      }

      function close(){
        const elr = document.getElementById(rootId);
        if(elr) elr.remove();
      }

      function getSaved(){
        try{
          const a = JSON.parse(localStorage.getItem(lsKey)||"[]");
          if(Array.isArray(a)) return new Set(a.map(x=>Number(x)).filter(x=>Number.isFinite(x)));
        }catch(_e){}
        return new Set();
      }

      function saveFrom(root){
        try{
          const idxs = Array.from(root.querySelectorAll("input[type=checkbox][data-i]:checked"))
            .map(cb=>Number(cb.getAttribute("data-i")))
            .filter(x=>Number.isFinite(x));
          localStorage.setItem(lsKey, JSON.stringify(idxs));
        }catch(_e){}
      }

      function applyToNote(root){
        const cbs = root.querySelectorAll("input[type=checkbox][data-i]:checked");
        const chosenCn = [];
        cbs.forEach(cb=>{
          const i = Number(cb.getAttribute("data-i"));
          if(Number.isFinite(i) && PHRASES[i]) chosenCn.push(PHRASES[i][0]);
        });
        saveFrom(root);
        if(!chosenCn.length){ close(); return; }
        const noteEl = el("tywGiftNote");
        if(noteEl){
          let v = String(noteEl.value||"").trim();
          chosenCn.forEach(cn=>{
            if(!v.includes(cn)) v = v ? (v + " " + cn) : cn;
          });
          noteEl.value = v.trim();
          try{ noteEl.focus(); }catch(_e){}
        }
        close();
      }

      function open(){
        ensureCss();
        close();
        const saved = getSaved();
        const items = PHRASES.map((p,i)=>{
          const checked = saved.has(i) ? "checked" : "";
          return `<label class="it"><input type="checkbox" data-i="${i}" ${checked}/><div><span class="cn">${esc(p[0])}</span><span class="py">${esc(p[1])}</span><span class="en">${esc(p[2])}</span></div></label>`;
        }).join("");

        const wrap = document.createElement("div");
        wrap.id = rootId;
        wrap.innerHTML = `
          <div class="card" role="dialog" aria-modal="true">
            <div class="head">
              <div class="title">CNY Red Packet Blessing Phrases</div>
              <button class="x" type="button" data-x>×</button>
            </div>
            <div class="body">
              <div class="hint">Pick one or more lines, then Apply. (We add the Chinese phrases into NOTE.)</div>
              <div class="list">${items}</div>
            </div>
            <div class="bar">
              <button class="btn" type="button" data-clear>Clear</button>
              <button class="btn primary" type="button" data-apply>Apply</button>
            </div>
          </div>
        `;

        wrap.addEventListener("click", (e)=>{
          const t = e.target;
          if(t === wrap){ close(); return; }
          if(t && t.getAttribute && t.getAttribute("data-x")!=null){ close(); return; }
          if(t && t.getAttribute && t.getAttribute("data-clear")!=null){
            wrap.querySelectorAll("input[type=checkbox]").forEach(cb=>cb.checked=false);
            try{ localStorage.setItem(lsKey, "[]"); }catch(_e){}
            return;
          }
          if(t && t.getAttribute && t.getAttribute("data-apply")!=null){ applyToNote(wrap); return; }
        });

        document.addEventListener("keydown", function _cnyEsc(e){
          if(!document.getElementById(rootId)) { document.removeEventListener("keydown", _cnyEsc); return; }
          if(e && e.key === "Escape") close();
        });

        document.body.appendChild(wrap);
      }

      function bind(){
        const btn = el("tywGiftCnyBtn");
        if(!btn) return false;
        if(btn.dataset && btn.dataset.cnyBound) return true;
        if(btn.dataset) btn.dataset.cnyBound = "1";
        btn.addEventListener("click", open);
        return true;
      }

      try{ bind(); }catch(_e){}
      setTimeout(()=>{ try{ bind(); }catch(_e){} }, 1200);
    })();


// Create account
    onOnce("tywCreateAcctBtn","click", async (ev) => {
      clearMsg(el("tywCreateAcctMsg")); clearMsg(el("tywCreateAcctOk"));
      const btn = (ev && ev.currentTarget) ? ev.currentTarget : el("tywCreateAcctBtn");
      const unlock = lockBtn(btn);
      try{
        const name = String(el("tywNewAcctName").value || "").trim();
        const sortOrder = 10;
        if(!name) throw new Error("Name required.");
        try{ ensureMaxLen("Cosmic Pouch name", name, LIMITS.acctName); }catch(e){ throw e; }

        const op = bankQueueCreateAccount_({ name, sortOrder });
        bankRenderNow_();

        setMsg(el("tywCreateAcctOk"), "Cosmic pouch created (syncing…).", true);
        el("tywNewAcctName").value = "";

        bankSyncOp_(op);
      }catch(e){
        setMsg(el("tywCreateAcctMsg"), e.message || String(e), false);
      }finally{
        unlock();
      }
    });
    // ====== Cultivations (Record) ======
    const CULT = {
      types:[], records:[], summaries:[], loaded:false, loading:false, usersLoaded:false,
      archiveOverride:{}, authoritative:false, source:"", backendSummaryVersion:0,
      zeroStateConfirmed:false, lastLoadedAt:0, _loadPromise:null
    };
    const CULT_CACHE_KEY = "cultPackV3";

    function cultCurrentCallsign_(){
      let cs = "";
      try{ cs = String((S && S.callsign) ? S.callsign : "").trim().toUpperCase(); }catch(_e0){}
      if(!cs){ try{ cs = String(sessionStorage.getItem("tyw_callsign")||"").trim().toUpperCase(); }catch(_e1){} }
      return cs;
    }

    function cultCacheRead_(){
      try{
        const pack = slbCacheGet_(CULT_CACHE_KEY, 14*24*60*60*1000);
        const C = window.SLB_CULT_CONTRACT;
        if(!C || !C.validateCachePackage) return null;
        const checked = C.validateCachePackage(pack, cultCurrentCallsign_());
        if(!checked.ok) return null;
        return Object.assign({}, pack, { summaries:checked.summaries });
      }catch(_e){ return null; }
    }

    function cultCacheWrite_(meta){
      try{
        meta = meta || {};
        const C = window.SLB_CULT_CONTRACT;
        const cs = cultCurrentCallsign_();
        if(!C || !cs || CULT.authoritative !== true) return false;
        const checked = C.validateSummaries(CULT.summaries, {allowEmpty:true});
        if(!checked.ok) return false;
        const pack = {
          cacheSchema:C.cacheSchema,
          callsign:cs,
          authoritative:true,
          backendSummaryVersion:Number(CULT.backendSummaryVersion||C.summaryVersion),
          savedAt:Date.now(),
          source:String(meta.source||CULT.source||"SUMMARY"),
          zeroStateConfirmed:CULT.zeroStateConfirmed === true,
          types:CULT.types || [],
          records:(CULT.records||[]).filter(r=>!cultIsTmpId_(r.logId) && !String(r.__state||"")),
          summaries:checked.summaries,
          fullHistory:!!CULT.fullHistoryLoaded
        };
        const validPack = C.validateCachePackage(pack, cs);
        if(!validPack.ok) return false;
        slbCacheSet_(CULT_CACHE_KEY, pack);
        return true;
      }catch(_e){ return false; }
    }

    function cultArchiveKey_(){
      const cs = String((S && S.callsign) ? S.callsign : (sessionStorage.getItem("tyw_callsign")||""))
        .trim().toUpperCase() || "unknown";
      return "slb_cult_archive_override_v3_" + cs;
    }
    function cultLoadArchiveOverride_(){
      try{ CULT.archiveOverride = JSON.parse(localStorage.getItem(cultArchiveKey_())||"{}") || {}; }
      catch(_e){ CULT.archiveOverride = {}; }
      if(!CULT.archiveOverride || typeof CULT.archiveOverride !== "object") CULT.archiveOverride = {};
    }
    function cultSaveArchiveOverride_(){
      try{ localStorage.setItem(cultArchiveKey_(), JSON.stringify(CULT.archiveOverride||{})); }catch(_e){}
    }
    function cultSetArchiveOverride_(typeKey, val){
      const tk = String(typeKey||"").trim();
      if(!tk) return;
      CULT.archiveOverride = CULT.archiveOverride || {};
      if(val) CULT.archiveOverride[tk] = 1;
      else delete CULT.archiveOverride[tk];
      cultSaveArchiveOverride_();
    }
    function cultIsArchivedSummary_(s){
      if(!s) return false;
      // Trust server first; then derive "archived" from completion so all devices match.
      if(s.archived) return true;
      if(s.archivedAt) return true;
      const doneRaw = Number(s.doneDays||0) || 0;
      const targetTotal = Number(s.targetTotal||s.targetBase||108) || 108;
      if(targetTotal > 0 && doneRaw >= targetTotal) return true;
      return false;
    }

    function cultCsvCell_(v){
      const s = String(v == null ? "" : v);
      if(/[\n\r,\"]/g.test(s)) return '"' + s.replace(/\"/g,'""') + '"';
      return s;
    }
    function cultBuildCsvClient_(){
      const cs = String((S && S.callsign) ? S.callsign : "").trim().toUpperCase();
      const date = new Date().toISOString();
      const build = String((S && S.backendBuild) ? S.backendBuild : (el('slbBuild') ? el('slbBuild').textContent : "")) || "";

      const lines = [];
      lines.push("SECTION,A,B,C,D,E,F,G,H,I,J,K");
      lines.push(["CULT_META","exportedAt",cultCsvCell_(date),"callsign",cultCsvCell_(cs),"build",cultCsvCell_(build),"","","","",""].join(","));

      // SUMMARY
      lines.push(["CULT_SUMMARY","typeKey","displayName","doneDays","targetTotal","targetBase","penaltyDays","status","lastDoneDateISO","archived","archivedAt","hasToday"].join(","));
      (CULT.summaries||[]).forEach(s=>{
        lines.push([
          "CULT_SUMMARY",
          cultCsvCell_(s.typeKey||""),
          cultCsvCell_(s.displayName||s.typeLabel||s.typeKey||""),
          cultCsvCell_(String(s.doneDays||0)),
          cultCsvCell_(String(s.targetTotal||s.targetBase||108)),
          cultCsvCell_(String(s.targetBase||108)),
          cultCsvCell_(String(s.penaltyDays||0)),
          cultCsvCell_(s.status||""),
          cultCsvCell_(s.lastDoneDateISO||""),
          cultCsvCell_(cultIsArchivedSummary_(s) ? "1" : "0"),
          cultCsvCell_(s.archivedAt||""),
          cultCsvCell_(s.hasToday ? "1" : "0")
        ].join(","));
      });

      // LOGS (raw)
      lines.push(["CULT_LOG","logId","createdAt","callsign","dateISO","typeKey","typeLabel","note","proofUrl","deleted","",""].join(","));
      (CULT.records||[]).forEach(r=>{
        lines.push([
          "CULT_LOG",
          cultCsvCell_(r.logId||""),
          cultCsvCell_(r.createdAt||""),
          cultCsvCell_(cs),
          cultCsvCell_(r.dateISO||""),
          cultCsvCell_(r.typeKey||""),
          cultCsvCell_(r.typeLabel||r.typeKey||""),
          cultCsvCell_(r.note||""),
          cultCsvCell_(r.proofUrl||""),
          cultCsvCell_(String(r.deleted||0)),
          "",""
        ].join(","));
      });

      // TARGETS + ADJUST + EVENTS as schema headers only (so admin can still import even if backend export isn't available)
      lines.push(["CULT_TARGETS","callsign","typeKey","targetDays","updatedAt","note","archived","archivedAt","deleted","","",""].join(","));
      lines.push(["CULT_ADJUST","callsign","typeKey","typeLabel","baseDoneDays","baseLastDateISO","note","updatedAt","deleted","","",""].join(","));
      lines.push(["CULT_EVENTS","eventId","createdAt","callsign","typeKey","kind","missedDays","fromDateISO","toDateISO","note","deleted",""].join(","));

      return lines.join("\n");
    }

    function todayISO(){
      const d = new Date();
      const y = d.getFullYear();
      const m = String(d.getMonth()+1).padStart(2,"0");
      const da = String(d.getDate()).padStart(2,"0");
      return y + "-" + m + "-" + da;
    }
    // ===== Cultivations: Optimistic UI (instant UI, backend sync after, with rollback/retry) =====
    function cultMakeReqId_(prefix){
      try{ CULT._opSeq = (CULT._opSeq||0) + 1; }catch(_e){}
      return (prefix||"c") + "_" + Date.now() + "_" + Math.random().toString(16).slice(2) + "_" + (CULT._opSeq||0);
    }

    function cultIsRetryableErr_(e){
      const msg = String((e && (e.message||e)) || "").toLowerCase();
      if(!msg) return false;
      if(msg.indexOf("timeout") >= 0) return true;
      if(msg.indexOf("script load failed") >= 0) return true;
      if(msg.indexOf("failed to fetch") >= 0) return true;
      if(msg.indexOf("network") >= 0) return true;
      if(msg.indexOf("offline") >= 0) return true;
      return false;
    }

    function cultSendWithRetry_(action, args, opts){
      const requestId = (opts && opts.requestId) ? String(opts.requestId) : cultMakeReqId_("op");
      const maxAttempts = (opts && opts.maxAttempts) ? Number(opts.maxAttempts) : 3;
      const baseDelay = (opts && opts.baseDelayMs) ? Number(opts.baseDelayMs) : 600;
      let attempt = 0;
      const doTry = () => {
        attempt++;
        return rpc(action, args, { requestId }).catch(err => {
          if(attempt < maxAttempts && cultIsRetryableErr_(err)){
            const d = baseDelay * Math.pow(2, attempt-1) + Math.floor(Math.random()*250);
            return new Promise(res => setTimeout(res, d)).then(doTry);
          }
          throw err;
        });
      };
      return doTry();
    }

    function cultIsTmpId_(id){ return /^tmp_/i.test(String(id||"")); }
    function cultTmpId_(){ return "tmp_" + Date.now() + "_" + Math.random().toString(16).slice(2); }

    function cultClientTz_(){
      try{ return Intl.DateTimeFormat().resolvedOptions().timeZone || ""; }catch(_e){ return ""; }
    }
    function cultTzPayload_(){
      let off = 0;
      try{ off = new Date().getTimezoneOffset(); }catch(_e){ off = 0; }
      return { timezone: cultClientTz_(), tzOffsetMinutes: off, clientLocalNow: new Date().toISOString() };
    }
    function cultTodayInfoText_(){
      const tz = cultClientTz_() || "your device timezone";
      return "Ready for " + todayISO() + " (" + tz + ").";
    }
    function renderTodayInfo_(){
      const n = el("slbCultTodayInfo");
      if(!n) return;
      const q = cultOutboxRead_();
      const pending = q.filter(x=>String(x.state||"pending") !== "done").length;
      n.textContent = cultTodayInfoText_() + (pending ? (" " + pending + " waiting to sync.") : " All saved taps will be retried if connection is slow.");
    }

    function cultOutboxKey_(){
      const cs = String((S && S.callsign) ? S.callsign : (sessionStorage.getItem("tyw_callsign")||""))
        .trim().toUpperCase() || "ANON";
      return "slb_cult_outbox_v4_" + cs;
    }
    function cultOutboxRead_(){
      try{
        const arr = JSON.parse(localStorage.getItem(cultOutboxKey_()) || "[]");
        return Array.isArray(arr) ? arr : [];
      }catch(_e){ return []; }
    }
    function cultOutboxWrite_(arr){
      try{ localStorage.setItem(cultOutboxKey_(), JSON.stringify((Array.isArray(arr)?arr:[]).slice(-80))); }catch(_e){}
      try{ renderTodayInfo_(); }catch(_e){}
    }
    function cultOutboxUpsert_(rec){
      if(!rec) return;
      const reqId = String(rec.__reqId || cultMakeReqId_("cultAdd"));
      rec.__reqId = reqId;
      const item = {
        reqId,
        tmpId: String(rec.logId || cultTmpId_()),
        dateISO: String(rec.dateISO||""),
        typeKey: String(rec.typeKey||""),
        typeLabel: String(rec.typeLabel||""),
        note: String(rec.note||""),
        proofUrl: String(rec.proofUrl||""),
        createdAt: String(rec.createdAt || new Date().toISOString()),
        state: String(rec.__state || "pending"),
        lastError: String(rec.__lastError || "")
      };
      if(!item.dateISO || !item.typeKey) return;
      const arr = cultOutboxRead_().filter(x=>String(x.reqId||"") !== reqId && String(x.tmpId||"") !== item.tmpId);
      arr.push(item);
      cultOutboxWrite_(arr);
    }
    function cultOutboxRemove_(recOrReq){
      const req = typeof recOrReq === "string" ? recOrReq : String((recOrReq && (recOrReq.__reqId || recOrReq.reqId || recOrReq.logId)) || "");
      const tmp = typeof recOrReq === "object" ? String(recOrReq.tmpId || recOrReq.logId || "") : "";
      if(!req && !tmp) return;
      cultOutboxWrite_(cultOutboxRead_().filter(x=>String(x.reqId||"") !== req && String(x.tmpId||"") !== tmp));
    }
    function cultOutboxMark_(rec, state, err){
      if(!rec) return;
      const req = String(rec.__reqId || rec.reqId || "");
      const tmp = String(rec.logId || rec.tmpId || "");
      const arr = cultOutboxRead_();
      let changed = false;
      arr.forEach(x=>{
        if((req && String(x.reqId||"")===req) || (tmp && String(x.tmpId||"")===tmp)){
          x.state = String(state||"pending");
          x.lastError = String(err||"");
          changed = true;
        }
      });
      if(changed) cultOutboxWrite_(arr);
    }
    function cultRecordExists_(dateISO, typeKey){
      const k = String(dateISO||"") + "|" + String(typeKey||"");
      return buildRecordMap_().has(k);
    }
    function cultHydrateOutbox_(){
      const arr = cultOutboxRead_();
      if(!arr.length){ renderTodayInfo_(); return; }
      let changed = false;
      const kept = [];
      arr.forEach(item=>{
        const dateISO = String(item.dateISO||"");
        const typeKey = String(item.typeKey||"");
        if(!dateISO || !typeKey) return;
        // If the backend/cache already contains this exact day/type, the queued write is no longer needed.
        const exists = (CULT.records||[]).some(r=> String(r.dateISO||"")===dateISO && String(r.typeKey||"")===typeKey && !cultIsTmpId_(r.logId));
        if(exists){ changed = true; return; }
        let rec = (CULT.records||[]).find(r=> String(r.__reqId||"")===String(item.reqId||"") || String(r.logId||"")===String(item.tmpId||""));
        const hadSameLocal = (CULT.records||[]).some(r=> String(r.dateISO||"")===dateISO && String(r.typeKey||"")===typeKey);
        if(!rec){
          rec = {
            logId: String(item.tmpId || cultTmpId_()),
            createdAt: String(item.createdAt || new Date().toISOString()),
            dateISO,
            typeKey,
            typeLabel: String(item.typeLabel || typeDisplayName_(typeKey)),
            note: String(item.note||""),
            proofUrl: String(item.proofUrl||""),
            __state: String(item.state||"pending") === "failed" ? "failed" : "pending",
            __reqId: String(item.reqId || cultMakeReqId_("cultAdd")),
            __lastError: String(item.lastError||"")
          };
          CULT.records = (CULT.records||[]).concat([rec]);
          if(!hadSameLocal){
            const sum = cultEnsureSummary_(typeKey, rec.typeLabel);
            if(sum) sum.__pendingDate = dateISO;
          }
        }else{
          rec.__state = String(item.state||"pending") === "failed" ? "failed" : "pending";
          rec.__reqId = String(item.reqId || rec.__reqId || cultMakeReqId_("cultAdd"));
        }
        kept.push(item);
      });
      if(changed) cultOutboxWrite_(kept);
      renderTodayInfo_();
    }
    function cultStartOutboxSync_(){
      if(CULT._outboxSyncRunning) return;
      CULT._outboxSyncRunning = true;
      (async()=>{
        try{
          let guard = 0;
          while(guard++ < 20){
            const item = cultOutboxRead_().find(x=>String(x.state||"pending") !== "done");
            if(!item) break;
            let rec = (CULT.records||[]).find(r=> String(r.__reqId||"")===String(item.reqId||"") || String(r.logId||"")===String(item.tmpId||""));
            if(!rec){
              rec = {
                logId: String(item.tmpId || cultTmpId_()), createdAt: String(item.createdAt || new Date().toISOString()),
                dateISO: String(item.dateISO||""), typeKey: String(item.typeKey||""), typeLabel: String(item.typeLabel||""),
                note: String(item.note||""), proofUrl: String(item.proofUrl||""), __state:"pending", __reqId:String(item.reqId||cultMakeReqId_("cultAdd"))
              };
              CULT.records = (CULT.records||[]).concat([rec]);
            }
            rec.__state = "pending";
            try{ renderQuickBtns_(); renderProgress_(); renderTable_(); renderTodayInfo_(); }catch(_e){}
            const ok = await cultSyncAddRecord_(rec, { fromOutbox:true });
            try{ renderQuickBtns_(); renderProgress_(); renderTable_(); renderTodayInfo_(); updateQuickDisabled_(); }catch(_e){}
            if(!ok) break;
          }
        }finally{
          CULT._outboxSyncRunning = false;
          try{ renderTodayInfo_(); }catch(_e){}
        }
      })();
    }

    function cultTypeSyncState_(typeKey){
      const tk = String(typeKey||"");
      let hasPending = false, hasFailed = false;
      (CULT.records||[]).forEach(r=>{
        if(String(r.typeKey||"") !== tk) return;
        const st = String(r.__state||"");
        if(st === "failed") hasFailed = true;
        if(st === "pending") hasPending = true;
      });
      return hasFailed ? "failed" : (hasPending ? "pending" : "");
    }

    function cultEnsureSummary_(typeKey, typeLabel){
      const tk = String(typeKey||"").trim();
      if(!tk) return null;
      let s = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
      if(s) return s;
      // Create a minimal summary so progress UI can update instantly
      s = {
        typeKey: tk,
        typeLabel: String(typeLabel||"").trim(),
        displayName: String(typeLabel||"").trim() || typeDisplayName_(tk),
        started: true,
        doneDays: 0,
        targetBase: 108,
        penaltyDays: 0,
        targetTotal: 108,
        restarts: 0,
        lastDateISO: "",
        __pendingOnly: true
      };
      CULT.summaries = (CULT.summaries||[]).concat([s]);
      return s;
    }

    function cultLocalBumpSummaryOnAdd_(sum, dateISO){
      if(!sum) return;
      const d = String(dateISO||"");
      // Pending writes never change authoritative totals. The server response supplies
      // the accepted count; this marker is only for the visible synchronization state.
      if(d) sum.__pendingDate = d;
      sum.started = true;
    }

    function cultLocalDropSummaryOnDiscard_(typeKey, dateISO){
      const tk = String(typeKey||"");
      const sum = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
      if(!sum) return;
      if(sum.__pendingOnly){
        const remains = (CULT.records||[]).some(r=>String(r.typeKey||"")===tk && (cultIsTmpId_(r.logId) || String(r.__state||"")));
        if(!remains) CULT.summaries = (CULT.summaries||[]).filter(x=>x !== sum);
      }
    }

    function cultApplyLocalAdd_(op){
      // op: { tmpId, dateISO, typeKey, typeLabel, note, proofUrl, createdAt }
      const tmpId = op.tmpId || cultTmpId_();
      const dateISO = String(op.dateISO||"");
      const typeKey = String(op.typeKey||"");
      const typeLabel = String(op.typeLabel||"");
      const note = String(op.note||"");
      const proofUrl = String(op.proofUrl||"");
      const createdAt = op.createdAt || new Date().toISOString();
      const r = { logId: tmpId, createdAt, dateISO, typeKey, typeLabel: typeLabel || typeDisplayName_(typeKey), note, proofUrl, __state: "pending", __reqId: cultMakeReqId_("cultAdd") };
      CULT.records = (CULT.records||[]).concat([r]);
      const sum = cultEnsureSummary_(typeKey, r.typeLabel);
      if(sum) sum.__pendingDate = dateISO;
      if(!op.noQueue) cultOutboxUpsert_(r);
      renderTodayInfo_();
      return r;
    }

    function cultRemoveLocalRecord_(logId){
      const id = String(logId||"");
      const r = (CULT.records||[]).find(x=>String(x.logId||"")===id);
      if(!r) return null;
      CULT.records = (CULT.records||[]).filter(x=>String(x.logId||"")!==id);
      try{ cultOutboxRemove_(r); }catch(_e){}
      renderTodayInfo_();
      return r;
    }

    function cultSyncAddRecord_(rec, opts){
      if(!rec) return;
      const dateISO = String(rec.dateISO||"");
      const typeKey = String(rec.typeKey||"");
      const typeLabel = String(rec.typeLabel||"");
      const note = String(rec.note||"");
      const proofUrl = String(rec.proofUrl||"");
      const reqId = String(rec.__reqId||cultMakeReqId_("cultAdd"));
      rec.__reqId = reqId;
      rec.__state = "pending";
      try{ cultOutboxUpsert_(rec); }catch(_e){}
      const payload = Object.assign({ dateISO, typeKey, typeLabel, note, proofUrl }, cultTzPayload_());
      // fire & forget
      return cultSendWithRetry_("cultAdd", payload, { requestId: reqId, maxAttempts: 4 }).then(res=>{
        const data = (res && (res.data||res)) || {};
        const created = (data && (data.record || data.created)) ? (data.record || data.created) : null;
        if(created && created.logId){
          rec.logId = String(created.logId);
          rec.createdAt = String(created.createdAt || rec.createdAt || "");
          rec.typeLabel = String(created.typeLabel || rec.typeLabel || "");
        }
        let acceptedSummary = false;
        if(data && data.authoritative === true && data.summary && data.summary.typeKey){
          const C = window.SLB_CULT_CONTRACT;
          const checked = C && C.validateSummaries ? C.validateSummaries([data.summary], {allowEmpty:false}) : {ok:false};
          if(checked.ok){
            const authoritative = Object.assign({}, checked.summaries[0], {
              started: true,
              lastDateISO: String(data.summary.lastDateISO || data.summary.lastDoneDateISO || dateISO),
              hasToday: String(data.summary.lastDoneDateISO || data.summary.lastDateISO || "") === todayISO()
            });
            try{ delete authoritative.__pendingOnly; delete authoritative.__pendingDate; }catch(_e){}
            const idx = (CULT.summaries||[]).findIndex(x=>String(x.typeKey||"")===String(authoritative.typeKey||""));
            if(idx >= 0) CULT.summaries[idx] = authoritative;
            else CULT.summaries = (CULT.summaries||[]).concat([authoritative]);
            CULT.authoritative = true;
            CULT.source = "MUTATION";
            CULT.backendSummaryVersion = Number(data.summaryVersion || data.summary.summaryVersion || (C && C.summaryVersion) || 0);
            CULT.zeroStateConfirmed = (CULT.summaries||[]).every(s=>Number(s.doneDays||0) === 0);
            acceptedSummary = true;
          }
        }
        rec.__state = "";
        try{ cultOutboxRemove_(rec); }catch(_e){}
        if(acceptedSummary) cultCacheWrite_({source:"MUTATION"});
        else setTimeout(()=>{ try{ loadCultivations(true).catch(()=>{}); }catch(_e){} }, 0);
        try{ renderTodayInfo_(); }catch(_e){}
        return true;
      }).catch(err=>{
        const msg = String((err && (err.message||err)) || "");
        // If backend says already recorded, treat as success and reload to get real logId
        if(msg && msg.toLowerCase().indexOf("already recorded") >= 0){
          rec.__state = "";
          try{ cultOutboxRemove_(rec); }catch(_e){}
          setTimeout(()=>{ try{ cultReloadLite(false); }catch(_e){} }, 0);
          try{ renderTodayInfo_(); }catch(_e){}
          return true;
        }
        rec.__state = "failed";
        rec.__lastError = msg;
        try{ cultOutboxMark_(rec, "failed", msg); }catch(_e){}
        toast("err", "Cultivation not synced yet. It will retry when this page opens.");
        try{ renderTodayInfo_(); }catch(_e){}
        return false;
      });
    }


    function safeCustomKey(label){
      const raw = String(label||"").trim();
      const up = raw.toUpperCase();
      let base = up.replace(/[^A-Z0-9]+/g,"_").replace(/^_+|_+$/g,"");
      if(!base) base = "CUSTOM";
      if(base.length > 24) base = base.slice(0,24);
      let h = 0;
      for(let i=0;i<up.length;i++){ h = ((h<<5)-h) + up.charCodeAt(i); h |= 0; }
      const hx = (h>>>0).toString(16).slice(0,6);
      return "CUSTOM:" + base + "_" + hx;
    }

    function cultEls(){
      return {
        // quick
        quickDate: el("slbCultQuickDate"),
        quickBtns: el("slbCultQuickBtns"),
        todayInfo: el("slbCultTodayInfo"),
        loadFullHistory: el("slbCultLoadFullHistory"),
        // progress
        progressList: el("slbCultProgressList"),
        archivedList: el("slbCultArchivedList"),
        achSummary: el("slbCultAchSummary"),
        // export
        exportBtn: el("slbCultExportBtn"),
        exportMsg: el("slbCultExportMsg"),
        exportOk: el("slbCultExportOk"),
        // add record
        date: el("slbCultDate"),
        type: el("slbCultType"),
        customRow: el("slbCultCustomRow"),
        customInput: el("slbCultCustom"),
        customBack: el("slbCultCustomBack"),
        note: el("slbCultNote"),
        proof: el("slbCultProof"),
        addBtn: el("slbCultAddBtn"),
        msg: el("slbCultMsg"),
        ok: el("slbCultOk"),
        // self repair
        repairType: el("slbCultRepairType"),
        repairDone: el("slbCultRepairDone"),
        repairTotal: el("slbCultRepairTotal"),
        repairLast: el("slbCultRepairLast"),
        repairNote: el("slbCultRepairNote"),
        repairApply: el("slbCultRepairApply"),
        repairFill: el("slbCultRepairFill"),
        repairMsg: el("slbCultRepairMsg"),
        repairOk: el("slbCultRepairOk"),
        // table
        body: el("slbCultBody"),
        filterType: el("slbCultFilterType"),
        sort: el("slbCultSort"),
        reload: el("slbCultReload"),

        // admin (in admin panel)
        admUser: el("slbCultAdmUser"),
        admType: el("slbCultAdmType"),
        admCustomRow: el("slbCultAdmCustomRow"),
        admCustomInput: el("slbCultAdmCustom"),
        admCustomBack: el("slbCultAdmCustomBack"),
        admDone: el("slbCultAdmDone"),
        admLast: el("slbCultAdmLast"),
        admNote: el("slbCultAdmNote"),
        admSave: el("slbCultAdmSave"),
        admDeleteType: el("slbCultAdmDeleteType"),
        admCurrent: el("slbCultAdmCurrent"),
        admSetDone: el("slbCultAdmSetDone"),
        admSetTotal: el("slbCultAdmSetTotal"),
        admCustomAdjust: el("slbCultAdmCustomAdjust"),
        admFillFromCurrent: el("slbCultAdmFillFromCurrent"),
        admMsg: el("slbCultAdmMsg"),
        admOk: el("slbCultAdmOk"),
        admImportFile: el("slbCultAdmImportFile"),
        admImportBtn: el("slbCultAdmImportBtn"),
        admImportMsg: el("slbCultAdmImportMsg"),
        admImportOk: el("slbCultAdmImportOk"),
      };
    }

    function ensureModal_(){
      if(document.getElementById("slbCultModal")) return;
      const mask = document.createElement("div");
      mask.id = "slbCultModalMask";


/* ====== SLB CORE: 90_core_app.part06.js ====== */
/* SLB PART FILE — NOT STANDALONE
   This file is concatenated by slb_build/build.mjs into assets/slb.bundle.generated.js
*/

/* SLB CORE APP (split) - part 06/6
   NOTE: These parts are concatenated in order by slb_build/build.mjs.
*/
      mask.className = "slbModalMask";
      const modal = document.createElement("div");
      modal.id = "slbCultModal";
      modal.className = "slbModal";
      modal.innerHTML =
        '<h4>Edit cultivation record</h4>' +
        '<div class="row"><label>Note</label><textarea id="slbCultModalNote" rows="4" maxlength="500" placeholder="Optional"></textarea></div>' +
        '<div class="row"><label>Proof link</label><input id="slbCultModalProof" type="url" maxlength="800" placeholder="https://..." /></div>' +
        '<div class="err hidden" id="slbCultModalMsg"></div>' +
        '<div class="actions">' +
          '<button class="btn" id="slbCultModalSave" type="button">Save</button>' +
          '<button class="btn soft" id="slbCultModalCancel" type="button">Cancel</button>' +
        '</div>';
      var root = (document.getElementById("SaamLawBank") || document.getElementById("tyWealthCourtyard") || document.body);
      root.appendChild(mask);
      root.appendChild(modal);
      const close = () => {
        mask.classList.remove("show");
        modal.classList.remove("show");
        clearMsg(el("slbCultModalMsg"));
        modal.dataset.logId = "";
      };
      mask.addEventListener("click", close);
      onOnce("slbCultModalCancel","click", close);
      onOnce("slbCultModalSave","click", async () => {
        const logId = String(modal.dataset.logId||"");
        const msg = el("slbCultModalMsg");
        clearMsg(msg);
        if(!logId) return close();
        const unlock = lockBtn(el("slbCultModalSave"));
        try{
          const note = String(el("slbCultModalNote").value||"").trim();
          const proofUrl = String(el("slbCultModalProof").value||"").trim();
          await rpc("cultUpdate", { logId, note, proofUrl });
          toast("ok","Updated.");
          close();
          await cultReloadLite(true);
        }catch(e){
          setMsg(msg, e.message || String(e), false);
        }finally{ unlock(); }
      });
    }

    function openEditModal_(logId){
      ensureModal_();
      const r = (CULT.records||[]).find(x=>String(x.logId||"")===String(logId||""));
      const mask = el("slbCultModalMask");
      const modal = el("slbCultModal");
      if(!mask || !modal) return;
      modal.dataset.logId = String(logId||"");
      el("slbCultModalNote").value = (r && r.note) ? String(r.note) : "";
      el("slbCultModalProof").value = (r && r.proofUrl) ? String(r.proofUrl) : "";
      clearMsg(el("slbCultModalMsg"));
      mask.classList.add("show");
      modal.classList.add("show");
      el("slbCultModalNote").focus();
    }

    function typeDisplayName_(typeKey){
      const tk = String(typeKey||"");
      const s = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
      if(s) return String(s.displayName||s.typeLabel||tk);
      const hit = (CULT.types||[]).find(t=>String(t.typeKey||"")===tk);
      if(hit) return String(hit.displayName||hit.typeKey||tk);
      return tk;
    }

    function isCustomKey_(k){ return String(k||"").toUpperCase().indexOf("CUSTOM:")===0; }

    function renderTypeSelect_(sel){
      if(!sel) return;
      const previous = String(sel.value||"");
      sel.innerHTML = "";
      const seen = new Set();
      const options = [];
      (CULT.types||[]).forEach(t=>{
        const key = String(t.typeKey||"");
        if(!key || seen.has(key)) return;
        seen.add(key);
        options.push({ key:key, label:String(t.displayName||key) });
      });
      (CULT.summaries||[]).forEach(s=>{
        const key = String(s.typeKey||"");
        if(!key || seen.has(key)) return;
        seen.add(key);
        options.push({ key:key, label:String(s.displayName||s.typeLabel||key) });
      });
      options.forEach(t=>{
        const opt = document.createElement("option");
        opt.value = t.key;
        opt.textContent = t.label;
        sel.appendChild(opt);
      });
      const opt = document.createElement("option");
      opt.value = "CUSTOM";
      opt.textContent = "Custom…";
      sel.appendChild(opt);
      if(previous && Array.from(sel.options).some(o=>o.value===previous)) sel.value = previous;
    }

    function renderFilterSelect_(sel){
      if(!sel) return;
      const seen = new Map();
      (CULT.types||[]).forEach(t=>{ const k=String(t.typeKey||""); if(k) seen.set(k, String(t.displayName||k)); });
      (CULT.summaries||[]).forEach(s=>{ const k=String(s.typeKey||""); if(k && !seen.has(k)) seen.set(k, String(s.displayName||s.typeLabel||k)); });
      (CULT.records||[]).forEach(r=>{ const k=String(r.typeKey||""); if(k && !seen.has(k)) seen.set(k, String(r.typeLabel||k)); });
      const arr = Array.from(seen.entries()).map(([k,n])=>({k,n}));
      arr.sort((a,b)=> a.n.toLowerCase().localeCompare(b.n.toLowerCase()) || a.k.localeCompare(b.k));
      sel.innerHTML = "";
      const all = document.createElement("option"); all.value="*"; all.textContent="All types"; sel.appendChild(all);
      arr.forEach(it=>{ const o=document.createElement("option"); o.value=it.k; o.textContent=it.n; sel.appendChild(o); });
      if(!sel.value) sel.value = "*";
    }

    function toggleCustom_(sel, customRow, customInput, on){
      if(!sel || !customRow) return;
      const isOn = (on!=null) ? !!on : (String(sel.value||"") === "CUSTOM");
      sel.classList.toggle("hidden", isOn);
      customRow.classList.toggle("hidden", !isOn);
      if(isOn && customInput) customInput.focus();
    }

    function collectType_(sel, customInput){
      const v = String(sel ? sel.value : "").trim();
      if(!v) throw new Error("Type missing.");
      if(v !== "CUSTOM") return { typeKey:v, typeLabel:"" };
      const label = String(customInput ? customInput.value : "").trim();
      if(!label) throw new Error("Custom label missing.");
      return { typeKey: safeCustomKey(label), typeLabel: label };
    }

    function recordKey_(r){ return String(r.dateISO||"") + "|" + String(r.typeKey||""); }

    function buildRecordMap_(){
      const m = new Set();
      (CULT.records||[]).forEach(r=>{ m.add(recordKey_(r)); });
      return m;
    }
    function cultHasDoneForDate_(dateISO, typeKey){
      const d = String(dateISO||"");
      const tk = String(typeKey||"");
      if(buildRecordMap_().has(d + "|" + tk)) return true;
      const s = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
      if(!s) return false;
      const serverToday = String(CULT.dailyTodayISO || todayISO());
      const lastDone = String(s.lastDoneDateISO || s.lastDateISO || "");
      return (d === serverToday && !!s.hasToday) || lastDone === d;
    }

    function cultFoldOpen_(id){
      const d = document.getElementById(id);
      return !!(d && d.open);
    }
    function cultHistoryOpen_(){ return cultFoldOpen_("slbCultHistoryFold"); }
    function cultProgressOpen_(){ return cultFoldOpen_("slbCultProgressFold"); }
    function cultAchOpen_(){ return cultFoldOpen_("slbCultAchFold"); }
    function cultRepairOpen_(){ return cultFoldOpen_("slbCultRepairFold"); }
    function cultRenderLazy_(){
      try{ renderTodayInfo_(); }catch(_e){}
      try{ renderQuickBtns_(); updateQuickDisabled_(); }catch(_e){}
      try{ if(cultProgressOpen_()) renderProgress_(); }catch(_e){}
      try{ if(cultAchOpen_()) renderArchived_(); }catch(_e){}
      try{ if(cultHistoryOpen_()) renderTable_(); }catch(_e){}
    }

    function cultPageStarted_(){
      const p = el("slbCultPanel");
      return !!(p && p.classList && p.classList.contains("slbCultStarted"));
    }
    function cultSetPageStarted_(on){
      const p = el("slbCultPanel");
      if(p && p.classList) p.classList.toggle("slbCultStarted", !!on);
    }
    function cultImp_(node, prop, val){
      try{ if(node && node.style) node.style.setProperty(prop, val, "important"); }catch(_e){}
    }
    function cultTheme_(){
      try{
        const t = String(document.documentElement.getAttribute("data-slb-theme") || "").toLowerCase();
        if(t === "dark" || t === "light") return t;
      }catch(_e){}
      try{
        if(window.SLBTheme && typeof window.SLBTheme.get === "function"){
          return window.SLBTheme.get() === "dark" ? "dark" : "light";
        }
      }catch(_e){}
      return "light";
    }
    function cultStyleQuickBtn_(b, done){
      if(!b) return;
      const dark = cultTheme_() === "dark";
      const common = {
        "min-height":"108px", "padding":"17px 14px", "border-radius":"19px",
        "display":"flex", "flex-direction":"column", "align-items":"center", "justify-content":"center",
        "text-align":"center", "white-space":"normal", "gap":"6px", "opacity":"1",
        "font-weight":"900", "line-height":"1.2", "appearance":"none", "-webkit-appearance":"none"
      };
      Object.keys(common).forEach(k=>cultImp_(b,k,common[k]));
      if(done){
        if(dark){
          cultImp_(b,"background","linear-gradient(180deg,#2b241d 0%,#211915 100%)");
          cultImp_(b,"color","#ffd7bd");
          cultImp_(b,"border","2px solid rgba(255,138,58,.55)");
          cultImp_(b,"box-shadow","0 8px 22px rgba(0,0,0,.32), inset 0 1px 0 rgba(255,255,255,.08)");
        }else{
          cultImp_(b,"background","linear-gradient(180deg,#fffdfb 0%,#fff1e5 100%)");
          cultImp_(b,"color","#8a3508");
          cultImp_(b,"border","2px solid rgba(239,94,20,.48)");
          cultImp_(b,"box-shadow","0 8px 20px rgba(145,69,18,.13), inset 0 1px 0 rgba(255,255,255,.92)");
        }
      }else{
        cultImp_(b,"background",dark
          ? "linear-gradient(180deg,#ff8738 0%,#ef5e14 100%)"
          : "linear-gradient(180deg,#ff9a57 0%,#f36b22 54%,#e6530d 100%)");
        cultImp_(b,"color","#ffffff");
        cultImp_(b,"border","1px solid rgba(239,94,20,.72)");
        cultImp_(b,"box-shadow",dark
          ? "0 10px 22px rgba(239,94,20,.26), inset 0 1px 0 rgba(255,255,255,.22)"
          : "0 10px 22px rgba(183,70,11,.22), inset 0 1px 0 rgba(255,255,255,.36)");
      }
      try{
        b.querySelectorAll(".slbCultQuickAction,.slbCultQuickName,.slbCultQuickMeta").forEach(sp=>{
          cultImp_(sp,"display","block"); cultImp_(sp,"width","100%"); cultImp_(sp,"max-width","100%");
          cultImp_(sp,"margin","0 auto"); cultImp_(sp,"text-align","center"); cultImp_(sp,"color","inherit");
          cultImp_(sp,"pointer-events","none");
        });
      }catch(_e){}
    }

    function renderQuickBtns_(){
      const E = cultEls();
      if(!E.quickBtns) return;
      const list = (CULT.summaries||[]).filter(s=>s && s.started && !cultIsArchivedSummary_(s));
      if(!list.length){
        if(CULT.loading && !CULT.loaded){
          E.quickBtns.innerHTML =
            '<div class="slbCultEmpty">' +
              '<div class="slbCultEmptyTitle">Loading today&rsquo;s cultivation&hellip;</div>' +
              '<div class="note">This should only take a moment.</div>' +
            '</div>';
          return;
        }
        E.quickBtns.innerHTML =
          '<div class="slbCultEmpty">' +
            '<div class="slbCultEmptyTitle">No active cultivation yet</div>' +
            '<div class="note">Add one once, record its first completed day, and its daily +1 button will live here.</div>' +
            '<button class="btn orange mini" type="button" data-cult-open-setup="1" style="margin-top:10px;">Add my first cultivation</button>' +
          '</div>';
        return;
      }
      E.quickBtns.innerHTML = list.map(s=>{
        const tkRaw = String(s.typeKey||"");
        const tk = escapeAttr(tkRaw);
        const name = escapeHtml(String(s.displayName||s.typeLabel||s.typeKey||""));
        const done = Number(s.doneDays||0) || 0;
        const total = Number(s.targetTotal||s.targetBase||108) || 108;
        const sync = cultTypeSyncState_(tkRaw);
        const syncText = sync === "failed" ? "Retry needed" : (sync === "pending" ? "Syncing" : "Ready");
        const progressText = s.__pendingOnly ? "-- / --" : (done + " / " + total);
        return '<button class="btn orange slbCultQuickBtn" type="button" data-cult-quick="1" data-typekey="'+tk+'">' +
          '<span class="slbCultQuickAction">+1 today</span>' +
          '<span class="slbCultQuickName">'+name+'</span>' +
          '<span class="slbCultQuickMeta">'+progressText+' • '+syncText+'</span>' +
        '</button>';
      }).join("");
      // Apply disabled state based on selected date
      updateQuickDisabled_();
    }

    function updateQuickDisabled_(){
      const E = cultEls();
      if(!E.quickBtns) return;
      const dateISO = String(E.quickDate && E.quickDate.value ? E.quickDate.value : "").trim() || todayISO();
      if(E.quickDate && !E.quickDate.value) E.quickDate.value = dateISO;
      const btns = E.quickBtns.querySelectorAll("button[data-cult-quick]");
      btns.forEach(b=>{
        const tk = String(b.getAttribute("data-typekey")||"");
        const sum = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
        const serverToday = String(CULT.dailyTodayISO || todayISO());
        const lastDone = String((sum && (sum.lastDoneDateISO || sum.lastDateISO)) || "");
        const matches = (CULT.records||[]).filter(r=>String(r.dateISO||"")===dateISO && String(r.typeKey||"")===tk);
        const pending = matches.some(r=>String(r.__state||"") === "pending");
        const failed = matches.some(r=>String(r.__state||"") === "failed");
        const syncedRecord = matches.some(r=>!cultIsTmpId_(r.logId) && !String(r.__state||""));
        const confirmed = syncedRecord || (!!sum && ((dateISO === serverToday && !!sum.hasToday) || lastDone === dateISO));
        b.disabled = !!(confirmed || pending);
        b.classList.toggle("soft", !!confirmed);
        b.classList.toggle("slbCultDoneToday", !!confirmed);
        cultStyleQuickBtn_(b, !!confirmed);
        const action = b.querySelector(".slbCultQuickAction");
        if(action) action.textContent = confirmed ? "Saved today" : (pending ? "Syncing..." : (failed ? "Retry sync" : "+1 today"));
        const meta = b.querySelector(".slbCultQuickMeta");
        if(meta){
          const done = sum ? (Number(sum.doneDays||0)||0) : 0;
          const total = sum ? (Number(sum.targetTotal||sum.targetBase||108)||108) : 108;
          const progress = sum && sum.__pendingOnly ? "-- / --" : (done + " / " + total);
          meta.textContent = progress + " • " + (confirmed ? "Saved" : (pending ? "Syncing" : (failed ? "Retry needed" : "Ready")));
        }
      });
    }

    function renderProgress_(){
      const E = cultEls();
      if(!E.progressList) return;
      if(!cultProgressOpen_()) return;
      const list = (CULT.summaries||[]).filter(s=>s && s.started && !cultIsArchivedSummary_(s));
      if(!list.length){
        const anyStarted = (CULT.summaries||[]).some(s=>s && s.started);
        if(anyStarted){
          E.progressList.innerHTML = '<div class="note">No active cultivations. (All archived below)</div>';
        }else{
          E.progressList.innerHTML = '<div class="note">No active cultivation yet. Use “Add a new cultivation” above to begin.</div>';
        }
        return;
      }
      const html = list.map(s=>{
        const tk = escapeAttr(String(s.typeKey||""));
        const name = escapeHtml(String(s.displayName||s.typeLabel||s.typeKey||""));
        const done = Number(s.doneDays||0) || 0;
        const targetTotal = Number(s.targetTotal||s.targetBase||108) || 108;
        const pen = Number(s.penaltyDays||0) || 0;
        const base = Number(s.targetBase||108) || 108;
        const restarts = Number(s.restarts||0) || 0;
        const last = s.lastDateISO ? String(s.lastDateISO) : "";
        const pct = Math.max(0, Math.min(100, targetTotal ? (done/targetTotal*100) : 0));
        const sync = cultTypeSyncState_(tk);
        const syncHtml = sync ? (' <span class="pill slbStickyState ' + (sync==='failed'?'retry':'syncing') + '" title="' + (sync==='failed'?'Not synced. Open the table and tap Retry.':'Syncing with backend…') + '">' + (sync==='failed'?'Not Synced':'Syncing…') + '</span>') : '';
        return (
          '<div class="slbProgCard" data-cult-card="1" data-typekey="'+tk+'">' +
            '<div class="slbProgHead">' +
              '<div class="slbProgName">'+name+'</div>' +
              '<div class="note"><b>'+done+'</b> / '+targetTotal+syncHtml+'</div>' +
            '</div>' +
            '<div class="slbProgBar"><div class="slbProgFill" style="width:'+pct.toFixed(1)+'%"></div></div>' +
            '<div class="slbProgMeta">' +
              '<span>Target: '+base+'</span>' +
              '<span>Penalty: +'+pen+'</span>' +
              (restarts?('<span>Restarts: '+restarts+'</span>'):'') +
              (last?('<span>Last: '+escapeHtml(last)+'</span>'):'') +
            '</div>' +
            '<div class="slbProgActions">' +
              '<button class="btn soft mini" type="button" data-act="target">Target…</button>' +
              '<button class="btn soft mini" type="button" data-act="missed">Missed…</button>' +
              '<button class="btn soft mini" type="button" data-act="rename">Rename…</button>' +
              (done>=targetTotal ? '<button class="btn soft mini" type="button" data-act="archive">Archive</button>' : '') +
              '<button class="btn danger mini" type="button" data-act="deleteType">Delete</button>' +
            '</div>' +
          '</div>'
        );
      }).join("");
      E.progressList.innerHTML = html;
    }
function renderArchived_(){
  const E = cultEls();
  if(!E.archivedList) return;
  if(!cultAchOpen_()) return;

  const list = (CULT.summaries||[]).filter(s=>s && s.started && cultIsArchivedSummary_(s));

  function fmtNice(iso){
    try{
      const d = new Date(iso);
      if(!isFinite(d)) return "";
      return d.toLocaleDateString("en-US", { year:"numeric", month:"short", day:"numeric" });
    }catch(_e){ return ""; }
  }

  function safeTime(iso){
    try{
      const d = new Date(String(iso||""));
      return isFinite(d) ? d.getTime() : 0;
    }catch(_e){ return 0; }
  }

  // summary + breakdown
  try{
    if(E.achSummary){
      if(!list.length){
        E.achSummary.innerHTML = 'You have <b>0</b> achievement trophies.';
      }else{
        const ds = list.map(s=> String(s.archivedAt||s.lastDateISO||"")).filter(Boolean)
          .map(x=>{ try{ const d=new Date(x); return isFinite(d)?d:null; }catch(_e){ return null; } })
          .filter(Boolean)
          .sort((a,b)=>a-b);
        const since = ds.length ? fmtNice(ds[0].toISOString()) : "";

        const counts = {};
        list.forEach(s=>{
          const n = String(s.displayName||s.typeLabel||s.typeKey||"").trim();
          if(!n) return;
          counts[n] = (counts[n]||0) + 1;
        });
        const breakdown = Object.keys(counts)
          .sort((a,b)=>a.localeCompare(b))
          .map(n=> escapeHtml(n) + ' × ' + counts[n])
          .join(' • ');

        E.achSummary.innerHTML =
          'You have <b>'+list.length+'</b> achievement trophies' + (since?(' since '+since):'') + '.' +
          (breakdown?('<br><span style="opacity:.9;">Breakdown: '+breakdown+'</span>'):'');
      }
    }
  }catch(_e){}

  if(!list.length){
    E.archivedList.innerHTML = '<tr><td colspan="4"><div class="note">No achievements yet.</div></td></tr>';
    return;
  }

  const sorted = list.slice().sort((a,b)=>{
    const ad = safeTime(a.archivedAt||a.lastDateISO||"");
    const bd = safeTime(b.archivedAt||b.lastDateISO||"");
    if(ad !== bd) return bd - ad; // newest first
    const an = String(a.displayName||a.typeLabel||a.typeKey||"");
    const bn = String(b.displayName||b.typeLabel||b.typeKey||"");
    return an.localeCompare(bn);
  });

  const html = sorted.map(s=>{
    const tk = escapeAttr(String(s.typeKey||""));
    const nameRaw = String(s.displayName||s.typeLabel||s.typeKey||"");
    const name = escapeHtml(nameRaw);

    const doneRaw = Number(s.doneDays||0) || 0;
    const targetTotal = Number(s.targetTotal||s.targetBase||108) || 108;
    const doneShow = targetTotal > 0 ? Math.min(doneRaw, targetTotal) : doneRaw;

    const whenIso = String(s.archivedAt||s.lastDateISO||"");
    const when = whenIso ? fmtNice(whenIso) : "";

    const rawHint = (doneRaw > doneShow) ? ('Raw: '+doneRaw+'/'+targetTotal) : '';
    const doneHtml = '<b' + (rawHint ? (' title="'+escapeAttr(rawHint)+'"') : '') + '>' + doneShow + '/' + targetTotal + '</b> Days';
    const details = (when?('Completed on '+escapeHtml(when)+' - '):'Completed - ') + doneHtml + '.';

    return (
      '<tr data-typekey="'+tk+'">' +
        '<td style="width:44px; font-size:18px; line-height:1; padding-top:10px;">🏆</td>' +
        '<td style="font-weight:900;">'+name+'</td>' +
        '<td>'+details+'</td>' +
        '<td style="white-space:nowrap;">' +
          '<button class="btn soft mini" type="button" data-act="unarchive">Unarchive</button> <button class="btn soft mini" type="button" data-act="rename">Rename…</button> ' +
          '<button class="btn danger mini" type="button" data-act="deleteType">Delete</button>' +
        '</td>' +
      '</tr>'
    );
  }).join("");

  E.archivedList.innerHTML = html;
}




    function renderTable_(){
      const E = cultEls();
      if(!E.body) return;
      if(!cultHistoryOpen_()) return;
      const filter = E.filterType ? String(E.filterType.value||"*") : "*";
      const sort = E.sort ? String(E.sort.value||"new") : "new";
      let rows = (CULT.records||[]).slice();
      if(filter !== "*") rows = rows.filter(r=>String(r.typeKey||"")===filter);
      rows.sort((a,b)=>{
        const ad = String(a.dateISO||"");
        const bd = String(b.dateISO||"");
        const at = String(a.typeLabel||a.typeKey||"");
        const bt = String(b.typeLabel||b.typeKey||"");
        if(sort === "old") return ad.localeCompare(bd) || at.localeCompare(bt);
        if(sort === "type") return at.localeCompare(bt) || bd.localeCompare(ad);
        // new
        return bd.localeCompare(ad) || bt.localeCompare(at);
      });
      const html = rows.map(r=>{
        const id = escapeAttr(String(r.logId||""));
        const d = escapeHtml(r.dateISO||"");
        const type = escapeHtml(r.typeLabel||r.typeKey||"");
        const note = escapeHtml(r.note||"");
        const proof = String(r.proofUrl||"").trim();
        const proofHtml = proof ? ('<a href="' + escapeAttr(proof) + '" target="_blank" rel="noopener">Link</a>') : '';
        const isBaseline = !!r.isBaseline || String(r.logId||"").indexOf("BASELINE:")===0;
        const st = String(r.__state||"");
        const statePill = st==="pending"
          ? ' <span class="pill slbStickyState syncing">Syncing…</span>'
          : (st==="failed" ? ' <span class="pill slbStickyState retry">Not Synced</span>' : '');
        const noteHtml = note + statePill;
        let actions = '';
        if(isBaseline){
          actions = '<div class="slbCultTableActions"><span class="note">Admin adjustment</span></div>';
        }else if(cultIsTmpId_(r.logId) && st==="pending"){
          actions = ('<div class="slbCultTableActions">' +
              '<span class="note">Syncing…</span>' +
              '<button class="btn soft mini" type="button" data-act="discard" data-id="'+id+'">Discard</button>' +
            '</div>');
        }else if(cultIsTmpId_(r.logId) && st==="failed"){
          actions = ('<div class="slbCultTableActions">' +
              '<button class="btn soft mini" type="button" data-act="retry" data-id="'+id+'">Retry</button>' +
              '<button class="btn danger mini" type="button" data-act="discard" data-id="'+id+'">Discard</button>' +
            '</div>');
        }else{
          actions = ('<div class="slbCultTableActions">' +
              '<button class="btn soft mini" type="button" data-act="edit" data-id="'+id+'">Edit</button>' +
              '<button class="btn danger mini" type="button" data-act="del" data-id="'+id+'">Delete</button>' +
            '</div>');
        }
        const trCls = (st==="pending" ? ' class="slbCultRow_pending"' : (st==="failed" ? ' class="slbCultRow_failed"' : ''));
        return '<tr'+trCls+'>' +
          '<td>' + d + '</td>' +
          '<td>' + type + '</td>' +
          '<td>' + noteHtml + '</td>' +
          '<td>' + proofHtml + '</td>' +
          '<td>' + actions + '</td>' +
        '</tr>';
      }).join("");
      E.body.innerHTML = html || '<tr><td colspan="5" class="note">No records yet.</td></tr>';
    }

    // Back-compat: some deployments used older action names.
    async function cultRpcAny_(actions, args, rpcOpts){
      let lastErr = null;
      const list = Array.isArray(actions) ? actions : [actions];
      for(const act of list){
        try{ return await rpc(String(act||''), args || {}, rpcOpts || {}); }
        catch(e){ lastErr = e; }
      }
      throw lastErr || new Error('Cultivation RPC failed');
    }



    // V20: safe local summary builder. This name is used by all fallback paths so
    // an older scoped helper cannot throw "cultBuildSummariesFromRecords_ is not defined".
    function cultBuildSummariesFromRecordsSafe_(records, existing){
      const C = window.SLB_CULT_CONTRACT;
      if(!C || !C.buildSummariesFromRecords) return [];
      return C.buildSummariesFromRecords(records, existing, typeDisplayName_, todayISO());
    }
    try{ window.SLB_cultBuildSummariesFromRecordsSafe_ = cultBuildSummariesFromRecordsSafe_; }catch(_e){}

    async function cultLoadTypes_(){
      const tRes = await rpc("cultGetTypes", {}, { timeoutMs: 8000, noGlobalRetry:true, progressMode:"silent", cacheTtlMs: 60000, useWarmCache:true });
      CULT.types = (tRes && tRes.types) ? tRes.types : [];
    }

    async function cultReloadLite(refreshTypes, opts){
      if(!S || !S.token) return;
      opts = opts || {};
      const fullHistory = !!opts.fullHistory;
      if(fullHistory) CULT.fullHistoryLoaded = true;
      const dailyArgs = Object.assign({ todayISO: todayISO(), includeRecent:true, recentDays:15 }, cultTzPayload_());
      const dailyOpts = { timeoutMs:12000, noGlobalRetry:true, progressMode:"silent", cacheTtlMs:0, useWarmCache:false };
      const historyArgs = Object.assign({ limit:900, todayISO:todayISO(), lite:false }, cultTzPayload_());
      const historyOpts = { timeoutMs:25000, noGlobalRetry:true, progressMode:"silent", cacheTtlMs:0, useWarmCache:false };

      // The Today screen uses the small CULT_SUMMARY endpoint. Full records are fetched
      // only when the disciple explicitly opens history.
      const jobs = [
        refreshTypes ? cultLoadTypes_() : Promise.resolve(true),
        cultRpcAny_(["cultGetMyDaily","cultMyDaily"], dailyArgs, dailyOpts),
        fullHistory ? cultRpcAny_(["cultGetMy","cultGetMine","cultMyList"], historyArgs, historyOpts) : Promise.resolve(null)
      ];
      const settled = await Promise.allSettled(jobs);
      const dailySet = settled[1];
      const historySet = settled[2];
      const previousSummaries = Array.isArray(CULT.summaries) ? CULT.summaries.filter(s=>!s.__pendingOnly).slice() : [];
      let acceptedDaily = false;
      let dailyError = null;

      if(dailySet.status === "fulfilled"){
        const daily = (dailySet.value && (dailySet.value.data || dailySet.value)) || {};
        CULT.dailyTodayISO = String(daily.todayISO || todayISO());
        const C = window.SLB_CULT_CONTRACT;
        const checked = C && C.validateDailyPayload
          ? C.validateDailyPayload(daily, previousSummaries)
          : {ok:false, errors:["Cultivation response validator is unavailable."], summaries:[]};
        if(checked.ok){
          CULT.summaries = checked.summaries.map(s=>Object.assign({}, s, {
            started: true,
            lastDateISO: String(s.lastDateISO || s.lastDoneDateISO || "")
          }));
          CULT.authoritative = true;
          CULT.source = String(daily.source||"SUMMARY");
          CULT.backendSummaryVersion = Number(daily.summaryVersion||0);
          CULT.zeroStateConfirmed = daily.zeroStateConfirmed === true;
          acceptedDaily = true;
        }else{
          dailyError = new Error("Cultivation totals were not replaced: " + checked.errors.join("; "));
        }

        if(fullHistory && historySet.status === "fulfilled"){
          const history = (historySet.value && (historySet.value.data || historySet.value)) || {};
          CULT.records = Array.isArray(history.records) ? history.records : [];
        }else{
          const recent = Array.isArray(daily.recentRecords) ? daily.recentRecords : (Array.isArray(daily.records) ? daily.records : []);
          const localPending = (CULT.records||[]).filter(r=>
            cultIsTmpId_(r.logId) || String(r.__state||"") === "pending" || String(r.__state||"") === "failed"
          );
          const merged = [];
          const seen = new Set();
          recent.concat(localPending).forEach(r=>{
            const natural = String(r.dateISO||"") + "|" + String(r.typeKey||"");
            const key = (!cultIsTmpId_(r.logId) && String(r.logId||"")) ? String(r.logId) : natural;
            if(localPending.indexOf(r) >= 0 && recent.some(x=>String(x.dateISO||"")+"|"+String(x.typeKey||"") === natural)) return;
            if(!key || seen.has(key)) return;
            seen.add(key);
            merged.push(r);
          });
          CULT.records = merged;
        }
      }else if(fullHistory && historySet.status === "fulfilled"){
        const history = (historySet.value && (historySet.value.data || historySet.value)) || {};
        CULT.records = Array.isArray(history.records) ? history.records : [];
        dailyError = dailySet.reason || new Error("Cultivation totals could not load.");
      }else{
        dailyError = dailySet.reason || new Error("Cultivation data could not load.");
      }

      // Re-attach queued taps for synchronization display only. Pending records never
      // increment or replace authoritative totals.
      try{ cultHydrateOutbox_(); }catch(_e){}

      // Reconcile per-device archive override (prevents mobile "Achievements" from resurrecting archived items)
      try{
        const ov = (CULT.archiveOverride && typeof CULT.archiveOverride === "object") ? CULT.archiveOverride : {};
        let changed = false;
        (CULT.summaries || []).forEach(s => {
          const tk = String(s.typeKey || "");
          if(!tk) return;
          if(s.archived === true && ov[tk] === false){ delete ov[tk]; changed = true; }
        });
        if(changed){
          CULT.archiveOverride = ov;
          try{ localStorage.setItem(cultArchiveKey_(), JSON.stringify(ov)); }catch(_e){}
        }
      }catch(_e){}

      if(acceptedDaily) cultCacheWrite_({source:CULT.source});

      const E = cultEls();
      renderTypeSelect_(E.type);
      renderTypeSelect_(E.admType);
      renderTypeSelect_(E.repairType);
      renderFilterSelect_(E.filterType);
      cultRenderLazy_();
      try{ cultStartOutboxSync_(); }catch(_e){}

      if(!acceptedDaily) throw (dailyError || new Error("Cultivation totals could not be verified."));
      return true;
    }

    function cultHydrateAuth_(detail){
      if(!S) return false;
      const d = detail && detail.auth ? detail.auth : (detail || {});
      try{ if(!S.token && d.token) S.token = String(d.token||""); }catch(_e0){}
      try{ if(!S.callsign && d.callsign) S.callsign = String(d.callsign||"").trim().toUpperCase(); }catch(_e1){}
      if(!S.token){ try{ S.token = String(sessionStorage.getItem("tyw_token")||""); }catch(_e2){} }
      if(!S.callsign){ try{ S.callsign = String(sessionStorage.getItem("tyw_callsign")||"").trim().toUpperCase(); }catch(_e3){} }
      if(!S.token || !S.callsign){
        try{
          const raw = localStorage.getItem("ty_auth_v1") || "";
          const saved = raw ? JSON.parse(raw) : null;
          if(!S.token && saved && saved.token) S.token = String(saved.token||"");
          if(!S.callsign && saved && saved.callsign) S.callsign = String(saved.callsign||"").trim().toUpperCase();
        }catch(_e4){}
      }
      return !!(S.token && S.callsign);
    }

    function cultPanelVisible_(){
      if(el("slbMyAltar")) return false;
      const panel = el("slbCultPanel");
      return !!(panel && !panel.classList.contains("hidden"));
    }

    function loadCultivations(force){
      if(!cultHydrateAuth_()){
        try{
          const E = cultEls();
          if(E.todayInfo) E.todayInfo.textContent = "Waiting for your disciple session...";
        }catch(_e){}
        return Promise.resolve(false);
      }
      if(CULT._loadPromise) return CULT._loadPromise;
      const p = Promise.resolve().then(()=>cultLoadCultivationsImpl_(!!force));
      let wrapped = null;
      wrapped = p.finally(()=>{ if(CULT._loadPromise === wrapped) CULT._loadPromise = null; });
      CULT._loadPromise = wrapped;
      return wrapped;
    }

    async function cultLoadCultivationsImpl_(force){
      cultSetPageStarted_(true);
      // Instant daily screen boot: never leave the user stuck on "Loading today status".
      try{
        const EBoot = cultEls();
        const tBoot = todayISO();
        if(EBoot.quickDate && !EBoot.quickDate.value) EBoot.quickDate.value = tBoot;
        if(EBoot.date && !EBoot.date.value) EBoot.date.value = tBoot;
        if(EBoot.admLast && !EBoot.admLast.value) EBoot.admLast.value = tBoot;
        if(EBoot.repairLast && !EBoot.repairLast.value) EBoot.repairLast.value = tBoot;
        renderTodayInfo_();
        if(EBoot.quickBtns && !String(EBoot.quickBtns.innerHTML||"").trim()){
          EBoot.quickBtns.innerHTML =
            '<div class="slbCultEmpty">' +
              '<div class="slbCultEmptyTitle">Loading today&rsquo;s cultivation&hellip;</div>' +
              '<div class="note">This should only take a moment.</div>' +
            '</div>';
        }
      }catch(_e){}

      // Instant UI: hydrate cultivation from cache on first entry
      try{
        const currentCs = cultCurrentCallsign_();
        if(CULT._cacheHydratedFor !== currentCs){
          CULT._cacheHydratedFor = currentCs;
          const c = cultCacheRead_();
          if(c && typeof c === "object"){
            CULT.types = Array.isArray(c.types) ? c.types : (CULT.types || []);
            CULT.records = Array.isArray(c.records) ? c.records : (CULT.records || []);
            CULT.summaries = Array.isArray(c.summaries) ? c.summaries : (CULT.summaries || []);
            CULT.authoritative = true;
            CULT.source = String(c.source||"SUMMARY");
            CULT.backendSummaryVersion = Number(c.backendSummaryVersion||0);
            CULT.zeroStateConfirmed = c.zeroStateConfirmed === true;
            const E0 = cultEls();
            try{ renderTypeSelect_(E0.type); renderTypeSelect_(E0.admType); renderTypeSelect_(E0.repairType); }catch(_e){}
            try{ renderFilterSelect_(E0.filterType); }catch(_e){}
            try{ cultHydrateOutbox_(); cultRenderLazy_(); cultStartOutboxSync_(); }catch(_e){}
          }
        }
      }catch(_e){}

      // Load local archive override once per session (defensive: keeps Achievements 'sticky' even if backend is still on an older deployment)
      if(!CULT._ovLoaded){ try{ cultLoadArchiveOverride_(); CULT._ovLoaded = true; }catch(_e){} }
      if(CULT.loading) return false;
      const loadedAge = Date.now() - Number(CULT.lastLoadedAt || 0);
      if(CULT.loaded && !force && loadedAge < 30000){
        // Even when cultivations are already loaded, ensure admin dropdowns are populated
        // (admin panel can be opened before the Cultivations tab, or before role flags are ready).
        const E0 = cultEls();
        try{ renderTypeSelect_(E0.type); renderTypeSelect_(E0.admType); renderTypeSelect_(E0.repairType); }catch(_e){}
        try{
          if(E0.admUser && (!CULT.usersLoaded || !E0.admUser.options || E0.admUser.options.length===0)){
            const uRes = await rpc("giftUserList", {});
            const users = (uRes && uRes.users) ? uRes.users : [];
            E0.admUser.innerHTML = "";
            users.forEach(u=>{
              const opt = document.createElement("option");
              opt.value = String(u.callsign||"").toUpperCase();
              opt.textContent = (u.displayName ? (u.displayName + " — " + opt.value) : opt.value);
              E0.admUser.appendChild(opt);
            });
            CULT.usersLoaded = true;
          }
        }catch(_e){}
        try{ setTimeout(()=>{ try{ cultAdmRefreshCurrent_(); }catch(_e){} }, 0); }catch(_e){}

        cultRenderLazy_();
        return;
      }

      CULT.loading = true;
      const E = cultEls();
      try{ if(E.reload){ E.reload.disabled = true; E.reload.textContent = "Refreshing..."; } }catch(_e){}
      clearMsg(E.msg); clearMsg(E.ok);
      try{
        // defaults
        const t = todayISO();
        if(E.quickDate && !E.quickDate.value) E.quickDate.value = t;
        if(E.date && !E.date.value) E.date.value = t;
        if(E.admLast && !E.admLast.value) E.admLast.value = t;
        if(E.repairLast && !E.repairLast.value) E.repairLast.value = t;

        try{ cultHydrateOutbox_(); cultRenderLazy_(); cultStartOutboxSync_(); }catch(_e){}
        await cultReloadLite(true);

        // admin user list (populate disciple dropdown when present)
        if(E.admUser && (!CULT.usersLoaded || !E.admUser.options || E.admUser.options.length===0)){
          try{
            const uRes = await rpc("giftUserList", {});
            const users = (uRes && uRes.users) ? uRes.users : [];
            E.admUser.innerHTML = "";
            users.forEach(u=>{
              const opt = document.createElement("option");
              opt.value = String(u.callsign||"").toUpperCase();
              opt.textContent = (u.displayName ? (u.displayName + " — " + opt.value) : opt.value);
              E.admUser.appendChild(opt);
            });
            CULT.usersLoaded = true;
            try{ setTimeout(()=>{ try{ cultAdmRefreshCurrent_(); }catch(_e){} }, 0); }catch(_e){}
          }catch(_e){}
        }

        CULT.loaded = true;
        CULT.lastLoadedAt = Date.now();
        CULT._autoRetryCount = 0;
        cultRenderLazy_();
        try{ if(E.reload) E.reload.textContent = "Refresh"; }catch(_e){}
        clearMsg(E.ok);
        return true;
      }catch(e){
        try{ renderTodayInfo_(); }catch(_e){}
        try{
          if(E.quickBtns && (!CULT.summaries || !CULT.summaries.length)){
            E.quickBtns.innerHTML =
              '<div class="slbCultEmpty">' +
                '<div class="slbCultEmptyTitle">Could not refresh yet</div>' +
                '<div class="note">Check the connection and tap Refresh. Any cached cultivation buttons remain safe to use.</div>' +
              '</div>';
          }
        }catch(_e){}
        CULT._autoRetryCount = Number(CULT._autoRetryCount||0) + 1;
        if(CULT._autoRetryCount <= 2){
          try{ if(E.todayInfo) E.todayInfo.textContent = "Connection is slow. Retrying automatically…"; }catch(_e){}
          setTimeout(()=>{
            try{
              const panel = el("slbCultPanel");
              if(panel && !panel.classList.contains("hidden")){
                CULT.loaded = false;
                loadCultivations(true).catch(()=>{});
              }
            }catch(_e){}
          }, 650 * CULT._autoRetryCount);
        }else{
          setMsg(E.msg, (e && e.message ? e.message : String(e)) + " Cached/local records are still safe.", false);
        }
        try{ if(E.reload) E.reload.textContent = "Retry"; }catch(_e){}
        return false;
      }finally{
        CULT.loading = false;
        try{ if(E.reload) E.reload.disabled = false; }catch(_e){}
      }
    }

    try{ window.SLB_loadCultivations = loadCultivations; window.SLB_cultRenderLazy = cultRenderLazy_; }catch(_e){}
    try{
      const authReady = (e) => {
        try{
          cultHydrateAuth_(e && e.detail ? e.detail : null);
          if(cultPanelVisible_()) loadCultivations(false).catch(()=>{});
        }catch(_e){}
      };
      window.addEventListener("slb:auth-ready", authReady);
      window.addEventListener("ty_auth_ready", authReady);
      window.addEventListener("online", () => {
        try{ if(cultPanelVisible_()) loadCultivations(true).catch(()=>{}); }catch(_e){}
      });
      document.addEventListener("visibilitychange", () => {
        try{
          if(document.visibilityState === "visible" && cultPanelVisible_()) loadCultivations(false).catch(()=>{});
        }catch(_e){}
      });
      setTimeout(()=>{ try{ if(cultPanelVisible_() && cultHydrateAuth_()) loadCultivations(false).catch(()=>{}); }catch(_e){} }, 0);
    }catch(_e){}
    try{
      window.addEventListener("slbthemechange", () => {
        try{ updateQuickDisabled_(); }catch(_e){}
      });
    }catch(_e){}

    // ===== UI wiring =====
    onOnce("slbCultQuickDate","change", () => { updateQuickDisabled_(); renderTodayInfo_(); });
    function cultOpenSetup_(){
      const E = cultEls();
      const manage = el("slbCultManageFold");
      const fold = el("slbCultSetupFold");
      if(manage) manage.open = true;
      if(fold) fold.open = true;
      const d = String((E.quickDate && E.quickDate.value) || todayISO());
      if(E.date) E.date.value = d;
      try{ renderTypeSelect_(E.type); }catch(_e){}
      try{
        if(E.type && E.type.options && E.type.options.length){
          E.type.selectedIndex = 0;
          toggleCustom_(E.type, E.customRow, E.customInput, false);
        }
      }catch(_e){}
      try{ if(E.note) E.note.value = ""; if(E.proof) E.proof.value = ""; }catch(_e){}
      setTimeout(()=>{ try{ (E.type || E.date).focus(); fold && fold.scrollIntoView({behavior:"smooth",block:"start"}); }catch(_e){} }, 40);
    }
    onOnce("slbCultStartNew","click", cultOpenSetup_);
    document.addEventListener("click", (e)=>{
      const b = e.target && e.target.closest ? e.target.closest("[data-cult-open-setup]") : null;
      if(!b) return;
      cultOpenSetup_();
    });
    onOnce("slbCultReload","click", async () => { CULT.loaded = false; await loadCultivations(true); });
    onOnce("slbCultLoadFullHistory","click", async () => {
      const E = cultEls();
      const unlock = lockBtn(E.loadFullHistory);
      try{
        await cultReloadLite(true, { fullHistory:true });
        renderTable_();
        toast("ok", "Full history loaded.");
      }catch(err){
        toast("err", (err && err.message) ? err.message : String(err));
      }finally{ unlock(); }
    });

    document.addEventListener("toggle", (e) => {
      const id = e && e.target && e.target.id;
      if(!id || String(id).indexOf("slbCult") !== 0) return;
      if(!e.target.open) return;
      try{
        const E = cultEls();
        renderTypeSelect_(E.type); renderTypeSelect_(E.repairType); renderFilterSelect_(E.filterType);
      }catch(_e){}
      if(id === "slbCultProgressFold") { try{ renderProgress_(); }catch(_e){} }
      if(id === "slbCultAchFold") { try{ renderArchived_(); }catch(_e){} }
      if(id === "slbCultHistoryFold") { try{ renderTable_(); }catch(_e){} }
      if(id === "slbCultRepairFold") { try{ cultRepairFillFromCurrent_(); }catch(_e){} }
    }, true);

    function cultRepairCurrent_(){
      const E = cultEls();
      const tk = String(E.repairType && E.repairType.value || "").trim();
      if(!tk) return null;
      return (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk) || null;
    }
    function cultRepairFillFromCurrent_(){
      const E = cultEls();
      const s = cultRepairCurrent_();
      if(!E) return;
      if(E.repairLast && !E.repairLast.value) E.repairLast.value = todayISO();
      if(!s) return;
      if(E.repairDone) E.repairDone.value = String(Math.max(0, Number(s.doneDays||0)||0));
      if(E.repairTotal) E.repairTotal.value = String(Math.max(1, Number(s.targetTotal||s.targetBase||108)||108));
      if(E.repairLast) E.repairLast.value = String(s.lastDateISO || todayISO());
    }
    onOnce("slbCultRepairType","change", () => { cultRepairFillFromCurrent_(); });
    onOnce("slbCultRepairFill","click", () => { cultRepairFillFromCurrent_(); });
    onOnce("slbCultRepairApply","click", async () => {
      const E = cultEls();
      clearMsg(E.repairMsg); clearMsg(E.repairOk);
      const unlock = lockBtn(E.repairApply);
      try{
        const tk = String(E.repairType && E.repairType.value || "").trim();
        if(!tk) throw new Error("Cultivation type missing.");
        const typeLabel = isCustomKey_(tk) ? typeDisplayName_(tk) : "";
        const doneDays = Math.max(0, Math.floor(Number(E.repairDone ? E.repairDone.value : 0) || 0));
        const totalDays = Math.max(1, Math.floor(Number(E.repairTotal ? E.repairTotal.value : 108) || 108));
        const baseLastDateISO = String(E.repairLast && E.repairLast.value || "").trim() || todayISO();
        const note = String(E.repairNote && E.repairNote.value || "").trim();
        if(!confirm("Replace this tracker with exactly " + doneDays + " / " + totalDays + "? Old records for this cultivation will no longer affect the count.")) return;
        const callsign = String((S && S.callsign) ? S.callsign : "").trim().toUpperCase();
        const payload = Object.assign({
          callsign,
          typeKey: tk,
          typeLabel,
          doneDays,
          totalDays,
          baseDoneDays: doneDays,
          targetDays: totalDays,
          baseLastDateISO,
          lastDoneDateISO: baseLastDateISO,
          note: note || "self repair"
        }, cultTzPayload_());
        const actions = ["cultRepairSelf", "cultSelfAdjust", "cultRepairProgress", "cultSetMyBaseline"];
        if(S && S.isAdmin) actions.push("adminCultCustomAdjust", "adminCultAdjust");
        await cultRpcAny_(actions, payload);
        setMsg(E.repairOk, "Repair saved.", true);
        toast("ok", "Repair saved.");
        await cultReloadLite(true, { fullHistory: !!CULT.fullHistoryLoaded });
      }catch(err){
        const msg = (err && err.message) ? err.message : String(err);
        setMsg(E.repairMsg, msg, false);
      }finally{ unlock(); }
    });
    onOnce("slbCultExportBtn","click", async () => {
      const E = cultEls();
      clearMsg(E.exportMsg); clearMsg(E.exportOk);
      const unlock = lockBtn(E.exportBtn);
      try{
        let csv = "";
        let fileName = "";
        let usedClient = false;
        let res = null;

        try{
          // Try a few action names just in case
          const ACTIONS = ["cultExportCsv","exportCultCsv","cultivationExportCsv","cultExportCSV"];
          const res0 = await rpcTryCached("cultExportCsv", ACTIONS, {});
          res = (res0 && res0.data) ? res0.data : res0;

          csv = (res && (res.csvText || res.csv || res.text || res.content || res.body)) || "";
          if(Array.isArray(csv)) csv = csv.join("\n");
          if(typeof csv !== "string") csv = String(csv || "");
          if(!csv.trim()) throw new Error("No CSV returned.");

          // Older backend builds export only logs and miss the SUMMARY/TARGET info.
          // If CULT_SUMMARY isn't present, fall back to a client-built CSV (includes targets, progress, and achievements state).
          const hasSummary = (csv.indexOf("\nCULT_SUMMARY,") !== -1) || (csv.indexOf("CULT_SUMMARY,") === 0);
          if(!hasSummary){
            usedClient = true;
            csv = cultBuildCsvClient_();
          }

          fileName =
            (res && (res.fileName || res.filename || res.name)) ||
            ("slb-cultivation-" + String((S && S.callsign) ? S.callsign : "") + "-" + new Date().toISOString().slice(0,10) + (usedClient?"-CLIENT":"") + ".csv");
        }catch(_e){
          usedClient = true;
          csv = cultBuildCsvClient_();
          fileName = ("slb-cultivation-" + String((S && S.callsign) ? S.callsign : "") + "-" + new Date().toISOString().slice(0,10) + "-CLIENT.csv");
        }

        if(csv.charCodeAt(0) !== 0xFEFF) csv = "\uFEFF" + csv;

        const blob = new Blob([csv], { type:"text/csv;charset=utf-8" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        setMsg(E.exportOk, (usedClient ? "CSV downloaded (client build): " : "CSV downloaded: ") + fileName, true);
      }catch(err){
        setMsg(E.exportMsg, (err && err.message) ? err.message : String(err), false);
      }finally{ unlock(); }
    });


    onOnce("slbCultFilterType","change", () => { renderTable_(); });
    onOnce("slbCultSort","change", () => { renderTable_(); });

    onOnce("slbCultType","change", (e) => {
      const E = cultEls();
      if(String(e && e.target && e.target.value) === "CUSTOM") toggleCustom_(E.type, E.customRow, E.customInput, true);
    });
    onOnce("slbCultCustomBack","click", () => {
      const E = cultEls();
      // reset to first option
      if(E.type){
        const first = E.type.querySelector("option");
        if(first) E.type.value = first.value;
      }
      if(E.customInput) E.customInput.value = "";
      toggleCustom_(E.type, E.customRow, E.customInput, false);
    });

    // Add record (single button lock, no global freeze)
    onOnce("slbCultAddBtn","click", async () => {
      const E = cultEls();
      clearMsg(E.msg); clearMsg(E.ok);
      const unlock = lockBtn(E.addBtn);
      try{
        const dateISO = String(E.date && E.date.value ? E.date.value : "").trim() || todayISO();
        const tt = collectType_(E.type, E.customInput);
        const note = String(E.note ? E.note.value : "").trim();
        const proofUrl = String(E.proof ? E.proof.value : "").trim();
        if(cultHasDoneForDate_(dateISO, tt.typeKey)) throw new Error("That cultivation is already recorded for this date.");

        const rec = cultApplyLocalAdd_({ tmpId: cultTmpId_(), dateISO, typeKey: tt.typeKey, typeLabel: tt.typeLabel, note, proofUrl });

        // refresh UI immediately
        renderFilterSelect_(E.filterType);
        renderQuickBtns_(E.quickBtns);
        renderProgress_();
        renderArchived_();
        renderTable_();
        updateQuickDisabled_();

        toast("ok","Cultivation is syncing.");
        const synced = await cultSyncAddRecord_(rec);
        try{ renderQuickBtns_(); renderProgress_(); renderArchived_(); renderTable_(); updateQuickDisabled_(); }catch(_e){}
        if(synced){
          toast("ok","Cultivation saved.");
          setMsg(E.ok, "Cultivation accepted by the server.", true);
          if(E.note) E.note.value = "";
          if(E.proof) E.proof.value = "";
          try{ const fold = el("slbCultSetupFold"); if(fold) fold.open = false; }catch(_e){}
        }else{
          setMsg(E.msg, "The cultivation was not accepted yet. It is saved locally and can be retried.", false);
        }
      }catch(e){
        toast("err", e.message || String(e));
        setMsg(E.msg, e.message || String(e), false);
      }finally{ unlock(); }
    });

    // Quick add buttons (each locks itself so user can click multiple different types)
    document.addEventListener("click", async (e) => {
      const b = e.target && e.target.closest ? e.target.closest("button[data-cult-quick]") : null;
      if(!b) return;
      if(b.disabled) return;
      const tk = String(b.getAttribute("data-typekey")||"");
      const E = cultEls();
      const dateISO = String(E.quickDate && E.quickDate.value ? E.quickDate.value : "").trim() || todayISO();
      const unlock = lockBtn(b);
      try{
        // If custom type key, pass a friendly label when possible
        const label = isCustomKey_(tk) ? typeDisplayName_(tk) : "";
        let rec = (CULT.records||[]).find(r=>String(r.dateISO||"")===dateISO && String(r.typeKey||"")===tk && String(r.__state||"")==="failed") || null;
        if(!rec){
          const pending = (CULT.records||[]).some(r=>String(r.dateISO||"")===dateISO && String(r.typeKey||"")===tk && String(r.__state||"")==="pending");
          if(pending || cultHasDoneForDate_(dateISO, tk)) return;
          rec = cultApplyLocalAdd_({ tmpId: cultTmpId_(), dateISO, typeKey: tk, typeLabel: label, note:"", proofUrl:"" });
        }else{
          rec.__state = "pending";
          try{ cultOutboxMark_(rec, "pending", ""); }catch(_e){}
        }

        // instant UI
        renderQuickBtns_(E.quickBtns);
        renderProgress_();
        renderArchived_();
        renderTable_();
        updateQuickDisabled_();

        toast("ok", typeDisplayName_(tk) + " is syncing.");
        const synced = await cultSyncAddRecord_(rec);
        try{ renderQuickBtns_(); renderProgress_(); renderArchived_(); renderTable_(); updateQuickDisabled_(); }catch(_e){}
        if(synced){
          toast("ok", typeDisplayName_(tk) + " saved.");
          setMsg(E.ok, "Cultivation accepted by the server.", true);
        }else{
          setMsg(E.msg, "The +1 was not accepted yet. Tap Retry sync when the connection is ready.", false);
        }
      }catch(err){
        const m = (err && err.message) ? err.message : String(err);
        try{ setMsg(cultEls().msg, m, false); }
        catch(_e){ toast("err", m); }
      }finally{ unlock(); try{ updateQuickDisabled_(); }catch(_e){} }
    });

    // Table row actions (edit/delete/retry/discard)
    document.addEventListener("click", async (e) => {
      const btn = e.target && e.target.closest ? e.target.closest("button[data-act][data-id]") : null;
      if(!btn) return;
      const act = String(btn.getAttribute("data-act")||"");
      const id = String(btn.getAttribute("data-id")||"");
      if(!id) return;

      const rec = (CULT.records||[]).find(x=>String(x.logId||"")===id) || null;

      if(act === "edit"){
        if(cultIsTmpId_(id)){
          toast("err","Not synced yet. Retry first.");
          return;
        }
        openEditModal_(id);
        return;
      }

      if(act === "discard"){
        if(!confirm("Discard this record?")) return;
        const unlock = lockBtn(btn);
        try{
          const removed = cultRemoveLocalRecord_(id);
          if(removed){
            cultLocalDropSummaryOnDiscard_(removed.typeKey, removed.dateISO);
            renderProgress_(); renderArchived_(); renderTable_(); updateQuickDisabled_();
          }
          toast("ok","Discarded.");
        }finally{ unlock(); }
        return;
      }

      if(act === "retry"){
        const unlock = lockBtn(btn);
        try{
          if(!rec) return;
          rec.__state = "pending";
          renderProgress_(); renderArchived_(); renderTable_(); updateQuickDisabled_();
          await cultSyncAddRecord_(rec);
          renderProgress_(); renderArchived_(); renderTable_(); updateQuickDisabled_();
        }finally{ unlock(); }
        return;
      }

      if(act === "del"){
        // If it's an optimistic local record, discard locally instead
        if(cultIsTmpId_(id)){
          if(!confirm("Discard this unsynced record?")) return;
          const removed = cultRemoveLocalRecord_(id);
          if(removed){
            cultLocalDropSummaryOnDiscard_(removed.typeKey, removed.dateISO);
            renderProgress_(); renderArchived_(); renderTable_(); updateQuickDisabled_();
          }
          toast("ok","Discarded.");
          return;
        }

        if(!confirm("Delete this record?")) return;
        const unlock = lockBtn(btn);
        try{
          await rpc("cultDeleteLog", { logId: id });
          toast("ok","Deleted.");
          await cultReloadLite(true);
        }catch(err){
          toast("err", (err && err.message) ? err.message : String(err));
        }finally{ unlock(); }
      }
    });

    // Progress card actions
    document.addEventListener("click", async (e) => {
      const btn = e.target && e.target.closest ? e.target.closest("[data-cult-card] button[data-act]") : null;
      if(!btn) return;
      const card = btn.closest("[data-cult-card]");
      if(!card) return;
      const tk = String(card.getAttribute("data-typekey")||"");
      const act = String(btn.getAttribute("data-act")||"");
      const name = typeDisplayName_(tk);
      const unlock = lockBtn(btn);
      try{
        if(act === "target"){
          const s = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
          const cur = s ? Number(s.targetBase||108) || 108 : 108;
          const v = prompt("Set target days for " + name + " (enter 0 to reset):", String(cur));
          if(v == null) return;
          const n = Number(String(v).trim());
          if(isNaN(n) || n < 0) throw new Error("Target must be 0 or a positive number.");
          await rpc("cultSetTarget", { typeKey: tk, targetDays: n });
          toast("ok","Target updated.");
          await cultReloadLite(true);
          return;
        }
        if(act === "missed"){
          const v = prompt("How many consecutive days did you miss for " + name + "? Rule: days 1-2 add 3 days each, days 3-6 add 7 days each, and day 7 restarts from zero.", "1");
          if(v == null) return;
          const n = Number(String(v).trim());
          if(!Number.isFinite(n) || n < 1) throw new Error("Missed days must be 1 or more.");
          const restart = n >= 7;
          let penaltyDays = 0;
          if(!restart){
            for(let i=1;i<=n;i++) penaltyDays += (i <= 2 ? 3 : 7);
          }
          await cultRpcAny_("cultApplyMissed", Object.assign({ typeKey: tk, missedDays: n, penaltyDays, restart }, cultTzPayload_()));
          toast("ok", restart ? "Restart applied." : ("Penalty applied: +" + penaltyDays + " days."));
          await cultReloadLite(true, { fullHistory: !!CULT.fullHistoryLoaded });
          return;
        }

        if(act === "rename"){
          const cur = typeDisplayName_(tk);
          const v = prompt("Rename cultivation item:", cur);
          if(v == null) return;
          const nn = String(v).trim();
          if(!nn){
            if(!confirm("Clear custom name for '" + cur + "'?")) return;
          }
          await rpc("cultRenameType", { typeKey: tk, displayName: nn });
          toast("ok","Name saved.");
          await cultReloadLite(false);
          return;
        }

        if(act === "archive"){
          if(!confirm("Archive '" + name + "'? It will move to Achievements.")) return;
          await rpc("cultArchiveType", { typeKey: tk });
          // local stickiness (even if backend is still on an older deployment / cache)
          try{ cultSetArchiveOverride_(tk, true); }catch(_e){}
          // optimistic UI (so user sees it immediately even if reload fails)
          try{
            const s = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
            if(s){ s.archived = true; s.archivedAt = new Date().toISOString(); }
            renderProgress_(); renderArchived_(); renderQuickBtns_(); updateQuickDisabled_();
          }catch(_e){}
          try{ setMsg(cultEls().ok, "Archived.", true); }catch(_e){ toast("ok","Archived."); }
          try{ await cultReloadLite(true); }catch(_e){}
          return;
        }
        if(act === "unarchive"){
          await rpc("cultUnarchiveType", { typeKey: tk });
          try{ cultSetArchiveOverride_(tk, false); }catch(_e){}
          try{
            const s = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
            if(s){ s.archived = false; s.archivedAt = ""; }
            renderProgress_(); renderArchived_(); renderQuickBtns_(); updateQuickDisabled_();
          }catch(_e){}
          try{ setMsg(cultEls().ok, "Unarchived.", true); }catch(_e){ toast("ok","Unarchived."); }
          try{ await cultReloadLite(true); }catch(_e){}
          return;
        }

        if(act === "rename"){
          const cur = typeDisplayName_(tk);
          const v = prompt("Rename cultivation item:", cur);
          if(v == null) return;
          const nn = String(v).trim();
          if(!nn){
            if(!confirm("Clear custom name for '" + cur + "'?")) return;
          }
          await rpc("cultRenameType", { typeKey: tk, displayName: nn });
          toast("ok","Name saved.");
          await cultReloadLite(false);
          return;
        }

        if(act === "deleteType"){
          if(!confirm("Delete cultivation '" + name + "' (all its logs, penalties, targets)?")) return;
          await rpc("cultDeleteType", { typeKey: tk });
          toast("ok","Deleted cultivation.");
          await cultReloadLite(true);
          return;
        }
      }catch(err){
        const msg = (err && err.message) ? err.message : String(err);
        try{ setMsg(cultEls().msg, msg, false); }catch(_e){ toast("err", msg); }
      }finally{ unlock(); }
    });

    // Achievements (Archived) table actions (unarchive/delete)
    document.addEventListener("click", async (e) => {
      const btn = e.target && e.target.closest ? e.target.closest("#slbCultArchivedList button[data-act]") : null;
      if(!btn) return;
      const row = btn.closest("tr[data-typekey]");
      if(!row) return;
      const tk = String(row.getAttribute("data-typekey")||"");
      const act = String(btn.getAttribute("data-act")||"");
      const name = typeDisplayName_(tk);
      const unlock = lockBtn(btn);
      try{
        if(act === "unarchive"){
          if(!confirm("Move '" + name + "' back to active progress?")) return;
          await rpc("cultUnarchiveType", { typeKey: tk });
          try{ cultSetArchiveOverride_(tk, false); }catch(_e){}
          try{
            const s = (CULT.summaries||[]).find(x=>String(x.typeKey||"")===tk);
            if(s){ s.archived = false; s.archivedAt = ""; }
            renderProgress_(); renderArchived_(); renderQuickBtns_(); updateQuickDisabled_();
          }catch(_e){}
          try{ setMsg(cultEls().ok, "Unarchived.", true); }catch(_e){ toast("ok","Unarchived."); }
          try{ await cultReloadLite(true); }catch(_e){}
          return;
        }

        if(act === "deleteType"){
          if(!confirm("Delete achievement '" + name + "' (all its logs, penalties, targets)?")) return;
          await rpc("cultDeleteType", { typeKey: tk });
          toast("ok","Deleted cultivation.");
          await cultReloadLite(true);
          return;
        }

      }catch(err){
        const msg = (err && err.message) ? err.message : String(err);
        try{ setMsg(cultEls().msg, msg, false); }catch(_e){ toast("err", msg); }
      }finally{ unlock(); }
    });

    
    // Admin helper: show current progress for selected disciple+type
    async function cultAdmRefreshCurrent_(){
      const E = cultEls();
      if(!E || !E.admCurrent) return null;
      try{
        const callsign = String(E.admUser ? E.admUser.value : "").trim().toUpperCase();
        if(!callsign){ E.admCurrent.textContent = "Current: —"; return null; }

        let tt = null;
        try{ tt = collectType_(E.admType, E.admCustomInput); }catch(_e){ tt = null; }
        const typeKey = String(tt && tt.typeKey || "").trim();
        if(!typeKey){ E.admCurrent.textContent = "Current: —"; return null; }

        const sum = await rpc("adminCultGetSummary", { callsign: callsign, typeKey: typeKey });
        const done = Math.max(0, parseInt((sum && sum.doneDays) || 0, 10) || 0);
        const total = Math.max(1, parseInt((sum && (sum.targetTotal || sum.targetBase || sum.targetDays)) || 108, 10) || 108);
        const penalty = Math.max(0, parseInt((sum && sum.penaltyDays) || 0, 10) || 0);
        const status = String((sum && sum.status) || "").trim();

        let extra = "";
        if(penalty > 0) extra += " (+penalty " + penalty + ")";
        if(status) extra += " • " + status;

        E.admCurrent.textContent = "Current: " + done + "/" + total + extra;
        return { sum: sum, done: done, total: total, typeKey: typeKey, callsign: callsign };
      }catch(err){
        try{ E.admCurrent.textContent = "Current: (error)"; }catch(_e){}
        return null;
      }
    }

    function cultAdmFillFromCurrent_(cur){
      const E = cultEls();
      if(!E || !cur) return;
      try{ if(E.admSetDone) E.admSetDone.value = String(cur.done); }catch(_e){}
      try{ if(E.admSetTotal) E.admSetTotal.value = String(cur.total); }catch(_e){}
    }

// Admin: adjust baseline
    onOnce("slbCultAdmUser","change", () => { try{ cultAdmRefreshCurrent_(); }catch(_e){} });
    onOnce("slbCultAdmType","change", (e) => {
      const E = cultEls();
      if(String(e && e.target && e.target.value) === "CUSTOM") toggleCustom_(E.admType, E.admCustomRow, E.admCustomInput, true);
      try{ cultAdmRefreshCurrent_(); }catch(_e){}
    });
    onOnce("slbCultAdmCustomBack","click", () => {
      const E = cultEls();
      if(E.admType){
        const first = E.admType.querySelector("option");
        if(first) E.admType.value = first.value;
      }
      if(E.admCustomInput) E.admCustomInput.value = "";
      toggleCustom_(E.admType, E.admCustomRow, E.admCustomInput, false);
    });

    onOnce("slbCultAdmSave","click", async () => {
      const E = cultEls();
      clearMsg(E.admMsg); clearMsg(E.admOk);
      const unlock = lockBtn(E.admSave);
      try{
        if(!S.isAdmin) throw new Error("Admin only.");
        const callsign = String(E.admUser ? E.admUser.value : "").trim().toUpperCase();
        if(!callsign) throw new Error("Disciple missing.");
        const tt = collectType_(E.admType, E.admCustomInput);
        const baseDoneDays = Number(E.admDone ? E.admDone.value : 0) || 0;
        const baseLastDateISO = String(E.admLast ? E.admLast.value : "").trim();
        const note = String(E.admNote ? E.admNote.value : "").trim();
        await rpc("adminCultAdjust", { callsign, typeKey: tt.typeKey, typeLabel: (tt.typeLabel||""), baseDoneDays, baseLastDateISO, note });
        toast("ok","Baseline saved.");
        setMsg(E.admOk, "Saved.", true);
      }catch(err){
        toast("err", (err && err.message) ? err.message : String(err));
        setMsg(E.admMsg, err.message || String(err), false);
      }finally{ unlock(); }
    });

    
    onOnce("slbCultAdmImportBtn","click", async () => {
      const E = cultEls();
      clearMsg(E.admImportMsg); clearMsg(E.admImportOk);
      const unlock = lockBtn(E.admImportBtn);
      try{
        if(!S.isAdmin) throw new Error("Admin only.");
        const callsign = String(E.admUser ? E.admUser.value : "").trim().toUpperCase();
        if(!callsign) throw new Error("Disciple missing.");
        const f = E.admImportFile && E.admImportFile.files ? E.admImportFile.files[0] : null;
        if(!f) throw new Error("Please choose a CSV file first.");

        const text = await new Promise((resolve,reject)=>{
          const fr = new FileReader();
          fr.onload = () => resolve(String(fr.result||""));
          fr.onerror = () => reject(new Error("Failed to read file."));
          fr.readAsText(f);
        });

        const res = await rpc("adminCultImportCsv", { callsign: callsign, csvText: text });
        const a = Number(res && res.addedLogs || 0);
        const b = Number(res && res.addedTargets || 0);
        const c = Number(res && res.addedAdjust || 0);
        const d = Number(res && res.addedEvents || 0);

        setMsg(E.admImportOk, "Imported. Added logs: " + a + ", targets: " + b + ", baseline: " + c + ", events: " + d, true);
        await cultReloadLite(true);
      }catch(err){
        setMsg(E.admImportMsg, (err && err.message) ? err.message : String(err), false);
      }finally{ unlock(); }
    });

onOnce("slbCultAdmDeleteType","click", async () => {
      const E = cultEls();
      clearMsg(E.admMsg); clearMsg(E.admOk);
      const unlock = lockBtn(E.admDeleteType);
      try{
        if(!S.isAdmin) throw new Error("Admin only.");
        const callsign = String(E.admUser ? E.admUser.value : "").trim().toUpperCase();
        if(!callsign) throw new Error("Disciple missing.");
        const tt = collectType_(E.admType, E.admCustomInput);
        const name = tt.typeLabel || tt.typeKey;
        if(!confirm(`Delete ${name} for ${callsign}? This will remove that cultivation logs / penalties / targets for the disciple.`)) return;
        await rpc("adminCultDeleteType", { callsign, typeKey: tt.typeKey });
        toast("ok","Cultivation deleted for disciple.");
        setMsg(E.admOk, "Deleted.", true);
      }catch(err){
        toast("err", (err && err.message) ? err.message : String(err));
        setMsg(E.admMsg, err.message || String(err), false);
      }finally{ unlock(); }
    });

    
    onOnce("slbCultAdmFillFromCurrent","click", async () => {
      try{
        const cur = await cultAdmRefreshCurrent_();
        cultAdmFillFromCurrent_(cur);
      }catch(_e){}
    });

    onOnce("slbCultAdmReloadLists","click", async () => {
      try{
        await loadCultivations(true);
        try{ cultAdmRefreshCurrent_(); }catch(_e){}
      }catch(_e){}
    });

    onOnce("slbCultAdmCustomAdjust","click", async () => {
      const E = cultEls();
      clearMsg(E.admMsg); clearMsg(E.admOk);
      const unlock = lockBtn(E.admCustomAdjust || E.admSave);
      try{
        if(!S.isAdmin) throw new Error("Admin only.");
        const callsign = String(E.admUser ? E.admUser.value : "").trim().toUpperCase();
        if(!callsign) throw new Error("Disciple missing.");
        const tt = collectType_(E.admType, E.admCustomInput);

        const doneDays = Math.max(0, Math.floor(Number(E.admSetDone ? E.admSetDone.value : 0) || 0));
        const totalDays = Math.max(1, Math.floor(Number(E.admSetTotal ? E.admSetTotal.value : 0) || 0));
        const note = String(E.admNote ? E.admNote.value : "").trim();
        const baseLastDateISO = todayISO();

        await rpc("adminCultCustomAdjust", { callsign, typeKey: tt.typeKey, typeLabel: (tt.typeLabel||""), doneDays, totalDays, baseLastDateISO, note });
        toast("ok","Admin adjust applied.");
        setMsg(E.admOk, "Adjusted.", true);

        await cultAdmRefreshCurrent_();
        try{ if(typeof loadAdminCultOverviewAll === "function") await loadAdminCultOverviewAll(); }catch(_e){}
      }catch(err){
        toast("err", (err && err.message) ? err.message : String(err));
        setMsg(E.admMsg, err.message || String(err), false);
      }finally{ unlock(); }
    });

// Export
    onOnce("tywExportBtn","click", async () => {
  const m = el("tywExportMsg");
  const ok = el("tywExportOk");
  clearMsg(m); clearMsg(ok);

  try{
    setBusy(true);

    // Try common backend action names (in case Apps Script renamed it)
    const EXPORT_ACTIONS = [
      "exportCsv","exportCSV","exportUserCsv","exportBackup","backupCsv",
      "downloadCsv","export","backup"
    ];

    // Use your existing action auto-detect helper (same as Phase 3)
    const res0 = await rpcTryCached("exportCsv", EXPORT_ACTIONS, {});
    const res = (res0 && res0.data) ? res0.data : res0;

    // Accept many possible payload keys
    let csv =
      (res && (res.csvText || res.csv || res.text || res.content || res.body)) ||
      (res && res.payload && (res.payload.csvText || res.payload.csv || res.payload.text)) ||
      "";

    if(Array.isArray(csv)) csv = csv.join("\n");
    if(typeof csv !== "string") csv = String(csv || "");

    // If backend returns a direct file URL instead of raw CSV text
    const fileUrl = res && (res.fileUrl || res.downloadUrl || res.url);
    if(!csv.trim()){
      if(fileUrl){
        window.open(fileUrl, "_blank", "noopener");
        setMsg(ok, "Export opened in a new tab.", true);
        return;
      }

      const keys = (res && typeof res === "object")
        ? Object.keys(res).slice(0, 25).join(", ")
        : "(not an object)";
      throw new Error("No CSV returned. Backend returned keys: " + keys);
    }

    // Add BOM for Excel friendliness
    if(csv.charCodeAt(0) !== 0xFEFF) csv = "\uFEFF" + csv;

    const fileName =
      (res && (res.fileName || res.filename || res.name)) ||
      ("tyw-backup-" + new Date().toISOString().slice(0,10) + ".csv");

    const blob = new Blob([csv], { type:"text/csv;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    setMsg(ok, "CSV downloaded: " + fileName, true);
  }catch(e){
    setMsg(m, e.message || String(e), false);
  }finally{
    setBusy(false);
  }
});


    // ====== Refresh + Logout (status strip) ======
    onOnce("tywRefreshIcon","click", async () => {
      try{
        setBusy(true);
        setText("tywStatus", "Refreshing...");

        // Clear local caches so stale content can't stick (Ctrl+F5 does NOT clear localStorage)
        try{
          for(var i=localStorage.length-1;i>=0;i--){
            var k = localStorage.key(i);
            if(!k) continue;
            if(k.indexOf('slb_pagecache_') === 0) localStorage.removeItem(k);
            if(k === 'slb.anniv.items.v1') localStorage.removeItem(k);
          }
        }catch(_e){}

        await refreshBackendStatus();
        if(S.token){
          await refreshDashboard();
          // also refresh phase3 current panel quickly
          const now = root.querySelector("[data-panel]:not(.hidden)");
          const tab = now ? now.getAttribute("data-panel") : "myCabin";
          if(tab === "offer") await loadMyOffers();
          if(tab === "market") await loadMarket();
          if(tab === "orders") await loadMyOrders();
          if(tab === "sales") await loadMySales();

          // Force-refresh Anniversaries block if it exists on this page
          try{ if(window.SLB && SLB.__annivLoad) SLB.__annivLoad(true); }catch(_e){}

        }
        setText("tywStatus", "Ready");
      }catch(e){
        setText("tywStatus", "Error");
        alert(e.message || String(e));
      }finally{
        setBusy(false);
      }
    });

    onOnce("tywLogoutLink","click", (e) => {
      e.preventDefault();

      // HARD logout reset: prevent cross-account UI + cache bleed (esp. CHAT).
      try{ sessionStorage.clear(); }catch(_e0){}
      try{
        for(var i=localStorage.length-1;i>=0;i--){
          var k = localStorage.key(i);
          if(!k) continue;
          if(k.indexOf('slb_pagecache_') === 0) localStorage.removeItem(k);
          if(k.indexOf('slb_chat_seen_') === 0) localStorage.removeItem(k);
          if(k.indexOf('slb_warm_cache_') === 0) localStorage.removeItem(k);
          if(k.indexOf('slb_offline_') === 0) localStorage.removeItem(k);
          if(k.indexOf('slb_tre_ops_') === 0) localStorage.removeItem(k);
          if(k === 'slb_outbox_meta_v1') localStorage.removeItem(k);
        }
      }catch(_e1){}

      try{ slbClearSharedAuth_(); }catch(_e){}
      try{ if(window.SLB_OFFAUTH && SLB_OFFAUTH.clear) SLB_OFFAUTH.clear(); }catch(_e2){}

      S.token = ""; S.callsign=""; S.displayName=""; S.isAdmin=false; S.isModerator=false; S.canCreatePouches=false; S.dash=null;
      closeAllDrops();
      showLogin();

      // Force a full reload (clears in-memory module state) without requiring users to clear browser data.
      try{
        var base = (location.href || "").split("#")[0];
        var glue = (base.indexOf("?") >= 0) ? "&" : "?";
        location.replace(base + glue + "_slb_logout=" + Date.now());
      }catch(_e3){
        try{ location.reload(); }catch(_e4){}
      }
    });

// Retry backend connection (when blocked/offline)
onOnce("slbRetryBtn","click", async () => {
  try{
    setBusy(true);
    if(BOOT){ BOOT.showSteps(); BOOT.setStep(2,"active"); BOOT.setLine("Retrying…"); }
    const res = await refreshBackendStatus();
    if(res){
      toast("ok","Connected.");
      // If we already have a token, try to recover the session quickly.
      if(S.token){
        const _fast = (function(){ try{ return !!window.__SLB_FASTBOOT__; }catch(_e){ return false; } })();
        if(BOOT){ BOOT.setStep(3,"active"); BOOT.setLine(_fast ? "Restoring your session…" : "Loading your data…"); }

        if(_fast){
          try{ Promise.resolve(refreshDashboardLite()).catch(()=>{}); }catch(_e){}
          try{ setTimeout(()=>{ try{ Promise.resolve(reloadTxnsFirstPage()).catch(()=>{}); }catch(_e){} }, 50); }catch(_e){}
          showApp();
          if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); }
        }else{
          await refreshDashboard();
          showApp();
          if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); }
        }
      }
    }
  }catch(e){
    toast("err", (e && e.message) ? e.message : String(e));
  }finally{
    setBusy(false);
  }
});

    // ====== Login wiring ======
    function doLogin(){ const b = el("tywLoginBtn"); if(b) b.click(); }
    onOnce("tywPin","keydown", (e) => { if(e.key === "Enter") doLogin(); });
    onOnce("tywCallsign","keydown", (e) => { if(e.key === "Enter") doLogin(); });

    onOnce("tywLoginBtn","click", async () => {
      const msg = el("tywLoginMsg");
      clearMsg(msg);

      const callsign = cleanCallsign(el("tywCallsign").value || "");
      const pin = cleanPin(el("tywPin").value || "");

      if(!callsign) return setMsg(msg, "Callsign required.", false);
      if(pin.length !== 4) return setMsg(msg, "PIN must be 4 digits.", false);

      if(navigator && navigator.onLine === false){
        setMsg(msg, "Offline sign-in is disabled for security. Connect to the internet and log in.", false);
        return;
      }

      try{
        setBusy(true);
        if(BOOT){ BOOT.showSteps(); BOOT.hideConn(); BOOT.setStep(1,"done"); BOOT.setStep(2,"done"); BOOT.setStep(3,"active"); BOOT.setLine("Loading your data…"); }
        setMsg(msg, "Logging in...", true);

        let bundle = null;
        try{ bundle = await rpc("loginBundle", {callsign, pin}); }catch(_e){ bundle = null; }

        if(bundle && bundle.token && bundle.dash){
          S.token = bundle.token;
          sessionStorage.setItem("tyw_token", S.token);
          applyDashboard(bundle.dash);
          try{
            const r = el("tywRemember");
            if(r && r.checked){
              localStorage.setItem(SAVE_LOGIN_KEY, JSON.stringify({ callsign }));
            }else{
              localStorage.removeItem(SAVE_LOGIN_KEY);

// Clear any legacy offline-security state.
              try{ if(window.SLB_OFFAUTH && SLB_OFFAUTH.clear) SLB_OFFAUTH.clear(); }catch(_e3){}
            }
          }catch(_e){}
          if(msg) msg.classList.add("hidden");
          showApp();
          if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); }
          // Phase 3 tabs are lazy-loaded on open (faster login)
          return;
        }

        const res = await rpc("login", {callsign, pin});
        if(res && res.build){
          try{ S.backendBuild = res.build; }catch(_e){}
          setBuildText(res.build);
        }
        S.token = res.token;
        sessionStorage.setItem("tyw_token", S.token);

        setMsg(msg, "Loading dashboard...", true);
        await refreshDashboard();

        // Remember callsign only if user opted in
        try{
          const r = el("tywRemember");
          if(r && r.checked){
            localStorage.setItem(SAVE_LOGIN_KEY, JSON.stringify({ callsign }));
          }else{
            localStorage.removeItem(SAVE_LOGIN_KEY);
try{ if(window.SLB_OFFAUTH && SLB_OFFAUTH.clear) SLB_OFFAUTH.clear(); }catch(_e3){}
          }
        }catch(_e){}
        if(msg) msg.classList.add("hidden");
        showApp();
        if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); }
        // Phase 3 tabs are lazy-loaded on open (faster login)
      }catch(e){
        setMsg(msg, e.message || String(e), false);
        if(BOOT){ BOOT.setStep(3,"waiting"); BOOT.setLine("Ready. Please log in."); }
      }finally{
        setBusy(false);
      }
    });

    // ====== Boot ======


    // ====== Admin wiring (Awards / Payroll / User Management) ======


// Roster (Admin)
    onOnce("tywAdmRosterReloadBtn","click", async () => {
      if(!S.isAdminOrMod) return;
      try{ setBusy(true); await loadAdminRoster(); await loadAdminCultOverviewAll(); }
      catch(e){ /* errors shown inside loadAdminRoster */ }
      finally{ setBusy(false); }
    });
    onOnce("tywAdmRosterSearch","input", () => {
      try{ renderAdminRoster(); }catch(_e){}
    });

    
    // Cultivation Overview (Admin/Moderator)
    onOnce("slbAdmCultOverviewReloadBtn","click", async () => {
      if(!S.isAdminOrMod) return;
      try{ setBusy(true); await loadAdminCultOverviewAll(); }
      catch(e){ /* errors shown inside loadAdminCultOverviewAll */ }
      finally{ setBusy(false); }
    });
    onOnce("slbAdmCultOverviewSearch","input", () => { try{ renderAdminCultOverviewAll(); }catch(_e){} });

    // Cultivation Overview tools (Expand all / Collapse all) - event delegation
    try{
      if(root && !root.__slbCultOvTools){
        root.__slbCultOvTools = true;
        root.addEventListener("click", function(e){
          const btn = e && e.target && e.target.closest ? e.target.closest(".slbCultOvBtn") : null;
          if(!btn) return;
          const act = btn.getAttribute("data-act") || "";
          const body = el("slbAdmCultOverviewBody");
          if(!body) return;
          const items = body.querySelectorAll("details.slbCultOvItem");
          if(!items || !items.length) return;
          if(act === "expand"){
            items.forEach(d=>{ try{ d.open = true; }catch(_e){} });
          }else if(act === "collapse"){
            items.forEach(d=>{ try{ d.open = false; }catch(_e){} });
          }else{
            return;
          }
          try{ e.preventDefault(); }catch(_e){}
        }, true);
      }
    }catch(_e){}

// Auto-load roster when opening the page
    document.addEventListener("click", function(e){
      const b = e.target.closest && e.target.closest(".admNavBtn");
      if(!b) return;
      const k = (b.getAttribute("data-adm") || "");

      // Roster page
      if(k === "roster"){
        if(!S.adminRoster) loadAdminRoster().catch(()=>{});
        else renderAdminRoster();
        if(!S.adminCultOverviewAll) loadAdminCultOverviewAll().catch(()=>{});
        else renderAdminCultOverviewAll();
        return;
      }

      // Disciples page (admin + moderator)
      if(k === "disciples"){
        if(!S.adminDisciples) loadAdminDisciples(true).catch(()=>{});
        else discRender_();
        return;
      }

      // Cultivations admin page: always show the overview card (admin + moderator)
      if(k === "cult"){
        if(!S.adminCultOverviewAll) loadAdminCultOverviewAll().catch(()=>{});
        else renderAdminCultOverviewAll();
        // Admin-only: ensure baseline tool dropdowns have data
        try{
          if(S.isAdmin) loadCultivations(false).catch(()=>{});
        }catch(_e){}
        return;
      }
    });


// Reload disciple names without disturbing the currently loaded target.
    onOnce("tywAdmReloadNamesBtn","click", async () => {
      if(!slbIsAdmin_()) return;
      try{ await loadAdminUsers(true); }catch(e){ setMsg(el("tywAdmMsg"), (e && (e.message||String(e))) || "Name reload failed.", false); }
    });

// Load User button
    onOnce("tywAdmLoadUserBtn","click", async () => {
      if(!slbIsAdmin_()) return;
      try{
        setBusy(true);
        // IMPORTANT: scope the target select to the Admin panel to avoid duplicate IDs in Shopify wrappers.
        const adm = (root.querySelector("#tywAdminPanel") || root);
        const btn = adm.querySelector("#tywAdmLoadUserBtn") || el("tywAdmLoadUserBtn");
        const sel = (btn && btn.closest(".col") ? btn.closest(".col").querySelector("#tywAdmUserSelect") : null) || adm.querySelector("#tywAdmUserSelect") || el("tywAdmUserSelect");
        const forced = sel ? sel.value : "";

        // Refresh the names, but never restore an empty stale selection over the
        // valid self/target selection chosen by the refreshed list.
        try{ await loadAdminUsers(); }catch(_e){}
        const selFix = (sel || adm.querySelector("#tywAdmUserSelect") || el("tywAdmUserSelect"));
        const resolved = cleanCallsign(forced || (selFix ? selFix.value : "") || S.adminTarget || S.callsign || "");
        try{ if(selFix && resolved) selFix.value = resolved; }catch(_e){}

        await loadAdminTarget(resolved);
      }catch(e){
        // show error instead of swallowing
        setMsg(el("tywAdmMsg"), (e && (e.message||String(e))) || "Load failed.", false);
      }finally{
        setBusy(false);
      }
    });

    // Save pouch permission
    onOnce("tywAdmSavePouchPermBtn","click", async () => {
      if(!slbIsAdmin_()) return;
      const target = String(S.adminTarget||"").trim().toUpperCase();
      if(!target) return setMsg(el("tywAdmMsg"), "Load a user first.", false);
      const allow = !!(el("tywAdmAllowPouches") && el("tywAdmAllowPouches").checked);
      try{
        setBusy(true);
        await rpcTryCached("adminSetPouchCreation", ["adminSetPouchCreation"], { callsign: target, allow: allow ? "1" : "0" });
        // reload target
        await loadAdminTarget();
        setMsg(el("tywAdmOk"), "Permission updated.", true);
      }catch(e){
        setMsg(el("tywAdmMsg"), e.message || String(e), false);
      }finally{
        setBusy(false);
      }
    });


    onOnce("tywAdmSaveModeratorBtn","click", async () => {
      if(!slbIsAdmin_()) return;

      const adm = (root.querySelector("#tywAdminPanel") || root);
      const sel = adm.querySelector("#tywAdmUserSelect") || el("tywAdmUserSelect");

      // Prefer the already-loaded target; fallback to current select.
      const targetCs = cleanCallsign(String((S.adminTarget || (sel ? sel.value : "")) || "").trim().toUpperCase());
      if(!targetCs){ setMsg(el("tywAdmModeratorMsg"), "Pick a user first.", false); return; }

      const cb = (adm.querySelector("#tywAdmIsModerator") || el("tywAdmIsModerator"));
      const allow = !!(cb && cb.checked);

      const btn = (adm.querySelector("#tywAdmSaveModeratorBtn") || el("tywAdmSaveModeratorBtn"));

      try{
        setBusy(true);
        try{ if(btn) btn.disabled = true; }catch(_e){}
        clearMsg(el("tywAdmModeratorMsg"));
        setMsg(el("tywAdmModeratorMsg"), "Saving...", true);

        await rpc("adminSetModerator", { callsign: targetCs, allow: allow ? "1" : "0" });

        // Refresh from sheet, then refresh target view so checkbox/badge match reality.
        try{ await loadAdminUsers(); }catch(_e){}
        try{ if(sel) sel.value = targetCs; }catch(_e){}
        try{ await loadAdminTarget(targetCs); }catch(_e){}

        setMsg(el("tywAdmModeratorMsg"), (allow ? "Moderator enabled." : "Moderator disabled."), true);
      }catch(e){
        setMsg(el("tywAdmModeratorMsg"), e.message || String(e), false);
      }finally{
        try{ if(btn) btn.disabled = false; }catch(_e){}
        setBusy(false);
      }
    });


    // One-click PIN reset (Admin): generate temp PIN + copy
    onOnce("tywAdmGenPinCopyBtn","click", async () => {
      clearMsg(el("tywAdmPinMsg")); clearMsg(el("tywAdmPinOk"));
      const badge = el("tywAdmResetPinBadge");
      if(badge) badge.textContent = "—";
      if(!S.isAdmin) return toast("err","Admin only.");
      const target = String(S.adminTarget||"").trim().toUpperCase();
      if(!target) return setMsg(el("tywAdmPinMsg"), "Load a target user first (Admin → Target → Load User).", false);

      const copyText = async (text) => {
        const t = String(text||"");
        if(!t) return false;
        try{
          if(navigator.clipboard && navigator.clipboard.writeText){
            await navigator.clipboard.writeText(t);
            return true;
          }
        }catch(_e){}
        try{
          const ta = document.createElement("textarea");
          ta.value = t;
          ta.setAttribute("readonly","");
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          ta.style.top = "0";
          document.body.appendChild(ta);
          ta.select();
          const ok = document.execCommand("copy");
          document.body.removeChild(ta);
          return !!ok;
        }catch(_e2){}
        return false;
      };

      try{
        setBusy(true);
        const out = await rpcTryCached("adminResetUserPin", ["adminResetUserPin"], { callsign: target, generate: "1" });
        const pin = String((out && out.tempPin) || "").trim();
        if(!pin) throw new Error("No temp PIN returned. Try again.");
        const copied = await copyText(pin);
        if(badge) badge.textContent = "Temp PIN: " + pin + (copied ? " (copied)" : "");
        setMsg(el("tywAdmPinOk"), `Temp PIN generated for ${target}. ${copied ? "Copied." : "Copy it from the badge."}`, true);
        toast("ok", copied ? "Temp PIN copied." : "Temp PIN generated.");
      }catch(e){
        setMsg(el("tywAdmPinMsg"), e.message || String(e), false);
        toast("err", e.message || String(e));
      }finally{
        setBusy(false);
      }
    });
onOnce("tywAdmAwardReloadBtn","click", async () => {
      clearMsg(el("tywAdmAwardMsg")); clearMsg(el("tywAdmAwardOk"));
      try{ setBusy(true); await loadAdminAwards(); setMsg(el("tywAdmAwardOk"), "Reloaded.", true); }
      catch(e){ setMsg(el("tywAdmAwardMsg"), e.message || String(e), false); }
      finally{ setBusy(false); }
    });

    onOnce("tywAdmAwardCreateBtn","click", async () => {
      clearMsg(el("tywAdmAwardMsg")); clearMsg(el("tywAdmAwardOk"));
      const name = String(el("tywAdmAwardName")?.value || "").trim();
      const amt = toNum(el("tywAdmAwardAmt")?.value);
      if(!name) return setMsg(el("tywAdmAwardMsg"), "Award name required.", false);
      if(!(amt > 0)) return setMsg(el("tywAdmAwardMsg"), "Amount must be > 0.", false);
      try{
        setBusy(true);
        await rpc("adminAwardUpsert", { enabled:true, name, amount: amt });
        el("tywAdmAwardName").value = "";
        el("tywAdmAwardAmt").value = "";
        await loadAdminAwards();
        setMsg(el("tywAdmAwardOk"), "Award created.", true);
      }catch(e){
        setMsg(el("tywAdmAwardMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });

    onOnce("tywAdmPayReloadBtn","click", async () => {
      clearMsg(el("tywAdmPayMsg")); clearMsg(el("tywAdmPayOk"));
      try{ setBusy(true); await loadAdminPayroll(); setMsg(el("tywAdmPayOk"), "Reloaded.", true); }
      catch(e){ setMsg(el("tywAdmPayMsg"), e.message || String(e), false); }
      finally{ setBusy(false); }
    });

    onOnce("tywAdmPayCreateBtn","click", async () => {
      clearMsg(el("tywAdmPayMsg")); clearMsg(el("tywAdmPayOk"));
      const callsign = cleanCallsign(el("tywAdmPayCall")?.value || "");
      const accountId = String(el("tywAdmPayAcct")?.value || "").trim();
      const amount = toNum(el("tywAdmPayAmt")?.value);
      const freq = String(el("tywAdmPayFreq")?.value || "DAILY").trim().toUpperCase();
      const dow = String(el("tywAdmPayDow")?.value || "").trim();
      const dom = String(el("tywAdmPayDom")?.value || "").trim();
      const hour = String(el("tywAdmPayHour")?.value || "").trim();
      const minute = String(el("tywAdmPayMin")?.value || "").trim();
      const note = String(el("tywAdmPayNote")?.value || "").trim();
      if(!callsign) return setMsg(el("tywAdmPayMsg"), "Target callsign required.", false);
      if(!accountId) return setMsg(el("tywAdmPayMsg"), "Pick target account.", false);
      if(!Number.isFinite(amount) || amount === 0) return setMsg(el("tywAdmPayMsg"), "Amount cannot be 0.", false);
      try{
        setBusy(true);
        await rpc("adminPayrollUpsert", { enabled:true, callsign, accountId, amount, freq, dow, dom, hour, minute, tz:"America/Toronto", note });
        await loadAdminPayroll();
        setMsg(el("tywAdmPayOk"), "Payroll rule saved.", true);
      }catch(e){
        setMsg(el("tywAdmPayMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });

    onOnce("tywAdmPayRunDueBtn","click", async () => {
      clearMsg(el("tywAdmPayMsg")); clearMsg(el("tywAdmPayOk"));
      try{
        setBusy(true);
        const out = await rpc("adminPayrollRunDueNow", { forceAll:false });
        await loadAdminPayroll();
        setMsg(el("tywAdmPayOk"), `Ran due now. ${out && out.count ? out.count : ""}`.trim(), true);
      }catch(e){
        setMsg(el("tywAdmPayMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });

    onOnce("tywAdmPayForceAllBtn","click", async () => {
      clearMsg(el("tywAdmPayMsg")); clearMsg(el("tywAdmPayOk"));
      try{
        setBusy(true);
        const out = await rpc("adminPayrollRunDueNow", { forceAll:true });
        await loadAdminPayroll();
        setMsg(el("tywAdmPayOk"), `Forced all now. ${out && out.count ? out.count : ""}`.trim(), true);
      }catch(e){
        setMsg(el("tywAdmPayMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });

    onOnce("tywAdmEditSaveBtn","click", async () => {
      clearMsg(el("tywAdmEditMsg")); clearMsg(el("tywAdmEditOk"));
      const target = S.adminTarget || (el("tywAdmUserSelect")?.value || "");
      const newName = String(el("tywAdmEditName")?.value || "").trim();
      const newCall = cleanCallsign(String(el("tywAdmEditCall")?.value || "").trim());
      try{ ensureMaxLen("Display name", newName, LIMITS.displayName); if(newCall) ensureMaxLen("New callsign", newCall, 12); }catch(e){ return setMsg(el("tywAdmEditMsg"), e.message || String(e), false); }
      if(!target) return setMsg(el("tywAdmEditMsg"), "Select and load a target user first.", false);
      try{
        setBusy(true);
        const out = await rpc("adminUserUpdate", { callsign: target, newCallsign: (newCall && newCall !== target) ? newCall : "", displayName: newName });
        setMsg(el("tywAdmEditOk"), out.migrated ? `Renamed to ${out.callsign}.` : "Saved.", true);
        await loadAdminUsers();
        // reselect new callsign if migrated
        if(out && out.callsign){
          const sel = el("tywAdmUserSelect");
          if(sel) sel.value = out.callsign;
          S.adminTarget = out.callsign;
          setText("tywAdmTargetBadge", "Target: " + out.callsign);
        }
        await loadAdminTarget().catch(()=>{});
      }catch(e){
        setMsg(el("tywAdmEditMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });

    onOnce("tywAdmEditDisableBtn","click", async () => {
      clearMsg(el("tywAdmEditMsg")); clearMsg(el("tywAdmEditOk"));
      const target = S.adminTarget || (el("tywAdmUserSelect")?.value || "");
      if(!target) return setMsg(el("tywAdmEditMsg"), "Select and load a target user first.", false);
      if(!confirm("Disable this user? They will not be able to log in.")) return;
      try{
        setBusy(true);
        await rpc("adminUserDelete", { callsign: target, purge:false });
        setMsg(el("tywAdmEditOk"), "User disabled.", true);
        await loadAdminUsers();
      }catch(e){
        setMsg(el("tywAdmEditMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });

    onOnce("tywAdmEditDeleteBtn","click", async () => {
      clearMsg(el("tywAdmEditMsg")); clearMsg(el("tywAdmEditOk"));
      const target = S.adminTarget || (el("tywAdmUserSelect")?.value || "");
      if(!target) return setMsg(el("tywAdmEditMsg"), "Select and load a target user first.", false);
      if(!confirm("Purge delete this user? This is irreversible and removes all records.")) return;
      try{
        setBusy(true);
        await rpc("adminUserDelete", { callsign: target, purge:true });
        setMsg(el("tywAdmEditOk"), "User purged.", true);
        await loadAdminUsers();
        // reset target view
        S.adminTarget = "";
        S.adminDash = null;
        setText("tywAdmTargetBadge", "Target: —");
      }catch(e){
        setMsg(el("tywAdmEditMsg"), e.message || String(e), false);
      }finally{ setBusy(false); }
    });


    // ===== External bootstrap (universal overlay login -> SLB without refresh) =====
    let __slbBootstrapBusy = false;
    async function bootstrapFromSharedAuth(payload){
      if(__slbBootstrapBusy) return;
      __slbBootstrapBusy = true;
      try{
        payload = payload || {};
        let tok = "";
        try{ tok = (payload.auth && payload.auth.token) ? String(payload.auth.token || "") : ""; }catch(_e0){}
        try{ if(!tok) tok = String(sessionStorage.getItem("tyw_token") || ""); }catch(_e1){}
        if(!tok){
          try{
            const raw = localStorage.getItem("ty_auth_v1") || "";
            if(raw){ const a = JSON.parse(raw); if(a && a.token) tok = String(a.token || ""); }
          }catch(_e2){}
        }
        if(tok){
          S.token = tok;
          try{ sessionStorage.setItem("tyw_token", tok); }catch(_e3){}
        }

        try{
          let cs = "";
          try{ cs = (payload.auth && payload.auth.callsign) ? String(payload.auth.callsign || "") : ""; }catch(_eC0){}
          try{ if(!cs) cs = String(sessionStorage.getItem("tyw_callsign") || ""); }catch(_eC1){}
          if(cs){ S.callsign = String(cs).toUpperCase(); try{ sessionStorage.setItem("tyw_callsign", S.callsign); }catch(_eC2){} }
          let dn = "";
          try{ dn = (payload.auth && payload.auth.displayName) ? String(payload.auth.displayName || "") : ""; }catch(_eD0){}
          try{ if(!dn) dn = String(sessionStorage.getItem("tyw_displayName") || ""); }catch(_eD1){}
          if(dn){ S.displayName = String(dn); try{ sessionStorage.setItem("tyw_displayName", S.displayName); }catch(_eD2){} }
        }catch(_eId){}

        // V3.116: one startup owner. Status ping is decorative and never blocks the app shell.
        try{ Promise.resolve(refreshBackendStatus()).catch(function(){}); }catch(_e4){}
        try{
          if(!root.__tywKeepAlive){
            root.__tywKeepAlive = setInterval(function(){ try{ Promise.resolve(refreshBackendStatus()).catch(function(){}); }catch(_e){} }, 4 * 60 * 1000);
          }
        }catch(_eKeep){}

        if(payload.dash){
          try{ applyDashboard(payload.dash); }catch(_e5){}
        }else if(S.token){
          const _fast = (function(){ try{ return !!window.__SLB_FASTBOOT__; }catch(_e){ return false; } })();
          const loadPromise = _fast ? refreshDashboardLite() : refreshDashboard();
          try{
            Promise.resolve(loadPromise).catch(function(e){
              try{
                if(slbIsDefinitiveAuthFailure_(e)){
                  try{ sessionStorage.removeItem("tyw_token"); }catch(_e0){}
                  try{ slbClearSharedAuth_(); }catch(_e1){}
                  try{ S.token = ""; }catch(_e2){}
                  try{ showLogin(); }catch(_e3){}
                }else{
                  try{ console.warn("[SLB] Background dashboard load failed; shell remains available:", e); }catch(_e4){}
                }
              }catch(_e5){}
            });
          }catch(_e6){}
          if(_fast){
            try{ setTimeout(function(){ try{ Promise.resolve(reloadTxnsFirstPage()).catch(function(){}); }catch(_e){} }, 50); }catch(_e7){}
          }
        }

        if(S.token){
          try{ showApp(); }catch(_e8){}
          try{ if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); } }catch(_e9){}
        }else{
          try{ showLogin(); }catch(_e10){}
          try{ if(BOOT){ BOOT.setStep(3,"waiting"); BOOT.setLine("Ready. Please log in."); } }catch(_e11){}
        }
      }finally{
        __slbBootstrapBusy = false;
      }
    }

(async () => {
      // The universal page wrapper owns startup when this bridge flag is present.
      // Do not launch a second ping/dashboard flow from the bundle itself.
      try{ if(window.__SLB_BOOTSTRAP_BRIDGE__) return; }catch(_eBridge){}

      // Fast refresh login restore: when a warm token already exists, show the app shell immediately.
      // Backend ping + dashboard refresh continue in the background, so F5 does not feel like a second login.
      try{
        const _earlyFast = !!(S && S.token && (function(){ try{ return !!window.__SLB_FASTBOOT__; }catch(_e){ return false; } })());
        if(_earlyFast){
          try{ if(BOOT){ BOOT.showSteps(); BOOT.setStep(1,"done"); BOOT.setStep(2,"active"); BOOT.setStep(3,"active"); BOOT.setLine("Restoring your session…"); } }catch(_e0){}
          try{ showApp(); }catch(_e1){}
          try{ if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); } }catch(_e2){}
          try{ Promise.resolve(refreshDashboardLite()).catch((e)=>{
            try{
              if(slbIsDefinitiveAuthFailure_(e)){
                try{ sessionStorage.removeItem("tyw_token"); }catch(_e3){}
                try{ slbClearSharedAuth_(); }catch(_eShared){}
                try{ S.token = ""; }catch(_e4){}
                try{ showLogin(); }catch(_e5){}
              }
            }catch(_e6){}
          }); }catch(_e7){}
          try{ setTimeout(()=>{ try{ Promise.resolve(reloadTxnsFirstPage()).catch(()=>{}); }catch(_e8){} }, 50); }catch(_e9){}
        }
      }catch(_earlyBootErr){}
      await refreshBackendStatus();
      root.__tywKeepAlive = setInterval(() => { rpc("ping", {}).catch(()=>{}); }, 4 * 60 * 1000);

      if(S.token){
        try{
          // FastBoot: paint instantly from local cache (if any), then refresh in the background.
          const _fast = (function(){ try{ return !!window.__SLB_FASTBOOT__; }catch(_e){ return false; } })();
          if(BOOT){ BOOT.showSteps(); BOOT.setStep(3,"active"); BOOT.setLine(_fast ? "Restoring your session…" : "Loading your data…"); }

          if(_fast){
            // 1) Hydrate UI immediately (cache-first) without blocking the first paint.
            try{
              Promise.resolve(refreshDashboardLite()).catch((e)=>{
                // If token is invalid, fall back to login (avoid a broken empty UI).
                try{
                  if(slbIsDefinitiveAuthFailure_(e)){
                    try{ sessionStorage.removeItem("tyw_token"); }catch(_e0){}
                    try{ slbClearSharedAuth_(); }catch(_eShared){}
                    try{ S.token = ""; }catch(_e1){}
                    try{ showLogin(); }catch(_e2){}
                  }
                }catch(_e3){}
              });
            }catch(_e){}
            try{
              setTimeout(()=>{ try{ Promise.resolve(reloadTxnsFirstPage()).catch(()=>{}); }catch(_e){} }, 50);
            }catch(_e){}

            // 2) Show the app shell right away (router will apply hash deep link if present).
            showApp();

            // 3) Hide the hero loader fast (data continues loading inside panels).
            if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); }
          }else{
            await refreshDashboard();
            showApp();
            if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Ready."); BOOT.hideStepsSoon(); }
          }

          // Phase 3 tabs are lazy-loaded on open (faster auto-login)
        }catch(_e){
          if(!S.token || slbIsDefinitiveAuthFailure_(_e)){
            try{ sessionStorage.removeItem("tyw_token"); }catch(_eTok){}
            try{ slbClearSharedAuth_(); }catch(_eShared){}
            try{ S.token = ""; }catch(_eState){}
            if(BOOT){ BOOT.setStep(3,"waiting"); BOOT.setLine("Ready. Please log in."); }
            showLogin();
          }else{
            // Keep the authenticated shell visible on a temporary network/backend failure.
            try{ slbPersistSharedAuth_(); }catch(_ePersist){}
            try{ showApp(); }catch(_eShow){}
            if(BOOT){ BOOT.setStep(3,"done"); BOOT.setLine("Connection problem. Your login was kept."); BOOT.hideStepsSoon(); }
            try{ toast("warn","Connection problem. Your login was kept; try the page again."); }catch(_eToast){}
            try{ console.warn("[SLB] Dashboard restore failed without invalidating the login:", _e); }catch(_eLog){}
          }
        }
      }else{
        if(BOOT){ BOOT.setStep(3,"waiting"); BOOT.setLine("Ready. Please log in."); }
        showLogin();
      }



    })();
    async function cultExportCsvPublic_(){
      let csv = "", fileName = "", usedClient = false, res = null;
      try{
        try{
          const ACTIONS = ["cultExportCsv","exportCultCsv","cultivationExportCsv","cultExportCSV"];
          const res0 = await rpcTryCached("cultExportCsv", ACTIONS, {});
          res = (res0 && res0.data) ? res0.data : res0;
          csv = (res && (res.csvText || res.csv || res.text || res.content || res.body)) || "";
          if(Array.isArray(csv)) csv = csv.join("\n");
          if(typeof csv !== "string") csv = String(csv || "");
          if(!csv.trim()) throw new Error("No CSV returned.");
          const hasSummary = (csv.indexOf("\nCULT_SUMMARY,") !== -1) || (csv.indexOf("CULT_SUMMARY,") === 0);
          if(!hasSummary){ usedClient = true; csv = cultBuildCsvClient_(); }
          fileName = (res && (res.fileName || res.filename || res.name)) || ("slb-cultivation-" + String((S && S.callsign) ? S.callsign : "") + "-" + new Date().toISOString().slice(0,10) + (usedClient?"-CLIENT":"") + ".csv");
        }catch(_e){
          usedClient = true;
          csv = cultBuildCsvClient_();
          fileName = ("slb-cultivation-" + String((S && S.callsign) ? S.callsign : "") + "-" + new Date().toISOString().slice(0,10) + "-CLIENT.csv");
        }
        if(csv.charCodeAt(0) !== 0xFEFF) csv = "\uFEFF" + csv;
        const blob = new Blob([csv], { type:"text/csv;charset=utf-8" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(function(){ try{ URL.revokeObjectURL(link.href); }catch(_e){} }, 500);
        return { fileName:fileName, usedClient:usedClient };
      }catch(err){ throw err; }
    }

    // ===== Export minimal API for external patches (Market Optimistic UI) =====
    try{
      var __app = (window.SLB_APP = window.SLB_APP || {});
      var __existingRpc = __app.rpc;
      if(__existingRpc && __existingRpc.__slb_stub){ __app.__realRpc = rpc; } else { __app.rpc = rpc; }
      Object.assign(__app, {
        rpc: rpc,
        rpcTryCached: rpcTryCached,
        S: S,
        P3: P3,
        ensurePhase3ForTab: ensurePhase3ForTab,
        loadMyOffers: loadMyOffers,
        loadMarket: loadMarket,
        loadMyOrders: loadMyOrders,
        loadMySales: loadMySales,
        renderMarket: renderMarket,
        renderMyOffers: renderMyOffers,
        renderOrders: renderOrders,
        renderSales: renderSales,
        renderPhase3Tab: function(tab){
          tab = String(tab || "");
          if(tab === "market") return renderMarket();
          if(tab === "orders") return renderOrders();
          if(tab === "offer") return renderMyOffers();
          if(tab === "sales") return renderSales();
        },
        refreshDashboardLite: refreshDashboardLite,
        reloadTxnsFirstPage: reloadTxnsFirstPage,
        ensureGiftUsersLoaded: ensureGiftUsersLoaded,
        bootstrapFromSharedAuth: bootstrapFromSharedAuth,
        activateEmbeddedTab: activateEmbeddedTab_,
        openPanel: setPanel,
        bindTreasures: function(){ try{ return treBindOnce_(); }catch(_e){ return false; } },
        loadTreasures: function(force){ try{ treBindOnce_(); }catch(_e){} return treLoad_(force !== false); },
        openTreasures: async function(force){
          try{ treBindOnce_(); }catch(_e0){}
          var result = await treLoad_(force !== false);
          try{ treBindOnce_(); }catch(_e1){}
          try{ treRender_(); }catch(_e2){}
          return result;
        },
        renderTreasures: function(){ try{ treBindOnce_(); }catch(_e){} return treRender_(); },
        exportTreasuresCsv: function(){ return treExportCsv_(); },
        exportCultivationCsv: function(){ return cultExportCsvPublic_(); },
        applyTreasuresPayload: function(payload){ try{ treBindOnce_(); }catch(_e){} return treApplyPayload_(payload); },
        getTreasuresState: function(){ try{ return treState_(); }catch(_e){ return null; } },
        getTreasuresDiagnostics: function(){
          try{
            var st=treState_(), e=document.getElementById('slbTreList');
            return { bound:!!st.bound, loadedOnce:!!st.loadedOnce, loading:!!st.loading, lastFetch:Number(st.lastFetch||0), lastAttempt:Number(st.lastAttempt||0), lastError:String(st.lastError||''), itemCount:Array.isArray(st.items)?st.items.length:0, rowCount:e&&e.children?e.children.length:0, readBound:!!(document.getElementById('slbTreReadFoldBtn')||{}).__bound, writeBound:!!(document.getElementById('slbTreWriteFoldBtn')||{}).__bound };
          }catch(_e){ return null; }
        },
        treasuresIsHydrated: function(){ try{ var st=treState_(),e=document.getElementById('slbTreList'); return !!(st.loadedOnce && !st.loading && e && e.children && e.children.length); }catch(_e){ return false; } },
        refreshBoard: function(force){ return boardRefresh_(force !== false); },
        renderBoard: function(payload){ return boardRenderNotes_(payload); },
        boardIsHydrated: function(){ try{ var e = document.getElementById("slbBoardList"); return !!(e && e.__hasLoaded); }catch(_e){ return false; } },
        setBusy: setBusy,
        lockBtn: lockBtn,
        setMsg: setMsg,
        clearMsg: clearMsg,
        toast: toast,
        outbox: (typeof OUTBOX !== 'undefined' ? OUTBOX : null),
        outboxPendingCount: function(){ try{ return (OUTBOX && OUTBOX.pendingCount) ? OUTBOX.pendingCount() : 0; }catch(_e){ return 0; } },
        outboxList: function(){ try{ return (OUTBOX && OUTBOX.listMeta) ? OUTBOX.listMeta() : []; }catch(_e){ return []; } }
      });

      // If the universal page overlay already logged in before the SLB bundle finished loading,
      // it may have left a pending payload here. Bootstrap once.
      try{
        if(window.__TY_AUTH_PENDING__ && !window.__SLB_BOOTSTRAP_BRIDGE__){
          bootstrapFromSharedAuth(window.__TY_AUTH_PENDING__).catch(()=>{});
          try{ window.__TY_AUTH_PENDING__ = null; }catch(_e){}
        }
      }catch(_e){}
    }catch(_e){}


// ===== Global Outbox Sync Runner (Phase 3) =====
(function(){
  if(window.__SLB_OUTBOX_SYNC_V1__) return;
  window.__SLB_OUTBOX_SYNC_V1__ = true;

  function safeNow(){ try{ return Date.now(); }catch(_e){ return 0; } }
  function isVisible(){ try{ return document.visibilityState === "visible"; }catch(_e){ return true; } }
  function online(){ try{ return navigator.onLine !== false; }catch(_e){ return true; } }

  var busy = false;
  var timer = null;
  var OWNER = "slb_" + safeNow() + "_" + Math.random().toString(16).slice(2);

  // Phase 5: lightweight sync log (kept in memory; available for debug)
  var _log = [];
  function logPush(ev){
    try{
      _log.push(Object.assign({ ts: new Date().toISOString() }, ev||{}));
      if(_log.length > 60) _log = _log.slice(_log.length - 60);
    }catch(_e){}
  }

  function getCounts_(){
    try{
      var meta = (OUTBOX && OUTBOX.listMeta) ? OUTBOX.listMeta() : [];
      var pending = 0, failed = 0, inflight = 0, attention = 0;
      for(var i=0;i<meta.length;i++){
        var m = meta[i]; if(!m) continue;
        if(m.status === 'inflight') inflight++;
        if(m.status === 'pending') pending++;
        if(m.status === 'failed'){ failed++; if(m.needsAttention) attention++; }
      }
      return { pending: pending, failed: failed, inflight: inflight, needsAttention: attention };
    }catch(_e){ return { pending:0, failed:0, inflight:0, needsAttention:0 }; }
  }

  async function flushQueue(force){
    try{
      if(busy) return { sent:0, remaining: (OUTBOX && OUTBOX.pendingCount ? OUTBOX.pendingCount() : 0) };
      if(!OUTBOX || !OUTBOX.claimNext || !rpc) return { sent:0, remaining:0 };
      if(!force && !online()) return { sent:0, remaining: OUTBOX.pendingCount() };

      busy = true;
      try{ window.__SLB_BEFOREUNLOAD_ATTACH__ && window.__SLB_BEFOREUNLOAD_ATTACH__(); }catch(_e){}

      var sent = 0;
      var started = safeNow();
      var budget = force ? 45000 : 12000;

      var maxItems = force ? 50 : 6;

      while(true){
        if(!force && !isVisible()) break;
        if(!force && (safeNow() - started) > budget) break;

        var item = null;
        try{ item = await OUTBOX.claimNext(OWNER, force); }catch(_e){ item = null; }
        if(!item || !item.id) break;

        var payload = item.payload || {};
        var action = String(payload.action || "");
        var args = payload.args || {};

        if(!action){
          try{ OUTBOX.markFailed(item.id, "Missing payload."); }catch(_e){}
          continue;
        }

        try{
          // Disable outbox re-enqueue during flush; keep UI quiet
          await rpc(action, args, { outbox: { enabled:false }, progressMode: "silent" });
          try{ await OUTBOX.markDone(item.id); }catch(_e){}
          try{ logPush({ type:'ok', id: item.id, action: action }); }catch(_e){}
          sent++;
          if(sent >= maxItems) break;
        }catch(e){
          try{ OUTBOX.markFailed(item.id, e); }catch(_e){}
          try{ logPush({ type:'err', id: item.id, action: action, msg: String((e && e.message)?e.message:e||'') }); }catch(_e){}
          // If we drop offline, stop early and wait for resume
          if(!online()) break;
          // If server is slow, don't spin forever in auto mode
          if(!force && (safeNow() - started) > budget) break;
        }
      }

      return { sent: sent, remaining: OUTBOX.pendingCount() };
    }catch(_e){
      try{ return { sent:0, remaining: (OUTBOX && OUTBOX.pendingCount ? OUTBOX.pendingCount() : 0) }; }catch(_e2){ return { sent:0, remaining:0 }; }
    }finally{
      busy = false;
      try{ window.__SLB_BEFOREUNLOAD_DETACH__ && window.__SLB_BEFOREUNLOAD_DETACH__(); }catch(_e){}
    }
  }

  function kick(delay){
    try{
      var d = Number(delay || 700) || 700;
      setTimeout(function(){ flushQueue(false); }, d);
    }catch(_e){}
  }

  function start(){
    if(timer) return;
    timer = setInterval(function(){
      if(isVisible()) flushQueue(false);
    }, 15000);
  }

  try{
    window.addEventListener("online", function(){ flushQueue(true); });
    document.addEventListener("visibilitychange", function(){ if(isVisible()) flushQueue(false); });
  }catch(_e){}

  // Phase 5: warn user before leaving during a large upload / sync
  // NOTE: A permanently-registered beforeunload handler disables BFCache (back/forward instant restore) in many browsers.
  // We attach it ONLY while a chunk upload / outbox flush is actively running, then detach when idle.
  try{
    var __slbBUAttached = false;
    var __slbBUHandler = function(e){
      try{
        var ca = window.__SLB_CHUNK_ACTIVE__;
        if(ca && (Date.now() - Number(ca.startedAt||0)) < (10*60*1000)){
          e.preventDefault();
          e.returnValue = "";
          return "";
        }
        if(busy){
          var st = getCounts_();
          if(st && st.inflight > 0){
            e.preventDefault();
            e.returnValue = "";
            return "";
          }
        }
      }catch(_e){}
    };
    window.__SLB_BEFOREUNLOAD_ATTACH__ = function(){
      try{
        if(__slbBUAttached) return;
        __slbBUAttached = true;
        window.addEventListener("beforeunload", __slbBUHandler);
      }catch(_e){}
    };
    window.__SLB_BEFOREUNLOAD_DETACH__ = function(){
      try{
        if(!__slbBUAttached) return;
        __slbBUAttached = false;
        window.removeEventListener("beforeunload", __slbBUHandler);
      }catch(_e){}
    };
  }catch(_e){}if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){ start(); kick(900); }, { once:true });
  }else{
    start(); kick(900);
  }

  // Export for hero Sync button + diagnostics
  try{
    window.SLB_SYNC = window.SLB_SYNC || {};
    Object.assign(window.SLB_SYNC, {
      flushQueue: flushQueue,
      isBusy: function(){ return !!busy; },
      getStatus: function(){ return getCounts_(); },
      getLog: function(){ return _log.slice(); },
      clearLog: function(){ _log = []; }
    });
  }catch(_e){}

  try{
    if(window.SLB_APP){
      window.SLB_APP.outboxFlush = flushQueue;
      window.SLB_APP.outboxSyncBusy = function(){ return !!busy; };
    }
  }catch(_e){}
})();




  })();

// ===== Admin Pages Menu (V1.0 stable) =====
(function(){
  if (window.__SLB_ADM_PAGES_INIT__) return;
  window.__SLB_ADM_PAGES_INIT__ = true;

  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }

  // Auto-load helper: click Reload on Disciples page until rows appear.
  // We click the button (instead of calling internal functions) because the Disciples module is in a different closure.
  function kickDiscAutoLoad_(why){
    try{
      // Reset miss-tries on each navigation so a previous failed attempt doesn't
      // permanently disable auto-load.
      try{
        if(why === 'open' || why === 'restore') window.__SLB_DISC_AUTOLOAD_MISS_TRIES__ = 0;
      }catch(_e){}
      var btn = document.getElementById('slbAdmDiscReloadBtn');
      var body = document.getElementById('slbAdmDiscBody');

      // Elements can exist after the admin panel is opened / first rendered.
      // If missing, retry a few times.
      if(!btn || !body){
        var missTries = (window.__SLB_DISC_AUTOLOAD_MISS_TRIES__||0) + 1;
        window.__SLB_DISC_AUTOLOAD_MISS_TRIES__ = missTries;
        if(missTries <= 10) setTimeout(function(){ kickDiscAutoLoad_(why||"miss"); }, 250);
        return;
      }

      // If already filled, do nothing.
      try{
        if((body.children && body.children.length > 0) || body.querySelector('tr')) return;
      }catch(_e){}

      // Avoid spamming: only one kicker loop at a time.
      if(window.__SLB_DISC_AUTOLOAD_BUSY__){
        // If previous attempt got stuck, retry shortly.
        setTimeout(function(){
          try{
            var b=document.getElementById('slbAdmDiscBody');
            var hasRows = false;
            try{ hasRows = !!(b && (b.querySelector('tr') || (b.children && b.children.length>0))); }catch(_e){}
            if(!hasRows){ window.__SLB_DISC_AUTOLOAD_BUSY__ = false; kickDiscAutoLoad_('busyretry'); }
          }catch(_e){}
        }, 700);
        return;
      }
      window.__SLB_DISC_AUTOLOAD_BUSY__ = true;

      // Prefer calling the internal loader if it has been exposed.
      // Synthetic clicks can be blocked by some themes / overlays.
      try{
        if(typeof window.SLB_loadAdminDisciples === 'function'){
          var _p = null;
          try{ _p = window.SLB_loadAdminDisciples(true); }
          catch(_e0){ try{ window.__SLB_DISC_AUTOLOAD_BUSY__ = false; }catch(_eX){} _p = null; }
          if(_p !== null && _p !== undefined){
            Promise.resolve(_p)
              .catch(function(){})
              .finally(function(){ try{ window.__SLB_DISC_AUTOLOAD_BUSY__ = false; }catch(_e){} });
            return;
          }
        }
      }catch(_e){}

      var tries = 0;
      (function tick(){
        tries++;

        // stop if filled
        try{
          if(body.children && body.children.length > 0){
            window.__SLB_DISC_AUTOLOAD_BUSY__ = false;
            return;
          }
        }catch(_e){}

        // If button is ready, click it (will lock itself during RPC).
        // Use dispatchEvent to bypass some theme click blockers.
        try{
          if(!btn.disabled){
            try{ btn.dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window })); }
            catch(_e0){ btn.click(); }
          }
        }catch(_e2){}

        if(tries < 18){
          setTimeout(tick, 260);
        }else{
          window.__SLB_DISC_AUTOLOAD_BUSY__ = false;
        }
      })();
    }catch(_e){
      try{ window.__SLB_DISC_AUTOLOAD_BUSY__ = false; }catch(_e2){}
    }
  }

  // Auto-load helper: load Roster page data until rows appear.
  function kickRosterAutoLoad_(why){
    try{
      // Reset miss-tries on each navigation so a previous failed attempt doesn't
      // permanently disable auto-load.
      try{
        if(why === 'open' || why === 'restore') window.__SLB_ROSTER_AUTOLOAD_MISS_TRIES__ = 0;
      }catch(_e){}
      var btn = document.getElementById('tywAdmRosterReloadBtn');
      var body = document.getElementById('tywAdmRosterBody');

      if(!btn || !body){
        var missTries = (window.__SLB_ROSTER_AUTOLOAD_MISS_TRIES__||0) + 1;
        window.__SLB_ROSTER_AUTOLOAD_MISS_TRIES__ = missTries;
        if(missTries <= 10) setTimeout(function(){ kickRosterAutoLoad_(why||"miss"); }, 250);
        return;
      }

      // already filled
      try{
        if((body.children && body.children.length > 0) || body.querySelector('tr')) return;
      }catch(_e){}

      if(window.__SLB_ROSTER_AUTOLOAD_BUSY__){
        setTimeout(function(){
          try{
            var b=document.getElementById('tywAdmRosterBody');
            var hasRows=false;
            try{ hasRows = !!(b && (b.querySelector('tr') || (b.children && b.children.length>0))); }catch(_e){}
            if(!hasRows){ window.__SLB_ROSTER_AUTOLOAD_BUSY__ = false; kickRosterAutoLoad_('busyretry'); }
          }catch(_e){}
        }, 700);
        return;
      }
      window.__SLB_ROSTER_AUTOLOAD_BUSY__ = true;

      // Prefer direct loader if exposed
      try{
        if(typeof window.SLB_loadAdminRoster === 'function'){
          var _p = null;
          try{ _p = window.SLB_loadAdminRoster(); }
          catch(_e0){ try{ window.__SLB_ROSTER_AUTOLOAD_BUSY__ = false; }catch(_eX){} _p = null; }
          if(_p !== null && _p !== undefined){
            Promise.resolve(_p)
              .catch(function(){})
              .finally(function(){ try{ window.__SLB_ROSTER_AUTOLOAD_BUSY__ = false; }catch(_e){} });
            return;
          }
        }
      }catch(_e){}

      var tries = 0;
      (function tick(){
        tries++;
        try{
          if(body.children && body.children.length > 0){
            window.__SLB_ROSTER_AUTOLOAD_BUSY__ = false;
            return;
          }
        }catch(_e){}

        try{
          if(!btn.disabled){
            try{ btn.dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window })); }
            catch(_e0){ btn.click(); }
          }
        }catch(_e2){}

        if(tries < 18){
          setTimeout(tick, 260);
        }else{
          window.__SLB_ROSTER_AUTOLOAD_BUSY__ = false;
        }
      })();
    }catch(_e){
      try{ window.__SLB_ROSTER_AUTOLOAD_BUSY__ = false; }catch(_e2){}
    }
  }



  function showAdmPage(key){
    var panel = qs('#tywAdminPanel');
    if(!panel) return;

    var pages = qsa('.admPage', panel);
    var btns  = qsa('.admNavBtn', panel);

    // If a page is hidden for the current role, don't show a blank panel.
    function isVisible_(p){
      if(!p) return false;
      try{
        if(p.style && p.style.display === 'none') return false;
        var cs = window.getComputedStyle ? window.getComputedStyle(p) : null;
        if(cs && cs.display === 'none') return false;
        return true;
      }catch(_e){
        return true;
      }
    }

    try{
      var want = pages.find(function(p){ return (p.getAttribute('data-adm')===key) && isVisible_(p); });
      if(!want){
        var firstVis = pages.find(function(p){ return isVisible_(p); });
        if(firstVis) key = firstVis.getAttribute('data-adm') || key;
      }
    }catch(_e){}

    pages.forEach(function(p){ p.classList.toggle('active', p.getAttribute('data-adm')===key); });
    btns.forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-adm')===key); });

    // safety: if key not found, show first page
    var anyActive = pages.some(function(p){ return p.classList.contains('active'); });
    if(!anyActive && pages.length){
      pages[0].classList.add('active');
      var k0 = pages[0].getAttribute('data-adm');
      btns.forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-adm')===k0); });
    }

    // update deep link when switching admin sub-pages
    try{ if(window.SLB_route && window.SLB_route.sync) window.SLB_route.sync(true); }catch(_e){}

    // Auto-load Disciples list when opening the page (works even when theme blocks bubbled clicks)
    try{
      if(key === "library_telemetry" && typeof window.SLB_loadLibraryTelemetry === "function"){ setTimeout(function(){ try{ window.SLB_loadLibraryTelemetry(false); }catch(_eTel){} },0); }
      if(key === "target" && typeof window.SLB_loadAdminUsers === "function"){ setTimeout(function(){ try{ window.SLB_loadAdminUsers(false); }catch(_eUsers){} },0); }
      if(key === "adjust" && typeof window.SLB_refreshAdminAdjust === "function"){
        setTimeout(function(){ try{ window.SLB_refreshAdminAdjust(); }catch(_eAdj){} },0);
      }
      if(key === "roster"){ kickRosterAutoLoad_("open"); }
      if(key === "disciples"){ kickDiscAutoLoad_("open"); }
      if(key === "cult"){
        // Ensure Cultivation admin dropdowns (Disciple/Type) populate reliably
        var tries = 0;
        (function kick(){
          tries++;
          try{
            if(typeof loadAdminCultOverviewAll === "function"){
              if(!S.adminCultOverviewAll){ loadAdminCultOverviewAll().catch(()=>{}); }
            }
          }catch(_e2){}
          try{
            if(typeof loadCultivations === "function"){
              if(S && S.token){
                loadCultivations(false).catch(()=>{});
              }else if(tries < 8){
                setTimeout(kick, 250);
              }
            }
          }catch(_e3){}
        })();
      }
    }catch(_e){}
  }

  function isModOnlyFlag_(){
    try{
      return (sessionStorage.getItem("tyw_isModerator") === "1") && (sessionStorage.getItem("tyw_isAdmin") !== "1");
    }catch(_e){
      return false;
    }
  }

  function applyRoleUI_(){
    try{
      var isModOnly = isModOnlyFlag_();
      var panel = qs('#tywAdminPanel');
      if(!panel) return;


      // Mod-only: show a single safe page (Roster) and embed the Cultivation Overview card inside it.
      // This avoids moderators getting stuck when submenu clicks are blocked by theme overlays.
      function moveCultOverviewToRoster_(){
        try{
          if(!isModOnly) return;
          var roster = document.getElementById('tywAdmRoster');
          var cultPg = document.getElementById('slbAdmCultPage');
          if(!roster || !cultPg) return;

          // First card inside Cultivations page is the overview card.
          var card = cultPg.querySelector('.card');
          if(!card) return;

          if(card.dataset && card.dataset.slbMovedToRoster === '1') return;
          if(card.dataset) card.dataset.slbMovedToRoster = '1';

          // Add a divider before the moved section for clarity.
          var hr = document.createElement('div');
          hr.className = 'hr';
          hr.style.marginTop = '12px';

          var wrap = document.createElement('div');
          wrap.id = 'slbModCultOverviewWrap';
          wrap.appendChild(hr);
          wrap.appendChild(card);

          roster.appendChild(wrap);
        }catch(_e){}
      }

      // Moderator allowed pages (read-only)
      var allow = null;
      if(isModOnly) allow = { roster:1, disciples:1, cult:1, diary:1 };

      // Mark role on panel so CSS can enforce hiding even if other rules use !important
      try{ panel.classList.toggle('slbModOnly', !!isModOnly); }catch(_e){}

      var btns = qsa('.admNavBtn', panel);
      var pages = qsa('.admPage', panel);

      btns.forEach(function(b){
        var k = b.getAttribute('data-adm') || '';
        if(allow && !allow[k]){
          try{ b.setAttribute('hidden',''); }catch(_e){}
          b.style.display = 'none';
        }else{
          try{ b.removeAttribute('hidden'); }catch(_e2){}
          b.style.display = '';
        }
      });

      pages.forEach(function(p){
        var k = p.getAttribute('data-adm') || '';
        if(allow && !allow[k]){
          try{ p.setAttribute('hidden',''); }catch(_e){}
          p.style.display = 'none';
          p.classList.remove('active');
        }else{
          try{ p.removeAttribute('hidden'); }catch(_e2){}
          p.style.display = '';
        }
      });

      
      // Mod-only: rename menu labels (Moderator sees singular)
      try{
        var bDisc = panel.querySelector('.admNavBtn[data-adm="disciples"]');
        var bCult = panel.querySelector('.admNavBtn[data-adm="cult"]');
        if(isModOnly){
          if(bDisc) bDisc.textContent = 'Disciple';
          if(bCult) bCult.textContent = 'Cultivation';
        }else{
          if(bDisc) bDisc.textContent = 'Disciples';
          if(bCult) bCult.textContent = 'Cultivations';
        }
      }catch(_e){}
// Mod-only: show Cultivation as its own page (no embed into roster)
      // moveCultOverviewToRoster_();

      // Mod-only: make Cultivations read-only (hide baseline edit tools)
      if(isModOnly){
        try{
          var editBox = document.getElementById('slbAdmCultEditTools');
          if(editBox) editBox.style.display = 'none';
        }catch(_e){}
      }else{
        // Admin: keep edit tools visible
        try{
          var editBox2 = document.getElementById('slbAdmCultEditTools');
          if(editBox2) editBox2.style.display = '';
        }catch(_e2){}
      }

      // Ensure a visible page is active (don't force-roster if user already on an allowed page)
      if(isModOnly){
        try{
          var active = qs('.admPage.active', panel);
          if(!active || active.style.display === 'none') showAdmPage('roster');
        }catch(_e3){ showAdmPage('roster'); }
      }

      // Apply Disciples role UI (hide admin-only buttons, disable fields)
      try{ discApplyRoleUI_(); }catch(_e4){}      // Auto-load Disciples list if the Disciples page is already active (session restore)
      try{
        var activePg = qs('.admPage.active', panel);
        var kAct = activePg ? (activePg.getAttribute('data-adm')||'') : '';
        if(kAct === 'roster'){ kickRosterAutoLoad_("restore"); }
        if(kAct === 'disciples'){ kickDiscAutoLoad_("restore"); }
      }catch(_e){}
      // Hard-bind visible Admin/Moderator menu buttons (capture) to survive theme click blockers
      try{ hardBindAdmNav_(); }catch(_e5){}
    }catch(e){}
  }


  // Hard-bind Admin/Moderator menu clicks in CAPTURE phase.
  // Some Shopify themes attach click handlers that stopPropagation, which breaks delegated document listeners.
  // This ensures roster/cult (and any visible page) can always be opened.
  function hardBindAdmNav_(){
    try{
      var panel = qs('#tywAdminPanel');
      if(!panel) return;
      qsa('.admNavBtn', panel).forEach(function(btn){
        try{
          if(btn.dataset && btn.dataset.slbHardBound === "1") return;
          if(btn.dataset) btn.dataset.slbHardBound = "1";
          btn.addEventListener('click', function(ev){
            try{ ev.preventDefault(); ev.stopPropagation(); }catch(_e){}
            try{ showAdmPage(btn.getAttribute('data-adm') || 'target'); }catch(_e2){}
          }, true); // capture
        }catch(_e3){}
      });
    }catch(_e4){}
  }

  // expose for main tab switcher
  try{
    window.SLB_showAdmPage = showAdmPage;
    window.SLB_applyRoleUI = applyRoleUI_;
  }catch(_e){}


// P4.1d: direct bindings for Archive/New User (bypass delegated click issues)
(function(){
  function bindOne(id,key){
    var el = document.getElementById(id);
    if(!el) return;
    el.addEventListener('click', function(ev){
      try{ ev.preventDefault(); ev.stopPropagation(); }catch(e){}
      try{ showAdmPage(key); }catch(e){}
    }, true); // capture
  }
  bindOne('admBtnArchive','archive');
  bindOne('admBtnCreate','create');
})();

// P4.1e debug: log clicks for Archive/New User
(function(){
  function logBind(id){
    var el=document.getElementById(id);
    if(!el) return;
    // Debug click trace (disabled by default). Enable via: window.SLB_DEBUG = true
    el.addEventListener('click', function(){
      try{ if(window.SLB_DEBUG){ console.log('[SLB] click', id); } }catch(e){}
    }, true);
  }
  logBind('admBtnArchive'); logBind('admBtnCreate');
})();


  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.admNavBtn');
    if(!b) return;
    e.preventDefault();
    showAdmPage(b.getAttribute('data-adm') || 'target');
  });

  // when switching into admin tab, ensure a page is visible
  document.addEventListener('click', function(e){
    var mi = e.target.closest && e.target.closest('.menuItem');
    if(mi && mi.getAttribute('data-tab') === 'admin'){
      setTimeout(function(){
        var panel = qs('#tywAdminPanel');
        if(!panel) return;
        var active = qs('.admNavBtn.active', panel);
        showAdmPage(active ? active.getAttribute('data-adm') : 'target');
      }, 0);
    }
  });

  // default
  setTimeout(function(){ try{ hardBindAdmNav_(); }catch(_e){} showAdmPage('target'); }, 0);
})();


// ===== SLB Frontend Polish (Steps 4–7): accessibility, copy helpers, table polish, soft double-click guard =====
(function(){
  function getRoot(){
    return document.getElementById("SaamLawBank") || document.getElementById("tyWealthCourtyard");
  }

  async function copyToClipboard(text){
    var t = String(text || "").trim();
    if(!t) return false;

    try{
      if(navigator.clipboard && navigator.clipboard.writeText){
        await navigator.clipboard.writeText(t);
        return true;
      }
    }catch(_e){}

    try{
      var ta = document.createElement("textarea");
      ta.value = t;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      ta.style.top = "0";
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return !!ok;
    }catch(_e2){}
    return false;
  }

  function install(){
    var root = getRoot();
    if(!root || root.__slbPolish47) return;
    root.__slbPolish47 = true;

    // Copy buttons (data-copy-from="inputId" or data-copy="text")
    root.addEventListener("click", function(e){
      var btn = e.target && e.target.closest ? e.target.closest("button.slbCopyBtn") : null;
      if(!btn || !root.contains(btn)) return;

      e.preventDefault();
      e.stopPropagation();

      var from = btn.getAttribute("data-copy-from");
      var val = "";
      if(from){
        var inp = document.getElementById(from);
        val = inp ? inp.value : "";
      }else{
        val = btn.getAttribute("data-copy") || btn.getAttribute("data-copy-value") || "";
      }
      val = String(val || "").trim();
      if(!val){
        try{ toast("err", "Nothing to copy."); }catch(_e){}
        return;
      }

      copyToClipboard(val).then(function(ok){
        try{ toast(ok ? "ok" : "err", ok ? "Copied." : "Copy failed."); }catch(_e){}
      });
    }, true);

    // Click-to-copy helper (anything with class slbCopyable)
    root.addEventListener("click", function(e){
      var node = e.target && e.target.closest ? e.target.closest(".slbCopyable") : null;
      if(!node || !root.contains(node)) return;
      var val = node.getAttribute("data-copy") || node.getAttribute("data-copy-value") || node.textContent || "";
      val = String(val || "").trim();
      if(!val) return;
      copyToClipboard(val).then(function(ok){
        try{ toast(ok ? "ok" : "err", ok ? "Copied." : "Copy failed."); }catch(_e){}
      });
    });

    // Soft double-click guard for action buttons (prevents rapid accidental double-submits)
    var actionAttrs = [
      "data-txn","data-ocancel","data-orecv","data-saccept","data-sdeliv",
      "data-buy","data-del","data-rename","data-save",
      "data-pay-run","data-pay-del",
      "data-aw-give","data-aw-revoke","data-aw-del","data-cult-add","data-cult-adj"
    ];

    root.addEventListener("click", function(e){
      var btn = e.target && e.target.closest ? e.target.closest("button") : null;
      if(!btn || !root.contains(btn)) return;

      // ignore navigation/menu buttons
      if(btn.classList.contains("navBtn") || btn.classList.contains("menuItem")) return;
      if(btn.hasAttribute("data-tab") || btn.hasAttribute("data-drop") || btn.hasAttribute("data-panel") || btn.hasAttribute("data-toggle")) return;

      var isAction = false;
      for(var i=0; i<actionAttrs.length; i++){
        if(btn.hasAttribute(actionAttrs[i])){ isAction = true; break; }
      }
      if(!isAction) return;

      var now = Date.now();
      var last = Number(btn.getAttribute("data-slb-lastclick") || "0");
      if(last && (now - last) < 900){
        e.preventDefault();
        e.stopPropagation();
        if(e.stopImmediatePropagation) e.stopImmediatePropagation();
        return;
      }
      btn.setAttribute("data-slb-lastclick", String(now));
    }, true);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){ setTimeout(install, 0); });
  }else{
    setTimeout(install, 0);
  }
})();


/* ====== SLB FEATURE: 70_page_config.js ====== */
/* SLB Page Config Applier (Phase 1)
   - Reads PAGE_CONFIG from backend and applies small visual overrides.
   - Safe: only touches elements explicitly marked with data-slp-* attributes.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;

  var CACHE = Object.create(null); // { pageKey: {ts, cfg} }
  var CACHE_TTL_MS = 2 * 60 * 1000;

  function now(){ return Date.now ? Date.now() : (new Date()).getTime(); }
  function str(s){ return String(s||''); }
  function trim(s){ return str(s).trim(); }

  function rpc(action, args){
    try{
      if(SLB && typeof SLB.rpc === 'function') return SLB.rpc(action, args||{});
    }catch(_e){}
    try{
      if(w.SLB_APP && w.SLB_APP.rpc && typeof w.SLB_APP.rpc === 'function') return w.SLB_APP.rpc(action, args||{});
    }catch(_e2){}
    return Promise.reject(new Error('RPC not available'));
  }

  function applyText(root, cfg){
    if(!root) return;
    var text = (cfg && cfg.text) ? cfg.text : null;
    var show = (cfg && cfg.show) ? cfg.show : null;

    // text nodes
    try{
      root.querySelectorAll('[data-slp-text]').forEach(function(el){
        var key = trim(el.getAttribute('data-slp-text'));
        if(!key || !text) return;
        if(text[key] === undefined || text[key] === null) return;
        el.textContent = str(text[key]);
      });
    }catch(_e){}

    // placeholders
    try{
      root.querySelectorAll('[data-slp-ph]').forEach(function(el){
        var key = trim(el.getAttribute('data-slp-ph'));
        if(!key || !text) return;
        if(text[key] === undefined || text[key] === null) return;
        try{ el.setAttribute('placeholder', str(text[key])); }catch(_e2){}
      });
    }catch(_e3){}

    // selector overrides (Phase 2)
    // cfg.selectors: [{ sel: '...', kind: 'text'|'ph', value: '...' }]
    try{
      var sels = (cfg && cfg.selectors && Array.isArray(cfg.selectors)) ? cfg.selectors : null;
      if(sels && sels.length){
        var max = Math.min(sels.length, 80);
        for(var i=0;i<max;i++){
          var r = sels[i]; if(!r) continue;
          var sel = trim(r.sel);
          var kind = trim(r.kind||'text').toLowerCase();
          var val = (r.value===undefined || r.value===null) ? null : str(r.value);
          if(!sel || val===null) continue;

          // Safety: if selector not rooted, scope it to #SaamLawBank
          if(sel.indexOf('#SaamLawBank')!==0) sel = '#SaamLawBank ' + sel;

          var node = null;
          try{ node = root.querySelector(sel); }catch(_qe){ node=null; }
          if(!node) continue;

          if(kind === 'ph'){
            try{ node.setAttribute('placeholder', val); }catch(_phE){}
          }else{
            try{ node.textContent = val; }catch(_txE){}
          }
        }
      }
    }catch(_sE){}

    
    // Phase 3: block rules
    // cfg.blocks: [{ sel:'...', name:'...', enabled:true/false, preset:'none|orange|grey' }]
    try{
      var blocks = (cfg && cfg.blocks && Array.isArray(cfg.blocks)) ? cfg.blocks : null;
      if(blocks && blocks.length){
        var bmax = Math.min(blocks.length, 80);
        for(var bi=0; bi<bmax; bi++){
          var b = blocks[bi]; if(!b) continue;
          var bsel = trim(b.sel);
          if(!bsel) continue;
          if(bsel.indexOf('#SaamLawBank')!==0) bsel = '#SaamLawBank ' + bsel;
          var nodeB=null;
          try{ nodeB = root.querySelector(bsel); }catch(_be){ nodeB=null; }
          if(!nodeB) continue;

          var enabled = (b.enabled === undefined || b.enabled === null) ? true : !!b.enabled;
          nodeB.classList.toggle('slbPbHidden', !enabled);

          var preset = trim(b.preset||'').toLowerCase();
          nodeB.classList.remove('slbPbPreset--orange','slbPbPreset--grey');
          if(preset === 'orange') nodeB.classList.add('slbPbPreset--orange');
          else if(preset === 'grey' || preset === 'gray') nodeB.classList.add('slbPbPreset--grey');
        }
      }
    }catch(_bE){}

    // Phase 3: button color overrides
    // cfg.buttons: [{ sel:'...', color:'orange|red|black|blue|white|grey' }]
    try{
      var btns = (cfg && cfg.buttons && Array.isArray(cfg.buttons)) ? cfg.buttons : null;
      if(btns && btns.length){
        var cmax = Math.min(btns.length, 80);
        for(var ci=0; ci<cmax; ci++){
          var br = btns[ci]; if(!br) continue;
          var csel = trim(br.sel);
          var color = trim(br.color||'').toLowerCase();
          if(!csel || !color) continue;
          if(csel.indexOf('#SaamLawBank')!==0) csel = '#SaamLawBank ' + csel;
          var btn=null;
          try{ btn = root.querySelector(csel); }catch(_ce){ btn=null; }
          if(!btn) continue;

          // ensure base class
          try{ if(btn.classList && !btn.classList.contains('slb-btn')) btn.classList.add('slb-btn'); }catch(_cl){}
          // remove old color
          try{
            btn.classList.remove('slb-btn--orange','slb-btn--red','slb-btn--black','slb-btn--blue','slb-btn--white','slb-btn--grey');
          }catch(_rm){}
          // add new
          var map = {'orange':'slb-btn--orange','red':'slb-btn--red','black':'slb-btn--black','blue':'slb-btn--blue','white':'slb-btn--white','grey':'slb-btn--grey','gray':'slb-btn--grey'};
          var cls = map[color];
          if(cls){ try{ btn.classList.add(cls); }catch(_ad){} }
        }
      }
    }catch(_cE){}

// show/hide blocks
    try{
      root.querySelectorAll('[data-slp-show]').forEach(function(el){
        var key = trim(el.getAttribute('data-slp-show'));
        if(!key || !show) return;
        var v = show[key];
        if(v === undefined || v === null) return;
        var ok = !!v;
        el.classList.toggle('hidden', !ok);
      });
    }catch(_e4){}
  }

  function loadCfg(pageKey){
    pageKey = trim(pageKey);
    if(!pageKey) return Promise.resolve(null);

    var hit = CACHE[pageKey];
    if(hit && (now() - hit.ts) < CACHE_TTL_MS) return Promise.resolve(hit.cfg);

    return rpc('pageCfgGet', { pageKey: pageKey }).then(function(r){
      var cfg = (r && r.ok) ? (r.config || null) : null;
      CACHE[pageKey] = { ts: now(), cfg: cfg };
      return cfg;
    }).catch(function(_e){
      return null;
    });
  }

  function applyForTab(tab, root){
    tab = trim(tab);
    if(!tab) return;
    var pageKey = tab; // in Phase 1, pageKey = tab key

    var panel = null;
    try{ panel = (root || document).querySelector('[data-panel="' + tab + '"]'); }catch(_e){}
    if(!panel) return;

    loadCfg(pageKey).then(function(cfg){
      if(!cfg) return;
      applyText(panel, cfg);
    });
  }

  // Register for the Phase 1 pages we are targeting.
  function reg(tab){
    try{
      SLB.features.register(tab, {
        onOpen: function(ctx){
          try{ applyForTab(tab, (ctx && ctx.root) ? ctx.root : document); }catch(_e){}
        }
      });
    }catch(_e2){}
  }

  ['deposit','withdraw','gift','user','accounts'].forEach(reg);

  // Expose a tiny helper for the Visual Builder preview.
  w.SLB_applyPageCfgPreview = function(pageKey, cfg){
    pageKey = trim(pageKey);
    if(!pageKey) return;
    try{ CACHE[pageKey] = { ts: now(), cfg: cfg || null }; }catch(_e){}
    try{ applyForTab(pageKey, document); }catch(_e2){}
  };
})(window);


/* ====== SLB FEATURE: 71_anniv.js ====== */
/* SLB FEATURE: Anniversaries (Phase 4)
   - Uses GOD_ANNIVERSARY sheet (backend storage)
   - Computes next solar date using SLB.lunar engine (frontend)
*/

(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;

  function el(id){ return document.getElementById(id); }
  function txt(n, s){ if(n) n.textContent = (s==null?"":String(s)); }
  function show(n, on){ if(n) n.classList.toggle('hidden', !on); }
  function rpc(action, args){
    try{ if(SLB && typeof SLB.rpc === 'function') return SLB.rpc(action, args||{}); }catch(_e){}
    try{ if(w.SLB_APP && w.SLB_APP.rpc && typeof w.SLB_APP.rpc === 'function') return w.SLB_APP.rpc(action, args||{}); }catch(_e2){}
    return Promise.reject(new Error('RPC not available'));
  }

  function parseYmdToMs(ymd){
    // ymd: "YYYY-MM-DD" (treat as local date)
    var m = String(ymd||'').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if(!m) return NaN;
    return new Date(Number(m[1]), Number(m[2])-1, Number(m[3])).getTime();
  }

  function safeNum(v, d){
    var n = parseInt(String(v).trim(),10);
    return isFinite(n) ? n : d;
  }

  function cmpLunar(a,b){
    var am = safeNum(a && a.lunarMonth, 99);
    var bm = safeNum(b && b.lunarMonth, 99);
    if(am !== bm) return am - bm;

    var al = String(a && a.isLeapMonth || '0') === '1' ? 1 : 0;
    var bl = String(b && b.isLeapMonth || '0') === '1' ? 1 : 0;
    if(al !== bl) return al - bl;

    var ad = safeNum(a && a.lunarDay, 99);
    var bd = safeNum(b && b.lunarDay, 99);
    if(ad !== bd) return ad - bd;

    var an = String((a && (a.displayName||a.godKey)) || '').toLowerCase();
    var bn = String((b && (b.displayName||b.godKey)) || '').toLowerCase();
    if(an < bn) return -1;
    if(an > bn) return 1;
    return 0;
  }

  function sortItems(items){
    return (items||[]).slice().sort(cmpLunar);
  }

  // Local cache: keeps the list snappy and avoids re-fetching every time.
  var ANNIV_LS_KEY = 'slb.anniv.items.v1';
  var ANNIV_MEM_TTL_MS = 2*60*1000;
  var ANNIV_LS_TTL_MS  = 6*60*60*1000;
  var _memTs = 0;
  var _memItems = null;
  var _memSig = '';
  var _bgRefreshing = false;
  var _bgAutoTs = 0;

  function nowMs(){ return (Date.now ? Date.now() : (new Date()).getTime()); }

  function sigItems(items){
    try{
      return (items||[]).map(function(it){
        return [
          String(it.annivId||''),
          String(it.type||''),
          String(it.godKey||''),
          String(it.displayName||''),
          String(it.lunarMonth||''),
          String(it.lunarDay||''),
          String(it.isLeapMonth||''),
          String(it.url||''),
          String(it.notes||''),
          String(it.activeFlag||'')
        ].join('|');
      }).join('\n');
    }catch(_e){ return ''; }
  }

  function lsGet(key){
    try{
      if(SLB.storage && typeof SLB.storage.get==='function') return SLB.storage.get(key);
    }catch(_e){}
    try{ return localStorage.getItem(key); }catch(_e2){}
    return null;
  }

  function lsSet(key, val){
    try{
      if(SLB.storage && typeof SLB.storage.set==='function') return SLB.storage.set(key, val);
    }catch(_e){}
    try{ localStorage.setItem(key, val); }catch(_e2){}
  }

  function readLocalCache(){
    // Prefer SLB.storage JSON helpers (handles quota + serialization safely)
    try{
      if(SLB.storage && typeof SLB.storage.getJSON === 'function'){
        var p = SLB.storage.getJSON(ANNIV_LS_KEY, null);
        if(p && p.v) p = p.v; // backward-compatible wrapper
        if(p && p.items && Array.isArray(p.items)) return p;
      }
    }catch(e){}
    // Fallback to localStorage
    try{
      var raw = localStorage.getItem(ANNIV_LS_KEY);
      if(!raw) return null;
      var p2 = JSON.parse(raw);
      if(p2 && p2.v) p2 = p2.v;
      if(p2 && p2.items && Array.isArray(p2.items)) return p2;
    }catch(e){}
    return null;
  }

  function writeLocalCache(items){
    var rec = {ts: nowMs(), items: items||[], sig: sigItems(items||[])};
    try{
      if(SLB.storage && typeof SLB.storage.setJSON === 'function'){
        SLB.storage.setJSON(ANNIV_LS_KEY, rec);
        return;
      }
    }catch(e){}
    try{
      localStorage.setItem(ANNIV_LS_KEY, JSON.stringify(rec));
    }catch(e){}
  }


  async function computeNextSolarYmd(lm, ld, isLeap){
    lm = parseInt(lm,10); ld = parseInt(ld,10);
    if(!(lm>=1 && lm<=12) || !(ld>=1 && ld<=30)) return '';

    if(!SLB.lunar || typeof SLB.lunar.ensureEngine !== 'function') return '';
    var ok = await SLB.lunar.ensureEngine();
    if(!ok) return '';

    var year = (new Date()).getFullYear();
    var todayMs = (new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate())).getTime();

    function conv(y){
      var month = isLeap ? -Math.abs(lm) : Math.abs(lm);
      var lunarObj = null;
      if(typeof w.Lunar !== 'undefined' && typeof w.Lunar.fromYmd === 'function') lunarObj = w.Lunar.fromYmd(y, month, ld);
      else if(typeof w.Lunar !== 'undefined' && typeof w.Lunar.fromYmdHms === 'function') lunarObj = w.Lunar.fromYmdHms(y, month, ld, 12, 0, 0);
      if(!lunarObj) return { ymd:'', ms:NaN };
      var solar = lunarObj.getSolar();
      var ymd = (solar && typeof solar.toYmd === 'function') ? solar.toYmd() : '';
      return { ymd: ymd, ms: parseYmdToMs(ymd) };
    }

    var a = conv(year);
    if(a.ymd && isFinite(a.ms) && a.ms >= todayMs) return a.ymd;
    var b = conv(year+1);
    return b.ymd || '';
  }

  function escapeHtml(s){
    s = String(s==null?"":s);
    return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function bindOnce(){
    if(SLB.__annivBound) return;
    SLB.__annivBound = true;

    var q = el('slbAnnivQ');
    var reloadBtn = el('slbAnnivReloadBtn');
    var tbody = el('slbAnnivTbody');

    // Make rows clickable (open URL). Admin: Shift/Alt-click or double-click to pick/edit.
    try{
      if(tbody && !tbody.__slbAnnivRowClickBound){
        tbody.__slbAnnivRowClickBound = true;
        tbody.addEventListener('click', function(ev){
          var tr = ev.target && ev.target.closest ? ev.target.closest('tr[data-anniv-id]') : null;
          if(!tr) return;
          var id = tr.getAttribute('data-anniv-id') || '';
          var url = tr.getAttribute('data-url') || '';
          var adm = isAdminOrMod();

          if(adm && (ev.shiftKey || ev.altKey)){
            pick(id);
            return;
          }

          if(url){
            try{ window.open(url, '_blank', 'noopener'); }catch(_e){}
            return;
          }

          if(adm) pick(id);
        });

        tbody.addEventListener('dblclick', function(ev){
          if(!isAdminOrMod()) return;
          var tr = ev.target && ev.target.closest ? ev.target.closest('tr[data-anniv-id]') : null;
          if(!tr) return;
          pick(tr.getAttribute('data-anniv-id') || '');
        });
      }
    }catch(_e){}

    var msg = el('slbAnnivMsg');

    var adminBox = el('slbAnnivAdminBox');
    var godSel = el('slbAnnivGodSel');
    var urlInp = el('slbAnnivUrl');
    var lmInp = el('slbAnnivLm');
    var ldInp = el('slbAnnivLd');
    var leapSel = el('slbAnnivLeap');
    var notesInp = el('slbAnnivNotes');
    var clearBtn = el('slbAnnivClearBtn');
    var saveBtn = el('slbAnnivSaveBtn');
    var seedBtn = el('slbAnnivSeedBtn');
    var delBtn = el('slbAnnivDeleteBtn');
    var adminHint = el('slbAnnivAdminHint');

    var state = { items: [], selectedId: '' };

    function isAdminOrMod(){
      // Use the same admin flags as the core SLB app (sessionStorage + S state).
      // Do NOT gate on w.S (it does not exist), or the admin UI will never show.
      try{
        if(typeof S !== 'undefined') return !!(S.isAdminOrMod || S.isAdmin);
      }catch(_e){}
      try{
        return (sessionStorage.getItem('tyw_isAdmin') === '1') || (sessionStorage.getItem('tyw_isModerator') === '1');
      }catch(_e2){}
      return false;
    }

    
    
    // Cache role check once for this panel open
    var _adm = isAdminOrMod();
async function loadGods(){
      if(!godSel) return;
      try{
        var out = await rpc('letterGodsList', {});
        var items = (out && out.items) ? out.items : [];
        var html = '<option value="">Select…</option>';
        for(var i=0;i<items.length;i++){
          var it = items[i];
          html += '<option value="' + escapeHtml(it.id||'') + '">' + escapeHtml(it.name||it.cn||it.en||it.id||'') + '</option>';
        }
        godSel.innerHTML = html;
      }catch(_e){
        godSel.innerHTML = '<option value="">(LETTER_GOD unavailable)</option>';
      }
    }

    async function seedOfficial(){
      if(!isAdminOrMod()) return;
      setMsg('');
      try{
        var out = await rpc('adminAnnivSeedGodDays', {});
        var s = 'Seeded. Inserted: ' + (out.inserted||0) + ', Updated: ' + (out.updated||0);
        if(out.unmatched) s += ', Unmatched: ' + out.unmatched;
        setMsg(s);
        await load(true);
      }catch(e){ setMsg('Error: ' + (e.message||String(e))); }
    }

function setMsg(s){ txt(msg, s||''); }

    function clearForm(){
      state.selectedId = '';
      if(godSel) godSel.value = '';
      if(urlInp) urlInp.value = '';
      if(lmInp) lmInp.value = '';
      if(ldInp) ldInp.value = '';
      if(leapSel) leapSel.value = '0';
      if(notesInp) notesInp.value = '';
      if(adminHint) txt(adminHint, 'New record');
      if(delBtn) delBtn.disabled = true;
    }

    // Show admin box + init admin-only controls
    show(adminBox, _adm);
    if(_adm){
      try{ loadGods(); }catch(_e){}
      try{ clearForm(); }catch(_e2){}
    }


    function pick(id){
      state.selectedId = id;
      var it = state.items.find(function(x){ return String(x.annivId||'') === String(id||''); });
      if(!it){ clearForm(); return; }
      if(godSel) godSel.value = it.godKey || '';
      if(urlInp) urlInp.value = it.url || '';
      if(lmInp) lmInp.value = it.lunarMonth || '';
      if(ldInp) ldInp.value = it.lunarDay || '';
      if(leapSel) leapSel.value = String(it.isLeapMonth||'0') === '1' ? '1' : '0';
      if(notesInp) notesInp.value = it.notes || '';
      if(adminHint) txt(adminHint, 'Editing: ' + (it.displayName||it.annivId));
      if(delBtn) delBtn.disabled = false;
    }

    async function render(){
      if(!tbody) return;
      var rows = state.items || [];

      if(rows.length === 0){
        tbody.innerHTML = '<tr><td colspan="3" class="muted">No records</td></tr>';
        return;
      }

      // Compute next dates sequentially (small list); keeps browser stable.
      var html = '';
      for(var i=0;i<rows.length;i++){
        var it = rows[i];
        var lunarStr = (String(it.lunarMonth||'') + '/' + String(it.lunarDay||'')) + (String(it.isLeapMonth||'0')==='1' ? ' (leap)' : '');
        var nextSolar = '';
        try{ nextSolar = await computeNextSolarYmd(it.lunarMonth, it.lunarDay, String(it.isLeapMonth||'0')==='1'); }catch(_e){}

        var name = escapeHtml(it.displayName||it.annivId||'');
        var url = String(it.url||'').trim();

        html += '<tr data-anniv-id="' + escapeHtml(it.annivId) + '"' + (url ? (' data-url="' + escapeHtml(url) + '"') : '') + '>' +
          '<td><span class="slbAnnivName">' + name + '</span></td>' +
          '<td class="slbAnnivLunar">' + escapeHtml(lunarStr) + '</td>' +
          '<td class="slbAnnivNext">' + escapeHtml(nextSolar || '') + '</td>' +
        '</tr>';
      }
tbody.innerHTML = html;
    }

    async function load(force){
      setMsg('');
      var t = nowMs();
      var didRenderFromCache = false;

      // If we have fresh in-memory data, use it instantly.
      if(!force && _memItems && (t - _memTs) < ANNIV_MEM_TTL_MS){
        state.items = sortItems(_memItems);
        await render();
        didRenderFromCache = true;
      }

      // Revalidate in background (throttled) so admin edits show up fast for everyone.
      if(!force && (t - (_bgAutoTs||0)) > 5*60*1000){
        _bgAutoTs = t;
        refreshInBackground();
      }

      // If no fresh memory, try local cache.
      if(!force && !didRenderFromCache){
        var lc = readLocalCache();
        if(lc && lc.items && lc.items.length){
          state.items = sortItems(lc.items);
          _memItems = state.items;
          _memTs = lc.ts || 0;
          _memSig = lc.sig || sigItems(state.items);
          await render();
          didRenderFromCache = true;

          // Revalidate in background (throttled) so admin edits show up fast for everyone.
          if((t - (_bgAutoTs||0)) > 5*60*1000){
            _bgAutoTs = t;
            refreshInBackground();
          }
        }
      }

      // If we didn't render anything yet, show a simple loading row.
      if(!didRenderFromCache){
        if(tbody) tbody.innerHTML = '<tr><td colspan="3" class="muted">Loading…</td></tr>';
      }

      // If forcing, or no cache, fetch remote now.
      if(force || !didRenderFromCache){
        try{
          var res = await rpc('annivList', {});
          var items = sortItems((res && res.items) ? res.items : []);
          state.items = items;
          writeLocalCache(items);
          _memItems = items;
          _memTs = nowMs();
          _memSig = sigItems(items);
          
          await render();
        }catch(e){
          if(!didRenderFromCache){
            if(tbody) tbody.innerHTML = '<tr><td colspan="3" class="muted">Error: ' + escapeHtml(e.message||String(e)) + '</td></tr>';
          }
        }
      }

      // Admin box visibility (after first render)
      try{
        if(isAdminOrMod()){
          show(adminBox, true);
          await loadGods();
          if(!state.selectedId) clearForm();
        }else{
          show(adminBox, false);
        }
      }catch(_e){}
    }

    async function refreshInBackground(){
      if(_bgRefreshing) return;
      _bgRefreshing = true;
      try{
        var res = await rpc('annivList', {});
        var items = sortItems((res && res.items) ? res.items : []);
        var newSig = sigItems(items);
        var oldSig = _memSig || '';
        _memItems = items;
        _memTs = nowMs();
        _memSig = newSig || oldSig;

        if(newSig && newSig !== oldSig){
          state.items = items;
          writeLocalCache(items);
          await render();
        }else{
          // still refresh timestamp so we don't refetch constantly
          writeLocalCache(items);
        }
      }catch(_e){}
      _bgRefreshing = false;
    }
    async function save(){
      if(!isAdminOrMod()) return;
      setMsg('');
      try{
        var payload = {
          annivId: state.selectedId || '',
          type: 'GOD',
          godKey: godSel ? godSel.value : '',
          displayName: '',
          url: urlInp ? urlInp.value : '',
          lunarMonth: lmInp ? lmInp.value : '',
          lunarDay: ldInp ? ldInp.value : '',
          isLeapMonth: (leapSel && leapSel.value === '1') ? '1' : '0',
          notes: notesInp ? notesInp.value : ''
        };
        var out = await rpc('adminAnnivUpsert', payload);
        state.selectedId = (out && out.annivId) ? out.annivId : (payload.annivId||'');
        setMsg('Saved');
        await load(true);
        if(state.selectedId) pick(state.selectedId);
      }catch(e){ setMsg('Error: ' + (e.message||String(e))); }
    }

    async function del(){
      if(!isAdminOrMod()) return;
      var id = state.selectedId;
      if(!id) return;
      setMsg('');
      try{
        await rpc('adminAnnivDelete', { annivId: id });
        setMsg('Deleted');
        clearForm();
        await load(true);
      }catch(e){ setMsg('Error: ' + (e.message||String(e))); }
    }

    if(clearBtn) clearBtn.addEventListener('click', function(){ clearForm(); });
    if(saveBtn) saveBtn.addEventListener('click', function(){ save(); });
    if(seedBtn) seedBtn.addEventListener('click', function(){ seedOfficial(); });
    if(delBtn) delBtn.addEventListener('click', function(){ del(); });


    // Admin: anniversary reminder test + debug
    if(_adm){
      var testEmailTo = el('slbAnnivTestEmailTo');
      var testBtn = el('slbAnnivTestEmailBtn');
      var dbgBtn = el('slbAnnivDebugBtn');
      var fixBtn = el('slbAnnivEnsureTriggerBtn');
      var testMsg = el('slbAnnivTestEmailMsg');

      function setTestMsg(t){
        if(!testMsg) return;
        testMsg.textContent = t || '';
        testMsg.style.display = t ? 'block' : 'none';
      }
      function getTestEmail(){
        return (testEmailTo && testEmailTo.value ? String(testEmailTo.value) : '').trim();
      }

      if(testBtn){
        testBtn.addEventListener('click', function(){
          var email = getTestEmail();
          testBtn.disabled = true;
          setTestMsg('Sending test email...');
          rpc('adminAnnivNotifyTestEmail', { email: email }).then(function(d){
            d = d || {};
            if(d.queued){
              setTestMsg('Queued | To: ' + (d.to || '') + (d.runAfterSec ? (' | Run in ~' + d.runAfterSec + 's') : '') + (d.note ? (' | ' + d.note) : ''));
              return;
            }
            var c = d.dueCounts || {};
            setTestMsg('Sent: ' + (d.sent ? 'YES' : 'NO') + ' | To: ' + (d.to || '') + ' | Due7: ' + (c.due7 || 0) + ' | Due1: ' + (c.due1 || 0));
          }).catch(function(e){
            setTestMsg('Error: ' + (e && e.message ? e.message : String(e)));
          }).finally(function(){
            testBtn.disabled = false;
          });
        });
      }

      if(dbgBtn){
        dbgBtn.addEventListener('click', function(){
          dbgBtn.disabled = true;
          setTestMsg('Checking debug status...');
          rpc('adminAnnivNotifyDebug', {}).then(function(d){
            d = d || {};
            var c = d.dueCounts || {};
            var hasTrig = false;
            try{
              var tr = d.triggers || [];
              for(var i=0;i<tr.length;i++){
                if(String((tr[i]||{}).handler||'') === 'annivNotifyCron'){ hasTrig = true; break; }
              }
            }catch(_e){}
            var lr = d.lastRun || {};
            var testPart = '';
            if(lr.testLastStatus){
              testPart = ' | Test: ' + (lr.testLastStatus || '') + (lr.testLastError ? (' - ' + lr.testLastError) : '');
            }
            setTestMsg('TZ: ' + (d.tz || '') + ' | Now: ' + (d.now || '') + ' | Trigger: ' + (hasTrig ? 'YES' : 'NO') + ' | Due7: ' + (c.due7 || 0) + ' | Due1: ' + (c.due1 || 0) + testPart);
          }).catch(function(e){
            setTestMsg('Error: ' + (e && e.message ? e.message : String(e)));
          }).finally(function(){
            dbgBtn.disabled = false;
          });
        });
      }

      if(fixBtn){
        fixBtn.addEventListener('click', function(){
          fixBtn.disabled = true;
          setTestMsg('Repairing trigger...');
          rpc('adminAnnivNotifyEnsureTrigger', {}).then(function(d){
            d = d || {};
            setTestMsg('Repair trigger: ' + (d.installed ? 'OK' : ('FAILED' + (d.error ? ' - ' + d.error : ''))));
          }).catch(function(e){
            setTestMsg('Error: ' + (e && e.message ? e.message : String(e)));
          }).finally(function(){
            fixBtn.disabled = false;
          });
        });
      }
    }

    // Expose to onOpen
    SLB.__annivLoad = function(force){ return load(!!force); };
  }

  // Register in SLB features registry
  SLB.features = SLB.features || {};
  if(typeof SLB.features.register === 'function'){
    SLB.features.register('anniv', {
      onOpen: function(ctx){
        bindOnce();
        try{ if(SLB.__annivLoad) SLB.__annivLoad(false); }catch(_e){}
      }
    });
  }
})(window);


/* ====== SLB FEATURE: 71_currency_balance_hub.js ====== */
/*
  SLB Shared Currency Balance Hub V1
  One lightweight, read-only Coin/SP request shared by My Cabin, Golden Center,
  and any later surface that needs the same balances. Saved per callsign so a
  returning user sees numbers immediately while the live refresh runs.
*/
(function(w,d){
  'use strict';

  if(w.SLB_BALANCE_HUB&&w.SLB_BALANCE_HUB.version>=2)return;

  var VERSION=2;
  var STORE_PREFIX='slb_currency_snapshot_v3148_';
  var FRESH_MS=20000;
  var MAX_SAVED_AGE_MS=14*24*60*60*1000;
  var memory={};
  var inflight={};

  function num(v){var n=Number(v);return Number.isFinite(n)?n:0}
  function app(){return w.SLB_APP||null}
  function callsign(){
    var a=app(),s=a&&a.S,cs=s&&s.callsign;
    if(cs)return String(cs).trim().toUpperCase();
    try{cs=sessionStorage.getItem('tyw_callsign');if(cs)return String(cs).trim().toUpperCase()}catch(_e0){}
    try{var raw=localStorage.getItem('ty_auth_v1');if(raw){var x=JSON.parse(raw);if(x&&x.callsign)return String(x.callsign).trim().toUpperCase()}}catch(_e1){}
    return '';
  }
  function key(cs){return STORE_PREFIX+String(cs||'').trim().toUpperCase()}
  function unwrap(out){
    var cur=out,i=0;
    while(cur&&typeof cur==='object'&&i<6){
      if(cur.ok===false)throw new Error(cur.error||cur.err||cur.message||'SLB currency request failed.');
      if(cur.data&&typeof cur.data==='object'&&Object.keys(cur).length<=5){cur=cur.data;i++;continue}
      if(cur.result&&typeof cur.result==='object'&&Object.keys(cur).length<=5){cur=cur.result;i++;continue}
      break;
    }
    return cur||{};
  }
  function walletCoin(wallet){wallet=wallet||{};return num(wallet.coinBalance!==undefined?wallet.coinBalance:wallet.chipBalance)}
  function walletSp(wallet){wallet=wallet||{};return num(wallet.spBalance!==undefined?wallet.spBalance:wallet.spiritPower)}
  function normalize(data,cs){
    data=unwrap(data);cs=String(cs||callsign()||(data.profile&&data.profile.callsign)||data.callsign||'').trim().toUpperCase();
    var previous=cs&&memory[cs]||null;
    var pouches=Array.isArray(data.pouches)?data.pouches:(previous&&Array.isArray(previous.pouches)?previous.pouches:[]);
    var totalCoins=data.totalCoinBalance!==undefined?num(data.totalCoinBalance):pouches.reduce(function(sum,p){return sum+walletCoin(p&&p.wallet)},0);
    var totalSp=data.totalSpBalance!==undefined?num(data.totalSpBalance):pouches.reduce(function(sum,p){return sum+walletSp(p&&p.wallet)},0);
    var selectedId=String(data.selectedPouchId!==undefined?data.selectedPouchId:(previous&&previous.selectedPouchId)||'');
    if(!selectedId&&pouches[0])selectedId=String(pouches[0].accountId||pouches[0].pouchAccountId||'');
    var selected=pouches.find(function(p){return String(p&&(p.accountId||p.pouchAccountId)||'')===selectedId})||pouches[0]||null;
    var out={
      version:VERSION,
      callsign:cs,
      at:Date.now(),
      profile:data.profile||(previous&&previous.profile)||{callsign:cs},
      pouches:pouches,
      selectedPouchId:selectedId,
      wallet:data.wallet||(selected&&selected.wallet)||(previous&&previous.wallet)||null,
      currency:data.currency||(previous&&previous.currency)||{name:'Coins',coinsPerStone:10},
      totalCoinBalance:Math.max(0,totalCoins),
      totalSpBalance:Math.max(0,totalSp),
      source:String(data.source||data.mode||'currency-snapshot')
    };
    if(data.coinDebt!==undefined)out.coinDebt=num(data.coinDebt);else if(previous&&previous.coinDebt!==undefined)out.coinDebt=num(previous.coinDebt);
    if(Array.isArray(data.recentTransactions))out.recentTransactions=data.recentTransactions;else if(previous&&Array.isArray(previous.recentTransactions))out.recentTransactions=previous.recentTransactions;
    if(data.openSolo!==undefined)out.openSolo=data.openSolo;else if(previous&&previous.openSolo!==undefined)out.openSolo=previous.openSolo;
    if(data.openRoom!==undefined)out.openRoom=data.openRoom;else if(previous&&previous.openRoom!==undefined)out.openRoom=previous.openRoom;
    return out;
  }
  function readSaved(cs){
    cs=String(cs||callsign()).trim().toUpperCase();if(!cs)return null;
    if(memory[cs])return memory[cs];
    try{
      var raw=localStorage.getItem(key(cs));if(!raw)return null;
      var value=JSON.parse(raw);if(!value||String(value.callsign||'').toUpperCase()!==cs)return null;
      if(!value.at||Date.now()-Number(value.at)>MAX_SAVED_AGE_MS)return null;
      memory[cs]=value;return value;
    }catch(_e){return null}
  }
  function writeSaved(snapshot){
    if(!snapshot||!snapshot.callsign)return snapshot;
    memory[snapshot.callsign]=snapshot;
    w.SLB_CURRENCY_SNAPSHOT=snapshot;
    try{localStorage.setItem(key(snapshot.callsign),JSON.stringify(snapshot))}catch(_e){}
    try{
      var event;
      if(typeof w.CustomEvent==='function')event=new CustomEvent('slb:currency-updated',{detail:snapshot});
      else{event=d.createEvent('CustomEvent');event.initCustomEvent('slb:currency-updated',false,false,snapshot)}
      w.dispatchEvent(event);
    }catch(_e2){}
    return snapshot;
  }
  function getRpc(){
    var a=app();
    if(a&&typeof a.__realRpc==='function')return {ctx:a,fn:a.__realRpc};
    if(a&&typeof a.rpc==='function')return {ctx:a,fn:a.rpc};
    if(w.SLB&&typeof w.SLB.rpc==='function')return {ctx:w.SLB,fn:w.SLB.rpc};
    return null;
  }
  function waitForRpc(timeout){
    var started=Date.now();
    return new Promise(function(resolve,reject){
      function check(){
        var found=getRpc();if(found&&callsign()){resolve(found);return}
        if(Date.now()-started>=timeout){reject(new Error('SLB currency service is not ready.'));return}
        setTimeout(check,100);
      }
      check();
    });
  }
  function dashboardData(dash){
    dash=dash||(app()&&app().S&&app().S.dash)||null;
    if(!dash)return null;
    if(dash.currencySnapshot)return dash.currencySnapshot;
    if(dash.totalCoinBalance!==undefined||dash.totalSpBalance!==undefined)return dash;
    return null;
  }
  function accept(data){
    var cs=callsign()||String(data&&data.callsign||data&&data.profile&&data.profile.callsign||'').toUpperCase();
    return writeSaved(normalize(data,cs));
  }
  function acceptDashboard(dash){var data=dashboardData(dash);return data?accept(data):null}
  function peek(){return acceptDashboard()||readSaved(callsign())}
  function directRefresh_(opts,cs){
    return waitForRpc(Number(opts.waitMs||15000)).then(function(rpc){
      return Promise.resolve(rpc.fn.call(rpc.ctx,'ictCurrencySnapshot',{}, {
        cacheTtlMs:0,
        progressMode:'silent',
        timeoutMs:Number(opts.timeoutMs||30000),
        useWarmCache:false
      }));
    }).then(function(data){return accept(data)});
  }
  function refresh(opts){
    opts=opts||{};
    var cs=callsign();
    if(!cs)return Promise.reject(new Error('SLB login is not ready.'));
    var current=acceptDashboard();
    if(!opts.force&&current&&Date.now()-Number(current.at||0)<FRESH_MS)return Promise.resolve(current);
    if(inflight[cs])return inflight[cs];
    var a=app();
    inflight[cs]=Promise.resolve().then(function(){
      // The dashboard is now the single source for Stones, Pouches, Coins, and SP.
      if(a&&typeof a.refreshDashboardLite==='function'){
        return Promise.resolve(a.refreshDashboardLite()).then(function(){
          var grouped=acceptDashboard(a.S&&a.S.dash);
          if(grouped)return grouped;
          return directRefresh_(opts,cs); // staged/older backend fallback only
        });
      }
      return directRefresh_(opts,cs);
    }).catch(function(err){
      var saved=readSaved(cs);if(saved)return saved;throw err;
    }).then(function(value){delete inflight[cs];return value},function(err){delete inflight[cs];throw err});
    return inflight[cs];
  }

  function invalidate(){var cs=callsign(),snap=readSaved(cs);if(snap)snap.at=0;return snap}

  w.SLB_BALANCE_HUB={version:VERSION,peek:peek,refresh:refresh,accept:accept,acceptDashboard:acceptDashboard,invalidate:invalidate,callsign:callsign};

  try{if(w.__SLB_PENDING_DASH_CURRENCY__){accept(w.__SLB_PENDING_DASH_CURRENCY__);delete w.__SLB_PENDING_DASH_CURRENCY__}}catch(_ePending){}
  w.addEventListener('slb:dashboard-updated',function(event){acceptDashboard(event&&event.detail)});
})(window,document);


/* ====== SLB FEATURE: 72_golden_center.js ====== */
/*
  SLB Golden Center
  Unified game-world money hub. Reuses live bank, mission, and market panels and embeds BB Budget with the active SLB session.
*/
(function(w,d){
  'use strict';

  var TAB='goldenCenter';
  var root=null;
  var panelMap={};
  var anchorMap={};
  var mountedByGroup={};
  var currentBank='accounts';
  var currentMarketSide='buy';
  var currentMarket='market';
  var routeTab='accounts';
  var balanceBusy=false;
  var coinCache={at:0,value:null};
  var loadState={};
  var loadPromises={};
  var loadAttempts={};
  var retryTimers={};
  var modulePromises={};
  var preloadPromise=null;
  var observer=null;
  var mountedHydrationTimers={};
  var visibleMarketTimers={};
  var visibleMarketRuns={};
  var marketUiPromises={};
  var marketUiCompleted={};
  var budgetStartPromise=null;
  var budgetStarted=false;
  var coinBank={busy:false,historyBusy:false,ready:false,loadedAt:0,pouches:[],pouchId:'',wallet:null,currency:{coinsPerStone:10},recent:[],history:[],filter:'all',total:0,debt:0,status:'Loading Coin Bank…',error:false};

  var PANEL_TITLES={
    accounts:['BANK STATION','Cosmic Pouch'],
    deposit:['BANK STATION','Deposit'],
    withdraw:['BANK STATION','Withdrawal'],
    gift:['BANK STATION','Gift'],
    txns:['BANK RECORDS','History'],
    coins:['COIN BANK','Coins'],
    market:['BUYER COUNTER','Market'],
    orders:['BUYER COUNTER','My Orders'],
    offer:['SELLER COUNTER','Offer'],
    sales:['SELLER COUNTER','My Sales'],
    missions:['MISSION BOARD','Available Missions']
  };

  function el(id){return d.getElementById(id)}
  function qs(sel,scope){return (scope||d).querySelector(sel)}
  function qsa(sel,scope){return Array.prototype.slice.call((scope||d).querySelectorAll(sel))}
  function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function num(v){var n=Number(v);return Number.isFinite(n)?n:0}
  function isOnHand(a){
    var kind=String(a&&a.kind||'').toUpperCase().trim();
    if(kind==='POUCH')return false;
    if(kind==='WALLET')return true;
    var id=String(a&&(a.accountId||a.walletId)||'');
    if(id.indexOf('w_')===0)return true;
    var key=String(a&&a.name||'').toLowerCase().replace(/[_\-\s]+/g,'').trim();
    return key==='wallet'||key==='onhand'||key==='onhandwallet';
  }
  function format(v){
    var n=num(v),dec=Math.abs(n-Math.round(n))>.00001?2:0;
    try{return n.toLocaleString(undefined,{minimumFractionDigits:dec,maximumFractionDigits:2})}catch(_e){return String(Math.round(n*100)/100)}
  }
  function app(){return w.SLB_APP||null}
  function getRpc(){
    var a=app();
    if(a&&typeof a.__realRpc==='function')return a.__realRpc.bind(a);
    if(a&&typeof a.rpc==='function')return a.rpc.bind(a);
    if(w.SLB&&typeof w.SLB.rpc==='function')return w.SLB.rpc.bind(w.SLB);
    return null;
  }
  function rpc(action,args,opts){
    var fn=getRpc();
    if(!fn)return Promise.reject(new Error('SLB is not ready.'));
    return Promise.resolve(fn(action,args||{},opts||{})).then(function(out){
      if(out&&out.ok===false)throw new Error(out.error||out.message||'SLB request failed.');
      return out&&out.data&&Object.keys(out).length<=3?out.data:out;
    });
  }

  function moduleTab(tab){
    if(tab==='missions')return 'missions';
    if(tab==='market'||tab==='orders'||tab==='offer'||tab==='sales')return 'market';
    return '';
  }
  function storedToken(){
    var a=app(),s=a&&a.S;
    if(s&&s.token)return String(s.token||'');
    try{var t=sessionStorage.getItem('tyw_token');if(t)return String(t)}catch(_e0){}
    try{var raw=localStorage.getItem('ty_auth_v1');if(raw){var auth=JSON.parse(raw);if(auth&&auth.token)return String(auth.token)}}catch(_e1){}
    return '';
  }
  function waitForAuth(timeout){
    var started=Date.now();
    return new Promise(function(resolve,reject){
      function check(){
        var a=app();
        if(a&&getRpc()&&storedToken()){resolve(true);return}
        try{
          if(a&&typeof a.bootstrapFromSharedAuth==='function'&&w.__TY_AUTH_PENDING__)a.bootstrapFromSharedAuth(w.__TY_AUTH_PENDING__).catch(function(){});
        }catch(_e){}
        if(Date.now()-started>=timeout){reject(new Error('SLB login is not ready.'));return}
        setTimeout(check,120);
      }
      check();
    });
  }
  function directLoadModule(key){
    var urls=w.SLB_LAZY_ASSETS||{},url=String(urls[key]||'').trim();
    if(!url)return Promise.resolve(false);
    return new Promise(function(resolve){
      var existing=qsa('script[src]',d).find(function(node){return String(node.src||'').split('?')[0]===String(url).split('?')[0]});
      if(existing){
        if(existing.getAttribute('data-slb-lazy-state')==='loaded'||(key==='missions'&&w.SLB_MISSIONS)){resolve(true);return}
        existing.addEventListener('load',function(){resolve(true)},{once:true});
        existing.addEventListener('error',function(){resolve(false)},{once:true});
        setTimeout(function(){resolve(key!=='missions'||!!w.SLB_MISSIONS)},6000);
        return;
      }
      var script=d.createElement('script');
      script.src=url;script.async=true;script.setAttribute('data-slb-golden-module',key);script.setAttribute('data-slb-managed-resource','golden-module');
      script.onload=function(){resolve(true)};script.onerror=function(){resolve(false)};
      (d.head||d.documentElement).appendChild(script);
    });
  }
  function ensureServiceModule(tab){
    var key=moduleTab(tab);
    if(!key)return Promise.resolve(true);
    if(key==='missions'&&w.SLB_MISSIONS&&typeof w.SLB_MISSIONS.loadUser==='function')return Promise.resolve(true);
    if(modulePromises[key])return modulePromises[key];
    modulePromises[key]=Promise.resolve().then(function(){
      if(w.SLB_LAZY&&typeof w.SLB_LAZY.ensureForTab==='function')return w.SLB_LAZY.ensureForTab(tab);
      return directLoadModule(key);
    }).then(function(ok){
      if(ok===false)throw new Error(key+' module failed to load.');
      return true;
    }).catch(function(err){
      delete modulePromises[key];
      throw err;
    });
    return modulePromises[key];
  }

  function setText(id,text){var x=el(id);if(x)x.textContent=text}
  function setSync(text,state){
    var x=el('slbGoldenSyncState');
    if(!x)return;
    x.textContent=text;
    x.className='slbGoldenSyncState'+(state?' '+state:'');
  }
  function fitBalanceNumber(node){
    if(!node)return;
    node.style.removeProperty('font-size');
    var run=function(){
      var available=node.clientWidth||0;if(!available)return;
      var size=parseFloat(w.getComputedStyle(node).fontSize)||40,min=22,guard=0;
      while(node.scrollWidth>available+1&&size>min&&guard++<30){size-=1;node.style.fontSize=size+'px'}
    };
    if(w.requestAnimationFrame)w.requestAnimationFrame(run);else run();
  }
  function animateNumber(id,value){
    var node=el(id);if(!node)return;
    var end=num(value),start=num(node.dataset.goldenValue||0),beg=Date.now(),duration=520;
    if(id==='slbGoldenCoins')end=Math.floor(Math.max(0,end));
    node.dataset.goldenValue=String(end);
    if(!w.requestAnimationFrame){node.textContent=format(end);fitBalanceNumber(node);return}
    function frame(){
      var p=Math.min(1,(Date.now()-beg)/duration),ease=1-Math.pow(1-p,3);
      node.textContent=format(start+(end-start)*ease);
      if(p<1)w.requestAnimationFrame(frame);else{node.textContent=format(end);fitBalanceNumber(node)}
    }
    w.requestAnimationFrame(frame);
  }

  function readNodeNumber(id){
    var node=el(id);if(!node)return null;
    var raw=String(node.textContent||'').replace(/[^0-9.\-]/g,'');
    if(!raw)return null;
    var value=Number(raw);
    return Number.isFinite(value)?value:null;
  }
  function stoneSnapshot(){
    var a=app(),s=a&&a.S,dash=s&&s.dash||null,totals=dash&&dash.totals||null,accounts=dash&&Array.isArray(dash.accounts)?dash.accounts:[];
    var onHandFromAccounts=0,pouchesFromAccounts=0;
    accounts.forEach(function(acct){
      if(!acct||acct.__state==='failed')return;
      if(isOnHand(acct))onHandFromAccounts+=num(acct.balance);
      else if(String(acct.status||'ACTIVE').toUpperCase()==='ACTIVE')pouchesFromAccounts+=num(acct.balance);
    });
    var onHandFromTotals=totals&&totals.walletStones!==undefined?num(totals.walletStones):null;
    var totalFromTotals=totals&&totals.totalStones!==undefined?num(totals.totalStones):null;
    var domOnHand=readNodeNumber('tywWallet2');
    if(domOnHand===null)domOnHand=readNodeNumber('tywWallet');
    var domTotal=readNodeNumber('tywTotal');

    var onHand=(onHandFromTotals!==null?onHandFromTotals:(domOnHand!==null?domOnHand:onHandFromAccounts));
    var totalStones=(totalFromTotals!==null?totalFromTotals:(domTotal!==null?domTotal:(onHandFromAccounts+pouchesFromAccounts)));
    var pouches=Math.max(0,num(totalStones)-num(onHand));
    if((!pouches&&pouchesFromAccounts>0) || pouchesFromAccounts>pouches)pouches=pouchesFromAccounts;
    return {onHand:onHand,pouches:pouches,totalStones:totalStones,hasAccounts:!!accounts.length};
  }
  function renderStoneBalances(){
    var snap=stoneSnapshot();
    animateNumber('slbGoldenOnHand',snap.onHand);
    animateNumber('slbGoldenPouches',snap.pouches);
    return snap;
  }
  function parseCoinTotal(data){
    data=data||{};
    if(data.totalCoinBalance!==undefined)return Math.floor(Math.max(0,num(data.totalCoinBalance)));
    var list=Array.isArray(data.pouches)?data.pouches:[];
    return Math.floor(Math.max(0,list.reduce(function(sum,p){var x=p&&p.wallet||{};return sum+num(x.coinBalance!==undefined?x.coinBalance:x.chipBalance)},0)));
  }
  function parseSpiritTotal(data){
    data=data||{};
    if(data.totalSpBalance!==undefined)return num(data.totalSpBalance);
    var list=Array.isArray(data.pouches)?data.pouches:[];
    return list.reduce(function(sum,p){var x=p&&p.wallet||{};return sum+num(x.spBalance!==undefined?x.spBalance:x.spiritPower)},0);
  }
  function balanceHub(){return w.SLB_BALANCE_HUB||null}
  function renderCurrencyBalances(data){
    if(!data)return false;
    var hasCoin=data.totalCoinBalance!==undefined,hasSp=data.totalSpBalance!==undefined;
    if(!hasCoin&&!hasSp)return false;
    var coins=hasCoin?parseCoinTotal(data):(coinCache.value!==null?coinCache.value:0);
    var sp=hasSp?parseSpiritTotal(data):(coinCache.sp!==undefined?coinCache.sp:0);
    coinCache={at:num(data.at)||Date.now(),value:coins,sp:sp};
    if(hasCoin)animateNumber('slbGoldenCoins',coins);
    if(hasSp)animateNumber('slbGoldenSpiritPower',sp);
    return true;
  }
  function savedCurrency(){
    var a=app(),dash=a&&a.S&&a.S.dash,grouped=dash&&(dash.currencySnapshot||((dash.totalCoinBalance!==undefined||dash.totalSpBalance!==undefined)?dash:null));
    if(grouped)return grouped;
    var hub=balanceHub();
    return hub&&typeof hub.peek==='function'?hub.peek():null;
  }
  function refreshCurrency(force){
    var hub=balanceHub();
    if(hub&&typeof hub.refresh==='function')return hub.refresh({force:!!force});
    var a=app();
    return waitForAuth(12000).then(function(){
      if(a&&typeof a.refreshDashboardLite==='function')return a.refreshDashboardLite();
      return null;
    }).then(function(){
      var dash=a&&a.S&&a.S.dash,data=dash&&(dash.currencySnapshot||((dash.totalCoinBalance!==undefined||dash.totalSpBalance!==undefined)?dash:null));
      if(!data)throw new Error('Grouped currency dashboard is not ready.');
      return data;
    });
  }
  function acceptCurrency(data){
    var hub=balanceHub();
    if(hub&&typeof hub.accept==='function')return hub.accept(data);
    renderCurrencyBalances(data);
    return data;
  }

  function coinRequestId(kind){return 'golden_'+kind+'_'+Date.now()+'_'+Math.random().toString(16).slice(2)}
  function selectedCoinPouch(){
    var id=String(coinBank.pouchId||'');
    return coinBank.pouches.find(function(p){return String(p&&p.accountId||'')===id})||coinBank.pouches[0]||null;
  }
  function selectedCoinWallet(){
    var pouch=selectedCoinPouch();
    if(coinBank.wallet&&(!pouch||String(coinBank.wallet.pouchAccountId||'')===String(pouch.accountId||'')))return coinBank.wallet;
    return pouch&&pouch.wallet||{coinBalance:0,chipBalance:0,spBalance:0};
  }
  function selectedCoinBalance(){var x=selectedCoinWallet();return Math.floor(Math.max(0,num(x.coinBalance!==undefined?x.coinBalance:x.chipBalance)))}
  function selectedStoneBalance(){var p=selectedCoinPouch();return p?Math.max(0,num(p.balance)):0}
  function applyCoinBank(data){
    data=data||{};
    if(Array.isArray(data.pouches))coinBank.pouches=data.pouches;
    if(data.selectedPouchId)coinBank.pouchId=String(data.selectedPouchId);
    if(!coinBank.pouchId&&coinBank.pouches[0])coinBank.pouchId=String(coinBank.pouches[0].accountId||'');
    if(data.wallet)coinBank.wallet=data.wallet;else{var p=selectedCoinPouch();if(p&&p.wallet)coinBank.wallet=p.wallet}
    if(data.currency)coinBank.currency=data.currency;
    if(Array.isArray(data.recentTransactions))coinBank.recent=data.recentTransactions;
    if(Array.isArray(data.transactions))coinBank.history=data.transactions;
    coinBank.total=data.totalCoinBalance!==undefined?num(data.totalCoinBalance):parseCoinTotal(data);
    coinBank.spTotal=data.totalSpBalance!==undefined?num(data.totalSpBalance):parseSpiritTotal(data);
    if(data.coinDebt!==undefined)coinBank.debt=num(data.coinDebt);
    coinBank.ready=true;coinBank.loadedAt=Date.now();
  }
  function coinTxType(t){return String(t&&t.type||'').toUpperCase()}
  function coinTxClient(t){return t&&t.clientJson&&typeof t.clientJson==='object'?t.clientJson:{}}
  function coinTxCategory(t){var type=coinTxType(t),c=coinTxClient(t);if(type.indexOf('COC_')===0)return num(c.debtCleared)>0||num(c.debtAdded)>0?'debt':'clash';if(type.indexOf('BUY_IN')>=0||type.indexOf('MIGRATION')>=0||type.indexOf('EXCHANGE')>=0||type.indexOf('CASH_OUT')>=0)return 'exchange';return 'games'}
  function coinTxLabel(t){var type=coinTxType(t);if(type==='COC_DUTY_SETTLEMENT')return 'Clash Duty';if(type.indexOf('BUY_IN')>=0)return 'Stone to Coin Exchange';if(type.indexOf('CASH_OUT')>=0)return 'Coin Cash Out';if(type.indexOf('MIGRATION')>=0)return 'Coin Migration';if(type.indexOf('PAYOUT')>=0||type.indexOf('WIN')>=0)return 'Game Payout';if(type.indexOf('LOSS')>=0||type.indexOf('STAKE')>=0||type.indexOf('RESERVE')>=0||type.indexOf('FORFEIT')>=0)return 'Game Cost';return String(t&&t.note||type.replace(/_/g,' ')||'Coin Activity')}
  function coinTxDelta(t){var c=coinTxClient(t);return coinTxType(t)==='COC_DUTY_SETTLEMENT'&&c.grossEventCoins!==undefined?num(c.grossEventCoins):num(t&&t.coinDelta)}
  function coinTxDetail(t){
    var c=coinTxClient(t),type=coinTxType(t),parts=[];
    if(type==='COC_DUTY_SETTLEMENT'){
      if(num(c.walletDelta)>0)parts.push('+'+format(c.walletDelta)+' to Coin Drawers');
      if(num(c.walletDelta)<0)parts.push('−'+format(Math.abs(c.walletDelta))+' from Coin Drawers');
      if(num(c.debtCleared)>0)parts.push(format(c.debtCleared)+' debt cleared');
      if(num(c.debtAdded)>0)parts.push(format(c.debtAdded)+' new debt');
    }else{
      if(t&&t.note)parts.push(String(t.note));
      if(num(t&&t.stoneDelta))parts.push((num(t.stoneDelta)>0?'+':'')+format(t.stoneDelta)+' Stones');
    }
    return parts.join(' · ');
  }
  function coinTxPouch(t){
    var id=String(t&&t.pouchAccountId||'');
    if(id==='MULTI')return 'Multiple Drawers';
    var p=coinBank.pouches.find(function(x){return String(x&&x.accountId||'')===id});
    return p&&p.name||id||'Tao-Game Coins';
  }
  function coinTxHtml(t){
    var delta=coinTxDelta(t),detail=coinTxDetail(t),after=t&&t.balanceAfter!==undefined?num(t.balanceAfter):num(t&&t.coinBalance);
    return '<article class="slbGoldenCoinTxn '+coinTxCategory(t)+' '+(delta>0?'pos':delta<0?'neg':'zero')+'"><div class="slbGoldenCoinTxnMain"><div><strong>'+esc(coinTxLabel(t))+'</strong><small>'+esc(t&&t.timeISO?new Date(t.timeISO).toLocaleString():'')+'</small></div><b>'+(delta>0?'+':'')+format(delta)+'</b></div>'+(detail?'<p>'+esc(detail)+'</p>':'')+'<div class="slbGoldenCoinTxnFoot"><span>'+esc(coinTxPouch(t))+'</span><span>Balance '+format(after)+'</span></div></article>';
  }
  function coinBankHtml(){
    return '<div class="slbGoldenCoinBank">'+
      '<div class="slbGoldenCoinStats"><div><img class="slbGoldenCoinStatIcon" src="https://cdn.shopify.com/s/files/1/1299/3411/files/pouch_stones.png?v=1784943410" alt="" loading="lazy" decoding="async"><span><small>POUCH STONES</small><b id="slbGoldenCoinStones">—</b></span></div><div><img class="slbGoldenCoinStatIcon" src="https://cdn.shopify.com/s/files/1/1299/3411/files/coin_drawer.png?v=1784943213" alt="" loading="lazy" decoding="async"><span><small>SELECTED DRAWER</small><b id="slbGoldenCoinDrawer">—</b></span></div><div><img class="slbGoldenCoinStatIcon" src="https://cdn.shopify.com/s/files/1/1299/3411/files/coin.png?v=1784942804" alt="" loading="lazy" decoding="async"><span><small>ALL COINS</small><b id="slbGoldenCoinTotal">—</b></span></div><div class="debt"><img class="slbGoldenCoinStatIcon" src="https://cdn.shopify.com/s/files/1/1299/3411/files/coin_debt.png?v=1784943410" alt="" loading="lazy" decoding="async"><span><small>COIN DEBT</small><b id="slbGoldenCoinDebt">—</b></span></div></div>'+
      '<div class="slbGoldenCoinTools">'+
        '<div class="slbGoldenCoinField pouch"><label for="slbGoldenCoinPouch">Cosmic Pouch</label><select id="slbGoldenCoinPouch"><option value="">Loading…</option></select></div>'+
        '<div class="slbGoldenCoinAction buy"><div class="slbGoldenCoinField"><label for="slbGoldenCoinBuyAmount">Stones</label><input id="slbGoldenCoinBuyAmount" type="number" min="1" step="1" value="1"></div><div class="slbGoldenCoinButtonCell"><span aria-hidden="true">Action</span><button id="slbGoldenCoinBuy" type="button">Buy Coins</button></div></div>'+
        '<div class="slbGoldenCoinAction cash"><div class="slbGoldenCoinField"><label for="slbGoldenCoinCashAmount">Coins</label><input id="slbGoldenCoinCashAmount" type="number" min="10" step="10" value="10"></div><div class="slbGoldenCoinButtonCell"><span aria-hidden="true">Action</span><button id="slbGoldenCoinCash" type="button">Cash Out</button></div><div class="slbGoldenCoinButtonCell compact"><span aria-hidden="true">Action</span><button id="slbGoldenCoinCashAll" type="button">All</button></div></div>'+
      '</div>'+
      '<div class="slbGoldenCoinMeta"><div class="slbGoldenCoinRate">1 Spirit Stone = <b id="slbGoldenCoinRate">10</b> Coins</div><div class="slbGoldenCoinStatus" id="slbGoldenCoinStatus" role="status" aria-live="polite">Loading Coin Bank…</div><button class="refresh" id="slbGoldenCoinRefresh" type="button">Refresh Coin Bank</button></div>'+
      '<div class="slbGoldenCoinHistoryHead"><h4>Recent Coin History</h4><div class="slbGoldenCoinFilters"><button class="active" type="button" data-golden-coin-filter="all">All</button><button type="button" data-golden-coin-filter="clash">Clash</button><button type="button" data-golden-coin-filter="games">Games</button><button type="button" data-golden-coin-filter="exchange">Exchange</button><button type="button" data-golden-coin-filter="debt">Debt</button></div></div><div class="slbGoldenCoinHistory" id="slbGoldenCoinHistory"><div class="slbGoldenLoading">Loading Coin history…</div></div>'+
    '</div>';
  }
  function renderCoinBank(){
    var host=el('slbGoldenBankHost');if(!host||mountedByGroup.bank!=='coins')return;
    var pouch=selectedCoinPouch(),sel=el('slbGoldenCoinPouch');
    if(sel){sel.innerHTML=coinBank.pouches.length?coinBank.pouches.map(function(p){return '<option value="'+esc(p.accountId)+'">'+esc(p.name||p.accountId)+' · '+format(p.balance)+' Stones</option>'}).join(''):'<option value="">No active Cosmic Pouch</option>';if(coinBank.pouchId)sel.value=coinBank.pouchId;sel.disabled=coinBank.busy}
    setText('slbGoldenCoinStones',coinBank.ready?format(selectedStoneBalance()):'—');setText('slbGoldenCoinDrawer',coinBank.ready?format(selectedCoinBalance()):'—');setText('slbGoldenCoinTotal',coinBank.ready?format(coinBank.total):'—');setText('slbGoldenCoinDebt',coinBank.ready?format(coinBank.debt):'—');setText('slbGoldenCoinRate',format(coinBank.currency&&coinBank.currency.coinsPerStone||10));
    var status=el('slbGoldenCoinStatus');if(status){status.textContent=coinBank.status;status.className='slbGoldenCoinStatus'+(coinBank.busy||coinBank.historyBusy?' busy':coinBank.error?' error':coinBank.ready?' good':'')}
    ['slbGoldenCoinBuy','slbGoldenCoinCash','slbGoldenCoinCashAll','slbGoldenCoinRefresh'].forEach(function(id){var b=el(id);if(b)b.disabled=coinBank.busy||coinBank.historyBusy});
    qsa('[data-golden-coin-filter]',host).forEach(function(b){b.classList.toggle('active',b.getAttribute('data-golden-coin-filter')===coinBank.filter)});
    var history=el('slbGoldenCoinHistory');if(history){var source=coinBank.history.length?coinBank.history:coinBank.recent;var rows=source.filter(function(t){if(coinBank.filter==='all')return true;var c=coinTxCategory(t);if(coinBank.filter==='clash')return coinTxType(t)==='COC_DUTY_SETTLEMENT';return c===coinBank.filter}).slice(0,6);history.innerHTML=coinBank.historyBusy?'<div class="slbGoldenLoading">Loading Coin history…</div>':rows.length?rows.map(coinTxHtml).join(''):'<div class="slbGoldenCoinEmpty">No Coin transactions match this view.</div>'}
  }
  function loadCoinBank(force){
    var cached=savedCurrency();
    if(cached){applyCoinBank(cached);renderCurrencyBalances(cached);coinBank.status='Saved Coin Bank shown. Refreshing…'}
    if(coinBank.busy)return Promise.resolve(false);coinBank.busy=true;coinBank.error=false;renderCoinBank();
    return refreshCurrency(!!force).then(function(data){
      applyCoinBank(data);renderCurrencyBalances(data);
      coinBank.status=coinBank.pouches.length?'Coin Bank ready.':'No active Cosmic Pouch was found.';
      coinBank.busy=false;renderCoinBank();
      // History is secondary and must never hold the counters or Coin controls.
      loadCoinHistory(false);
      return true;
    }).catch(function(err){
      coinBank.error=!coinBank.ready;
      coinBank.status=coinBank.ready?'Saved Coin Bank is ready; live refresh is delayed.':(err&&err.message||'Could not load Coin Bank.');
      return false;
    }).finally(function(){coinBank.busy=false;renderCoinBank()});
  }
  function loadCoinHistory(showBusy){
    if(coinBank.historyBusy)return Promise.resolve(false);coinBank.historyBusy=showBusy!==false;renderCoinBank();
    return rpc('nscCoinHistory',{limit:30},{cacheTtlMs:0,progressMode:'silent'}).then(function(data){applyCoinBank(data);acceptCurrency(data);return true}).catch(function(err){coinBank.error=!coinBank.ready;coinBank.status=coinBank.ready?'Coin Bank ready; history is delayed.':(err&&err.message||'Could not load Coin history.');return false}).finally(function(){coinBank.historyBusy=false;renderCoinBank()});
  }
  function openCoinBank(){
    restoreGroup('bank');var host=el('slbGoldenBankHost');if(!host)return;mountedByGroup.bank='coins';
    var cached=savedCurrency();if(cached){applyCoinBank(cached);renderCurrencyBalances(cached)}
    host.innerHTML=coinBankHtml();renderCoinBank();
    if(!coinBank.ready||Date.now()-num(coinBank.loadedAt)>45000)loadCoinBank(false);
  }
  function coinBankExchange(kind,all){
    var pouch=selectedCoinPouch();if(!pouch){coinBank.error=true;coinBank.status='Pick a Cosmic Pouch first.';renderCoinBank();return}
    var isBuy=kind==='buy',input=el(isBuy?'slbGoldenCoinBuyAmount':'slbGoldenCoinCashAmount'),amount=Math.round(num(input&&input.value));
    if(isBuy&&amount<1){coinBank.error=true;coinBank.status='Enter at least 1 Spirit Stone.';renderCoinBank();return}
    var coins=all?Math.round(selectedCoinBalance()):amount;if(!isBuy&&coins<1){coinBank.error=true;coinBank.status='There are no Coins to cash out.';renderCoinBank();return}
    if(!isBuy&&!all&&coins%10!==0){coinBank.error=true;coinBank.status='Cash out a multiple of 10 Coins, or use Cash Out All.';renderCoinBank();return}
    var rate=num(coinBank.currency&&coinBank.currency.coinsPerStone)||10;
    var question=isBuy?'Exchange '+amount+' Spirit Stone'+(amount===1?'':'s')+' for '+(amount*rate)+' Coins?':'Cash out '+(all?'all ':'')+format(coins)+' Coins back to Spirit Stones?';
    if(!w.confirm(question))return;
    coinBank.busy=true;coinBank.error=false;coinBank.status=isBuy?'Exchanging Stones into Coins…':'Cashing out Coins…';renderCoinBank();
    var action=isBuy?'nscBuyIn':'nscCashOut',args={pouchAccountId:pouch.accountId};if(isBuy)args.amount=amount;else if(all)args.cashOutAll=true;else args.amount=coins;
    rpc(action,args,{requestId:coinRequestId(isBuy?'buy':'cashout'),cacheTtlMs:0,progressMode:'silent'}).then(function(data){applyCoinBank(data);acceptCurrency(data);coinBank.status=isBuy?'Coins added to your drawer.':'Coins returned to Spirit Stones.';return loadCoinHistory(false)}).catch(function(err){coinBank.error=true;coinBank.status=err&&err.message||'Coin exchange failed.'}).finally(function(){coinBank.busy=false;renderCoinBank();var hub=balanceHub();if(hub&&typeof hub.invalidate==='function')hub.invalidate();refreshBalances(true)});
  }
  function getLoader(tab){
    var a=app();
    if(tab==='gift'&&a&&typeof a.ensureGiftUsersLoaded==='function')return function(){return a.ensureGiftUsersLoaded()};
    if(tab==='txns'&&a&&typeof a.reloadTxnsFirstPage==='function')return function(){return a.reloadTxnsFirstPage()};
    if(tab==='market'&&a&&typeof a.loadMarket==='function')return function(){return a.loadMarket()};
    if(tab==='orders'&&a&&typeof a.loadMyOrders==='function')return function(){return a.loadMyOrders()};
    if(tab==='offer'&&a&&typeof a.loadMyOffers==='function')return function(){return a.loadMyOffers()};
    if(tab==='sales'&&a&&typeof a.loadMySales==='function')return function(){return a.loadMySales()};
    if(tab==='missions'&&w.SLB_MISSIONS&&typeof w.SLB_MISSIONS.loadUser==='function')return function(){return w.SLB_MISSIONS.loadUser()};
    return null;
  }
  function phase3Loaded(tab){
    var key=tab==='offer'?'offer':tab;
    var a=app(),s=a&&a.S,p3=s&&s.p3,loaded=p3&&p3.loaded;
    return !!(loaded&&loaded[key]===true);
  }
  function getMarketRenderer(tab){
    var a=app();
    if(!a)return null;
    if(typeof a.renderPhase3Tab==='function')return function(){return a.renderPhase3Tab(tab)};
    var name=tab==='market'?'renderMarket':tab==='orders'?'renderOrders':tab==='offer'?'renderMyOffers':tab==='sales'?'renderSales':'';
    return name&&typeof a[name]==='function'?function(){return a[name]()} : null;
  }
  function renderLoadedMarket(tab,panel){
    if(!isMarketTab(tab))return false;
    var render=getMarketRenderer(tab);
    if(!render)return false;
    try{render()}catch(_e){return false}
    normalizeHostedPanel(panel||panelMap[tab]);
    return marketBodyHasData(tab);
  }
  function bodyHasRows(id){
    var body=el(id);
    return !!(body&&body.children&&body.children.length);
  }
  function isHydrated(tab){
    if(tab==='market'||tab==='orders'||tab==='offer'||tab==='sales')return phase3Loaded(tab)&&marketBodyHasData(tab);
    if(tab==='missions'){
      var api=w.SLB_MISSIONS,state=api&&typeof api.getUserState==='function'?api.getUserState():null;
      return !!(state&&state.loaded&&bodyHasRows('tywMissionsBody')&&bodyHasRows('tywMissionHistoryBody'));
    }
    return loadState[tab]==='done';
  }
  function needsHydrationCheck(tab){return tab==='market'||tab==='orders'||tab==='offer'||tab==='sales'||tab==='missions'}
  function isMarketTab(tab){return tab==='market'||tab==='orders'||tab==='offer'||tab==='sales'}
  function marketReloadButton(tab){return el(({market:'tywMarketReloadBtn',orders:'tywOrdersReloadBtn',offer:'tywOfferReloadBtn',sales:'tywSalesReloadBtn'})[tab]||'')}
  function clickMarketReload(tab){
    var button=marketReloadButton(tab);
    if(!button||button.disabled)return false;
    try{button.click();return true}catch(_e){return false}
  }
  function marketDataCount(tab){
    var a=app(),s=a&&a.S,p3=s&&s.p3;if(!p3)return 0;
    var key=tab==='market'?'marketOffers':tab==='orders'?'myOrders':tab==='offer'?'mineOffers':tab==='sales'?'mySales':'';
    return key&&Array.isArray(p3[key])?p3[key].length:0;
  }
  function marketBodyHasData(tab){
    var id=({market:'tywMarketBody',orders:'tywOrdersBody',offer:'tywMyOffersBody',sales:'tywSalesBody'})[tab],body=el(id);
    if(!body)return false;
    return qsa('tr',body).some(function(row){
      if(row.classList.contains('slbP3LoadState'))return false;
      var text=String(row.textContent||'').toLowerCase();
      return !/^(loading(?:\s|…|\.\.\.)|could not load|failed to load)/.test(text.trim());
    });
  }
  function clearVisibleMarketTimer(tab){if(visibleMarketTimers[tab])clearTimeout(visibleMarketTimers[tab]);delete visibleMarketTimers[tab]}
  function waitForVisibleMarketResult(tab,button,timeout){
    var started=Date.now();
    return new Promise(function(resolve){
      function check(){
        if(marketDataCount(tab)>0&&marketBodyHasData(tab)){resolve(true);return}
        if(Date.now()-started>=timeout){resolve(false);return}
        if(button&&!button.disabled&&Date.now()-started>900){resolve(marketDataCount(tab)>0&&marketBodyHasData(tab));return}
        setTimeout(check,180);
      }
      check();
    });
  }
  function waitForMarketReloadReady(tab,timeout){
    var started=Date.now();
    return Promise.all([ensureServiceModule(tab),waitForAuth(timeout)]).then(function(){
      return new Promise(function(resolve,reject){
        function check(){
          var button=marketReloadButton(tab);
          /* onOnce() writes this marker only after the real SLB Reload handler is attached. */
          var wired=!!(button&&button.dataset&&button.dataset.tywWiredClick==='1');
          if(button&&wired&&!button.disabled){resolve(button);return}
          if(Date.now()-started>=timeout){reject(new Error(tab+' Reload control is not wired.'));return}
          setTimeout(check,120);
        }
        check();
      });
    });
  }
  function waitForMarketUiSettle(tab,button,beforeHtml,timeout){
    var started=Date.now(),sawBusy=false;
    return new Promise(function(resolve){
      function check(){
        var body=el(({market:'tywMarketBody',orders:'tywOrdersBody',offer:'tywMyOffersBody',sales:'tywSalesBody'})[tab]||'');
        var busy=!!(button&&(button.disabled||button.classList.contains('isLoading')));
        if(busy)sawBusy=true;
        var html=body?String(body.innerHTML||''):'';
        var changed=html!==beforeHtml;
        var settled=marketBodyHasData(tab);
        if(!busy&&settled&&(sawBusy||changed||Date.now()-started>650)){resolve(true);return}
        if(Date.now()-started>=timeout){resolve(settled);return}
        setTimeout(check,100);
      }
      check();
    });
  }
  function runMarketUiReload(tab,force){
    if(!isMarketTab(tab))return Promise.resolve(false);
    if(!force&&marketUiCompleted[tab]&&marketBodyHasData(tab))return Promise.resolve(true);
    if(marketUiPromises[tab])return marketUiPromises[tab];
    var p=waitForMarketReloadReady(tab,30000).then(function(button){
      var body=el(({market:'tywMarketBody',orders:'tywOrdersBody',offer:'tywMyOffersBody',sales:'tywSalesBody'})[tab]||'');
      var before=body?String(body.innerHTML||''):'';
      button.click();
      return waitForMarketUiSettle(tab,button,before,15000).then(function(ok){
        if(ok)return true;
        return waitForMarketReloadReady(tab,8000).then(function(button2){
          var body2=el(({market:'tywMarketBody',orders:'tywOrdersBody',offer:'tywMyOffersBody',sales:'tywSalesBody'})[tab]||'');
          var before2=body2?String(body2.innerHTML||''):'';
          button2.click();
          return waitForMarketUiSettle(tab,button2,before2,15000);
        });
      });
    }).then(function(ok){
      if(!ok)throw new Error(tab+' Reload finished without rendering its table.');
      marketUiCompleted[tab]=true;
      loadState[tab]='done';loadAttempts[tab]=0;
      renderLoadedMarket(tab,panelMap[tab]);
      return true;
    }).catch(function(){
      marketUiCompleted[tab]=false;
      loadState[tab]='failed';loadAttempts[tab]=num(loadAttempts[tab])+1;
      return false;
    }).finally(function(){delete marketUiPromises[tab]});
    marketUiPromises[tab]=p;
    return p;
  }
  function scheduleVisibleMarketRefresh(tab,panel){
    if(!isMarketTab(tab))return;
    clearVisibleMarketTimer(tab);
    visibleMarketTimers[tab]=setTimeout(function(){
      if(!panel||!panel.isConnected||mountedByGroup.market!==tab)return;
      var force=!(marketUiCompleted[tab]&&marketBodyHasData(tab));
      runMarketUiReload(tab,force).then(function(){
        renderLoadedMarket(tab,panel);
        normalizeHostedPanel(panel);
      });
    },160);
  }
  function wait(ms){return new Promise(function(resolve){setTimeout(resolve,ms)})}
  function waitForLoader(tab,timeout){
    var started=Date.now();
    return Promise.all([ensureServiceModule(tab),waitForAuth(timeout)]).then(function(){
      return new Promise(function(resolve,reject){
        function check(){
          var loader=getLoader(tab);
          if(loader){resolve(loader);return}
          if(Date.now()-started>=timeout){reject(new Error(tab+' loader is not ready.'));return}
          setTimeout(check,120);
        }
        check();
      });
    });
  }
  function waitForHydration(tab,timeout){
    if(!needsHydrationCheck(tab))return Promise.resolve(true);
    var started=Date.now();
    return new Promise(function(resolve){
      function check(){
        if(isHydrated(tab)){resolve(true);return}
        if(Date.now()-started>=timeout){resolve(false);return}
        setTimeout(check,120);
      }
      check();
    });
  }
  function scheduleRetry(tab){
    if(retryTimers[tab]||!root||root.classList.contains('hidden'))return;
    var attempt=num(loadAttempts[tab]);
    if(attempt>=8)return;
    var delays=[450,750,1200,1900,3000,4600,6500,8500];
    retryTimers[tab]=setTimeout(function(){
      delete retryTimers[tab];
      ensureLoaded(tab,false);
    },delays[Math.min(attempt,delays.length-1)]);
  }
  function ensureLoaded(tab,force){
    if(isMarketTab(tab))return runMarketUiReload(tab,!!force);
    if(!force&&isHydrated(tab)){loadState[tab]='done';return Promise.resolve(true)}
    if(loadState[tab]==='loading'&&loadPromises[tab]){
      if(force)return loadPromises[tab].then(function(){return isHydrated(tab)?true:ensureLoaded(tab,true)});
      return loadPromises[tab];
    }
    if(force){loadState[tab]='idle';loadAttempts[tab]=0}
    loadState[tab]='loading';
    var p=waitForLoader(tab,12000).then(function(loader){
      return Promise.resolve().then(loader).then(function(){
        if(isMarketTab(tab))renderLoadedMarket(tab,panelMap[tab]);
        return waitForHydration(tab,2200);
      }).then(function(ok){
        if(ok||!isMarketTab(tab))return ok;
        /* The original market Reload path performs additional UI/runtime setup. Run that proven path automatically. */
        clickMarketReload(tab);
        return waitForHydration(tab,4200).then(function(ok2){
          if(ok2)return true;
          return wait(900).then(function(){clickMarketReload(tab);return waitForHydration(tab,5200)});
        });
      });
    }).then(function(ok){
      if(!ok)throw new Error(tab+' did not hydrate.');
      loadState[tab]='done';
      loadAttempts[tab]=0;
      return true;
    }).catch(function(){
      loadState[tab]='failed';
      loadAttempts[tab]=num(loadAttempts[tab])+1;
      scheduleRetry(tab);
      return false;
    }).finally(function(){delete loadPromises[tab]});
    loadPromises[tab]=p;
    return p;
  }
  function preloadServices(){
    if(preloadPromise)return preloadPromise;
    var tabs=['market','missions','orders','offer','sales','gift','txns'];
    preloadPromise=tabs.reduce(function(chain,tab){
      return chain.then(function(){return ensureLoaded(tab,false)}).then(function(){return wait(90)});
    },Promise.resolve()).finally(function(){preloadPromise=null});
    return preloadPromise;
  }

  function refreshBalances(force){
    // Render one grouped local/dashboard snapshot, then issue one dashboard call.
    renderStoneBalances();
    var cached=savedCurrency(),hasSaved=renderCurrencyBalances(cached);
    if(cached){applyCoinBank(cached);renderCoinBank()}
    if(balanceBusy&&!force)return Promise.resolve();
    balanceBusy=true;
    var btn=el('slbGoldenRefresh');
    if(btn){btn.disabled=true;btn.classList.add('is-loading')}
    setSync(hasSaved?'Saved balances shown. Refreshing together…':'Syncing all four balances together…','busy');

    var hub=balanceHub(),a=app();
    var grouped=(hub&&typeof hub.refresh==='function')?hub.refresh({force:!!force}):waitForAuth(12000).then(function(){
      if(a&&typeof a.refreshDashboardLite==='function')return a.refreshDashboardLite();
      return null;
    }).then(function(){return a&&a.S&&a.S.dash&&a.S.dash.currencySnapshot||null});

    return Promise.resolve(grouped).then(function(data){
      renderStoneBalances();
      data=data||savedCurrency();
      if(data){renderCurrencyBalances(data);applyCoinBank(data);renderCoinBank()}
      setSync('Golden Treasury ready.','good');
      return true;
    }).catch(function(){
      renderStoneBalances();renderCurrencyBalances(savedCurrency());
      setSync(hasSaved?'Saved balances ready; live refresh is delayed.':'Could not refresh all balances.','error');
      return false;
    }).finally(function(){
      balanceBusy=false;
      if(btn){btn.disabled=false;btn.classList.remove('is-loading')}
    });
  }


  function findPanels(){
    ['accounts','deposit','withdraw','gift','txns','missions','market','orders','offer','sales'].forEach(function(tab){
      var p=qs('[data-panel="'+tab+'"]');
      if(!p)return;
      panelMap[tab]=p;
      if(!anchorMap[tab]){
        var c=d.createComment('SLB Golden Center anchor: '+tab);
        p.parentNode.insertBefore(c,p);
        anchorMap[tab]=c;
      }
    });
  }
  function placeholderFor(group){
    return '<div class="slbGoldenLoading">Choose a '+(group==='market'?'market counter':group==='mission'?'mission':'bank service')+'.</div>';
  }
  function restoreGroup(group){
    var tab=mountedByGroup[group];
    if(!tab)return;
    var p=panelMap[tab],anchor=anchorMap[tab];
    if(p&&anchor&&anchor.parentNode){
      p.setAttribute('data-panel',tab);
      p.classList.add('hidden');
      p.classList.remove('slbGoldenHostedPanel');
      p.removeAttribute('data-golden-hosted');
      p.setAttribute('aria-hidden','true');
      anchor.parentNode.insertBefore(p,anchor.nextSibling);
    }
    var host=el(group==='bank'?'slbGoldenBankHost':group==='mission'?'slbGoldenMissionHost':'slbGoldenMarketHost');
    if(host)host.innerHTML=placeholderFor(group);
    delete mountedByGroup[group];
  }
  function restoreAll(){
    restoreGroup('bank');restoreGroup('mission');restoreGroup('market');
  }
  function normalizeHostedPanel(panel){
    if(!panel)return;
    qsa('table',panel).forEach(function(table){
      table.style.removeProperty('border-collapse');
      table.style.removeProperty('border-spacing');
      table.style.removeProperty('background');
      table.style.removeProperty('background-color');
      table.style.removeProperty('box-shadow');
    });
    qsa('thead th,thead td,tbody td',panel).forEach(function(cell){
      ['background','background-color','background-image','background-clip','color','opacity','border','border-color','box-shadow'].forEach(function(prop){cell.style.removeProperty(prop)});
    });
  }
  function callLoader(tab,panel){
    var job=ensureLoaded(tab,false);
    Promise.resolve(job).then(function(){normalizeHostedPanel(panel||panelMap[tab])});
    return job;
  }

  function ensureMountedHydration(tab,panel){
    if(!needsHydrationCheck(tab))return;
    if(mountedHydrationTimers[tab])clearTimeout(mountedHydrationTimers[tab]);
    var attempts=0,group=(tab==='missions'?'mission':'market');
    function run(){
      if(!panel||!panel.isConnected||mountedByGroup[group]!==tab)return;
      normalizeHostedPanel(panel);
      if(isHydrated(tab))return;
      attempts++;
      Promise.resolve(ensureLoaded(tab,true)).then(function(){normalizeHostedPanel(panel)}).finally(function(){
        if(!isHydrated(tab)&&attempts<5)mountedHydrationTimers[tab]=setTimeout(run,Math.min(2200,250+(attempts*450)));
      });
    }
    mountedHydrationTimers[tab]=setTimeout(run,180);
  }

  function mountPanel(tab,group){
    findPanels();
    var p=panelMap[tab],host=el(group==='bank'?'slbGoldenBankHost':group==='mission'?'slbGoldenMissionHost':'slbGoldenMarketHost');
    if(!p||!host){if(host)host.innerHTML='<div class="slbGoldenLoading error">This service could not be opened.</div>';return false}
    if(mountedByGroup[group]===tab){
      p.classList.remove('hidden');
      if(isMarketTab(tab)){renderLoadedMarket(tab,p);scheduleVisibleMarketRefresh(tab,p)}
      return true
    }
    restoreGroup(group);
    /* Keep data-panel intact: the original Market/Mission modules use it for lifecycle checks. */
    p.classList.remove('hidden');
    p.classList.add('slbGoldenHostedPanel');
    p.setAttribute('data-golden-hosted',group);
    p.setAttribute('aria-hidden','false');
    host.innerHTML='';
    host.appendChild(p);
    mountedByGroup[group]=tab;
    normalizeHostedPanel(p);
    callLoader(tab,p);
    if(tab==='missions')ensureMountedHydration(tab,p);
    if(isMarketTab(tab)){
      renderLoadedMarket(tab,p);
      if(w.requestAnimationFrame)w.requestAnimationFrame(function(){renderLoadedMarket(tab,p)});
      setTimeout(function(){renderLoadedMarket(tab,p)},90);
      scheduleVisibleMarketRefresh(tab,p);
    }
    setTimeout(function(){normalizeHostedPanel(p)},60);
    return true;
  }

  function markButtons(selector,value,attr){
    qsa(selector,root).forEach(function(b){
      var active=String(b.getAttribute(attr)||'')===String(value);
      b.classList.toggle('active',active);
      b.setAttribute('aria-pressed',active?'true':'false');
    });
  }
  function syncRoute(){setTimeout(function(){try{if(w.SLB_route&&typeof w.SLB_route.sync==='function')w.SLB_route.sync(false)}catch(_e){}},0)}
  function openBank(tab){
    currentBank=tab||'accounts';routeTab=currentBank;
    markButtons('[data-golden-bank]',currentBank,'data-golden-bank');
    var title=PANEL_TITLES[currentBank]||['BANK STATION',currentBank];
    setText('slbGoldenBankTitle',title[1]);
    if(currentBank==='coins'){openCoinBank();syncRoute();return}
    mountPanel(currentBank,'bank');syncRoute();
  }
  function openMarket(tab){
    currentMarket=tab||(currentMarketSide==='sell'?'offer':'market');routeTab=currentMarket;
    currentMarketSide=(currentMarket==='offer'||currentMarket==='sales')?'sell':'buy';
    qsa('[data-golden-market-side]',root).forEach(function(b){
      var active=b.getAttribute('data-golden-market-side')===currentMarketSide;
      b.classList.toggle('active',active);b.setAttribute('aria-selected',active?'true':'false');
    });
    qsa('[data-golden-market-lane]',root).forEach(function(l){l.classList.toggle('active',l.getAttribute('data-golden-market-lane')===currentMarketSide)});
    markButtons('[data-golden-market]',currentMarket,'data-golden-market');
    var title=PANEL_TITLES[currentMarket]||['MARKET COUNTER',currentMarket];
    setText('slbGoldenMarketTitle',title[1]);
    mountPanel(currentMarket,'market');syncRoute();
  }
  function setMarketSide(side){
    currentMarketSide=side==='sell'?'sell':'buy';
    openMarket(currentMarketSide==='sell'?'offer':'market');
  }
  function openMissions(){routeTab='missions';mountPanel('missions','mission');syncRoute()}

  function setAccordion(name,open){
    var section=qs('[data-golden-section="'+name+'"]',root);
    var btn=qs('[data-golden-accordion="'+name+'"]',root);
    var body=el(name==='bank'?'slbGoldenBankBody':name==='budget'?'slbGoldenBudgetBody':name==='missions'?'slbGoldenMissionBody':name==='market'?'slbGoldenMarketBody':'');
    if(!section||!btn||!body)return;
    section.classList.toggle('is-open',!!open);
    body.classList.toggle('hidden',!open);
    btn.setAttribute('aria-expanded',open?'true':'false');
    var state=qs('.slbGoldenStationState',btn);
    if(state)state.textContent=open?'CLOSE STATION':name==='bank'?'ENTER BANK':name==='missions'?'VIEW MISSIONS':name==='market'?'ENTER MARKET':'ASK FOR HELP';
    if(open){
      if(name==='bank')openBank(currentBank);
      if(name==='budget')activateBudget(true);
      if(name==='missions')openMissions();
      if(name==='market')openMarket(currentMarket);
    }
  }

  function budgetAssetUrl(host,name){
    return String(host&&host.getAttribute('data-bb-'+name+'-url')||'').trim();
  }
  function ensureBudgetCss(host){
    var url=budgetAssetUrl(host,'css');
    if(!url)return;
    var clean=url.split('?')[0];
    var found=qsa('link[rel="stylesheet"][href]',d).some(function(node){return String(node.href||'').split('?')[0]===clean});
    if(found)return;
    var link=d.createElement('link');link.rel='stylesheet';link.href=url;link.setAttribute('data-slb-bb-budget-asset','css');
    (d.head||d.documentElement).appendChild(link);
  }
  function loadBudgetScript(host,name,ready){
    if(ready())return Promise.resolve(true);
    var url=budgetAssetUrl(host,name);
    if(!url)return Promise.reject(new Error('Missing BB Budget '+name+' asset URL.'));
    return new Promise(function(resolve,reject){
      var script=d.createElement('script');
      script.src=/^(?:data:|blob:)/i.test(url)?url:(url+(url.indexOf('?')>=0?'&':'?')+'slb_bb_retry='+Date.now()+'_'+name);
      script.async=false;
      script.setAttribute('data-slb-bb-budget-asset',name);
      script.setAttribute('data-slb-managed-resource','bb-budget-'+name);
      script.onload=function(){if(ready())resolve(true);else reject(new Error('BB Budget '+name+' loaded without becoming ready.'))};
      script.onerror=function(){reject(new Error('BB Budget '+name+' failed to load.'))};
      (d.head||d.documentElement).appendChild(script);
    });
  }
  function ensureBudgetAssets(host){
    ensureBudgetCss(host);
    return loadBudgetScript(host,'util',function(){return !!(w.TYBH&&w.TYBH.util)})
      .then(function(){return loadBudgetScript(host,'core',function(){return !!(w.TYBH&&w.TYBH.core)})})
      .then(function(){return loadBudgetScript(host,'ui',function(){return !!(w.TYBH&&w.TYBH.ui&&typeof w.TYBH.ui.openEmbedded==='function')})});
  }
  function showBudgetStartError(host,err){
    var box=el('slbGoldenBudgetStartError');
    if(!box){
      box=d.createElement('div');box.id='slbGoldenBudgetStartError';box.className='slbGoldenLoading error';
      host.insertBefore(box,host.firstChild||null);
    }
    box.textContent='BB Budget could not start. '+String(err&&err.message||'Please reopen the station.');
  }
  function clearBudgetStartState(host){
    var box=el('slbGoldenBudgetStartError');if(box&&box.parentNode)box.parentNode.removeChild(box);
    var wait=el('slbGoldenBudgetStarting');if(wait&&wait.parentNode)wait.parentNode.removeChild(wait);
  }
  function activateBudget(scrollIntoView){
    var host=el('slbGoldenBudgetHost');
    if(!host)return false;
    function scroll(){
      if(!scrollIntoView)return;
      var station=qs('[data-golden-section="budget"]',root);
      if(station&&station.scrollIntoView)setTimeout(function(){station.scrollIntoView({behavior:'smooth',block:'start'})},40);
    }
    if(budgetStarted&&w.TYBH&&w.TYBH.ui&&typeof w.TYBH.ui.openEmbedded==='function'){
      clearBudgetStartState(host);scroll();
      Promise.resolve(w.TYBH.ui.openEmbedded()).catch(function(err){showBudgetStartError(host,err)});
      return true;
    }
    if(budgetStartPromise){scroll();return true}
    clearBudgetStartState(host);
    var waiting=d.createElement('div');waiting.id='slbGoldenBudgetStarting';waiting.className='slbGoldenLoading';waiting.textContent='Opening BB Budget…';
    host.insertBefore(waiting,host.firstChild||null);
    budgetStartPromise=ensureBudgetAssets(host).then(function(){
      if(!(w.TYBH&&w.TYBH.ui&&typeof w.TYBH.ui.openEmbedded==='function'))throw new Error('BB Budget UI is not ready.');
      return Promise.resolve(w.TYBH.ui.openEmbedded());
    }).then(function(){
      budgetStarted=true;clearBudgetStartState(host);scroll();return true;
    }).catch(function(err){
      budgetStarted=false;clearBudgetStartState(host);showBudgetStartError(host,err);throw err;
    }).finally(function(){budgetStartPromise=null});
    budgetStartPromise.catch(function(){});
    return true;
  }
  function openBudget(){
    if(!root)return;
    setAccordion('budget',true);
  }
  function scheduleMoneyRefresh(){
    setTimeout(function(){refreshBalances(true)},900);
    setTimeout(function(){refreshBalances(true)},3200);
  }

  function openTab(tab){
    tab=String(tab||'accounts').trim();if(!root&&!init())return false;
    ['bank','budget','missions','market'].forEach(function(name){setAccordion(name,false)});
    if(['accounts','deposit','withdraw','gift','txns','coins'].indexOf(tab)>=0){currentBank=tab;routeTab=tab;setAccordion('bank',true);return true}
    if(tab==='missions'){routeTab='missions';setAccordion('missions',true);return true}
    if(['market','orders','offer','sales'].indexOf(tab)>=0){currentMarket=tab;routeTab=tab;setAccordion('market',true);return true}
    currentBank='accounts';routeTab='accounts';setAccordion('bank',true);return true;
  }
  function getRouteState(){return {tab:routeTab||'accounts'}}

  function bind(){
    if(!root||root.dataset.goldenBound==='1')return;
    root.dataset.goldenBound='1';
    root.addEventListener('click',function(e){
      var t=e.target&&e.target.closest?e.target.closest('button'):null;if(!t)return;
      var accordion=t.getAttribute('data-golden-accordion');
      if(accordion){setAccordion(accordion,t.getAttribute('aria-expanded')!=='true');return}
      var bank=t.getAttribute('data-golden-bank');if(bank){openBank(bank);return}
      var side=t.getAttribute('data-golden-market-side');if(side){setMarketSide(side);return}
      var market=t.getAttribute('data-golden-market');if(market){openMarket(market);return}
      if(t.id==='slbGoldenCoinBuy'){coinBankExchange('buy',false);return}
      if(t.id==='slbGoldenCoinCash'){coinBankExchange('cash',false);return}
      if(t.id==='slbGoldenCoinCashAll'){coinBankExchange('cash',true);return}
      if(t.id==='slbGoldenCoinRefresh'){loadCoinBank(true);return}
      var coinFilter=t.getAttribute('data-golden-coin-filter');if(coinFilter){coinBank.filter=coinFilter;renderCoinBank();return}
      if(t.id==='slbGoldenRefresh'){refreshBalances(true);return}
    });

    root.addEventListener('change',function(e){
      var t=e.target;if(!t||t.id!=='slbGoldenCoinPouch')return;
      coinBank.pouchId=String(t.value||'');var p=selectedCoinPouch();coinBank.wallet=p&&p.wallet||null;coinBank.status='Coin Drawer selected.';coinBank.error=false;renderCoinBank();
    });

    w.addEventListener('slb:dashboard-updated',function(event){if(root&&!root.classList.contains('hidden')){renderStoneBalances();var data=event&&event.detail&&(event.detail.currencySnapshot||event.detail);if(data){renderCurrencyBalances(data);applyCoinBank(data);renderCoinBank()}}});
    w.addEventListener('slb:currency-updated',function(event){
      var data=event&&event.detail;if(!data)return;
      renderCurrencyBalances(data);applyCoinBank(data);renderCoinBank();
    });

    d.addEventListener('click',function(e){
      var menu=e.target&&e.target.closest?e.target.closest('.menuItem[data-tab]'):null;
      if(menu&&menu.getAttribute('data-tab')!==TAB)restoreAll();
      if(menu&&menu.getAttribute('data-tab')===TAB&&menu.getAttribute('data-golden-open')==='budget'){
        setTimeout(function(){openBudget()},80);
      }
      var helpClose=e.target&&e.target.closest?e.target.closest('#slbHelpClose,#slbHelpClose2,.slbHelpX,[data-slb-help-close]'):null;
      if(helpClose&&w.SLB_HELP&&typeof w.SLB_HELP.close==='function'){w.SLB_HELP.close();return;}
      var action=e.target&&e.target.closest?e.target.closest('#tywDepBtn,#tywWitBtn,#tywGiftBtn,#tywCreateAcctBtn,#tywOfferPostBtn,[data-buy-offer],[data-order-action],[data-sale-action],[data-ms-start],[data-ms-done],#tywMissionDoneConfirmBtn'):null;
      if(action)scheduleMoneyRefresh();
    },true);

    if(observer)observer.disconnect();
    observer=new MutationObserver(function(){if(root.classList.contains('hidden'))restoreAll()});
    observer.observe(root,{attributes:true,attributeFilter:['class']});
  }

  function init(){
    root=el('slbGoldenCenterPanel');
    if(!root)return false;
    findPanels();bind();
    if(!root.classList.contains('hidden'))open();
    return true;
  }
  function open(){
    if(!root&&!init())return;
    routeTab='accounts';currentBank='accounts';
    setAccordion('bank',true);
    refreshBalances(false);
    loadCoinBank();
    activateBudget(false);
    preloadServices();
    setTimeout(function(){preloadServices()},2200);
  }

  w.SLB_GOLDEN_CENTER={open:open,openTab:openTab,getRouteState:getRouteState,openBudget:openBudget,restoreAll:restoreAll,refresh:refreshBalances,mount:function(tab,group){return mountPanel(tab,group)},preload:preloadServices,reload:function(tab){return ensureLoaded(String(tab||''),true)},status:function(tab){tab=String(tab||'');return {state:loadState[tab]||'idle',attempts:num(loadAttempts[tab]),hydrated:isHydrated(tab)}}};
  w.SLB=w.SLB||{};
  if(w.SLB.features&&typeof w.SLB.features.register==='function')w.SLB.features.register(TAB,{onOpen:open});

  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})(window,document);


/* ====== SLB FEATURE: 72_my_cabin.js ====== */
/*
  SLB My Cabin V11
  Daily home hub that temporarily hosts the original live SLB panels.

  Important lifecycle rule:
  Many original SLB apps refuse to hydrate while their panel has the `hidden`
  class. My Cabin therefore parks background tabs in an off-screen live dock,
  removes `hidden`, runs each original loader, and only marks a tab ready after
  its real UI/state has settled. No generic "resolved promise = loaded" logic.
*/
(function(w,d){
  'use strict';

  var TAB='myCabin';
  var root=null;
  var panelMap={};
  var anchorMap={};
  var mounted={};
  var parked={};
  var current={day:'overview',tao:'m3Received',portal:'diaryWrite',settings:'user'};
  var routeTab='overview';
  var observer=null;
  var wealthBusy=false;
  var modulePromises={};
  var preloadPromise=null;
  var preloadState={};
  var preloadDock=null;
  var virtualPanels={};
  var diaryReadFold=null;
  var diaryReadAnchor=null;
  var m3ReceivedMap={};
  var backupBound=false;

  var GROUP_HOSTS={
    day:'slbCabinDayHost',
    tao:'slbCabinTaoHost',
    portal:'slbCabinPortalHost',
    settings:'slbCabinSettingsHost'
  };
  var PANEL_TITLES={
    overview:'Starting My Day',m3Received:'Celestial Kitchen Receive',diaryRead:'Read Diary',cult:'My Altar',treasures:'Treasures',library:'Library',
    diaryWrite:'Write Diary',chat:'Chat',m3Offering:'Celestial Kitchen Brew',cabinEmail:'E-Mail',user:'User',export:'Backup',help:'SLB Help'
  };
  // Physical SLB panels. Cabin-only views are built separately and are never
  // mistaken for normal MAIN-menu panels.
  var PANEL_TABS=['overview','diary','cult','treasures','library','chat','m3Offering','user','export'];
  var PRELOAD_TABS=[];
  var LEGACY_COIN_CACHE_KEY='slb_cabin_coin_total_v3145';

  function el(id){return d.getElementById(id)}
  function qs(sel,scope){try{return (scope||d).querySelector(sel)}catch(_e){return null}}
  function qsa(sel,scope){try{return Array.prototype.slice.call((scope||d).querySelectorAll(sel))}catch(_e){return []}}
  function num(v){var n=Number(v);return Number.isFinite(n)?n:0}
  function format(v){try{return num(v).toLocaleString('en-CA',{maximumFractionDigits:2})}catch(_e){return String(num(v))}}
  function app(){return w.SLB_APP||null}
  function sleep(ms){return new Promise(function(resolve){setTimeout(resolve,ms)})}
  function cabinVisible(){return !!(root&&!root.classList.contains('hidden'))}
  function text(node){return String(node&&node.textContent||'').trim()}
  function esc(value){return String(value==null?'':value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;')}
  function loadingText(value){return /loading|preparing|waiting|still preparing/i.test(String(value||''))}

  function unwrap(out){
    var cur=out,i=0;
    while(cur&&typeof cur==='object'&&i<6){
      if(cur.ok===false)throw new Error(cur.error||cur.err||cur.message||'SLB request failed.');
      if(cur.data&&typeof cur.data==='object'&&Object.keys(cur).length<=5){cur=cur.data;i++;continue}
      if(cur.result&&typeof cur.result==='object'&&Object.keys(cur).length<=5){cur=cur.result;i++;continue}
      break;
    }
    return cur;
  }
  function rpc(action,args,opts){
    var a=app(),fn=a&&(typeof a.__realRpc==='function'?a.__realRpc:typeof a.rpc==='function'?a.rpc:null);
    if(!fn&&w.SLB&&typeof w.SLB.rpc==='function')fn=w.SLB.rpc.bind(w.SLB);
    if(!fn)return Promise.reject(new Error('SLB is not ready.'));
    return Promise.resolve(fn.call(a||w.SLB,action,args||{},opts||{})).then(unwrap);
  }
  function storedToken(){
    var a=app(),s=a&&a.S;
    if(s&&s.token)return String(s.token||'');
    try{var t=sessionStorage.getItem('tyw_token');if(t)return String(t)}catch(_e0){}
    try{var raw=localStorage.getItem('ty_auth_v1');if(raw){var x=JSON.parse(raw);if(x&&x.token)return String(x.token)}}catch(_e1){}
    return '';
  }
  function waitForAuth(timeout){
    var started=Date.now();
    return new Promise(function(resolve,reject){
      function check(){
        if(app()&&storedToken()){resolve(true);return}
        if(Date.now()-started>=timeout){reject(new Error('SLB login is not ready.'));return}
        setTimeout(check,120);
      }
      check();
    });
  }
  function waitForValue(getter,timeout,label){
    var started=Date.now();
    return new Promise(function(resolve,reject){
      function check(){
        var value=null;
        try{value=getter()}catch(_e){}
        if(value){resolve(value);return}
        if(Date.now()-started>=timeout){reject(new Error((label||'SLB component')+' is not ready.'));return}
        setTimeout(check,120);
      }
      check();
    });
  }
  function waitForAppMethod(name,timeout){
    return waitForValue(function(){var a=app();return a&&typeof a[name]==='function'?a:null},timeout,'SLB '+name);
  }
  function waitForWindowMethod(path,timeout){
    return waitForValue(function(){
      var cur=w,parts=String(path||'').split('.');
      for(var i=0;i<parts.length;i++){if(!cur)return null;cur=cur[parts[i]]}
      return typeof cur==='function'?cur:null;
    },timeout,path);
  }
  function waitUntil(test,timeout,label,interval){
    var started=Date.now();interval=interval||150;
    return new Promise(function(resolve,reject){
      function check(){
        var ok=false;
        try{ok=!!test()}catch(_e){}
        if(ok){resolve(true);return}
        if(Date.now()-started>=timeout){reject(new Error((label||'Panel')+' did not finish loading.'));return}
        setTimeout(check,interval);
      }
      check();
    });
  }

  function animate(id,value){
    var node=el(id);if(!node)return;
    var end=num(value),start=num(node.dataset.cabinValue||0),beg=Date.now(),duration=520;
    node.dataset.cabinValue=String(end);
    if(!w.requestAnimationFrame){node.textContent=format(end);return}
    function frame(){
      var p=Math.min(1,(Date.now()-beg)/duration),ease=1-Math.pow(1-p,3);
      node.textContent=format(start+(end-start)*ease);
      if(p<1)w.requestAnimationFrame(frame);else node.textContent=format(end);
    }
    w.requestAnimationFrame(frame);
  }
  function nodeNumber(id){
    var node=el(id);if(!node)return null;
    var raw=String(node.textContent||'').replace(/[^0-9.\-]/g,'');
    if(!raw)return null;
    var n=Number(raw);return Number.isFinite(n)?n:null;
  }
  function totalStones(){
    var a=app(),s=a&&a.S,dash=s&&s.dash,totals=dash&&dash.totals;
    if(totals&&totals.totalStones!==undefined)return num(totals.totalStones);
    var dom=nodeNumber('tywTotal');if(dom!==null)return dom;
    var accounts=dash&&Array.isArray(dash.accounts)?dash.accounts:[];
    return accounts.reduce(function(sum,x){return sum+num(x&&x.balance)},0);
  }
  function balanceHub(){return w.SLB_BALANCE_HUB||null}
  function renderCurrencySnapshot(data){
    if(!data||data.totalCoinBalance===undefined)return false;
    animate('slbCabinTotalCoins',data.totalCoinBalance);
    return true;
  }
  function renderSavedCurrency(){
    var a=app(),dash=a&&a.S&&a.S.dash,grouped=dash&&(dash.currencySnapshot||((dash.totalCoinBalance!==undefined||dash.totalSpBalance!==undefined)?dash:null));
    if(renderCurrencySnapshot(grouped))return grouped;
    var hub=balanceHub(),saved=hub&&typeof hub.peek==='function'?hub.peek():null;
    if(renderCurrencySnapshot(saved))return saved;
    // First V3.148 visit can still use the V3.145 Cabin total while the new
    // per-callsign shared snapshot is being created.
    try{
      var raw=localStorage.getItem(LEGACY_COIN_CACHE_KEY),legacy=Number(raw);
      if(raw!==null&&raw!==''&&Number.isFinite(legacy))animate('slbCabinTotalCoins',legacy);
    }catch(_e){}
    return null;
  }

  function refreshWealth(force){
    // Paint one grouped cached/dashboard snapshot first, then make only one live
    // dashboard request for Stones, Pouches, Coins, and SP.
    animate('slbCabinTotalStones',totalStones());
    renderSavedCurrency();
    if(wealthBusy&&!force)return Promise.resolve(false);
    wealthBusy=true;
    var btn=el('slbCabinRefresh');if(btn){btn.disabled=true;btn.classList.add('is-loading')}
    var hub=balanceHub(),a=app();
    var grouped=(hub&&typeof hub.refresh==='function')?hub.refresh({force:!!force}):waitForAuth(15000).then(function(){
      if(a&&typeof a.refreshDashboardLite==='function')return a.refreshDashboardLite();
      return null;
    }).then(function(){return a&&a.S&&a.S.dash&&a.S.dash.currencySnapshot||null});
    return Promise.resolve(grouped).then(function(data){
      animate('slbCabinTotalStones',totalStones());
      renderCurrencySnapshot(data||renderSavedCurrency());
      return true;
    }).catch(function(){
      animate('slbCabinTotalStones',totalStones());renderSavedCurrency();return false;
    }).then(function(value){
      wealthBusy=false;if(btn){btn.disabled=false;btn.classList.remove('is-loading')}return value;
    },function(err){wealthBusy=false;if(btn){btn.disabled=false;btn.classList.remove('is-loading')}throw err});
  }


  function moduleTab(tab){
    if(tab==='diaryRead'||tab==='diaryWrite')return 'diary';
    if(tab==='m3Received')return 'm3Offering';
    return tab;
  }
  function physicalTab(tab){
    if(tab==='diaryWrite')return 'diary';
    return tab;
  }
  function moduleNeeded(tab){var key=moduleTab(tab);return key==='diary'||key==='library'||key==='chat'||key==='m3Offering'||key==='cult'}
  function ensureModule(tab){
    var key=moduleTab(tab);
    if(!moduleNeeded(tab))return Promise.resolve(true);
    if(modulePromises[key])return modulePromises[key];
    modulePromises[key]=waitForValue(function(){return w.SLB_LAZY&&typeof w.SLB_LAZY.ensureForTab==='function'?w.SLB_LAZY:null},15000,'SLB lazy loader')
      .then(function(lazy){return lazy.ensureForTab(key)})
      .then(function(ok){if(ok===false)throw new Error(PANEL_TITLES[tab]+' could not load.');return true})
      .catch(function(err){delete modulePromises[key];throw err});
    return modulePromises[key];
  }

  function findPanels(){
    PANEL_TABS.forEach(function(tab){
      var panel=qs('[data-panel="'+tab+'"]');
      if(!panel)return;
      panelMap[tab]=panel;
      if(!anchorMap[tab]&&panel.parentNode){
        var anchor=d.createComment('SLB My Cabin anchor: '+tab);
        panel.parentNode.insertBefore(anchor,panel);
        anchorMap[tab]=anchor;
      }
    });
  }
  function ensurePreloadDock(){
    if(preloadDock&&preloadDock.parentNode)return preloadDock;
    preloadDock=el('slbCabinPreloadDock');
    if(!preloadDock){
      preloadDock=d.createElement('div');
      preloadDock.id='slbCabinPreloadDock';
      preloadDock.className='slbCabinPreloadDock';
      preloadDock.setAttribute('aria-hidden','true');
      (root||d.body).appendChild(preloadDock);
    }
    return preloadDock;
  }
  function normalizePanel(panel,visible){
    if(!panel)return;
    panel.classList.remove('hidden');
    panel.classList.toggle('slbCabinHostedPanel',!!visible);
    panel.classList.toggle('slbCabinPreloadedPanel',!visible);
    panel.setAttribute('aria-hidden',visible?'false':'true');
  }
  function mountedGroupForTab(tab){
    var groups=Object.keys(mounted);
    for(var i=0;i<groups.length;i++){if(mounted[groups[i]]===tab)return groups[i]}
    return "";
  }
  function parkPanel(tab,force){
    var panel=panelMap[tab],dock=ensurePreloadDock();
    if(!panel||!dock)return false;
    if(!force&&mountedGroupForTab(tab))return false;
    dock.appendChild(panel);
    panel.setAttribute('data-cabin-preloaded','1');
    panel.removeAttribute('data-cabin-hosted');
    normalizePanel(panel,false);
    parked[tab]=true;
    return true;
  }
  function restorePanelHome(tab){
    var panel=panelMap[tab],anchor=anchorMap[tab];
    if(!panel||!anchor||!anchor.parentNode)return false;
    panel.classList.add('hidden');
    panel.classList.remove('slbCabinHostedPanel','slbCabinPreloadedPanel');
    panel.removeAttribute('data-cabin-hosted');
    panel.removeAttribute('data-cabin-preloaded');
    panel.setAttribute('aria-hidden','true');
    anchor.parentNode.insertBefore(panel,anchor.nextSibling);
    delete parked[tab];
    return true;
  }
  function preparePreloadDock(){
    findPanels();ensurePreloadDock();
    PANEL_TABS.forEach(function(tab){
      var isMounted=Object.keys(mounted).some(function(group){return mounted[group]===tab});
      if(!isMounted)parkPanel(tab);
    });
  }

  function hostFor(group){return el(GROUP_HOSTS[group])}
  function placeholder(group){
    var value=group==='day'?'Opening your morning space…':group==='tao'?'Preparing your Tao pages…':group==='portal'?'Preparing the Tao Portal…':'Preparing your settings…';
    return '<div class="slbCabinLoading">'+value+'</div>';
  }
  function restoreGroup(group,forceHome){
    var tab=mounted[group];if(!tab)return;
    if(tab!=='help'&&tab!=='m3Received'&&tab!=='diaryRead'&&tab!=='cabinEmail'){
      var physical=physicalTab(tab);
      if(forceHome||!cabinVisible())restorePanelHome(physical);else parkPanel(physical,true);
    }
    var host=hostFor(group);if(host)host.innerHTML=placeholder(group);
    delete mounted[group];
  }
  function restoreAll(forceHome){
    Object.keys(GROUP_HOSTS).forEach(function(group){restoreGroup(group,!!forceHome)});
    if(forceHome||!cabinVisible()){
      restoreDiarySplit();
      try{if(w.SLB_M3&&typeof w.SLB_M3.setView==='function')w.SLB_M3.setView('all')}catch(_eM3){}
      PANEL_TABS.forEach(restorePanelHome);
      closeM3Modal();
    }
  }
  function showError(host,message){if(host)host.innerHTML='<div class="slbCabinLoading error">'+String(message||'This page could not open.')+'</div>'}
  function stripIds(node){
    if(!node)return;
    if(node.removeAttribute)node.removeAttribute('id');
    qsa('[id]',node).forEach(function(x){x.removeAttribute('id')});
  }
  function buildHelpPage(){
    var wrap=d.createElement('section');wrap.className='slbCabinHelpPage';
    var top=d.createElement('div');top.className='slbCabinHelpTop';
    top.innerHTML='<div><span class="slbCabinHelpKicker">CABIN GUIDE</span><h3>SLB Help</h3><p>Open a topic below. Everything stays inside My Cabin.</p></div>';
    wrap.appendChild(top);
    var source=el('slbHelpTopics');
    if(source){var clone=source.cloneNode(true);stripIds(clone);clone.classList.add('slbCabinHelpTopics');wrap.appendChild(clone)}
    else{var empty=d.createElement('div');empty.className='slbCabinLoading error';empty.textContent='Help topics are still preparing.';wrap.appendChild(empty)}
    return wrap;
  }
  function mountHelp(group){
    var host=hostFor(group);if(!host)return false;
    restoreGroup(group,false);mounted[group]='help';host.innerHTML='';host.appendChild(buildHelpPage());return true;
  }

  function virtualPanel(key,className){
    var panel=virtualPanels[key];
    // A virtual panel may be fully prepared while still detached during
    // background preload. Reuse it so hosted child DOM (Diary Read, etc.) is
    // never orphaned by creating a second replacement panel.
    if(panel)return panel;
    panel=d.createElement('section');
    panel.className='slbCabinVirtualPanel '+(className||'');
    panel.setAttribute('data-cabin-virtual',key);
    virtualPanels[key]=panel;
    return panel;
  }

  function closeM3Modal(){
    var old=el('slbCabinM3Modal');
    if(old&&old.parentNode)old.parentNode.removeChild(old);
  }
  function ensureM3ReceivedPanel(){
    var panel=virtualPanel('m3Received','slbCabinM3Received');
    if(panel.dataset.built!=='1'){
      panel.dataset.built='1';
      panel.innerHTML='<div class="slbCabinLoading">Preparing the Celestial Kitchen receiving portal…</div>';
    }
    return panel;
  }
  function renderM3Received(_records){
    var panel=ensureM3ReceivedPanel();
    try{if(w.SLB_M3&&typeof w.SLB_M3.mountReceive==='function')w.SLB_M3.mountReceive(panel)}catch(_e){}
  }
  function m3ReceivedHydrated(){
    var panel=virtualPanels.m3Received||ensureM3ReceivedPanel();
    return !!qs('#slbMagic3MReceive',panel);
  }
  function loadM3Received(force){
    var panel=ensureM3ReceivedPanel();
    return ensureModule('m3Offering').then(function(){
      return waitForValue(function(){return w.SLB_M3&&typeof w.SLB_M3.mountReceive==='function'?w.SLB_M3:null},20000,'Celestial Kitchen receiving portal');
    }).then(function(api){
      api.mountReceive(panel);
      if(typeof api.setView==='function')api.setView('receive');
      if(force&&typeof api.refresh==='function')return Promise.resolve(api.refresh()).then(function(){api.mountReceive(panel);return true});
      return true;
    }).then(function(){return waitUntil(m3ReceivedHydrated,30000,'Celestial Kitchen receiving portal',160)});
  }

  function ensureDiaryReadPanel(){
    var panel=virtualPanel('diaryRead','slbCabinDiaryReadPanel');
    if(panel.dataset.built!=='1'){
      panel.dataset.built='1';
      panel.innerHTML='<section class="slbCabinLatestReply"><div class="slbCabinLatestReplyHead"><span>LATEST REPLY FROM SI JUEN</span><b id="slbCabinLatestReplyDate">—</b></div><div id="slbCabinLatestReplyBody" class="slbCabinLatestReplyBody"><div class="slbCabinLoading">Checking for the latest reply…</div></div></section><div class="slbCabinDiaryReadHost"><div class="slbCabinLoading">Preparing your diary history…</div></div>';
    }
    return panel;
  }
  function diaryReadHydrated(){var panel=virtualPanels.diaryRead,list=el('slbDiaryReadList')||qs('#slbDiaryReadList',panel);return !!(list&&list.children&&list.children.length)}
  function loadLatestDiaryReply(){
    var panel=ensureDiaryReadPanel(),body=qs('#slbCabinLatestReplyBody',panel),date=qs('#slbCabinLatestReplyDate',panel);
    if(body)body.innerHTML='<div class="slbCabinLoading">Checking for the latest reply…</div>';
    return ensureModule('diary').then(function(){
      return waitForValue(function(){return w.SLB_DIARY&&typeof w.SLB_DIARY.getLatestReply==='function'?w.SLB_DIARY.getLatestReply:null},20000,'Diary latest reply');
    }).then(function(fn){return fn.call(w.SLB_DIARY)}).then(function(reply){
      if(date)date.textContent=reply&&reply.dateKey?reply.dateKey:'No reply yet';
      if(body)body.innerHTML=reply&&reply.html?reply.html:'<div class="slbCabinEmpty">No reply from Si Juen yet.</div>';
      return true;
    }).catch(function(err){
      if(date)date.textContent='Unavailable';
      if(body)body.innerHTML='<div class="slbCabinEmpty error">'+esc(err&&err.message||err||'Could not load the latest reply.')+'</div>';
      return false;
    });
  }
  function prepareDiarySplit(mode){
    return ensureModule('diary').then(function(){
      var api=w.SLB_DIARY;if(api&&typeof api.onOpen==='function')api.onOpen();else if(api&&typeof api.mount==='function')api.mount();
      return waitForValue(function(){return (diaryReadFold||el('slbDiaryFoldRead'))&&el('slbDiaryFoldWrite')?true:null},20000,'Diary sections');
    }).then(function(){
      var diaryPanel=panelMap.diary||qs('[data-panel="diary"]'),readFold=diaryReadFold||el('slbDiaryFoldRead'),writeFold=el('slbDiaryFoldWrite');
      if(!diaryPanel||!readFold||!writeFold)throw new Error('Diary sections are not ready.');
      diaryReadFold=readFold;
      if(!diaryReadAnchor||!diaryReadAnchor.parentNode){diaryReadAnchor=d.createComment('My Cabin Diary Read anchor');readFold.parentNode.insertBefore(diaryReadAnchor,readFold)}
      var readPanel=ensureDiaryReadPanel(),readHost=qs('.slbCabinDiaryReadHost',readPanel);
      if(readFold.parentNode!==readHost){readHost.innerHTML='';readHost.appendChild(readFold)}
      readPanel.classList.add('is-ready');
      readFold.classList.add('slbCabinDiaryReadOnly');
      var readBody=el('slbDiaryReadBoxBody')||qs('#slbDiaryReadBoxBody',readFold),readBtn=qs('button[data-fold="read"]',readFold);
      if(readBody)readBody.classList.remove('hidden');if(readBtn){readBtn.textContent='Close';readBtn.setAttribute('aria-expanded','true')}
      diaryPanel.classList.toggle('slbCabinDiaryWriteOnly',mode==='write');
      var writeBody=el('slbDiaryWriteBody'),writeBtn=qs('button[data-fold="write"]',writeFold);
      if(mode==='write'&&writeBody&&writeBody.classList.contains('hidden')&&writeBtn){try{writeBtn.click()}catch(_e){writeBody.classList.remove('hidden')}}
      if(mode==='read'&&readBody&&readBody.classList.contains('hidden')&&readBtn){try{readBtn.click()}catch(_e2){readBody.classList.remove('hidden')}}
      return true;
    });
  }
  function restoreDiarySplit(){
    var diaryPanel=panelMap.diary||qs('[data-panel="diary"]');
    if(diaryReadFold&&diaryReadAnchor&&diaryReadAnchor.parentNode){diaryReadAnchor.parentNode.insertBefore(diaryReadFold,diaryReadAnchor.nextSibling)}
    if(diaryReadFold)diaryReadFold.classList.remove('slbCabinDiaryReadOnly');
    if(diaryPanel)diaryPanel.classList.remove('slbCabinDiaryWriteOnly');
  }

  function ensureEmailPanel(){
    var panel=virtualPanel('cabinEmail','slbCabinEmailPanel');
    if(panel.dataset.built==='1')return panel;
    panel.dataset.built='1';
    panel.innerHTML='<div class="slbCabinVirtualTop"><div><span>DIRECT MESSAGE</span><h3>E-Mail Jee Si Juen</h3><p>Use this form to email Jee Si Juen directly when your usual email is not working, or when you are outside and need to send it through SLB.</p></div></div>'
      +'<div class="slbCabinEmailForm"><label for="slbCabinEmailSubject">Subject</label><input id="slbCabinEmailSubject" maxlength="180" placeholder="What is this about?">'
      +'<label for="slbCabinEmailBody">Message</label><textarea id="slbCabinEmailBody" maxlength="50000" rows="12" placeholder="Type your message here…"></textarea>'
      +'<div class="slbCabinEmailActions"><div id="slbCabinEmailStatus" class="muted" role="status"></div><button class="btn orange" id="slbCabinEmailSend" type="button">Send E-Mail</button></div></div>';
    panel.addEventListener('click',function(event){if(event.target&&event.target.id==='slbCabinEmailSend')sendCabinEmail()});
    return panel;
  }
  function sendCabinEmail(){
    var subject=String(el('slbCabinEmailSubject')&&el('slbCabinEmailSubject').value||'').trim();
    var body=String(el('slbCabinEmailBody')&&el('slbCabinEmailBody').value||'').trim();
    var button=el('slbCabinEmailSend'),status=el('slbCabinEmailStatus');
    if(!subject||!body){if(status){status.className='err';status.textContent='Enter both a subject and message.'}return Promise.resolve(false)}
    if(button){button.disabled=true;button.textContent='Sending…'}if(status){status.className='muted';status.textContent='Sending securely through SLB…'}
    return waitForAuth(15000).then(function(){return rpc('cabinEmailSend',{subject:subject,body:body},{progressMode:'silent'})}).then(function(){
      if(status){status.className='ok';status.textContent='E-mail sent to Jee Si Juen.'}
      if(el('slbCabinEmailSubject'))el('slbCabinEmailSubject').value='';if(el('slbCabinEmailBody'))el('slbCabinEmailBody').value='';return true;
    }).catch(function(err){if(status){status.className='err';status.textContent=String(err&&err.message||err||'E-mail failed.')}return false}).then(function(result){if(button){button.disabled=false;button.textContent='Send E-Mail'}return result});
  }

  function mountVirtual(tab,group){
    var host=hostFor(group);if(!host)return false;
    restoreGroup(group,false);var panel=tab==='m3Received'?ensureM3ReceivedPanel():tab==='diaryRead'?ensureDiaryReadPanel():ensureEmailPanel();
    host.innerHTML='';host.appendChild(panel);mounted[group]=tab;
    if(tab==='m3Received')hydrateTab('m3Received',false).catch(function(){});
    if(tab==='diaryRead')Promise.all([prepareDiarySplit('read').then(function(){return waitUntil(diaryReadHydrated,45000,'Diary history',180)}),loadLatestDiaryReply()]).catch(function(err){showError(qs('.slbCabinDiaryReadHost',panel),err&&err.message||err)});
    return true;
  }

  function overviewHydrated(){
    var today=text(el('slbOvAnnivTodayLine'));
    var status=text(el('slbOvAnnivStatus'));
    return !!today&&!loadingText(today)&&!!status&&!loadingText(status);
  }
  function cultivationHost(){
    var panel=el('slbCultPanel');
    return panel&&panel.querySelector?panel.querySelector('slb-my-altar-live-v2'):null;
  }
  function cultivationHydrated(){
    var host=cultivationHost(),api=w.SLB_MY_ALTAR,mount=host&&host.shadow&&host.shadow.querySelector('[data-mount]');
    return !!(host&&host.rby&&host.rby.engine&&mount&&mount.classList.contains('is-ready')&&api&&typeof api.open==='function');
  }
  function prefetchPublishedMyAltar(){
    return waitForValue(function(){return w.SLB_UAE&&typeof w.SLB_UAE.prefetchMyAltarPublished==='function'?w.SLB_UAE.prefetchMyAltarPublished:null},20000,'Published My Altar prefetch').then(function(fn){return Promise.resolve(fn.call(w.SLB_UAE,false));}).catch(function(){return false;});
  }
  function treasuresHydrated(){
    var a=app(),st=a&&typeof a.getTreasuresState==='function'?a.getTreasuresState():null;
    var list=el('slbTreList');
    return !!(st&&st.loadedOnce&&!st.loading&&list&&list.children&&list.children.length);
  }
  function libraryHydrated(){
    var cats=el('slbLibCats'),list=el('slbLibList');
    if(cats&&cats.children&&cats.children.length)return true;
    if(list&&!list.classList.contains('hidden')&&list.children&&list.children.length)return true;
    return false;
  }
  function chatHydrated(){
    var rooms=el('slbChatRooms');
    return !!(rooms&&rooms.querySelector('.slbChatRoomBtn'));
  }
  function diaryHydrated(){
    var panel=panelMap.diary;
    return !!(panel&&panel.__slbDiaryMounted&&(el('slbDiaryFoldWrite')||el('slbDiaryDate')||el('slbDiaryBodyRich')));
  }
  function diaryWriteHydrated(){return diaryHydrated()&&!!el('slbDiaryWriteBody')}
  function m3Hydrated(){
    var panel=panelMap.m3Offering;
    if(!panel)return false;
    return !/Loading…|module is not loaded/i.test(String(panel.textContent||''));
  }

  function loadOverview(force){
    return waitForAuth(20000).then(function(){
      try{if(w.SLB&&w.SLB.features&&typeof w.SLB.features.onOpen==='function')w.SLB.features.onOpen('overview',{embedded:true,container:'myCabin'})}catch(_e){}
      return waitForValue(function(){return w.SLB&&typeof w.SLB.__overviewAnnivRefresh==='function'?w.SLB.__overviewAnnivRefresh:null},12000,'Overview lunar/anniversary loader');
    }).then(function(refresh){
      var a=app();
      var board=a&&typeof a.refreshBoard==='function'?Promise.resolve(a.refreshBoard(force===true)).catch(function(){return false}):Promise.resolve(false);
      var anniv=Promise.resolve(refresh(force===true));
      return Promise.all([board,anniv]);
    }).then(function(){return waitUntil(overviewHydrated,30000,'Lunar date and anniversaries',180)});
  }
  function loadCultivation(force){
    // The Cabin button is not a normal MAIN-menu tab, so the global lazy loader
    // never sees a data-tab="cult" click. Load Universal Altar explicitly
    // before waiting for the live custom element to upgrade.
    return ensureModule('cult').then(function(){return waitForAuth(20000)}).then(function(){
      return Promise.all([
        waitForValue(function(){return cultivationHost()&&cultivationHost().shadow?cultivationHost():null},20000,'My Altar live host'),
        waitForValue(function(){return w.SLB_MY_ALTAR&&typeof w.SLB_MY_ALTAR.open==='function'?w.SLB_MY_ALTAR:null},20000,'My Altar')
      ]);
    }).then(function(parts){
      var host=parts[0],api=parts[1];
      var ready=host&&typeof host.activate==='function'?Promise.resolve(host.activate()):Promise.resolve(host);
      return ready.then(function(){
        // Opening My Altar must never wait behind a second blocking PET bootstrap.
        // The controller renders its local PET cache immediately and syncs quietly.
        try{api.open(host)}catch(_eOpen){}
        try{if(api.mountController)api.mountController(host)}catch(_eMount){}
        // api.open() already starts one quiet PET sync. Do not start a second
        // forced bootstrap while the first one is still running.
        return true;
      });
    }).then(function(){return waitUntil(cultivationHydrated,12000,'My Altar',100)});
  }
  function loadTreasures(force){
    return waitForAuth(25000).then(function(){
      return waitForValue(function(){var a=app();return a&&(typeof a.openTreasures==='function'||typeof a.loadTreasures==='function')?a:null},25000,'SLB Treasures controller');
    }).then(function(a){
      try{if(typeof a.bindTreasures==='function')a.bindTreasures()}catch(_e0){}
      var run=typeof a.openTreasures==='function'?a.openTreasures(force===true):a.loadTreasures(force===true);
      return Promise.resolve(run).then(function(){
        try{if(typeof a.bindTreasures==='function')a.bindTreasures()}catch(_e1){}
        try{if(typeof a.renderTreasures==='function')a.renderTreasures()}catch(_e2){}
      });
    }).then(function(){return waitUntil(treasuresHydrated,95000,'Treasures',220)});
  }
  function loadLibrary(){
    return ensureModule('library').then(function(){return waitForValue(function(){return w.SLB_LIBRARY&&typeof w.SLB_LIBRARY.reload==='function'?w.SLB_LIBRARY.reload:null},20000,'Library loader')}).then(function(fn){
      return Promise.resolve(fn.call(w.SLB_LIBRARY));
    }).then(function(){return waitUntil(libraryHydrated,60000,'Library',220)});
  }
  function loadChat(){
    return ensureModule('chat').then(function(){return waitForValue(function(){return w.SLB_CHAT&&typeof w.SLB_CHAT.onOpen==='function'?w.SLB_CHAT.onOpen:null},25000,'Chat loader')}).then(function(fn){
      return Promise.resolve(fn.call(w.SLB_CHAT));
    }).then(function(){return waitUntil(chatHydrated,45000,'Chat rooms',200)});
  }
  function loadDiaryRead(){
    return Promise.all([prepareDiarySplit('read').then(function(){return waitUntil(diaryReadHydrated,45000,'Diary history',180)}),loadLatestDiaryReply()]).then(function(){return true});
  }
  function loadDiaryWrite(){
    return prepareDiarySplit('write').then(function(){return waitUntil(diaryWriteHydrated,30000,'Diary writer',160)});
  }
  function loadM3(){
    return ensureModule('m3Offering').then(function(){return waitForValue(function(){return w.SLB_M3&&(typeof w.SLB_M3.open==='function'||typeof w.SLB_M3.refresh==='function')?w.SLB_M3:null},20000,'Celestial Kitchen Brew')}).then(function(api){
      if(typeof api.open==='function')api.open('send');else api.refresh();
      try{if(typeof api.setView==='function')api.setView('send')}catch(_e){}
      return waitUntil(m3Hydrated,30000,'Celestial Kitchen Brew',180);
    });
  }
  function loadSimple(tab){
    return waitForAuth(15000).then(function(){
      var a=app();
      if(a&&typeof a.activateEmbeddedTab==='function')return a.activateEmbeddedTab(tab);
      return true;
    });
  }
  function runOriginalLoader(tab,force){
    if(tab==='overview')return loadOverview(force);
    if(tab==='m3Received')return loadM3Received(force);
    if(tab==='diaryRead')return loadDiaryRead();
    if(tab==='cult')return loadCultivation(force);
    if(tab==='treasures')return loadTreasures(force);
    if(tab==='library')return loadLibrary();
    if(tab==='diaryWrite')return loadDiaryWrite();
    if(tab==='chat')return loadChat();
    if(tab==='m3Offering')return loadM3();
    return loadSimple(tab);
  }
  function tabHydrated(tab){
    if(tab==='overview')return overviewHydrated();
    if(tab==='m3Received')return m3ReceivedHydrated();
    if(tab==='diaryRead')return diaryReadHydrated();
    if(tab==='cult')return cultivationHydrated();
    if(tab==='treasures')return treasuresHydrated();
    if(tab==='library')return libraryHydrated();
    if(tab==='diaryWrite')return diaryWriteHydrated();
    if(tab==='chat')return chatHydrated();
    if(tab==='m3Offering')return m3Hydrated();
    return true;
  }
  function hydrateTab(tab,force){
    if(!force&&preloadState[tab]==='ready'&&tabHydrated(tab))return Promise.resolve(true);
    if(!force&&preloadState[tab]&&typeof preloadState[tab].then==='function')return preloadState[tab];
    var attempts=force?2:3;
    var task=waitForAuth(20000).then(function(){
      var physical=physicalTab(tab);
      if(tab!=='overview'&&tab!=='m3Received'&&tab!=='diaryRead'&&tab!=='cabinEmail'&&!mountedGroupForTab(tab)&&!mountedGroupForTab(physical))parkPanel(physical,false);
      function attempt(index){
        return runOriginalLoader(tab,force||index>0).then(function(){
          if(!tabHydrated(tab))throw new Error(PANEL_TITLES[tab]+' did not hydrate.');
          return true;
        }).catch(function(err){
          if(index+1>=attempts)throw err;
          return sleep(650*(index+1)).then(function(){return attempt(index+1)});
        });
      }
      return attempt(0);
    }).then(function(){preloadState[tab]='ready';return true}).catch(function(err){
      preloadState[tab]='failed';
      try{console.warn('[My Cabin] '+(PANEL_TITLES[tab]||tab)+' preload:',err&&err.message||err)}catch(_e){}
      return false;
    });
    preloadState[tab]=task;
    return task;
  }


  function activateVisiblePanel(tab){
    try{
      if(tab==='diaryRead'){
        loadDiaryRead().catch(function(){});return;
      }
      if(tab==='diaryWrite'){
        loadDiaryWrite().catch(function(){});return;
      }
      if(tab==='treasures'){
        var a=app();
        try{if(a&&typeof a.bindTreasures==='function')a.bindTreasures()}catch(_e0){}
        try{if(a&&typeof a.renderTreasures==='function')a.renderTreasures()}catch(_e1){}
        hydrateTab('treasures',true).then(function(){
          var currentApp=app();
          try{if(currentApp&&typeof currentApp.bindTreasures==='function')currentApp.bindTreasures()}catch(_e2){}
          try{if(currentApp&&typeof currentApp.renderTreasures==='function')currentApp.renderTreasures()}catch(_e3){}
        }).catch(function(){});
        return;
      }
      if(tab==='m3Offering'){
        loadM3().catch(function(){});return;
      }
      if(tab==='m3Received'){
        loadM3Received(false).catch(function(){});return;
      }
      hydrateTab(tab,!tabHydrated(tab)).catch(function(){});
    }catch(_e){}
  }

  function mountPanel(tab,group){
    findPanels();
    if(tab==='help')return mountHelp(group);
    if(tab==='m3Received'||tab==='diaryRead'||tab==='cabinEmail')return mountVirtual(tab,group);
    var physical=physicalTab(tab),panel=panelMap[physical],host=hostFor(group);
    if(!panel||!host){showError(host,PANEL_TITLES[tab]+' could not open.');return false}
    if(mounted[group]===tab){
      if(panel.parentNode!==host){host.innerHTML='';host.appendChild(panel)}
      panel.setAttribute('data-cabin-hosted',group);panel.removeAttribute('data-cabin-preloaded');
      normalizePanel(panel,true);
      if(tab==='treasures'){try{var a0=app();if(a0&&typeof a0.bindTreasures==='function')a0.bindTreasures()}catch(_e0){}}
      setTimeout(function(){activateVisiblePanel(tab)},0);
      return true;
    }
    restoreGroup(group,false);
    host.innerHTML='';host.appendChild(panel);mounted[group]=tab;delete parked[physical];
    panel.setAttribute('data-cabin-hosted',group);panel.removeAttribute('data-cabin-preloaded');normalizePanel(panel,true);
    if(tab==='treasures'){try{var a1=app();if(a1&&typeof a1.bindTreasures==='function')a1.bindTreasures()}catch(_e1){}}
    setTimeout(function(){activateVisiblePanel(tab)},0);
    return true;
  }

  function markButtons(selector,value,attr){
    qsa(selector,root).forEach(function(button){
      var active=button.getAttribute(attr)===value;
      button.classList.toggle('active',active);
      button.setAttribute('aria-pressed',active?'true':'false');
      if(button.getAttribute('role')==='tab')button.setAttribute('aria-selected',active?'true':'false');
    });
  }
  function setStageTitle(group,tab){
    var id=group==='tao'?'slbCabinTaoTitle':group==='portal'?'slbCabinPortalTitle':group==='settings'?'slbCabinSettingsTitle':'';
    var node=id?el(id):null;
    if(node){
      node.textContent=PANEL_TITLES[tab]||tab;
      var bar=node.closest&&node.closest('.slbCabinStageTop'),stage=bar&&bar.parentElement,isMyAltar=group==='tao'&&tab==='cult';
      if(bar){bar.classList.toggle('hidden',isMyAltar);bar.setAttribute('aria-hidden',isMyAltar?'true':'false')}
      if(stage)stage.classList.toggle('is-my-altar-stage',isMyAltar);
    }
  }
  function syncRoute(){
    setTimeout(function(){
      try{if(w.SLB_route&&typeof w.SLB_route.sync==='function')w.SLB_route.sync(false)}catch(_e){}
    },0);
  }
  function groupForTab(tab){
    tab=String(tab||'').trim();
    if(tab==='overview')return 'day';
    if(['m3Received','diaryRead','cult','treasures','library'].indexOf(tab)>=0)return 'tao';
    if(['diaryWrite','m3Offering','chat','cabinEmail'].indexOf(tab)>=0)return 'portal';
    if(['user','export','help'].indexOf(tab)>=0)return 'settings';
    return '';
  }
  function openGroup(group,tab){
    current[group]=tab;routeTab=tab;setStageTitle(group,tab);
    if(group==='tao')markButtons('[data-cabin-tao]',tab,'data-cabin-tao');
    if(group==='portal')markButtons('[data-cabin-portal]',tab,'data-cabin-portal');
    if(group==='settings')markButtons('[data-cabin-settings]',tab,'data-cabin-settings');
    mountPanel(tab,group);syncRoute();
  }
  function openTab(tab,opts){
    opts=opts||{};tab=String(tab||'overview').trim();
    var group=groupForTab(tab);if(!group){tab='overview';group='day'}
    if(!root&&!init())return false;
    ['day','tao','portal','settings'].forEach(function(g){if(g!==group)setAccordion(g,false)});
    current[group]=tab;routeTab=tab;setAccordion(group,true);
    if(tab==='library'&&opts.postId){
      try{w.__SLB_LIB_SELECTED_POSTID=String(opts.postId||'').trim()}catch(_e){}
      setTimeout(function(){try{if(w.SLB_LIBRARY&&typeof w.SLB_LIBRARY.reload==='function')w.SLB_LIBRARY.reload()}catch(_e2){}},80);
    }
    if(tab==='overview'&&opts.noteId)focusBoardNote(opts.noteId);
    return true;
  }
  function getRouteState(){return {tab:routeTab||'overview'}}
  function focusBoardNote(noteId){
    noteId=String(noteId||'').trim();if(!noteId)return Promise.resolve(false);
    if(routeTab!=='overview')openTab('overview',{});
    return hydrateTab('overview',true).catch(function(){return false}).then(function(){
      return waitForValue(function(){return qs('[data-noteid="'+noteId.replace(/"/g,'\\"')+'"]',root)},12000,'Board message');
    }).then(function(node){
      try{node.scrollIntoView({behavior:'smooth',block:'center'});node.classList.add('slbDeepLinkedNote');node.style.outline='3px solid var(--ty-orange,#ef5e14)';node.style.outlineOffset='3px';setTimeout(function(){try{node.classList.remove('slbDeepLinkedNote');node.style.outline='';node.style.outlineOffset=''}catch(_e){}},7000)}catch(_e){}
      return true;
    }).catch(function(){return false});
  }
  function bodyId(group){return group==='day'?'slbCabinDayBody':group==='tao'?'slbCabinTaoBody':group==='portal'?'slbCabinPortalBody':'slbCabinSettingsBody'}
  function setAccordion(group,open){
    var section=qs('[data-cabin-section="'+group+'"]',root),button=qs('[data-cabin-accordion="'+group+'"]',root),body=el(bodyId(group));
    if(!section||!button||!body)return;
    section.classList.toggle('is-open',!!open);body.classList.toggle('hidden',!open);button.setAttribute('aria-expanded',open?'true':'false');
    if(open)openGroup(group,current[group]);else restoreGroup(group,false);
  }

  function preload(){
    // V3.145 intentionally performs no background network preload. My Cabin
    // used to open every module plus My Altar at login, monopolizing the single
    // Apps Script transport and preventing the hero coin count from loading.
    preparePreloadDock();
    if(preloadPromise)return preloadPromise;
    preloadPromise=Promise.resolve([]).then(function(result){preloadPromise=null;return result});
    return preloadPromise;
  }

  function backupStatus(id,message,type){
    var node=el(id);if(!node)return;node.className='slbBackupStatus '+(type||'muted');node.textContent=String(message||'');
  }
  function lockAction(button,label){
    if(!button)return function(){};var old=button.textContent;button.disabled=true;button.textContent=label;return function(){button.disabled=false;button.textContent=old};
  }
  function bindBackupTools(){
    if(backupBound)return;backupBound=true;
    var importBtn=el('slbBackupDiaryImportBtn'),importFile=el('slbBackupDiaryImportFile'),diaryExport=el('slbBackupDiaryExportBtn');
    var cultExport=el('slbBackupCultivationExportBtn'),treExport=el('slbBackupTreasuresExportBtn');
    if(importBtn&&importFile){
      importBtn.addEventListener('click',function(){try{importFile.click()}catch(_e){}});
      importFile.addEventListener('change',function(){
        var file=importFile.files&&importFile.files[0];if(!file)return;var unlock=lockAction(importBtn,'Importing…');backupStatus('slbBackupDiaryStatus','Importing Diary CSV…','muted');
        ensureModule('diary').then(function(){return waitForValue(function(){return w.SLB_DIARY&&typeof w.SLB_DIARY.importCsvFile==='function'?w.SLB_DIARY.importCsvFile:null},20000,'Diary import')}).then(function(fn){return fn.call(w.SLB_DIARY,file)}).then(function(result){backupStatus('slbBackupDiaryStatus','Diary import complete'+(result&&result.ok!=null?': '+result.ok+' imported'+(result.fail?', '+result.fail+' failed':''):'.'),'ok')}).catch(function(err){backupStatus('slbBackupDiaryStatus',err&&err.message||err||'Diary import failed.','err')}).then(function(){unlock();try{importFile.value=''}catch(_e){}});
      });
    }
    if(diaryExport)diaryExport.addEventListener('click',function(){var unlock=lockAction(diaryExport,'Exporting…');backupStatus('slbBackupDiaryStatus','Preparing Diary CSV…','muted');ensureModule('diary').then(function(){return waitForValue(function(){return w.SLB_DIARY&&typeof w.SLB_DIARY.exportCsv==='function'?w.SLB_DIARY.exportCsv:null},20000,'Diary export')}).then(function(fn){return fn.call(w.SLB_DIARY)}).then(function(){backupStatus('slbBackupDiaryStatus','Diary CSV downloaded.','ok')}).catch(function(err){backupStatus('slbBackupDiaryStatus',err&&err.message||err||'Diary export failed.','err')}).then(unlock)});
    if(cultExport)cultExport.addEventListener('click',function(){var unlock=lockAction(cultExport,'Exporting…');backupStatus('slbBackupCultivationStatus','Preparing Cultivation CSV…','muted');waitForValue(function(){var a=app();return a&&typeof a.exportCultivationCsv==='function'?a.exportCultivationCsv:null},20000,'Cultivation export').then(function(fn){return fn.call(app())}).then(function(result){backupStatus('slbBackupCultivationStatus','Cultivation CSV downloaded'+(result&&result.fileName?': '+result.fileName:'.'),'ok')}).catch(function(err){backupStatus('slbBackupCultivationStatus',err&&err.message||err||'Cultivation export failed.','err')}).then(unlock)});
    if(treExport)treExport.addEventListener('click',function(){var unlock=lockAction(treExport,'Exporting…');backupStatus('slbBackupTreasuresStatus','Preparing Treasures CSV…','muted');waitForValue(function(){var a=app();return a&&typeof a.exportTreasuresCsv==='function'?a.exportTreasuresCsv:null},20000,'Treasures export').then(function(fn){return fn.call(app())}).then(function(){backupStatus('slbBackupTreasuresStatus','Treasures CSV downloaded.','ok')}).catch(function(err){backupStatus('slbBackupTreasuresStatus',err&&err.message||err||'Treasures export failed.','err')}).then(unlock)});
  }

  function bind(){
    if(!root||root.dataset.cabinBound==='1')return;
    root.dataset.cabinBound='1';
    root.addEventListener('click',function(event){
      var button=event.target&&event.target.closest?event.target.closest('button'):null;if(!button)return;
      var accordion=button.getAttribute('data-cabin-accordion');if(accordion){setAccordion(accordion,button.getAttribute('aria-expanded')!=='true');return}
      var tao=button.getAttribute('data-cabin-tao');if(tao){openGroup('tao',tao);return}
      var portal=button.getAttribute('data-cabin-portal');if(portal){openGroup('portal',portal);return}
      var settings=button.getAttribute('data-cabin-settings');if(settings){openGroup('settings',settings);return}
      if(button.id==='slbCabinRefresh'){
        refreshWealth(true);
        preloadState.overview='failed';hydrateTab('overview',true);
        return;
      }
      if(button.id==='slbCabinGoldenShortcut'){
        restoreAll(true);
        var link=qs('.menuItem[data-tab="goldenCenter"]');
        if(link){try{link.click()}catch(_e){}}
        else if(app()&&typeof app().openPanel==='function')app().openPanel('goldenCenter');
      }
    });
    d.addEventListener('click',function(event){
      var menu=event.target&&event.target.closest?event.target.closest('.menuItem[data-tab]'):null;
      if(menu&&menu.getAttribute('data-tab')!==TAB)restoreAll(true);
    },true);
    w.addEventListener('slb:auth-ready',function(){
      // Keep the login transport free for the Cabin wealth counters. My Altar
      // is loaded only when its tab is opened.
      if(cabinVisible())refreshWealth(false);
    });
    w.addEventListener('slb:dashboard-updated',function(event){if(cabinVisible()){animate('slbCabinTotalStones',totalStones());renderCurrencySnapshot(event&&event.detail&&(event.detail.currencySnapshot||event.detail))}});
    w.addEventListener('slb:currency-updated',function(event){if(cabinVisible())renderCurrencySnapshot(event&&event.detail)});
    if(observer)observer.disconnect();
    observer=new MutationObserver(function(){if(root.classList.contains('hidden'))restoreAll(true)});
    observer.observe(root,{attributes:true,attributeFilter:['class']});
  }
  function open(){
    if(!root&&!init())return;
    restoreAll(true);
    Object.keys(preloadState).forEach(function(k){delete preloadState[k]});preloadPromise=null;
    current={day:'overview',tao:'m3Received',portal:'diaryWrite',settings:'user'};routeTab='overview';
    setStageTitle('tao','m3Received');setStageTitle('portal','diaryWrite');setStageTitle('settings','user');
    preparePreloadDock();
    // Start the hero balances first. The overview opens a moment later and no
    // longer competes with a hidden My Altar or every other Cabin module.
    refreshWealth(false);
    setAccordion('tao',false);setAccordion('portal',false);setAccordion('settings',false);setAccordion('day',true);
  }
  function init(){
    root=el('slbCabinPanel');if(!root)return false;
    findPanels();ensurePreloadDock();bindBackupTools();bind();
    if(!root.classList.contains('hidden'))open();return true;
  }

  w.SLB_MY_CABIN={
    open:open,
    openTab:openTab,
    getRouteState:getRouteState,
    focusBoardNote:focusBoardNote,
    restoreAll:function(){restoreAll(true)},
    refresh:function(){return refreshWealth(true)},
    refreshBoard:function(){return hydrateTab('overview',true)},
    refreshTreasures:function(){return hydrateTab('treasures',true)},
    mount:mountPanel,
    preload:preload,
    preloadState:preloadState,
    hydrate:function(tab,force){return hydrateTab(tab,!!force)}
  };
  w.SLB=w.SLB||{};
  if(w.SLB.features&&typeof w.SLB.features.register==='function')w.SLB.features.register(TAB,{onOpen:open});
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})(window,document);


/* ====== SLB FEATURE: 72_overview_anniv.js ====== */
/* SLB FEATURE: Overview God Anniversary Reminder (Phase 5B)
   - Renders a reminder block on Overview page
   - Uses GOD_ANNIVERSARY via backend action: annivList
   - Computes "This lunar month" and "Next lunar month" via shared SLB.lunar engine
*/
(function(w){
  'use strict';
  w.SLB = w.SLB || {};
  var SLB = w.SLB;

  function el(id){ return document.getElementById(id); }
  function txt(n,s){ if(n) n.textContent = (s==null?'':String(s)); }

  function rpc(action, args){
    try{ if(SLB && typeof SLB.rpc === 'function') return SLB.rpc(action, args||{}); }catch(_e){}
    try{ if(w.SLB_APP && w.SLB_APP.rpc && typeof w.SLB_APP.rpc === 'function') return w.SLB_APP.rpc(action, args||{}); }catch(_e2){}
    return Promise.reject(new Error('RPC not available'));
  }

  function nowMs(){ return Date.now ? Date.now() : (new Date()).getTime(); }

  function parseYmdToMs(ymd){
    var m = String(ymd||'').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if(!m) return NaN;
    return new Date(Number(m[1]), Number(m[2])-1, Number(m[3])).getTime();
  }

  function dayDiff(fromMs, toMs){
    if(!isFinite(fromMs) || !isFinite(toMs)) return NaN;
    return Math.round((toMs - fromMs) / 86400000);
  }

  function safeNum(v, d){
    var n = parseInt(String(v).trim(),10);
    return isFinite(n) ? n : d;
  }

  function safeCall(obj, names, fallback){
    if(fallback === undefined) fallback = '';
    for(var i=0;i<(names||[]).length;i++){
      var k = names[i];
      if(obj && typeof obj[k] === 'function'){
        try{ return obj[k](); }catch(_e){}
      }
    }
    return fallback;
  }

  function mk(tag, cls){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    return n;
  }

  function clearNode(n){
    if(!n) return;
    while(n.firstChild) n.removeChild(n.firstChild);
  }

  function tagForDay(ld){
    if(ld === 1) return '初一';
    if(ld === 15) return '十五';
    return 'Day ' + ld;
  }


  function prettySolarDateOnlyFromDate(dt){
    try{
      var d = (dt instanceof Date) ? dt : new Date(dt);
      var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()] || '';
      if(!mo) return '';
      return mo + ' ' + d.getDate() + ', ' + d.getFullYear();
    }catch(_e){ return ''; }
  }

  function prettySolar(ymd){
    var m = String(ymd||'').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if(!m) return '';
    var d = new Date(Number(m[1]), Number(m[2])-1, Number(m[3]));
    var wd = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()] || '';
    var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()] || '';
    var dd = d.getDate();
    var yy = d.getFullYear();
    if(!wd || !mo) return '';
    return wd + ', ' + mo + ' ' + dd + ', ' + yy;
  }

  async function ensureLunar(){
    if(!SLB.lunar || typeof SLB.lunar.ensureEngine !== 'function') throw new Error('Lunar engine not available');
    await SLB.lunar.ensureEngine();
    if(!(w.Solar && w.Lunar)) throw new Error('Lunar engine blocked');
  }

  async function getCurrentLunarMD(){
    await ensureLunar();
    var solar = SLB.lunar.solarFromDate(new Date());
    var lunar = SLB.lunar.lunarFromSolar(solar);
    if(!lunar || !lunar.getMonth || !lunar.getDay) return null;

    var m0 = null;
    var leap = false;
    try{
      m0 = lunar.getMonth();
      leap = lunar.isLeap ? lunar.isLeap() : false;
      if(typeof m0 === 'number' && m0 < 0){ leap = true; m0 = Math.abs(m0); }
    }catch(_e){}

    return {
      m: m0,
      d: lunar.getDay(),
      leap: !!leap
    };
  }

  async function computeNextSolarYmd(lm, ld, isLeap){
    lm = safeNum(lm, 0); ld = safeNum(ld, 0);
    if(!(lm>=1 && lm<=12) || !(ld>=1 && ld<=30)) return '';
    await ensureLunar();

    var today = new Date();
    today.setHours(0,0,0,0);
    var start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var end = new Date(start.getTime() + 370*86400000);

    for(var t=start.getTime(); t<=end.getTime(); t+=86400000){
      var d = new Date(t);
      var solar = SLB.lunar.solarFromYmd(d.getFullYear(), d.getMonth()+1, d.getDate());
      if(!solar) continue;
      var lunar = SLB.lunar.lunarFromSolar(solar);
      if(!lunar) continue;

      try{
        var m = lunar.getMonth ? lunar.getMonth() : null;
        var day = lunar.getDay ? lunar.getDay() : null;
        var leap = lunar.isLeap ? lunar.isLeap() : false;
        if(m === lm && day === ld && (!!leap) === (!!isLeap)){
          return SLB.lunar.formatSolarYmd(solar);
        }
      }catch(_e){}
    }
    return '';
  }


  async function setTodayLine(){
    var n = el('slbOvAnnivTodayLine');
    if(!n) return;

    // Format:
    // TODAY IS: (FRIDAY) Jan 30, 2026 - Lunar 12 month 12 day
    // 腊月十二 - 乙巳年 己丑月 甲辰日 (星期五)

    var WD_EN = ['SUNDAY','MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY'];
    var WD_CN = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];

    try{
      await ensureLunar();
      var now = new Date();
      var solar = SLB.lunar.solarFromDate(now);
      var lunar = SLB.lunar.lunarFromSolar(solar);
      if(!lunar){
        n.textContent = 'TODAY IS: ' + prettySolarDateOnlyFromDate(now);
        return;
      }

      var wdEn = WD_EN[now.getDay()] || '';
      var wdCn = WD_CN[now.getDay()] || '';

      var solarTxt = prettySolarDateOnlyFromDate(now);

      var m0 = safeCall(lunar, ['getMonth'], null);
      var d0 = safeCall(lunar, ['getDay'], null);
      var leap = safeCall(lunar, ['isLeap'], false);
      if(typeof m0 === 'number' && m0 < 0){ leap = true; m0 = Math.abs(m0); }

      var mCN = safeCall(lunar, ['getMonthInChinese','getMonthInChineseExact'], '');
      var dCN = safeCall(lunar, ['getDayInChinese','getDayInChineseExact'], '');
      var cnMD = (leap ? '閏' : '') + (mCN ? (mCN + '月') : '') + (dCN || '');

      var gzY = safeCall(lunar, ['getYearInGanZhiExact','getYearInGanZhi','getYearInGanZhiByLiChun'], '');
      var gzM = safeCall(lunar, ['getMonthInGanZhiExact','getMonthInGanZhi'], '');
      var gzD = safeCall(lunar, ['getDayInGanZhiExact','getDayInGanZhi'], '');
      var gz = [gzY, gzM, gzD].filter(Boolean).join(' ');

      var lunarNum = (isFinite(m0) && isFinite(d0)) ? ('Lunar ' + (leap ? 'Leap ' : '') + m0 + ' month ' + d0 + ' day') : 'Lunar';

      var line1 = 'TODAY IS: ' + (wdEn ? ('(' + wdEn + ') ') : '') + (solarTxt || '') + ' - ' + lunarNum;
      var line2 = (cnMD || '') + (gz ? (' - ' + gz) : '') + (wdCn ? (' (' + wdCn + ')') : '');

      // 2-line display
      n.innerHTML = (line1 || '').trim() + '<br>' + (line2 || '').trim();
    }catch(_e){
      var now2 = new Date();
      n.textContent = 'TODAY IS: ' + prettySolarDateOnlyFromDate(now2);
    }
  }


  function filterGodRows(rows){
    return (rows||[]).filter(function(r){
      if(!r) return false;
      var af = String(r.activeFlag||'1');
      if(af !== '1') return false;
      if(String(r.type||'').toLowerCase() !== 'god') return false;

      var lm = safeNum(r.lunarMonth, 0);
      var ld = safeNum(r.lunarDay, 0);
      if(!(lm>=1 && lm<=12) || !(ld>=1 && ld<=30)) return false;

      return true;
    });
  }

  // De-duplicate rows (prevents double display if the sheet has duplicates)
  // Keyed by: godKey/name + lunarMonth + lunarDay + isLeapMonth (URL is NOT part of the key)
  // If duplicates exist, prefer the row that has a URL.
  function dedupeGodRows(rows){
    var seen = Object.create(null);
    var out = [];

    function makeKey(r){
      var name = String(r.godKey||r.displayName||'').trim().toLowerCase();
      var lm = String(r.lunarMonth||'').trim();
      var ld = String(r.lunarDay||'').trim();
      var leap = String(r.isLeapMonth||'0').trim();
      return [name,lm,ld,leap].join('|');
    }

    function better(a,b){
      var au = String(a && a.url || '').trim();
      var bu = String(b && b.url || '').trim();
      if(!au && bu) return b;
      return a;
    }

    (rows||[]).forEach(function(r){
      if(!r) return;
      var key = makeKey(r);
      if(!key || key === '|||') return;
      if(!seen[key]){
        seen[key] = r;
        out.push(r);
        return;
      }
      var cur = seen[key];
      var best = better(cur, r);
      if(best !== cur){
        seen[key] = best;
        for(var i=0;i<out.length;i++){
          if(out[i] === cur){ out[i] = best; break; }
        }
      }
    });
    return out;
  }

  // cache (memory + localStorage)
  var CACHE = { ts:0, rows:null };
  var CACHE_TTL = 2*60*1000; // memory cache (fast within same page session)

  var LS_KEY = 'slb.ovAnniv.rows.v1';
  var LS_TTL = 24*60*60*1000; // 24 hours
  var BG_REFRESH = null;

  function readLocalCache(){
    try{
      if(SLB.storage && typeof SLB.storage.getJSON === 'function'){
        return SLB.storage.getJSON(LS_KEY, null);
      }
    }catch(_e){}
    // fallback
    try{
      var raw = localStorage.getItem(LS_KEY);
      return raw ? JSON.parse(raw) : null;
    }catch(_e2){}
    return null;
  }

  function writeLocalCache(rows, ts){
    try{
      var payload = { ts: ts||nowMs(), rows: rows||[] };
      if(SLB.storage && typeof SLB.storage.setJSON === 'function'){
        // store WITHOUT TTL so we can keep stale cache as fallback
        SLB.storage.setJSON(LS_KEY, payload, 0);
        return true;
      }
    }catch(_e){}
    try{
      localStorage.setItem(LS_KEY, JSON.stringify({ v: { ts: ts||nowMs(), rows: rows||[] } }));
      return true;
    }catch(_e2){}
    return false;
  }

  function getLocalRows(force){
    if(force) return null;
    var p = readLocalCache();
    if(!p) return null;
    // SLB.storage wrapper returns payload.v; but fallback wrapper stores {v:{...}}
    if(p && p.v && typeof p.v === 'object') p = p.v;
    if(p && Array.isArray(p.rows)) return p;
    return null;
  }

  function refreshRowsInBackground(){
    if(BG_REFRESH) return BG_REFRESH;
    BG_REFRESH = rpc('annivList', {}).then(function(res){
      var rows = (res && res.items) ? res.items : (Array.isArray(res) ? res : []);
      var t = nowMs();
      CACHE = { ts: t, rows: rows };
      writeLocalCache(rows, t);
      return rows;
    }).catch(function(_e){
      return null;
    }).finally(function(){
      BG_REFRESH = null;
    });
    return BG_REFRESH;
  }

  async function loadRows(force){
    var t = nowMs();

    // Memory cache
    if(!force && CACHE.rows && (t - CACHE.ts) < CACHE_TTL) return CACHE.rows;

    // Local cache
    var local = getLocalRows(force);
    if(local && local.rows){
      CACHE = { ts: local.ts || t, rows: local.rows };
      if(local.ts && (t - local.ts) > LS_TTL){
        // stale - refresh quietly
        refreshRowsInBackground();
      }
      return CACHE.rows;
    }

    // Network fetch
    var res;
    try{
      res = await rpc('annivList', {});
    }catch(e){
      var msg = String((e && (e.message||e)) || '');
      if(msg.indexOf('Missing sheet: GOD_ANNIVERSARY') >= 0){
        CACHE = { ts: t, rows: [] };
        writeLocalCache([], t);
        return [];
      }
      // If fetch fails but local exists, fall back to it
      if(local && local.rows) return local.rows;
      throw e;
    }

    var rows = (res && res.items) ? res.items : (Array.isArray(res) ? res : []);
    CACHE = { ts: t, rows: rows };
    writeLocalCache(rows, t);
    return rows;
  }


  var state = { mode: 'this', rows: null, lunar: null, bound:false };

  // render concurrency guard
  var RENDER_SEQ = 0;

  function normMode(m){
    return (m === 'next') ? 'next' : 'this';
  }

  function applyTogUI(){
    var bThis = el('slbOvAnnivThisBtn');
    var bNext = el('slbOvAnnivNextBtn');
    if(bThis) bThis.classList.toggle('orange', state.mode === 'this');
    if(bNext) bNext.classList.toggle('orange', state.mode === 'next');
  }

  function renderOne(r, lm, ld, ymd, dLater, passed){
    var list = el('slbOvAnnivList');
    if(!list) return;

    var item = mk('div','slbOvAnnivItem');

    var line1 = mk('div','slbOvAnnivLine1');
    var line2 = mk('div','slbOvAnnivLine2');

    var name = String(r.displayName||r.godKey||'').trim();
    var url = String(r.url||'').trim();
    var line1Text = 'L' + lm + '/' + ld + ' — ' + name + ' ' + tagForDay(ld);

    if(url){
      var a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = line1Text;
      line1.appendChild(a);
    }else{
      line1.textContent = line1Text;
    }

    if(passed){
      line2.textContent = 'Passed';
      line2.classList.add('passed');
    }else if(isFinite(dLater)){
      if(dLater === 0){
        line2.textContent = 'Today';
      }else{
        var pretty = prettySolar(ymd);
        if(!pretty && ymd) pretty = ymd;
        var laterText = (dLater === 1) ? '1 day later' : (dLater + ' days later');
        line2.textContent = (pretty ? (pretty + ' • ' + laterText) : laterText);
      }
    }else if(ymd){
      var pretty2 = prettySolar(ymd) || ymd;
      line2.textContent = pretty2;
    }else{
      line2.textContent = '';
    }

    item.appendChild(line1);
    item.appendChild(line2);
    list.appendChild(item);
  }

  async function render(forceLoad){
    // A hidden panel may be temporarily detached while My Cabin moves it.
    // Do not invalidate an in-progress render unless the real Overview DOM exists.
    var wrap = el('slbOvAnnivWrap');
    var status = el('slbOvAnnivStatus');
    var list = el('slbOvAnnivList');
    if(!wrap || !status || !list) return false;
    var seq = ++RENDER_SEQ;

    try{
      txt(status, 'Loading…');
      clearNode(list);
      try{ await setTodayLine(); }catch(_e0){}
      if(seq !== RENDER_SEQ) return;

      state.mode = normMode(state.mode);
      applyTogUI();

      var rows = await loadRows(!!forceLoad);
      state.rows = dedupeGodRows(filterGodRows(rows));
      if(seq !== RENDER_SEQ) return;

      var cur = await getCurrentLunarMD();
      state.lunar = cur;
      if(seq !== RENDER_SEQ) return;

      if(!cur || !cur.m){
        txt(status, 'Lunar date not available (blocked).');
        return;
      }

      var viewM = cur.m;
      if(state.mode === 'next') viewM = ((cur.m % 12) + 1);

      var items = (state.rows||[]).filter(function(r){
        return safeNum(r.lunarMonth,0) === viewM;
      }).sort(function(a,b){
        var ad = safeNum(a.lunarDay, 999);
        var bd = safeNum(b.lunarDay, 999);
        if(ad !== bd) return ad - bd;

        var al = String(a.isLeapMonth||'0') === '1' ? 1 : 0;
        var bl = String(b.isLeapMonth||'0') === '1' ? 1 : 0;
        if(al !== bl) return al - bl;

        var an = String(a.displayName||a.godKey||'').toLowerCase();
        var bn = String(b.displayName||b.godKey||'').toLowerCase();
        if(an < bn) return -1;
        if(an > bn) return 1;
        return 0;
      });

      if(!items.length){
        txt(status, state.mode === 'next' ? 'No anniversaries in next lunar month.' : 'No anniversaries in this lunar month.');
        return;
      }

      txt(status, state.mode === 'next' ? ('Next lunar month (L' + viewM + ')') : ('This lunar month (L' + viewM + ')'));

      var todayMs = new Date(); todayMs.setHours(0,0,0,0); todayMs = todayMs.getTime();

      for(var i=0;i<items.length;i++){
        if(seq !== RENDER_SEQ) return;
        var r = items[i];
        var lm = safeNum(r.lunarMonth,0);
        var ld = safeNum(r.lunarDay,0);
        var isLeap = String(r.isLeapMonth||'0') === '1';

        var passed = (state.mode === 'this' && cur && lm === cur.m && ld < cur.d);

        var ymd = '';
        var dLater = NaN;

        if(!passed){
          try{ ymd = await computeNextSolarYmd(lm, ld, isLeap); }catch(_e){ ymd = ''; }
          if(seq !== RENDER_SEQ) return;
          var solarMs = ymd ? parseYmdToMs(ymd) : NaN;
          dLater = isFinite(solarMs) ? dayDiff(todayMs, solarMs) : NaN;
        }
        if(seq !== RENDER_SEQ) return;

        renderOne(r, lm, ld, ymd, dLater, passed);
      }
    }catch(e){
      txt(status, 'Error: ' + (e && e.message ? e.message : String(e)));
    }
  }

  function setMode(mode){
    state.mode = normMode(mode);
    applyTogUI();
    render(false);
  }

  function bindOnce(){
    if(state.bound) return;
    state.bound = true;

    var bThis = el('slbOvAnnivThisBtn');
    var bNext = el('slbOvAnnivNextBtn');
    if(bThis) bThis.addEventListener('click', function(){ setMode('this'); });
    if(bNext) bNext.addEventListener('click', function(){ setMode('next'); });

    // allow external refresh
    SLB.__overviewAnnivRefresh = function(force){
      return render(!!force);
    };
  }

  // Register feature on Overview tab
  SLB.features = SLB.features || {};
  if(typeof SLB.features.register === 'function'){
    SLB.features.register('overview', {
      onOpen: function(_ctx){
        bindOnce();
        try{ render(false); }catch(_e){}
      }
    });
  }
})(window);


/* ====== SLB FEATURE: 73_bagwa_hall.js ====== */
/*
  SLB Bagwa Hall V1
  Native Tin Yat hub. Original panels are moved into a warm hall and preloaded
  sequentially inside a live off-screen dock so lazy modules do not return
  early merely because their original panel is hidden.
*/
(function(w,d){
  'use strict';
  var TAB='bagwaHall',root=null,observer=null,preloadDock=null,preloadPromise=null;
  var panelMap={},anchorMap={},mounted={},preloadState={},modulePromises={};
  var current={affinity:'gdgToken',worship:'letters',office:'temple'};
  var routeTab='gdgToken';
  var HOSTS={affinity:'slbBagwaAffinityHost',worship:'slbBagwaWorshipHost',office:'slbBagwaOfficeHost'};
  var TITLES={gdgToken:'GDG Token',letters:'Letter',offeringHall:'Offering Hall',anniv:'Anniversary',cCalendar:'Calendar',temple:'Request FU',cmr:'Medic',sdr:'Luck',swr:'Weather',dcr:'Div',ddr:'DDR',stars9Div:'9 Stars',fanTaiSui:'Fan Tai Sui'};
  var PANEL_TABS=['gdgToken','letters','offeringHall','anniv','cCalendar','temple','cmr','sdr','swr','dcr','ddr','stars9Div','fanTaiSui'];
  var PRELOAD_ORDER=['gdgToken','letters','offeringHall','anniv','cCalendar','temple','cmr','sdr','swr','dcr','ddr','stars9Div','fanTaiSui'];
  var MODULE_TAB={letters:'letters',offeringHall:'offeringHall',cCalendar:'cCalendar',temple:'temple',cmr:'cmr',sdr:'sdr',swr:'swr',dcr:'dcr',ddr:'ddr',fanTaiSui:'fanTaiSui'};

  function el(id){return d.getElementById(id)}
  function qs(sel,scope){try{return (scope||d).querySelector(sel)}catch(_e){return null}}
  function qsa(sel,scope){try{return Array.prototype.slice.call((scope||d).querySelectorAll(sel))}catch(_e){return []}}
  function app(){return w.SLB_APP||null}
  function sleep(ms){return new Promise(function(resolve){setTimeout(resolve,ms)})}
  function visible(){return !!(root&&!root.classList.contains('hidden'))}
  function storedToken(){var a=app(),s=a&&a.S;if(s&&s.token)return String(s.token);try{return sessionStorage.getItem('tyw_token')||''}catch(_e){return ''}}
  function waitFor(test,timeout,label){var start=Date.now();return new Promise(function(resolve,reject){(function check(){var v=null;try{v=test()}catch(_e){}if(v){resolve(v);return}if(Date.now()-start>=timeout){reject(new Error((label||'SLB component')+' is not ready.'));return}setTimeout(check,120)})()})}
  function waitForAuth(timeout){return waitFor(function(){return app()&&storedToken()},timeout||20000,'SLB login')}

  function findPanels(){
    PANEL_TABS.forEach(function(tab){
      var p=qs('[data-panel="'+tab+'"]');if(!p)return;panelMap[tab]=p;
      if(!anchorMap[tab]&&p.parentNode){var a=d.createComment('SLB Bagwa Hall anchor: '+tab);p.parentNode.insertBefore(a,p);anchorMap[tab]=a}
    });
  }
  function ensureDock(){
    if(preloadDock&&preloadDock.parentNode)return preloadDock;
    preloadDock=el('slbBagwaPreloadDock');
    if(!preloadDock){preloadDock=d.createElement('div');preloadDock.id='slbBagwaPreloadDock';preloadDock.className='slbBagwaPreloadDock';preloadDock.setAttribute('aria-hidden','true');(root||d.body).appendChild(preloadDock)}
    return preloadDock;
  }
  function normalize(panel,hosted){
    if(!panel)return;panel.classList.remove('hidden');panel.classList.add('slbBagwaHostedPanel');
    if(hosted)panel.setAttribute('data-bagwa-hosted','1');else panel.removeAttribute('data-bagwa-hosted');
  }
  function groupFor(tab){var out='';Object.keys(mounted).some(function(g){if(mounted[g]===tab){out=g;return true}return false});return out}
  function park(tab){
    findPanels();var p=panelMap[tab];if(!p||groupFor(tab))return p;
    var dock=ensureDock();if(p.parentNode!==dock)dock.appendChild(p);normalize(p,false);p.setAttribute('data-bagwa-preloaded','1');return p;
  }
  function restoreTab(tab){
    var p=panelMap[tab],a=anchorMap[tab];if(!p)return;
    try{if(a&&a.parentNode)a.parentNode.insertBefore(p,a.nextSibling);else if(root&&p.parentNode===root)root.removeChild(p)}catch(_e){}
    p.classList.add('hidden');p.classList.remove('slbBagwaHostedPanel');p.removeAttribute('data-bagwa-hosted');p.removeAttribute('data-bagwa-preloaded');
  }
  function restoreGroup(group){var tab=mounted[group];if(tab)restoreTab(tab);delete mounted[group];var host=el(HOSTS[group]);if(host){var stage=host.closest&&host.closest('.slbBagwaServiceStage');if(stage)stage.classList.remove('slbBagwaOfferingStage');host.innerHTML=''}}
  function restoreAll(){Object.keys(mounted).forEach(restoreGroup);PANEL_TABS.forEach(restoreTab);if(preloadDock)preloadDock.innerHTML=''}

  function ensureModule(tab){
    var key=MODULE_TAB[tab];if(!key)return Promise.resolve(true);if(modulePromises[key])return modulePromises[key];
    modulePromises[key]=waitFor(function(){return w.SLB_LAZY&&typeof w.SLB_LAZY.ensureForTab==='function'?w.SLB_LAZY:null},15000,'SLB lazy loader').then(function(lazy){return lazy.ensureForTab(key)}).then(function(ok){if(ok===false)throw new Error(TITLES[tab]+' could not load.');return true}).catch(function(err){delete modulePromises[key];throw err});
    return modulePromises[key];
  }
  function featureOpen(tab){try{if(w.SLB&&w.SLB.features&&typeof w.SLB.features.onOpen==='function')return w.SLB.features.onOpen(tab,{state:app()&&app().S,root:d,embedded:true,container:'bagwaHall'})}catch(_e){}return null}
  function activate(tab,force){
    return ensureModule(tab).then(function(){
      featureOpen(tab);
      if(tab==='offeringHall'&&w.SLB_OfferingHall){if(force&&typeof w.SLB_OfferingHall.refresh==='function')return w.SLB_OfferingHall.refresh();if(typeof w.SLB_OfferingHall.open==='function')return w.SLB_OfferingHall.open()}
      else if(tab==='anniv'&&w.SLB&&typeof w.SLB.__annivLoad==='function')return w.SLB.__annivLoad(!!force)
      else if(tab==='temple'&&w.SLB_TEMPLE&&typeof w.SLB_TEMPLE.reload==='function')return w.SLB_TEMPLE.reload()
      else if(tab==='cmr'&&typeof w.__SLB_CMR_PULSE_TRYBOOT__==='function')w.__SLB_CMR_PULSE_TRYBOOT__()
      else if(tab==='dcr')featureOpen(tab)
      else if(tab==='stars9Div')featureOpen(tab)
      if(tab==='letters'){var b=el('slbLettersReadRefreshBtn');if(b&&!b.disabled)try{b.click()}catch(_e2){}}
      return true;
    });
  }
  function ready(tab){
    if(tab==='gdgToken')return !!qs('#slbGdgMount .slbGdgPage');
    if(tab==='letters')return !!w.__SLB_LETTERS_BUILD_TAG__;
    if(tab==='offeringHall')return !!w.SLB_OfferingHall;
    if(tab==='anniv')return !!(w.SLB&&typeof w.SLB.__annivLoad==='function');
    if(tab==='cCalendar')return !!w.__SLB_CCALENDAR_BOOTED__;
    if(tab==='temple')return !!w.SLB_TEMPLE;
    if(tab==='cmr')return !!(w.SLB_CMR&&el('tycmRoot'));
    if(tab==='sdr')return !!(w.SLB_SDR&&el('slbSdrToolHost'));
    if(tab==='swr')return !!(w.SLB_SWR&&el('slbSwrToolHost'));
    if(tab==='dcr')return !!el('slbDcrMetaBox');
    if(tab==='ddr')return !!(w.SLB_DDR&&el('tyddrMount'));
    if(tab==='stars9Div')return !!el('nsDivDigitType');
    if(tab==='fanTaiSui')return !!qs('#confirmBtn',panelMap.fanTaiSui);
    return true;
  }
  function hydrate(tab,force){
    if(!force&&preloadState[tab]==='ready'&&ready(tab))return Promise.resolve(true);
    if(!force&&preloadState[tab]&&typeof preloadState[tab].then==='function')return preloadState[tab];
    var task=waitForAuth(25000).then(function(){if(!groupFor(tab))park(tab);return activate(tab,force)}).then(function(){return waitFor(function(){return ready(tab)},45000,TITLES[tab])}).then(function(){preloadState[tab]='ready';return true}).catch(function(err){preloadState[tab]='failed';try{console.warn('[Bagwa Hall] '+TITLES[tab]+':',err&&err.message||err)}catch(_e){}return false});
    preloadState[tab]=task;return task;
  }
  function preload(){
    if(preloadPromise)return preloadPromise;findPanels();ensureDock();
    preloadPromise=waitForAuth(25000).then(function(){
      var chain=Promise.resolve(true);
      PRELOAD_ORDER.forEach(function(tab,index){chain=chain.then(function(){return sleep(index?140:0)}).then(function(){return hydrate(tab,false)})});
      return chain;
    }).then(function(v){preloadPromise=null;return v},function(err){preloadPromise=null;throw err});return preloadPromise;
  }

  function hostFor(group){return el(HOSTS[group])}
  function mount(tab,group){
    findPanels();var p=panelMap[tab],host=hostFor(group);if(!p||!host){if(host)host.innerHTML='<div class="slbBagwaError">'+(TITLES[tab]||tab)+' could not open.</div>';return false}
    if(mounted[group]!==tab){restoreGroup(group);host.innerHTML='';host.appendChild(p);mounted[group]=tab}
    else if(p.parentNode!==host){host.innerHTML='';host.appendChild(p)}
    normalize(p,true);p.removeAttribute('data-bagwa-preloaded');
    var stage=host.closest&&host.closest('.slbBagwaServiceStage');if(stage)stage.classList.toggle('slbBagwaOfferingStage',tab==='offeringHall');
    setTimeout(function(){activate(tab,!ready(tab)).then(function(){preloadState[tab]='ready'}).catch(function(){hydrate(tab,true)})},0);return true;
  }
  function mark(group,tab){var attr='data-bagwa-'+group;qsa('['+attr+']',root).forEach(function(b){var on=b.getAttribute(attr)===tab;b.classList.toggle('active',on);b.setAttribute('aria-pressed',on?'true':'false')})}
  function stageTitle(group,tab){var n=el(group==='worship'?'slbBagwaWorshipTitle':'slbBagwaOfficeTitle');if(n)n.textContent=TITLES[tab]||tab}
  function syncRoute(){setTimeout(function(){try{if(w.SLB_route&&typeof w.SLB_route.sync==='function')w.SLB_route.sync(false)}catch(_e){}},0)}
  function openGroup(group,tab){current[group]=tab;routeTab=tab;if(group!=='affinity'){mark(group,tab);stageTitle(group,tab)}mount(tab,group);syncRoute()}
  function bodyId(group){return group==='affinity'?'slbBagwaAffinityBody':group==='worship'?'slbBagwaWorshipBody':'slbBagwaOfficeBody'}
  function setAccordion(group,open){var sec=qs('[data-bagwa-section="'+group+'"]',root),btn=qs('[data-bagwa-accordion="'+group+'"]',root),body=el(bodyId(group));if(!sec||!btn||!body)return;sec.classList.toggle('is-open',!!open);body.classList.toggle('hidden',!open);btn.setAttribute('aria-expanded',open?'true':'false');if(open)openGroup(group,current[group]);else restoreGroup(group)}

  function groupForTab(tab){
    if(tab==='gdgToken')return 'affinity';
    if(['letters','offeringHall','anniv','cCalendar'].indexOf(tab)>=0)return 'worship';
    if(['temple','cmr','sdr','swr','dcr','ddr','stars9Div','fanTaiSui'].indexOf(tab)>=0)return 'office';
    return '';
  }
  function openTab(tab){
    tab=String(tab||'gdgToken').trim();var group=groupForTab(tab);if(!group){tab='gdgToken';group='affinity'}
    if(!root&&!init())return false;
    ['affinity','worship','office'].forEach(function(g){if(g!==group)setAccordion(g,false)});
    current[group]=tab;routeTab=tab;setAccordion(group,true);return true;
  }
  function getRouteState(){return {tab:routeTab||'gdgToken'}}

  function refreshHall(){
    var btn=el('slbBagwaRefresh');if(btn&&btn.disabled)return Promise.resolve(false);
    if(btn){btn.disabled=true;btn.classList.add('is-loading')}
    Object.keys(preloadState).forEach(function(k){preloadState[k]='failed'});
    return Promise.all([hydrate(current.affinity,true),hydrate(current.worship,true),hydrate(current.office,true)].map(function(job){return Promise.resolve(job).catch(function(){return null})})).finally(function(){if(btn){btn.disabled=false;btn.classList.remove('is-loading')}});
  }

  function bind(){
    if(!root||root.dataset.bagwaBound==='1')return;root.dataset.bagwaBound='1';
    root.addEventListener('click',function(ev){var b=ev.target&&ev.target.closest?ev.target.closest('button'):null;if(!b)return;var acc=b.getAttribute('data-bagwa-accordion');if(acc){setAccordion(acc,b.getAttribute('aria-expanded')!=='true');return}var wtab=b.getAttribute('data-bagwa-worship');if(wtab){openGroup('worship',wtab);return}var otab=b.getAttribute('data-bagwa-office');if(otab){openGroup('office',otab);return}if(b.id==='slbBagwaRefresh'){refreshHall()}});
    d.addEventListener('click',function(ev){var m=ev.target&&ev.target.closest?ev.target.closest('.menuItem[data-tab]'):null;if(m&&m.getAttribute('data-tab')!==TAB)restoreAll()},true);
    w.addEventListener('slb:auth-ready',function(){if(visible())preload().catch(function(){})});
    observer=new MutationObserver(function(){if(root.classList.contains('hidden'))restoreAll()});observer.observe(root,{attributes:true,attributeFilter:['class']});
  }
  function open(){if(!root&&!init())return;restoreAll();Object.keys(preloadState).forEach(function(k){delete preloadState[k]});preloadPromise=null;current={affinity:'gdgToken',worship:'letters',office:'temple'};routeTab='gdgToken';setAccordion('worship',false);setAccordion('office',false);setAccordion('affinity',true);preload().catch(function(){})}
  function init(){root=el('slbBagwaHallPanel');if(!root)return false;findPanels();ensureDock();bind();if(!root.classList.contains('hidden'))open();return true}

  w.SLB_BAGWA_HALL={open:open,openTab:openTab,getRouteState:getRouteState,restoreAll:restoreAll,preload:preload,hydrate:function(tab,force){return hydrate(tab,!!force)},mount:mount,state:preloadState};
  w.SLB=w.SLB||{};if(w.SLB.features&&typeof w.SLB.features.register==='function')w.SLB.features.register(TAB,{onOpen:open});
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})(window,document);


/* ====== SLB FEATURE: 73_coc_war.js ====== */
/* SLB Feature: Clash Duty Hall - automatic Clash of Clans duty tracking */
(function(w,d){
  'use strict';
  var TAB='cocWar', mount=null, state={busy:false,data:null,error:'',notice:'',lastTownCallsign:'',clanBusy:false,clan:null,clanError:''}, toastTimer=null;
  function el(id){return d.getElementById(id)}
  function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]})}
  function num(v){var n=Number(v);return isFinite(n)?n:0}
  function fmt(v){return num(v).toLocaleString(undefined,{maximumFractionDigits:2})}
  function pct(v){return v==null?'—':fmt(v)+'%'}
  function tag(v){return String(v||'').toUpperCase()}
  function date(v){if(!v)return '—';try{return new Date(v).toLocaleString()}catch(_e){return String(v)}}
  function shortDate(v){if(!v)return '—';try{return new Date(v).toLocaleDateString()}catch(_e){return String(v)}}
  function rid(prefix){return String(prefix||'coc')+'_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,9)}
  function rpcFn(){
    try{if(w.SLB_APP&&typeof w.SLB_APP.__realRpc==='function')return w.SLB_APP.__realRpc.bind(w.SLB_APP)}catch(_e0){}
    try{if(w.SLB_APP&&typeof w.SLB_APP.rpc==='function')return w.SLB_APP.rpc.bind(w.SLB_APP)}catch(_e1){}
    try{if(w.SLB&&typeof w.SLB.rpc==='function')return w.SLB.rpc.bind(w.SLB)}catch(_e2){}
    return null;
  }
  function rpc(action,args,write){
    var fn=rpcFn();if(!fn)return Promise.reject(new Error('SLB connection is not ready.'));
    var opts={timeoutMs:write?70000:45000,progressMode:write?'normal':'silent',cacheTtlMs:0,useWarmCache:false,noGlobalRetry:!!write,__slbNoGlobalRetry:!!write};
    if(write)opts.requestId=rid(action);
    return Promise.resolve(fn(action,args||{},opts)).then(function(out){if(out&&out.ok===false)throw new Error(out.error||out.message||'SLB request failed.');return out&&out.data&&Object.keys(out).length<=3?out.data:out;});
  }
  function coinClass(v){return num(v)>0?'pos':num(v)<0?'neg':'zero'}
  function coin(v){v=num(v);return '<span class="slbCocCoin '+coinClass(v)+'">'+(v>0?'+':'')+fmt(v)+' Coins</span>'}
  function statusPill(v){var s=String(v||'UNKNOWN').toUpperCase(),cls=s==='SETTLED'||s==='COMPLETE'?'good':s.indexOf('AWAIT')>=0||s.indexOf('PENDING')>=0?'warn':s.indexOf('BLOCK')>=0||s.indexOf('ERROR')>=0?'bad':'';return '<span class="slbCocPill '+cls+'">'+esc(s.replace(/_/g,' '))+'</span>'}
  function shell(){return ''+
    '<div class="slbCocShell">'+
      '<section class="slbCocHero"><img class="slbCocHeroArt" src="https://cdn.shopify.com/s/files/1/1299/3411/files/ChatGPT_Image_Jul_21_2026_04_31_39_PM.png?v=1784665925" alt="Clash Duty Hall" loading="eager" decoding="async"><div class="slbCocHeroActions"><button class="slbCocRefresh" id="slbCocRefresh" type="button" aria-label="Refresh Clash Duty Hall" title="Refresh Clash Duty Hall">⟳</button><button class="slbCocBackGame" id="slbCocBackGame" type="button" aria-label="Return to Tao-Game Center" title="Return to Tao-Game Center">←</button></div></section>'+
      '<div id="slbCocClanLive"><div class="slbCocLoading">Loading live clan command board…</div></div><div id="slbCocNotice"></div><div id="slbCocBody"><div class="slbCocLoading">Loading your Clash duty profile…</div></div>'+
      '<div class="slbCocToast" id="slbCocToast"></div>'+
    '</div>';
  }
  function showToast(msg){var t=el('slbCocToast');if(!t)return;clearTimeout(toastTimer);t.textContent=msg;t.classList.add('show');toastTimer=setTimeout(function(){t.classList.remove('show')},2600)}
  function setNotice(){var n=el('slbCocNotice');if(!n)return;if(state.error)n.innerHTML='<div class="slbCocAlert bad"><strong>Clash Duty Hall could not load.</strong><span>'+esc(state.error)+'</span></div>';else if(state.notice)n.innerHTML='<div class="slbCocAlert good"><span>'+esc(state.notice)+'</span></div>';else n.innerHTML='';}
  function liveUnavailable(data,fallback){return '<div class="slbCocLiveUnavailable">'+statusPill(data&&data.httpCode?'HTTP '+data.httpCode:'NOT ACTIVE')+'<span>'+esc(data&&data.message||fallback||'No current data is available.')+'</span></div>'}
  function liveRegistration(item){return item&&item.registered?'<span class="slbCocRosterFlag registered">'+esc(item.callsign||'SLB linked')+'</span>':'<span class="slbCocRosterFlag">Not linked</span>'}
  function liveWarView(war){
    if(!war||!war.available)return liveUnavailable(war,'Current war information is unavailable.');
    if(!war.active&&String(war.state||'')==='NOT_IN_WAR')return liveUnavailable(war,war.message||'The clan is not currently in a regular war.');
    var clan=war.clan||{},opp=war.opponent||{},members=war.members||[];return ''+
      '<div class="slbCocScoreboard"><div><small>OUR CLAN</small><strong>'+esc(clan.name||'Clan')+'</strong><b>'+fmt(clan.stars)+' ★</b><span>'+fmt(clan.attacks)+' attacks · '+pct(clan.destruction)+'</span></div><em>VS</em><div><small>OPPONENT</small><strong>'+esc(opp.name||'Opponent')+'</strong><b>'+fmt(opp.stars)+' ★</b><span>'+fmt(opp.attacks)+' attacks · '+pct(opp.destruction)+'</span></div></div>'+
      '<div class="slbCocLiveMeta">'+statusPill(war.state)+'<span>Team '+fmt(war.teamSize)+' · '+fmt(war.attacksPerMember)+' attacks each</span><span>Ends '+date(war.endTime)+'</span></div>'+ 
      '<details class="slbCocLiveNested"><summary>War lineup and attacks ('+members.length+')</summary><div class="slbCocTableWrap"><table class="slbCocTable slbCocLiveTable"><thead><tr><th>#</th><th>Town</th><th>Duty</th><th>Stars</th><th>SLB</th></tr></thead><tbody>'+members.map(function(m){return '<tr><td>'+fmt(m.mapPosition)+'</td><td><strong>'+esc(m.name)+'</strong><small>'+esc(m.tag)+' · TH '+fmt(m.townHallLevel)+'</small></td><td>'+fmt(m.attacksUsed)+' / '+fmt(m.attacksAllowed)+'</td><td>'+fmt(m.stars)+'</td><td>'+liveRegistration(m)+'</td></tr>'}).join('')+'</tbody></table></div></details>';
  }
  function liveCwlView(cwl){
    if(!cwl||!cwl.available)return liveUnavailable(cwl,'No current CWL league group is available.');
    return '<div class="slbCocLiveStack">'+statusPill(cwl.state)+'<strong>'+esc(cwl.season||'Current CWL Season')+'</strong><span>'+fmt(cwl.clanCount)+' clans · '+fmt(cwl.roundCount)+' rounds</span><span>'+fmt(cwl.completedRounds)+' rounds have active war tags</span>'+(cwl.clan?'<small>'+esc(cwl.clan.name)+' · Level '+fmt(cwl.clan.clanLevel)+'</small>':'')+'</div>';
  }
  function liveRaidView(raid){
    if(!raid||!raid.available)return liveUnavailable(raid,'No current Raid Weekend data is available.');
    if(!raid.members||!raid.members.length)return '<div class="slbCocLiveStack">'+statusPill(raid.state)+'<strong>'+esc(raid.message||'Raid Weekend')+'</strong><span>Starts '+date(raid.startTime)+' · Ends '+date(raid.endTime)+'</span></div>';
    return '<div class="slbCocLiveStack">'+statusPill(raid.state)+'<strong>'+fmt(raid.capitalTotalLoot)+' Capital Gold</strong><span>'+fmt(raid.totalAttacks)+' attacks · '+fmt(raid.districtsDestroyed)+' districts destroyed</span><span>'+fmt(raid.raidsCompleted)+' raids completed · Ends '+date(raid.endTime)+'</span></div><details class="slbCocLiveNested"><summary>Raid participation ('+raid.members.length+')</summary><div class="slbCocTableWrap"><table class="slbCocTable slbCocLiveTable"><thead><tr><th>Player</th><th>Attacks</th><th>Capital Gold</th><th>SLB</th></tr></thead><tbody>'+raid.members.map(function(m){return '<tr><td><strong>'+esc(m.name)+'</strong><small>'+esc(m.tag)+'</small></td><td>'+fmt(m.attacks)+' / '+fmt(num(m.attackLimit)+num(m.bonusAttackLimit))+'</td><td>'+fmt(m.capitalResourcesLooted)+'</td><td>'+liveRegistration(m)+'</td></tr>'}).join('')+'</tbody></table></div></details>';
  }
  function liveRosterView(members){
    if(!members||!members.length)return '<div class="slbCocEmpty">Clan roster is not available.</div>';
    return '<div class="slbCocTableWrap"><table class="slbCocTable slbCocLiveTable"><thead><tr><th>Rank</th><th>Player</th><th>Profile</th><th>Donations</th><th>SLB Link</th></tr></thead><tbody>'+members.map(function(m){var move=num(m.previousClanRank)-num(m.clanRank),movement=move>0?'▲ '+fmt(move):move<0?'▼ '+fmt(Math.abs(move)):'—';return '<tr><td><strong>#'+fmt(m.clanRank)+'</strong><small>'+movement+'</small></td><td><strong>'+esc(m.name)+'</strong><small>'+esc(m.tag)+' · '+esc(String(m.role||'member').replace(/([A-Z])/g,' $1'))+'</small></td><td>TH '+fmt(m.townHallLevel)+'<small>'+fmt(m.trophies)+' trophies · '+esc(m.league)+'</small></td><td>'+fmt(m.donations)+'<small>Received '+fmt(m.donationsReceived)+'</small></td><td>'+liveRegistration(m)+'</td></tr>'}).join('')+'</tbody></table></div>';
  }
  function clanLiveView(data){
    data=data||{};var clan=data.clan||{},members=data.members||[],title=clan.available?(clan.name||'Clan Command Board'):'Clan Command Board',sub=clan.available?(clan.tag+' · '+(clan.location||'Clash of Clans')):(clan.message||'Live clan information is temporarily unavailable.');return '<section class="slbCocSection slbCocClanBoard"><div class="slbCocClanHead"><div><div class="slbCocEyebrow">CLAN-WIDE LIVE DASHBOARD</div><h3>'+esc(title)+'</h3><p>'+esc(sub)+'</p></div><div class="slbCocClanActions">'+statusPill(clan.available?'LIVE API':'PARTIAL DATA')+'<button class="btn soft mini" id="slbCocClanRefresh" type="button">Refresh Clan</button><small>Updated '+date(data.updatedAt)+'</small></div></div>'+ 
      (clan.available?'<div class="slbCocMetrics slbCocClanMetrics">'+metric('Clan Level',fmt(clan.clanLevel),clan.warLeague)+metric('Members',fmt(clan.memberCount),'Official clan roster')+metric('SLB Towns',fmt(data.registeredTownCount),fmt(data.registeredDiscipleCount)+' disciples linked')+metric('War Record',fmt(clan.warWins)+' wins','Current streak '+fmt(clan.warWinStreak))+metric('Clan Points',fmt(clan.clanPoints),'Home Village')+metric('Capital League',clan.capitalLeague||'Unranked',fmt(clan.clanCapitalPoints)+' points')+'</div>':'<div class="slbCocAlert warn"><strong>Partial clan dashboard</strong><span>'+esc(clan.message||'Clan information is temporarily unavailable, but each event panel still loads independently.')+'</span></div>')+
      '<div class="slbCocLiveGrid"><details class="slbCocLiveCard" open><summary>⚔ Current War</summary><div class="slbCocLiveBody">'+liveWarView(data.currentWar)+'</div></details><details class="slbCocLiveCard"><summary>🏆 CWL Status</summary><div class="slbCocLiveBody">'+liveCwlView(data.cwl)+'</div></details><details class="slbCocLiveCard" open><summary>🏰 Raid Weekend</summary><div class="slbCocLiveBody">'+liveRaidView(data.raid)+'</div></details></div>'+ 
      '<details class="slbCocFold slbCocClanRoster"><summary>Full Clan Roster ('+members.length+') · rankings, donations, and SLB links</summary>'+liveRosterView(members)+'</details></section>';
  }
  function renderClan(){var box=el('slbCocClanLive');if(!box)return;if(state.clanBusy&&!state.clan){box.innerHTML='<div class="slbCocLoading">Loading live clan, war, CWL, and Raid data…</div>';return}if(state.clanError&&!state.clan){box.innerHTML='<div class="slbCocAlert warn"><strong>Clan command board could not refresh.</strong><span>'+esc(state.clanError)+'</span><button class="btn soft mini" id="slbCocClanRefresh" type="button">Try Again</button></div>';}else if(state.clan)box.innerHTML=clanLiveView(state.clan);var refresh=el('slbCocClanRefresh');if(refresh)refresh.onclick=function(){loadClan();};}
  function townCard(t){var ranked=num(t.townRank)>0,rank=ranked?'#'+fmt(t.townRank):'—',mult=ranked?fmt(num(t.positiveMultiplier)*100)+'%':'—';return '<article class="slbCocTownCard '+(t.active?'':'inactive')+'"><div class="slbCocTownTop"><div><small>'+esc(t.playerTag)+'</small><h4>'+esc(t.townName||'Unknown Town')+'</h4></div>'+statusPill(t.active?'ACTIVE':'INACTIVE')+'</div><div class="slbCocTownStats"><span><small>Town Hall</small><b>TH '+fmt(t.townHallLevel)+'</b></span><span><small>Experience</small><b>'+fmt(t.experienceLevel)+'</b></span><span><small>Town Rank</small><b>'+rank+'</b></span><span><small>Positive Reward</small><b>'+mult+'</b></span></div><div class="slbCocTiny">Registered '+shortDate(t.registrationDate)+' · Last profile sync '+date(t.lastProfileSync)+'</div>'+(t.lastProfileError?'<div class="slbCocInlineError">'+esc(t.lastProfileError)+'</div>':'')+'</article>'}
  function warningFor(e,r){var type=String(e.eventType||''),required=type==='RAID'?Math.max(0,num(r.standardAttackLimit)-num(r.attacksUsed)):Math.max(0,num(r.attacksAllowed)-num(r.attacksUsed));if(!required||String(e.state||'').toUpperCase().indexOf('ENDED')>=0)return '';var title=type==='REGULAR'?(required===1?'ONE WAR ATTACK REMAINS':required+' WAR ATTACKS REMAIN'):type==='CWL'?'ONE CWL ATTACK REMAINS':required+' STANDARD RAID ATTACKS REMAIN';var penalty=type==='RAID'?50:40;var text=esc(r.townNameSnapshot||r.playerTag)+' still has '+required+' required attack'+(required===1?'':'s')+' remaining.';if(type==='RAID')text+=' Finishing with zero Raid attacks will result in a '+penalty+'-Coin duty penalty. An unused bonus attack is never penalized.';else text+=' Missing each required attack will result in a '+penalty+'-Coin duty penalty.';return '<div class="slbCocDutyWarning"><strong>'+title+'</strong><span>'+text+'</span></div>'}
  function eventTown(e,r){var remaining=Math.max(0,num(r.attacksAllowed)-num(r.attacksUsed)),isFinal=!r.projected||String(e.settlementStatus||'').toUpperCase()==='SETTLED',amountLabel=isFinal?'Final Town Settlement':'Projected Town Coins';return '<div class="slbCocEventTown">'+warningFor(e,r)+'<div class="slbCocEventTownHead"><div><strong>'+esc(r.townNameSnapshot||r.playerTag)+'</strong><small>'+esc(r.playerTag)+' · Rank #'+fmt(r.townRankSnapshot)+' · '+fmt(num(r.multiplierSnapshot)*100)+'% positive rewards</small></div><div class="slbCocCoinBox"><small>'+amountLabel+'</small>'+coin(r.finalCoins)+'</div></div><div class="slbCocProgressGrid"><span><small>Attacks Used</small><b>'+fmt(r.attacksUsed)+' / '+fmt(r.attacksAllowed)+'</b></span><span><small>API Remaining</small><b>'+fmt(remaining)+'</b></span><span><small>Stars</small><b>'+fmt(r.stars)+'</b></span><span><small>Capital Gold</small><b>'+fmt(r.capitalGold)+'</b></span><span><small>Positive Raw</small><b>'+fmt(r.positiveRawCoins)+'</b></span><span><small>Penalty</small><b>'+(num(r.penaltyCoins)?'−'+fmt(r.penaltyCoins):'0')+'</b></span></div></div>'}
  function eventCard(e,current){var title=e.eventType==='REGULAR'?'Regular Clan War':e.eventType==='CWL'?'CWL Battle Day':'Raid Weekend',settled=String(e.settlementStatus||'').toUpperCase()==='SETTLED',amountLabel=settled?'Final Event Settlement':'Projected Event Coins';return '<article class="slbCocEventCard '+(current?'current':'history')+'"><div class="slbCocEventHead"><div><div class="slbCocEventType">'+esc(title)+'</div><h3>'+esc(e.opponent||title)+'</h3><div class="slbCocTiny">'+date(e.startTime)+' · ID '+esc(e.eventId)+'</div></div><div class="slbCocEventStatus">'+statusPill(e.state)+statusPill(e.settlementStatus)+'<small>'+amountLabel+'</small><div>'+coin(e.projectedCoins)+'</div></div></div>'+(e.apiDataStatus&&e.apiDataStatus!=='COMPLETE'?'<div class="slbCocAlert warn"><strong>AWAITING COMPLETE DATA</strong><span>No penalty or settlement will be issued until reliable API data is available. If this event was discovered too late for a valid frozen snapshot, it remains permanently blocked.</span></div>':'')+'<div class="slbCocEventTowns">'+((e.towns||[]).length?(e.towns||[]).map(function(r){return eventTown(e,r)}).join(''):'<div class="slbCocEmpty">No registered town from this account was selected.</div>')+'</div></article>'}
  function metric(label,value,sub){return '<div class="slbCocMetric"><small>'+esc(label)+'</small><b>'+esc(value)+'</b><span>'+esc(sub||'')+'</span></div>'}
  function cocEventLabel(v){v=String(v||'').toUpperCase();return v==='REGULAR'?'Regular War':v==='CWL'?'CWL Battle Day':v==='RAID'?'Raid Weekend':v||'Clash Duty'}
  function cocSeenKey(callsign){return 'slb_coc_last_seen_settlement_v1_'+String(callsign||'').toUpperCase()}
  function cocSeenSettlement(callsign){try{return String(localStorage.getItem(cocSeenKey(callsign))||'')}catch(_e){return ''}}
  function payoutSummaryView(data){
    var p=data.payoutSummary||{},latest=p.latest||null,debt=num(p.currentDebt),result=num(p.dutyResult),added=num(p.addedToDrawers),removed=num(p.removedFromDrawers),cleared=num(p.debtCleared),debtAdded=num(p.debtAdded);
    var latestId=latest&&String(latest.ledgerEntryId||latest.duplicateId||''),unseen=!!(latestId&&cocSeenSettlement(data.callsign)!==latestId);
    var banner=unseen?'<div class="slbCocPayoutNotice"><div><strong>Clash Duty payout recorded!</strong><span>'+esc(cocEventLabel(latest.eventType))+' · '+coin(latest.grossEventCoins)+' duty result'+(num(latest.debtCleared)>0?' · '+fmt(latest.debtCleared)+' Coins cleared debt':'')+(num(latest.walletDelta)>0?' · '+fmt(latest.walletDelta)+' Coins added to '+esc(latest.destination||'Tao-Game Pouch'):'')+'</span></div><button class="btn soft mini" id="slbCocPayoutDismiss" type="button">Got It</button></div>':'';
    var latestHtml=latest?'<div class="slbCocPayoutLatest"><div><small>Latest settlement</small><b>'+esc(cocEventLabel(latest.eventType))+'</b><span>'+date(latest.settledAt)+'</span></div><div><small>Duty result</small>'+coin(latest.grossEventCoins)+'</div><div><small>To Coin Drawers</small>'+coin(latest.walletDelta)+'</div><div><small>Destination</small><b>'+esc(latest.destination||'Tao-Game Pouch')+'</b></div></div>':'<div class="slbCocEmpty">No automatic Clash Duty settlement has been recorded for this callsign yet.</div>';
    return banner+'<section class="slbCocPayoutCard"><div class="slbCocPayoutHead"><div><div class="slbCocEyebrow">CLASH DUTY COINS</div><h3>Your payout and Coin Pouch</h3><p>Duty results settle automatically after complete Clash data is available. Rewards clear Coin Debt first, then the remainder enters your Tao-Game Coin Drawers.</p></div><button class="btn orange" id="slbCocOpenCoinHistory" type="button">View Coin History</button></div>'+
      '<div class="slbCocPayoutGrid"><div class="'+coinClass(result)+'"><small>Last 7 Days Duty Result</small><b>'+(result>0?'+':'')+fmt(result)+'</b><span>Gross Clash rewards and penalties</span></div><div class="pos"><small>Added to Coin Drawers</small><b>+'+fmt(added)+'</b><span>Spendable Tao-Game Coins received</span></div><div class="'+(cleared>0?'debtClear':'zero')+'"><small>Used to Clear Debt</small><b>'+fmt(cleared)+'</b><span>Rewards applied before pouch credit</span></div><div class="'+(removed>0?'neg':'zero')+'"><small>Taken from Drawers</small><b>'+(removed>0?'−':'')+fmt(removed)+'</b><span>Duty penalties collected</span></div><div class="balance"><small>Current Total Coins</small><b>'+fmt(p.currentCoinBalance)+'</b><span>Across all Tao-Game Coin Drawers</span></div><div class="'+(debt>0?'debt':'zero')+'"><small>Current Coin Debt</small><b>'+fmt(debt)+'</b><span>'+(debt>0?'Future Coin income clears this first':'No Coin Debt')+'</span></div></div>'+
      (debtAdded>0?'<div class="slbCocDebtInline"><strong>New debt added during the last 7 days: '+fmt(debtAdded)+' Coins</strong><span>This happened because duty penalties were larger than the available Coin balance.</span></div>':'')+
      latestHtml+'</section>';
  }
  function openGameCenterCoinHistory(){
    var tab=el('slbGcLaunchBack')||d.querySelector('[data-tab="gameCenter"]');if(tab)tab.click();
    var tries=0;function open(){var b=el('slbGcOpenCoinHistory');if(b){b.click();return}if(tries++<12)setTimeout(open,120)}setTimeout(open,120);
  }
  function discipleView(data){var towns=data.towns||[],metrics=data.metrics||{},current=data.currentEvents||[],history=data.history||[];return ''+
    payoutSummaryView(data)+
    (num(data.coinDebt)>0?'<div class="slbCocDebt"><strong>COIN DEBT: '+fmt(data.coinDebt)+'</strong><span>Future Coin income clears this debt first. Your full Coin activity is available in Tao-Game Center.</span></div>':'')+
    '<section class="slbCocSection"><div class="slbCocSectionHead"><div><div class="slbCocEyebrow">DISCIPLE DUTY PROFILE</div><h3>'+esc(data.callsign)+'</h3></div><div class="slbCocSyncState">'+statusPill(data.connection&&data.connection.ready?'API READY':'API SETUP NEEDED')+'</div></div><div class="slbCocMetrics">'+metric('Regular-War Duty',pct(metrics.regularDutyRate),'Completed required attacks')+metric('CWL Duty',pct(metrics.cwlDutyRate),'Used selected CWL attacks')+metric('Raid Participation',pct(metrics.raidParticipationRate),'Expected Raid weekends joined')+metric('Current Duty Streak',fmt(metrics.completedDutyStreak),'Completed events in a row')+'</div></section>'+
    '<section class="slbCocSection"><div class="slbCocSectionHead"><div><h3>Registered Towns</h3><p>Active-town order is automatic: Town Hall, experience level, then earliest registration. Inactive registrations remain locked to the disciple but are not ranked for new events.</p></div></div><div class="slbCocTownGrid">'+(towns.length?towns.map(townCard).join(''):'<div class="slbCocEmpty">No Clash town is registered to this callsign yet. Admin must register the player tag.</div>')+'</div></section>'+
    '<section class="slbCocSection"><div class="slbCocSectionHead"><div><h3>Current Duty</h3><p>Warnings appear automatically when a selected town still has required attacks remaining.</p></div></div><div class="slbCocEventList">'+(current.length?current.map(function(e){return eventCard(e,true)}).join(''):'<div class="slbCocEmpty">No active regular war, CWL day, or Raid Weekend is currently assigned to your registered towns.</div>')+'</div></section>'+
    '<section class="slbCocSection"><details class="slbCocFold" open><summary>Recent Clash Duty History</summary><div class="slbCocEventList">'+(history.length?history.slice(0,12).map(function(e){return eventCard(e,false)}).join(''):'<div class="slbCocEmpty">No completed Clash Duty history yet.</div>')+'</div></details></section>';
  }
  function apiStatus(c){return '<div class="slbCocApiGrid">'+metric('Enabled',c.enabled?'YES':'NO','COC_ENABLED')+metric('Clan Tag',c.clanTag||'Missing',c.validClanTag?'Valid format':'Check format')+metric('API Token',c.hasToken?'SET':'MISSING','Never sent to browser')+metric('Mode',c.useProxy?'PROXY':'DIRECT','API adapter')+metric('Proxy URL',c.useProxy?(c.hasProxy?'SET':'MISSING'):'Not used','Optional')+metric('Ready',c.ready?'YES':'NO','Connection requirements')+'</div>'}
  function adminTownRow(t){return '<tr><td><strong>'+esc(t.townName||'Unknown')+'</strong><small>'+esc(t.playerTag)+'</small></td><td><strong>'+esc(t.callsign)+'</strong><small>SLB disciple</small></td><td>TH '+fmt(t.townHallLevel)+'<small>XP '+fmt(t.experienceLevel)+'</small></td><td>#'+fmt(t.townRank)+'<small>'+fmt(num(t.positiveMultiplier)*100)+'%</small></td><td>'+statusPill(t.active?'ACTIVE':'INACTIVE')+'</td><td><button class="btn soft mini" data-coc-toggle="'+esc(t.playerTag)+'" data-coc-active="'+(t.active?'0':'1')+'" type="button">'+(t.active?'Deactivate':'Activate')+'</button></td></tr>'}
  function adminView(data){var a=data.admin||{},cfg=(data.config&&data.config.scores)||{},keys=['REGULAR_ATTACK_REWARD','REGULAR_STAR_REWARD','REGULAR_FULL_DUTY_REWARD','REGULAR_WIN_REWARD','REGULAR_MISSED_ATTACK_PENALTY','CWL_ATTACK_REWARD','CWL_STAR_REWARD','CWL_THREE_STAR_REWARD','CWL_ROUND_WIN_REWARD','CWL_MISSED_ATTACK_PENALTY','RAID_ATTACK_REWARD','RAID_FULL_STANDARD_DUTY_REWARD','RAID_ZERO_ATTACK_PENALTY','TOWN_1_MULTIPLIER','TOWN_2_MULTIPLIER','TOWN_3_MULTIPLIER','TOWN_4_MULTIPLIER','TOWN_5_PLUS_MULTIPLIER'];return '<section class="slbCocSection slbCocAdmin"><div class="slbCocSectionHead"><div><div class="slbCocEyebrow">ADMIN GATE</div><h3>Clash Duty Administration</h3><p>No manual scoring or reward approval is available. Admin controls only registration, configuration, connection tests, and automatic sync tools.</p></div></div>'+apiStatus(data.connection||{})+
    '<div class="slbCocAdminActions"><button class="btn orange" id="slbCocTestApi" type="button">Test API</button><button class="btn soft" id="slbCocRunSync" type="button">Run Event Sync</button><button class="btn soft" id="slbCocProfileSync" type="button">Sync Town Profiles</button><button class="btn soft" id="slbCocTriggers" type="button">Install Safe Triggers</button><button class="btn soft" id="slbCocTests" type="button">Run Simulations</button><button class="btn soft" id="slbCocStorageHealth" type="button">Check Spreadsheet Health</button><button class="btn soft" id="slbCocUiTests" type="button">UI Test Preview</button></div><div id="slbCocAdminResult"></div><div class="slbCocAlert good"><strong>AFTER TOWN REGISTRATION: AUTOMATION IS ON</strong><span>No payout approval is required. Registration automatically reuses an eligible Tao-Game Pouch and Coin Drawer, or creates a zero-balance pouch and drawer when the disciple has none. No Spirit Stones are moved and no Coins are minted during setup. Installed triggers refresh town profiles every 6 hours and events every 15 minutes, then settle complete reliable events automatically. A town registered after an event start snapshot begins with the next eligible event.</span></div>'+ 
    '<div class="slbCocAdminGrid"><form class="slbCocAdminCard" id="slbCocTownForm"><h4>Add a Disciple&apos;s Clash Town</h4><div class="slbCocAlert warn"><strong>QUICK SETUP</strong><span>1. Enter the disciple callsign.<br>2. Paste the town&apos;s Player Tag or official player-profile share link.<br>3. Select Add Town. For another town, keep the same callsign and paste the next tag.</span></div><label>Disciple Callsign<input id="slbCocCallsign" required autocomplete="off" value="'+esc(state.lastTownCallsign||'')+'" placeholder="Example: TY9YUE"></label><label>Clash Player Tag or Profile Link<input id="slbCocPlayerTag" required autocomplete="off" autocapitalize="characters" placeholder="Example: #P0Y2J8LQ"></label><label class="slbCocCheck"><input id="slbCocActive" type="checkbox" checked> Active town</label><button class="btn orange" type="submit">Add or Update This Town</button><p class="slbCocTiny">The SLB disciple ID is found automatically from the callsign. Use the Player Tag from that town&apos;s profile—not the clan tag or town name. The town name, Town Hall, and experience level are fetched automatically. Repeat this form for each additional town.</p></form>'+ 
    '<div class="slbCocAdminCard"><h4>Scoring Configuration</h4><div class="slbCocConfigGrid">'+keys.map(function(k){return '<label>'+esc(k.replace(/_/g,' '))+'<span><input type="number" min="0" step="0.01" inputmode="decimal" data-coc-config="'+esc(k)+'" value="'+esc(cfg[k])+'"><button class="btn soft mini" data-coc-config-save="'+esc(k)+'" type="button">Save</button></span></label>'}).join('')+'</div><p class="slbCocTiny">Stored in COC_CONFIG. API secrets stay only in Script Properties.</p></div></div>'+ 
    '<details class="slbCocFold" open><summary>Town Registry ('+(a.allTowns||[]).length+')</summary><div class="slbCocTableWrap"><table class="slbCocTable"><thead><tr><th>Town</th><th>Disciple</th><th>Profile</th><th>Rank</th><th>Status</th><th></th></tr></thead><tbody>'+((a.allTowns||[]).length?(a.allTowns||[]).map(adminTownRow).join(''):'<tr><td colspan="6">No towns registered.</td></tr>')+'</tbody></table></div></details>'+ 
    '<details class="slbCocFold"><summary>Unsettled Events ('+(a.unsettled||[]).length+')</summary><div class="slbCocAdminList">'+((a.unsettled||[]).length?(a.unsettled||[]).slice(0,30).map(function(e){return '<div><strong>'+esc(e.eventType)+' · '+esc(e.opponent||e.eventId)+'</strong><span>'+statusPill(e.apiDataStatus)+' '+statusPill(e.settlementStatus)+'</span><small>'+esc(e.eventId)+'</small></div>'}).join(''):'<div class="slbCocEmpty">No unsettled events.</div>')+'</div></details>'+ 
    '<details class="slbCocFold"><summary>Settlement Records ('+(a.settlements||[]).length+')</summary><div class="slbCocAdminList">'+((a.settlements||[]).length?(a.settlements||[]).map(function(s){return '<div><strong>'+esc(s.callsign)+' · '+esc(s.eventType)+'</strong><span>'+coin(s.grossEventCoins)+' · Debt after '+fmt(s.debtAfter)+'</span><small>'+esc(s.duplicateId)+' · Ledger '+esc(s.ledgerEntryId)+'</small></div>'}).join(''):'<div class="slbCocEmpty">No settlements yet.</div>')+'</div></details>'+ 
    '<details class="slbCocFold"><summary>Recent Sync Errors ('+(a.errors||[]).length+')</summary><div class="slbCocAdminList">'+((a.errors||[]).length?(a.errors||[]).map(function(e){return '<div><strong>'+esc(e.source)+' · HTTP '+esc(e.httpCode||'—')+'</strong><span>'+esc(e.message)+'</span><small>'+date(e.timeISO)+' · '+esc(e.eventId||'No event ID')+'</small></div>'}).join(''):'<div class="slbCocEmpty">No recent Clash sync errors.</div>')+'</div></details><div id="slbCocUiPreview"></div></section>'}
  function render(){setNotice();var b=el('slbCocBody');if(!b)return;if(state.busy&&!state.data){b.innerHTML='<div class="slbCocLoading">Syncing Clash Duty Hall…</div>';return}if(!state.data){b.innerHTML='<div class="slbCocEmpty">Clash Duty Hall is not available yet.</div>';return}b.innerHTML=discipleView(state.data)+(state.data.isAdmin?adminView(state.data):'');bindDynamic();}
  function load(msg){state.busy=true;state.error='';state.notice=msg||'';render();return rpc('cocDashboard',{},false).then(function(data){state.data=data;state.notice='';state.busy=false;render();}).catch(function(e){state.busy=false;state.error=e.message||String(e);render();});}
  function loadClan(){state.clanBusy=true;state.clanError='';renderClan();return rpc('cocClanLive',{},false).then(function(data){state.clan=data;state.clanBusy=false;renderClan();}).catch(function(e){state.clanBusy=false;state.clanError=e.message||String(e);renderClan();});}
  function refreshAll(msg){var btn=el('slbCocRefresh');if(btn){btn.disabled=true;btn.classList.add('is-loading')}return Promise.all([load(msg||''),loadClan()]).finally(function(){if(btn){btn.disabled=false;btn.classList.remove('is-loading')}});}
  function act(action,args,success){state.error='';state.notice='';var r=el('slbCocAdminResult');if(r)r.innerHTML='<div class="slbCocLoading small">Working…</div>';return rpc(action,args||{},true).then(function(out){if(r)r.innerHTML='<div class="slbCocAlert good"><strong>'+esc(success||'Completed')+'</strong><pre>'+esc(JSON.stringify(out,null,2))+'</pre></div>';showToast(success||'Completed');return refreshAll();}).catch(function(e){if(r)r.innerHTML='<div class="slbCocAlert bad"><strong>Action failed</strong><span>'+esc(e.message||e)+'</span></div>';showToast(e.message||String(e));});}
  function checkStorageHealth(){
    var r=el('slbCocAdminResult');if(r)r.innerHTML='<div class="slbCocLoading small">Checking spreadsheet size…</div>';
    return rpc('adminCocStorageHealth',{},false).then(function(out){
      var cls=String(out.status||'HEALTHY').toLowerCase(),largest=out.largestSheets||[];
      if(r)r.innerHTML='<div class="slbCocStorageHealth '+esc(cls)+'"><div class="slbCocStorageTop"><div><small>SLB SPREADSHEET HEALTH</small><strong>'+esc(out.status||'HEALTHY')+'</strong><span>'+esc(out.message||'')+'</span></div><div><b>'+fmt(out.allocatedPercent)+'%</b><small>allocated cell capacity</small></div></div><div class="slbCocStorageMetrics"><span><small>Sheets</small><b>'+fmt(out.sheetCount)+'</b></span><span><small>Allocated Cells</small><b>'+fmt(out.allocatedCells)+'</b></span><span><small>Used Rectangle</small><b>'+fmt(out.usedRectangleCells)+'</b></span><span><small>Populated Rows</small><b>'+fmt(out.populatedRows)+'</b></span></div><details><summary>Largest sheets</summary><div class="slbCocAdminList">'+largest.map(function(x){return '<div><strong>'+esc(x.name)+'</strong><span>'+fmt(x.lastRow)+' rows · '+fmt(x.lastColumn)+' used columns</span><small>'+fmt(x.allocatedCells)+' allocated cells</small></div>'}).join('')+'</div></details></div>';
    }).catch(function(e){if(r)r.innerHTML='<div class="slbCocAlert bad"><strong>Storage check failed</strong><span>'+esc(e.message||e)+'</span></div>';});
  }
  function bindDynamic(){
    var form=el('slbCocTownForm');if(form)form.onsubmit=function(e){e.preventDefault();var callsign=String(el('slbCocCallsign').value||'').trim().toUpperCase();state.lastTownCallsign=callsign;act('adminCocTownSave',{callsign:callsign,playerTag:el('slbCocPlayerTag').value,active:el('slbCocActive').checked},'Town saved. The callsign is kept ready for another town tag.');};
    Array.prototype.forEach.call(d.querySelectorAll('[data-coc-toggle]'),function(b){b.onclick=function(){act('adminCocTownSetActive',{playerTag:b.dataset.cocToggle,active:b.dataset.cocActive==='1'},'Town status updated');};});
    Array.prototype.forEach.call(d.querySelectorAll('[data-coc-config-save]'),function(b){b.onclick=function(){var key=b.dataset.cocConfigSave,input=d.querySelector('[data-coc-config="'+key+'"]');act('adminCocConfigSave',{key:key,value:input?input.value:''},'Configuration saved');};});
    if(el('slbCocTestApi'))el('slbCocTestApi').onclick=function(){act('adminCocTestApi',{},'API connection successful');};
    if(el('slbCocRunSync'))el('slbCocRunSync').onclick=function(){act('adminCocRunSync',{},'Automatic event sync completed');};
    if(el('slbCocProfileSync'))el('slbCocProfileSync').onclick=function(){act('adminCocRunProfileSync',{},'Town profiles synchronized');};
    if(el('slbCocTriggers'))el('slbCocTriggers').onclick=function(){act('adminCocSetupTriggers',{},'Automatic triggers installed');};
    if(el('slbCocTests'))el('slbCocTests').onclick=function(){act('adminCocRunTests',{},'Simulation tests completed');};
    if(el('slbCocStorageHealth'))el('slbCocStorageHealth').onclick=checkStorageHealth;
    if(el('slbCocOpenCoinHistory'))el('slbCocOpenCoinHistory').onclick=openGameCenterCoinHistory;
    if(el('slbCocPayoutDismiss'))el('slbCocPayoutDismiss').onclick=function(){var latest=state.data&&state.data.payoutSummary&&state.data.payoutSummary.latest,id=latest&&String(latest.ledgerEntryId||latest.duplicateId||'');try{if(id)localStorage.setItem(cocSeenKey(state.data.callsign),id)}catch(_e){}render();};
    if(el('slbCocUiTests'))el('slbCocUiTests').onclick=runUiTests;
  }
  function runUiTests(){var box=el('slbCocUiPreview');if(!box)return;box.innerHTML='<div class="slbCocUiTests"><h4>Responsive Theme Test Fixtures</h4><div class="slbCocUiFixture light"><strong>Light Mode</strong><span>ONE WAR ATTACK REMAINS</span><small>360px mobile fixture</small></div><div class="slbCocUiFixture dark"><strong>Dark Mode</strong><span>RAID DUTY COMPLETE</span><small>Desktop dark fixture</small></div></div>';box.scrollIntoView({behavior:'smooth',block:'center'});showToast('UI test fixtures rendered.');}
  function init(){mount=el('slbCocWarMount');if(!mount)return;if(mount.dataset.cocReady!=='1'){mount.dataset.cocReady='1';mount.innerHTML=shell();var guide=el('slbCocStaticGuide'),hero=mount.querySelector('.slbCocHero');if(guide&&hero)hero.insertAdjacentElement('afterend',guide);if(el('slbCocRefresh'))el('slbCocRefresh').onclick=function(){refreshAll('Refreshing Clash data…')};if(el('slbCocBackGame'))el('slbCocBackGame').onclick=function(){var p=el('slbGcLaunchBack')||d.querySelector('[data-tab="gameCenter"]');if(p)p.click();};}refreshAll();}
  function isOpen(){var p=el('slbCocWarPanel');return !!(p&&!p.classList.contains('hidden'))}
  function register(){w.SLB=w.SLB||{};if(w.SLB.features&&typeof w.SLB.features.register==='function')w.SLB.features.register(TAB,{onOpen:init,reload:refreshAll});}
  function boot(){register();if(isOpen())init();var p=el('slbCocWarPanel');if(p&&w.MutationObserver&&!p.dataset.cocObserved){p.dataset.cocObserved='1';new MutationObserver(function(){if(isOpen())init();}).observe(p,{attributes:true,attributeFilter:['class']});}}
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);else boot();
  w.SLB_COC_TESTS={runUi:runUiTests,refresh:refreshAll};
})(window,document);


/* ====== SLB FEATURE: 74_9stars_div.js ====== */
/* 9 Stars Div (User Page)
 * Tab: stars9Div
 */
(function(){
  "use strict";

  function $(sel, root){
    try{ return (root||document).querySelector(sel); }catch(_e){ return null; }
  }

  function escHtml(s){
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function safeStr(s, max){
    s = String(s == null ? "" : s);
    s = s.replace(/\s+/g, " ").trim();
    if(max && s.length > max) s = s.slice(0, max).trim();
    return s;
  }

  function fmtWhen(iso){
    try{
      var d = new Date(iso);
      if(!isFinite(d.getTime())) return String(iso||"");
      return d.toLocaleString();
    }catch(_e){
      return String(iso||"");
    }
  }

  function fmtStones(n){
    var x = Number(n||0);
    if(!isFinite(x)) x = 0;
    if(Math.abs(x - Math.round(x)) < 1e-9) return String(Math.round(x));
    return String(Math.round(x * 100) / 100);
  }

  function validNumberForType(type, numStr){
    var t = String(type||"").trim();
    var s = String(numStr||"").trim();
    if(!s) return false;
    if(!/^\d+$/.test(s)) return false;
    if(t === "1"){
      if(s.length !== 1) return false;
      var n1 = Number(s);
      return n1 >= 1 && n1 <= 9;
    }
    if(t === "2"){
      if(s.length !== 2) return false;
      var n2 = Number(s);
      return n2 >= 10 && n2 <= 99;
    }
    if(t === "3"){
      if(s.length !== 3) return false;
      var n3 = Number(s);
      return n3 >= 100 && n3 <= 999;
    }
    return false;
  }

  function normalizeTypeLabel(t){
    t = String(t||"").trim();
    if(t === "1") return "1 digit";
    if(t === "2") return "2 digits";
    if(t === "3") return "3 digits";
    return t || "";
  }

  function pickFinalAnswer_(row){
    if(!row) return "";
    var fa = safeStr(row.siJuenFinalAnswer, 2000);
    if(fa) return fa;
    return safeStr(row.generatedAnswer, 2000);
  }

  function setBusy_(btn, isBusy){
    var busy = !!isBusy;
    try{
      if(btn){
        btn.disabled = busy;
        if(busy){
          if(!btn.dataset._oldText) btn.dataset._oldText = btn.textContent;
          btn.textContent = 'Working…';
        }else{
          if(btn.dataset._oldText){
            btn.textContent = btn.dataset._oldText;
            delete btn.dataset._oldText;
          }
        }
      }
    }catch(_e0){}
    try{
      if(window.SLB && SLB.ui && SLB.ui.setBusy){
        SLB.ui.setBusy(btn, busy);
      }
    }catch(_e){}
  }

  function toast_(msg, isErr){
    try{
      if(window.SLB_APP && SLB_APP.toast){
        SLB_APP.toast(String(msg||""), !!isErr);
        return;
      }
    }catch(_e){}
    try{
      if(window.SLB && SLB.ui && SLB.ui.toast){
        SLB.ui.toast(String(msg||""), !!isErr);
        return;
      }
    }catch(_e2){}
    try{ console.log(isErr ? "[ERR]" : "[OK]", msg); }catch(_e2){}
  }

  function rpc_(action, args){
    if(!window.SLB_APP || !SLB_APP.rpc) return Promise.reject(new Error("SLB_APP.rpc not available"));
    return SLB_APP.rpc(action, args||{});
  }

  function getPouchesFromState_(S){
    try{
      var a = (S && S.dash && Array.isArray(S.dash.accounts)) ? S.dash.accounts : [];
      return a.filter(function(x){
        var id = String((x && x.accountId) || "").trim();
        return /^a_/i.test(id);
      });
    }catch(_e){
      return [];
    }
  }

  function fillPaySelect_(sel, pouches, preferId){
    if(!sel) return;
    var html = "";
    if(!pouches || !pouches.length){
      html = '<option value="">(No pouches found)</option>';
      sel.innerHTML = html;
      return;
    }

    var best = "";
    if(preferId){
      pouches.forEach(function(p){
        if(String(p.accountId) === String(preferId)) best = String(p.accountId);
      });
    }
    if(!best) best = String(pouches[0].accountId||"");

    html = pouches.map(function(p){
      var id = String(p.accountId||"");
      var name = safeStr(p.name, 80) || id;
      var bal = fmtStones(p.balance);
      var selAttr = (id === best) ? " selected" : "";
      return '<option value="' + escHtml(id) + '"' + selAttr + '>' + escHtml(name) + ' — ' + escHtml(bal) + '</option>';
    }).join("");

    sel.innerHTML = html;
  }

  function setDigitUi_(root){
    var typeSel = $("#nsDivDigitType", root);
    var num = $("#nsDivNumber", root);
    var hint = $("#nsDivNumberHint", root);
    if(!typeSel || !num || !hint) return;

    var t = String(typeSel.value||"2");

    if(t === "1"){
      num.placeholder = "e.g. 3";
      hint.textContent = "1 digit: mindset guidance only (no doing).";
      num.maxLength = 1;
    }else if(t === "3"){
      num.placeholder = "e.g. 368";
      hint.textContent = "3 digits: A(outside) + B(inside) + C(result/fruit).";
      num.maxLength = 3;
    }else{
      num.placeholder = "e.g. 36";
      hint.textContent = "2 digits: tens = outside action, ones = inside purpose.";
      num.maxLength = 2;
    }

    // keep only digits
    try{
      var v = String(num.value||"");
      var d = v.replace(/\D+/g, "");
      if(d !== v) num.value = d;
      if(num.value.length > num.maxLength) num.value = num.value.slice(0, num.maxLength);
    }catch(_e){}
  }

  function resetForm_(root){
    var typeSel = $("#nsDivDigitType", root);
    var num = $("#nsDivNumber", root);
    var q = $("#nsDivQuestion", root);
    var d1 = $("#nsDivD1", root);
    var d2 = $("#nsDivD2", root);
    var ui = $("#nsDivUserInterp", root);
    var msg = $("#nsDivSubmitMsg", root);
    var res = $("#nsDivResultWrap", root);

    if(typeSel) typeSel.value = "2";
    if(num) num.value = "";
    if(q) q.value = "";
    if(ui) ui.value = "";
    if(msg) msg.textContent = "";
    if(res) res.classList.add("hidden");

    // Keep parties (common usage)
    if(d1 && !String(d1.value||"").trim()) d1.value = "";
    if(d2 && !String(d2.value||"").trim()) d2.value = "";

    setDigitUi_(root);
  }

  function setDisabled_(el, disabled){
    if(!el) return;
    try{ el.disabled = !!disabled; }catch(_e){}
    try{ el.setAttribute('aria-disabled', (!!disabled) ? 'true' : 'false'); }catch(_e2){}
  }

  function setSubmitUiDisabled_(root, disabled){
    var ids = [
      'nsDivDigitType','nsDivNumber','nsDivPayAccount','nsDivD1','nsDivD2','nsDivQuestion','nsDivUserInterp','nsDivResetBtn','nsDivSubmitBtn'
    ];
    for(var i=0;i<ids.length;i++){
      setDisabled_($("#"+ids[i], root), disabled);
    }
  }

  function renderRecords_(root, rows){
    var body = $("#nsDivRecBody", root);
    if(!body) return;

    rows = Array.isArray(rows) ? rows : [];

    if(!rows.length){
      body.innerHTML = '<tr><td colspan="6" class="muted">No records yet.</td></tr>';
      return;
    }

    var html = rows.map(function(r){
      var id = String(r.id||"");
      var when = fmtWhen(r.createdAt);
      var t = normalizeTypeLabel(r.digitType);
      var n = String(r.number||"");
      var d1 = safeStr(r.d1Party, 80);
      var d2 = safeStr(r.d2Party, 80);
      var st = String(r.status||"");
      return (
        '<tr data-ns-id="' + escHtml(id) + '">' +
          '<td>' + escHtml(when) + '</td>' +
          '<td>' + escHtml(t) + '</td>' +
          '<td>' + escHtml(n) + '</td>' +
          '<td>' + escHtml(d1) + ' → ' + escHtml(d2) + '</td>' +
          '<td><span class="pill">' + escHtml(st) + '</span></td>' +
          '<td><button class="btn mini" data-ns-open="' + escHtml(id) + '" type="button">Open</button></td>' +
        '</tr>'
      );
    }).join("");

    body.innerHTML = html;
  }

  function showDetail_(root, row){
    var wrap = $("#nsDivRecDetail", root);
    if(!wrap) return;

    $("#nsDivRecDetailTitle", root).textContent = "Submission";
    $("#nsDivRecDetailSub", root).textContent = (row && row.id) ? (String(row.id) + " • " + fmtWhen(row.createdAt||"")) : "";
    $("#nsDivRecDetailStatus", root).textContent = String((row && row.status) || "");

    var pill = $("#nsDivRecDetailStatus", root);
    if(pill) pill.className = "pill";

    var d1 = safeStr(row.d1Party, 200);
    var d2 = safeStr(row.d2Party, 200);

    $("#nsDivRecDetailD1", root).value = d1;
    $("#nsDivRecDetailD2", root).value = d2;
    $("#nsDivRecDetailQ", root).value = safeStr(row.question, 2000);
    $("#nsDivRecDetailUI", root).value = safeStr(row.userInterpretation, 4000);
    $("#nsDivRecDetailGen", root).value = safeStr(row.generatedAnswer, 2000);
    $("#nsDivRecDetailFinal", root).value = pickFinalAnswer_(row);

    var why = safeStr(row.siJuenWhy, 4000);
    var whyEl = $("#nsDivRecDetailWhy", root);
    if(whyEl){
      if(why){
        whyEl.textContent = "Si Juen note: " + why;
        whyEl.style.display = "block";
      }else{
        whyEl.textContent = "";
        whyEl.style.display = "none";
      }
    }

    wrap.classList.remove("hidden");

    try{ wrap.scrollIntoView({behavior:"smooth", block:"start"}); }catch(_e){}
  }

  function showSubmitResult_(root, res){
    var wrap = $("#nsDivResultWrap", root);
    if(!wrap) return;

    var id = res && res.id ? String(res.id) : "";
    var receipt = res && res.receipt ? String(res.receipt) : "";
    var finalAnswer = safeStr(res && res.finalAnswer, 2000);

    var receiptLine = $("#nsDivReceiptLine", root);
    if(receiptLine) receiptLine.textContent = receipt;

    var lastId = $("#nsDivLastId", root);
    if(lastId){
      lastId.textContent = id ? ("ID: " + id) : "";
      lastId.setAttribute("data-id", id);
    }

    var stPill = $("#nsDivStatusPill", root);
    if(stPill) stPill.textContent = "NEW";

    var gen = $("#nsDivGenerated", root);
    if(gen) gen.value = safeStr(res && res.generatedAnswer, 2000);

    var fin = $("#nsDivFinal", root);
    if(fin) fin.value = finalAnswer || safeStr(res && res.generatedAnswer, 2000);

    var why = $("#nsDivSiJuenWhy", root);
    if(why){
      why.textContent = "";
      why.style.display = "none";
    }

    wrap.classList.remove("hidden");
  }

  function bindOnce_(root, S){
    if(!root) return;
    if(root.__nsDivBound) return;
    root.__nsDivBound = true;

    var typeSel = $("#nsDivDigitType", root);
    var num = $("#nsDivNumber", root);
    var paySel = $("#nsDivPayAccount", root);
    var submitBtn = $("#nsDivSubmitBtn", root);
    var resetBtn = $("#nsDivResetBtn", root);
    var openRecBtn = $("#nsDivOpenInRecordsBtn", root);
    var reloadBtn = $("#nsDivRecReloadBtn", root);
    var search = $("#nsDivRecSearch", root);

    if(typeSel){
      typeSel.addEventListener("change", function(){
        setDigitUi_(root);
      });
    }

    if(num){
      num.addEventListener("input", function(){
        try{
          var v = String(num.value||"");
          var d = v.replace(/\D+/g, "");
          if(d !== v) num.value = d;
          var maxL = Number(num.maxLength||0) || 3;
          if(num.value.length > maxL) num.value = num.value.slice(0, maxL);
        }catch(_e){}
      });
    }

    if(paySel){
      paySel.addEventListener("change", function(){
        try{ localStorage.setItem("slb_ns_pay", String(paySel.value||"")); }catch(_e){}
      });
    }

    if(resetBtn){
      resetBtn.addEventListener("click", function(){
        resetForm_(root);
      });
    }

    function loadRecords_(){
      var body = $("#nsDivRecBody", root);

      setBusy_(reloadBtn, true);
      setDisabled_(search, true);

      var q = safeStr(search && search.value, 80);
      var args = { limit: 100 };
      if(q) args.search = q;

      // Cache-first: show last-known list immediately, then refresh from backend
      var ss = (typeof stableStringify === "function") ? stableStringify : function(v){ try{ return JSON.stringify(v); }catch(_e){ return String(v); } };
      var ck = "nsDiv_listCases_" + ss(args||{});
      try{
        var cached = (typeof slbCacheGet_ === "function") ? slbCacheGet_(ck, 7*24*60*60*1000) : null;
        if(Array.isArray(cached)){
          var rows0 = cached.slice();
          rows0.sort(function(a,b){
            var ta = Date.parse(a && a.createdAt || "") || 0;
            var tb = Date.parse(b && b.createdAt || "") || 0;
            return tb - ta;
          });
          renderRecords_(root, rows0);
        }else{
          if(body) body.innerHTML = '<tr><td colspan="6" class="muted">Loading…</td></tr>';
        }
      }catch(_e){
        if(body) body.innerHTML = '<tr><td colspan="6" class="muted">Loading…</td></tr>';
      }

      return rpc_("listCases", args)
        .then(function(res){
          var rows = (res && Array.isArray(res.rows)) ? res.rows : (Array.isArray(res) ? res : (res && Array.isArray(res.items) ? res.items : []));
          // sort newest first
          rows.sort(function(a,b){
            var ta = Date.parse(a && a.createdAt || "") || 0;
            var tb = Date.parse(b && b.createdAt || "") || 0;
            return tb - ta;
          });
          renderRecords_(root, rows);
          try{
            if(typeof slbCacheSet_ === "function"){
              var cacheRows = rows.slice(0, 50).map(function(r){
                r = r || {};
                return {
                  id: r.id,
                  createdAt: r.createdAt,
                  createdByCallsign: r.createdByCallsign,
                  digitType: r.digitType,
                  number: r.number,
                  d1Party: r.d1Party,
                  d2Party: r.d2Party,
                  status: r.status,
                  question: (r.question ? String(r.question).slice(0, 200) : ""),
                  siJuenFinalAnswer: (r.siJuenFinalAnswer ? String(r.siJuenFinalAnswer).slice(0, 200) : "")
                };
              });
              slbCacheSet_(ck, cacheRows);
            }
          }catch(_e2){}
          return rows;
        })
        .catch(function(e){
          if(body) body.innerHTML = '<tr><td colspan="6" class="muted">Failed to load.</td></tr>';
          toast_(e && e.message ? e.message : "Failed to load", true);
          return [];
        })
        .finally(function(){
          setBusy_(reloadBtn, false);
          setDisabled_(search, false);
        });
    }

    if(reloadBtn){
      reloadBtn.addEventListener("click", function(){
        loadRecords_();
      });
    }

    if(search){
      search.addEventListener("keydown", function(ev){
        if(ev && ev.key === "Enter"){
          ev.preventDefault();
          loadRecords_();
        }
      });
    }

    // delegated open buttons
    root.addEventListener("click", function(ev){
      var t = ev && ev.target;
      if(!t) return;

      var openId = t.getAttribute && t.getAttribute("data-ns-open");
      if(openId){
        ev.preventDefault();
        setBusy_(t, true);
        rpc_("getCase", { id: String(openId) })
          .then(function(res){
            var row = res && (res.row || res);
            if(row && row.id) showDetail_(root, row);
          })
          .catch(function(e){ toast_(e && e.message ? e.message : "Failed", true); })
          .finally(function(){ setBusy_(t, false); });
        return;
      }

      if(t === openRecBtn){
        ev.preventDefault();
        var id = $("#nsDivLastId", root) && $("#nsDivLastId", root).getAttribute("data-id");
        if(id){
          setBusy_(openRecBtn, true);
          rpc_("getCase", { id: String(id) })
            .then(function(res){
              var row = res && (res.row || res);
              if(row && row.id) showDetail_(root, row);
            })
            .catch(function(e){ toast_(e && e.message ? e.message : "Failed", true); })
            .finally(function(){ setBusy_(openRecBtn, false); });
        }
      }
    });

    if(submitBtn){
      submitBtn.addEventListener("click", function(){
        var t = String(typeSel && typeSel.value || "2");
        var number = safeStr(num && num.value, 8);
        var d1 = safeStr($("#nsDivD1", root) && $("#nsDivD1", root).value, 200);
        var d2 = safeStr($("#nsDivD2", root) && $("#nsDivD2", root).value, 200);
        var question = safeStr($("#nsDivQuestion", root) && $("#nsDivQuestion", root).value, 2000);
        var interp = safeStr($("#nsDivUserInterp", root) && $("#nsDivUserInterp", root).value, 4000);
        var payId = safeStr(paySel && paySel.value, 120);

        var msg = $("#nsDivSubmitMsg", root);
        if(msg) msg.textContent = "";

        if(!validNumberForType(t, number)){
          toast_("Invalid number for digit type.", true);
          if(msg) msg.textContent = "Invalid number for digit type.";
          return;
        }
        if(!d1 || !d2){
          toast_("Please fill D1 and D2.", true);
          if(msg) msg.textContent = "Please fill D1 and D2.";
          return;
        }
        if(!question){
          toast_("Please write the question.", true);
          if(msg) msg.textContent = "Please write the question.";
          return;
        }
        if(!payId){
          toast_("Please select a pouch.", true);
          if(msg) msg.textContent = "Please select a pouch.";
          return;
        }

        var payload = {
          digitType: t,
          number: number,
          d1Party: d1,
          d2Party: d2,
          question: question,
          userInterpretation: interp,
          payAccountId: payId
        };

        // lock UI during submission
        setSubmitUiDisabled_(root, true);
        setBusy_(submitBtn, true);
        if(msg) msg.textContent = "Submitting… (cost: 1 Spirit Stone)";

        rpc_("submitCase", payload)
          .then(function(res){
            showSubmitResult_(root, res);
            toast_(res && res.receipt ? res.receipt : "Submitted", false);

            // scroll to result for mobile
            try{
              var rw = $("#nsDivResultWrap", root);
              if(rw && rw.scrollIntoView) rw.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }catch(_eScroll){}

            // Refresh balances (optional) then reload pouches
            try{
              if(window.SLB_APP && SLB_APP.refreshDashboardLite){
                SLB_APP.refreshDashboardLite();
              }
            }catch(_e){}

            
            // Refresh Transactions (so Transactions tab shows the new spend)
            try{
              if(window.SLB_APP && SLB_APP.reloadTxnsFirstPage){
                Promise.resolve(SLB_APP.reloadTxnsFirstPage()).catch(function(){});
              }
            }catch(_e2){}
// Reload records
            loadRecords_();

            if(msg) msg.textContent = (res && res.receipt) ? String(res.receipt) : "Success.";
          })
          .catch(function(e){
            var m = (e && e.message) ? String(e.message) : "Submit failed";
            var mm = m;
            if(/not enough spirit stones/i.test(m)) mm = "Not enough Spirit Stones in that pouch. Please top up and try again.";
            toast_(mm, true);
            if(msg) msg.textContent = mm;
          })
          .finally(function(){
            setBusy_(submitBtn, false);
            setSubmitUiDisabled_(root, false);
          });
      });
    }

    // expose for onOpen
    root.__nsDivLoadRecords = loadRecords_;
  }

  function onOpen_(ctx){
    ctx = ctx || {};
    var root = ctx.root || document;
    var S = ctx.state || {};

    // Only run if UI exists
    if(!$("#nsDivDigitType", root)) return;

    bindOnce_(root, S);
    setDigitUi_(root);

    // Fill pouch select
    var paySel = $("#nsDivPayAccount", root);
    var preferId = "";
    try{ preferId = localStorage.getItem("slb_ns_pay") || ""; }catch(_e){}
    var pouches = getPouchesFromState_(S);
    fillPaySelect_(paySel, pouches, preferId);

    // First-load records
    if(root.__nsDivLoadRecords) root.__nsDivLoadRecords();
  }

  try{
    if(window.SLB && SLB.features && SLB.features.register){
      SLB.features.register("stars9Div", {
        onOpen: onOpen_
      });
    }
  }catch(_e){}
})();


/* ====== SLB FEATURE: 75_9stars_review.js ====== */
/* ===== 9 Stars Review (Admin) ===== */
(function(){
  if(!window.SLB) return;

  function E(id){ return document.getElementById(id); }
  function esc_(s){
    return String(s||"").replace(/[&<>'"]/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;','\'':'&#39;'})[c] || c;
    });
  }

  function clip_(s, n){
    s = String(s||'').replace(/\s+/g,' ').trim();
    n = Number(n||0);
    if(n <= 0) return s;
    if(s.length <= n) return s;
    return s.slice(0, n-1) + '…';
  }

  function fmtWhen_(iso){
    var s = String(iso||'');
    if(!s) return '';
    try{
      var d = new Date(s);
      if(String(d) === 'Invalid Date') return s;
      var y = d.getFullYear();
      var m = ('0' + (d.getMonth()+1)).slice(-2);
      var da = ('0' + d.getDate()).slice(-2);
      var hh = ('0' + d.getHours()).slice(-2);
      var mm = ('0' + d.getMinutes()).slice(-2);
      return y + '-' + m + '-' + da + ' ' + hh + ':' + mm;
    }catch(_e){
      return s;
    }
  }

  function setDisabled_(el, disabled){
    if(!el) return;
    try{ el.disabled = !!disabled; }catch(_e){}
    try{ el.setAttribute('aria-disabled', (!!disabled) ? 'true' : 'false'); }catch(_e2){}
  }

  function toast_(msg, isErr){
    try{
      if(window.SLB_APP && SLB_APP.toast){
        SLB_APP.toast(String(msg||""), !!isErr);
        return;
      }
    }catch(_e){}
    try{
      if(window.SLB && SLB.ui && SLB.ui.toast){
        SLB.ui.toast(String(msg||""), !!isErr);
        return;
      }
    }catch(_e2){}
    try{ alert(String(msg||"")); }catch(_e3){}
  }

  function setBusy_(btn, isBusy){
    var busy = !!isBusy;
    try{
      if(btn){
        btn.disabled = busy;
        if(busy){
          if(!btn.dataset._oldText) btn.dataset._oldText = btn.textContent;
          btn.textContent = 'Working…';
        }
        else if(btn.dataset._oldText){ btn.textContent = btn.dataset._oldText; }
      }
    }catch(_e2){}
    try{
      if(window.SLB && SLB.ui && SLB.ui.setBusy){
        SLB.ui.setBusy(btn, busy);
      }
    }catch(_e){}
  }

  var state = {
    bound:false,
    rows:[],
    selectedId:""
  };

  function setMsg_(msg, isErr){
    var box = E('nsRevMsg');
    if(!box) return;
    var m = String(msg||"").trim();
    if(!m){ box.classList.add('hidden'); box.textContent = ""; return; }
    box.textContent = m;
    box.classList.remove('hidden');
    box.classList.toggle('ok', !isErr);
    box.classList.toggle('err', !!isErr);
  }

  function setDetailStatus_(st){
    var pill = E('nsRevDetailStatus');
    if(!pill) return;
    pill.textContent = st || '—';
  }

  function renderList_(rows){
    var mount = E('nsRevList');
    if(!mount) return;

    if(!rows || !rows.length){
      mount.innerHTML = '<div class="m7Hint" style="padding:10px 12px;">No results.</div>';
      return;
    }

    var html = '';
    for(var i=0;i<rows.length;i++){
      var r = rows[i] || {};
      var id = String(r.id||"");
      var cs = String(r.createdByCallsign||"");
      var dt = String(r.digitType||"");
      var num = String(r.number||"");
      var st = String(r.status||"");
      var at = fmtWhen_(String(r.createdAt||""));
      var d1 = String(r.d1Party||"");
      var d2 = String(r.d2Party||"");
      var q = clip_(String(r.question||""), 110);
      var sel = (id && state.selectedId && id === state.selectedId) ? ' style="outline:2px solid rgba(239,94,20,0.55);outline-offset:-2px;"' : '';

      var line1 = esc_(cs) + ' · ' + esc_(at);
      var line2 = (num ? ('#' + esc_(num) + ' · ') : '') + (d1 ? (esc_(d1) + ' → ') : '') + (d2 ? esc_(d2) : '') + (st ? (' · ' + esc_(st)) : '');
      var line3 = q ? esc_(q) : '';

      html += '<div class="m7Row" data-ns-id="' + esc_(id) + '" role="button" tabindex="0"' + sel + '>';
      html +=   '<div class="m7RowTop"><div>' + line1 + '</div><div>' + esc_(id) + '</div></div>';
      html +=   '<div class="m7RowLine">' + line2 + '</div>';
      if(line3) html += '<div class="m7RowLine muted" style="margin-top:4px;">' + line3 + '</div>';
      html += '</div>';
    }
    mount.innerHTML = html;
  }

  function fetchList_(){
    var status = (E('nsRevFilterStatus') ? String(E('nsRevFilterStatus').value||"").trim() : "NEW");
    var search = (E('nsRevSearch') ? String(E('nsRevSearch').value||"").trim() : "");

    var refreshBtn = E('nsRevRefreshBtn');
    var statusSel = E('nsRevFilterStatus');
    var searchEl = E('nsRevSearch');

    // Cache-first: show last-known list immediately, then refresh from backend
    var ss = (typeof stableStringify === "function") ? stableStringify : function(v){ try{ return JSON.stringify(v); }catch(_e){ return String(v); } };
    var args = { status: status, search: search, scope: 'all', limit: 200 };
    var ck = "nsRev_listCases_" + ss(args||{});
    try{
      var cached = (typeof slbCacheGet_ === "function") ? slbCacheGet_(ck, 7*24*60*60*1000) : null;
      if(Array.isArray(cached)){
        state.rows = cached;
        renderList_(cached);
      }
    }catch(_e){}

    setMsg_("", false);
    setBusy_(refreshBtn, true);
    setDisabled_(statusSel, true);
    setDisabled_(searchEl, true);

    return SLB_APP.rpc('listCases', args).then(function(res){
      var rows = (res && Array.isArray(res.rows)) ? res.rows : (Array.isArray(res) ? res : (res && Array.isArray(res.items) ? res.items : []));
      state.rows = rows;
      renderList_(rows);
      try{
        if(typeof slbCacheSet_ === "function"){
          var cut_ = function(s, n){ s = String(s||""); return (s.length > n) ? (s.slice(0,n) + "…") : s; };
          var cacheRows = rows.slice(0, 100).map(function(r){
            r = r || {};
            return {
              id: r.id,
              createdAt: r.createdAt,
              createdByCallsign: r.createdByCallsign,
              digitType: r.digitType,
              number: r.number,
              d1Party: r.d1Party,
              d2Party: r.d2Party,
              status: r.status,
              question: cut_(r.question, 160)
            };
          });
          slbCacheSet_(ck, cacheRows);
        }
      }catch(_e2){}
      return rows;
    }).catch(function(e){
      state.rows = [];
      renderList_([]);
      throw e;
    }).finally(function(){
      setBusy_(refreshBtn, false);
      setDisabled_(statusSel, false);
      setDisabled_(searchEl, false);
    });
  }

  function clearDetail_(){
    state.selectedId = "";
    if(E('nsRevId')) E('nsRevId').value = "";
    if(E('nsRevDetailSub')) E('nsRevDetailSub').textContent = '—';
    setDetailStatus_('—');

    var ids = ['nsRevCallsign','nsRevDigitType','nsRevNumber','nsRevD1','nsRevD2','nsRevQuestion','nsRevUserInterp','nsRevGenerated','nsRevFinal','nsRevWhy'];
    ids.forEach(function(id){ var el = E(id); if(el) el.value = ""; });
    if(E('nsRevStatusEdit')) E('nsRevStatusEdit').value = 'NEW';
  }

  function openCase_(id){
    id = String(id||"").trim();
    if(!id) return Promise.resolve();

    setMsg_("", false);
    state.selectedId = id;
    renderList_(state.rows);

    function apply_(res){
      if(!res || !res.id) return false;

      if(E('nsRevId')) E('nsRevId').value = String(res.id||"");
      if(E('nsRevCallsign')) E('nsRevCallsign').value = String(res.createdByCallsign||"");
      if(E('nsRevDigitType')) E('nsRevDigitType').value = String(res.digitType||"");
      if(E('nsRevNumber')) E('nsRevNumber').value = String(res.number||"");
      if(E('nsRevD1')) E('nsRevD1').value = String(res.d1Party||"");
      if(E('nsRevD2')) E('nsRevD2').value = String(res.d2Party||"");
      if(E('nsRevQuestion')) E('nsRevQuestion').value = String(res.question||"");
      if(E('nsRevUserInterp')) E('nsRevUserInterp').value = String(res.userInterpretation||"");
      if(E('nsRevGenerated')) E('nsRevGenerated').value = String(res.generatedAnswer||"");

      var finalAns = String(res.siJuenFinalAnswer||"").trim();
      if(!finalAns) finalAns = String(res.generatedAnswer||"").trim();
      if(E('nsRevFinal')) E('nsRevFinal').value = finalAns;
      if(E('nsRevWhy')) E('nsRevWhy').value = String(res.siJuenWhy||"");

      var st = String(res.status||'NEW').toUpperCase();
      if(E('nsRevStatusEdit')) E('nsRevStatusEdit').value = (st === 'REVIEWED' || st === 'FINAL') ? st : 'NEW';
      setDetailStatus_(st);

      if(E('nsRevDetailSub')){
        var sub = [];
        if(res.createdAt) sub.push(fmtWhen_(String(res.createdAt)));
        if(res.id) sub.push('ID ' + String(res.id));
        E('nsRevDetailSub').textContent = sub.join(' · ') || '—';
      }

      try{ if(typeof slbCacheSet_ === "function") slbCacheSet_("nsCase_" + String(res.id||id), res); }catch(_e){}
      return true;
    }

    // Cache-first: show last-known case immediately, then refresh
    try{
      var cached = (typeof slbCacheGet_ === "function") ? slbCacheGet_("nsCase_" + id, 30*24*60*60*1000) : null;
      if(cached && cached.id) apply_(cached);
    }catch(_e2){}

    return SLB_APP.rpc('getCase', { id: id }).then(function(res){
      if(!res || !res.id) throw new Error('Case not found.');
      apply_(res);
      return res;
    }).catch(function(e){
      toast_(e && e.message ? e.message : 'Failed to load case', true);
      throw e;
    });
  }

  function bind_(){
    if(state.bound) return;
    state.bound = true;

    var list = E('nsRevList');
    if(list){
      list.addEventListener('click', function(ev){
        var t = ev.target;
        while(t && t !== list){
          var id = t.getAttribute && t.getAttribute('data-ns-id');
          if(id){ openCase_(id); return; }
          t = t.parentNode;
        }
      });
      list.addEventListener('keydown', function(ev){
        if(ev.key !== 'Enter' && ev.key !== ' ') return;
        var t = ev.target;
        var id = t && t.getAttribute ? t.getAttribute('data-ns-id') : '';
        if(id){ ev.preventDefault(); openCase_(id); }
      });
    }

    var refresh = E('nsRevRefreshBtn');
    if(refresh){ refresh.addEventListener('click', function(){ fetchList_().catch(function(e){ toast_(e && e.message ? e.message : 'Failed', true); }); }); }

    var search = E('nsRevSearch');
    if(search){
      search.addEventListener('keydown', function(ev){
        if(ev.key === 'Enter'){
          fetchList_().catch(function(e){ toast_(e && e.message ? e.message : 'Failed', true); });
        }
      });
    }

    var filter = E('nsRevFilterStatus');
    if(filter){ filter.addEventListener('change', function(){ fetchList_().catch(function(e){ toast_(e && e.message ? e.message : 'Failed', true); }); }); }

    var saveBtn = E('nsRevSaveBtn');
    if(saveBtn){
      saveBtn.addEventListener('click', function(){
        saveCase_({btn:saveBtn}).then(function(){
          return fetchList_();
        }).then(function(rows){
          // keep selection if still present, otherwise clear
          var still = rows.some(function(r){ return String(r.id||"") === state.selectedId; });
          if(!still) clearDetail_();
        }).catch(function(_e){});
      });
    }

    var saveNextBtn = E('nsRevSaveNextBtn');
    if(saveNextBtn){
      saveNextBtn.addEventListener('click', function(){
        var cur = state.selectedId;
        var nextId = nextIdAfter_(cur, state.rows);

        saveCase_({btn:saveNextBtn}).then(function(){
          return fetchList_();
        }).then(function(rows){
          var openId = nextId;
          if(openId && !rows.some(function(r){ return String(r.id||"") === openId; })){
            openId = rows.length ? String(rows[0].id||"") : "";
          }
          if(openId) return openCase_(openId);
          clearDetail_();
        }).catch(function(_e){});
      });
    }
  }

  SLB.features.register('stars9Review', {
    onOpen: function(ctx){
      ctx = ctx || {};
      var S = ctx.state || {};
      var isAdminOrMod = false;
      try{ isAdminOrMod = !!(S && (S.isAdminOrMod || S.isAdmin || S.isModerator)); }catch(_e){}
      if(!isAdminOrMod){
        setMsg_('Admin only.', true);
        return;
      }

      setMsg_('', false);
      bind_();
      if(!state.selectedId) clearDetail_();
      fetchList_().catch(function(e){
        toast_(e && e.message ? e.message : 'Failed to load queue', true);
      });
    }
  });
})();


/* ====== SLB FEATURE: diary.js ====== */
/* SLB Feature: Diary (Phase 3)
   Centralizes Diary onOpen logic.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(!SLB.features || !SLB.features.register) return;

  SLB.features.register('diary', {
    onOpen: function(){
      try{
        if(w.SLB_DIARY && typeof w.SLB_DIARY.onOpen === 'function'){
          w.SLB_DIARY.onOpen();
          return;
        }
        if(w.SLB_DIARY && typeof w.SLB_DIARY.reload === 'function'){
          w.SLB_DIARY.reload();
        }
      }catch(_e){}
    }
  });
})(window);


/* ====== SLB FEATURE: library.js ====== */
/* SLB Feature: Library (Phase 3)
   Centralizes Library onOpen logic.
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(!SLB.features || !SLB.features.register) return;

  SLB.features.register('library', {
    onOpen: function(){
      try{
        if(w.SLB_LIBRARY && typeof w.SLB_LIBRARY.onOpen === 'function'){
          w.SLB_LIBRARY.onOpen();
          return;
        }
        if(w.SLB_LIBRARY && typeof w.SLB_LIBRARY.reload === 'function'){
          w.SLB_LIBRARY.reload();
        }
      }catch(_e){}
    }
  });
})(window);


/* ====== SLB FEATURE: shipping.js ====== */
/* SLB Feature: Shipping (Phase 2)
   Goal: 4-click envelope printing from disciple roster.
   - Admin menu -> Shipping -> choose disciple -> Print

   Phase 2 additions:
   - Structured address fields (Address 1/2, City, Province/State, Postal/ZIP, Country)
   - Save button (Admin/Mod) -> writes back to Disciples sheet
   - Printing prefers structured fields, falls back to legacy Address blob
*/
(function(w){
  w.SLB = w.SLB || {};
  var SLB = w.SLB;
  if(!SLB.features || !SLB.features.register) return;

  var S = {
    loaded:false,
    list:[],
    byKey:{},
    lastKey:"",
    bulk:{
      open:false,
      selected:{},
      filter:""
    }
  };

  function el(id){ return document.getElementById(id); }
  function val(id){ var e=el(id); return e ? String(e.value||"") : ""; }
  function setVal(id, v){ var e=el(id); if(e) e.value = (v==null?"":String(v)); }

  function setMsg(text, ok){
    var m = el('slbShipMsg');
    if(!m) return;
    m.textContent = String(text||"");
    m.classList.toggle('err', !ok && !!text);
    m.classList.toggle('ok',  !!ok && !!text);
  }

  // RPC helper: In this SLB build, rpc is exposed via window.SLB_APP (not window.rpc).
  var rpcFn = null;
  function getRpc(){
    try{ if(w.SLB_APP && typeof w.SLB_APP.__realRpc === 'function') return w.SLB_APP.__realRpc.bind(w.SLB_APP); }catch(_e0){}
    try{ if(w.SLB_APP && typeof w.SLB_APP.rpc === 'function') return w.SLB_APP.rpc.bind(w.SLB_APP); }catch(_e1){}
    try{ if(typeof w.rpc === 'function') return w.rpc.bind(w); }catch(_e2){}
    return null;
  }
  function waitRpcReady_(cb){
    var t0 = Date.now();
    var maxMs = 30000;
    (function tick(){
      rpcFn = getRpc();
      if(rpcFn) return cb(true);
      if(Date.now() - t0 > maxMs) return cb(false);
      setTimeout(tick, 200);
    })();
  }

  function ucase(s){ return String(s||"").toUpperCase(); }

  function clean(s){
    return String(s||"").replace(/\u00A0/g,' ').replace(/\s+/g,' ').trim();
  }

  function safeLinesFromBlock(s){
    s = String(s||"").replace(/\u00A0/g,' ').trim();
    if(!s) return [];
    s = s.replace(/\r\n/g,'\n').replace(/\r/g,'\n');
    if(s.indexOf('\n') < 0 && s.indexOf(',') >= 0){
      var parts = s.split(',').map(function(x){ return String(x||"").trim(); }).filter(Boolean);
      if(parts.length >= 3) return parts;
    }
    return s.split('\n').map(function(x){ return String(x||"").trim(); }).filter(Boolean);
  }

  function normCountry(s){
    s = ucase(clean(s));
    if(!s) return '';
    if(s === 'CA' || s === 'CAN') return 'CANADA';
    if(s === 'US' || s === 'USA' || s === 'UNITED STATES' || s === 'UNITED STATES OF AMERICA') return 'USA';
    return s;
  }

  function isLikelyCountryLine(s){
    s = normCountry(s);
    return (s === 'CANADA' || s === 'USA' || s === 'UNITED STATES');
  }

  function parseLegacyIntoFields(d, onlyEmpty){
    d = d || {};
    var out = {
      address1: clean(d.address1||''),
      address2: clean(d.address2||''),
      city: clean(d.city||''),
      province: clean(d.province||''),
      postal: clean(d.postal||''),
      country: clean(d.country||'')
    };
    var legacy = clean(d.address||'');
    if(!legacy) return out;

    var lines = safeLinesFromBlock(legacy).map(function(x){ return clean(x); }).filter(Boolean);
    // strip a leading TO: line
    if(lines.length && /^to\s*:/i.test(lines[0])) lines.shift();
    // strip empty
    lines = lines.filter(Boolean);
    if(!lines.length) return out;

    // Country: last line if obvious
    if(lines.length >= 2 && isLikelyCountryLine(lines[lines.length-1])){
      if(!out.country || !onlyEmpty) out.country = normCountry(lines.pop());
    }

    // City line is usually last remaining line
    var cityLine = '';
    if(lines.length >= 2){
      cityLine = lines[lines.length-1];
    }

    var caPostalRe = /\b([A-Z]\d[A-Z])\s?(\d[A-Z]\d)\b/i;
    var usZipRe = /\b(\d{5})(-\d{4})?\b/;
    var usState = {
      AL:1,AK:1,AZ:1,AR:1,CA:1,CO:1,CT:1,DE:1,FL:1,GA:1,HI:1,ID:1,IL:1,IN:1,IA:1,KS:1,KY:1,LA:1,ME:1,MD:1,MA:1,MI:1,MN:1,MS:1,MO:1,MT:1,NE:1,NV:1,NH:1,NJ:1,NM:1,NY:1,NC:1,ND:1,OH:1,OK:1,OR:1,PA:1,RI:1,SC:1,SD:1,TN:1,TX:1,UT:1,VT:1,VA:1,WA:1,WV:1,WI:1,WY:1,DC:1
    };
    var caProv = {ON:1,QC:1,BC:1,AB:1,MB:1,SK:1,NS:1,NB:1,NL:1,NT:1,YT:1,NU:1,PE:1};

    function setIf(field, v){
      v = clean(v);
      if(!v) return;
      if(onlyEmpty){ if(out[field]) return; }
      out[field] = v;
    }

    if(cityLine){
      var raw = ucase(cityLine);
      // US style: CITY, ST ZIP
      if(raw.indexOf(',') >= 0){
        var parts = raw.split(',');
        var city = clean(parts[0]);
        var right = clean(parts.slice(1).join(' '));
        var toks = right.split(/\s+/).filter(Boolean);
        var st = toks[0] || '';
        var zip = toks.slice(1).join(' ');
        if(city) setIf('city', city);
        if(st && (usState[st] || caProv[st])) setIf('province', st);
        if(zip){
          var mzip = zip.match(usZipRe);
          if(mzip) setIf('postal', mzip[0]);
          else {
            var mca = zip.match(caPostalRe);
            if(mca) setIf('postal', (mca[1] + ' ' + mca[2]).toUpperCase());
          }
        }
      } else {
        // Canada/Other: CITY PROV POSTAL (postal at end)
        var mca2 = raw.match(caPostalRe);
        if(mca2){
          setIf('postal', (mca2[1] + ' ' + mca2[2]).toUpperCase());
          raw = raw.replace(caPostalRe,'').trim();
        } else {
          var muz = raw.match(usZipRe);
          if(muz){ setIf('postal', muz[0]); raw = raw.replace(usZipRe,'').trim(); }
        }
        var toks2 = raw.split(/\s+/).filter(Boolean);
        if(toks2.length >= 2){
          var maybeProv = toks2[toks2.length-1];
          if((caProv[maybeProv] || usState[maybeProv])){
            setIf('province', maybeProv);
            toks2 = toks2.slice(0, -1);
          }
        }
        if(toks2.length) setIf('city', toks2.join(' '));
      }
    }

    // Address lines: everything before city line
    if(lines.length >= 2){
      lines.pop(); // remove city line
    } else {
      // not enough lines to infer city; keep all as address
    }
    // If first remaining line looks like a name (no digits) and we already have name elsewhere, skip it
    if(lines.length >= 2 && !/\d/.test(lines[0]) && /\d/.test(lines[1])){
      // likely name then street
      lines.shift();
    }
    if(lines.length){ setIf('address1', lines[0]); }
    if(lines.length >= 2){ setIf('address2', lines[1]); }

    // If country still blank, infer from postal/prov
    if(!out.country || !onlyEmpty){
      // no-op (respect existing)
    }
    if(!out.country && out.postal){
      if(caPostalRe.test(out.postal)) out.country = 'CANADA';
      else if(usZipRe.test(out.postal)) out.country = 'USA';
    }
    if(!out.country && out.province){
      var pr = ucase(out.province);
      if(caProv[pr]) out.country = 'CANADA';
      else if(usState[pr]) out.country = 'USA';
    }

    return out;
  }

  function isUSCountry(c){
    c = ucase(clean(c));
    return (c === 'US' || c === 'USA' || c === 'UNITED STATES' || c === 'UNITED STATES OF AMERICA');
  }

  function formatCityLine(d){
    d = d || {};
    var city = ucase(clean(d.city));
    var prov = ucase(clean(d.province));
    var postal = ucase(clean(d.postal));
    if(!city && !prov && !postal) return '';

    if(isUSCountry(d.country)){
      // CITY, ST ZIP
      var left = city;
      if(left && prov) left = left + ', ' + prov;
      else if(!left && prov) left = prov;
      if(postal) return (left ? (left + ' ' + postal) : postal);
      return left;
    }

    // Canada/Other: CITY PROV  POSTAL (double space like your return address)
    var line = '';
    if(city) line += city;
    if(prov) line += (line ? ' ' : '') + prov;
    if(postal) line += (line ? '  ' : '') + postal;
    return line.trimEnd();
  }

  function formatRecipientLines(d){
    d = d || {};
    // Allow an editable shipping name override (so you can tweak TO: line)
    var name = clean(d.shipName) || clean(d.ordinaryName) || clean(d.taoistName) || clean(d.callsign) || '';
    var lines = [];
    if(name) lines.push('TO: ' + ucase(name));

    var a1 = clean(d.address1);
    var a2 = clean(d.address2);
    if(a1) lines.push(ucase(a1));
    if(a2) lines.push(ucase(a2));

    // Fallback to legacy blob if structured fields are blank
    if(!a1 && !a2){
      safeLinesFromBlock(d.address).forEach(function(a){ lines.push(ucase(a)); });
    }

    var cityLine = formatCityLine(d);
    if(cityLine) lines.push(cityLine);

    var country = ucase(clean(d.country));
    if(country) lines.push(country);

    // Remove duplicates / blanks
    var out = [];
    var seen = {};
    lines.forEach(function(l){
      l = String(l||"").replace(/\s+/g,' ').trim();
      if(!l) return;
      var k = l.toLowerCase();
      if(seen[k]) return;
      seen[k] = 1;
      out.push(l);
    });
    return out;
  }

  function renderSelected(key){
    var d = S.byKey[key];
    if(!d){
      try{ el('slbShipPreview').textContent = ''; }catch(_e){}
      try{ el('slbShipEnvelopeTo').textContent = 'TO: NAME\nADDRESS\nCITY\nCOUNTRY'; }catch(_e){}
      setVal('slbShipAddr1','');
      setVal('slbShipAddr2','');
      setVal('slbShipCity','');
      setVal('slbShipProv','');
      setVal('slbShipPostal','');
      setVal('slbShipCountry','');
    setVal('slbShipToName','');
      return;
    }

    // Populate editor fields (prefer structured, else best-effort from legacy)
    // TO name override defaults to the disciple's stored name(s)
    setVal('slbShipToName', d.shipName || d.ordinaryName || d.taoistName || d.callsign || '');
    setVal('slbShipAddr1', d.address1 || '');
    setVal('slbShipAddr2', d.address2 || '');
    setVal('slbShipCity',  d.city || '');
    setVal('slbShipProv',  d.province || '');
    setVal('slbShipPostal',d.postal || '');
    setVal('slbShipCountry',d.country || '');

    var lines = formatRecipientLines(d);
    var txt = lines.join('\n');
    try{ el('slbShipPreview').textContent = txt; }catch(_e){}
    try{ el('slbShipEnvelopeTo').textContent = txt || ' '; }catch(_e){}
    S.lastKey = key;
  }

  function buildPrintHtml(toLines, logoUrl){
    // Based on your Word envelope template
    // Page size: 9.5in x 4.125in (#10 envelope landscape)
    // Recipient frame (Word): x=5716 twips (3.969in), y=2731 twips (1.896in)
    var css = `
      @page{ size: 9.5in 4.125in; margin: 0; }
      html,body{ width:9.5in; height:4.125in; margin:0; padding:0; }
      body{ position:relative; -webkit-print-color-adjust:exact; print-color-adjust:exact; }

      /* Return block */
      /* Logo + return block tuned to match the original Word template tighter alignment */
      .logo{ position:absolute; left:0.42in; top:0.08in; width:0.95in; height:0.95in; object-fit:contain; }
      .retTitle{ position:absolute; left:1.30in; top:0.22in; font-family: Algerian, 'Times New Roman', serif; font-weight:700; font-size:24pt; line-height:1.0; white-space:nowrap; }
      .retAddr{ position:absolute; left:1.30in; top:0.59in; font-family: 'Myriad Pro Cond','Myriad Pro', Arial, sans-serif; font-size:16pt; line-height:1.0; white-space:nowrap; letter-spacing:0.2pt; }

      /* Recipient block */
      .to{ position:absolute; left:3.969in; top:1.896in; width:3.20in; font-family: 'Myriad Pro', Arial, sans-serif; font-weight:700; font-size:14pt; line-height:1.15; white-space:pre; }
    `;
    var esc = function(s){
      return String(s||"")
        .replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;');
    };
    return `<!doctype html><html><head><meta charset="utf-8"><title>Envelope</title><style>${css}
      .printHint{ position:absolute; right:0.25in; bottom:0.20in; font-family: Arial, sans-serif; font-size:10pt; opacity:0.6; }
      .printBtn{ position:absolute; right:0.25in; top:0.20in; font-family: Arial, sans-serif; font-size:10pt; padding:6px 10px; border:1px solid #999; border-radius:10px; background:#fff; cursor:pointer; }
      @media print{ .printBtn,.printHint{ display:none; } }
    </style></head><body>
      ${logoUrl ? `<img class="logo" src="${esc(logoUrl)}" alt="Tin Yat Dragon" />` : ''}
      <div class="retTitle">Tin Yat Dragon</div>
      <div class="retAddr">1186-2967 DUNDAS ST. W. TORONTO, ON M6P 1Z2, CANADA</div>
      <div class="to">${esc(toLines.join('\n'))}</div>
      <button class="printBtn" onclick="try{window.focus();window.print();}catch(e){}">Print</button>
      <div class="printHint">If print does not auto-start, click Print.</div>
      <script>
        window.onload=function(){
          // Try auto-print. Some browsers block it; the button remains as fallback.
          setTimeout(function(){
            try{ window.focus(); }catch(e){};
            try{ window.print(); }catch(e){};
          }, 120);
        };
      </script>
    </body></html>`;
  }

  function doPrint(){
    var key = (el('slbShipDiscipleSelect')||{}).value || S.lastKey;
    var d = S.byKey[key];
    if(!d){ setMsg('Choose a disciple first.', false); return; }
    var lines = formatRecipientLines(d);
    if(!lines.length){ setMsg('This disciple has no address data yet.', false); return; }
    var logoUrl = '';
    try{ logoUrl = (el('slbShipEnvelopeMock')||{}).dataset ? (el('slbShipEnvelopeMock').dataset.logoUrl||'') : ''; }catch(_e){}
    var html = buildPrintHtml(lines, logoUrl);
    var win = null;
    // Avoid noopener here so the print page can reliably call print() in some browsers.
    try{ win = window.open('', '_blank'); }catch(_e){}
    if(!win){ setMsg('Popup blocked. Allow popups for this site, then try again.', false); return; }
    try{
      win.document.open();
      win.document.write(html);
      win.document.close();
      setMsg('', true);
    }catch(e){
      try{ win.close(); }catch(_e2){}
      setMsg(e && e.message ? e.message : String(e), false);
    }
  }

  function setLocalFromEditor(d){
    d.shipName = clean(val('slbShipToName'));
    d.address1 = clean(val('slbShipAddr1'));
    d.address2 = clean(val('slbShipAddr2'));
    d.city = clean(val('slbShipCity'));
    d.province = clean(val('slbShipProv'));
    d.postal = clean(val('slbShipPostal'));
    d.country = clean(val('slbShipCountry'));
    return d;
  }

  function applyParsedToEditor(key, parsed){
    if(!parsed) return;
    setVal('slbShipAddr1', parsed.address1 || '');
    setVal('slbShipAddr2', parsed.address2 || '');
    setVal('slbShipCity',  parsed.city || '');
    setVal('slbShipProv',  parsed.province || '');
    setVal('slbShipPostal',parsed.postal || '');
    setVal('slbShipCountry',parsed.country || '');
    var d = S.byKey[key];
    if(d){
      d.address1 = parsed.address1 || d.address1;
      d.address2 = parsed.address2 || d.address2;
      d.city = parsed.city || d.city;
      d.province = parsed.province || d.province;
      d.postal = parsed.postal || d.postal;
      d.country = parsed.country || d.country;
    }
    renderSelected(key);
  }

  function doParseSelected(andSave){
    var key = (el('slbShipDiscipleSelect')||{}).value || S.lastKey;
    var d = S.byKey[key];
    if(!d){ setMsg('Choose a disciple first.', false); return; }
    var parsed = parseLegacyIntoFields(d, true);
    applyParsedToEditor(key, parsed);
    setMsg('Auto-split applied (filled empty fields only).', true);
    if(andSave) doSave();
  }

  function bulkWrap(){ return el('slbShipBulkWrap'); }
  function bulkListEl(){ return el('slbShipBulkList'); }

  function bulkItemLabel(d){
    var cs = String(d.callsign||'').trim();
    var nm = String(d.ordinaryName||'').trim() || String(d.taoistName||'').trim();
    return (cs ? (cs + ' • ') : '') + (nm || '—') + '  [' + String(d.bucket||'IN') + ']';
  }

  function hasStructured(d){
    return !!(clean(d.address1)||clean(d.address2)||clean(d.city)||clean(d.province)||clean(d.postal)||clean(d.country));
  }

  function bulkMatchesFilter(d, f){
    f = clean(f).toLowerCase();
    if(!f) return true;
    var cs = String(d.callsign||'').toLowerCase();
    var nm = String(d.ordinaryName||d.taoistName||'').toLowerCase();
    return cs.indexOf(f) >= 0 || nm.indexOf(f) >= 0;
  }

  function renderBulkList(){
    var wrap = bulkWrap();
    var box = bulkListEl();
    if(!wrap || !box) return;
    if(!S.bulk.open){ box.innerHTML = ''; return; }

    var f = S.bulk.filter || '';
    var frag = document.createDocumentFragment();
    var shown = 0;
    S.list.forEach(function(d){
      if(!bulkMatchesFilter(d, f)) return;
      shown++;
      var key = String(d.bucket||'IN') + ':' + String(d.discipleId||d.callsign||'');

      var row = document.createElement('div');
      row.className = 'row';
      row.style.cssText = 'gap:10px;align-items:center;justify-content:space-between;padding:6px 6px;border-radius:10px;';

      var left = document.createElement('label');
      left.style.cssText = 'display:flex;gap:10px;align-items:center;cursor:pointer;flex:1;min-width:0;';

      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = !!S.bulk.selected[key];
      cb.addEventListener('change', function(){
        if(cb.checked) S.bulk.selected[key] = 1;
        else delete S.bulk.selected[key];
      });

      var txt = document.createElement('span');
      txt.textContent = bulkItemLabel(d);
      txt.style.cssText = 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

      left.appendChild(cb);
      left.appendChild(txt);

      var badge = document.createElement('span');
      badge.className = 'badge';
      badge.textContent = hasStructured(d) ? 'HAS FIELDS' : 'LEGACY';
      badge.style.opacity = hasStructured(d) ? '0.9' : '0.65';

      row.appendChild(left);
      row.appendChild(badge);
      frag.appendChild(row);
    });

    box.innerHTML = '';
    box.appendChild(frag);
    if(!shown) box.innerHTML = '<div class="note">No results.</div>';
  }

  function bulkToggle(){
    S.bulk.open = !S.bulk.open;
    var wrap = bulkWrap();
    if(wrap) wrap.classList.toggle('hidden', !S.bulk.open);
    renderBulkList();
  }

  function bulkClear(){
    S.bulk.selected = {};
    var s = el('slbShipBulkSearch');
    if(s) s.value = '';
    S.bulk.filter = '';
    renderBulkList();
  }

  function bulkSelectAllFiltered(){
    var f = S.bulk.filter || '';
    S.list.forEach(function(d){
      if(!bulkMatchesFilter(d, f)) return;
      var key = String(d.bucket||'IN') + ':' + String(d.discipleId||d.callsign||'');
      S.bulk.selected[key] = 1;
    });
    renderBulkList();
  }

  function bulkParseSelected(){
    var keys = Object.keys(S.bulk.selected||{});
    if(!keys.length){ setMsg('Select at least 1 disciple.', false); return; }
    var changed = 0;
    keys.forEach(function(key){
      var d = S.byKey[key];
      if(!d) return;
      var before = JSON.stringify({a1:d.address1||'',a2:d.address2||'',c:d.city||'',p:d.province||'',z:d.postal||'',co:d.country||''});
      var parsed = parseLegacyIntoFields(d, true);
      d.address1 = parsed.address1 || d.address1;
      d.address2 = parsed.address2 || d.address2;
      d.city = parsed.city || d.city;
      d.province = parsed.province || d.province;
      d.postal = parsed.postal || d.postal;
      d.country = parsed.country || d.country;
      var after = JSON.stringify({a1:d.address1||'',a2:d.address2||'',c:d.city||'',p:d.province||'',z:d.postal||'',co:d.country||''});
      if(before !== after) changed++;
    });
    // Refresh editor if current is selected
    var cur = (el('slbShipDiscipleSelect')||{}).value || S.lastKey;
    if(S.bulk.selected[cur]) renderSelected(cur);
    renderBulkList();
    setMsg('Auto-split done for ' + changed + ' disciple(s). Now click Save Selected.', true);
  }

  async function bulkSaveSelected(){
    var keys = Object.keys(S.bulk.selected||{});
    if(!keys.length){ setMsg('Select at least 1 disciple.', false); return; }
    if(!(rpcFn = getRpc())){
      setMsg('Loading…', true);
      return waitRpcReady_(function(ok){
        if(!ok){ setMsg('rpc not ready', false); return; }
        try{ bulkSaveSelected(); }catch(_e){}
      });
    }
    var ok = 0;
    for(var i=0;i<keys.length;i++){
      var key = keys[i];
      var d = S.byKey[key];
      if(!d) continue;
      setMsg('Saving ' + (i+1) + '/' + keys.length + '…', true);
      try{
        var payload = {
          bucket: d.bucket || 'IN',
          discipleId: d.discipleId || '',
          callsign: d.callsign || '',
          shipName: clean(d.shipName||''),
          address1: clean(d.address1||''),
          address2: clean(d.address2||''),
          city: clean(d.city||''),
          province: clean(d.province||''),
          postal: clean(d.postal||''),
          country: clean(d.country||'')
        };
        var res = await rpcFn('adminDiscipleUpdateShipping', payload);
        var dd = null;
        try{ dd = (res && res.disciple) ? res.disciple : null; }catch(_e){}
        if(dd){ S.byKey[key] = dd; }
        ok++;
      }catch(e){
        setMsg('Save failed at ' + bulkItemLabel(d) + ': ' + ((e&&e.message)?e.message:String(e)), false);
        renderBulkList();
        return;
      }
    }
    renderBulkList();
    setMsg('Saved ' + ok + ' disciple(s).', true);
  }

  async function doSave(){
    var key = (el('slbShipDiscipleSelect')||{}).value || S.lastKey;
    var d = S.byKey[key];
    if(!d){ setMsg('Choose a disciple first.', false); return; }

    setLocalFromEditor(d);

    // Basic sanity
    if(!clean(d.address1) && !clean(d.address2) && !clean(d.city) && !clean(d.country)){
      setMsg('Nothing to save (all fields are blank).', false);
      renderSelected(key);
      return;
    }

    // Button feedback
    var saveBtn = el('slbShipSaveBtn');
    var oldLbl = '';
    try{ oldLbl = saveBtn ? saveBtn.textContent : ''; }catch(_e){}
    try{ if(saveBtn){ saveBtn.disabled = true; saveBtn.textContent = 'SAVING…'; } }catch(_e2){}

    setMsg('Saving…', true);
    try{
      if(!(rpcFn = getRpc())){
        await new Promise(function(resolve){
          waitRpcReady_(function(ok){ resolve(ok); });
        });
        rpcFn = getRpc();
      }
      if(!rpcFn) throw new Error('rpc not ready');
      var payload = {
        bucket: d.bucket || 'IN',
        discipleId: d.discipleId || '',
        callsign: d.callsign || '',
        shipName: d.shipName || '',
        address1: d.address1 || '',
        address2: d.address2 || '',
        city: d.city || '',
        province: d.province || '',
        postal: d.postal || '',
        country: d.country || ''
      };
      var res = await rpcFn('adminDiscipleUpdateShipping', payload);

      // Server returns {ok:true, disciple:{...}} via ok_ wrapper
      var dd = null;
      try{ dd = (res && res.disciple) ? res.disciple : null; }catch(_e){}
      if(dd){
        // Keep local cache fresh
        S.byKey[key] = dd;
      }

      setMsg('Saved to Disciples sheet.', true);
      renderSelected(key);
    }catch(e){
      setMsg((e && e.message) ? e.message : String(e), false);
    }finally{
      try{ if(saveBtn){ saveBtn.disabled = false; saveBtn.textContent = 'SAVED'; } }catch(_e3){}
      setTimeout(function(){
        try{ if(saveBtn){ saveBtn.textContent = oldLbl || 'Save'; } }catch(_e4){}
      }, 900);
    }
  }

  async function loadList(force){
    if(S.loaded && !force) return;
    setMsg('Loading disciples…', true);
    var data = null;
    try{
      if(!(rpcFn = getRpc())){
        await new Promise(function(resolve){
          waitRpcReady_(function(ok){ resolve(ok); });
        });
        rpcFn = getRpc();
      }
      if(!rpcFn) throw new Error('rpc not ready');
      data = await rpcFn('adminDiscipleList', { includeOut: 1 });
      // Some legacy wrappers return { ok:true, data:{...} } while ours returns msg.data directly.
      if(data && typeof data === 'object' && data.data && typeof data.data === 'object') data = data.data;
    }catch(e){
      setMsg((e && e.message) ? e.message : String(e), false);
      return;
    }

    var arr = [];
    try{
      if(Array.isArray(data)) arr = arr.concat(data);
      else{
        if(data && Array.isArray(data.in)) arr = arr.concat(data.in);
        if(data && Array.isArray(data.out)) arr = arr.concat(data.out);
        // Fallback shapes
        if(!arr.length && data && Array.isArray(data.items)) arr = arr.concat(data.items);
        if(!arr.length && data && Array.isArray(data.list)) arr = arr.concat(data.list);
      }
    }catch(_e){}

    arr.sort(function(a,b){
      var ac = String(a.callsign||'');
      var bc = String(b.callsign||'');
      if(ac < bc) return -1;
      if(ac > bc) return 1;
      var an = String(a.ordinaryName||a.taoistName||'');
      var bn = String(b.ordinaryName||b.taoistName||'');
      return an.localeCompare(bn);
    });

    S.list = arr;
    S.byKey = {};
    var sel = el('slbShipDiscipleSelect');
    if(!sel) return;
    sel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = '— Choose —';
    sel.appendChild(opt0);

    arr.forEach(function(d){
      var key = String(d.bucket||'IN') + ':' + String(d.discipleId||d.callsign||'');
      S.byKey[key] = d;
      var cs = String(d.callsign||'').trim();
      var nm = String(d.ordinaryName||'').trim() || String(d.taoistName||'').trim();
      var label = (cs ? (cs + ' • ') : '') + (nm || '—') + '  [' + String(d.bucket||'IN') + ']';
      var opt = document.createElement('option');
      opt.value = key;
      opt.textContent = label;
      sel.appendChild(opt);
    });

    S.loaded = true;
    setMsg('Loaded ' + arr.length + ' disciples.', true);
    try{ if(S.lastKey && S.byKey[S.lastKey]){ sel.value = S.lastKey; renderSelected(S.lastKey); } }catch(_e2){}
    try{ if(S.bulk.open) renderBulkList(); }catch(_e3){}
  }

  

  // ===== Letter Printing (PDF) =====
  function buildLetterPrintHtml(pdfUrl){
    // Simple print wrapper: user can confirm settings (duplex/long-edge) in print dialog.
    return `<!doctype html><html><head><meta charset="utf-8" />
      <title>Print Letter</title>
      <style>
        html,body{height:100%;margin:0;}
        .bar{position:fixed;top:0;left:0;right:0;z-index:10;display:flex;gap:10px;align-items:center;
             padding:10px 12px;font:14px/1.2 system-ui,-apple-system,Segoe UI,Roboto,Arial;background:#111;color:#fff;}
        .bar .hint{opacity:0.85;font-size:12px;}
        .bar button{padding:8px 12px;border-radius:10px;border:0;cursor:pointer;font-weight:700;}
        .bar .print{background:#ef5e14;color:#fff;}
        .bar .close{background:#2a2f33;color:#fff;}
        .wrap{position:absolute;top:52px;left:0;right:0;bottom:0;}
        iframe{width:100%;height:100%;border:0;}
        @media print{ .bar{display:none;} .wrap{top:0;} }
      </style>
    </head><body>
      <div class="bar">
        <button class="print" id="btnPrint" type="button">Print</button>
        <button class="close" id="btnClose" type="button">Close</button>
        <div class="hint">Tip: set Paper = Letter; Duplex = On; Flip = Long edge.</div>
      </div>
      <div class="wrap"><iframe id="pdfFrame" src="${pdfUrl}"></iframe></div>
      <script>
        (function(){
          var f = document.getElementById('pdfFrame');
          function doPrint(){
            try{
              if(f && f.contentWindow){ f.contentWindow.focus(); f.contentWindow.print(); return; }
            }catch(e){}
            window.print();
          }
          document.getElementById('btnPrint').addEventListener('click', doPrint);
          document.getElementById('btnClose').addEventListener('click', function(){ window.close(); });
          // Try to print once loaded (some browsers block; user still can click Print button)
          try{ f.addEventListener('load', function(){ setTimeout(function(){}, 50); }); }catch(e){}
        })();
      </script>
    </body></html>`;
  }

  function doPrintLetter(){
    var btn = el('slbShipPrintLetterBtn');
    var pdfUrl = '';
    try{
      pdfUrl = (btn && btn.dataset && btn.dataset.letterUrl) ? btn.dataset.letterUrl : (btn ? (btn.getAttribute('data-letter-url')||'') : '');
    }catch(_e){}
    if(!pdfUrl){ setMsg('Letter PDF not found in theme assets.', false); return; }
    var w2 = window.open('', '_blank');
    if(!w2){ setMsg('Popup blocked. Please allow popups and try again.', false); return; }
    var html = buildLetterPrintHtml(pdfUrl);
    try{
      w2.document.open();
      w2.document.write(html);
      w2.document.close();
    }catch(e){
      try{ w2.location.href = pdfUrl; }catch(_e){}
    }
  }


  // -----------------------------
  // FAQ Print (2-column Word-style)
  // -----------------------------
  function escHtml(s){
    return String(s==null?'':s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function nl2br(s){
    s = String(s==null?'':s);
    s = s.replace(/\r\n/g,'\n').replace(/\r/g,'\n');
    return escHtml(s).replace(/\n/g,'<br>');
  }

  function getFaqLogoUrl_(){
    var wrap = el('slbFaqPreviewWrap');
    if(!wrap) return '';
    return String(wrap.getAttribute('data-faq-logo-url')||'');
  }

  function getFaqData_(){
    return {
      orderNo: clean(val('slbFaqOrderNo')),
      placedOn: clean(val('slbFaqPlacedOn')),
      person: clean(val('slbFaqPerson')),
      items: String(val('slbFaqItems')||''),
      note: String(val('slbFaqNote')||''),
      special: String(val('slbFaqSpecial')||'')
    };
  }

  function buildFaqBodyHtml_(d, forPrint){
    d = d || {};
    var logoUrl = getFaqLogoUrl_();

    // Default example formatting (matches doc feel)
    var itemsHtml = nl2br(d.items || '');
    var noteHtml  = nl2br(d.note || '');
    var spHtml    = nl2br(d.special || '');

    // layout numbers derived from FAQ.docx:
    // - Letter size
    // - margins ~0.39in
    // - 2 columns, gap ~0.49in, equal widths ~3.61in
    var css = `
      @page{ size: letter; margin: 0.39in; }
      html,body{ margin:0; padding:0; background:#fff; }
      body{ color:#000; font-family: Calibri, Arial, sans-serif; font-size:11pt; line-height:1.25; }
      .page{ width:8.5in; min-height:11in; box-sizing:border-box; }
      .cols{ width: calc(8.5in - 0.39in - 0.39in); display:grid; grid-template-columns: 3.61in 3.61in; column-gap:0.49in; }
      .h1{ font-family:'Eras Bold ITC', Calibri, Arial, sans-serif; font-size:28pt; color:#ef5e14; font-weight:700; margin:0 0 0.15in 0; }
      .q{ font-weight:700; margin:0.12in 0 0.04in 0; }
      .a{ margin:0 0 0.08in 0; }
      .rightTop{ text-align:center; margin-top:0.1in; }
      .logo{ width:1.03in; height:1.03in; object-fit:contain; display:inline-block; }
      .box{ margin-top:0.18in; border:1px solid #d8d8d8; border-radius:8px; padding:0.16in 0.16in; font-family:'Courier New', Courier, monospace; font-size:12pt; line-height:1.25; }
      .box .line{ margin:0 0 0.12in 0; }
      .box .label{ font-weight:700; }
      .box .items{ margin:0.05in 0 0.12in 0; font-weight:700; }
      .snTitle{ font-family:'Eras Bold ITC', Calibri, Arial, sans-serif; font-size:12pt; font-weight:700; text-decoration:underline; margin:0.18in 0 0.06in 0; }
    `;

    // FAQ text (left column) pulled from your FAQ.docx (static)
    var left = `
      <div class="h1">FAQ</div>

      <div class="q">Why Is My FU Folded?</div>
      <div class="a">An unfolded FU carries the master's decree, meaning the god will only follow the master's instructions. A FU folded into a triangle, however, is special. It authorizes the person carrying it to speak to the god on behalf of the master. This means you can call on the god and ask for help directly.</div>

      <div class="q">What Is the Sticker For?</div>
      <div class="a">The sticker acts as a connection point to your FU. To activate it, circle the FU three times clockwise with the sticker, tap the FU once, then place the sticker on something you carry daily, like the back of your smartphone.</div>
      <div class="a">Think of the FU as a walkie-talkie that lets you talk to the assigned god. If you forget your FU at home, you lose that connection for the day. But with the sticker, you still have a backup link, keeping you connected and protected at all times.</div>

      <div class="q">How Long Does My FU Last?</div>
      <div class="a">A FU is not just an "energy paper" or a battery that runs out. It doesn’t "expire" in that way. By default, a FU lasts about a year, but its effectiveness depends on your relationship with the assigned god.</div>
      <div class="a">If you stay faithful and maintain a good bond, the god will continue to help. If the god has fulfilled its duty or decides to leave, signs will appear—your FU may get lost, damaged, or even washed in the laundry. These signs mean it's time for a new FU.</div>
      <div class="a">You can extend the FU’s power by burning magic tokens over it. This keeps the god engaged and be able to help longer.</div>

      <div class="q">Can I Carry More Than One FU at Once?</div>
      <div class="a">Yes, you can—as long as all the FUs are from us. Mixing our magic with other paths is not a good idea. It's like hiring two different security teams that don't work together.</div>
    `;

    var orderNo = d.orderNo ? ('#' + d.orderNo.replace(/^#+/,'').trim()) : '#';
    var placed = d.placedOn || '';

    // If date input returns YYYY-MM-DD, show as 'Mon D, YYYY'
    if (/^\d{4}-\d{2}-\d{2}$/.test(placed)) {
      var p2 = placed.split('-');
      var yyyy = parseInt(p2[0], 10), mm = parseInt(p2[1], 10), dd = parseInt(p2[2], 10);
      var mnames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      if (yyyy && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
        placed = mnames[mm - 1] + ' ' + dd + ', ' + yyyy;
      }
    }
    var person = d.person || '';

    var right = `
      <div class="rightTop">
        ${logoUrl ? `<img class="logo" src="${escHtml(logoUrl)}" alt="Logo" />` : ''}
      </div>

      <div class="box">
        <div class="line"><span class="label">ORDER</span>: ${escHtml(orderNo)}</div>
        <div class="line"><span class="label">Placed on</span>: ${escHtml(placed)}</div>

        <div class="line"><span class="label">Items:</span></div>
        <div class="items">${itemsHtml || ''}</div>

        <div class="line"><span class="label">Note:</span></div>
        <div class="line">${noteHtml || ''}</div>

        <div class="snTitle">Special Notes</div>
        <div class="line">${spHtml || ''}</div>

        ${person ? `<div class="line" style="margin-top:0.14in;font-weight:700;">${escHtml(person).toUpperCase()}</div>` : ''}
      </div>
    `;

    return {
      css: css,
      html: `<div class="page"><div class="cols"><div>${left}</div><div>${right}</div></div></div>`
    };
  }

  function renderFaqPreview_(){
    var wrap = el('slbFaqPreview');
    if(!wrap) return;
    var d = getFaqData_();
    var built = buildFaqBodyHtml_(d, false);
    wrap.innerHTML = `<style>${built.css}</style>${built.html}`;
  }

  function printFaq_(){
    var d = getFaqData_();
    var built = buildFaqBodyHtml_(d, true);
    var win = window.open('', '_blank');
    if(!win){ setMsg('Popup blocked. Please allow popups for printing.', false); return; }
    win.document.open();
    win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Print FAQ</title><style>${built.css}
@media print{.no-print{display:none !important;}}</style></head><body>${built.html}
      <div class="no-print" style="position:fixed;top:10px;right:10px;z-index:9999;">
        <button onclick="window.print()" style="font:14px Arial;padding:8px 12px;border-radius:10px;border:1px solid #ddd;background:#fff;cursor:pointer;">Print</button>
      </div>
    </body></html>`);
    win.document.close();
    // try auto-print (some browsers block); user can click Print button anyway.
    try{ setTimeout(function(){ win.focus(); win.print(); }, 350); }catch(_e){}
  }
function bindOnce(){
    var sel = el('slbShipDiscipleSelect');
    if(sel && !sel._slbBound){
      sel.addEventListener('change', function(){ renderSelected(sel.value); });
      sel._slbBound = true;
    }
    var btn = el('slbShipPrintBtn');
    if(btn && !btn._slbBound){
      btn.addEventListener('click', doPrint);
      var lbtn = el('slbShipPrintLetterBtn');
      if(lbtn && !lbtn._slbBound){
        lbtn.addEventListener('click', doPrintLetter);
        lbtn._slbBound = true;
      }
      btn._slbBound = true;
    }
    var rbtn = el('slbShipReloadBtn');
    if(rbtn && !rbtn._slbBound){
      rbtn.addEventListener('click', function(){ loadList(true); });
      rbtn._slbBound = true;
    }
    var sbtn = el('slbShipSaveBtn');
    if(sbtn && !sbtn._slbBound){
      sbtn.addEventListener('click', doSave);
      sbtn._slbBound = true;
    }

    var pbtn = el('slbShipParseBtn');
    if(pbtn && !pbtn._slbBound){
      pbtn.addEventListener('click', function(){ doParseSelected(false); });
      pbtn._slbBound = true;
    }
    var psbtn = el('slbShipParseSaveBtn');
    if(psbtn && !psbtn._slbBound){
      psbtn.addEventListener('click', function(){ doParseSelected(true); });
      psbtn._slbBound = true;
    }
    var btog = el('slbShipBulkToggleBtn');
    if(btog && !btog._slbBound){
      btog.addEventListener('click', bulkToggle);
      btog._slbBound = true;
    }
    var bsel = el('slbShipBulkSelectAllBtn');
    if(bsel && !bsel._slbBound){
      bsel.addEventListener('click', bulkSelectAllFiltered);
      bsel._slbBound = true;
    }
    var bclr = el('slbShipBulkClearBtn');
    if(bclr && !bclr._slbBound){
      bclr.addEventListener('click', bulkClear);
      bclr._slbBound = true;
    }
    var bparse = el('slbShipBulkParseBtn');
    if(bparse && !bparse._slbBound){
      bparse.addEventListener('click', bulkParseSelected);
      bparse._slbBound = true;
    }
    var bsave = el('slbShipBulkSaveBtn');
    if(bsave && !bsave._slbBound){
      bsave.addEventListener('click', bulkSaveSelected);
      bsave._slbBound = true;
    }
    var bsearch = el('slbShipBulkSearch');
    if(bsearch && !bsearch._slbBound){
      bsearch.addEventListener('input', function(){
        S.bulk.filter = String(bsearch.value||'');
        renderBulkList();
      });
      bsearch._slbBound = true;
    }

    // Live preview while typing (lightweight)
    var ids = ['slbShipAddr1','slbShipAddr2','slbShipCity','slbShipProv','slbShipPostal','slbShipCountry'];
    ids.forEach(function(id){
      var e = el(id);
      if(e && !e._slbBound){
        e.addEventListener('input', function(){
          var key = (el('slbShipDiscipleSelect')||{}).value || S.lastKey;
          var d = S.byKey[key];
          if(!d) return;
          setLocalFromEditor(d);
          renderSelected(key);
        });
        e._slbBound = true;
      }
    });
    // FAQ bindings
    var faqIds = ['slbFaqOrderNo','slbFaqPlacedOn','slbFaqPerson','slbFaqItems','slbFaqNote','slbFaqSpecial'];
    faqIds.forEach(function(id){
      var e = el(id);
      if(e && !e._slbBound){
        e.addEventListener('input', renderFaqPreview_);
        e._slbBound = true;
      }
    });
    var fbtn = el('slbFaqPrintBtn');
    if(fbtn && !fbtn._slbBound){
      fbtn.addEventListener('click', function(){
        try{ printFaq_(); }catch(_e){ setMsg('Print FAQ failed.', false); }
      });
      fbtn._slbBound = true;
    }

    // Initial FAQ preview
    try{ renderFaqPreview_(); }catch(_e){}

  }

  SLB.features.register('shipping', {
    onOpen: function(){
      try{ bindOnce(); }catch(_e){}
      // Some panels open before rpc/token hydration completes; retry a moment later.
      try{ loadList(false); }catch(_e2){}
      try{ setTimeout(function(){ loadList(false); }, 250); }catch(_e3){}
    }
  });
})(window);

